
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire256a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire256a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("1u0KT", function(module, exports) {
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("Xw6Mv"));

});
parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});




parcelRegister("6VZtt", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $50c7c0793ca9e0ff$export$bf730a2d8bf68b42, (v) => $50c7c0793ca9e0ff$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $50c7c0793ca9e0ff$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");

var $hfliI = parcelRequire("hfliI");
function $50c7c0793ca9e0ff$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $50c7c0793ca9e0ff$var$q = "function" === typeof Object.is ? Object.is : $50c7c0793ca9e0ff$var$p, $50c7c0793ca9e0ff$var$r = $hfliI.useSyncExternalStore, $50c7c0793ca9e0ff$var$t = $acw62.useRef, $50c7c0793ca9e0ff$var$u = $acw62.useEffect, $50c7c0793ca9e0ff$var$v = $acw62.useMemo, $50c7c0793ca9e0ff$var$w = $acw62.useDebugValue;
$50c7c0793ca9e0ff$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $50c7c0793ca9e0ff$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $50c7c0793ca9e0ff$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($50c7c0793ca9e0ff$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $50c7c0793ca9e0ff$var$r(a, c[0], c[1]);
    $50c7c0793ca9e0ff$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $50c7c0793ca9e0ff$var$w(d);
    return d;
};

});
parcelRegister("hfliI", function(module, exports) {
"use strict";

module.exports = (parcelRequire("30Ie1"));

});
parcelRegister("30Ie1", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $2313ad640c2ad62d$export$306c0aa65ff9ec16, (v) => $2313ad640c2ad62d$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2313ad640c2ad62d$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $2313ad640c2ad62d$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $2313ad640c2ad62d$var$k = "function" === typeof Object.is ? Object.is : $2313ad640c2ad62d$var$h, $2313ad640c2ad62d$var$l = $acw62.useState, $2313ad640c2ad62d$var$m = $acw62.useEffect, $2313ad640c2ad62d$var$n = $acw62.useLayoutEffect, $2313ad640c2ad62d$var$p = $acw62.useDebugValue;
function $2313ad640c2ad62d$var$q(a, b) {
    var d = b(), f = $2313ad640c2ad62d$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $2313ad640c2ad62d$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $2313ad640c2ad62d$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $2313ad640c2ad62d$var$m(function() {
        $2313ad640c2ad62d$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $2313ad640c2ad62d$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $2313ad640c2ad62d$var$p(d);
    return d;
}
function $2313ad640c2ad62d$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$2313ad640c2ad62d$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $2313ad640c2ad62d$var$t(a, b) {
    return b();
}
var $2313ad640c2ad62d$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $2313ad640c2ad62d$var$t : $2313ad640c2ad62d$var$q;
$2313ad640c2ad62d$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $2313ad640c2ad62d$var$u;

});



parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hOzOt"))();

});
parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $f4905a8b274aa381$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});



parcelRegister("8zh6d", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", () => $63cedb313e1b8018$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $63cedb313e1b8018$export$2e2bcd8739ae039);
function $63cedb313e1b8018$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $63cedb313e1b8018$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $63cedb313e1b8018$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $63cedb313e1b8018$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $63cedb313e1b8018$export$2e2bcd8739ae039 = $63cedb313e1b8018$export$4f5d2d50c9deca37;

});

parcelRegister("jnmRN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.browserPrefixToKey = $e1b1e7274ffc28cf$var$browserPrefixToKey;
module.exports.browserPrefixToStyle = $e1b1e7274ffc28cf$var$browserPrefixToStyle;
module.exports.default = void 0;
module.exports.getPrefix = $e1b1e7274ffc28cf$var$getPrefix;
const $e1b1e7274ffc28cf$var$prefixes = [
    "Moz",
    "Webkit",
    "O",
    "ms"
];
function $e1b1e7274ffc28cf$var$getPrefix() /*: string*/ {
    var _window$document;
    let prop /*: string*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "transform";
    // Ensure we're running in an environment where there is actually a global
    // `window` obj
    if (typeof window === "undefined") return "";
    // If we're in a pseudo-browser server-side environment, this access
    // path may not exist, so bail out if it doesn't.
    const style = (_window$document = window.document) === null || _window$document === void 0 || (_window$document = _window$document.documentElement) === null || _window$document === void 0 ? void 0 : _window$document.style;
    if (!style) return "";
    if (prop in style) return "";
    for(let i = 0; i < $e1b1e7274ffc28cf$var$prefixes.length; i++){
        if ($e1b1e7274ffc28cf$var$browserPrefixToKey(prop, $e1b1e7274ffc28cf$var$prefixes[i]) in style) return $e1b1e7274ffc28cf$var$prefixes[i];
    }
    return "";
}
function $e1b1e7274ffc28cf$var$browserPrefixToKey(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
    return prefix ? "".concat(prefix).concat($e1b1e7274ffc28cf$var$kebabToTitleCase(prop)) : prop;
}
function $e1b1e7274ffc28cf$var$browserPrefixToStyle(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
    return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
}
function $e1b1e7274ffc28cf$var$kebabToTitleCase(str /*: string*/ ) /*: string*/ {
    let out = "";
    let shouldCapitalize = true;
    for(let i = 0; i < str.length; i++){
        if (shouldCapitalize) {
            out += str[i].toUpperCase();
            shouldCapitalize = false;
        } else if (str[i] === "-") shouldCapitalize = true;
        else out += str[i];
    }
    return out;
}
// Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`
var $e1b1e7274ffc28cf$var$_default = module.exports.default = $e1b1e7274ffc28cf$var$getPrefix();

});

parcelRegister("7eM6q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $544f2767f390b5ca$var$React = $544f2767f390b5ca$var$_interopRequireWildcard((parcelRequire("acw62")));

var $544f2767f390b5ca$var$_propTypes = $544f2767f390b5ca$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $544f2767f390b5ca$var$_reactDom = $544f2767f390b5ca$var$_interopRequireDefault((parcelRequire("1u0KT")));

var $hVGkP = parcelRequire("hVGkP");

var $jc5pr = parcelRequire("jc5pr");

var $7jnr7 = parcelRequire("7jnr7");

var $544f2767f390b5ca$var$_log = $544f2767f390b5ca$var$_interopRequireDefault((parcelRequire("ldVpK")));
function $544f2767f390b5ca$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $544f2767f390b5ca$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($544f2767f390b5ca$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $544f2767f390b5ca$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $544f2767f390b5ca$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $544f2767f390b5ca$var$_defineProperty(obj, key, value) {
    key = $544f2767f390b5ca$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $544f2767f390b5ca$var$_toPropertyKey(arg) {
    var key = $544f2767f390b5ca$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $544f2767f390b5ca$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*:: import type {EventHandler, MouseTouchEvent} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ // Simple abstraction for dragging events names.
const $544f2767f390b5ca$var$eventsFor = {
    touch: {
        start: "touchstart",
        move: "touchmove",
        stop: "touchend"
    },
    mouse: {
        start: "mousedown",
        move: "mousemove",
        stop: "mouseup"
    }
};
// Default to mouse events.
let $544f2767f390b5ca$var$dragEventFor = $544f2767f390b5ca$var$eventsFor.mouse;
/*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/ /*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/ /*:: export type ControlPosition = {x: number, y: number};*/ /*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/ /*:: export type DraggableCoreDefaultProps = {
  allowAnyClick: boolean,
  disabled: boolean,
  enableUserSelectHack: boolean,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
  scale: number,
};*/ /*:: export type DraggableCoreProps = {
  ...DraggableCoreDefaultProps,
  cancel: string,
  children: ReactElement<any>,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  nodeRef?: ?React.ElementRef<any>,
};*/ //
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//
class $544f2767f390b5ca$var$DraggableCore extends $544f2767f390b5ca$var$React.Component /*:: <DraggableCoreProps>*/  {
    constructor(){
        super(...arguments);
        $544f2767f390b5ca$var$_defineProperty(this, "dragging", false);
        // Used while dragging to determine deltas.
        $544f2767f390b5ca$var$_defineProperty(this, "lastX", NaN);
        $544f2767f390b5ca$var$_defineProperty(this, "lastY", NaN);
        $544f2767f390b5ca$var$_defineProperty(this, "touchIdentifier", null);
        $544f2767f390b5ca$var$_defineProperty(this, "mounted", false);
        $544f2767f390b5ca$var$_defineProperty(this, "handleDragStart", (e)=>{
            // Make it possible to attach event handlers on top of this one.
            this.props.onMouseDown(e);
            // Only accept left-clicks.
            if (!this.props.allowAnyClick && typeof e.button === "number" && e.button !== 0) return false;
            // Get nodes. Be sure to grab relative document (could be iframed)
            const thisNode = this.findDOMNode();
            if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) throw new Error("<DraggableCore> not mounted on DragStart!");
            const { ownerDocument: ownerDocument } = thisNode;
            // Short circuit if handle or cancel prop was provided and selector doesn't match.
            if (this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || this.props.handle && !(0, $hVGkP.matchesSelectorAndParentsTo)(e.target, this.props.handle, thisNode) || this.props.cancel && (0, $hVGkP.matchesSelectorAndParentsTo)(e.target, this.props.cancel, thisNode)) return;
            // Prevent scrolling on mobile devices, like ipad/iphone.
            // Important that this is after handle/cancel.
            if (e.type === "touchstart") e.preventDefault();
            // Set touch identifier in component state if this is a touch event. This allows us to
            // distinguish between individual touches on multitouch screens by identifying which
            // touchpoint was set to this element.
            const touchIdentifier = (0, $hVGkP.getTouchIdentifier)(e);
            this.touchIdentifier = touchIdentifier;
            // Get the current drag point from the event. This is used as the offset.
            const position = (0, $jc5pr.getControlPosition)(e, touchIdentifier, this);
            if (position == null) return; // not possible but satisfies flow
            const { x: x, y: y } = position;
            // Create an event object with all the data parents need to make a decision here.
            const coreEvent = (0, $jc5pr.createCoreData)(this, x, y);
            (0, $544f2767f390b5ca$var$_log.default)("DraggableCore: handleDragStart: %j", coreEvent);
            // Call event handler. If it returns explicit false, cancel.
            (0, $544f2767f390b5ca$var$_log.default)("calling", this.props.onStart);
            const shouldUpdate = this.props.onStart(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) return;
            // Add a style to the body to disable user-select. This prevents text from
            // being selected all over the page.
            if (this.props.enableUserSelectHack) (0, $hVGkP.addUserSelectStyles)(ownerDocument);
            // Initiate dragging. Set the current x and y as offsets
            // so we know how much we've moved during the drag. This allows us
            // to drag elements around even if they have been moved, without issue.
            this.dragging = true;
            this.lastX = x;
            this.lastY = y;
            // Add events to the document directly so we catch when the user's mouse/touch moves outside of
            // this element. We use different events depending on whether or not we have detected that this
            // is a touch-capable device.
            (0, $hVGkP.addEvent)(ownerDocument, $544f2767f390b5ca$var$dragEventFor.move, this.handleDrag);
            (0, $hVGkP.addEvent)(ownerDocument, $544f2767f390b5ca$var$dragEventFor.stop, this.handleDragStop);
        });
        $544f2767f390b5ca$var$_defineProperty(this, "handleDrag", (e)=>{
            // Get the current drag point from the event. This is used as the offset.
            const position = (0, $jc5pr.getControlPosition)(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            // Snap to grid if prop has been provided
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX, deltaY = y - this.lastY;
                [deltaX, deltaY] = (0, $jc5pr.snapToGrid)(this.props.grid, deltaX, deltaY);
                if (!deltaX && !deltaY) return; // skip useless drag
                x = this.lastX + deltaX, y = this.lastY + deltaY;
            }
            const coreEvent = (0, $jc5pr.createCoreData)(this, x, y);
            (0, $544f2767f390b5ca$var$_log.default)("DraggableCore: handleDrag: %j", coreEvent);
            // Call event handler. If it returns explicit false, trigger end.
            const shouldUpdate = this.props.onDrag(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) {
                try {
                    // $FlowIgnore
                    this.handleDragStop(new MouseEvent("mouseup"));
                } catch (err) {
                    // Old browsers
                    const event = document.createEvent("MouseEvents");
                    // I see why this insanity was deprecated
                    // $FlowIgnore
                    event.initMouseEvent("mouseup", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    this.handleDragStop(event);
                }
                return;
            }
            this.lastX = x;
            this.lastY = y;
        });
        $544f2767f390b5ca$var$_defineProperty(this, "handleDragStop", (e)=>{
            if (!this.dragging) return;
            const position = (0, $jc5pr.getControlPosition)(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            // Snap to grid if prop has been provided
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX || 0;
                let deltaY = y - this.lastY || 0;
                [deltaX, deltaY] = (0, $jc5pr.snapToGrid)(this.props.grid, deltaX, deltaY);
                x = this.lastX + deltaX, y = this.lastY + deltaY;
            }
            const coreEvent = (0, $jc5pr.createCoreData)(this, x, y);
            // Call event handler
            const shouldContinue = this.props.onStop(e, coreEvent);
            if (shouldContinue === false || this.mounted === false) return false;
            const thisNode = this.findDOMNode();
            if (thisNode) // Remove user-select hack
            {
                if (this.props.enableUserSelectHack) (0, $hVGkP.removeUserSelectStyles)(thisNode.ownerDocument);
            }
            (0, $544f2767f390b5ca$var$_log.default)("DraggableCore: handleDragStop: %j", coreEvent);
            // Reset the el.
            this.dragging = false;
            this.lastX = NaN;
            this.lastY = NaN;
            if (thisNode) {
                // Remove event handlers
                (0, $544f2767f390b5ca$var$_log.default)("DraggableCore: Removing handlers");
                (0, $hVGkP.removeEvent)(thisNode.ownerDocument, $544f2767f390b5ca$var$dragEventFor.move, this.handleDrag);
                (0, $hVGkP.removeEvent)(thisNode.ownerDocument, $544f2767f390b5ca$var$dragEventFor.stop, this.handleDragStop);
            }
        });
        $544f2767f390b5ca$var$_defineProperty(this, "onMouseDown", (e)=>{
            $544f2767f390b5ca$var$dragEventFor = $544f2767f390b5ca$var$eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
            return this.handleDragStart(e);
        });
        $544f2767f390b5ca$var$_defineProperty(this, "onMouseUp", (e)=>{
            $544f2767f390b5ca$var$dragEventFor = $544f2767f390b5ca$var$eventsFor.mouse;
            return this.handleDragStop(e);
        });
        // Same as onMouseDown (start drag), but now consider this a touch device.
        $544f2767f390b5ca$var$_defineProperty(this, "onTouchStart", (e)=>{
            // We're on a touch device now, so change the event handlers
            $544f2767f390b5ca$var$dragEventFor = $544f2767f390b5ca$var$eventsFor.touch;
            return this.handleDragStart(e);
        });
        $544f2767f390b5ca$var$_defineProperty(this, "onTouchEnd", (e)=>{
            // We're on a touch device now, so change the event handlers
            $544f2767f390b5ca$var$dragEventFor = $544f2767f390b5ca$var$eventsFor.touch;
            return this.handleDragStop(e);
        });
    }
    componentDidMount() {
        this.mounted = true;
        // Touch handlers must be added with {passive: false} to be cancelable.
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        const thisNode = this.findDOMNode();
        if (thisNode) (0, $hVGkP.addEvent)(thisNode, $544f2767f390b5ca$var$eventsFor.touch.start, this.onTouchStart, {
            passive: false
        });
    }
    componentWillUnmount() {
        this.mounted = false;
        // Remove any leftover event handlers. Remove both touch and mouse handlers in case
        // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
        const thisNode = this.findDOMNode();
        if (thisNode) {
            const { ownerDocument: ownerDocument } = thisNode;
            (0, $hVGkP.removeEvent)(ownerDocument, $544f2767f390b5ca$var$eventsFor.mouse.move, this.handleDrag);
            (0, $hVGkP.removeEvent)(ownerDocument, $544f2767f390b5ca$var$eventsFor.touch.move, this.handleDrag);
            (0, $hVGkP.removeEvent)(ownerDocument, $544f2767f390b5ca$var$eventsFor.mouse.stop, this.handleDragStop);
            (0, $hVGkP.removeEvent)(ownerDocument, $544f2767f390b5ca$var$eventsFor.touch.stop, this.handleDragStop);
            (0, $hVGkP.removeEvent)(thisNode, $544f2767f390b5ca$var$eventsFor.touch.start, this.onTouchStart, {
                passive: false
            });
            if (this.props.enableUserSelectHack) (0, $hVGkP.removeUserSelectStyles)(ownerDocument);
        }
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() /*: ?HTMLElement*/ {
        var _this$props, _this$props2;
        return (_this$props = this.props) !== null && _this$props !== void 0 && _this$props.nodeRef ? (_this$props2 = this.props) === null || _this$props2 === void 0 || (_this$props2 = _this$props2.nodeRef) === null || _this$props2 === void 0 ? void 0 : _this$props2.current : $544f2767f390b5ca$var$_reactDom.default.findDOMNode(this);
    }
    render() /*: React.Element<any>*/ {
        // Reuse the child provided
        // This makes it flexible to use whatever element is wanted (div, ul, etc)
        return /*#__PURE__*/ $544f2767f390b5ca$var$React.cloneElement($544f2767f390b5ca$var$React.Children.only(this.props.children), {
            // Note: mouseMove handler is attached to document so it will still function
            // when the user drags quickly and leaves the bounds of the element.
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            // onTouchStart is added on `componentDidMount` so they can be added with
            // {passive: false}, which allows it to cancel. See
            // https://developers.google.com/web/updates/2017/01/scrolling-intervention
            onTouchEnd: this.onTouchEnd
        });
    }
}
module.exports.default = $544f2767f390b5ca$var$DraggableCore;
$544f2767f390b5ca$var$_defineProperty($544f2767f390b5ca$var$DraggableCore, "displayName", "DraggableCore");
$544f2767f390b5ca$var$_defineProperty($544f2767f390b5ca$var$DraggableCore, "propTypes", {
    /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */ allowAnyClick: $544f2767f390b5ca$var$_propTypes.default.bool,
    children: $544f2767f390b5ca$var$_propTypes.default.node.isRequired,
    /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */ disabled: $544f2767f390b5ca$var$_propTypes.default.bool,
    /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */ enableUserSelectHack: $544f2767f390b5ca$var$_propTypes.default.bool,
    /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */ offsetParent: function(props /*: DraggableCoreProps*/ , propName /*: $Keys<DraggableCoreProps>*/ ) {
        if (props[propName] && props[propName].nodeType !== 1) throw new Error("Draggable's offsetParent must be a DOM Node.");
    },
    /**
   * `grid` specifies the x and y that dragging should snap to.
   */ grid: $544f2767f390b5ca$var$_propTypes.default.arrayOf($544f2767f390b5ca$var$_propTypes.default.number),
    /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ handle: $544f2767f390b5ca$var$_propTypes.default.string,
    /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */ cancel: $544f2767f390b5ca$var$_propTypes.default.string,
    /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */ nodeRef: $544f2767f390b5ca$var$_propTypes.default.object,
    /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */ onStart: $544f2767f390b5ca$var$_propTypes.default.func,
    /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */ onDrag: $544f2767f390b5ca$var$_propTypes.default.func,
    /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */ onStop: $544f2767f390b5ca$var$_propTypes.default.func,
    /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */ onMouseDown: $544f2767f390b5ca$var$_propTypes.default.func,
    /**
   * `scale`, if set, applies scaling while dragging an element
   */ scale: $544f2767f390b5ca$var$_propTypes.default.number,
    /**
   * These properties should be defined on the child, not here.
   */ className: $7jnr7.dontSetMe,
    style: $7jnr7.dontSetMe,
    transform: $7jnr7.dontSetMe
});
$544f2767f390b5ca$var$_defineProperty($544f2767f390b5ca$var$DraggableCore, "defaultProps", {
    allowAnyClick: false,
    // by default only accept left click
    disabled: false,
    enableUserSelectHack: true,
    onStart: function() {},
    onDrag: function() {},
    onStop: function() {},
    onMouseDown: function() {},
    scale: 1
});

});
parcelRegister("hVGkP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.addClassName = $d0d8995f7df729b6$var$addClassName;
module.exports.addEvent = $d0d8995f7df729b6$var$addEvent;
module.exports.addUserSelectStyles = $d0d8995f7df729b6$var$addUserSelectStyles;
module.exports.createCSSTransform = $d0d8995f7df729b6$var$createCSSTransform;
module.exports.createSVGTransform = $d0d8995f7df729b6$var$createSVGTransform;
module.exports.getTouch = $d0d8995f7df729b6$var$getTouch;
module.exports.getTouchIdentifier = $d0d8995f7df729b6$var$getTouchIdentifier;
module.exports.getTranslation = $d0d8995f7df729b6$var$getTranslation;
module.exports.innerHeight = $d0d8995f7df729b6$var$innerHeight;
module.exports.innerWidth = $d0d8995f7df729b6$var$innerWidth;
module.exports.matchesSelector = $d0d8995f7df729b6$var$matchesSelector;
module.exports.matchesSelectorAndParentsTo = $d0d8995f7df729b6$var$matchesSelectorAndParentsTo;
module.exports.offsetXYFromParent = $d0d8995f7df729b6$var$offsetXYFromParent;
module.exports.outerHeight = $d0d8995f7df729b6$var$outerHeight;
module.exports.outerWidth = $d0d8995f7df729b6$var$outerWidth;
module.exports.removeClassName = $d0d8995f7df729b6$var$removeClassName;
module.exports.removeEvent = $d0d8995f7df729b6$var$removeEvent;
module.exports.removeUserSelectStyles = $d0d8995f7df729b6$var$removeUserSelectStyles;

var $7jnr7 = parcelRequire("7jnr7");

var $d0d8995f7df729b6$var$_getPrefix = $d0d8995f7df729b6$var$_interopRequireWildcard((parcelRequire("jnmRN")));
function $d0d8995f7df729b6$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d0d8995f7df729b6$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d0d8995f7df729b6$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d0d8995f7df729b6$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/*:: import type {ControlPosition, PositionOffsetControlPosition, MouseTouchEvent} from './types';*/ let $d0d8995f7df729b6$var$matchesSelectorFunc = "";
function $d0d8995f7df729b6$var$matchesSelector(el /*: Node*/ , selector /*: string*/ ) /*: boolean*/ {
    if (!$d0d8995f7df729b6$var$matchesSelectorFunc) $d0d8995f7df729b6$var$matchesSelectorFunc = (0, $7jnr7.findInArray)([
        "matches",
        "webkitMatchesSelector",
        "mozMatchesSelector",
        "msMatchesSelector",
        "oMatchesSelector"
    ], function(method) {
        // $FlowIgnore: Doesn't think elements are indexable
        return (0, $7jnr7.isFunction)(el[method]);
    });
    // Might not be found entirely (not an Element?) - in that case, bail
    // $FlowIgnore: Doesn't think elements are indexable
    if (!(0, $7jnr7.isFunction)(el[$d0d8995f7df729b6$var$matchesSelectorFunc])) return false;
    // $FlowIgnore: Doesn't think elements are indexable
    return el[$d0d8995f7df729b6$var$matchesSelectorFunc](selector);
}
// Works up the tree to the draggable itself attempting to match selector.
function $d0d8995f7df729b6$var$matchesSelectorAndParentsTo(el /*: Node*/ , selector /*: string*/ , baseNode /*: Node*/ ) /*: boolean*/ {
    let node = el;
    do {
        if ($d0d8995f7df729b6$var$matchesSelector(node, selector)) return true;
        if (node === baseNode) return false;
        // $FlowIgnore[incompatible-type]
        node = node.parentNode;
    }while (node);
    return false;
}
function $d0d8995f7df729b6$var$addEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ , inputOptions /*: Object*/ ) /*: void*/ {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    // $FlowIgnore[method-unbinding]
    if (el.addEventListener) el.addEventListener(event, handler, options);
    else if (el.attachEvent) el.attachEvent("on" + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el["on" + event] = handler;
}
function $d0d8995f7df729b6$var$removeEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ , inputOptions /*: Object*/ ) /*: void*/ {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    // $FlowIgnore[method-unbinding]
    if (el.removeEventListener) el.removeEventListener(event, handler, options);
    else if (el.detachEvent) el.detachEvent("on" + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el["on" + event] = null;
}
function $d0d8995f7df729b6$var$outerHeight(node /*: HTMLElement*/ ) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetTop which is including margin. See getBoundPosition
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height += (0, $7jnr7.int)(computedStyle.borderTopWidth);
    height += (0, $7jnr7.int)(computedStyle.borderBottomWidth);
    return height;
}
function $d0d8995f7df729b6$var$outerWidth(node /*: HTMLElement*/ ) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetLeft which is including margin. See getBoundPosition
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width += (0, $7jnr7.int)(computedStyle.borderLeftWidth);
    width += (0, $7jnr7.int)(computedStyle.borderRightWidth);
    return width;
}
function $d0d8995f7df729b6$var$innerHeight(node /*: HTMLElement*/ ) /*: number*/ {
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height -= (0, $7jnr7.int)(computedStyle.paddingTop);
    height -= (0, $7jnr7.int)(computedStyle.paddingBottom);
    return height;
}
function $d0d8995f7df729b6$var$innerWidth(node /*: HTMLElement*/ ) /*: number*/ {
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width -= (0, $7jnr7.int)(computedStyle.paddingLeft);
    width -= (0, $7jnr7.int)(computedStyle.paddingRight);
    return width;
}
/*:: interface EventWithOffset {
  clientX: number, clientY: number
}*/ // Get from offsetParent
function $d0d8995f7df729b6$var$offsetXYFromParent(evt /*: EventWithOffset*/ , offsetParent /*: HTMLElement*/ , scale /*: number*/ ) /*: ControlPosition*/ {
    const isBody = offsetParent === offsetParent.ownerDocument.body;
    const offsetParentRect = isBody ? {
        left: 0,
        top: 0
    } : offsetParent.getBoundingClientRect();
    const x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
    const y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
    return {
        x: x,
        y: y
    };
}
function $d0d8995f7df729b6$var$createCSSTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: Object*/ {
    const translation = $d0d8995f7df729b6$var$getTranslation(controlPos, positionOffset, "px");
    return {
        [(0, $d0d8995f7df729b6$var$_getPrefix.browserPrefixToKey)("transform", $d0d8995f7df729b6$var$_getPrefix.default)]: translation
    };
}
function $d0d8995f7df729b6$var$createSVGTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: string*/ {
    const translation = $d0d8995f7df729b6$var$getTranslation(controlPos, positionOffset, "");
    return translation;
}
function $d0d8995f7df729b6$var$getTranslation(_ref /*:: */ , positionOffset /*: PositionOffsetControlPosition*/ , unitSuffix /*: string*/ ) /*: string*/ {
    let { x: x, y: y } /*: ControlPosition*/  = _ref /*: ControlPosition*/ ;
    let translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");
    if (positionOffset) {
        const defaultX = "".concat(typeof positionOffset.x === "string" ? positionOffset.x : positionOffset.x + unitSuffix);
        const defaultY = "".concat(typeof positionOffset.y === "string" ? positionOffset.y : positionOffset.y + unitSuffix);
        translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
    }
    return translation;
}
function $d0d8995f7df729b6$var$getTouch(e /*: MouseTouchEvent*/ , identifier /*: number*/ ) /*: ?{clientX: number, clientY: number}*/ {
    return e.targetTouches && (0, $7jnr7.findInArray)(e.targetTouches, (t)=>identifier === t.identifier) || e.changedTouches && (0, $7jnr7.findInArray)(e.changedTouches, (t)=>identifier === t.identifier);
}
function $d0d8995f7df729b6$var$getTouchIdentifier(e /*: MouseTouchEvent*/ ) /*: ?number*/ {
    if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
    if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
}
// User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.
// Note we're passing `document` b/c we could be iframed
function $d0d8995f7df729b6$var$addUserSelectStyles(doc /*: ?Document*/ ) {
    if (!doc) return;
    let styleEl = doc.getElementById("react-draggable-style-el");
    if (!styleEl) {
        styleEl = doc.createElement("style");
        styleEl.type = "text/css";
        styleEl.id = "react-draggable-style-el";
        styleEl.innerHTML = ".react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n";
        styleEl.innerHTML += ".react-draggable-transparent-selection *::selection {all: inherit;}\n";
        doc.getElementsByTagName("head")[0].appendChild(styleEl);
    }
    if (doc.body) $d0d8995f7df729b6$var$addClassName(doc.body, "react-draggable-transparent-selection");
}
function $d0d8995f7df729b6$var$removeUserSelectStyles(doc /*: ?Document*/ ) {
    if (!doc) return;
    try {
        if (doc.body) $d0d8995f7df729b6$var$removeClassName(doc.body, "react-draggable-transparent-selection");
        // $FlowIgnore: IE
        if (doc.selection) // $FlowIgnore: IE
        doc.selection.empty();
        else {
            // Remove selection caused by scroll, unless it's a focused input
            // (we use doc.defaultView in case we're in an iframe)
            const selection = (doc.defaultView || window).getSelection();
            if (selection && selection.type !== "Caret") selection.removeAllRanges();
        }
    } catch (e) {
    // probably IE
    }
}
function $d0d8995f7df729b6$var$addClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
    if (el.classList) el.classList.add(className);
    else if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) el.className += " ".concat(className);
}
function $d0d8995f7df729b6$var$removeClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
    if (el.classList) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), "g"), "");
}

});
parcelRegister("7jnr7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dontSetMe = $552c7cc0c70bb1ed$var$dontSetMe;
module.exports.findInArray = $552c7cc0c70bb1ed$var$findInArray;
module.exports.int = $552c7cc0c70bb1ed$var$int;
module.exports.isFunction = $552c7cc0c70bb1ed$var$isFunction;
module.exports.isNum = $552c7cc0c70bb1ed$var$isNum;
// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
function $552c7cc0c70bb1ed$var$findInArray(array /*: Array<any> | TouchList*/ , callback /*: Function*/ ) /*: any*/ {
    for(let i = 0, length = array.length; i < length; i++){
        if (callback.apply(callback, [
            array[i],
            i,
            array
        ])) return array[i];
    }
}
function $552c7cc0c70bb1ed$var$isFunction(func /*: any*/ ) /*: boolean %checks*/ {
    // $FlowIgnore[method-unbinding]
    return typeof func === "function" || Object.prototype.toString.call(func) === "[object Function]";
}
function $552c7cc0c70bb1ed$var$isNum(num /*: any*/ ) /*: boolean %checks*/ {
    return typeof num === "number" && !isNaN(num);
}
function $552c7cc0c70bb1ed$var$int(a /*: string*/ ) /*: number*/ {
    return parseInt(a, 10);
}
function $552c7cc0c70bb1ed$var$dontSetMe(props /*: Object*/ , propName /*: string*/ , componentName /*: string*/ ) /*: ?Error*/ {
    if (props[propName]) return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
}

});


parcelRegister("jc5pr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.canDragX = $df93557b6a1aa90a$var$canDragX;
module.exports.canDragY = $df93557b6a1aa90a$var$canDragY;
module.exports.createCoreData = $df93557b6a1aa90a$var$createCoreData;
module.exports.createDraggableData = $df93557b6a1aa90a$var$createDraggableData;
module.exports.getBoundPosition = $df93557b6a1aa90a$var$getBoundPosition;
module.exports.getControlPosition = $df93557b6a1aa90a$var$getControlPosition;
module.exports.snapToGrid = $df93557b6a1aa90a$var$snapToGrid;

var $7jnr7 = parcelRequire("7jnr7");

var $hVGkP = parcelRequire("hVGkP");
/*:: import type Draggable from '../Draggable';*/ /*:: import type {Bounds, ControlPosition, DraggableData, MouseTouchEvent} from './types';*/ /*:: import type DraggableCore from '../DraggableCore';*/ function $df93557b6a1aa90a$var$getBoundPosition(draggable /*: Draggable*/ , x /*: number*/ , y /*: number*/ ) /*: [number, number]*/ {
    // If no bounds, short-circuit and move on
    if (!draggable.props.bounds) return [
        x,
        y
    ];
    // Clone new bounds
    let { bounds: bounds } = draggable.props;
    bounds = typeof bounds === "string" ? bounds : $df93557b6a1aa90a$var$cloneBounds(bounds);
    const node = $df93557b6a1aa90a$var$findDOMNode(draggable);
    if (typeof bounds === "string") {
        const { ownerDocument: ownerDocument } = node;
        const ownerWindow = ownerDocument.defaultView;
        let boundNode;
        if (bounds === "parent") boundNode = node.parentNode;
        else boundNode = ownerDocument.querySelector(bounds);
        if (!(boundNode instanceof ownerWindow.HTMLElement)) throw new Error('Bounds selector "' + bounds + '" could not find an element.');
        const boundNodeEl /*: HTMLElement*/  = boundNode; // for Flow, can't seem to refine correctly
        const nodeStyle = ownerWindow.getComputedStyle(node);
        const boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl);
        // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
        bounds = {
            left: -node.offsetLeft + (0, $7jnr7.int)(boundNodeStyle.paddingLeft) + (0, $7jnr7.int)(nodeStyle.marginLeft),
            top: -node.offsetTop + (0, $7jnr7.int)(boundNodeStyle.paddingTop) + (0, $7jnr7.int)(nodeStyle.marginTop),
            right: (0, $hVGkP.innerWidth)(boundNodeEl) - (0, $hVGkP.outerWidth)(node) - node.offsetLeft + (0, $7jnr7.int)(boundNodeStyle.paddingRight) - (0, $7jnr7.int)(nodeStyle.marginRight),
            bottom: (0, $hVGkP.innerHeight)(boundNodeEl) - (0, $hVGkP.outerHeight)(node) - node.offsetTop + (0, $7jnr7.int)(boundNodeStyle.paddingBottom) - (0, $7jnr7.int)(nodeStyle.marginBottom)
        };
    }
    // Keep x and y below right and bottom limits...
    if ((0, $7jnr7.isNum)(bounds.right)) x = Math.min(x, bounds.right);
    if ((0, $7jnr7.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom);
    // But above left and top limits.
    if ((0, $7jnr7.isNum)(bounds.left)) x = Math.max(x, bounds.left);
    if ((0, $7jnr7.isNum)(bounds.top)) y = Math.max(y, bounds.top);
    return [
        x,
        y
    ];
}
function $df93557b6a1aa90a$var$snapToGrid(grid /*: [number, number]*/ , pendingX /*: number*/ , pendingY /*: number*/ ) /*: [number, number]*/ {
    const x = Math.round(pendingX / grid[0]) * grid[0];
    const y = Math.round(pendingY / grid[1]) * grid[1];
    return [
        x,
        y
    ];
}
function $df93557b6a1aa90a$var$canDragX(draggable /*: Draggable*/ ) /*: boolean*/ {
    return draggable.props.axis === "both" || draggable.props.axis === "x";
}
function $df93557b6a1aa90a$var$canDragY(draggable /*: Draggable*/ ) /*: boolean*/ {
    return draggable.props.axis === "both" || draggable.props.axis === "y";
}
// Get {x, y} positions from event.
function $df93557b6a1aa90a$var$getControlPosition(e /*: MouseTouchEvent*/ , touchIdentifier /*: ?number*/ , draggableCore /*: DraggableCore*/ ) /*: ?ControlPosition*/ {
    const touchObj = typeof touchIdentifier === "number" ? (0, $hVGkP.getTouch)(e, touchIdentifier) : null;
    if (typeof touchIdentifier === "number" && !touchObj) return null; // not the right touch
    const node = $df93557b6a1aa90a$var$findDOMNode(draggableCore);
    // User can provide an offsetParent if desired.
    const offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
    return (0, $hVGkP.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
}
// Create an data object exposed by <DraggableCore>'s events
function $df93557b6a1aa90a$var$createCoreData(draggable /*: DraggableCore*/ , x /*: number*/ , y /*: number*/ ) /*: DraggableData*/ {
    const isStart = !(0, $7jnr7.isNum)(draggable.lastX);
    const node = $df93557b6a1aa90a$var$findDOMNode(draggable);
    if (isStart) // If this is our first move, use the x and y as last coords.
    return {
        node: node,
        deltaX: 0,
        deltaY: 0,
        lastX: x,
        lastY: y,
        x: x,
        y: y
    };
    else // Otherwise calculate proper values.
    return {
        node: node,
        deltaX: x - draggable.lastX,
        deltaY: y - draggable.lastY,
        lastX: draggable.lastX,
        lastY: draggable.lastY,
        x: x,
        y: y
    };
}
// Create an data exposed by <Draggable>'s events
function $df93557b6a1aa90a$var$createDraggableData(draggable /*: Draggable*/ , coreData /*: DraggableData*/ ) /*: DraggableData*/ {
    const scale = draggable.props.scale;
    return {
        node: coreData.node,
        x: draggable.state.x + coreData.deltaX / scale,
        y: draggable.state.y + coreData.deltaY / scale,
        deltaX: coreData.deltaX / scale,
        deltaY: coreData.deltaY / scale,
        lastX: draggable.state.x,
        lastY: draggable.state.y
    };
}
// A lot faster than stringify/parse
function $df93557b6a1aa90a$var$cloneBounds(bounds /*: Bounds*/ ) /*: Bounds*/ {
    return {
        left: bounds.left,
        top: bounds.top,
        right: bounds.right,
        bottom: bounds.bottom
    };
}
function $df93557b6a1aa90a$var$findDOMNode(draggable /*: Draggable | DraggableCore*/ ) /*: HTMLElement*/ {
    const node = draggable.findDOMNode();
    if (!node) throw new Error("<DraggableCore>: Unmounted during event!");
    // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
    return node;
}

});

parcelRegister("ldVpK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f7375926498124e5$var$log;
/*eslint no-console:0*/ function $f7375926498124e5$var$log() {}

});


var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));



var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";

var $1u0KT = parcelRequire("1u0KT");
var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $1u0KT.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $1u0KT.hydrateRoot;



/**
 * React Router DOM v6.23.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
/**
 * @remix-run/router v1.16.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $1d34d5c4a288b213$var$decodePath(pathname);
        matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        unstable_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches);
            result = results[0];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData;
            if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
            // would be a breaking change to use any.
            // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
            actionData = {
                [pendingActionResult[0]]: pendingActionResult[1].data
            };
            else if (state.actionData) {
                if (Object.keys(state.actionData).length === 0) actionData = null;
                else actionData = state.actionData;
            }
            updateState($1d34d5c4a288b213$var$_extends({
                navigation: loadingNavigation
            }, actionData !== undefined ? {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(request, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", fetchRequest, [
            match
        ], requestMatches);
        let actionResult = actionResults[0];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(revalidationRequest, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", fetchRequest, [
            match
        ], matches);
        let result = results[0];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches) {
        try {
            let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties);
            return await Promise.all(results.map((result, i)=>{
                if ($1d34d5c4a288b213$var$isRedirectHandlerResult(result)) {
                    let response = result.result;
                    return {
                        type: $1d34d5c4a288b213$var$ResultType.redirect,
                        response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                    };
                }
                return $1d34d5c4a288b213$var$convertHandlerResultToDataResult(result);
            }));
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            return matchesToLoad.map(()=>({
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                }));
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        let [loaderResults, ...fetcherResults] = await Promise.all([
            matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : [],
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) {
                    let fetcherRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                    return callDataStrategy("loader", fetcherRequest, [
                        f.match
                    ], f.matches).then((r)=>r[0]);
                } else return Promise.resolve({
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                });
            })
        ]);
        await Promise.all([
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, unstable_dataStrategy: unstable_dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `HandlerResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isHandlerResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[0];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(unstable_dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext);
        return await Promise.all(results.map((result, i)=>{
            if ($1d34d5c4a288b213$var$isRedirectHandlerResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            return $1d34d5c4a288b213$var$convertHandlerResultToDataResult(result);
        }));
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$1d34d5c4a288b213$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $1d34d5c4a288b213$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map((m)=>m.resolve()));
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    let routeIdsToLoad = matchesToLoad.reduce((acc, m)=>acc.add(m.route.id), new Set());
    let loadedMatches = new Set();
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: matches.map((match)=>{
            let shouldLoad = routeIdsToLoad.has(match.route.id);
            // `resolve` encapsulates the route.lazy, executing the
            // loader/action, and mapping return values/thrown errors to a
            // HandlerResult.  Users can pass a callback to take fine-grained control
            // over the execution of the loader/action
            let resolve = (handlerOverride)=>{
                loadedMatches.add(match.route.id);
                return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                });
            };
            return $1d34d5c4a288b213$var$_extends({}, match, {
                shouldLoad: shouldLoad,
                resolve: resolve
            });
        }),
        request: request,
        params: matches[0].params,
        context: requestContext
    });
    // Throw if any loadRoute implementations not called since they are what
    // ensures a route is fully loaded
    matches.forEach((m)=>$1d34d5c4a288b213$export$3e9cee6b33872309(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded."));
    // Filter out any middleware-only matches for which we didn't need to run handlers
    return results.filter((_, i)=>routeIdsToLoad.has(matches[i].route.id));
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<HandlerResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise;
        if (handlerOverride) handlerPromise = handlerOverride((ctx)=>actualHandler(ctx));
        else handlerPromise = (async ()=>{
            try {
                let val = await actualHandler();
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // HandlerResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertHandlerResultToDataResult(handlerResult) {
    let { result: result, type: type, status: status } = handlerResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) return {
        type: $1d34d5c4a288b213$var$ResultType.error,
        error: result,
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : status
    };
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result,
        statusCode: status
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $1d34d5c4a288b213$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectHandlerResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $1d34d5c4a288b213$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.23.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned[key]) $7939e29d663dd3ed$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $1u0KT[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}





var $7ff67dcaf0eda1ab$exports = {};
$7ff67dcaf0eda1ab$exports = new URL("logo.69af303e.webp", import.meta.url).toString();


const $5519b20d0c9306a9$var$logoUrl = new URL($7ff67dcaf0eda1ab$exports);
var $fa0ac2351c3841d6$exports = {};
$fa0ac2351c3841d6$exports = new URL("logo_with_text.d0bb7d35.webp", import.meta.url).toString();


const $5519b20d0c9306a9$var$logoWithTextUrl = new URL($fa0ac2351c3841d6$exports);
function $5519b20d0c9306a9$export$e6ff31bff12b7ff4({ withText: withText = false }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex gap-2 items-center",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: withText ? $5519b20d0c9306a9$var$logoWithTextUrl.toString() : $5519b20d0c9306a9$var$logoUrl.toString(),
            alt: "Logo",
            className: "h-8 w-auto"
        })
    });
}





/**
 * @license lucide-react v0.381.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v0.381.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.381.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $db42588f972bc829$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const $db42588f972bc829$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && array.indexOf(className) === index;
    }).join(" ");


/**
 * @license lucide-react v0.381.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.381.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $65855df5fc59b2ec$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};



const $d2b1338ec3fa0df8$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)(({ color: color = "currentColor", size: size = 24, strokeWidth: strokeWidth = 2, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>{
    return (0, $acw62.createElement)("svg", {
        ref: ref,
        ...(0, $65855df5fc59b2ec$export$2e2bcd8739ae039),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, $db42588f972bc829$export$3d46f4579dba46e5)("lucide", className),
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $acw62.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]);
});


const $810dc495bedb1cb1$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $acw62.forwardRef)(({ className: className, ...props }, ref)=>(0, $acw62.createElement)((0, $d2b1338ec3fa0df8$export$2e2bcd8739ae039), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $db42588f972bc829$export$3d46f4579dba46e5)(`lucide-${(0, $db42588f972bc829$export$73bda83cddbc7187)(iconName)}`, className),
            ...props
        }));
    Component.displayName = `${iconName}`;
    return Component;
};


const $2851b04c8fda51c6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("CircleUser", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "10",
            r: "3",
            key: "ilqhr7"
        }
    ],
    [
        "path",
        {
            d: "M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662",
            key: "154egf"
        }
    ]
]);

/**
 * @license lucide-react v0.381.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d8cd836460c6f743$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Film", [
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2",
            key: "afitv7"
        }
    ],
    [
        "path",
        {
            d: "M7 3v18",
            key: "bbkbws"
        }
    ],
    [
        "path",
        {
            d: "M3 7.5h4",
            key: "zfgn84"
        }
    ],
    [
        "path",
        {
            d: "M3 12h18",
            key: "1i2n21"
        }
    ],
    [
        "path",
        {
            d: "M3 16.5h4",
            key: "1230mu"
        }
    ],
    [
        "path",
        {
            d: "M17 3v18",
            key: "in4fa5"
        }
    ],
    [
        "path",
        {
            d: "M17 7.5h4",
            key: "myr1c1"
        }
    ],
    [
        "path",
        {
            d: "M17 16.5h4",
            key: "go4c1d"
        }
    ]
]);

/**
 * @license lucide-react v0.381.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $db352f301915b5ae$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Folders", [
    [
        "path",
        {
            d: "M20 17a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3.9a2 2 0 0 1-1.69-.9l-.81-1.2a2 2 0 0 0-1.67-.9H8a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2Z",
            key: "4u7rpt"
        }
    ],
    [
        "path",
        {
            d: "M2 8v11a2 2 0 0 0 2 2h14",
            key: "1eicx1"
        }
    ]
]);

/**
 * @license lucide-react v0.381.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4b66c39b6083b2b9$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Menu", [
    [
        "line",
        {
            x1: "4",
            x2: "20",
            y1: "12",
            y2: "12",
            key: "1e0a9i"
        }
    ],
    [
        "line",
        {
            x1: "4",
            x2: "20",
            y1: "6",
            y2: "6",
            key: "1owob3"
        }
    ],
    [
        "line",
        {
            x1: "4",
            x2: "20",
            y1: "18",
            y2: "18",
            key: "yk5zj1"
        }
    ]
]);




var $acw62 = parcelRequire("acw62");
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(this, arguments);
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $fb3356a19a5676fa$var$$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $fb3356a19a5676fa$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$fb3356a19a5676fa$var$$6ed0406888f73fc4$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $fb3356a19a5676fa$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $acw62.useCallback)($fb3356a19a5676fa$export$43e446d32b3d21af(...refs), refs);
}


/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $cf381de56a25bc52$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = (0, $acw62.Children).toArray(children);
    const slottable = childrenArray.find($cf381de56a25bc52$var$$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, $acw62.Children).count(newElement) > 1) return (0, $acw62.Children).only(null);
                return /*#__PURE__*/ (0, $acw62.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, $acw62.createElement)($cf381de56a25bc52$var$$5e63c961fc1ce211$var$SlotClone, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, $acw62.isValidElement)(newElement) ? /*#__PURE__*/ (0, $acw62.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, $acw62.createElement)($cf381de56a25bc52$var$$5e63c961fc1ce211$var$SlotClone, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$cf381de56a25bc52$export$8c6ed5c666ac1360.displayName = "Slot";
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $cf381de56a25bc52$var$$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(children)) return /*#__PURE__*/ (0, $acw62.cloneElement)(children, {
        ...$cf381de56a25bc52$var$$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: forwardedRef ? (0, $fb3356a19a5676fa$export$43e446d32b3d21af)(forwardedRef, children.ref) : children.ref
    });
    return (0, $acw62.Children).count(children) > 1 ? (0, $acw62.Children).only(null) : null;
});
$cf381de56a25bc52$var$$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $cf381de56a25bc52$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $cf381de56a25bc52$var$$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, $acw62.isValidElement)(child) && child.type === $cf381de56a25bc52$export$d9f1ccf0bdb05d45;
}
function $cf381de56a25bc52$var$$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $cf381de56a25bc52$export$be92b6f5f03c0fe9 = $cf381de56a25bc52$export$8c6ed5c666ac1360;


function $9f99d12a4badf0f8$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $9f99d12a4badf0f8$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $9f99d12a4badf0f8$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $9f99d12a4badf0f8$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $9f99d12a4badf0f8$export$2e2bcd8739ae039 = $9f99d12a4badf0f8$export$4f5d2d50c9deca37;


const $7d867aa0bbfd521e$var$falsyToString = (value)=>typeof value === "boolean" ? "".concat(value) : value === 0 ? "0" : value;
const $7d867aa0bbfd521e$export$a274e22fb40f762e = (0, $9f99d12a4badf0f8$export$4f5d2d50c9deca37);
const $7d867aa0bbfd521e$export$87dc52566e90b739 = (base, config)=>{
    return (props)=>{
        var ref;
        if ((config === null || config === void 0 ? void 0 : config.variants) == null) return $7d867aa0bbfd521e$export$a274e22fb40f762e(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
        const { variants: variants, defaultVariants: defaultVariants } = config;
        const getVariantClassNames = Object.keys(variants).map((variant)=>{
            const variantProp = props === null || props === void 0 ? void 0 : props[variant];
            const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
            if (variantProp === null) return null;
            const variantKey = $7d867aa0bbfd521e$var$falsyToString(variantProp) || $7d867aa0bbfd521e$var$falsyToString(defaultVariantProp);
            return variants[variant][variantKey];
        });
        const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param)=>{
            let [key, value] = param;
            if (value === undefined) return acc;
            acc[key] = value;
            return acc;
        }, {});
        const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (ref = config.compoundVariants) === null || ref === void 0 ? void 0 : ref.reduce((acc, param1)=>{
            let { class: cvClass, className: cvClassName, ...compoundVariantOptions } = param1;
            return Object.entries(compoundVariantOptions).every((param)=>{
                let [key, value] = param;
                return Array.isArray(value) ? value.includes({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                }[key]) : ({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                })[key] === value;
            }) ? [
                ...acc,
                cvClass,
                cvClassName
            ] : acc;
        }, []);
        return $7d867aa0bbfd521e$export$a274e22fb40f762e(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
    };
};


function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;


const $0bcdbd343f256d28$var$CLASS_PART_SEPARATOR = "-";
function $0bcdbd343f256d28$var$createClassUtils(config) {
    const classMap = $0bcdbd343f256d28$var$createClassMap(config);
    const { conflictingClassGroups: conflictingClassGroups, conflictingClassGroupModifiers: conflictingClassGroupModifiers } = config;
    function getClassGroupId(className) {
        const classParts = className.split($0bcdbd343f256d28$var$CLASS_PART_SEPARATOR);
        // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and remove it from classParts.
        if (classParts[0] === "" && classParts.length !== 1) classParts.shift();
        return $0bcdbd343f256d28$var$getGroupRecursive(classParts, classMap) || $0bcdbd343f256d28$var$getGroupIdForArbitraryProperty(className);
    }
    function getConflictingClassGroupIds(classGroupId, hasPostfixModifier) {
        const conflicts = conflictingClassGroups[classGroupId] || [];
        if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) return [
            ...conflicts,
            ...conflictingClassGroupModifiers[classGroupId]
        ];
        return conflicts;
    }
    return {
        getClassGroupId: getClassGroupId,
        getConflictingClassGroupIds: getConflictingClassGroupIds
    };
}
function $0bcdbd343f256d28$var$getGroupRecursive(classParts, classPartObject) {
    if (classParts.length === 0) return classPartObject.classGroupId;
    const currentClassPart = classParts[0];
    const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
    const classGroupFromNextClassPart = nextClassPartObject ? $0bcdbd343f256d28$var$getGroupRecursive(classParts.slice(1), nextClassPartObject) : undefined;
    if (classGroupFromNextClassPart) return classGroupFromNextClassPart;
    if (classPartObject.validators.length === 0) return undefined;
    const classRest = classParts.join($0bcdbd343f256d28$var$CLASS_PART_SEPARATOR);
    return classPartObject.validators.find(({ validator: validator })=>validator(classRest))?.classGroupId;
}
const $0bcdbd343f256d28$var$arbitraryPropertyRegex = /^\[(.+)\]$/;
function $0bcdbd343f256d28$var$getGroupIdForArbitraryProperty(className) {
    if ($0bcdbd343f256d28$var$arbitraryPropertyRegex.test(className)) {
        const arbitraryPropertyClassName = $0bcdbd343f256d28$var$arbitraryPropertyRegex.exec(className)[1];
        const property = arbitraryPropertyClassName?.substring(0, arbitraryPropertyClassName.indexOf(":"));
        if (property) // I use two dots here because one dot is used as prefix for class groups in plugins
        return "arbitrary.." + property;
    }
}
/**
 * Exported for testing only
 */ function $0bcdbd343f256d28$var$createClassMap(config) {
    const { theme: theme, prefix: prefix } = config;
    const classMap = {
        nextPart: new Map(),
        validators: []
    };
    const prefixedClassGroupEntries = $0bcdbd343f256d28$var$getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
    prefixedClassGroupEntries.forEach(([classGroupId, classGroup])=>{
        $0bcdbd343f256d28$var$processClassesRecursively(classGroup, classMap, classGroupId, theme);
    });
    return classMap;
}
function $0bcdbd343f256d28$var$processClassesRecursively(classGroup, classPartObject, classGroupId, theme) {
    classGroup.forEach((classDefinition)=>{
        if (typeof classDefinition === "string") {
            const classPartObjectToEdit = classDefinition === "" ? classPartObject : $0bcdbd343f256d28$var$getPart(classPartObject, classDefinition);
            classPartObjectToEdit.classGroupId = classGroupId;
            return;
        }
        if (typeof classDefinition === "function") {
            if ($0bcdbd343f256d28$var$isThemeGetter(classDefinition)) {
                $0bcdbd343f256d28$var$processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
                return;
            }
            classPartObject.validators.push({
                validator: classDefinition,
                classGroupId: classGroupId
            });
            return;
        }
        Object.entries(classDefinition).forEach(([key, classGroup])=>{
            $0bcdbd343f256d28$var$processClassesRecursively(classGroup, $0bcdbd343f256d28$var$getPart(classPartObject, key), classGroupId, theme);
        });
    });
}
function $0bcdbd343f256d28$var$getPart(classPartObject, path) {
    let currentClassPartObject = classPartObject;
    path.split($0bcdbd343f256d28$var$CLASS_PART_SEPARATOR).forEach((pathPart)=>{
        if (!currentClassPartObject.nextPart.has(pathPart)) currentClassPartObject.nextPart.set(pathPart, {
            nextPart: new Map(),
            validators: []
        });
        currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
    });
    return currentClassPartObject;
}
function $0bcdbd343f256d28$var$isThemeGetter(func) {
    return func.isThemeGetter;
}
function $0bcdbd343f256d28$var$getPrefixedClassGroupEntries(classGroupEntries, prefix) {
    if (!prefix) return classGroupEntries;
    return classGroupEntries.map(([classGroupId, classGroup])=>{
        const prefixedClassGroup = classGroup.map((classDefinition)=>{
            if (typeof classDefinition === "string") return prefix + classDefinition;
            if (typeof classDefinition === "object") return Object.fromEntries(Object.entries(classDefinition).map(([key, value])=>[
                    prefix + key,
                    value
                ]));
            return classDefinition;
        });
        return [
            classGroupId,
            prefixedClassGroup
        ];
    });
}
// LRU cache inspired from hashlru (https://github.com/dominictarr/hashlru/blob/v1.0.4/index.js) but object replaced with Map to improve performance
function $0bcdbd343f256d28$var$createLruCache(maxCacheSize) {
    if (maxCacheSize < 1) return {
        get: ()=>undefined,
        set: ()=>{}
    };
    let cacheSize = 0;
    let cache = new Map();
    let previousCache = new Map();
    function update(key, value) {
        cache.set(key, value);
        cacheSize++;
        if (cacheSize > maxCacheSize) {
            cacheSize = 0;
            previousCache = cache;
            cache = new Map();
        }
    }
    return {
        get (key) {
            let value = cache.get(key);
            if (value !== undefined) return value;
            if ((value = previousCache.get(key)) !== undefined) {
                update(key, value);
                return value;
            }
        },
        set (key, value) {
            if (cache.has(key)) cache.set(key, value);
            else update(key, value);
        }
    };
}
const $0bcdbd343f256d28$var$IMPORTANT_MODIFIER = "!";
function $0bcdbd343f256d28$var$createSplitModifiers(config) {
    const separator = config.separator;
    const isSeparatorSingleCharacter = separator.length === 1;
    const firstSeparatorCharacter = separator[0];
    const separatorLength = separator.length;
    // splitModifiers inspired by https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
    return function splitModifiers(className) {
        const modifiers = [];
        let bracketDepth = 0;
        let modifierStart = 0;
        let postfixModifierPosition;
        for(let index = 0; index < className.length; index++){
            let currentCharacter = className[index];
            if (bracketDepth === 0) {
                if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
                    modifiers.push(className.slice(modifierStart, index));
                    modifierStart = index + separatorLength;
                    continue;
                }
                if (currentCharacter === "/") {
                    postfixModifierPosition = index;
                    continue;
                }
            }
            if (currentCharacter === "[") bracketDepth++;
            else if (currentCharacter === "]") bracketDepth--;
        }
        const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
        const hasImportantModifier = baseClassNameWithImportantModifier.startsWith($0bcdbd343f256d28$var$IMPORTANT_MODIFIER);
        const baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
        const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
        return {
            modifiers: modifiers,
            hasImportantModifier: hasImportantModifier,
            baseClassName: baseClassName,
            maybePostfixModifierPosition: maybePostfixModifierPosition
        };
    };
}
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */ function $0bcdbd343f256d28$var$sortModifiers(modifiers) {
    if (modifiers.length <= 1) return modifiers;
    const sortedModifiers = [];
    let unsortedModifiers = [];
    modifiers.forEach((modifier)=>{
        const isArbitraryVariant = modifier[0] === "[";
        if (isArbitraryVariant) {
            sortedModifiers.push(...unsortedModifiers.sort(), modifier);
            unsortedModifiers = [];
        } else unsortedModifiers.push(modifier);
    });
    sortedModifiers.push(...unsortedModifiers.sort());
    return sortedModifiers;
}
function $0bcdbd343f256d28$var$createConfigUtils(config) {
    return {
        cache: $0bcdbd343f256d28$var$createLruCache(config.cacheSize),
        splitModifiers: $0bcdbd343f256d28$var$createSplitModifiers(config),
        ...$0bcdbd343f256d28$var$createClassUtils(config)
    };
}
const $0bcdbd343f256d28$var$SPLIT_CLASSES_REGEX = /\s+/;
function $0bcdbd343f256d28$var$mergeClassList(classList, configUtils) {
    const { splitModifiers: splitModifiers, getClassGroupId: getClassGroupId, getConflictingClassGroupIds: getConflictingClassGroupIds } = configUtils;
    /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */ const classGroupsInConflict = new Set();
    return classList.trim().split($0bcdbd343f256d28$var$SPLIT_CLASSES_REGEX).map((originalClassName)=>{
        const { modifiers: modifiers, hasImportantModifier: hasImportantModifier, baseClassName: baseClassName, maybePostfixModifierPosition: maybePostfixModifierPosition } = splitModifiers(originalClassName);
        let classGroupId = getClassGroupId(maybePostfixModifierPosition ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
        let hasPostfixModifier = Boolean(maybePostfixModifierPosition);
        if (!classGroupId) {
            if (!maybePostfixModifierPosition) return {
                isTailwindClass: false,
                originalClassName: originalClassName
            };
            classGroupId = getClassGroupId(baseClassName);
            if (!classGroupId) return {
                isTailwindClass: false,
                originalClassName: originalClassName
            };
            hasPostfixModifier = false;
        }
        const variantModifier = $0bcdbd343f256d28$var$sortModifiers(modifiers).join(":");
        const modifierId = hasImportantModifier ? variantModifier + $0bcdbd343f256d28$var$IMPORTANT_MODIFIER : variantModifier;
        return {
            isTailwindClass: true,
            modifierId: modifierId,
            classGroupId: classGroupId,
            originalClassName: originalClassName,
            hasPostfixModifier: hasPostfixModifier
        };
    }).reverse()// Last class in conflict wins, so we need to filter conflicting classes in reverse order.
    .filter((parsed)=>{
        if (!parsed.isTailwindClass) return true;
        const { modifierId: modifierId, classGroupId: classGroupId, hasPostfixModifier: hasPostfixModifier } = parsed;
        const classId = modifierId + classGroupId;
        if (classGroupsInConflict.has(classId)) return false;
        classGroupsInConflict.add(classId);
        getConflictingClassGroupIds(classGroupId, hasPostfixModifier).forEach((group)=>classGroupsInConflict.add(modifierId + group));
        return true;
    }).reverse().map((parsed)=>parsed.originalClassName).join(" ");
}
/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */ function $0bcdbd343f256d28$export$a8bbfb445e1f163f() {
    let index = 0;
    let argument;
    let resolvedValue;
    let string = "";
    while(index < arguments.length){
        if (argument = arguments[index++]) {
            if (resolvedValue = $0bcdbd343f256d28$var$toValue(argument)) {
                string && (string += " ");
                string += resolvedValue;
            }
        }
    }
    return string;
}
function $0bcdbd343f256d28$var$toValue(mix) {
    if (typeof mix === "string") return mix;
    let resolvedValue;
    let string = "";
    for(let k = 0; k < mix.length; k++){
        if (mix[k]) {
            if (resolvedValue = $0bcdbd343f256d28$var$toValue(mix[k])) {
                string && (string += " ");
                string += resolvedValue;
            }
        }
    }
    return string;
}
function $0bcdbd343f256d28$export$ea2d4fba4d1bd27f(createConfigFirst, ...createConfigRest) {
    let configUtils;
    let cacheGet;
    let cacheSet;
    let functionToCall = initTailwindMerge;
    function initTailwindMerge(classList) {
        const config = createConfigRest.reduce((previousConfig, createConfigCurrent)=>createConfigCurrent(previousConfig), createConfigFirst());
        configUtils = $0bcdbd343f256d28$var$createConfigUtils(config);
        cacheGet = configUtils.cache.get;
        cacheSet = configUtils.cache.set;
        functionToCall = tailwindMerge;
        return tailwindMerge(classList);
    }
    function tailwindMerge(classList) {
        const cachedResult = cacheGet(classList);
        if (cachedResult) return cachedResult;
        const result = $0bcdbd343f256d28$var$mergeClassList(classList, configUtils);
        cacheSet(classList, result);
        return result;
    }
    return function callTailwindMerge() {
        return functionToCall($0bcdbd343f256d28$export$a8bbfb445e1f163f.apply(null, arguments));
    };
}
function $0bcdbd343f256d28$export$e176af7b8eefe933(key) {
    const themeGetter = (theme)=>theme[key] || [];
    themeGetter.isThemeGetter = true;
    return themeGetter;
}
const $0bcdbd343f256d28$var$arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
const $0bcdbd343f256d28$var$fractionRegex = /^\d+\/\d+$/;
const $0bcdbd343f256d28$var$stringLengths = /*#__PURE__*/ new Set([
    "px",
    "full",
    "screen"
]);
const $0bcdbd343f256d28$var$tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const $0bcdbd343f256d28$var$lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const $0bcdbd343f256d28$var$colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/;
// Shadow always begins with x and y offset separated by underscore optionally prepended by inset
const $0bcdbd343f256d28$var$shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const $0bcdbd343f256d28$var$imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function $0bcdbd343f256d28$var$isLength(value) {
    return $0bcdbd343f256d28$var$isNumber(value) || $0bcdbd343f256d28$var$stringLengths.has(value) || $0bcdbd343f256d28$var$fractionRegex.test(value);
}
function $0bcdbd343f256d28$var$isArbitraryLength(value) {
    return $0bcdbd343f256d28$var$getIsArbitraryValue(value, "length", $0bcdbd343f256d28$var$isLengthOnly);
}
function $0bcdbd343f256d28$var$isNumber(value) {
    return Boolean(value) && !Number.isNaN(Number(value));
}
function $0bcdbd343f256d28$var$isArbitraryNumber(value) {
    return $0bcdbd343f256d28$var$getIsArbitraryValue(value, "number", $0bcdbd343f256d28$var$isNumber);
}
function $0bcdbd343f256d28$var$isInteger(value) {
    return Boolean(value) && Number.isInteger(Number(value));
}
function $0bcdbd343f256d28$var$isPercent(value) {
    return value.endsWith("%") && $0bcdbd343f256d28$var$isNumber(value.slice(0, -1));
}
function $0bcdbd343f256d28$var$isArbitraryValue(value) {
    return $0bcdbd343f256d28$var$arbitraryValueRegex.test(value);
}
function $0bcdbd343f256d28$var$isTshirtSize(value) {
    return $0bcdbd343f256d28$var$tshirtUnitRegex.test(value);
}
const $0bcdbd343f256d28$var$sizeLabels = /*#__PURE__*/ new Set([
    "length",
    "size",
    "percentage"
]);
function $0bcdbd343f256d28$var$isArbitrarySize(value) {
    return $0bcdbd343f256d28$var$getIsArbitraryValue(value, $0bcdbd343f256d28$var$sizeLabels, $0bcdbd343f256d28$var$isNever);
}
function $0bcdbd343f256d28$var$isArbitraryPosition(value) {
    return $0bcdbd343f256d28$var$getIsArbitraryValue(value, "position", $0bcdbd343f256d28$var$isNever);
}
const $0bcdbd343f256d28$var$imageLabels = /*#__PURE__*/ new Set([
    "image",
    "url"
]);
function $0bcdbd343f256d28$var$isArbitraryImage(value) {
    return $0bcdbd343f256d28$var$getIsArbitraryValue(value, $0bcdbd343f256d28$var$imageLabels, $0bcdbd343f256d28$var$isImage);
}
function $0bcdbd343f256d28$var$isArbitraryShadow(value) {
    return $0bcdbd343f256d28$var$getIsArbitraryValue(value, "", $0bcdbd343f256d28$var$isShadow);
}
function $0bcdbd343f256d28$var$isAny() {
    return true;
}
function $0bcdbd343f256d28$var$getIsArbitraryValue(value, label, testValue) {
    const result = $0bcdbd343f256d28$var$arbitraryValueRegex.exec(value);
    if (result) {
        if (result[1]) return typeof label === "string" ? result[1] === label : label.has(result[1]);
        return testValue(result[2]);
    }
    return false;
}
function $0bcdbd343f256d28$var$isLengthOnly(value) {
    // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
    // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
    // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
    return $0bcdbd343f256d28$var$lengthUnitRegex.test(value) && !$0bcdbd343f256d28$var$colorFunctionRegex.test(value);
}
function $0bcdbd343f256d28$var$isNever() {
    return false;
}
function $0bcdbd343f256d28$var$isShadow(value) {
    return $0bcdbd343f256d28$var$shadowRegex.test(value);
}
function $0bcdbd343f256d28$var$isImage(value) {
    return $0bcdbd343f256d28$var$imageRegex.test(value);
}
const $0bcdbd343f256d28$export$6f98703d2f5d4276 = /*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    isAny: $0bcdbd343f256d28$var$isAny,
    isArbitraryImage: $0bcdbd343f256d28$var$isArbitraryImage,
    isArbitraryLength: $0bcdbd343f256d28$var$isArbitraryLength,
    isArbitraryNumber: $0bcdbd343f256d28$var$isArbitraryNumber,
    isArbitraryPosition: $0bcdbd343f256d28$var$isArbitraryPosition,
    isArbitraryShadow: $0bcdbd343f256d28$var$isArbitraryShadow,
    isArbitrarySize: $0bcdbd343f256d28$var$isArbitrarySize,
    isArbitraryValue: $0bcdbd343f256d28$var$isArbitraryValue,
    isInteger: $0bcdbd343f256d28$var$isInteger,
    isLength: $0bcdbd343f256d28$var$isLength,
    isNumber: $0bcdbd343f256d28$var$isNumber,
    isPercent: $0bcdbd343f256d28$var$isPercent,
    isTshirtSize: $0bcdbd343f256d28$var$isTshirtSize
}, Symbol.toStringTag, {
    value: "Module"
});
function $0bcdbd343f256d28$export$ed30944e0fe6ae5c() {
    const colors = $0bcdbd343f256d28$export$e176af7b8eefe933("colors");
    const spacing = $0bcdbd343f256d28$export$e176af7b8eefe933("spacing");
    const blur = $0bcdbd343f256d28$export$e176af7b8eefe933("blur");
    const brightness = $0bcdbd343f256d28$export$e176af7b8eefe933("brightness");
    const borderColor = $0bcdbd343f256d28$export$e176af7b8eefe933("borderColor");
    const borderRadius = $0bcdbd343f256d28$export$e176af7b8eefe933("borderRadius");
    const borderSpacing = $0bcdbd343f256d28$export$e176af7b8eefe933("borderSpacing");
    const borderWidth = $0bcdbd343f256d28$export$e176af7b8eefe933("borderWidth");
    const contrast = $0bcdbd343f256d28$export$e176af7b8eefe933("contrast");
    const grayscale = $0bcdbd343f256d28$export$e176af7b8eefe933("grayscale");
    const hueRotate = $0bcdbd343f256d28$export$e176af7b8eefe933("hueRotate");
    const invert = $0bcdbd343f256d28$export$e176af7b8eefe933("invert");
    const gap = $0bcdbd343f256d28$export$e176af7b8eefe933("gap");
    const gradientColorStops = $0bcdbd343f256d28$export$e176af7b8eefe933("gradientColorStops");
    const gradientColorStopPositions = $0bcdbd343f256d28$export$e176af7b8eefe933("gradientColorStopPositions");
    const inset = $0bcdbd343f256d28$export$e176af7b8eefe933("inset");
    const margin = $0bcdbd343f256d28$export$e176af7b8eefe933("margin");
    const opacity = $0bcdbd343f256d28$export$e176af7b8eefe933("opacity");
    const padding = $0bcdbd343f256d28$export$e176af7b8eefe933("padding");
    const saturate = $0bcdbd343f256d28$export$e176af7b8eefe933("saturate");
    const scale = $0bcdbd343f256d28$export$e176af7b8eefe933("scale");
    const sepia = $0bcdbd343f256d28$export$e176af7b8eefe933("sepia");
    const skew = $0bcdbd343f256d28$export$e176af7b8eefe933("skew");
    const space = $0bcdbd343f256d28$export$e176af7b8eefe933("space");
    const translate = $0bcdbd343f256d28$export$e176af7b8eefe933("translate");
    const getOverscroll = ()=>[
            "auto",
            "contain",
            "none"
        ];
    const getOverflow = ()=>[
            "auto",
            "hidden",
            "clip",
            "visible",
            "scroll"
        ];
    const getSpacingWithAutoAndArbitrary = ()=>[
            "auto",
            $0bcdbd343f256d28$var$isArbitraryValue,
            spacing
        ];
    const getSpacingWithArbitrary = ()=>[
            $0bcdbd343f256d28$var$isArbitraryValue,
            spacing
        ];
    const getLengthWithEmptyAndArbitrary = ()=>[
            "",
            $0bcdbd343f256d28$var$isLength,
            $0bcdbd343f256d28$var$isArbitraryLength
        ];
    const getNumberWithAutoAndArbitrary = ()=>[
            "auto",
            $0bcdbd343f256d28$var$isNumber,
            $0bcdbd343f256d28$var$isArbitraryValue
        ];
    const getPositions = ()=>[
            "bottom",
            "center",
            "left",
            "left-bottom",
            "left-top",
            "right",
            "right-bottom",
            "right-top",
            "top"
        ];
    const getLineStyles = ()=>[
            "solid",
            "dashed",
            "dotted",
            "double",
            "none"
        ];
    const getBlendModes = ()=>[
            "normal",
            "multiply",
            "screen",
            "overlay",
            "darken",
            "lighten",
            "color-dodge",
            "color-burn",
            "hard-light",
            "soft-light",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity"
        ];
    const getAlign = ()=>[
            "start",
            "end",
            "center",
            "between",
            "around",
            "evenly",
            "stretch"
        ];
    const getZeroAndEmpty = ()=>[
            "",
            "0",
            $0bcdbd343f256d28$var$isArbitraryValue
        ];
    const getBreaks = ()=>[
            "auto",
            "avoid",
            "all",
            "avoid-page",
            "page",
            "left",
            "right",
            "column"
        ];
    const getNumber = ()=>[
            $0bcdbd343f256d28$var$isNumber,
            $0bcdbd343f256d28$var$isArbitraryNumber
        ];
    const getNumberAndArbitrary = ()=>[
            $0bcdbd343f256d28$var$isNumber,
            $0bcdbd343f256d28$var$isArbitraryValue
        ];
    return {
        cacheSize: 500,
        separator: ":",
        theme: {
            colors: [
                $0bcdbd343f256d28$var$isAny
            ],
            spacing: [
                $0bcdbd343f256d28$var$isLength,
                $0bcdbd343f256d28$var$isArbitraryLength
            ],
            blur: [
                "none",
                "",
                $0bcdbd343f256d28$var$isTshirtSize,
                $0bcdbd343f256d28$var$isArbitraryValue
            ],
            brightness: getNumber(),
            borderColor: [
                colors
            ],
            borderRadius: [
                "none",
                "",
                "full",
                $0bcdbd343f256d28$var$isTshirtSize,
                $0bcdbd343f256d28$var$isArbitraryValue
            ],
            borderSpacing: getSpacingWithArbitrary(),
            borderWidth: getLengthWithEmptyAndArbitrary(),
            contrast: getNumber(),
            grayscale: getZeroAndEmpty(),
            hueRotate: getNumberAndArbitrary(),
            invert: getZeroAndEmpty(),
            gap: getSpacingWithArbitrary(),
            gradientColorStops: [
                colors
            ],
            gradientColorStopPositions: [
                $0bcdbd343f256d28$var$isPercent,
                $0bcdbd343f256d28$var$isArbitraryLength
            ],
            inset: getSpacingWithAutoAndArbitrary(),
            margin: getSpacingWithAutoAndArbitrary(),
            opacity: getNumber(),
            padding: getSpacingWithArbitrary(),
            saturate: getNumber(),
            scale: getNumber(),
            sepia: getZeroAndEmpty(),
            skew: getNumberAndArbitrary(),
            space: getSpacingWithArbitrary(),
            translate: getSpacingWithArbitrary()
        },
        classGroups: {
            // Layout
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        "auto",
                        "square",
                        "video",
                        $0bcdbd343f256d28$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */ container: [
                "container"
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        $0bcdbd343f256d28$var$isTshirtSize
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ "break-after": [
                {
                    "break-after": getBreaks()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ "break-before": [
                {
                    "break-before": getBreaks()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ "break-inside": [
                {
                    "break-inside": [
                        "auto",
                        "avoid",
                        "avoid-page",
                        "avoid-column"
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ "box-decoration": [
                {
                    "box-decoration": [
                        "slice",
                        "clone"
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        "border",
                        "content"
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                "block",
                "inline-block",
                "inline",
                "flex",
                "inline-flex",
                "table",
                "inline-table",
                "table-caption",
                "table-cell",
                "table-column",
                "table-column-group",
                "table-footer-group",
                "table-header-group",
                "table-row-group",
                "table-row",
                "flow-root",
                "grid",
                "inline-grid",
                "contents",
                "list-item",
                "hidden"
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ float: [
                {
                    float: [
                        "right",
                        "left",
                        "none",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        "left",
                        "right",
                        "both",
                        "none",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                "isolate",
                "isolation-auto"
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ "object-fit": [
                {
                    object: [
                        "contain",
                        "cover",
                        "fill",
                        "none",
                        "scale-down"
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ "object-position": [
                {
                    object: [
                        ...getPositions(),
                        $0bcdbd343f256d28$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: getOverflow()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-x": [
                {
                    "overflow-x": getOverflow()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-y": [
                {
                    "overflow-y": getOverflow()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-x": [
                {
                    "overscroll-x": getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-y": [
                {
                    "overscroll-y": getOverscroll()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                "static",
                "fixed",
                "absolute",
                "relative",
                "sticky"
            ],
            /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: [
                        inset
                    ]
                }
            ],
            /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-x": [
                {
                    "inset-x": [
                        inset
                    ]
                }
            ],
            /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-y": [
                {
                    "inset-y": [
                        inset
                    ]
                }
            ],
            /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ start: [
                {
                    start: [
                        inset
                    ]
                }
            ],
            /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ end: [
                {
                    end: [
                        inset
                    ]
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: [
                        inset
                    ]
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: [
                        inset
                    ]
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: [
                        inset
                    ]
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: [
                        inset
                    ]
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                "visible",
                "invisible",
                "collapse"
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        "auto",
                        $0bcdbd343f256d28$var$isInteger,
                        $0bcdbd343f256d28$var$isArbitraryValue
                    ]
                }
            ],
            // Flexbox and Grid
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: getSpacingWithAutoAndArbitrary()
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ "flex-direction": [
                {
                    flex: [
                        "row",
                        "row-reverse",
                        "col",
                        "col-reverse"
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ "flex-wrap": [
                {
                    flex: [
                        "wrap",
                        "wrap-reverse",
                        "nowrap"
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        "1",
                        "auto",
                        "initial",
                        "none",
                        $0bcdbd343f256d28$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: getZeroAndEmpty()
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: getZeroAndEmpty()
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        "first",
                        "last",
                        "none",
                        $0bcdbd343f256d28$var$isInteger,
                        $0bcdbd343f256d28$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ "grid-cols": [
                {
                    "grid-cols": [
                        $0bcdbd343f256d28$var$isAny
                    ]
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start-end": [
                {
                    col: [
                        "auto",
                        {
                            span: [
                                "full",
                                $0bcdbd343f256d28$var$isInteger,
                                $0bcdbd343f256d28$var$isArbitraryValue
                            ]
                        },
                        $0bcdbd343f256d28$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start": [
                {
                    "col-start": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-end": [
                {
                    "col-end": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ "grid-rows": [
                {
                    "grid-rows": [
                        $0bcdbd343f256d28$var$isAny
                    ]
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start-end": [
                {
                    row: [
                        "auto",
                        {
                            span: [
                                $0bcdbd343f256d28$var$isInteger,
                                $0bcdbd343f256d28$var$isArbitraryValue
                            ]
                        },
                        $0bcdbd343f256d28$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start": [
                {
                    "row-start": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-end": [
                {
                    "row-end": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ "grid-flow": [
                {
                    "grid-flow": [
                        "row",
                        "col",
                        "dense",
                        "row-dense",
                        "col-dense"
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ "auto-cols": [
                {
                    "auto-cols": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        $0bcdbd343f256d28$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ "auto-rows": [
                {
                    "auto-rows": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        $0bcdbd343f256d28$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: [
                        gap
                    ]
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ "gap-x": [
                {
                    "gap-x": [
                        gap
                    ]
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ "gap-y": [
                {
                    "gap-y": [
                        gap
                    ]
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ "justify-content": [
                {
                    justify: [
                        "normal",
                        ...getAlign()
                    ]
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ "justify-items": [
                {
                    "justify-items": [
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ "justify-self": [
                {
                    "justify-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ "align-content": [
                {
                    content: [
                        "normal",
                        ...getAlign(),
                        "baseline"
                    ]
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ "align-items": [
                {
                    items: [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ "align-self": [
                {
                    self: [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch",
                        "baseline"
                    ]
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ "place-content": [
                {
                    "place-content": [
                        ...getAlign(),
                        "baseline"
                    ]
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ "place-items": [
                {
                    "place-items": [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ "place-self": [
                {
                    "place-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: [
                        padding
                    ]
                }
            ],
            /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: [
                        padding
                    ]
                }
            ],
            /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: [
                        padding
                    ]
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: [
                        margin
                    ]
                }
            ],
            /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: [
                        margin
                    ]
                }
            ],
            /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: [
                        margin
                    ]
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */ "space-x": [
                {
                    "space-x": [
                        space
                    ]
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-x-reverse": [
                "space-x-reverse"
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */ "space-y": [
                {
                    "space-y": [
                        space
                    ]
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-y-reverse": [
                "space-y-reverse"
            ],
            // Sizing
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        "auto",
                        "min",
                        "max",
                        "fit",
                        "svw",
                        "lvw",
                        "dvw",
                        $0bcdbd343f256d28$var$isArbitraryValue,
                        spacing
                    ]
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ "min-w": [
                {
                    "min-w": [
                        $0bcdbd343f256d28$var$isArbitraryValue,
                        spacing,
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ "max-w": [
                {
                    "max-w": [
                        $0bcdbd343f256d28$var$isArbitraryValue,
                        spacing,
                        "none",
                        "full",
                        "min",
                        "max",
                        "fit",
                        "prose",
                        {
                            screen: [
                                $0bcdbd343f256d28$var$isTshirtSize
                            ]
                        },
                        $0bcdbd343f256d28$var$isTshirtSize
                    ]
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        $0bcdbd343f256d28$var$isArbitraryValue,
                        spacing,
                        "auto",
                        "min",
                        "max",
                        "fit",
                        "svh",
                        "lvh",
                        "dvh"
                    ]
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ "min-h": [
                {
                    "min-h": [
                        $0bcdbd343f256d28$var$isArbitraryValue,
                        spacing,
                        "min",
                        "max",
                        "fit",
                        "svh",
                        "lvh",
                        "dvh"
                    ]
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ "max-h": [
                {
                    "max-h": [
                        $0bcdbd343f256d28$var$isArbitraryValue,
                        spacing,
                        "min",
                        "max",
                        "fit",
                        "svh",
                        "lvh",
                        "dvh"
                    ]
                }
            ],
            /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */ size: [
                {
                    size: [
                        $0bcdbd343f256d28$var$isArbitraryValue,
                        spacing,
                        "auto",
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            // Typography
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ "font-size": [
                {
                    text: [
                        "base",
                        $0bcdbd343f256d28$var$isTshirtSize,
                        $0bcdbd343f256d28$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ "font-smoothing": [
                "antialiased",
                "subpixel-antialiased"
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ "font-style": [
                "italic",
                "not-italic"
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ "font-weight": [
                {
                    font: [
                        "thin",
                        "extralight",
                        "light",
                        "normal",
                        "medium",
                        "semibold",
                        "bold",
                        "extrabold",
                        "black",
                        $0bcdbd343f256d28$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ "font-family": [
                {
                    font: [
                        $0bcdbd343f256d28$var$isAny
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-normal": [
                "normal-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-ordinal": [
                "ordinal"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-slashed-zero": [
                "slashed-zero"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-figure": [
                "lining-nums",
                "oldstyle-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-spacing": [
                "proportional-nums",
                "tabular-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-fraction": [
                "diagonal-fractions",
                "stacked-fractons"
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        "tighter",
                        "tight",
                        "normal",
                        "wide",
                        "wider",
                        "widest",
                        $0bcdbd343f256d28$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ "line-clamp": [
                {
                    "line-clamp": [
                        "none",
                        $0bcdbd343f256d28$var$isNumber,
                        $0bcdbd343f256d28$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        "none",
                        "tight",
                        "snug",
                        "normal",
                        "relaxed",
                        "loose",
                        $0bcdbd343f256d28$var$isLength,
                        $0bcdbd343f256d28$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ "list-image": [
                {
                    "list-image": [
                        "none",
                        $0bcdbd343f256d28$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ "list-style-type": [
                {
                    list: [
                        "none",
                        "disc",
                        "decimal",
                        $0bcdbd343f256d28$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ "list-style-position": [
                {
                    list: [
                        "inside",
                        "outside"
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */ "placeholder-color": [
                {
                    placeholder: [
                        colors
                    ]
                }
            ],
            /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */ "placeholder-opacity": [
                {
                    "placeholder-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ "text-alignment": [
                {
                    text: [
                        "left",
                        "center",
                        "right",
                        "justify",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ "text-color": [
                {
                    text: [
                        colors
                    ]
                }
            ],
            /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */ "text-opacity": [
                {
                    "text-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ "text-decoration": [
                "underline",
                "overline",
                "line-through",
                "no-underline"
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ "text-decoration-style": [
                {
                    decoration: [
                        ...getLineStyles(),
                        "wavy"
                    ]
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ "text-decoration-thickness": [
                {
                    decoration: [
                        "auto",
                        "from-font",
                        $0bcdbd343f256d28$var$isLength,
                        $0bcdbd343f256d28$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ "underline-offset": [
                {
                    "underline-offset": [
                        "auto",
                        $0bcdbd343f256d28$var$isLength,
                        $0bcdbd343f256d28$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ "text-decoration-color": [
                {
                    decoration: [
                        colors
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ "text-transform": [
                "uppercase",
                "lowercase",
                "capitalize",
                "normal-case"
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ "text-overflow": [
                "truncate",
                "text-ellipsis",
                "text-clip"
            ],
            /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */ "text-wrap": [
                {
                    text: [
                        "wrap",
                        "nowrap",
                        "balance",
                        "pretty"
                    ]
                }
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: getSpacingWithArbitrary()
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ "vertical-align": [
                {
                    align: [
                        "baseline",
                        "top",
                        "middle",
                        "bottom",
                        "text-top",
                        "text-bottom",
                        "sub",
                        "super",
                        $0bcdbd343f256d28$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        "normal",
                        "nowrap",
                        "pre",
                        "pre-line",
                        "pre-wrap",
                        "break-spaces"
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ break: [
                {
                    break: [
                        "normal",
                        "words",
                        "all",
                        "keep"
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        "none",
                        "manual",
                        "auto"
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        "none",
                        $0bcdbd343f256d28$var$isArbitraryValue
                    ]
                }
            ],
            // Backgrounds
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ "bg-attachment": [
                {
                    bg: [
                        "fixed",
                        "local",
                        "scroll"
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ "bg-clip": [
                {
                    "bg-clip": [
                        "border",
                        "padding",
                        "content",
                        "text"
                    ]
                }
            ],
            /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */ "bg-opacity": [
                {
                    "bg-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ "bg-origin": [
                {
                    "bg-origin": [
                        "border",
                        "padding",
                        "content"
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ "bg-position": [
                {
                    bg: [
                        ...getPositions(),
                        $0bcdbd343f256d28$var$isArbitraryPosition
                    ]
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ "bg-repeat": [
                {
                    bg: [
                        "no-repeat",
                        {
                            repeat: [
                                "",
                                "x",
                                "y",
                                "round",
                                "space"
                            ]
                        }
                    ]
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ "bg-size": [
                {
                    bg: [
                        "auto",
                        "cover",
                        "contain",
                        $0bcdbd343f256d28$var$isArbitrarySize
                    ]
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ "bg-image": [
                {
                    bg: [
                        "none",
                        {
                            "gradient-to": [
                                "t",
                                "tr",
                                "r",
                                "br",
                                "b",
                                "bl",
                                "l",
                                "tl"
                            ]
                        },
                        $0bcdbd343f256d28$var$isArbitraryImage
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ "bg-color": [
                {
                    bg: [
                        colors
                    ]
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from-pos": [
                {
                    from: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via-pos": [
                {
                    via: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to-pos": [
                {
                    to: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from": [
                {
                    from: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via": [
                {
                    via: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to": [
                {
                    to: [
                        gradientColorStops
                    ]
                }
            ],
            // Borders
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-s": [
                {
                    "rounded-s": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-e": [
                {
                    "rounded-e": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-t": [
                {
                    "rounded-t": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-r": [
                {
                    "rounded-r": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-b": [
                {
                    "rounded-b": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-l": [
                {
                    "rounded-l": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ss": [
                {
                    "rounded-ss": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-se": [
                {
                    "rounded-se": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ee": [
                {
                    "rounded-ee": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-es": [
                {
                    "rounded-es": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tl": [
                {
                    "rounded-tl": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tr": [
                {
                    "rounded-tr": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-br": [
                {
                    "rounded-br": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-bl": [
                {
                    "rounded-bl": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w": [
                {
                    border: [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-x": [
                {
                    "border-x": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-y": [
                {
                    "border-y": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-s": [
                {
                    "border-s": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-e": [
                {
                    "border-e": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-t": [
                {
                    "border-t": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-r": [
                {
                    "border-r": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-b": [
                {
                    "border-b": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-l": [
                {
                    "border-l": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */ "border-opacity": [
                {
                    "border-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ "border-style": [
                {
                    border: [
                        ...getLineStyles(),
                        "hidden"
                    ]
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x": [
                {
                    "divide-x": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x-reverse": [
                "divide-x-reverse"
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y": [
                {
                    "divide-y": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y-reverse": [
                "divide-y-reverse"
            ],
            /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */ "divide-opacity": [
                {
                    "divide-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */ "divide-style": [
                {
                    divide: getLineStyles()
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color": [
                {
                    border: [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-x": [
                {
                    "border-x": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-y": [
                {
                    "border-y": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-t": [
                {
                    "border-t": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-r": [
                {
                    "border-r": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-b": [
                {
                    "border-b": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-l": [
                {
                    "border-l": [
                        borderColor
                    ]
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ "divide-color": [
                {
                    divide: [
                        borderColor
                    ]
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ "outline-style": [
                {
                    outline: [
                        "",
                        ...getLineStyles()
                    ]
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ "outline-offset": [
                {
                    "outline-offset": [
                        $0bcdbd343f256d28$var$isLength,
                        $0bcdbd343f256d28$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ "outline-w": [
                {
                    outline: [
                        $0bcdbd343f256d28$var$isLength,
                        $0bcdbd343f256d28$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ "outline-color": [
                {
                    outline: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w": [
                {
                    ring: getLengthWithEmptyAndArbitrary()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w-inset": [
                "ring-inset"
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */ "ring-color": [
                {
                    ring: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */ "ring-opacity": [
                {
                    "ring-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */ "ring-offset-w": [
                {
                    "ring-offset": [
                        $0bcdbd343f256d28$var$isLength,
                        $0bcdbd343f256d28$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */ "ring-offset-color": [
                {
                    "ring-offset": [
                        colors
                    ]
                }
            ],
            // Effects
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        "",
                        "inner",
                        "none",
                        $0bcdbd343f256d28$var$isTshirtSize,
                        $0bcdbd343f256d28$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */ "shadow-color": [
                {
                    shadow: [
                        $0bcdbd343f256d28$var$isAny
                    ]
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        opacity
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ "mix-blend": [
                {
                    "mix-blend": [
                        ...getBlendModes(),
                        "plus-lighter",
                        "plus-darker"
                    ]
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ "bg-blend": [
                {
                    "bg-blend": getBlendModes()
                }
            ],
            // Filters
            /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: [
                        blur
                    ]
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        brightness
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        contrast
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ "drop-shadow": [
                {
                    "drop-shadow": [
                        "",
                        "none",
                        $0bcdbd343f256d28$var$isTshirtSize,
                        $0bcdbd343f256d28$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        grayscale
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ "hue-rotate": [
                {
                    "hue-rotate": [
                        hueRotate
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        invert
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        saturate
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        sepia
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ "backdrop-filter": [
                {
                    "backdrop-filter": [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ "backdrop-blur": [
                {
                    "backdrop-blur": [
                        blur
                    ]
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ "backdrop-brightness": [
                {
                    "backdrop-brightness": [
                        brightness
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ "backdrop-contrast": [
                {
                    "backdrop-contrast": [
                        contrast
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ "backdrop-grayscale": [
                {
                    "backdrop-grayscale": [
                        grayscale
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ "backdrop-hue-rotate": [
                {
                    "backdrop-hue-rotate": [
                        hueRotate
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ "backdrop-invert": [
                {
                    "backdrop-invert": [
                        invert
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ "backdrop-opacity": [
                {
                    "backdrop-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ "backdrop-saturate": [
                {
                    "backdrop-saturate": [
                        saturate
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ "backdrop-sepia": [
                {
                    "backdrop-sepia": [
                        sepia
                    ]
                }
            ],
            // Tables
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ "border-collapse": [
                {
                    border: [
                        "collapse",
                        "separate"
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing": [
                {
                    "border-spacing": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-x": [
                {
                    "border-spacing-x": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-y": [
                {
                    "border-spacing-y": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ "table-layout": [
                {
                    table: [
                        "auto",
                        "fixed"
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        "top",
                        "bottom"
                    ]
                }
            ],
            // Transitions and Animation
            /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        "none",
                        "all",
                        "",
                        "colors",
                        "opacity",
                        "shadow",
                        "transform",
                        $0bcdbd343f256d28$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: getNumberAndArbitrary()
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        "linear",
                        "in",
                        "out",
                        "in-out",
                        $0bcdbd343f256d28$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: getNumberAndArbitrary()
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        "none",
                        "spin",
                        "ping",
                        "pulse",
                        "bounce",
                        $0bcdbd343f256d28$var$isArbitraryValue
                    ]
                }
            ],
            // Transforms
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        "",
                        "gpu",
                        "none"
                    ]
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: [
                        scale
                    ]
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ "scale-x": [
                {
                    "scale-x": [
                        scale
                    ]
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ "scale-y": [
                {
                    "scale-y": [
                        scale
                    ]
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: [
                        $0bcdbd343f256d28$var$isInteger,
                        $0bcdbd343f256d28$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ "translate-x": [
                {
                    "translate-x": [
                        translate
                    ]
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ "translate-y": [
                {
                    "translate-y": [
                        translate
                    ]
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ "skew-x": [
                {
                    "skew-x": [
                        skew
                    ]
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ "skew-y": [
                {
                    "skew-y": [
                        skew
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ "transform-origin": [
                {
                    origin: [
                        "center",
                        "top",
                        "top-right",
                        "right",
                        "bottom-right",
                        "bottom",
                        "bottom-left",
                        "left",
                        "top-left",
                        $0bcdbd343f256d28$var$isArbitraryValue
                    ]
                }
            ],
            // Interactivity
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: [
                        "auto",
                        colors
                    ]
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                {
                    appearance: [
                        "none",
                        "auto"
                    ]
                }
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        "auto",
                        "default",
                        "pointer",
                        "wait",
                        "text",
                        "move",
                        "help",
                        "not-allowed",
                        "none",
                        "context-menu",
                        "progress",
                        "cell",
                        "crosshair",
                        "vertical-text",
                        "alias",
                        "copy",
                        "no-drop",
                        "grab",
                        "grabbing",
                        "all-scroll",
                        "col-resize",
                        "row-resize",
                        "n-resize",
                        "e-resize",
                        "s-resize",
                        "w-resize",
                        "ne-resize",
                        "nw-resize",
                        "se-resize",
                        "sw-resize",
                        "ew-resize",
                        "ns-resize",
                        "nesw-resize",
                        "nwse-resize",
                        "zoom-in",
                        "zoom-out",
                        $0bcdbd343f256d28$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ "caret-color": [
                {
                    caret: [
                        colors
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ "pointer-events": [
                {
                    "pointer-events": [
                        "none",
                        "auto"
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        "none",
                        "y",
                        "x",
                        ""
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ "scroll-behavior": [
                {
                    scroll: [
                        "auto",
                        "smooth"
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-m": [
                {
                    "scroll-m": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mx": [
                {
                    "scroll-mx": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-my": [
                {
                    "scroll-my": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ms": [
                {
                    "scroll-ms": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-me": [
                {
                    "scroll-me": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mt": [
                {
                    "scroll-mt": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mr": [
                {
                    "scroll-mr": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mb": [
                {
                    "scroll-mb": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ml": [
                {
                    "scroll-ml": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-p": [
                {
                    "scroll-p": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-px": [
                {
                    "scroll-px": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-py": [
                {
                    "scroll-py": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-ps": [
                {
                    "scroll-ps": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pe": [
                {
                    "scroll-pe": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pt": [
                {
                    "scroll-pt": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pr": [
                {
                    "scroll-pr": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pb": [
                {
                    "scroll-pb": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pl": [
                {
                    "scroll-pl": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ "snap-align": [
                {
                    snap: [
                        "start",
                        "end",
                        "center",
                        "align-none"
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ "snap-stop": [
                {
                    snap: [
                        "normal",
                        "always"
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-type": [
                {
                    snap: [
                        "none",
                        "x",
                        "y",
                        "both"
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-strictness": [
                {
                    snap: [
                        "mandatory",
                        "proximity"
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        "auto",
                        "none",
                        "manipulation"
                    ]
                }
            ],
            /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */ "touch-x": [
                {
                    "touch-pan": [
                        "x",
                        "left",
                        "right"
                    ]
                }
            ],
            /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */ "touch-y": [
                {
                    "touch-pan": [
                        "y",
                        "up",
                        "down"
                    ]
                }
            ],
            /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */ "touch-pz": [
                "touch-pinch-zoom"
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        "none",
                        "text",
                        "all",
                        "auto"
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ "will-change": [
                {
                    "will-change": [
                        "auto",
                        "scroll",
                        "contents",
                        "transform",
                        $0bcdbd343f256d28$var$isArbitraryValue
                    ]
                }
            ],
            // SVG
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        colors,
                        "none"
                    ]
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ "stroke-w": [
                {
                    stroke: [
                        $0bcdbd343f256d28$var$isLength,
                        $0bcdbd343f256d28$var$isArbitraryLength,
                        $0bcdbd343f256d28$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        colors,
                        "none"
                    ]
                }
            ],
            // Accessibility
            /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */ sr: [
                "sr-only",
                "not-sr-only"
            ],
            /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */ "forced-color-adjust": [
                {
                    "forced-color-adjust": [
                        "auto",
                        "none"
                    ]
                }
            ]
        },
        conflictingClassGroups: {
            overflow: [
                "overflow-x",
                "overflow-y"
            ],
            overscroll: [
                "overscroll-x",
                "overscroll-y"
            ],
            inset: [
                "inset-x",
                "inset-y",
                "start",
                "end",
                "top",
                "right",
                "bottom",
                "left"
            ],
            "inset-x": [
                "right",
                "left"
            ],
            "inset-y": [
                "top",
                "bottom"
            ],
            flex: [
                "basis",
                "grow",
                "shrink"
            ],
            gap: [
                "gap-x",
                "gap-y"
            ],
            p: [
                "px",
                "py",
                "ps",
                "pe",
                "pt",
                "pr",
                "pb",
                "pl"
            ],
            px: [
                "pr",
                "pl"
            ],
            py: [
                "pt",
                "pb"
            ],
            m: [
                "mx",
                "my",
                "ms",
                "me",
                "mt",
                "mr",
                "mb",
                "ml"
            ],
            mx: [
                "mr",
                "ml"
            ],
            my: [
                "mt",
                "mb"
            ],
            size: [
                "w",
                "h"
            ],
            "font-size": [
                "leading"
            ],
            "fvn-normal": [
                "fvn-ordinal",
                "fvn-slashed-zero",
                "fvn-figure",
                "fvn-spacing",
                "fvn-fraction"
            ],
            "fvn-ordinal": [
                "fvn-normal"
            ],
            "fvn-slashed-zero": [
                "fvn-normal"
            ],
            "fvn-figure": [
                "fvn-normal"
            ],
            "fvn-spacing": [
                "fvn-normal"
            ],
            "fvn-fraction": [
                "fvn-normal"
            ],
            "line-clamp": [
                "display",
                "overflow"
            ],
            rounded: [
                "rounded-s",
                "rounded-e",
                "rounded-t",
                "rounded-r",
                "rounded-b",
                "rounded-l",
                "rounded-ss",
                "rounded-se",
                "rounded-ee",
                "rounded-es",
                "rounded-tl",
                "rounded-tr",
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-s": [
                "rounded-ss",
                "rounded-es"
            ],
            "rounded-e": [
                "rounded-se",
                "rounded-ee"
            ],
            "rounded-t": [
                "rounded-tl",
                "rounded-tr"
            ],
            "rounded-r": [
                "rounded-tr",
                "rounded-br"
            ],
            "rounded-b": [
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-l": [
                "rounded-tl",
                "rounded-bl"
            ],
            "border-spacing": [
                "border-spacing-x",
                "border-spacing-y"
            ],
            "border-w": [
                "border-w-s",
                "border-w-e",
                "border-w-t",
                "border-w-r",
                "border-w-b",
                "border-w-l"
            ],
            "border-w-x": [
                "border-w-r",
                "border-w-l"
            ],
            "border-w-y": [
                "border-w-t",
                "border-w-b"
            ],
            "border-color": [
                "border-color-t",
                "border-color-r",
                "border-color-b",
                "border-color-l"
            ],
            "border-color-x": [
                "border-color-r",
                "border-color-l"
            ],
            "border-color-y": [
                "border-color-t",
                "border-color-b"
            ],
            "scroll-m": [
                "scroll-mx",
                "scroll-my",
                "scroll-ms",
                "scroll-me",
                "scroll-mt",
                "scroll-mr",
                "scroll-mb",
                "scroll-ml"
            ],
            "scroll-mx": [
                "scroll-mr",
                "scroll-ml"
            ],
            "scroll-my": [
                "scroll-mt",
                "scroll-mb"
            ],
            "scroll-p": [
                "scroll-px",
                "scroll-py",
                "scroll-ps",
                "scroll-pe",
                "scroll-pt",
                "scroll-pr",
                "scroll-pb",
                "scroll-pl"
            ],
            "scroll-px": [
                "scroll-pr",
                "scroll-pl"
            ],
            "scroll-py": [
                "scroll-pt",
                "scroll-pb"
            ],
            touch: [
                "touch-x",
                "touch-y",
                "touch-pz"
            ],
            "touch-x": [
                "touch"
            ],
            "touch-y": [
                "touch"
            ],
            "touch-pz": [
                "touch"
            ]
        },
        conflictingClassGroupModifiers: {
            "font-size": [
                "leading"
            ]
        }
    };
}
/**
 * @param baseConfig Config where other config will be merged into. This object will be mutated.
 * @param configExtension Partial config to merge into the `baseConfig`.
 */ function $0bcdbd343f256d28$export$5d86b86a654a7039(baseConfig, { cacheSize: cacheSize, prefix: prefix, separator: separator, extend: extend = {}, override: override = {} }) {
    $0bcdbd343f256d28$var$overrideProperty(baseConfig, "cacheSize", cacheSize);
    $0bcdbd343f256d28$var$overrideProperty(baseConfig, "prefix", prefix);
    $0bcdbd343f256d28$var$overrideProperty(baseConfig, "separator", separator);
    for(const configKey in override)$0bcdbd343f256d28$var$overrideConfigProperties(baseConfig[configKey], override[configKey]);
    for(const key in extend)$0bcdbd343f256d28$var$mergeConfigProperties(baseConfig[key], extend[key]);
    return baseConfig;
}
function $0bcdbd343f256d28$var$overrideProperty(baseObject, overrideKey, overrideValue) {
    if (overrideValue !== undefined) baseObject[overrideKey] = overrideValue;
}
function $0bcdbd343f256d28$var$overrideConfigProperties(baseObject, overrideObject) {
    if (overrideObject) for(const key in overrideObject)$0bcdbd343f256d28$var$overrideProperty(baseObject, key, overrideObject[key]);
}
function $0bcdbd343f256d28$var$mergeConfigProperties(baseObject, mergeObject) {
    if (mergeObject) for(const key in mergeObject){
        const mergeValue = mergeObject[key];
        if (mergeValue !== undefined) baseObject[key] = (baseObject[key] || []).concat(mergeValue);
    }
}
function $0bcdbd343f256d28$export$c8d8406b6cd2243e(configExtension, ...createConfig) {
    return typeof configExtension === "function" ? $0bcdbd343f256d28$export$ea2d4fba4d1bd27f($0bcdbd343f256d28$export$ed30944e0fe6ae5c, configExtension, ...createConfig) : $0bcdbd343f256d28$export$ea2d4fba4d1bd27f(()=>$0bcdbd343f256d28$export$5d86b86a654a7039($0bcdbd343f256d28$export$ed30944e0fe6ae5c(), configExtension), ...createConfig);
}
const $0bcdbd343f256d28$export$b4660bb6000dfbc9 = /*#__PURE__*/ $0bcdbd343f256d28$export$ea2d4fba4d1bd27f($0bcdbd343f256d28$export$ed30944e0fe6ae5c);


function $c6a4e06ec85a7455$export$1343a74baacb0543(...inputs) {
    return (0, $0bcdbd343f256d28$export$b4660bb6000dfbc9)((0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(inputs));
}


const $b132ebe58e154a99$export$dca1ee5a936bb312 = (0, $7d867aa0bbfd521e$export$87dc52566e90b739)("inline-flex items-center justify-center whitespace-nowrap rounded-xl text-sm font-outfit font-medium ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 dark:ring-offset-slate-950 dark:focus-visible:ring-slate-300", {
    variants: {
        variant: {
            default: "bg-slate-900 text-slate-50 hover:bg-slate-900/90 dark:bg-slate-50 dark:text-slate-900 dark:hover:bg-slate-50/90",
            destructive: "bg-red-500 text-slate-50 hover:bg-red-500/90 dark:bg-red-900 dark:text-slate-50 dark:hover:bg-red-900/90",
            outline: "border border-slate-200 bg-white hover:bg-slate-100 hover:text-slate-900 dark:border-slate-800 dark:bg-slate-950 dark:hover:bg-slate-800 dark:hover:text-slate-50",
            secondary: "bg-slate-100 text-slate-900 hover:bg-slate-100/80 dark:bg-slate-800 dark:text-slate-50 dark:hover:bg-slate-800/80",
            ghost: "hover:bg-slate-100 hover:text-slate-900 dark:hover:bg-slate-800 dark:hover:text-slate-50",
            link: "text-slate-900 underline-offset-4 hover:underline dark:text-slate-50"
        },
        size: {
            default: "h-10 px-4 py-2",
            sm: "h-9 rounded-md px-3",
            lg: "h-11 rounded-md px-8",
            icon: "h-10 w-10"
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default"
    }
});
const $b132ebe58e154a99$export$353f5b6fc5456de1 = /*#__PURE__*/ $acw62.forwardRef(({ className: className, variant: variant, size: size, asChild: asChild = false, ...props }, ref)=>{
    const Comp = asChild ? (0, $cf381de56a25bc52$export$8c6ed5c666ac1360) : "button";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Comp, {
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)($b132ebe58e154a99$export$dca1ee5a936bb312({
            variant: variant,
            size: size,
            className: className
        })),
        ref: ref,
        ...props
    });
});
$b132ebe58e154a99$export$353f5b6fc5456de1.displayName = "Button";




var $acw62 = parcelRequire("acw62");

const $dec6137693824fa2$export$60332b2344f7fe41 = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("rounded-lg border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-950", className),
        ...props
    }));
$dec6137693824fa2$export$60332b2344f7fe41.displayName = "Card";
const $dec6137693824fa2$export$5665775b26e26c5d = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("flex flex-col space-y-1.5 p-6", className),
        ...props
    }));
$dec6137693824fa2$export$5665775b26e26c5d.displayName = "CardHeader";
const $dec6137693824fa2$export$474db65c3c394e1c = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("text-2xl font-semibold leading-none tracking-tight", className),
        ...props
    }));
$dec6137693824fa2$export$474db65c3c394e1c.displayName = "CardTitle";
const $dec6137693824fa2$export$16e0ed4cb97c00d4 = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("text-sm ", className),
        ...props
    }));
$dec6137693824fa2$export$16e0ed4cb97c00d4.displayName = "CardDescription";
const $dec6137693824fa2$export$64ef9b8c11710c47 = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("p-6 pt-0", className),
        ...props
    }));
$dec6137693824fa2$export$64ef9b8c11710c47.displayName = "CardContent";
const $dec6137693824fa2$export$e9897d434e0741ee = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("flex items-center p-6 pt-0", className),
        ...props
    }));
$dec6137693824fa2$export$e9897d434e0741ee.displayName = "CardFooter";




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $b4e9a20689651e16$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}




var $acw62 = parcelRequire("acw62");
function $45e038b71f97d914$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0, $acw62.createContext)(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0, $acw62.useMemo)(()=>context, Object.values(context));
        return /*#__PURE__*/ (0, $acw62.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0, $acw62.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $45e038b71f97d914$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0, $acw62.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0, $acw62.useMemo)(()=>context, Object.values(context));
            return /*#__PURE__*/ (0, $acw62.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0, $acw62.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0, $acw62.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0, $acw62.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $45e038b71f97d914$var$$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $45e038b71f97d914$var$$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope, scopeName: scopeName })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0, $acw62.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                }), [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $95d2d9f03fd0d4db$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0, $acw62.useRef)(callback);
    (0, $acw62.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0, $acw62.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }, []);
}


function $aef12de5508fd46e$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $aef12de5508fd46e$var$$71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onChange);
    const setValue = (0, $acw62.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $aef12de5508fd46e$var$$71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = (0, $acw62.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0, $acw62.useRef)(value);
    const handleChange = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onChange);
    (0, $acw62.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}




var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

const $dc7d5df3de21cdcb$var$$8927f6f2acc4f386$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $dc7d5df3de21cdcb$export$250ffa63cdc0d034 = $dc7d5df3de21cdcb$var$$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $cf381de56a25bc52$export$8c6ed5c666ac1360) : node;
        (0, $acw62.useEffect)(()=>{
            window[Symbol.for("radix-ui")] = true;
        }, []);
        return /*#__PURE__*/ (0, $acw62.createElement)(Comp, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $dc7d5df3de21cdcb$export$6d1a0317bde7de7f(target, event) {
    if (target) (0, $1u0KT.flushSync)(()=>target.dispatchEvent(event));
}
/* -----------------------------------------------------------------------------------------------*/ const $dc7d5df3de21cdcb$export$be92b6f5f03c0fe9 = $dc7d5df3de21cdcb$export$250ffa63cdc0d034;




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



// We have resorted to returning slots directly rather than exposing primitives that can then
// be slotted like `<CollectionItem as={Slot}>…</CollectionItem>`.
// This is because we encountered issues with generic types that cannot be statically analysed
// due to creating them dynamically via createCollection.
function $a9634733d4b9bce9$export$c74125a8e3af6bb2(name) {
    /* -----------------------------------------------------------------------------------------------
   * CollectionProvider
   * ---------------------------------------------------------------------------------------------*/ const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope, children: children } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map()).current;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref
        }, children);
    };
    /*#__PURE__*/ Object.assign(CollectionProvider, {
        displayName: PROVIDER_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionSlot
   * ---------------------------------------------------------------------------------------------*/ const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cf381de56a25bc52$export$8c6ed5c666ac1360), {
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionSlot, {
        displayName: COLLECTION_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionItem
   * ---------------------------------------------------------------------------------------------*/ const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
        const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cf381de56a25bc52$export$8c6ed5c666ac1360), {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionItemSlot, {
        displayName: ITEM_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * useCollection
   * ---------------------------------------------------------------------------------------------*/ function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}





var $acw62 = parcelRequire("acw62");
const $f9ad7d2f57cc5bec$var$$f631663db3294ace$var$DirectionContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
/* -------------------------------------------------------------------------------------------------
 * Direction
 * -----------------------------------------------------------------------------------------------*/ const $f9ad7d2f57cc5bec$export$c760c09fdd558351 = (props)=>{
    const { dir: dir, children: children } = props;
    return /*#__PURE__*/ (0, $acw62.createElement)($f9ad7d2f57cc5bec$var$$f631663db3294ace$var$DirectionContext.Provider, {
        value: dir
    }, children);
};
/* -----------------------------------------------------------------------------------------------*/ function $f9ad7d2f57cc5bec$export$b39126d51d94e6f3(localDir) {
    const globalDir = (0, $acw62.useContext)($f9ad7d2f57cc5bec$var$$f631663db3294ace$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
const $f9ad7d2f57cc5bec$export$2881499e37b75b9a = $f9ad7d2f57cc5bec$export$c760c09fdd558351;




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

/**
 * Listens for when the escape key is down
 */ function $322b9f9e9e453dd6$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const onEscapeKeyDown = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    (0, $acw62.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown);
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown);
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}


/* -------------------------------------------------------------------------------------------------
 * DismissableLayer
 * -----------------------------------------------------------------------------------------------*/ const $30a399657994b369$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
const $30a399657994b369$var$$5cb92bef7577960e$var$CONTEXT_UPDATE = "dismissableLayer.update";
const $30a399657994b369$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
const $30a399657994b369$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
let $30a399657994b369$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
const $30a399657994b369$var$$5cb92bef7577960e$var$DismissableLayerContext = /*#__PURE__*/ (0, $acw62.createContext)({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
const $30a399657994b369$export$177fb62ff3ec1f22 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    var _node$ownerDocument;
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = (0, $acw62.useContext)($30a399657994b369$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const [node1, setNode] = (0, $acw62.useState)(null);
    const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    const [, force] = (0, $acw62.useState)({});
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setNode(node));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1); // prettier-ignore
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    const index = node1 ? layers.indexOf(node1) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $30a399657994b369$var$$5cb92bef7577960e$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    const focusOutside = $30a399657994b369$var$$5cb92bef7577960e$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    (0, $322b9f9e9e453dd6$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    (0, $acw62.useEffect)(()=>{
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $30a399657994b369$var$$5cb92bef7577960e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        $30a399657994b369$var$$5cb92bef7577960e$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $30a399657994b369$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
        };
    }, [
        node1,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ (0, $acw62.useEffect)(()=>{
        return ()=>{
            if (!node1) return;
            context.layers.delete(node1);
            context.layersWithOutsidePointerEventsDisabled.delete(node1);
            $30a399657994b369$var$$5cb92bef7577960e$var$dispatchUpdate();
        };
    }, [
        node1,
        context
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($30a399657994b369$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($30a399657994b369$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, layerProps, {
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : undefined,
            ...props.style
        },
        onFocusCapture: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/*#__PURE__*/ Object.assign($30a399657994b369$export$177fb62ff3ec1f22, {
    displayName: $30a399657994b369$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DismissableLayerBranch
 * -----------------------------------------------------------------------------------------------*/ const $30a399657994b369$var$$5cb92bef7577960e$var$BRANCH_NAME = "DismissableLayerBranch";
const $30a399657994b369$export$4d5eb2109db14228 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const context = (0, $acw62.useContext)($30a399657994b369$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const ref = (0, $acw62.useRef)(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $acw62.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($30a399657994b369$export$4d5eb2109db14228, {
    displayName: $30a399657994b369$var$$5cb92bef7577960e$var$BRANCH_NAME
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function $30a399657994b369$var$$5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handlePointerDownOutside = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = (0, $acw62.useRef)(false);
    const handleClickRef = (0, $acw62.useRef)(()=>{});
    (0, $acw62.useEffect)(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                function handleAndDispatchPointerDownOutsideEvent() {
                    $30a399657994b369$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($30a399657994b369$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                }
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            } else // See: https://github.com/radix-ui/primitives/issues/2171
            ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function $30a399657994b369$var$$5cb92bef7577960e$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handleFocusOutside = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $30a399657994b369$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($30a399657994b369$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $30a399657994b369$var$$5cb92bef7577960e$var$dispatchUpdate() {
    const event = new CustomEvent($30a399657994b369$var$$5cb92bef7577960e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $30a399657994b369$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $dc7d5df3de21cdcb$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
const $30a399657994b369$export$be92b6f5f03c0fe9 = $30a399657994b369$export$177fb62ff3ec1f22;
const $30a399657994b369$export$aecb2ddcb55c95be = $30a399657994b369$export$4d5eb2109db14228;



var $acw62 = parcelRequire("acw62");
/** Number of components which have requested interest to have focus guards */ let $264faec0fdf8876a$var$$3db38b7d1fb3fe6a$var$count = 0;
function $264faec0fdf8876a$export$ac5b58043b79449b(props) {
    $264faec0fdf8876a$export$b7ece24a22aeda8c();
    return props.children;
}
/**
 * Injects a pair of focus guards at the edges of the whole DOM tree
 * to ensure `focusin` & `focusout` events can be caught consistently.
 */ function $264faec0fdf8876a$export$b7ece24a22aeda8c() {
    (0, $acw62.useEffect)(()=>{
        var _edgeGuards$, _edgeGuards$2;
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : $264faec0fdf8876a$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : $264faec0fdf8876a$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        $264faec0fdf8876a$var$$3db38b7d1fb3fe6a$var$count++;
        return ()=>{
            if ($264faec0fdf8876a$var$$3db38b7d1fb3fe6a$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $264faec0fdf8876a$var$$3db38b7d1fb3fe6a$var$count--;
        };
    }, []);
}
function $264faec0fdf8876a$var$$3db38b7d1fb3fe6a$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none";
    return element;
}
const $264faec0fdf8876a$export$be92b6f5f03c0fe9 = $264faec0fdf8876a$export$ac5b58043b79449b;




var $acw62 = parcelRequire("acw62");



const $03c48a27777929a8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
const $03c48a27777929a8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
const $03c48a27777929a8$var$$d3863c46a17e8a28$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * FocusScope
 * -----------------------------------------------------------------------------------------------*/ const $03c48a27777929a8$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME = "FocusScope";
const $03c48a27777929a8$export$20e40289641fbbb6 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container1, setContainer] = (0, $acw62.useState)(null);
    const onMountAutoFocus = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = (0, $acw62.useRef)(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = (0, $acw62.useRef)({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current; // Takes care of trapping focus if focus is moved outside programmatically for example
    (0, $acw62.useEffect)(()=>{
        if (trapped) {
            function handleFocusIn(event) {
                if (focusScope.paused || !container1) return;
                const target = event.target;
                if (container1.contains(target)) lastFocusedElementRef.current = target;
                else $03c48a27777929a8$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            function handleFocusOut(event) {
                if (focusScope.paused || !container1) return;
                const relatedTarget = event.relatedTarget; // A `focusout` event with a `null` `relatedTarget` will happen in at least two cases:
                //
                // 1. When the user switches app/tabs/windows/the browser itself loses focus.
                // 2. In Google Chrome, when the focused element is removed from the DOM.
                //
                // We let the browser do its thing here because:
                //
                // 1. The browser already keeps a memory of what's focused for when the page gets refocused.
                // 2. In Google Chrome, if we try to focus the deleted focused element (as per below), it
                //    throws the CPU to 100%, so we avoid doing anything for this reason here too.
                if (relatedTarget === null) return; // If the focus has moved to an actual legitimate element (`relatedTarget !== null`)
                // that is outside the container, we move focus to the last valid focused element inside.
                if (!container1.contains(relatedTarget)) $03c48a27777929a8$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            } // When the focused element gets removed from the DOM, browsers move focus
            // back to the document.body. In this case, we move focus to the container
            // to keep focus trapped correctly.
            function handleMutations(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $03c48a27777929a8$var$$d3863c46a17e8a28$var$focus(container1);
            }
            document.addEventListener("focusin", handleFocusIn);
            document.addEventListener("focusout", handleFocusOut);
            const mutationObserver = new MutationObserver(handleMutations);
            if (container1) mutationObserver.observe(container1, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn);
                document.removeEventListener("focusout", handleFocusOut);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container1,
        focusScope.paused
    ]);
    (0, $acw62.useEffect)(()=>{
        if (container1) {
            $03c48a27777929a8$var$$d3863c46a17e8a28$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($03c48a27777929a8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, $03c48a27777929a8$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                container1.addEventListener($03c48a27777929a8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container1.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $03c48a27777929a8$var$$d3863c46a17e8a28$var$focusFirst($03c48a27777929a8$var$$d3863c46a17e8a28$var$removeLinks($03c48a27777929a8$var$$d3863c46a17e8a28$var$getTabbableCandidates(container1)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $03c48a27777929a8$var$$d3863c46a17e8a28$var$focus(container1);
                }
            }
            return ()=>{
                container1.removeEventListener($03c48a27777929a8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus); // We hit a react bug (fixed in v17) with focusing in unmount.
                // We need to delay the focus a little to get around it for now.
                // See: https://github.com/facebook/react/issues/17894
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($03c48a27777929a8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, $03c48a27777929a8$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                    container1.addEventListener($03c48a27777929a8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container1.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $03c48a27777929a8$var$$d3863c46a17e8a28$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                        select: true
                    });
                    // we need to remove the listener after we `dispatchEvent`
                    container1.removeEventListener($03c48a27777929a8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $03c48a27777929a8$var$$d3863c46a17e8a28$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container1,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]); // Takes care of looping focus (when tabbing whilst at the edges)
    const handleKeyDown = (0, $acw62.useCallback)((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container = event.currentTarget;
            const [first, last] = $03c48a27777929a8$var$$d3863c46a17e8a28$var$getTabbableEdges(container);
            const hasTabbableElementsInside = first && last; // we can only wrap focus if we have tabbable edges
            if (!hasTabbableElementsInside) {
                if (focusedElement === container) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $03c48a27777929a8$var$$d3863c46a17e8a28$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $03c48a27777929a8$var$$d3863c46a17e8a28$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        tabIndex: -1
    }, scopeProps, {
        ref: composedRefs,
        onKeyDown: handleKeyDown
    }));
});
/*#__PURE__*/ Object.assign($03c48a27777929a8$export$20e40289641fbbb6, {
    displayName: $03c48a27777929a8$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Attempts focusing the first element in a list of candidates.
 * Stops when focus has actually moved.
 */ function $03c48a27777929a8$var$$d3863c46a17e8a28$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $03c48a27777929a8$var$$d3863c46a17e8a28$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
/**
 * Returns the first and last tabbable elements inside a container.
 */ function $03c48a27777929a8$var$$d3863c46a17e8a28$var$getTabbableEdges(container) {
    const candidates = $03c48a27777929a8$var$$d3863c46a17e8a28$var$getTabbableCandidates(container);
    const first = $03c48a27777929a8$var$$d3863c46a17e8a28$var$findVisible(candidates, container);
    const last = $03c48a27777929a8$var$$d3863c46a17e8a28$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $03c48a27777929a8$var$$d3863c46a17e8a28$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
/**
 * Returns the first visible element in a list.
 * NOTE: Only checks visibility up to the `container`.
 */ function $03c48a27777929a8$var$$d3863c46a17e8a28$var$findVisible(elements, container) {
    for (const element of elements){
        // we stop checking if it's hidden at the `container` level (excluding)
        if (!$03c48a27777929a8$var$$d3863c46a17e8a28$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $03c48a27777929a8$var$$d3863c46a17e8a28$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        // we stop at `upTo` (excluding it)
        if (upTo !== undefined && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $03c48a27777929a8$var$$d3863c46a17e8a28$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $03c48a27777929a8$var$$d3863c46a17e8a28$var$focus(element, { select: select = false } = {}) {
    // only focus if that element is focusable
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement; // NOTE: we prevent scrolling on focus, to minimize jarring transitions for users
        element.focus({
            preventScroll: true
        }); // only select if its not the same element, it supports selection and we need to select
        if (element !== previouslyFocusedElement && $03c48a27777929a8$var$$d3863c46a17e8a28$var$isSelectableInput(element) && select) element.select();
    }
}
/* -------------------------------------------------------------------------------------------------
 * FocusScope stack
 * -----------------------------------------------------------------------------------------------*/ const $03c48a27777929a8$var$$d3863c46a17e8a28$var$focusScopesStack = $03c48a27777929a8$var$$d3863c46a17e8a28$var$createFocusScopesStack();
function $03c48a27777929a8$var$$d3863c46a17e8a28$var$createFocusScopesStack() {
    /** A stack of focus scopes, with the active one at the top */ let stack = [];
    return {
        add (focusScope) {
            // pause the currently active focus scope (at the top of the stack)
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
            // remove in case it already exists (because we'll re-add it at the top of the stack)
            stack = $03c48a27777929a8$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            var _stack$;
            stack = $03c48a27777929a8$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
        }
    };
}
function $03c48a27777929a8$var$$d3863c46a17e8a28$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $03c48a27777929a8$var$$d3863c46a17e8a28$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
const $03c48a27777929a8$export$be92b6f5f03c0fe9 = $03c48a27777929a8$export$20e40289641fbbb6;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $b68d88740313b08e$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? (0, $acw62.useLayoutEffect) : ()=>{};


const $11885ec535b13ccc$var$$1746a345f3d73bb7$var$useReactId = $acw62["useId".toString()] || (()=>undefined);
let $11885ec535b13ccc$var$$1746a345f3d73bb7$var$count = 0;
function $11885ec535b13ccc$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $acw62.useState($11885ec535b13ccc$var$$1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($11885ec535b13ccc$var$$1746a345f3d73bb7$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}




var $acw62 = parcelRequire("acw62");
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $204931a4986f463b$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $204931a4986f463b$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $204931a4986f463b$export$803cd8101b6c182b = /*#__PURE__*/ $204931a4986f463b$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $204931a4986f463b$export$27b07d8a310ed8b5[0], side + "-" + $204931a4986f463b$export$27b07d8a310ed8b5[1]), []);
const $204931a4986f463b$export$96ec731ed4dcb222 = Math.min;
const $204931a4986f463b$export$8960430cfd85939f = Math.max;
const $204931a4986f463b$export$2077e0241d6afd3c = Math.round;
const $204931a4986f463b$export$a3fe094919f356fd = Math.floor;
const $204931a4986f463b$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $204931a4986f463b$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $204931a4986f463b$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $204931a4986f463b$export$7d15b64cf5a3a4c4(start, value, end) {
    return $204931a4986f463b$export$8960430cfd85939f(start, $204931a4986f463b$export$96ec731ed4dcb222(value, end));
}
function $204931a4986f463b$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $204931a4986f463b$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $204931a4986f463b$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $204931a4986f463b$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $204931a4986f463b$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $204931a4986f463b$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($204931a4986f463b$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $204931a4986f463b$export$2b57e0052a6d6d4c(placement) {
    return $204931a4986f463b$export$8a000a963141ac32($204931a4986f463b$export$f28e8f882010718a(placement));
}
function $204931a4986f463b$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $204931a4986f463b$export$f0989780f32bfcda(placement);
    const alignmentAxis = $204931a4986f463b$export$2b57e0052a6d6d4c(placement);
    const length = $204931a4986f463b$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $204931a4986f463b$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $204931a4986f463b$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $204931a4986f463b$export$496432a3699e50b1(placement) {
    const oppositePlacement = $204931a4986f463b$export$9c5e28bad23365fa(placement);
    return [
        $204931a4986f463b$export$2b182c584985588b(placement),
        oppositePlacement,
        $204931a4986f463b$export$2b182c584985588b(oppositePlacement)
    ];
}
function $204931a4986f463b$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$204931a4986f463b$var$oppositeAlignmentMap[alignment]);
}
function $204931a4986f463b$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $204931a4986f463b$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $204931a4986f463b$export$f0989780f32bfcda(placement);
    let list = $204931a4986f463b$var$getSideList($204931a4986f463b$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($204931a4986f463b$export$2b182c584985588b));
    }
    return list;
}
function $204931a4986f463b$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$204931a4986f463b$var$oppositeSideMap[side]);
}
function $204931a4986f463b$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $204931a4986f463b$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $204931a4986f463b$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $204931a4986f463b$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $9dccb9a8753b0e86$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $204931a4986f463b$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $204931a4986f463b$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $204931a4986f463b$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $9dccb9a8753b0e86$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $9dccb9a8753b0e86$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $9dccb9a8753b0e86$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $204931a4986f463b$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $204931a4986f463b$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $204931a4986f463b$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9dccb9a8753b0e86$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $204931a4986f463b$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $204931a4986f463b$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $204931a4986f463b$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $204931a4986f463b$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $204931a4986f463b$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $204931a4986f463b$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $204931a4986f463b$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $9dccb9a8753b0e86$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $204931a4986f463b$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $204931a4986f463b$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $204931a4986f463b$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $204931a4986f463b$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $204931a4986f463b$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $9dccb9a8753b0e86$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $204931a4986f463b$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $204931a4986f463b$export$803cd8101b6c182b) ? $9dccb9a8753b0e86$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $204931a4986f463b$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $204931a4986f463b$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $204931a4986f463b$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $204931a4986f463b$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $9dccb9a8753b0e86$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
            const isBasePlacement = (0, $204931a4986f463b$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $204931a4986f463b$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $204931a4986f463b$export$496432a3699e50b1)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...(0, $204931a4986f463b$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $204931a4986f463b$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $9dccb9a8753b0e86$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $9dccb9a8753b0e86$var$isAnySideFullyClipped(overflow) {
    return (0, $204931a4986f463b$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $9dccb9a8753b0e86$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $9dccb9a8753b0e86$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $9dccb9a8753b0e86$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $9dccb9a8753b0e86$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $9dccb9a8753b0e86$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $9dccb9a8753b0e86$var$getBoundingRect(rects) {
    const minX = (0, $204931a4986f463b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $204931a4986f463b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $204931a4986f463b$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $204931a4986f463b$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $9dccb9a8753b0e86$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $204931a4986f463b$export$ee05aea0aeecbad4)($9dccb9a8753b0e86$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $9dccb9a8753b0e86$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $9dccb9a8753b0e86$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $204931a4986f463b$export$ee05aea0aeecbad4)($9dccb9a8753b0e86$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $204931a4986f463b$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $204931a4986f463b$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $204931a4986f463b$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $204931a4986f463b$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $9dccb9a8753b0e86$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $204931a4986f463b$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $204931a4986f463b$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $9dccb9a8753b0e86$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $9dccb9a8753b0e86$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $9dccb9a8753b0e86$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $204931a4986f463b$export$f28e8f882010718a)((0, $204931a4986f463b$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $204931a4986f463b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $204931a4986f463b$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $204931a4986f463b$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $9dccb9a8753b0e86$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $204931a4986f463b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $204931a4986f463b$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $204931a4986f463b$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $9dccb9a8753b0e86$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $204931a4986f463b$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $204931a4986f463b$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $204931a4986f463b$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) availableWidth = alignment || noShift ? (0, $204931a4986f463b$export$96ec731ed4dcb222)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            else availableHeight = alignment || noShift ? (0, $204931a4986f463b$export$96ec731ed4dcb222)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $c51400d9a81fca36$export$651544f548703224(node) {
    if ($c51400d9a81fca36$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $c51400d9a81fca36$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $c51400d9a81fca36$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($c51400d9a81fca36$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $c51400d9a81fca36$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).Node;
}
function $c51400d9a81fca36$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).Element;
}
function $c51400d9a81fca36$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).HTMLElement;
}
function $c51400d9a81fca36$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $c51400d9a81fca36$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $c51400d9a81fca36$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $c51400d9a81fca36$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($c51400d9a81fca36$export$651544f548703224(element));
}
function $c51400d9a81fca36$export$d6c4e8150c35fed1(element) {
    const webkit = $c51400d9a81fca36$export$78551043582a6a98();
    const css = $c51400d9a81fca36$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $c51400d9a81fca36$export$940d8225183e1404(element) {
    let currentNode = $c51400d9a81fca36$export$4e12058fc4d51d56(element);
    while($c51400d9a81fca36$export$1b3bfaa9684536aa(currentNode) && !$c51400d9a81fca36$export$d1162fb0b6d4cd51(currentNode)){
        if ($c51400d9a81fca36$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        currentNode = $c51400d9a81fca36$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $c51400d9a81fca36$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $c51400d9a81fca36$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($c51400d9a81fca36$export$651544f548703224(node));
}
function $c51400d9a81fca36$export$3735103072e4a80(element) {
    return $c51400d9a81fca36$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $c51400d9a81fca36$export$dc8fc79fa2800137(element) {
    if ($c51400d9a81fca36$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $c51400d9a81fca36$export$4e12058fc4d51d56(node) {
    if ($c51400d9a81fca36$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $c51400d9a81fca36$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $c51400d9a81fca36$export$e495491855dc5418(node);
    return $c51400d9a81fca36$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $c51400d9a81fca36$export$7cd01a57c8ca906c(node) {
    const parentNode = $c51400d9a81fca36$export$4e12058fc4d51d56(node);
    if ($c51400d9a81fca36$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($c51400d9a81fca36$export$1b3bfaa9684536aa(parentNode) && $c51400d9a81fca36$export$989e911fa9af580a(parentNode)) return parentNode;
    return $c51400d9a81fca36$export$7cd01a57c8ca906c(parentNode);
}
function $c51400d9a81fca36$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $c51400d9a81fca36$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $c51400d9a81fca36$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $c51400d9a81fca36$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $c51400d9a81fca36$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $c51400d9a81fca36$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}


function $bede215d88ec3aee$var$getCssDimensions(element) {
    const css = (0, $c51400d9a81fca36$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $204931a4986f463b$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $204931a4986f463b$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $bede215d88ec3aee$var$unwrapElement(element) {
    return !(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $bede215d88ec3aee$var$getScale(element) {
    const domElement = $bede215d88ec3aee$var$unwrapElement(element);
    if (!(0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(domElement)) return (0, $204931a4986f463b$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $bede215d88ec3aee$var$getCssDimensions(domElement);
    let x = ($ ? (0, $204931a4986f463b$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $204931a4986f463b$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $bede215d88ec3aee$var$noOffsets = /*#__PURE__*/ (0, $204931a4986f463b$export$a397704b5e280835)(0);
function $bede215d88ec3aee$var$getVisualOffsets(element) {
    const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element);
    if (!(0, $c51400d9a81fca36$export$78551043582a6a98)() || !win.visualViewport) return $bede215d88ec3aee$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $bede215d88ec3aee$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $bede215d88ec3aee$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $bede215d88ec3aee$var$unwrapElement(element);
    let scale = (0, $204931a4986f463b$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(offsetParent)) scale = $bede215d88ec3aee$var$getScale(offsetParent);
        } else scale = $bede215d88ec3aee$var$getScale(element);
    }
    const visualOffsets = $bede215d88ec3aee$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bede215d88ec3aee$var$getVisualOffsets(domElement) : (0, $204931a4986f463b$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = currentWin.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $bede215d88ec3aee$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $c51400d9a81fca36$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = currentWin.frameElement;
        }
    }
    return (0, $204931a4986f463b$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
const $bede215d88ec3aee$var$topLayerSelectors = [
    ":popover-open",
    ":modal"
];
function $bede215d88ec3aee$var$isTopLayer(element) {
    return $bede215d88ec3aee$var$topLayerSelectors.some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $bede215d88ec3aee$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $c51400d9a81fca36$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? $bede215d88ec3aee$var$isTopLayer(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $204931a4986f463b$export$a397704b5e280835)(1);
    const offsets = (0, $204931a4986f463b$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $c51400d9a81fca36$export$651544f548703224)(offsetParent) !== "body" || (0, $c51400d9a81fca36$export$989e911fa9af580a)(documentElement)) scroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $bede215d88ec3aee$var$getBoundingClientRect(offsetParent);
            scale = $bede215d88ec3aee$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $bede215d88ec3aee$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $bede215d88ec3aee$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $bede215d88ec3aee$var$getBoundingClientRect((0, $c51400d9a81fca36$export$e495491855dc5418)(element)).left + (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $bede215d88ec3aee$var$getDocumentRect(element) {
    const html = (0, $c51400d9a81fca36$export$e495491855dc5418)(element);
    const scroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $204931a4986f463b$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $204931a4986f463b$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $bede215d88ec3aee$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $c51400d9a81fca36$export$3735103072e4a80)(body).direction === "rtl") x += (0, $204931a4986f463b$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bede215d88ec3aee$var$getViewportRect(element, strategy) {
    const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element);
    const html = (0, $c51400d9a81fca36$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $c51400d9a81fca36$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $bede215d88ec3aee$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $bede215d88ec3aee$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element) ? $bede215d88ec3aee$var$getScale(element) : (0, $204931a4986f463b$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bede215d88ec3aee$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $bede215d88ec3aee$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $bede215d88ec3aee$var$getDocumentRect((0, $c51400d9a81fca36$export$e495491855dc5418)(element));
    else if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $bede215d88ec3aee$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $bede215d88ec3aee$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $204931a4986f463b$export$ee05aea0aeecbad4)(rect);
}
function $bede215d88ec3aee$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(parentNode) || (0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $c51400d9a81fca36$export$3735103072e4a80)(parentNode).position === "fixed" || $bede215d88ec3aee$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $bede215d88ec3aee$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $c51400d9a81fca36$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(el) && (0, $c51400d9a81fca36$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $c51400d9a81fca36$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(currentNode) && !(0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $c51400d9a81fca36$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $c51400d9a81fca36$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $c51400d9a81fca36$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $bede215d88ec3aee$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $bede215d88ec3aee$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $bede215d88ec3aee$var$isTopLayer(element) ? [] : $bede215d88ec3aee$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $bede215d88ec3aee$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $204931a4986f463b$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $204931a4986f463b$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $204931a4986f463b$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $204931a4986f463b$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $bede215d88ec3aee$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $bede215d88ec3aee$var$getDimensions(element) {
    const { width: width, height: height } = $bede215d88ec3aee$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $bede215d88ec3aee$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $c51400d9a81fca36$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $bede215d88ec3aee$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $204931a4986f463b$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $c51400d9a81fca36$export$651544f548703224)(offsetParent) !== "body" || (0, $c51400d9a81fca36$export$989e911fa9af580a)(documentElement)) scroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $bede215d88ec3aee$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $bede215d88ec3aee$var$getWindowScrollBarX(documentElement);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x;
    const y = rect.top + scroll.scrollTop - offsets.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $bede215d88ec3aee$var$isStaticPositioned(element) {
    return (0, $c51400d9a81fca36$export$3735103072e4a80)(element).position === "static";
}
function $bede215d88ec3aee$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element) || (0, $c51400d9a81fca36$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $bede215d88ec3aee$var$getOffsetParent(element, polyfill) {
    const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element);
    if ($bede215d88ec3aee$var$isTopLayer(element)) return win;
    if (!(0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$bede215d88ec3aee$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $bede215d88ec3aee$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $c51400d9a81fca36$export$71535ffaa902797f)(offsetParent) && $bede215d88ec3aee$var$isStaticPositioned(offsetParent))offsetParent = $bede215d88ec3aee$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(offsetParent) && $bede215d88ec3aee$var$isStaticPositioned(offsetParent) && !(0, $c51400d9a81fca36$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $c51400d9a81fca36$export$940d8225183e1404)(element) || win;
}
const $bede215d88ec3aee$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $bede215d88ec3aee$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $bede215d88ec3aee$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $bede215d88ec3aee$var$isRTL(element) {
    return (0, $c51400d9a81fca36$export$3735103072e4a80)(element).direction === "rtl";
}
const $bede215d88ec3aee$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $bede215d88ec3aee$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $c51400d9a81fca36$export$e495491855dc5418,
    getClippingRect: $bede215d88ec3aee$var$getClippingRect,
    getOffsetParent: $bede215d88ec3aee$var$getOffsetParent,
    getElementRects: $bede215d88ec3aee$var$getElementRects,
    getClientRects: $bede215d88ec3aee$var$getClientRects,
    getDimensions: $bede215d88ec3aee$var$getDimensions,
    getScale: $bede215d88ec3aee$var$getScale,
    isElement: $c51400d9a81fca36$export$45a5e7f76e0caa8d,
    isRTL: $bede215d88ec3aee$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $bede215d88ec3aee$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $c51400d9a81fca36$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $204931a4986f463b$export$a3fe094919f356fd)(top);
        const insetRight = (0, $204931a4986f463b$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $204931a4986f463b$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $204931a4986f463b$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $204931a4986f463b$export$8960430cfd85939f)(0, (0, $204931a4986f463b$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $bede215d88ec3aee$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $bede215d88ec3aee$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $c51400d9a81fca36$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $c51400d9a81fca36$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $bede215d88ec3aee$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $bede215d88ec3aee$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $bede215d88ec3aee$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $bede215d88ec3aee$export$37b6bde19b108ecc = (0, $9dccb9a8753b0e86$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $bede215d88ec3aee$export$cc800923e997bb8 = (0, $9dccb9a8753b0e86$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $bede215d88ec3aee$export$91fb6ecbd551914 = (0, $9dccb9a8753b0e86$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $bede215d88ec3aee$export$fba63a578e423eb = (0, $9dccb9a8753b0e86$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $bede215d88ec3aee$export$8a83211c878a3f1f = (0, $9dccb9a8753b0e86$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $bede215d88ec3aee$export$346677f925de839c = (0, $9dccb9a8753b0e86$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $bede215d88ec3aee$export$fe8985bb6374093c = (0, $9dccb9a8753b0e86$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $bede215d88ec3aee$export$f2120bbfa5450bd2 = (0, $9dccb9a8753b0e86$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $bede215d88ec3aee$export$18c8ad048e32c7d5 = (0, $9dccb9a8753b0e86$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $bede215d88ec3aee$export$7bf07e38f3dc4b69 = (0, $9dccb9a8753b0e86$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $bede215d88ec3aee$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $bede215d88ec3aee$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $9dccb9a8753b0e86$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
var $4cdaae7c2a5f3f0d$var$index = typeof document !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $4cdaae7c2a5f3f0d$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$4cdaae7c2a5f3f0d$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$4cdaae7c2a5f3f0d$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $4cdaae7c2a5f3f0d$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $4cdaae7c2a5f3f0d$var$roundByDPR(element, value) {
    const dpr = $4cdaae7c2a5f3f0d$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $4cdaae7c2a5f3f0d$var$useLatestRef(value) {
    const ref = $acw62.useRef(value);
    $4cdaae7c2a5f3f0d$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $4cdaae7c2a5f3f0d$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $acw62.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $acw62.useState(middleware);
    if (!$4cdaae7c2a5f3f0d$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $acw62.useState(null);
    const [_floating, _setFloating] = $acw62.useState(null);
    const setReference = $acw62.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $acw62.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $acw62.useRef(null);
    const floatingRef = $acw62.useRef(null);
    const dataRef = $acw62.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $4cdaae7c2a5f3f0d$var$useLatestRef(whileElementsMounted);
    const platformRef = $4cdaae7c2a5f3f0d$var$useLatestRef(platform);
    const update = $acw62.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $bede215d88ec3aee$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                isPositioned: true
            };
            if (isMountedRef.current && !$4cdaae7c2a5f3f0d$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $1u0KT.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef
    ]);
    $4cdaae7c2a5f3f0d$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $acw62.useRef(false);
    $4cdaae7c2a5f3f0d$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $4cdaae7c2a5f3f0d$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $acw62.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $acw62.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $acw62.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $4cdaae7c2a5f3f0d$var$roundByDPR(elements.floating, data.x);
        const y = $4cdaae7c2a5f3f0d$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$4cdaae7c2a5f3f0d$var$getDPR(elements.floating) >= 1.5 && {
                willChange: "transform"
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $acw62.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $4cdaae7c2a5f3f0d$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === "function" ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $bede215d88ec3aee$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $bede215d88ec3aee$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $4cdaae7c2a5f3f0d$export$cc800923e997bb8 = (options, deps)=>({
        ...(0, $bede215d88ec3aee$export$cc800923e997bb8)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $4cdaae7c2a5f3f0d$export$fba63a578e423eb = (options, deps)=>({
        ...(0, $bede215d88ec3aee$export$fba63a578e423eb)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $4cdaae7c2a5f3f0d$export$7bf07e38f3dc4b69 = (options, deps)=>({
        ...(0, $bede215d88ec3aee$export$7bf07e38f3dc4b69)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $4cdaae7c2a5f3f0d$export$8a83211c878a3f1f = (options, deps)=>({
        ...(0, $bede215d88ec3aee$export$8a83211c878a3f1f)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $4cdaae7c2a5f3f0d$export$346677f925de839c = (options, deps)=>({
        ...(0, $bede215d88ec3aee$export$346677f925de839c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $4cdaae7c2a5f3f0d$export$91fb6ecbd551914 = (options, deps)=>({
        ...(0, $bede215d88ec3aee$export$91fb6ecbd551914)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $4cdaae7c2a5f3f0d$export$fe8985bb6374093c = (options, deps)=>({
        ...(0, $bede215d88ec3aee$export$fe8985bb6374093c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $4cdaae7c2a5f3f0d$export$18c8ad048e32c7d5 = (options, deps)=>({
        ...(0, $bede215d88ec3aee$export$18c8ad048e32c7d5)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $4cdaae7c2a5f3f0d$export$f2120bbfa5450bd2 = (options, deps)=>({
        ...$4cdaae7c2a5f3f0d$var$arrow$1(options),
        options: [
            options,
            deps
        ]
    });




var $acw62 = parcelRequire("acw62");

/* -------------------------------------------------------------------------------------------------
 * Arrow
 * -----------------------------------------------------------------------------------------------*/ const $1002b17d420264b2$var$$7e8f5cd07187803e$var$NAME = "Arrow";
const $1002b17d420264b2$export$21b07c8f274aebd5 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { children: children, width: width = 10, height: height = 5, ...arrowProps } = props;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).svg, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, arrowProps, {
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none"
    }), props.asChild ? children : /*#__PURE__*/ (0, $acw62.createElement)("polygon", {
        points: "0,0 30,0 15,10"
    }));
});
/*#__PURE__*/ Object.assign($1002b17d420264b2$export$21b07c8f274aebd5, {
    displayName: $1002b17d420264b2$var$$7e8f5cd07187803e$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $1002b17d420264b2$export$be92b6f5f03c0fe9 = $1002b17d420264b2$export$21b07c8f274aebd5;








var $acw62 = parcelRequire("acw62");

function $db5ba6ddde57f255$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = (0, $acw62.useState)(undefined);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            // provide size as early as possible
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                // Since we only observe the one element, we don't need to loop over the
                // array
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"]; // iron out differences between browsers
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    // for browsers that don't support `borderBoxSize`
                    // we calculate it ourselves to get the correct border box.
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else // not if it changes to another element.
        setSize(undefined);
    }, [
        element
    ]);
    return size;
}


const $a0ac11a1da65e329$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
const $a0ac11a1da65e329$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
/* -------------------------------------------------------------------------------------------------
 * Popper
 * -----------------------------------------------------------------------------------------------*/ const $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$POPPER_NAME = "Popper";
const [$a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$createPopperContext, $a0ac11a1da65e329$export$722aac194ae923] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const [$a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$PopperProvider, $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$usePopperContext] = $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$createPopperContext($a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const $a0ac11a1da65e329$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper, children: children } = props;
    const [anchor, setAnchor] = (0, $acw62.useState)(null);
    return /*#__PURE__*/ (0, $acw62.createElement)($a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor
    }, children);
};
/*#__PURE__*/ Object.assign($a0ac11a1da65e329$export$badac9ada3a0bdf9, {
    displayName: $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$POPPER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperAnchor
 * -----------------------------------------------------------------------------------------------*/ const $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME = "PopperAnchor";
const $a0ac11a1da65e329$export$ecd4e1ccab6ed6d = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, virtualRef: virtualRef, ...anchorProps } = props;
    const context = $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$usePopperContext($a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME, __scopePopper);
    const ref = (0, $acw62.useRef)(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $acw62.useEffect)(()=>{
        // Consumer can anchor the popper to something that isn't
        // a DOM node e.g. pointer position, so we override the
        // `anchorRef` with their virtual ref in this case.
        context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
    });
    return virtualRef ? null : /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, anchorProps, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($a0ac11a1da65e329$export$ecd4e1ccab6ed6d, {
    displayName: $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperContent
 * -----------------------------------------------------------------------------------------------*/ const $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME = "PopperContent";
const [$a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$useContentContext] = $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$createPopperContext($a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME);
const $a0ac11a1da65e329$export$bc4ae5855d3c4fc = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$trans, _middlewareData$trans2, _middlewareData$hide;
    const { __scopePopper: __scopePopper, side: side = "bottom", sideOffset: sideOffset = 0, align: align = "center", alignOffset: alignOffset = 0, arrowPadding: arrowPadding = 0, avoidCollisions: avoidCollisions = true, collisionBoundary: collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky: sticky = "partial", hideWhenDetached: hideWhenDetached = false, updatePositionStrategy: updatePositionStrategy = "optimized", onPlaced: onPlaced, ...contentProps } = props;
    const context = $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$usePopperContext($a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = (0, $acw62.useState)(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [arrow, setArrow] = (0, $acw62.useState)(null);
    const arrowSize = (0, $db5ba6ddde57f255$export$1ab7ae714698c4b8)(arrow);
    const arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
    const arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs, floatingStyles: floatingStyles, placement: placement, isPositioned: isPositioned, middlewareData: middlewareData } = (0, $4cdaae7c2a5f3f0d$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = (0, $bede215d88ec3aee$export$deee3a793edee05f)(...args, {
                animationFrame: updatePositionStrategy === "always"
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $4cdaae7c2a5f3f0d$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $4cdaae7c2a5f3f0d$export$fba63a578e423eb)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $4cdaae7c2a5f3f0d$export$7bf07e38f3dc4b69)() : undefined,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, $4cdaae7c2a5f3f0d$export$8a83211c878a3f1f)({
                ...detectOverflowOptions
            }),
            (0, $4cdaae7c2a5f3f0d$export$346677f925de839c)({
                ...detectOverflowOptions,
                apply: ({ elements: elements, rects: rects, availableWidth: availableWidth, availableHeight: availableHeight })=>{
                    const { width: anchorWidth, height: anchorHeight } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }
            }),
            arrow && (0, $4cdaae7c2a5f3f0d$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }),
            $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $4cdaae7c2a5f3f0d$export$fe8985bb6374093c)({
                strategy: "referenceHidden",
                ...detectOverflowOptions
            })
        ]
    });
    const [placedSide, placedAlign] = $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onPlaced);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (isPositioned) handlePlaced === null || handlePlaced === void 0 || handlePlaced();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
    const arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
    const cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
    const [contentZIndex, setContentZIndex] = (0, $acw62.useState)();
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            ["--radix-popper-transform-origin"]: [
                (_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x,
                (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y
            ].join(" ")
        } // Floating UI interally calculates logical alignment based the `dir` attribute on
        ,
        dir: props.dir
    }, /*#__PURE__*/ (0, $acw62.createElement)($a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, {
        scope: __scopePopper,
        placedSide: placedSide,
        onArrowChange: setArrow,
        arrowX: arrowX,
        arrowY: arrowY,
        shouldHideArrow: cannotCenterArrow
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        "data-side": placedSide,
        "data-align": placedAlign
    }, contentProps, {
        ref: composedRefs,
        style: {
            ...contentProps.style,
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: !isPositioned ? "none" : undefined,
            // hide the content if using the hide middleware and should be hidden
            opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : undefined
        }
    }))));
});
/*#__PURE__*/ Object.assign($a0ac11a1da65e329$export$bc4ae5855d3c4fc, {
    displayName: $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperArrow
 * -----------------------------------------------------------------------------------------------*/ const $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$ARROW_NAME = "PopperArrow";
const $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
const $a0ac11a1da65e329$export$79d62cd4e10a3fd0 = /*#__PURE__*/ (0, $acw62.forwardRef)(function $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0(props, forwardedRef) {
    const { __scopePopper: __scopePopper, ...arrowProps } = props;
    const contentContext = $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$useContentContext($a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$ARROW_NAME, __scopePopper);
    const baseSide = $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(/*#__PURE__*/ // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    (0, $acw62.createElement)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : undefined
        }
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $1002b17d420264b2$export$be92b6f5f03c0fe9), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, arrowProps, {
        ref: forwardedRef,
        style: {
            ...arrowProps.style,
            // ensures the element can be measured correctly (mostly for if SVG)
            display: "block"
        }
    }))));
});
/*#__PURE__*/ Object.assign($a0ac11a1da65e329$export$79d62cd4e10a3fd0, {
    displayName: $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$isNotNull(value) {
    return value !== null;
}
const $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$transformOrigin = (options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
            const { placement: placement, rects: rects, middlewareData: middlewareData } = data;
            const cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            const arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
            const arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
const $a0ac11a1da65e329$export$be92b6f5f03c0fe9 = $a0ac11a1da65e329$export$badac9ada3a0bdf9;
const $a0ac11a1da65e329$export$b688253958b8dfe7 = $a0ac11a1da65e329$export$ecd4e1ccab6ed6d;
const $a0ac11a1da65e329$export$7c6e2c02157bb7d2 = $a0ac11a1da65e329$export$bc4ae5855d3c4fc;
const $a0ac11a1da65e329$export$21b07c8f274aebd5 = $a0ac11a1da65e329$export$79d62cd4e10a3fd0;




var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

/* -------------------------------------------------------------------------------------------------
 * Portal
 * -----------------------------------------------------------------------------------------------*/ const $95d053caea9c023a$var$$f1701beae083dbae$var$PORTAL_NAME = "Portal";
const $95d053caea9c023a$export$602eac185826482c = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    var _globalThis$document;
    const { container: container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body, ...portalProps } = props;
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(/*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});
/*#__PURE__*/ Object.assign($95d053caea9c023a$export$602eac185826482c, {
    displayName: $95d053caea9c023a$var$$f1701beae083dbae$var$PORTAL_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $95d053caea9c023a$export$be92b6f5f03c0fe9 = $95d053caea9c023a$export$602eac185826482c;



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


function $3207c0aa9f229d8f$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0, $acw62.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
const $3207c0aa9f229d8f$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $3207c0aa9f229d8f$var$$921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : (0, $acw62.Children).only(children);
    const ref = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(presence.ref, child.ref);
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0, $acw62.cloneElement)(child, {
        ref: ref
    }) : null;
};
$3207c0aa9f229d8f$export$99c2b779aa4e8b8b.displayName = "Presence";
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $3207c0aa9f229d8f$var$$921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0, $acw62.useState)();
    const stylesRef = (0, $acw62.useRef)({});
    const prevPresentRef = (0, $acw62.useRef)(present);
    const prevAnimationNameRef = (0, $acw62.useRef)("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $3207c0aa9f229d8f$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    (0, $acw62.useEffect)(()=>{
        const currentAnimationName = $3207c0aa9f229d8f$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $3207c0aa9f229d8f$var$$921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none") // so we unmount instantly
            send("UNMOUNT");
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = $3207c0aa9f229d8f$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0, $1u0KT.flushSync)(()=>send("ANIMATION_END"));
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) prevAnimationNameRef.current = $3207c0aa9f229d8f$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener("animationstart", handleAnimationStart);
            node1.addEventListener("animationcancel", handleAnimationEnd);
            node1.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                node1.removeEventListener("animationstart", handleAnimationStart);
                node1.removeEventListener("animationcancel", handleAnimationEnd);
                node1.removeEventListener("animationend", handleAnimationEnd);
            };
        } else // We avoid doing so during cleanup as the node may change but still exist.
        send("ANIMATION_END");
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: (0, $acw62.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $3207c0aa9f229d8f$var$$921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}





var $acw62 = parcelRequire("acw62");









const $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
const $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroup
 * -----------------------------------------------------------------------------------------------*/ const $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$GROUP_NAME = "RovingFocusGroup";
const [$0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$Collection, $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$useCollection, $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$createCollectionScope] = (0, $a9634733d4b9bce9$export$c74125a8e3af6bb2)($0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$GROUP_NAME);
const [$0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext, $0483c88073bf4923$export$c7109489551a4f4] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$GROUP_NAME, [
    $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$createCollectionScope
]);
const [$0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$RovingFocusProvider, $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$useRovingFocusContext] = $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext($0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$GROUP_NAME);
const $0483c88073bf4923$export$8699f7c8af148338 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0, $acw62.createElement)($0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0, $acw62.createElement)($0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$Collection.Slot, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0, $acw62.createElement)($0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$RovingFocusGroupImpl, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef
    }))));
});
/*#__PURE__*/ Object.assign($0483c88073bf4923$export$8699f7c8af148338, {
    displayName: $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$GROUP_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$RovingFocusGroupImpl = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, orientation: orientation, loop: loop = false, dir: dir, currentTabStopId: currentTabStopIdProp, defaultCurrentTabStopId: defaultCurrentTabStopId, onCurrentTabStopIdChange: onCurrentTabStopIdChange, onEntryFocus: onEntryFocus, ...groupProps } = props;
    const ref = (0, $acw62.useRef)(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const direction = (0, $f9ad7d2f57cc5bec$export$b39126d51d94e6f3)(dir);
    const [currentTabStopId = null, setCurrentTabStopId] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId,
        onChange: onCurrentTabStopIdChange
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = (0, $acw62.useState)(false);
    const handleEntryFocus = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onEntryFocus);
    const getItems = $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = (0, $acw62.useRef)(false);
    const [focusableItemsCount, setFocusableItemsCount] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)($0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: (0, $acw62.useCallback)((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: (0, $acw62.useCallback)(()=>setIsTabbingBackOut(true), []),
        onFocusableItemAdd: (0, $acw62.useCallback)(()=>setFocusableItemsCount((prevCount)=>prevCount + 1), []),
        onFocusableItemRemove: (0, $acw62.useCallback)(()=>setFocusableItemsCount((prevCount)=>prevCount - 1), [])
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
        "data-orientation": orientation
    }, groupProps, {
        ref: composedRefs,
        style: {
            outline: "none",
            ...props.style
        },
        onMouseDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onMouseDown, ()=>{
            isClickFocusRef.current = true;
        }),
        onFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocus, (event)=>{
            // We normally wouldn't need this check, because we already check
            // that the focus is on the current target and not bubbling to it.
            // We do this because Safari doesn't focus buttons when clicked, and
            // instead, the wrapper will get focused and not through a bubbling event.
            const isKeyboardFocus = !isClickFocusRef.current;
            if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                const entryFocusEvent = new CustomEvent($0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$EVENT_OPTIONS);
                event.currentTarget.dispatchEvent(entryFocusEvent);
                if (!entryFocusEvent.defaultPrevented) {
                    const items = getItems().filter((item)=>item.focusable);
                    const activeItem = items.find((item)=>item.active);
                    const currentItem = items.find((item)=>item.id === currentTabStopId);
                    const candidateItems = [
                        activeItem,
                        currentItem,
                        ...items
                    ].filter(Boolean);
                    const candidateNodes = candidateItems.map((item)=>item.ref.current);
                    $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes);
                }
            }
            isClickFocusRef.current = false;
        }),
        onBlur: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsTabbingBackOut(false))
    })));
});
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroupItem
 * -----------------------------------------------------------------------------------------------*/ const $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$ITEM_NAME = "RovingFocusGroupItem";
const $0483c88073bf4923$export$ab9df7c53fe8454 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, focusable: focusable = true, active: active = false, tabStopId: tabStopId, ...itemProps } = props;
    const autoId = (0, $11885ec535b13ccc$export$f680877a34711e37)();
    const id = tabStopId || autoId;
    const context = $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$useRovingFocusContext($0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd, onFocusableItemRemove: onFocusableItemRemove } = context;
    (0, $acw62.useEffect)(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove();
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)($0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).span, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        tabIndex: isCurrentTabStop ? 0 : -1,
        "data-orientation": context.orientation
    }, itemProps, {
        ref: forwardedRef,
        onMouseDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
            // We prevent focusing non-focusable items on `mousedown`.
            // Even though the item has tabIndex={-1}, that only means take it out of the tab order.
            if (!focusable) event.preventDefault(); // Safari doesn't focus a button when clicked so we run our logic on mousedown also
            else context.onItemFocus(id);
        }),
        onFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocus, ()=>context.onItemFocus(id)),
        onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            if (event.key === "Tab" && event.shiftKey) {
                context.onItemShiftTab();
                return;
            }
            if (event.target !== event.currentTarget) return;
            const focusIntent = $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$getFocusIntent(event, context.orientation, context.dir);
            if (focusIntent !== undefined) {
                event.preventDefault();
                const items = getItems().filter((item)=>item.focusable);
                let candidateNodes = items.map((item)=>item.ref.current);
                if (focusIntent === "last") candidateNodes.reverse();
                else if (focusIntent === "prev" || focusIntent === "next") {
                    if (focusIntent === "prev") candidateNodes.reverse();
                    const currentIndex = candidateNodes.indexOf(event.currentTarget);
                    candidateNodes = context.loop ? $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                }
                /**
         * Imperative focus during keydown is risky so we prevent React's batching updates
         * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
         */ setTimeout(()=>$0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes));
            }
        })
    })));
});
/*#__PURE__*/ Object.assign($0483c88073bf4923$export$ab9df7c53fe8454, {
    displayName: $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$ITEM_NAME
});
/* -----------------------------------------------------------------------------------------------*/ // prettier-ignore
const $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$getFocusIntent(event, orientation, dir) {
    const key = $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return undefined;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return undefined;
    return $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
const $0483c88073bf4923$export$be92b6f5f03c0fe9 = $0483c88073bf4923$export$8699f7c8af148338;
const $0483c88073bf4923$export$6d08773d2e66f8f2 = $0483c88073bf4923$export$ab9df7c53fe8454;




var $4a7537e072260c10$var$getDefaultParent = function(originalTarget) {
    if (typeof document === "undefined") return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $4a7537e072260c10$var$counterMap = new WeakMap();
var $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
var $4a7537e072260c10$var$markerMap = {};
var $4a7537e072260c10$var$lockCount = 0;
var $4a7537e072260c10$var$unwrapHost = function(node) {
    return node && (node.host || $4a7537e072260c10$var$unwrapHost(node.parentNode));
};
var $4a7537e072260c10$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $4a7537e072260c10$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $4a7537e072260c10$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $4a7537e072260c10$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$4a7537e072260c10$var$markerMap[markerName]) $4a7537e072260c10$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $4a7537e072260c10$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = ($4a7537e072260c10$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $4a7537e072260c10$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $4a7537e072260c10$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "true");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "true");
            } catch (e) {
                console.error("aria-hidden: cannot operate on ", node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $4a7537e072260c10$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $4a7537e072260c10$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $4a7537e072260c10$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$4a7537e072260c10$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $4a7537e072260c10$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $4a7537e072260c10$var$lockCount--;
        if (!$4a7537e072260c10$var$lockCount) {
            // clear
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
            $4a7537e072260c10$var$markerMap = {};
        }
    };
};
var $4a7537e072260c10$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-aria-hidden";
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
    return $4a7537e072260c10$var$applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var $4a7537e072260c10$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-inert-ed";
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $4a7537e072260c10$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var $4a7537e072260c10$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var $4a7537e072260c10$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-suppressed";
    return ($4a7537e072260c10$export$cc95fea82d705fca() ? $4a7537e072260c10$export$59151cc8db999a24 : $4a7537e072260c10$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $a0acfd416da73b8a$var$extendStatics = function(d, b) {
    $a0acfd416da73b8a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $a0acfd416da73b8a$var$extendStatics(d, b);
};
function $a0acfd416da73b8a$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $a0acfd416da73b8a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a0acfd416da73b8a$export$18ce0697a983be9b = function() {
    $a0acfd416da73b8a$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a0acfd416da73b8a$export$18ce0697a983be9b.apply(this, arguments);
};
function $a0acfd416da73b8a$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a0acfd416da73b8a$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a0acfd416da73b8a$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a0acfd416da73b8a$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $a0acfd416da73b8a$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $a0acfd416da73b8a$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $a0acfd416da73b8a$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $a0acfd416da73b8a$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a0acfd416da73b8a$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a0acfd416da73b8a$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $a0acfd416da73b8a$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $a0acfd416da73b8a$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $a0acfd416da73b8a$export$45d3717a4c69092e(o, m, p);
}
function $a0acfd416da73b8a$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a0acfd416da73b8a$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a0acfd416da73b8a$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a0acfd416da73b8a$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a0acfd416da73b8a$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a0acfd416da73b8a$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $a0acfd416da73b8a$export$10c90e4f7922046c(v) {
    return this instanceof $a0acfd416da73b8a$export$10c90e4f7922046c ? (this.v = v, this) : new $a0acfd416da73b8a$export$10c90e4f7922046c(v);
}
function $a0acfd416da73b8a$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a0acfd416da73b8a$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a0acfd416da73b8a$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a0acfd416da73b8a$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $a0acfd416da73b8a$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a0acfd416da73b8a$export$19a8beecd37a4c45 === "function" ? $a0acfd416da73b8a$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a0acfd416da73b8a$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $a0acfd416da73b8a$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $a0acfd416da73b8a$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a0acfd416da73b8a$export$45d3717a4c69092e(result, mod, k);
    }
    $a0acfd416da73b8a$var$__setModuleDefault(result, mod);
    return result;
}
function $a0acfd416da73b8a$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a0acfd416da73b8a$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $a0acfd416da73b8a$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $a0acfd416da73b8a$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $a0acfd416da73b8a$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $a0acfd416da73b8a$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $a0acfd416da73b8a$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $a0acfd416da73b8a$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $a0acfd416da73b8a$export$2e2bcd8739ae039 = {
    __extends: $a0acfd416da73b8a$export$a8ba968b8961cb8a,
    __assign: $a0acfd416da73b8a$export$18ce0697a983be9b,
    __rest: $a0acfd416da73b8a$export$3c9a16f847548506,
    __decorate: $a0acfd416da73b8a$export$29e00dfd3077644b,
    __param: $a0acfd416da73b8a$export$d5ad3fd78186038f,
    __metadata: $a0acfd416da73b8a$export$f1db080c865becb9,
    __awaiter: $a0acfd416da73b8a$export$1050f835b63b671e,
    __generator: $a0acfd416da73b8a$export$67ebef60e6f28a6,
    __createBinding: $a0acfd416da73b8a$export$45d3717a4c69092e,
    __exportStar: $a0acfd416da73b8a$export$f33643c0debef087,
    __values: $a0acfd416da73b8a$export$19a8beecd37a4c45,
    __read: $a0acfd416da73b8a$export$8d051b38c9118094,
    __spread: $a0acfd416da73b8a$export$afc72e2116322959,
    __spreadArrays: $a0acfd416da73b8a$export$6388937ca91ccae8,
    __spreadArray: $a0acfd416da73b8a$export$1216008129fb82ed,
    __await: $a0acfd416da73b8a$export$10c90e4f7922046c,
    __asyncGenerator: $a0acfd416da73b8a$export$e427f37a30a4de9b,
    __asyncDelegator: $a0acfd416da73b8a$export$bbd80228419bb833,
    __asyncValues: $a0acfd416da73b8a$export$e3b29a3d6162315f,
    __makeTemplateObject: $a0acfd416da73b8a$export$4fb47efe1390b86f,
    __importStar: $a0acfd416da73b8a$export$c21735bcef00d192,
    __importDefault: $a0acfd416da73b8a$export$da59b14a69baef04,
    __classPrivateFieldGet: $a0acfd416da73b8a$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $a0acfd416da73b8a$export$d40a35129aaff81f,
    __classPrivateFieldIn: $a0acfd416da73b8a$export$81fdc39f203e4e04,
    __addDisposableResource: $a0acfd416da73b8a$export$88ac25d8e944e405,
    __disposeResources: $a0acfd416da73b8a$export$8f076105dc360e92
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $3f8d56f1a38c65c8$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $3f8d56f1a38c65c8$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $3f8d56f1a38c65c8$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";



var $acw62 = parcelRequire("acw62");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $9ce81be4473c2c96$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $acw62 = parcelRequire("acw62");
function $05ac61ef45da8ec5$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $acw62.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $1ec01e2201501f3d$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? $acw62.useLayoutEffect : $acw62.useEffect;
var $1ec01e2201501f3d$var$currentValues = new WeakMap();
function $1ec01e2201501f3d$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $05ac61ef45da8ec5$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $1ec01e2201501f3d$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $1ec01e2201501f3d$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $1ec01e2201501f3d$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



function $dce67a1050af61cf$var$ItoI(a) {
    return a;
}
function $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $dce67a1050af61cf$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    return $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware);
}
function $dce67a1050af61cf$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $dce67a1050af61cf$var$innerCreateMedium(null);
    medium.options = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $f6d5b57f3512e73c$export$e27363444bedfeac = (0, $dce67a1050af61cf$export$e13ec7dd7a14088d)();


var $cac2578984d345ac$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $cac2578984d345ac$export$22940b497e769dee = $acw62.forwardRef(function(props, parentRef) {
    var ref = $acw62.useRef(null);
    var _a = $acw62.useState({
        onScrollCapture: $cac2578984d345ac$var$nothing,
        onWheelCapture: $cac2578984d345ac$var$nothing,
        onTouchMoveCapture: $cac2578984d345ac$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, rest = (0, $a0acfd416da73b8a$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $1ec01e2201501f3d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, rest), callbacks);
    return $acw62.createElement($acw62.Fragment, null, enabled && $acw62.createElement(SideCar, {
        sideCar: (0, $f6d5b57f3512e73c$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref
    }), forwardProps ? $acw62.cloneElement($acw62.Children.only(children), (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $acw62.createElement(Container, (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$cac2578984d345ac$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$cac2578984d345ac$export$22940b497e769dee.classNames = {
    fullWidth: (0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e),
    zeroRight: (0, $3f8d56f1a38c65c8$export$1da7500147d4bc3)
};




var $acw62 = parcelRequire("acw62");
var $c86481a7b0dfcc68$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $a0acfd416da73b8a$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $acw62.createElement(Target, (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, rest));
};
$c86481a7b0dfcc68$var$SideCar.isSideCarExport = true;
function $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $c86481a7b0dfcc68$var$SideCar;
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $1334c25f36aeceaf$var$currentNonce;
var $1334c25f36aeceaf$export$c5f670b24c0ae95a = function(nonce) {
    $1334c25f36aeceaf$var$currentNonce = nonce;
};
var $1334c25f36aeceaf$export$2b85b721e524d74b = function() {
    if ($1334c25f36aeceaf$var$currentNonce) return $1334c25f36aeceaf$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};


function $be1d9ed5bb532264$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $1334c25f36aeceaf$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $be1d9ed5bb532264$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $be1d9ed5bb532264$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $be1d9ed5bb532264$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $be1d9ed5bb532264$var$makeStyleTag()) {
                    $be1d9ed5bb532264$var$injectStyles(stylesheet, style);
                    $be1d9ed5bb532264$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $b5f767dd03f483e5$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $be1d9ed5bb532264$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $acw62.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $eb3b6a23a33fb1ba$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $b5f767dd03f483e5$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $19c77eb414ad2a19$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $19c77eb414ad2a19$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $19c77eb414ad2a19$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $19c77eb414ad2a19$var$parse(left),
        $19c77eb414ad2a19$var$parse(top),
        $19c77eb414ad2a19$var$parse(right)
    ];
};
var $19c77eb414ad2a19$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $19c77eb414ad2a19$export$efed13b5d0ca3386;
    var offsets = $19c77eb414ad2a19$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $9f2b7a700f678519$var$Style = (0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8)();
var $9f2b7a700f678519$export$65254d5f26cb9564 = "data-scroll-locked";
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $9f2b7a700f678519$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $3f8d56f1a38c65c8$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    ").concat((0, $3f8d56f1a38c65c8$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $9f2b7a700f678519$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($9f2b7a700f678519$export$65254d5f26cb9564) || "0", 10);
    return isFinite(counter) ? counter : 0;
};
var $9f2b7a700f678519$export$a1939b1f9f9b02dc = function() {
    $acw62.useEffect(function() {
        document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, ($9f2b7a700f678519$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $9f2b7a700f678519$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($9f2b7a700f678519$export$65254d5f26cb9564);
            else document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $9f2b7a700f678519$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? "margin" : _b;
    $9f2b7a700f678519$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $acw62.useMemo(function() {
        return (0, $19c77eb414ad2a19$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $acw62.createElement($9f2b7a700f678519$var$Style, {
        styles: $9f2b7a700f678519$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};







var $6f0aa8d921410141$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $6f0aa8d921410141$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $6f0aa8d921410141$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
    // @ts-ignore
    window.removeEventListener("test", $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
} catch (err) {
    $6f0aa8d921410141$var$passiveSupported = false;
}
var $6f0aa8d921410141$export$10a6e88623fa9454 = $6f0aa8d921410141$var$passiveSupported ? {
    passive: false
} : false;


var $a7f277057d6643d0$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $a7f277057d6643d0$var$elementCanBeScrolled = function(node, overflow) {
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$a7f277057d6643d0$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $a7f277057d6643d0$var$elementCouldBeVScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, "overflowY");
};
var $a7f277057d6643d0$var$elementCouldBeHScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, "overflowX");
};
var $a7f277057d6643d0$export$9ec64480cae49817 = function(axis, node) {
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $a7f277057d6643d0$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $a7f277057d6643d0$var$getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) return true;
        }
        current = current.parentNode;
    }while (current && current !== document.body);
    return false;
};
var $a7f277057d6643d0$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $a7f277057d6643d0$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $a7f277057d6643d0$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $a7f277057d6643d0$var$elementCouldBeVScrolled(node) : $a7f277057d6643d0$var$elementCouldBeHScrolled(node);
};
var $a7f277057d6643d0$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $a7f277057d6643d0$var$getVScrollVariables(node) : $a7f277057d6643d0$var$getHScrollVariables(node);
};
var $a7f277057d6643d0$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $a7f277057d6643d0$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $a7f277057d6643d0$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $a7f277057d6643d0$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($a7f277057d6643d0$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $f5f147098910888d$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $f5f147098910888d$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $f5f147098910888d$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $f5f147098910888d$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $f5f147098910888d$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $f5f147098910888d$var$idCounter = 0;
var $f5f147098910888d$var$lockStack = [];
function $f5f147098910888d$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $acw62.useRef([]);
    var touchStartRef = $acw62.useRef([
        0,
        0
    ]);
    var activeAxis = $acw62.useRef();
    var id = $acw62.useState($f5f147098910888d$var$idCounter++)[0];
    var Style = $acw62.useState(function() {
        return (0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8)();
    })[0];
    var lastProps = $acw62.useRef(props);
    $acw62.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $acw62.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($f5f147098910888d$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $acw62.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2) return !lastProps.current.allowPinchZoom;
        var touch = $f5f147098910888d$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $a7f277057d6643d0$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $acw62.useCallback(function(_event) {
        var event = _event;
        if (!$f5f147098910888d$var$lockStack.length || $f5f147098910888d$var$lockStack[$f5f147098910888d$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $f5f147098910888d$export$39efaa2ca254a28d(event) : $f5f147098910888d$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && e.target === event.target && $f5f147098910888d$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($f5f147098910888d$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $acw62.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $acw62.useCallback(function(event) {
        touchStartRef.current = $f5f147098910888d$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $acw62.useEffect(function() {
        $f5f147098910888d$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        return function() {
            $f5f147098910888d$var$lockStack = $f5f147098910888d$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $acw62.createElement($acw62.Fragment, null, inert ? $acw62.createElement(Style, {
        styles: $f5f147098910888d$var$generateStyle(id)
    }) : null, removeScrollBar ? $acw62.createElement((0, $9f2b7a700f678519$export$9aa43b459c5ae9b9), {
        gapMode: "margin"
    }) : null);
}



var $0e88b28988758ab2$export$2e2bcd8739ae039 = (0, $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce)((0, $f6d5b57f3512e73c$export$e27363444bedfeac), (0, $f5f147098910888d$export$a09dbff87b5da2d));


var $cfb1c25e3ef3d3bc$var$ReactRemoveScroll = $acw62.forwardRef(function(props, ref) {
    return $acw62.createElement((0, $cac2578984d345ac$export$22940b497e769dee), (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $0e88b28988758ab2$export$2e2bcd8739ae039)
    }));
});
$cfb1c25e3ef3d3bc$var$ReactRemoveScroll.classNames = (0, $cac2578984d345ac$export$22940b497e769dee).classNames;
var $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039 = $cfb1c25e3ef3d3bc$var$ReactRemoveScroll;


const $82110f2367303f9b$var$$6cc32821e9371a1c$var$SELECTION_KEYS = [
    "Enter",
    " "
];
const $82110f2367303f9b$var$$6cc32821e9371a1c$var$FIRST_KEYS = [
    "ArrowDown",
    "PageUp",
    "Home"
];
const $82110f2367303f9b$var$$6cc32821e9371a1c$var$LAST_KEYS = [
    "ArrowUp",
    "PageDown",
    "End"
];
const $82110f2367303f9b$var$$6cc32821e9371a1c$var$FIRST_LAST_KEYS = [
    ...$82110f2367303f9b$var$$6cc32821e9371a1c$var$FIRST_KEYS,
    ...$82110f2367303f9b$var$$6cc32821e9371a1c$var$LAST_KEYS
];
const $82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_OPEN_KEYS = {
    ltr: [
        ...$82110f2367303f9b$var$$6cc32821e9371a1c$var$SELECTION_KEYS,
        "ArrowRight"
    ],
    rtl: [
        ...$82110f2367303f9b$var$$6cc32821e9371a1c$var$SELECTION_KEYS,
        "ArrowLeft"
    ]
};
const $82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_CLOSE_KEYS = {
    ltr: [
        "ArrowLeft"
    ],
    rtl: [
        "ArrowRight"
    ]
};
/* -------------------------------------------------------------------------------------------------
 * Menu
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$MENU_NAME = "Menu";
const [$82110f2367303f9b$var$$6cc32821e9371a1c$var$Collection, $82110f2367303f9b$var$$6cc32821e9371a1c$var$useCollection, $82110f2367303f9b$var$$6cc32821e9371a1c$var$createCollectionScope] = (0, $a9634733d4b9bce9$export$c74125a8e3af6bb2)($82110f2367303f9b$var$$6cc32821e9371a1c$var$MENU_NAME);
const [$82110f2367303f9b$var$$6cc32821e9371a1c$var$createMenuContext, $82110f2367303f9b$export$4027731b685e72eb] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($82110f2367303f9b$var$$6cc32821e9371a1c$var$MENU_NAME, [
    $82110f2367303f9b$var$$6cc32821e9371a1c$var$createCollectionScope,
    (0, $a0ac11a1da65e329$export$722aac194ae923),
    (0, $0483c88073bf4923$export$c7109489551a4f4)
]);
const $82110f2367303f9b$var$$6cc32821e9371a1c$var$usePopperScope = (0, $a0ac11a1da65e329$export$722aac194ae923)();
const $82110f2367303f9b$var$$6cc32821e9371a1c$var$useRovingFocusGroupScope = (0, $0483c88073bf4923$export$c7109489551a4f4)();
const [$82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuProvider, $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuContext] = $82110f2367303f9b$var$$6cc32821e9371a1c$var$createMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$MENU_NAME);
const [$82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuRootProvider, $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuRootContext] = $82110f2367303f9b$var$$6cc32821e9371a1c$var$createMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$MENU_NAME);
const $82110f2367303f9b$export$d9b273488cd8ce6f = (props)=>{
    const { __scopeMenu: __scopeMenu, open: open = false, children: children, dir: dir, onOpenChange: onOpenChange, modal: modal = true } = props;
    const popperScope = $82110f2367303f9b$var$$6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    const [content, setContent] = (0, $acw62.useState)(null);
    const isUsingKeyboardRef = (0, $acw62.useRef)(false);
    const handleOpenChange = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onOpenChange);
    const direction = (0, $f9ad7d2f57cc5bec$export$b39126d51d94e6f3)(dir);
    (0, $acw62.useEffect)(()=>{
        // Capture phase ensures we set the boolean before any side effects execute
        // in response to the key or pointer event as they might depend on this value.
        const handleKeyDown = ()=>{
            isUsingKeyboardRef.current = true;
            document.addEventListener("pointerdown", handlePointer, {
                capture: true,
                once: true
            });
            document.addEventListener("pointermove", handlePointer, {
                capture: true,
                once: true
            });
        };
        const handlePointer = ()=>isUsingKeyboardRef.current = false;
        document.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
            document.removeEventListener("pointerdown", handlePointer, {
                capture: true
            });
            document.removeEventListener("pointermove", handlePointer, {
                capture: true
            });
        };
    }, []);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $a0ac11a1da65e329$export$be92b6f5f03c0fe9), popperScope, /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuProvider, {
        scope: __scopeMenu,
        open: open,
        onOpenChange: handleOpenChange,
        content: content,
        onContentChange: setContent
    }, /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuRootProvider, {
        scope: __scopeMenu,
        onClose: (0, $acw62.useCallback)(()=>handleOpenChange(false), [
            handleOpenChange
        ]),
        isUsingKeyboardRef: isUsingKeyboardRef,
        dir: direction,
        modal: modal
    }, children)));
};
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$d9b273488cd8ce6f, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$MENU_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuAnchor
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$ANCHOR_NAME = "MenuAnchor";
const $82110f2367303f9b$export$9fa5ebd18bee4d43 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...anchorProps } = props;
    const popperScope = $82110f2367303f9b$var$$6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $a0ac11a1da65e329$export$b688253958b8dfe7), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, popperScope, anchorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$9fa5ebd18bee4d43, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuPortal
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$PORTAL_NAME = "MenuPortal";
const [$82110f2367303f9b$var$$6cc32821e9371a1c$var$PortalProvider, $82110f2367303f9b$var$$6cc32821e9371a1c$var$usePortalContext] = $82110f2367303f9b$var$$6cc32821e9371a1c$var$createMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$PORTAL_NAME, {
    forceMount: undefined
});
const $82110f2367303f9b$export$793392f970497feb = (props)=>{
    const { __scopeMenu: __scopeMenu, forceMount: forceMount, children: children, container: container } = props;
    const context = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$PORTAL_NAME, __scopeMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$PortalProvider, {
        scope: __scopeMenu,
        forceMount: forceMount
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $95d053caea9c023a$export$602eac185826482c), {
        asChild: true,
        container: container
    }, children)));
};
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$793392f970497feb, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuContent
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$CONTENT_NAME = "MenuContent";
const [$82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuContentProvider, $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuContentContext] = $82110f2367303f9b$var$$6cc32821e9371a1c$var$createMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$CONTENT_NAME);
const $82110f2367303f9b$export$479f0f2f71193efe = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const portalContext = $82110f2367303f9b$var$$6cc32821e9371a1c$var$usePortalContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const rootContext = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuRootContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$Collection.Provider, {
        scope: props.__scopeMenu
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$Collection.Slot, {
        scope: props.__scopeMenu
    }, rootContext.modal ? /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuRootContentModal, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuRootContentNonModal, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })))));
});
/* ---------------------------------------------------------------------------------------------- */ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuRootContentModal = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const context = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const ref = (0, $acw62.useRef)(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref); // Hide everything from ARIA except the `MenuContent`
    (0, $acw62.useEffect)(()=>{
        const content = ref.current;
        if (content) return (0, $4a7537e072260c10$export$6e33d16126ed003c)(content);
    }, []);
    return /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuContentImpl, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs // we make sure we're not trapping once it's been closed
        ,
        trapFocus: context.open // make sure to only disable pointer events when open
        ,
        disableOutsidePointerEvents: context.open,
        disableOutsideScroll: true // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault(), {
            checkForDefaultPrevented: false
        }),
        onDismiss: ()=>context.onOpenChange(false)
    }));
});
const $82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuRootContentNonModal = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const context = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuContentImpl, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        disableOutsideScroll: false,
        onDismiss: ()=>context.onOpenChange(false)
    }));
});
/* ---------------------------------------------------------------------------------------------- */ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuContentImpl = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, loop: loop = false, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, disableOutsidePointerEvents: disableOutsidePointerEvents, onEntryFocus: onEntryFocus, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, disableOutsideScroll: disableOutsideScroll, ...contentProps } = props;
    const context = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$CONTENT_NAME, __scopeMenu);
    const rootContext = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuRootContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$CONTENT_NAME, __scopeMenu);
    const popperScope = $82110f2367303f9b$var$$6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    const rovingFocusGroupScope = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useRovingFocusGroupScope(__scopeMenu);
    const getItems = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useCollection(__scopeMenu);
    const [currentItemId, setCurrentItemId] = (0, $acw62.useState)(null);
    const contentRef = (0, $acw62.useRef)(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, contentRef, context.onContentChange);
    const timerRef = (0, $acw62.useRef)(0);
    const searchRef = (0, $acw62.useRef)("");
    const pointerGraceTimerRef = (0, $acw62.useRef)(0);
    const pointerGraceIntentRef = (0, $acw62.useRef)(null);
    const pointerDirRef = (0, $acw62.useRef)("right");
    const lastPointerXRef = (0, $acw62.useRef)(0);
    const ScrollLockWrapper = disableOutsideScroll ? (0, $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039) : (0, $acw62.Fragment);
    const scrollLockWrapperProps = disableOutsideScroll ? {
        as: (0, $cf381de56a25bc52$export$8c6ed5c666ac1360),
        allowPinchZoom: true
    } : undefined;
    const handleTypeaheadSearch = (key)=>{
        var _items$find, _items$find2;
        const search = searchRef.current + key;
        const items = getItems().filter((item)=>!item.disabled);
        const currentItem = document.activeElement;
        const currentMatch = (_items$find = items.find((item)=>item.ref.current === currentItem)) === null || _items$find === void 0 ? void 0 : _items$find.textValue;
        const values = items.map((item)=>item.textValue);
        const nextMatch = $82110f2367303f9b$var$$6cc32821e9371a1c$var$getNextMatch(values, search, currentMatch);
        const newItem = (_items$find2 = items.find((item)=>item.textValue === nextMatch)) === null || _items$find2 === void 0 ? void 0 : _items$find2.ref.current; // Reset `searchRef` 1 second after it was last updated
        (function updateSearch(value) {
            searchRef.current = value;
            window.clearTimeout(timerRef.current);
            if (value !== "") timerRef.current = window.setTimeout(()=>updateSearch(""), 1000);
        })(search);
        if (newItem) /**
       * Imperative focus during keydown is risky so we prevent React's batching updates
       * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
       */ setTimeout(()=>newItem.focus());
    };
    (0, $acw62.useEffect)(()=>{
        return ()=>window.clearTimeout(timerRef.current);
    }, []); // Make sure the whole tree has focus guards as our `MenuContent` may be
    // the last element in the DOM (beacuse of the `Portal`)
    (0, $264faec0fdf8876a$export$b7ece24a22aeda8c)();
    const isPointerMovingToSubmenu = (0, $acw62.useCallback)((event)=>{
        var _pointerGraceIntentRe, _pointerGraceIntentRe2;
        const isMovingTowards = pointerDirRef.current === ((_pointerGraceIntentRe = pointerGraceIntentRef.current) === null || _pointerGraceIntentRe === void 0 ? void 0 : _pointerGraceIntentRe.side);
        return isMovingTowards && $82110f2367303f9b$var$$6cc32821e9371a1c$var$isPointerInGraceArea(event, (_pointerGraceIntentRe2 = pointerGraceIntentRef.current) === null || _pointerGraceIntentRe2 === void 0 ? void 0 : _pointerGraceIntentRe2.area);
    }, []);
    return /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuContentProvider, {
        scope: __scopeMenu,
        searchRef: searchRef,
        onItemEnter: (0, $acw62.useCallback)((event)=>{
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
        }, [
            isPointerMovingToSubmenu
        ]),
        onItemLeave: (0, $acw62.useCallback)((event)=>{
            var _contentRef$current;
            if (isPointerMovingToSubmenu(event)) return;
            (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 || _contentRef$current.focus();
            setCurrentItemId(null);
        }, [
            isPointerMovingToSubmenu
        ]),
        onTriggerLeave: (0, $acw62.useCallback)((event)=>{
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
        }, [
            isPointerMovingToSubmenu
        ]),
        pointerGraceTimerRef: pointerGraceTimerRef,
        onPointerGraceIntentChange: (0, $acw62.useCallback)((intent)=>{
            pointerGraceIntentRef.current = intent;
        }, [])
    }, /*#__PURE__*/ (0, $acw62.createElement)(ScrollLockWrapper, scrollLockWrapperProps, /*#__PURE__*/ (0, $acw62.createElement)((0, $03c48a27777929a8$export$20e40289641fbbb6), {
        asChild: true,
        trapped: trapFocus,
        onMountAutoFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(onOpenAutoFocus, (event)=>{
            var _contentRef$current2;
            // when opening, explicitly focus the content area only and leave
            // `onEntryFocus` in  control of focusing first item
            event.preventDefault();
            (_contentRef$current2 = contentRef.current) === null || _contentRef$current2 === void 0 || _contentRef$current2.focus();
        }),
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $30a399657994b369$export$177fb62ff3ec1f22), {
        asChild: true,
        disableOutsidePointerEvents: disableOutsidePointerEvents,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: onFocusOutside,
        onInteractOutside: onInteractOutside,
        onDismiss: onDismiss
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $0483c88073bf4923$export$be92b6f5f03c0fe9), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        asChild: true
    }, rovingFocusGroupScope, {
        dir: rootContext.dir,
        orientation: "vertical",
        loop: loop,
        currentTabStopId: currentItemId,
        onCurrentTabStopIdChange: setCurrentItemId,
        onEntryFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(onEntryFocus, (event)=>{
            // only focus first item when using keyboard
            if (!rootContext.isUsingKeyboardRef.current) event.preventDefault();
        })
    }), /*#__PURE__*/ (0, $acw62.createElement)((0, $a0ac11a1da65e329$export$7c6e2c02157bb7d2), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        role: "menu",
        "aria-orientation": "vertical",
        "data-state": $82110f2367303f9b$var$$6cc32821e9371a1c$var$getOpenState(context.open),
        "data-radix-menu-content": "",
        dir: rootContext.dir
    }, popperScope, contentProps, {
        ref: composedRefs,
        style: {
            outline: "none",
            ...contentProps.style
        },
        onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(contentProps.onKeyDown, (event)=>{
            // submenu key events bubble through portals. We only care about keys in this menu.
            const target = event.target;
            const isKeyDownInside = target.closest("[data-radix-menu-content]") === event.currentTarget;
            const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
            const isCharacterKey = event.key.length === 1;
            if (isKeyDownInside) {
                // menus should not be navigated using tab key so we prevent it
                if (event.key === "Tab") event.preventDefault();
                if (!isModifierKey && isCharacterKey) handleTypeaheadSearch(event.key);
            } // focus first/last item based on key pressed
            const content = contentRef.current;
            if (event.target !== content) return;
            if (!$82110f2367303f9b$var$$6cc32821e9371a1c$var$FIRST_LAST_KEYS.includes(event.key)) return;
            event.preventDefault();
            const items = getItems().filter((item)=>!item.disabled);
            const candidateNodes = items.map((item)=>item.ref.current);
            if ($82110f2367303f9b$var$$6cc32821e9371a1c$var$LAST_KEYS.includes(event.key)) candidateNodes.reverse();
            $82110f2367303f9b$var$$6cc32821e9371a1c$var$focusFirst(candidateNodes);
        }),
        onBlur: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onBlur, (event)=>{
            // clear search buffer when leaving the menu
            if (!event.currentTarget.contains(event.target)) {
                window.clearTimeout(timerRef.current);
                searchRef.current = "";
            }
        }),
        onPointerMove: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerMove, $82110f2367303f9b$var$$6cc32821e9371a1c$var$whenMouse((event)=>{
            const target = event.target;
            const pointerXHasChanged = lastPointerXRef.current !== event.clientX; // We don't use `event.movementX` for this check because Safari will
            // always return `0` on a pointer event.
            if (event.currentTarget.contains(target) && pointerXHasChanged) {
                const newDir = event.clientX > lastPointerXRef.current ? "right" : "left";
                pointerDirRef.current = newDir;
                lastPointerXRef.current = event.clientX;
            }
        }))
    })))))));
});
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$479f0f2f71193efe, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuGroup
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$GROUP_NAME = "MenuGroup";
const $82110f2367303f9b$export$22a631d1f72787bb = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...groupProps } = props;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        role: "group"
    }, groupProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$22a631d1f72787bb, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuLabel
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$LABEL_NAME = "MenuLabel";
const $82110f2367303f9b$export$dd37bec0e8a99143 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...labelProps } = props;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, labelProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$dd37bec0e8a99143, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$LABEL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuItem
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$ITEM_NAME = "MenuItem";
const $82110f2367303f9b$var$$6cc32821e9371a1c$var$ITEM_SELECT = "menu.itemSelect";
const $82110f2367303f9b$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { disabled: disabled = false, onSelect: onSelect, ...itemProps } = props;
    const ref = (0, $acw62.useRef)(null);
    const rootContext = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuRootContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$ITEM_NAME, props.__scopeMenu);
    const contentContext = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuContentContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$ITEM_NAME, props.__scopeMenu);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const isPointerDownRef = (0, $acw62.useRef)(false);
    const handleSelect = ()=>{
        const menuItem = ref.current;
        if (!disabled && menuItem) {
            const itemSelectEvent = new CustomEvent($82110f2367303f9b$var$$6cc32821e9371a1c$var$ITEM_SELECT, {
                bubbles: true,
                cancelable: true
            });
            menuItem.addEventListener($82110f2367303f9b$var$$6cc32821e9371a1c$var$ITEM_SELECT, (event)=>onSelect === null || onSelect === void 0 ? void 0 : onSelect(event), {
                once: true
            });
            (0, $dc7d5df3de21cdcb$export$6d1a0317bde7de7f)(menuItem, itemSelectEvent);
            if (itemSelectEvent.defaultPrevented) isPointerDownRef.current = false;
            else rootContext.onClose();
        }
    };
    return /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuItemImpl, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, itemProps, {
        ref: composedRefs,
        disabled: disabled,
        onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onClick, handleSelect),
        onPointerDown: (event)=>{
            var _props$onPointerDown;
            (_props$onPointerDown = props.onPointerDown) === null || _props$onPointerDown === void 0 || _props$onPointerDown.call(props, event);
            isPointerDownRef.current = true;
        },
        onPointerUp: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerUp, (event)=>{
            var _event$currentTarget;
            // Pointer down can move to a different menu item which should activate it on pointer up.
            // We dispatch a click for selection to allow composition with click based triggers and to
            // prevent Firefox from getting stuck in text selection mode when the menu closes.
            if (!isPointerDownRef.current) (_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 || _event$currentTarget.click();
        }),
        onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            const isTypingAhead = contentContext.searchRef.current !== "";
            if (disabled || isTypingAhead && event.key === " ") return;
            if ($82110f2367303f9b$var$$6cc32821e9371a1c$var$SELECTION_KEYS.includes(event.key)) {
                event.currentTarget.click();
                /**
         * We prevent default browser behaviour for selection keys as they should trigger
         * a selection only:
         * - prevents space from scrolling the page.
         * - if keydown causes focus to move, prevents keydown from firing on the new target.
         */ event.preventDefault();
            }
        })
    }));
});
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$2ce376c2cc3355c8, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$ITEM_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuItemImpl = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, disabled: disabled = false, textValue: textValue, ...itemProps } = props;
    const contentContext = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuContentContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$ITEM_NAME, __scopeMenu);
    const rovingFocusGroupScope = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useRovingFocusGroupScope(__scopeMenu);
    const ref = (0, $acw62.useRef)(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const [isFocused, setIsFocused] = (0, $acw62.useState)(false); // get the item's `.textContent` as default strategy for typeahead `textValue`
    const [textContent, setTextContent] = (0, $acw62.useState)("");
    (0, $acw62.useEffect)(()=>{
        const menuItem = ref.current;
        if (menuItem) {
            var _menuItem$textContent;
            setTextContent(((_menuItem$textContent = menuItem.textContent) !== null && _menuItem$textContent !== void 0 ? _menuItem$textContent : "").trim());
        }
    }, [
        itemProps.children
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$Collection.ItemSlot, {
        scope: __scopeMenu,
        disabled: disabled,
        textValue: textValue !== null && textValue !== void 0 ? textValue : textContent
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $0483c88073bf4923$export$6d08773d2e66f8f2), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        asChild: true
    }, rovingFocusGroupScope, {
        focusable: !disabled
    }), /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        role: "menuitem",
        "data-highlighted": isFocused ? "" : undefined,
        "aria-disabled": disabled || undefined,
        "data-disabled": disabled ? "" : undefined
    }, itemProps, {
        ref: composedRefs,
        onPointerMove: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerMove, $82110f2367303f9b$var$$6cc32821e9371a1c$var$whenMouse((event)=>{
            if (disabled) contentContext.onItemLeave(event);
            else {
                contentContext.onItemEnter(event);
                if (!event.defaultPrevented) {
                    const item = event.currentTarget;
                    item.focus();
                }
            }
        })),
        onPointerLeave: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerLeave, $82110f2367303f9b$var$$6cc32821e9371a1c$var$whenMouse((event)=>contentContext.onItemLeave(event))),
        onFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocus, ()=>setIsFocused(true)),
        onBlur: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsFocused(false))
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * MenuCheckboxItem
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$CHECKBOX_ITEM_NAME = "MenuCheckboxItem";
const $82110f2367303f9b$export$f6f243521332502d = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { checked: checked = false, onCheckedChange: onCheckedChange, ...checkboxItemProps } = props;
    return /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$ItemIndicatorProvider, {
        scope: props.__scopeMenu,
        checked: checked
    }, /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$export$2ce376c2cc3355c8, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        role: "menuitemcheckbox",
        "aria-checked": $82110f2367303f9b$var$$6cc32821e9371a1c$var$isIndeterminate(checked) ? "mixed" : checked
    }, checkboxItemProps, {
        ref: forwardedRef,
        "data-state": $82110f2367303f9b$var$$6cc32821e9371a1c$var$getCheckedState(checked),
        onSelect: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(checkboxItemProps.onSelect, ()=>onCheckedChange === null || onCheckedChange === void 0 ? void 0 : onCheckedChange($82110f2367303f9b$var$$6cc32821e9371a1c$var$isIndeterminate(checked) ? true : !checked), {
            checkForDefaultPrevented: false
        })
    })));
});
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$f6f243521332502d, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$CHECKBOX_ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuRadioGroup
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$RADIO_GROUP_NAME = "MenuRadioGroup";
const [$82110f2367303f9b$var$$6cc32821e9371a1c$var$RadioGroupProvider, $82110f2367303f9b$var$$6cc32821e9371a1c$var$useRadioGroupContext] = $82110f2367303f9b$var$$6cc32821e9371a1c$var$createMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$RADIO_GROUP_NAME, {
    value: undefined,
    onValueChange: ()=>{}
});
const $82110f2367303f9b$export$ea2200c9eee416b3 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { value: value, onValueChange: onValueChange, ...groupProps } = props;
    const handleValueChange = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onValueChange);
    return /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$RadioGroupProvider, {
        scope: props.__scopeMenu,
        value: value,
        onValueChange: handleValueChange
    }, /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$export$22a631d1f72787bb, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, groupProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$ea2200c9eee416b3, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$RADIO_GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuRadioItem
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$RADIO_ITEM_NAME = "MenuRadioItem";
const $82110f2367303f9b$export$69bd225e9817f6d0 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { value: value, ...radioItemProps } = props;
    const context = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useRadioGroupContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$RADIO_ITEM_NAME, props.__scopeMenu);
    const checked = value === context.value;
    return /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$ItemIndicatorProvider, {
        scope: props.__scopeMenu,
        checked: checked
    }, /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$export$2ce376c2cc3355c8, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        role: "menuitemradio",
        "aria-checked": checked
    }, radioItemProps, {
        ref: forwardedRef,
        "data-state": $82110f2367303f9b$var$$6cc32821e9371a1c$var$getCheckedState(checked),
        onSelect: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(radioItemProps.onSelect, ()=>{
            var _context$onValueChang;
            return (_context$onValueChang = context.onValueChange) === null || _context$onValueChang === void 0 ? void 0 : _context$onValueChang.call(context, value);
        }, {
            checkForDefaultPrevented: false
        })
    })));
});
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$69bd225e9817f6d0, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$RADIO_ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuItemIndicator
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$ITEM_INDICATOR_NAME = "MenuItemIndicator";
const [$82110f2367303f9b$var$$6cc32821e9371a1c$var$ItemIndicatorProvider, $82110f2367303f9b$var$$6cc32821e9371a1c$var$useItemIndicatorContext] = $82110f2367303f9b$var$$6cc32821e9371a1c$var$createMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$ITEM_INDICATOR_NAME, {
    checked: false
});
const $82110f2367303f9b$export$a2593e23056970a3 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, forceMount: forceMount, ...itemIndicatorProps } = props;
    const indicatorContext = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useItemIndicatorContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$ITEM_INDICATOR_NAME, __scopeMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
        present: forceMount || $82110f2367303f9b$var$$6cc32821e9371a1c$var$isIndeterminate(indicatorContext.checked) || indicatorContext.checked === true
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).span, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, itemIndicatorProps, {
        ref: forwardedRef,
        "data-state": $82110f2367303f9b$var$$6cc32821e9371a1c$var$getCheckedState(indicatorContext.checked)
    })));
});
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$a2593e23056970a3, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$ITEM_INDICATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuSeparator
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$SEPARATOR_NAME = "MenuSeparator";
const $82110f2367303f9b$export$1cec7dcdd713e220 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...separatorProps } = props;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        role: "separator",
        "aria-orientation": "horizontal"
    }, separatorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$1cec7dcdd713e220, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$SEPARATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuArrow
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$ARROW_NAME = "MenuArrow";
const $82110f2367303f9b$export$bcdda4773debf5fa = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...arrowProps } = props;
    const popperScope = $82110f2367303f9b$var$$6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $a0ac11a1da65e329$export$21b07c8f274aebd5), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, popperScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$bcdda4773debf5fa, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$ARROW_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuSub
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_NAME = "MenuSub";
const [$82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuSubProvider, $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuSubContext] = $82110f2367303f9b$var$$6cc32821e9371a1c$var$createMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_NAME);
const $82110f2367303f9b$export$71bdb9d1e2909932 = (props)=>{
    const { __scopeMenu: __scopeMenu, children: children, open: open = false, onOpenChange: onOpenChange } = props;
    const parentMenuContext = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_NAME, __scopeMenu);
    const popperScope = $82110f2367303f9b$var$$6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    const [trigger, setTrigger] = (0, $acw62.useState)(null);
    const [content, setContent] = (0, $acw62.useState)(null);
    const handleOpenChange = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onOpenChange); // Prevent the parent menu from reopening with open submenus.
    (0, $acw62.useEffect)(()=>{
        if (parentMenuContext.open === false) handleOpenChange(false);
        return ()=>handleOpenChange(false);
    }, [
        parentMenuContext.open,
        handleOpenChange
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $a0ac11a1da65e329$export$be92b6f5f03c0fe9), popperScope, /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuProvider, {
        scope: __scopeMenu,
        open: open,
        onOpenChange: handleOpenChange,
        content: content,
        onContentChange: setContent
    }, /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuSubProvider, {
        scope: __scopeMenu,
        contentId: (0, $11885ec535b13ccc$export$f680877a34711e37)(),
        triggerId: (0, $11885ec535b13ccc$export$f680877a34711e37)(),
        trigger: trigger,
        onTriggerChange: setTrigger
    }, children)));
};
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$71bdb9d1e2909932, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuSubTrigger
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_TRIGGER_NAME = "MenuSubTrigger";
const $82110f2367303f9b$export$5fbbb3ba7297405f = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const context = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const rootContext = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuRootContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const subContext = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuSubContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const contentContext = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuContentContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const openTimerRef = (0, $acw62.useRef)(null);
    const { pointerGraceTimerRef: pointerGraceTimerRef, onPointerGraceIntentChange: onPointerGraceIntentChange } = contentContext;
    const scope = {
        __scopeMenu: props.__scopeMenu
    };
    const clearOpenTimer = (0, $acw62.useCallback)(()=>{
        if (openTimerRef.current) window.clearTimeout(openTimerRef.current);
        openTimerRef.current = null;
    }, []);
    (0, $acw62.useEffect)(()=>clearOpenTimer, [
        clearOpenTimer
    ]);
    (0, $acw62.useEffect)(()=>{
        const pointerGraceTimer = pointerGraceTimerRef.current;
        return ()=>{
            window.clearTimeout(pointerGraceTimer);
            onPointerGraceIntentChange(null);
        };
    }, [
        pointerGraceTimerRef,
        onPointerGraceIntentChange
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$export$9fa5ebd18bee4d43, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        asChild: true
    }, scope), /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuItemImpl, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        id: subContext.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": context.open,
        "aria-controls": subContext.contentId,
        "data-state": $82110f2367303f9b$var$$6cc32821e9371a1c$var$getOpenState(context.open)
    }, props, {
        ref: (0, $fb3356a19a5676fa$export$43e446d32b3d21af)(forwardedRef, subContext.onTriggerChange) // This is redundant for mouse users but we cannot determine pointer type from
        ,
        onClick: (event)=>{
            var _props$onClick;
            (_props$onClick = props.onClick) === null || _props$onClick === void 0 || _props$onClick.call(props, event);
            if (props.disabled || event.defaultPrevented) return;
            /**
       * We manually focus because iOS Safari doesn't always focus on click (e.g. buttons)
       * and we rely heavily on `onFocusOutside` for submenus to close when switching
       * between separate submenus.
       */ event.currentTarget.focus();
            if (!context.open) context.onOpenChange(true);
        },
        onPointerMove: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerMove, $82110f2367303f9b$var$$6cc32821e9371a1c$var$whenMouse((event)=>{
            contentContext.onItemEnter(event);
            if (event.defaultPrevented) return;
            if (!props.disabled && !context.open && !openTimerRef.current) {
                contentContext.onPointerGraceIntentChange(null);
                openTimerRef.current = window.setTimeout(()=>{
                    context.onOpenChange(true);
                    clearOpenTimer();
                }, 100);
            }
        })),
        onPointerLeave: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerLeave, $82110f2367303f9b$var$$6cc32821e9371a1c$var$whenMouse((event)=>{
            var _context$content;
            clearOpenTimer();
            const contentRect = (_context$content = context.content) === null || _context$content === void 0 ? void 0 : _context$content.getBoundingClientRect();
            if (contentRect) {
                var _context$content2;
                // TODO: make sure to update this when we change positioning logic
                const side = (_context$content2 = context.content) === null || _context$content2 === void 0 ? void 0 : _context$content2.dataset.side;
                const rightSide = side === "right";
                const bleed = rightSide ? -5 : 5;
                const contentNearEdge = contentRect[rightSide ? "left" : "right"];
                const contentFarEdge = contentRect[rightSide ? "right" : "left"];
                contentContext.onPointerGraceIntentChange({
                    area: [
                        // consistently within polygon bounds
                        {
                            x: event.clientX + bleed,
                            y: event.clientY
                        },
                        {
                            x: contentNearEdge,
                            y: contentRect.top
                        },
                        {
                            x: contentFarEdge,
                            y: contentRect.top
                        },
                        {
                            x: contentFarEdge,
                            y: contentRect.bottom
                        },
                        {
                            x: contentNearEdge,
                            y: contentRect.bottom
                        }
                    ],
                    side: side
                });
                window.clearTimeout(pointerGraceTimerRef.current);
                pointerGraceTimerRef.current = window.setTimeout(()=>contentContext.onPointerGraceIntentChange(null), 300);
            } else {
                contentContext.onTriggerLeave(event);
                if (event.defaultPrevented) return; // There's 100ms where the user may leave an item before the submenu was opened.
                contentContext.onPointerGraceIntentChange(null);
            }
        })),
        onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            const isTypingAhead = contentContext.searchRef.current !== "";
            if (props.disabled || isTypingAhead && event.key === " ") return;
            if ($82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_OPEN_KEYS[rootContext.dir].includes(event.key)) {
                var _context$content3;
                context.onOpenChange(true); // The trigger may hold focus if opened via pointer interaction
                // so we ensure content is given focus again when switching to keyboard.
                (_context$content3 = context.content) === null || _context$content3 === void 0 || _context$content3.focus(); // prevent window from scrolling
                event.preventDefault();
            }
        })
    })));
});
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$5fbbb3ba7297405f, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuSubContent
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_CONTENT_NAME = "MenuSubContent";
const $82110f2367303f9b$export$e7142ab31822bde6 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const portalContext = $82110f2367303f9b$var$$6cc32821e9371a1c$var$usePortalContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const { forceMount: forceMount = portalContext.forceMount, ...subContentProps } = props;
    const context = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const rootContext = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuRootContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const subContext = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuSubContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_CONTENT_NAME, props.__scopeMenu);
    const ref = (0, $acw62.useRef)(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    return /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$Collection.Provider, {
        scope: props.__scopeMenu
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$Collection.Slot, {
        scope: props.__scopeMenu
    }, /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuContentImpl, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        id: subContext.contentId,
        "aria-labelledby": subContext.triggerId
    }, subContentProps, {
        ref: composedRefs,
        align: "start",
        side: rootContext.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: false,
        disableOutsideScroll: false,
        trapFocus: false,
        onOpenAutoFocus: (event)=>{
            var _ref$current;
            // when opening a submenu, focus content for keyboard users only
            if (rootContext.isUsingKeyboardRef.current) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
            event.preventDefault();
        } // The menu might close because of focusing another menu item in the parent menu. We
        ,
        onCloseAutoFocus: (event)=>event.preventDefault(),
        onFocusOutside: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>{
            // We prevent closing when the trigger is focused to avoid triggering a re-open animation
            // on pointer interaction.
            if (event.target !== subContext.trigger) context.onOpenChange(false);
        }),
        onEscapeKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onEscapeKeyDown, (event)=>{
            rootContext.onClose(); // ensure pressing escape in submenu doesn't escape full screen mode
            event.preventDefault();
        }),
        onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            // Submenu key events bubble through portals. We only care about keys in this menu.
            const isKeyDownInside = event.currentTarget.contains(event.target);
            const isCloseKey = $82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_CLOSE_KEYS[rootContext.dir].includes(event.key);
            if (isKeyDownInside && isCloseKey) {
                var _subContext$trigger;
                context.onOpenChange(false); // We focus manually because we prevented it in `onCloseAutoFocus`
                (_subContext$trigger = subContext.trigger) === null || _subContext$trigger === void 0 || _subContext$trigger.focus(); // prevent window from scrolling
                event.preventDefault();
            }
        })
    })))));
});
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$e7142ab31822bde6, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $82110f2367303f9b$var$$6cc32821e9371a1c$var$getOpenState(open) {
    return open ? "open" : "closed";
}
function $82110f2367303f9b$var$$6cc32821e9371a1c$var$isIndeterminate(checked) {
    return checked === "indeterminate";
}
function $82110f2367303f9b$var$$6cc32821e9371a1c$var$getCheckedState(checked) {
    return $82110f2367303f9b$var$$6cc32821e9371a1c$var$isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}
function $82110f2367303f9b$var$$6cc32821e9371a1c$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $82110f2367303f9b$var$$6cc32821e9371a1c$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
/**
 * This is the "meat" of the typeahead matching logic. It takes in all the values,
 * the search and the current match, and returns the next match (or `undefined`).
 *
 * We normalize the search because if a user has repeatedly pressed a character,
 * we want the exact same behavior as if we only had that one character
 * (ie. cycle through options starting with that character)
 *
 * We also reorder the values by wrapping the array around the current match.
 * This is so we always look forward from the current match, and picking the first
 * match will always be the correct one.
 *
 * Finally, if the normalized search is exactly one character, we exclude the
 * current match from the values because otherwise it would be the first to match always
 * and focus would never move. This is as opposed to the regular case, where we
 * don't want focus to move if the current match still matches.
 */ function $82110f2367303f9b$var$$6cc32821e9371a1c$var$getNextMatch(values, search, currentMatch) {
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]);
    const normalizedSearch = isRepeated ? search[0] : search;
    const currentMatchIndex = currentMatch ? values.indexOf(currentMatch) : -1;
    let wrappedValues = $82110f2367303f9b$var$$6cc32821e9371a1c$var$wrapArray(values, Math.max(currentMatchIndex, 0));
    const excludeCurrentMatch = normalizedSearch.length === 1;
    if (excludeCurrentMatch) wrappedValues = wrappedValues.filter((v)=>v !== currentMatch);
    const nextMatch = wrappedValues.find((value)=>value.toLowerCase().startsWith(normalizedSearch.toLowerCase()));
    return nextMatch !== currentMatch ? nextMatch : undefined;
}
// Determine if a point is inside of a polygon.
// Based on https://github.com/substack/point-in-polygon
function $82110f2367303f9b$var$$6cc32821e9371a1c$var$isPointInPolygon(point, polygon) {
    const { x: x, y: y } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y; // prettier-ignore
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
function $82110f2367303f9b$var$$6cc32821e9371a1c$var$isPointerInGraceArea(event, area) {
    if (!area) return false;
    const cursorPos = {
        x: event.clientX,
        y: event.clientY
    };
    return $82110f2367303f9b$var$$6cc32821e9371a1c$var$isPointInPolygon(cursorPos, area);
}
function $82110f2367303f9b$var$$6cc32821e9371a1c$var$whenMouse(handler) {
    return (event)=>event.pointerType === "mouse" ? handler(event) : undefined;
}
const $82110f2367303f9b$export$be92b6f5f03c0fe9 = $82110f2367303f9b$export$d9b273488cd8ce6f;
const $82110f2367303f9b$export$b688253958b8dfe7 = $82110f2367303f9b$export$9fa5ebd18bee4d43;
const $82110f2367303f9b$export$602eac185826482c = $82110f2367303f9b$export$793392f970497feb;
const $82110f2367303f9b$export$7c6e2c02157bb7d2 = $82110f2367303f9b$export$479f0f2f71193efe;
const $82110f2367303f9b$export$eb2fcfdbd7ba97d4 = $82110f2367303f9b$export$22a631d1f72787bb;
const $82110f2367303f9b$export$b04be29aa201d4f5 = $82110f2367303f9b$export$dd37bec0e8a99143;
const $82110f2367303f9b$export$6d08773d2e66f8f2 = $82110f2367303f9b$export$2ce376c2cc3355c8;
const $82110f2367303f9b$export$16ce288f89fa631c = $82110f2367303f9b$export$f6f243521332502d;
const $82110f2367303f9b$export$a98f0dcb43a68a25 = $82110f2367303f9b$export$ea2200c9eee416b3;
const $82110f2367303f9b$export$371ab307eab489c0 = $82110f2367303f9b$export$69bd225e9817f6d0;
const $82110f2367303f9b$export$c3468e2714d175fa = $82110f2367303f9b$export$a2593e23056970a3;
const $82110f2367303f9b$export$1ff3c3f08ae963c0 = $82110f2367303f9b$export$1cec7dcdd713e220;
const $82110f2367303f9b$export$21b07c8f274aebd5 = $82110f2367303f9b$export$bcdda4773debf5fa;
const $82110f2367303f9b$export$d7a01e11500dfb6f = $82110f2367303f9b$export$71bdb9d1e2909932;
const $82110f2367303f9b$export$2ea8a7a591ac5eac = $82110f2367303f9b$export$5fbbb3ba7297405f;
const $82110f2367303f9b$export$6d4de93b380beddf = $82110f2367303f9b$export$e7142ab31822bde6;



/* -------------------------------------------------------------------------------------------------
 * DropdownMenu
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$DROPDOWN_MENU_NAME = "DropdownMenu";
const [$a51a7192f883dda1$var$$d08ef79370b62062$var$createDropdownMenuContext, $a51a7192f883dda1$export$c0623cd925aeb687] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($a51a7192f883dda1$var$$d08ef79370b62062$var$DROPDOWN_MENU_NAME, [
    (0, $82110f2367303f9b$export$4027731b685e72eb)
]);
const $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope = (0, $82110f2367303f9b$export$4027731b685e72eb)();
const [$a51a7192f883dda1$var$$d08ef79370b62062$var$DropdownMenuProvider, $a51a7192f883dda1$var$$d08ef79370b62062$var$useDropdownMenuContext] = $a51a7192f883dda1$var$$d08ef79370b62062$var$createDropdownMenuContext($a51a7192f883dda1$var$$d08ef79370b62062$var$DROPDOWN_MENU_NAME);
const $a51a7192f883dda1$export$e44a253a59704894 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, children: children, dir: dir, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    const triggerRef = (0, $acw62.useRef)(null);
    const [open = false, setOpen] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $acw62.createElement)($a51a7192f883dda1$var$$d08ef79370b62062$var$DropdownMenuProvider, {
        scope: __scopeDropdownMenu,
        triggerId: (0, $11885ec535b13ccc$export$f680877a34711e37)(),
        triggerRef: triggerRef,
        contentId: (0, $11885ec535b13ccc$export$f680877a34711e37)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: (0, $acw62.useCallback)(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $82110f2367303f9b$export$be92b6f5f03c0fe9), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, menuScope, {
        open: open,
        onOpenChange: setOpen,
        dir: dir,
        modal: modal
    }), children));
};
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$e44a253a59704894, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$DROPDOWN_MENU_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuTrigger
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$TRIGGER_NAME = "DropdownMenuTrigger";
const $a51a7192f883dda1$export$d2469213b3befba9 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, disabled: disabled = false, ...triggerProps } = props;
    const context = $a51a7192f883dda1$var$$d08ef79370b62062$var$useDropdownMenuContext($a51a7192f883dda1$var$$d08ef79370b62062$var$TRIGGER_NAME, __scopeDropdownMenu);
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $82110f2367303f9b$export$b688253958b8dfe7), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        asChild: true
    }, menuScope), /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).button, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        type: "button",
        id: context.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": context.open,
        "aria-controls": context.open ? context.contentId : undefined,
        "data-state": context.open ? "open" : "closed",
        "data-disabled": disabled ? "" : undefined,
        disabled: disabled
    }, triggerProps, {
        ref: (0, $fb3356a19a5676fa$export$43e446d32b3d21af)(forwardedRef, context.triggerRef),
        onPointerDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerDown, (event)=>{
            // only call handler if it's the left button (mousedown gets triggered by all mouse buttons)
            // but not when the control key is pressed (avoiding MacOS right click)
            if (!disabled && event.button === 0 && event.ctrlKey === false) {
                context.onOpenToggle(); // prevent trigger focusing when opening
                // this allows the content to be given focus without competition
                if (!context.open) event.preventDefault();
            }
        }),
        onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            if (disabled) return;
            if ([
                "Enter",
                " "
            ].includes(event.key)) context.onOpenToggle();
            if (event.key === "ArrowDown") context.onOpenChange(true); // prevent keydown from scrolling window / first focused item to execute
            // that keydown (inadvertently closing the menu)
            if ([
                "Enter",
                " ",
                "ArrowDown"
            ].includes(event.key)) event.preventDefault();
        })
    })));
});
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$d2469213b3befba9, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuPortal
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$PORTAL_NAME = "DropdownMenuPortal";
const $a51a7192f883dda1$export$cd369b4d4d54efc9 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...portalProps } = props;
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $82110f2367303f9b$export$602eac185826482c), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, menuScope, portalProps));
};
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$cd369b4d4d54efc9, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuContent
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$CONTENT_NAME = "DropdownMenuContent";
const $a51a7192f883dda1$export$6e76d93a37c01248 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...contentProps } = props;
    const context = $a51a7192f883dda1$var$$d08ef79370b62062$var$useDropdownMenuContext($a51a7192f883dda1$var$$d08ef79370b62062$var$CONTENT_NAME, __scopeDropdownMenu);
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    const hasInteractedOutsideRef = (0, $acw62.useRef)(false);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $82110f2367303f9b$export$7c6e2c02157bb7d2), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        id: context.contentId,
        "aria-labelledby": context.triggerId
    }, menuScope, contentProps, {
        ref: forwardedRef,
        onCloseAutoFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            if (!hasInteractedOutsideRef.current) (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
            hasInteractedOutsideRef.current = false; // Always prevent auto focus because we either focus manually or want user agent focus
            event.preventDefault();
        }),
        onInteractOutside: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onInteractOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (!context.modal || isRightClick) hasInteractedOutsideRef.current = true;
        }),
        style: {
            ...props.style,
            "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
            "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
            "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
    }));
});
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$6e76d93a37c01248, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuGroup
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$GROUP_NAME = "DropdownMenuGroup";
const $a51a7192f883dda1$export$246bebaba3a2f70e = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...groupProps } = props;
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $82110f2367303f9b$export$eb2fcfdbd7ba97d4), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, menuScope, groupProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$246bebaba3a2f70e, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuLabel
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$LABEL_NAME = "DropdownMenuLabel";
const $a51a7192f883dda1$export$76e48c5b57f24495 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...labelProps } = props;
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $82110f2367303f9b$export$b04be29aa201d4f5), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, menuScope, labelProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$76e48c5b57f24495, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$LABEL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuItem
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$ITEM_NAME = "DropdownMenuItem";
const $a51a7192f883dda1$export$ed97964d1871885d = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...itemProps } = props;
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $82110f2367303f9b$export$6d08773d2e66f8f2), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, menuScope, itemProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$ed97964d1871885d, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuCheckboxItem
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$CHECKBOX_ITEM_NAME = "DropdownMenuCheckboxItem";
const $a51a7192f883dda1$export$53a69729da201fa9 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...checkboxItemProps } = props;
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $82110f2367303f9b$export$16ce288f89fa631c), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, menuScope, checkboxItemProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$53a69729da201fa9, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$CHECKBOX_ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuRadioGroup
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$RADIO_GROUP_NAME = "DropdownMenuRadioGroup";
const $a51a7192f883dda1$export$3323ad73d55f587e = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...radioGroupProps } = props;
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $82110f2367303f9b$export$a98f0dcb43a68a25), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, menuScope, radioGroupProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$3323ad73d55f587e, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$RADIO_GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuRadioItem
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$RADIO_ITEM_NAME = "DropdownMenuRadioItem";
const $a51a7192f883dda1$export$e4f69b41b1637536 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...radioItemProps } = props;
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $82110f2367303f9b$export$371ab307eab489c0), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, menuScope, radioItemProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$e4f69b41b1637536, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$RADIO_ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuItemIndicator
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$INDICATOR_NAME = "DropdownMenuItemIndicator";
const $a51a7192f883dda1$export$42355ae145153fb6 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...itemIndicatorProps } = props;
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $82110f2367303f9b$export$c3468e2714d175fa), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, menuScope, itemIndicatorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$42355ae145153fb6, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$INDICATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuSeparator
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$SEPARATOR_NAME = "DropdownMenuSeparator";
const $a51a7192f883dda1$export$da160178fd3bc7e9 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...separatorProps } = props;
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $82110f2367303f9b$export$1ff3c3f08ae963c0), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, menuScope, separatorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$da160178fd3bc7e9, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$SEPARATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuArrow
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$ARROW_NAME = "DropdownMenuArrow";
const $a51a7192f883dda1$export$34b8980744021ec5 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...arrowProps } = props;
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $82110f2367303f9b$export$21b07c8f274aebd5), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, menuScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$34b8980744021ec5, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$ARROW_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuSub
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$export$2f307d81a64f5442 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, children: children, open: openProp, onOpenChange: onOpenChange, defaultOpen: defaultOpen } = props;
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    const [open = false, setOpen] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $82110f2367303f9b$export$d7a01e11500dfb6f), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, menuScope, {
        open: open,
        onOpenChange: setOpen
    }), children);
};
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuSubTrigger
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$SUB_TRIGGER_NAME = "DropdownMenuSubTrigger";
const $a51a7192f883dda1$export$21dcb7ec56f874cf = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...subTriggerProps } = props;
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $82110f2367303f9b$export$2ea8a7a591ac5eac), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, menuScope, subTriggerProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$21dcb7ec56f874cf, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$SUB_TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuSubContent
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$SUB_CONTENT_NAME = "DropdownMenuSubContent";
const $a51a7192f883dda1$export$f34ec8bc2482cc5f = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...subContentProps } = props;
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $82110f2367303f9b$export$6d4de93b380beddf), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, menuScope, subContentProps, {
        ref: forwardedRef,
        style: {
            ...props.style,
            "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
            "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
            "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
    }));
});
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$f34ec8bc2482cc5f, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$SUB_CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$export$be92b6f5f03c0fe9 = $a51a7192f883dda1$export$e44a253a59704894;
const $a51a7192f883dda1$export$41fb9f06171c75f4 = $a51a7192f883dda1$export$d2469213b3befba9;
const $a51a7192f883dda1$export$602eac185826482c = $a51a7192f883dda1$export$cd369b4d4d54efc9;
const $a51a7192f883dda1$export$7c6e2c02157bb7d2 = $a51a7192f883dda1$export$6e76d93a37c01248;
const $a51a7192f883dda1$export$eb2fcfdbd7ba97d4 = $a51a7192f883dda1$export$246bebaba3a2f70e;
const $a51a7192f883dda1$export$b04be29aa201d4f5 = $a51a7192f883dda1$export$76e48c5b57f24495;
const $a51a7192f883dda1$export$6d08773d2e66f8f2 = $a51a7192f883dda1$export$ed97964d1871885d;
const $a51a7192f883dda1$export$16ce288f89fa631c = $a51a7192f883dda1$export$53a69729da201fa9;
const $a51a7192f883dda1$export$a98f0dcb43a68a25 = $a51a7192f883dda1$export$3323ad73d55f587e;
const $a51a7192f883dda1$export$371ab307eab489c0 = $a51a7192f883dda1$export$e4f69b41b1637536;
const $a51a7192f883dda1$export$c3468e2714d175fa = $a51a7192f883dda1$export$42355ae145153fb6;
const $a51a7192f883dda1$export$1ff3c3f08ae963c0 = $a51a7192f883dda1$export$da160178fd3bc7e9;
const $a51a7192f883dda1$export$21b07c8f274aebd5 = $a51a7192f883dda1$export$34b8980744021ec5;
const $a51a7192f883dda1$export$d7a01e11500dfb6f = $a51a7192f883dda1$export$2f307d81a64f5442;
const $a51a7192f883dda1$export$2ea8a7a591ac5eac = $a51a7192f883dda1$export$21dcb7ec56f874cf;
const $a51a7192f883dda1$export$6d4de93b380beddf = $a51a7192f883dda1$export$f34ec8bc2482cc5f;


/**
 * @license lucide-react v0.381.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8240f8fcfc513968$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Check", [
    [
        "path",
        {
            d: "M20 6 9 17l-5-5",
            key: "1gmf2c"
        }
    ]
]);

/**
 * @license lucide-react v0.381.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7979593adeba180b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ChevronRight", [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
]);

/**
 * @license lucide-react v0.381.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $dc81eef52ef659a2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Circle", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ]
]);



const $ef278092739ac562$export$e44a253a59704894 = $a51a7192f883dda1$export$be92b6f5f03c0fe9;
const $ef278092739ac562$export$d2469213b3befba9 = $a51a7192f883dda1$export$41fb9f06171c75f4;
const $ef278092739ac562$export$246bebaba3a2f70e = $a51a7192f883dda1$export$eb2fcfdbd7ba97d4;
const $ef278092739ac562$export$cd369b4d4d54efc9 = $a51a7192f883dda1$export$602eac185826482c;
const $ef278092739ac562$export$2f307d81a64f5442 = $a51a7192f883dda1$export$d7a01e11500dfb6f;
const $ef278092739ac562$export$3323ad73d55f587e = $a51a7192f883dda1$export$a98f0dcb43a68a25;
const $ef278092739ac562$export$21dcb7ec56f874cf = /*#__PURE__*/ $acw62.forwardRef(({ className: className, inset: inset, children: children, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a51a7192f883dda1$export$2ea8a7a591ac5eac, {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-slate-100 data-[state=open]:bg-slate-100 dark:focus:bg-slate-800 dark:data-[state=open]:bg-slate-800", inset && "pl-8", className),
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                className: "ml-auto h-4 w-4"
            })
        ]
    }));
$ef278092739ac562$export$21dcb7ec56f874cf.displayName = $a51a7192f883dda1$export$2ea8a7a591ac5eac.displayName;
const $ef278092739ac562$export$f34ec8bc2482cc5f = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a51a7192f883dda1$export$6d4de93b380beddf, {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("z-50 min-w-[8rem] overflow-hidden rounded-md border border-slate-200 bg-white p-1 text-slate-950 shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 dark:border-slate-800 dark:bg-slate-950 dark:text-slate-50", className),
        ...props
    }));
$ef278092739ac562$export$f34ec8bc2482cc5f.displayName = $a51a7192f883dda1$export$6d4de93b380beddf.displayName;
const $ef278092739ac562$export$6e76d93a37c01248 = /*#__PURE__*/ $acw62.forwardRef(({ className: className, sideOffset: sideOffset = 4, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a51a7192f883dda1$export$602eac185826482c, {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a51a7192f883dda1$export$7c6e2c02157bb7d2, {
            ref: ref,
            sideOffset: sideOffset,
            className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("z-50 min-w-[8rem] overflow-hidden rounded-md border border-slate-200 bg-white p-1 text-slate-950 shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 dark:border-slate-800 dark:bg-slate-950 dark:text-slate-50", className),
            ...props
        })
    }));
$ef278092739ac562$export$6e76d93a37c01248.displayName = $a51a7192f883dda1$export$7c6e2c02157bb7d2.displayName;
const $ef278092739ac562$export$ed97964d1871885d = /*#__PURE__*/ $acw62.forwardRef(({ className: className, inset: inset, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a51a7192f883dda1$export$6d08773d2e66f8f2, {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-slate-100 focus:text-slate-900 data-[disabled]:pointer-events-none data-[disabled]:opacity-50 dark:focus:bg-slate-800 dark:focus:text-slate-50", inset && "pl-8", className),
        ...props
    }));
$ef278092739ac562$export$ed97964d1871885d.displayName = $a51a7192f883dda1$export$6d08773d2e66f8f2.displayName;
const $ef278092739ac562$export$53a69729da201fa9 = /*#__PURE__*/ $acw62.forwardRef(({ className: className, children: children, checked: checked, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a51a7192f883dda1$export$16ce288f89fa631c, {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-slate-100 focus:text-slate-900 data-[disabled]:pointer-events-none data-[disabled]:opacity-50 dark:focus:bg-slate-800 dark:focus:text-slate-50", className),
        checked: checked,
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a51a7192f883dda1$export$c3468e2714d175fa, {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                        className: "h-4 w-4"
                    })
                })
            }),
            children
        ]
    }));
$ef278092739ac562$export$53a69729da201fa9.displayName = $a51a7192f883dda1$export$16ce288f89fa631c.displayName;
const $ef278092739ac562$export$e4f69b41b1637536 = /*#__PURE__*/ $acw62.forwardRef(({ className: className, children: children, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a51a7192f883dda1$export$371ab307eab489c0, {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-slate-100 focus:text-slate-900 data-[disabled]:pointer-events-none data-[disabled]:opacity-50 dark:focus:bg-slate-800 dark:focus:text-slate-50", className),
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a51a7192f883dda1$export$c3468e2714d175fa, {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc81eef52ef659a2$export$2e2bcd8739ae039), {
                        className: "h-2 w-2 fill-current"
                    })
                })
            }),
            children
        ]
    }));
$ef278092739ac562$export$e4f69b41b1637536.displayName = $a51a7192f883dda1$export$371ab307eab489c0.displayName;
const $ef278092739ac562$export$76e48c5b57f24495 = /*#__PURE__*/ $acw62.forwardRef(({ className: className, inset: inset, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a51a7192f883dda1$export$b04be29aa201d4f5, {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("px-2 py-1.5 text-sm font-semibold", inset && "pl-8", className),
        ...props
    }));
$ef278092739ac562$export$76e48c5b57f24495.displayName = $a51a7192f883dda1$export$b04be29aa201d4f5.displayName;
const $ef278092739ac562$export$da160178fd3bc7e9 = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a51a7192f883dda1$export$1ff3c3f08ae963c0, {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("-mx-1 my-1 h-px bg-slate-100 dark:bg-slate-800", className),
        ...props
    }));
$ef278092739ac562$export$da160178fd3bc7e9.displayName = $a51a7192f883dda1$export$1ff3c3f08ae963c0.displayName;
const $ef278092739ac562$export$b1e098e2962e8df5 = ({ className: className, ...props })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("ml-auto text-xs tracking-widest opacity-60", className),
        ...props
    });
};
$ef278092739ac562$export$b1e098e2962e8df5.displayName = "DropdownMenuShortcut";




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// packages/core/primitive/src/primitive.tsx
function $08b341c58095659f$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}


// packages/react/compose-refs/src/composeRefs.tsx

var $acw62 = parcelRequire("acw62");
function $a7154ff77d502c57$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $a7154ff77d502c57$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$a7154ff77d502c57$var$setRef(ref, node));
}
function $a7154ff77d502c57$export$c7b2cbe3552a0d05(...refs) {
    return $acw62.useCallback($a7154ff77d502c57$export$43e446d32b3d21af(...refs), refs);
}


// packages/react/context/src/createContext.tsx

var $acw62 = parcelRequire("acw62");

function $060ada451d2b7522$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $acw62.createContext(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props;
        const value = $acw62.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    }
    function useContext2(consumerName) {
        const context = $acw62.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext2
    ];
}
function $060ada451d2b7522$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $acw62.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName][index] || BaseContext;
            const value = $acw62.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        }
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName][index] || BaseContext;
            const context = $acw62.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $acw62.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $acw62.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $060ada451d2b7522$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $060ada451d2b7522$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $acw62.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}


// packages/react/id/src/id.tsx

var $acw62 = parcelRequire("acw62");
// packages/react/use-layout-effect/src/useLayoutEffect.tsx

var $acw62 = parcelRequire("acw62");
var $61e42f7af0168837$export$e5c5a5f917a5871c = Boolean(globalThis?.document) ? $acw62.useLayoutEffect : ()=>{};


var $e07951b5c21df8c1$var$useReactId = $acw62["useId".toString()] || (()=>void 0);
var $e07951b5c21df8c1$var$count = 0;
function $e07951b5c21df8c1$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $acw62.useState($e07951b5c21df8c1$var$useReactId());
    (0, $61e42f7af0168837$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId ?? String($e07951b5c21df8c1$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}


// packages/react/use-controllable-state/src/useControllableState.tsx

var $acw62 = parcelRequire("acw62");
// packages/react/use-callback-ref/src/useCallbackRef.tsx

var $acw62 = parcelRequire("acw62");
function $b2875c6558029792$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $acw62.useRef(callback);
    $acw62.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $acw62.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}


function $cf6c8262ce26f2a3$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $cf6c8262ce26f2a3$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $b2875c6558029792$export$25bec8c6f54ee79a)(onChange);
    const setValue = $acw62.useCallback((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value2 = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value2 !== prop) handleChange(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value,
        setValue
    ];
}
function $cf6c8262ce26f2a3$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = $acw62.useState(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = $acw62.useRef(value);
    const handleChange = (0, $b2875c6558029792$export$25bec8c6f54ee79a)(onChange);
    $acw62.useEffect(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}



var $acw62 = parcelRequire("acw62");

// packages/react/primitive/src/Primitive.tsx

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
// packages/react/slot/src/Slot.tsx

var $acw62 = parcelRequire("acw62");


var $3b9695b73ca006f6$export$8c6ed5c666ac1360 = $acw62.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = $acw62.Children.toArray(children);
    const slottable = childrenArray.find($3b9695b73ca006f6$var$isSlottable);
    if (slottable) {
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                if ($acw62.Children.count(newElement) > 1) return $acw62.Children.only(null);
                return $acw62.isValidElement(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($3b9695b73ca006f6$var$SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: $acw62.isValidElement(newElement) ? $acw62.cloneElement(newElement, void 0, newChildren) : null
        });
    }
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($3b9695b73ca006f6$var$SlotClone, {
        ...slotProps,
        ref: forwardedRef,
        children: children
    });
});
$3b9695b73ca006f6$export$8c6ed5c666ac1360.displayName = "Slot";
var $3b9695b73ca006f6$var$SlotClone = $acw62.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if ($acw62.isValidElement(children)) {
        const childrenRef = $3b9695b73ca006f6$var$getElementRef(children);
        return $acw62.cloneElement(children, {
            ...$3b9695b73ca006f6$var$mergeProps(slotProps, children.props),
            // @ts-ignore
            ref: forwardedRef ? (0, $a7154ff77d502c57$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef
        });
    }
    return $acw62.Children.count(children) > 1 ? $acw62.Children.only(null) : null;
});
$3b9695b73ca006f6$var$SlotClone.displayName = "SlotClone";
var $3b9695b73ca006f6$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
};
function $3b9695b73ca006f6$var$isSlottable(child) {
    return $acw62.isValidElement(child) && child.type === $3b9695b73ca006f6$export$d9f1ccf0bdb05d45;
}
function $3b9695b73ca006f6$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $3b9695b73ca006f6$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $3b9695b73ca006f6$export$be92b6f5f03c0fe9 = $3b9695b73ca006f6$export$8c6ed5c666ac1360;



var $0c579cd7a6758c8c$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
];
var $0c579cd7a6758c8c$export$250ffa63cdc0d034 = $0c579cd7a6758c8c$var$NODES.reduce((primitive, node)=>{
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $3b9695b73ca006f6$export$8c6ed5c666ac1360) : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $0c579cd7a6758c8c$export$6d1a0317bde7de7f(target, event) {
    if (target) $1u0KT.flushSync(()=>target.dispatchEvent(event));
}
var $0c579cd7a6758c8c$export$be92b6f5f03c0fe9 = $0c579cd7a6758c8c$export$250ffa63cdc0d034;




// packages/react/use-escape-keydown/src/useEscapeKeydown.tsx

var $acw62 = parcelRequire("acw62");

function $0417401b421093cf$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis?.document) {
    const onEscapeKeyDown = (0, $b2875c6558029792$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    $acw62.useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}



"use client";
var $dbcf3fbcc905eaed$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
var $dbcf3fbcc905eaed$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $dbcf3fbcc905eaed$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $dbcf3fbcc905eaed$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $dbcf3fbcc905eaed$var$originalBodyPointerEvents;
var $dbcf3fbcc905eaed$var$DismissableLayerContext = $acw62.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set()
});
var $dbcf3fbcc905eaed$export$177fb62ff3ec1f22 = $acw62.forwardRef((props, forwardedRef)=>{
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = $acw62.useContext($dbcf3fbcc905eaed$var$DismissableLayerContext);
    const [node, setNode] = $acw62.useState(null);
    const ownerDocument = node?.ownerDocument ?? globalThis?.document;
    const [, force] = $acw62.useState({});
    const composedRefs = (0, $a7154ff77d502c57$export$c7b2cbe3552a0d05)(forwardedRef, (node2)=>setNode(node2));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $dbcf3fbcc905eaed$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    const focusOutside = $dbcf3fbcc905eaed$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    (0, $0417401b421093cf$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown?.(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    $acw62.useEffect(()=>{
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $dbcf3fbcc905eaed$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        $dbcf3fbcc905eaed$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $dbcf3fbcc905eaed$var$originalBodyPointerEvents;
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            if (!node) return;
            context.layers.delete(node);
            context.layersWithOutsidePointerEventsDisabled.delete(node);
            $dbcf3fbcc905eaed$var$dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    $acw62.useEffect(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($dbcf3fbcc905eaed$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($dbcf3fbcc905eaed$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0c579cd7a6758c8c$export$250ffa63cdc0d034).div, {
        ...layerProps,
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
            ...props.style
        },
        onFocusCapture: (0, $08b341c58095659f$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $08b341c58095659f$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $08b341c58095659f$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    });
});
$dbcf3fbcc905eaed$export$177fb62ff3ec1f22.displayName = $dbcf3fbcc905eaed$var$DISMISSABLE_LAYER_NAME;
var $dbcf3fbcc905eaed$var$BRANCH_NAME = "DismissableLayerBranch";
var $dbcf3fbcc905eaed$export$4d5eb2109db14228 = $acw62.forwardRef((props, forwardedRef)=>{
    const context = $acw62.useContext($dbcf3fbcc905eaed$var$DismissableLayerContext);
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $a7154ff77d502c57$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $acw62.useEffect(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0c579cd7a6758c8c$export$250ffa63cdc0d034).div, {
        ...props,
        ref: composedRefs
    });
});
$dbcf3fbcc905eaed$export$4d5eb2109db14228.displayName = $dbcf3fbcc905eaed$var$BRANCH_NAME;
function $dbcf3fbcc905eaed$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis?.document) {
    const handlePointerDownOutside = (0, $b2875c6558029792$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = $acw62.useRef(false);
    const handleClickRef = $acw62.useRef(()=>{});
    $acw62.useEffect(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                let handleAndDispatchPointerDownOutsideEvent2 = function() {
                    $dbcf3fbcc905eaed$var$handleAndDispatchCustomEvent($dbcf3fbcc905eaed$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
                const eventDetail = {
                    originalEvent: event
                };
                if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent2();
            } else ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
function $dbcf3fbcc905eaed$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis?.document) {
    const handleFocusOutside = (0, $b2875c6558029792$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $dbcf3fbcc905eaed$var$handleAndDispatchCustomEvent($dbcf3fbcc905eaed$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $dbcf3fbcc905eaed$var$dispatchUpdate() {
    const event = new CustomEvent($dbcf3fbcc905eaed$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $dbcf3fbcc905eaed$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $0c579cd7a6758c8c$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
var $dbcf3fbcc905eaed$export$be92b6f5f03c0fe9 = $dbcf3fbcc905eaed$export$177fb62ff3ec1f22;
var $dbcf3fbcc905eaed$export$aecb2ddcb55c95be = $dbcf3fbcc905eaed$export$4d5eb2109db14228;



var $acw62 = parcelRequire("acw62");




"use client";
var $ba30e6cf05ed76d1$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var $ba30e6cf05ed76d1$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var $ba30e6cf05ed76d1$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $ba30e6cf05ed76d1$var$FOCUS_SCOPE_NAME = "FocusScope";
var $ba30e6cf05ed76d1$export$20e40289641fbbb6 = $acw62.forwardRef((props, forwardedRef)=>{
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container, setContainer] = $acw62.useState(null);
    const onMountAutoFocus = (0, $b2875c6558029792$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $b2875c6558029792$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = $acw62.useRef(null);
    const composedRefs = (0, $a7154ff77d502c57$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = $acw62.useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current;
    $acw62.useEffect(()=>{
        if (trapped) {
            let handleFocusIn2 = function(event) {
                if (focusScope.paused || !container) return;
                const target = event.target;
                if (container.contains(target)) lastFocusedElementRef.current = target;
                else $ba30e6cf05ed76d1$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleFocusOut2 = function(event) {
                if (focusScope.paused || !container) return;
                const relatedTarget = event.relatedTarget;
                if (relatedTarget === null) return;
                if (!container.contains(relatedTarget)) $ba30e6cf05ed76d1$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleMutations2 = function(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $ba30e6cf05ed76d1$var$focus(container);
            };
            var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
            document.addEventListener("focusin", handleFocusIn2);
            document.addEventListener("focusout", handleFocusOut2);
            const mutationObserver = new MutationObserver(handleMutations2);
            if (container) mutationObserver.observe(container, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn2);
                document.removeEventListener("focusout", handleFocusOut2);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container,
        focusScope.paused
    ]);
    $acw62.useEffect(()=>{
        if (container) {
            $ba30e6cf05ed76d1$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($ba30e6cf05ed76d1$var$AUTOFOCUS_ON_MOUNT, $ba30e6cf05ed76d1$var$EVENT_OPTIONS);
                container.addEventListener($ba30e6cf05ed76d1$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $ba30e6cf05ed76d1$var$focusFirst($ba30e6cf05ed76d1$var$removeLinks($ba30e6cf05ed76d1$var$getTabbableCandidates(container)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $ba30e6cf05ed76d1$var$focus(container);
                }
            }
            return ()=>{
                container.removeEventListener($ba30e6cf05ed76d1$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($ba30e6cf05ed76d1$var$AUTOFOCUS_ON_UNMOUNT, $ba30e6cf05ed76d1$var$EVENT_OPTIONS);
                    container.addEventListener($ba30e6cf05ed76d1$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $ba30e6cf05ed76d1$var$focus(previouslyFocusedElement ?? document.body, {
                        select: true
                    });
                    container.removeEventListener($ba30e6cf05ed76d1$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $ba30e6cf05ed76d1$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]);
    const handleKeyDown = $acw62.useCallback((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container2 = event.currentTarget;
            const [first, last] = $ba30e6cf05ed76d1$var$getTabbableEdges(container2);
            const hasTabbableElementsInside = first && last;
            if (!hasTabbableElementsInside) {
                if (focusedElement === container2) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $ba30e6cf05ed76d1$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $ba30e6cf05ed76d1$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0c579cd7a6758c8c$export$250ffa63cdc0d034).div, {
        tabIndex: -1,
        ...scopeProps,
        ref: composedRefs,
        onKeyDown: handleKeyDown
    });
});
$ba30e6cf05ed76d1$export$20e40289641fbbb6.displayName = $ba30e6cf05ed76d1$var$FOCUS_SCOPE_NAME;
function $ba30e6cf05ed76d1$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $ba30e6cf05ed76d1$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
function $ba30e6cf05ed76d1$var$getTabbableEdges(container) {
    const candidates = $ba30e6cf05ed76d1$var$getTabbableCandidates(container);
    const first = $ba30e6cf05ed76d1$var$findVisible(candidates, container);
    const last = $ba30e6cf05ed76d1$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
function $ba30e6cf05ed76d1$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
function $ba30e6cf05ed76d1$var$findVisible(elements, container) {
    for (const element of elements){
        if (!$ba30e6cf05ed76d1$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $ba30e6cf05ed76d1$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        if (upTo !== void 0 && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $ba30e6cf05ed76d1$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $ba30e6cf05ed76d1$var$focus(element, { select: select = false } = {}) {
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement;
        element.focus({
            preventScroll: true
        });
        if (element !== previouslyFocusedElement && $ba30e6cf05ed76d1$var$isSelectableInput(element) && select) element.select();
    }
}
var $ba30e6cf05ed76d1$var$focusScopesStack = $ba30e6cf05ed76d1$var$createFocusScopesStack();
function $ba30e6cf05ed76d1$var$createFocusScopesStack() {
    let stack = [];
    return {
        add (focusScope) {
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope?.pause();
            stack = $ba30e6cf05ed76d1$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            stack = $ba30e6cf05ed76d1$var$arrayRemove(stack, focusScope);
            stack[0]?.resume();
        }
    };
}
function $ba30e6cf05ed76d1$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $ba30e6cf05ed76d1$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
var $ba30e6cf05ed76d1$export$be92b6f5f03c0fe9 = $ba30e6cf05ed76d1$export$20e40289641fbbb6;



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");



"use client";
var $ebfd083b0ba34c8b$var$PORTAL_NAME = "Portal";
var $ebfd083b0ba34c8b$export$602eac185826482c = $acw62.forwardRef((props, forwardedRef)=>{
    const { container: containerProp, ...portalProps } = props;
    const [mounted, setMounted] = $acw62.useState(false);
    (0, $61e42f7af0168837$export$e5c5a5f917a5871c)(()=>setMounted(true), []);
    const container = containerProp || mounted && globalThis?.document?.body;
    return container ? (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0c579cd7a6758c8c$export$250ffa63cdc0d034).div, {
        ...portalProps,
        ref: forwardedRef
    }), container) : null;
});
$ebfd083b0ba34c8b$export$602eac185826482c.displayName = $ebfd083b0ba34c8b$var$PORTAL_NAME;
var $ebfd083b0ba34c8b$export$be92b6f5f03c0fe9 = $ebfd083b0ba34c8b$export$602eac185826482c;



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


"use client";
function $99c767be9c428111$var$useStateMachine(initialState, machine) {
    return $acw62.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
// packages/react/presence/src/Presence.tsx
var $99c767be9c428111$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $99c767be9c428111$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $acw62.Children.only(children);
    const ref = (0, $a7154ff77d502c57$export$c7b2cbe3552a0d05)(presence.ref, $99c767be9c428111$var$getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $acw62.cloneElement(child, {
        ref: ref
    }) : null;
};
$99c767be9c428111$export$99c2b779aa4e8b8b.displayName = "Presence";
function $99c767be9c428111$var$usePresence(present) {
    const [node, setNode] = $acw62.useState();
    const stylesRef = $acw62.useRef({});
    const prevPresentRef = $acw62.useRef(present);
    const prevAnimationNameRef = $acw62.useRef("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $99c767be9c428111$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    $acw62.useEffect(()=>{
        const currentAnimationName = $99c767be9c428111$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $61e42f7af0168837$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $99c767be9c428111$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || styles?.display === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $61e42f7af0168837$export$e5c5a5f917a5871c)(()=>{
        if (node) {
            const handleAnimationEnd = (event)=>{
                const currentAnimationName = $99c767be9c428111$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node && isCurrentAnimation) $1u0KT.flushSync(()=>send("ANIMATION_END"));
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node) prevAnimationNameRef.current = $99c767be9c428111$var$getAnimationName(stylesRef.current);
            };
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $acw62.useCallback((node2)=>{
            if (node2) stylesRef.current = getComputedStyle(node2);
            setNode(node2);
        }, [])
    };
}
function $99c767be9c428111$var$getAnimationName(styles) {
    return styles?.animationName || "none";
}
function $99c767be9c428111$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}




var $acw62 = parcelRequire("acw62");
"use client";
var $91b601f79870bd1a$var$count = 0;
function $91b601f79870bd1a$export$ac5b58043b79449b(props) {
    $91b601f79870bd1a$export$b7ece24a22aeda8c();
    return props.children;
}
function $91b601f79870bd1a$export$b7ece24a22aeda8c() {
    $acw62.useEffect(()=>{
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", edgeGuards[0] ?? $91b601f79870bd1a$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", edgeGuards[1] ?? $91b601f79870bd1a$var$createFocusGuard());
        $91b601f79870bd1a$var$count++;
        return ()=>{
            if ($91b601f79870bd1a$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $91b601f79870bd1a$var$count--;
        };
    }, []);
}
function $91b601f79870bd1a$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none";
    return element;
}
var $91b601f79870bd1a$export$be92b6f5f03c0fe9 = $91b601f79870bd1a$export$ac5b58043b79449b;




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



var $372a0cf9070b9222$export$e27363444bedfeac = (0, $dce67a1050af61cf$export$e13ec7dd7a14088d)();


var $99980e39e08ede4c$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $99980e39e08ede4c$export$22940b497e769dee = $acw62.forwardRef(function(props, parentRef) {
    var ref = $acw62.useRef(null);
    var _a = $acw62.useState({
        onScrollCapture: $99980e39e08ede4c$var$nothing,
        onWheelCapture: $99980e39e08ede4c$var$nothing,
        onTouchMoveCapture: $99980e39e08ede4c$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, gapMode = props.gapMode, rest = (0, $a0acfd416da73b8a$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $1ec01e2201501f3d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, rest), callbacks);
    return $acw62.createElement($acw62.Fragment, null, enabled && $acw62.createElement(SideCar, {
        sideCar: (0, $372a0cf9070b9222$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $acw62.cloneElement($acw62.Children.only(children), (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $acw62.createElement(Container, (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$99980e39e08ede4c$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$99980e39e08ede4c$export$22940b497e769dee.classNames = {
    fullWidth: (0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e),
    zeroRight: (0, $3f8d56f1a38c65c8$export$1da7500147d4bc3)
};





var $acw62 = parcelRequire("acw62");


var $12da545315d00cee$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $12da545315d00cee$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $12da545315d00cee$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $12da545315d00cee$var$options, $12da545315d00cee$var$options);
    // @ts-ignore
    window.removeEventListener("test", $12da545315d00cee$var$options, $12da545315d00cee$var$options);
} catch (err) {
    $12da545315d00cee$var$passiveSupported = false;
}
var $12da545315d00cee$export$10a6e88623fa9454 = $12da545315d00cee$var$passiveSupported ? {
    passive: false
} : false;


var $cc07fc4d7f20a29a$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $cc07fc4d7f20a29a$var$elementCanBeScrolled = function(node, overflow) {
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$cc07fc4d7f20a29a$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $cc07fc4d7f20a29a$var$elementCouldBeVScrolled = function(node) {
    return $cc07fc4d7f20a29a$var$elementCanBeScrolled(node, "overflowY");
};
var $cc07fc4d7f20a29a$var$elementCouldBeHScrolled = function(node) {
    return $cc07fc4d7f20a29a$var$elementCanBeScrolled(node, "overflowX");
};
var $cc07fc4d7f20a29a$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $cc07fc4d7f20a29a$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $cc07fc4d7f20a29a$var$getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $cc07fc4d7f20a29a$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $cc07fc4d7f20a29a$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $cc07fc4d7f20a29a$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $cc07fc4d7f20a29a$var$elementCouldBeVScrolled(node) : $cc07fc4d7f20a29a$var$elementCouldBeHScrolled(node);
};
var $cc07fc4d7f20a29a$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $cc07fc4d7f20a29a$var$getVScrollVariables(node) : $cc07fc4d7f20a29a$var$getHScrollVariables(node);
};
var $cc07fc4d7f20a29a$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $cc07fc4d7f20a29a$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $cc07fc4d7f20a29a$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $cc07fc4d7f20a29a$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($cc07fc4d7f20a29a$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        if (target instanceof ShadowRoot) target = target.host;
        else target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $ac64a7880471a2fa$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $ac64a7880471a2fa$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $ac64a7880471a2fa$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $ac64a7880471a2fa$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $ac64a7880471a2fa$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $ac64a7880471a2fa$var$idCounter = 0;
var $ac64a7880471a2fa$var$lockStack = [];
function $ac64a7880471a2fa$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $acw62.useRef([]);
    var touchStartRef = $acw62.useRef([
        0,
        0
    ]);
    var activeAxis = $acw62.useRef();
    var id = $acw62.useState($ac64a7880471a2fa$var$idCounter++)[0];
    var Style = $acw62.useState((0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8))[0];
    var lastProps = $acw62.useRef(props);
    $acw62.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $acw62.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($ac64a7880471a2fa$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $acw62.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2) return !lastProps.current.allowPinchZoom;
        var touch = $ac64a7880471a2fa$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $cc07fc4d7f20a29a$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $cc07fc4d7f20a29a$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $cc07fc4d7f20a29a$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $acw62.useCallback(function(_event) {
        var event = _event;
        if (!$ac64a7880471a2fa$var$lockStack.length || $ac64a7880471a2fa$var$lockStack[$ac64a7880471a2fa$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $ac64a7880471a2fa$export$39efaa2ca254a28d(event) : $ac64a7880471a2fa$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $ac64a7880471a2fa$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($ac64a7880471a2fa$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $acw62.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $ac64a7880471a2fa$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $acw62.useCallback(function(event) {
        touchStartRef.current = $ac64a7880471a2fa$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $ac64a7880471a2fa$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $ac64a7880471a2fa$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $acw62.useEffect(function() {
        $ac64a7880471a2fa$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $12da545315d00cee$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $12da545315d00cee$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $12da545315d00cee$export$10a6e88623fa9454));
        return function() {
            $ac64a7880471a2fa$var$lockStack = $ac64a7880471a2fa$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $12da545315d00cee$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $12da545315d00cee$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $12da545315d00cee$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $acw62.createElement($acw62.Fragment, null, inert ? $acw62.createElement(Style, {
        styles: $ac64a7880471a2fa$var$generateStyle(id)
    }) : null, removeScrollBar ? $acw62.createElement((0, $9f2b7a700f678519$export$9aa43b459c5ae9b9), {
        gapMode: props.gapMode
    }) : null);
}
function $ac64a7880471a2fa$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}



var $b3892212cec7c182$export$2e2bcd8739ae039 = (0, $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce)((0, $372a0cf9070b9222$export$e27363444bedfeac), (0, $ac64a7880471a2fa$export$a09dbff87b5da2d));


var $6defd2e83b0b8fba$var$ReactRemoveScroll = $acw62.forwardRef(function(props, ref) {
    return $acw62.createElement((0, $99980e39e08ede4c$export$22940b497e769dee), (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $b3892212cec7c182$export$2e2bcd8739ae039)
    }));
});
$6defd2e83b0b8fba$var$ReactRemoveScroll.classNames = (0, $99980e39e08ede4c$export$22940b497e769dee).classNames;
var $6defd2e83b0b8fba$export$2e2bcd8739ae039 = $6defd2e83b0b8fba$var$ReactRemoveScroll;





"use client";
var $eeaeb48e23f662e7$var$DIALOG_NAME = "Dialog";
var [$eeaeb48e23f662e7$var$createDialogContext, $eeaeb48e23f662e7$export$cc702773b8ea3e41] = (0, $060ada451d2b7522$export$50c7b4e9d9f19c1)($eeaeb48e23f662e7$var$DIALOG_NAME);
var [$eeaeb48e23f662e7$var$DialogProvider, $eeaeb48e23f662e7$var$useDialogContext] = $eeaeb48e23f662e7$var$createDialogContext($eeaeb48e23f662e7$var$DIALOG_NAME);
var $eeaeb48e23f662e7$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const triggerRef = $acw62.useRef(null);
    const contentRef = $acw62.useRef(null);
    const [open = false, setOpen] = (0, $cf6c8262ce26f2a3$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $e07951b5c21df8c1$export$f680877a34711e37)(),
        titleId: (0, $e07951b5c21df8c1$export$f680877a34711e37)(),
        descriptionId: (0, $e07951b5c21df8c1$export$f680877a34711e37)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: $acw62.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal,
        children: children
    });
};
$eeaeb48e23f662e7$export$3ddf2d174ce01153.displayName = $eeaeb48e23f662e7$var$DIALOG_NAME;
var $eeaeb48e23f662e7$var$TRIGGER_NAME = "DialogTrigger";
var $eeaeb48e23f662e7$export$2e1e1122cf0cba88 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...triggerProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $a7154ff77d502c57$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0c579cd7a6758c8c$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $eeaeb48e23f662e7$var$getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, $08b341c58095659f$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    });
});
$eeaeb48e23f662e7$export$2e1e1122cf0cba88.displayName = $eeaeb48e23f662e7$var$TRIGGER_NAME;
var $eeaeb48e23f662e7$var$PORTAL_NAME = "DialogPortal";
var [$eeaeb48e23f662e7$var$PortalProvider, $eeaeb48e23f662e7$var$usePortalContext] = $eeaeb48e23f662e7$var$createDialogContext($eeaeb48e23f662e7$var$PORTAL_NAME, {
    forceMount: void 0
});
var $eeaeb48e23f662e7$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog, forceMount: forceMount, children: children, container: container } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$PORTAL_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount,
        children: $acw62.Children.map(children, (child)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $99c767be9c428111$export$99c2b779aa4e8b8b), {
                present: forceMount || context.open,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $ebfd083b0ba34c8b$export$602eac185826482c), {
                    asChild: true,
                    container: container,
                    children: child
                })
            }))
    });
};
$eeaeb48e23f662e7$export$dad7c95542bacce0.displayName = $eeaeb48e23f662e7$var$PORTAL_NAME;
var $eeaeb48e23f662e7$var$OVERLAY_NAME = "DialogOverlay";
var $eeaeb48e23f662e7$export$bd1d06c79be19e17 = $acw62.forwardRef((props, forwardedRef)=>{
    const portalContext = $eeaeb48e23f662e7$var$usePortalContext($eeaeb48e23f662e7$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...overlayProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $99c767be9c428111$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogOverlayImpl, {
            ...overlayProps,
            ref: forwardedRef
        })
    }) : null;
});
$eeaeb48e23f662e7$export$bd1d06c79be19e17.displayName = $eeaeb48e23f662e7$var$OVERLAY_NAME;
var $eeaeb48e23f662e7$var$DialogOverlayImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...overlayProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$OVERLAY_NAME, __scopeDialog);
    return(// Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $6defd2e83b0b8fba$export$2e2bcd8739ae039), {
        as: (0, $3b9695b73ca006f6$export$8c6ed5c666ac1360),
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ],
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0c579cd7a6758c8c$export$250ffa63cdc0d034).div, {
            "data-state": $eeaeb48e23f662e7$var$getState(context.open),
            ...overlayProps,
            ref: forwardedRef,
            style: {
                pointerEvents: "auto",
                ...overlayProps.style
            }
        })
    }));
});
var $eeaeb48e23f662e7$var$CONTENT_NAME = "DialogContent";
var $eeaeb48e23f662e7$export$b6d9565de1e068cf = $acw62.forwardRef((props, forwardedRef)=>{
    const portalContext = $eeaeb48e23f662e7$var$usePortalContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $99c767be9c428111$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
});
$eeaeb48e23f662e7$export$b6d9565de1e068cf.displayName = $eeaeb48e23f662e7$var$CONTENT_NAME;
var $eeaeb48e23f662e7$var$DialogContentModal = $acw62.forwardRef((props, forwardedRef)=>{
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = $acw62.useRef(null);
    const composedRefs = (0, $a7154ff77d502c57$export$c7b2cbe3552a0d05)(forwardedRef, context.contentRef, contentRef);
    $acw62.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, $4a7537e072260c10$export$6e33d16126ed003c)(content);
    }, []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogContentImpl, {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $08b341c58095659f$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            event.preventDefault();
            context.triggerRef.current?.focus();
        }),
        onPointerDownOutside: (0, $08b341c58095659f$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (isRightClick) event.preventDefault();
        }),
        onFocusOutside: (0, $08b341c58095659f$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault())
    });
});
var $eeaeb48e23f662e7$var$DialogContentNonModal = $acw62.forwardRef((props, forwardedRef)=>{
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = $acw62.useRef(false);
    const hasPointerDownOutsideRef = $acw62.useRef(false);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            props.onCloseAutoFocus?.(event);
            if (!event.defaultPrevented) {
                if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            props.onInteractOutside?.(event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = context.triggerRef.current?.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
});
var $eeaeb48e23f662e7$var$DialogContentImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, ...contentProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, __scopeDialog);
    const contentRef = $acw62.useRef(null);
    const composedRefs = (0, $a7154ff77d502c57$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    (0, $91b601f79870bd1a$export$b7ece24a22aeda8c)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $ba30e6cf05ed76d1$export$20e40289641fbbb6), {
                asChild: true,
                loop: true,
                trapped: trapFocus,
                onMountAutoFocus: onOpenAutoFocus,
                onUnmountAutoFocus: onCloseAutoFocus,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dbcf3fbcc905eaed$export$177fb62ff3ec1f22), {
                    role: "dialog",
                    id: context.contentId,
                    "aria-describedby": context.descriptionId,
                    "aria-labelledby": context.titleId,
                    "data-state": $eeaeb48e23f662e7$var$getState(context.open),
                    ...contentProps,
                    ref: composedRefs,
                    onDismiss: ()=>context.onOpenChange(false)
                })
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$TitleWarning, {
                        titleId: context.titleId
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DescriptionWarning, {
                        contentRef: contentRef,
                        descriptionId: context.descriptionId
                    })
                ]
            })
        ]
    });
});
var $eeaeb48e23f662e7$var$TITLE_NAME = "DialogTitle";
var $eeaeb48e23f662e7$export$16f7638e4a34b909 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...titleProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$TITLE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0c579cd7a6758c8c$export$250ffa63cdc0d034).h2, {
        id: context.titleId,
        ...titleProps,
        ref: forwardedRef
    });
});
$eeaeb48e23f662e7$export$16f7638e4a34b909.displayName = $eeaeb48e23f662e7$var$TITLE_NAME;
var $eeaeb48e23f662e7$var$DESCRIPTION_NAME = "DialogDescription";
var $eeaeb48e23f662e7$export$94e94c2ec2c954d5 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...descriptionProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$DESCRIPTION_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0c579cd7a6758c8c$export$250ffa63cdc0d034).p, {
        id: context.descriptionId,
        ...descriptionProps,
        ref: forwardedRef
    });
});
$eeaeb48e23f662e7$export$94e94c2ec2c954d5.displayName = $eeaeb48e23f662e7$var$DESCRIPTION_NAME;
var $eeaeb48e23f662e7$var$CLOSE_NAME = "DialogClose";
var $eeaeb48e23f662e7$export$fba2fb7cd781b7ac = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...closeProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CLOSE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0c579cd7a6758c8c$export$250ffa63cdc0d034).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, $08b341c58095659f$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    });
});
$eeaeb48e23f662e7$export$fba2fb7cd781b7ac.displayName = $eeaeb48e23f662e7$var$CLOSE_NAME;
function $eeaeb48e23f662e7$var$getState(open) {
    return open ? "open" : "closed";
}
var $eeaeb48e23f662e7$var$TITLE_WARNING_NAME = "DialogTitleWarning";
var [$eeaeb48e23f662e7$export$69b62a49393917d6, $eeaeb48e23f662e7$var$useWarningContext] = (0, $060ada451d2b7522$export$fd42f52fd3ae1109)($eeaeb48e23f662e7$var$TITLE_WARNING_NAME, {
    contentName: $eeaeb48e23f662e7$var$CONTENT_NAME,
    titleName: $eeaeb48e23f662e7$var$TITLE_NAME,
    docsSlug: "dialog"
});
var $eeaeb48e23f662e7$var$TitleWarning = ({ titleId: titleId })=>{
    const titleWarningContext = $eeaeb48e23f662e7$var$useWarningContext($eeaeb48e23f662e7$var$TITLE_WARNING_NAME);
    const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
    $acw62.useEffect(()=>{
        if (titleId) {
            const hasTitle = document.getElementById(titleId);
            if (!hasTitle) console.error(MESSAGE);
        }
    }, [
        MESSAGE,
        titleId
    ]);
    return null;
};
var $eeaeb48e23f662e7$var$DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning";
var $eeaeb48e23f662e7$var$DescriptionWarning = ({ contentRef: contentRef, descriptionId: descriptionId })=>{
    const descriptionWarningContext = $eeaeb48e23f662e7$var$useWarningContext($eeaeb48e23f662e7$var$DESCRIPTION_WARNING_NAME);
    const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
    $acw62.useEffect(()=>{
        const describedById = contentRef.current?.getAttribute("aria-describedby");
        if (descriptionId && describedById) {
            const hasDescription = document.getElementById(descriptionId);
            if (!hasDescription) console.warn(MESSAGE);
        }
    }, [
        MESSAGE,
        contentRef,
        descriptionId
    ]);
    return null;
};
var $eeaeb48e23f662e7$export$be92b6f5f03c0fe9 = $eeaeb48e23f662e7$export$3ddf2d174ce01153;
var $eeaeb48e23f662e7$export$41fb9f06171c75f4 = $eeaeb48e23f662e7$export$2e1e1122cf0cba88;
var $eeaeb48e23f662e7$export$602eac185826482c = $eeaeb48e23f662e7$export$dad7c95542bacce0;
var $eeaeb48e23f662e7$export$c6fdb837b070b4ff = $eeaeb48e23f662e7$export$bd1d06c79be19e17;
var $eeaeb48e23f662e7$export$7c6e2c02157bb7d2 = $eeaeb48e23f662e7$export$b6d9565de1e068cf;
var $eeaeb48e23f662e7$export$f99233281efd08a0 = $eeaeb48e23f662e7$export$16f7638e4a34b909;
var $eeaeb48e23f662e7$export$393edc798c47379d = $eeaeb48e23f662e7$export$94e94c2ec2c954d5;
var $eeaeb48e23f662e7$export$f39c2d165cd861fe = $eeaeb48e23f662e7$export$fba2fb7cd781b7ac;



/**
 * @license lucide-react v0.381.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $cfb3b3013a649f15$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("X", [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
]);



const $891fc0b201b5d767$export$a9bf29f8d87ebbee = $eeaeb48e23f662e7$export$be92b6f5f03c0fe9;
const $891fc0b201b5d767$export$de69b9b0343a1903 = $eeaeb48e23f662e7$export$41fb9f06171c75f4;
const $891fc0b201b5d767$export$99d85c8298ee6511 = $eeaeb48e23f662e7$export$f39c2d165cd861fe;
const $891fc0b201b5d767$export$721c917f47f6cb = $eeaeb48e23f662e7$export$602eac185826482c;
const $891fc0b201b5d767$export$48dbb295cbd054d8 = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$c6fdb837b070b4ff, {
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", className),
        ...props,
        ref: ref
    }));
$891fc0b201b5d767$export$48dbb295cbd054d8.displayName = $eeaeb48e23f662e7$export$c6fdb837b070b4ff.displayName;
const $891fc0b201b5d767$var$sheetVariants = (0, $7d867aa0bbfd521e$export$87dc52566e90b739)("fixed z-50 gap-4 bg-white p-6 shadow-lg transition ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-500 dark:bg-slate-950", {
    variants: {
        side: {
            top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
            bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
            left: "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
            right: "inset-y-0 right-0 h-full w-3/4  border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm"
        }
    },
    defaultVariants: {
        side: "right"
    }
});
const $891fc0b201b5d767$export$fe5ec5b76996e2d3 = /*#__PURE__*/ $acw62.forwardRef(({ side: side = "right", className: className, children: children, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($891fc0b201b5d767$export$721c917f47f6cb, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($891fc0b201b5d767$export$48dbb295cbd054d8, {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($eeaeb48e23f662e7$export$7c6e2c02157bb7d2, {
                ref: ref,
                className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)($891fc0b201b5d767$var$sheetVariants({
                    side: side
                }), className),
                ...props,
                children: [
                    children,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($eeaeb48e23f662e7$export$f39c2d165cd861fe, {
                        className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-white transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-slate-950 focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-slate-100 dark:ring-offset-slate-950 dark:focus:ring-slate-300 dark:data-[state=open]:bg-slate-800",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                className: "h-4 w-4"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "sr-only",
                                children: "Close"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
$891fc0b201b5d767$export$fe5ec5b76996e2d3.displayName = $eeaeb48e23f662e7$export$7c6e2c02157bb7d2.displayName;
const $891fc0b201b5d767$export$de7da2aaa45f2eb5 = ({ className: className, ...props })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("flex flex-col space-y-2 text-center sm:text-left", className),
        ...props
    });
$891fc0b201b5d767$export$de7da2aaa45f2eb5.displayName = "SheetHeader";
const $891fc0b201b5d767$export$1adeb0155503ee5a = ({ className: className, ...props })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", className),
        ...props
    });
$891fc0b201b5d767$export$1adeb0155503ee5a.displayName = "SheetFooter";
const $891fc0b201b5d767$export$4bb009ae36731de9 = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$f99233281efd08a0, {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("text-lg font-semibold text-slate-950 dark:text-slate-50", className),
        ...props
    }));
$891fc0b201b5d767$export$4bb009ae36731de9.displayName = $eeaeb48e23f662e7$export$f99233281efd08a0.displayName;
const $891fc0b201b5d767$export$2ee64bd945b80e4a = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$393edc798c47379d, {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("text-sm text-slate-500 dark:text-slate-400", className),
        ...props
    }));
$891fc0b201b5d767$export$2ee64bd945b80e4a.displayName = $eeaeb48e23f662e7$export$393edc798c47379d.displayName;



const $c2a581aa5067f626$var$PAYMENTS_BASE_URL = "";
const $c2a581aa5067f626$export$a2806f257ddae97a = `${$c2a581aa5067f626$var$PAYMENTS_BASE_URL}/payments/create-checkout-session`;


var $ba760e6e9b761400$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/vanilla.mjs"
});
const $ba760e6e9b761400$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const destroy = ()=>{
        if (($ba760e6e9b761400$import_meta.env ? $ba760e6e9b761400$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
        listeners.clear();
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $ba760e6e9b761400$export$f51a9068ac82ea43 = (createState)=>createState ? $ba760e6e9b761400$var$createStoreImpl(createState) : $ba760e6e9b761400$var$createStoreImpl;
var $ba760e6e9b761400$export$2e2bcd8739ae039 = (createState)=>{
    if (($ba760e6e9b761400$import_meta.env ? $ba760e6e9b761400$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $ba760e6e9b761400$export$f51a9068ac82ea43(createState);
};



var $acw62 = parcelRequire("acw62");
var $6ae5e5baff12bbf7$exports = {};
"use strict";

$6ae5e5baff12bbf7$exports = (parcelRequire("6VZtt"));


var $ab3cb874dadc0915$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $ab3cb874dadc0915$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
const { useSyncExternalStoreWithSelector: $ab3cb874dadc0915$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($6ae5e5baff12bbf7$exports)));
let $ab3cb874dadc0915$var$didWarnAboutEqualityFn = false;
const $ab3cb874dadc0915$var$identity = (arg)=>arg;
function $ab3cb874dadc0915$export$6ccbb43953eebf8(api, selector = $ab3cb874dadc0915$var$identity, equalityFn) {
    if (($ab3cb874dadc0915$import_meta.env ? $ab3cb874dadc0915$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$ab3cb874dadc0915$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $ab3cb874dadc0915$var$didWarnAboutEqualityFn = true;
    }
    const slice = $ab3cb874dadc0915$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $ab3cb874dadc0915$var$useDebugValue(slice);
    return slice;
}
const $ab3cb874dadc0915$var$createImpl = (createState)=>{
    if (($ab3cb874dadc0915$import_meta.env ? $ab3cb874dadc0915$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $ba760e6e9b761400$export$f51a9068ac82ea43)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$ab3cb874dadc0915$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $ab3cb874dadc0915$export$185802fd694ee1f5 = (createState)=>createState ? $ab3cb874dadc0915$var$createImpl(createState) : $ab3cb874dadc0915$var$createImpl;
var $ab3cb874dadc0915$export$2e2bcd8739ae039 = (createState)=>{
    if (($ab3cb874dadc0915$import_meta.env ? $ab3cb874dadc0915$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $ab3cb874dadc0915$export$185802fd694ee1f5(createState);
};


class $21f88f1227598e15$export$8a9c04b0629a0419 extends Error {
    constructor(){
        super("Unauthorized");
        this.name = "UnauthorizedError";
    }
}
const $21f88f1227598e15$var$API_BASE_URL = "";
async function $21f88f1227598e15$export$e1a6ac82279174f0(url, options) {
    const response = await fetch(`${$21f88f1227598e15$var$API_BASE_URL}${url}`, {
        ...options,
        credentials: "include"
    });
    // check response status
    if (response.status === 401) throw new $21f88f1227598e15$export$8a9c04b0629a0419();
    return response.json();
}
async function $21f88f1227598e15$export$c2b96737387ce662() {
    const responseData = await $21f88f1227598e15$export$e1a6ac82279174f0(`/auth/check`);
    const { success: success, authenticated: authenticated, hasLoggedInBefore: hasLoggedInBefore } = responseData;
    if (!success) throw new Error("Failed to check authentication");
    return {
        authenticated: authenticated,
        hasLoggedInBefore: hasLoggedInBefore
    };
}
async function $21f88f1227598e15$export$a0973bcfe11b05c9() {
    const responseData = await $21f88f1227598e15$export$e1a6ac82279174f0(`/auth/logout`, {
        method: "POST"
    });
    const { success: success } = responseData;
    if (!success) throw new Error("Failed to logout");
}
async function $21f88f1227598e15$export$7200a869094fec36(email, password) {
    const responseData = await $21f88f1227598e15$export$e1a6ac82279174f0(`/auth/signup`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            email: email,
            password: password
        })
    });
    const { success: success, message: message } = responseData;
    if (!success) throw new Error(message || "Failed to signup");
}
async function $21f88f1227598e15$export$596d806903d1f59e(email, password) {
    const responseData = await $21f88f1227598e15$export$e1a6ac82279174f0(`/auth/login`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            email: email,
            password: password
        })
    });
    const { success: success, message: message } = responseData;
    if (!success) throw new Error(message || "Failed to login");
}
async function $21f88f1227598e15$export$7cbf767827cd68ba() {
    const responseData = await $21f88f1227598e15$export$e1a6ac82279174f0(`/api/user`);
    const { success: success, user: user, credits: credits } = responseData;
    if (!success) throw new Error("Failed to fetch user");
    return {
        user: user,
        credits: credits
    };
}
async function $21f88f1227598e15$export$bd33b5cca346a1c5() {
    const responseData = await $21f88f1227598e15$export$e1a6ac82279174f0(`/api/create-video-upload-url`, {
        method: "POST"
    });
    const { success: success, uploadUrl: uploadUrl, uploadPath: uploadPath, identifier: identifier } = responseData;
    if (!success) throw new Error("Failed to create video upload URL");
    return {
        uploadPath: uploadPath,
        uploadUrl: uploadUrl,
        identifier: identifier
    };
}
async function $21f88f1227598e15$export$cfdbd1456a933055({ uploadPath: uploadPath, identifier: identifier }) {
    const responseData = await $21f88f1227598e15$export$e1a6ac82279174f0(`/api/init-project-with-video`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            uploadPath: uploadPath,
            identifier: identifier
        })
    });
    const { success: success, projectId: projectId } = responseData;
    if (!success) throw new Error("Failed to init project with video");
    return projectId;
}
async function $21f88f1227598e15$export$b00a271f69f3d728() {
    const responseData = await $21f88f1227598e15$export$e1a6ac82279174f0(`/api/projects`);
    const { success: success, projects: projects } = responseData;
    if (!success) throw new Error("Failed to fetch projects");
    return projects;
}
async function $21f88f1227598e15$export$637b60a42bb03f06(projectId) {
    const responseData = await $21f88f1227598e15$export$e1a6ac82279174f0(`/api/projects/${projectId}`);
    const { success: success, project: project } = responseData;
    if (!success) throw new Error("Failed to fetch project");
    return project;
}
async function $21f88f1227598e15$export$d7ff2361273ba2c2(projectId) {
    const responseData = await $21f88f1227598e15$export$e1a6ac82279174f0(`/api/projects/${projectId}`, {
        method: "DELETE"
    });
    const { success: success } = responseData;
    if (!success) throw new Error("Failed to delete project");
}
async function $21f88f1227598e15$export$ae3b9d24cc82af70({ projectId: projectId, captionStyle: captionStyle, captionStyleSettings: captionStyleSettings }) {
    const responseData = await $21f88f1227598e15$export$e1a6ac82279174f0(`/api/projects/${projectId}/save-caption-style-settings`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            captionStyle: captionStyle,
            captionStyleSettings: captionStyleSettings
        })
    });
    const { success: success } = responseData;
    if (!success) throw new Error("Failed to save caption style settings");
}
async function $21f88f1227598e15$export$f3ec3b23e901d6d0(projectId) {
    const responseData = await $21f88f1227598e15$export$e1a6ac82279174f0(`/api/projects/${projectId}/can-export`);
    const { success: success, canExport: canExport, minutesRemaining: minutesRemaining, minutesToConsume: minutesToConsume } = responseData;
    if (!success) throw new Error("Failed to check if can export");
    return {
        canExport: canExport,
        minutesRemaining: minutesRemaining,
        minutesToConsume: minutesToConsume
    };
}
async function $21f88f1227598e15$export$619681a4b6d28e2e(projectId) {
    const responseData = await $21f88f1227598e15$export$e1a6ac82279174f0(`/api/projects/${projectId}/export`, {
        method: "POST"
    });
    const { success: success, exportId: exportId } = responseData;
    if (!success) throw new Error("Failed to export project");
    return exportId;
}
async function $21f88f1227598e15$export$d4c07b1daf44a7f(exportId) {
    const responseData = await $21f88f1227598e15$export$e1a6ac82279174f0(`/api/exports/${exportId}`);
    const { success: success, export: exportInst, previewUrl: previewUrl } = responseData;
    if (!success) throw new Error("Failed to fetch export");
    return {
        exportInst: exportInst,
        previewUrl: previewUrl
    };
}
async function $21f88f1227598e15$export$266000d9dfaf5358() {
    const responseData = await $21f88f1227598e15$export$e1a6ac82279174f0(`/api/exports`);
    const { success: success, exports: exports } = responseData;
    if (!success) throw new Error("Failed to fetch exports");
    return exports;
}


var $db1029f36b931e86$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/middleware.mjs"
});
const $db1029f36b931e86$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $db1029f36b931e86$export$4feba8a1bc8e9afd = $db1029f36b931e86$var$reduxImpl;
const $db1029f36b931e86$var$trackedConnections = /* @__PURE__ */ new Map();
const $db1029f36b931e86$var$getTrackedConnectionState = (name)=>{
    const api = $db1029f36b931e86$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $db1029f36b931e86$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $db1029f36b931e86$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $db1029f36b931e86$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $db1029f36b931e86$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($db1029f36b931e86$import_meta.env ? $db1029f36b931e86$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) {
            if (($db1029f36b931e86$import_meta.env ? $db1029f36b931e86$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
            return fn(set, get, api);
        }
        const { connection: connection, ...connectionInformation } = $db1029f36b931e86$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$db1029f36b931e86$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                if (($db1029f36b931e86$import_meta.env ? $db1029f36b931e86$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $db1029f36b931e86$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($db1029f36b931e86$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($db1029f36b931e86$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $db1029f36b931e86$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($db1029f36b931e86$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $db1029f36b931e86$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $db1029f36b931e86$export$6922d3b3a607469e = $db1029f36b931e86$var$devtoolsImpl;
const $db1029f36b931e86$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
const $db1029f36b931e86$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $db1029f36b931e86$export$5c593627aef9f076 = $db1029f36b931e86$var$subscribeWithSelectorImpl;
const $db1029f36b931e86$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $db1029f36b931e86$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $db1029f36b931e86$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $db1029f36b931e86$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $db1029f36b931e86$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $db1029f36b931e86$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            getStorage: ()=>localStorage,
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage;
        try {
            storage = options.getStorage();
        } catch (e) {}
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const thenableSerialize = $db1029f36b931e86$var$toThenable(options.serialize);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            let errorInSync;
            const thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>cb(get()));
            const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
            return $db1029f36b931e86$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                if (storageValue) return options.deserialize(storageValue);
            }).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
const $db1029f36b931e86$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $db1029f36b931e86$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $db1029f36b931e86$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $db1029f36b931e86$var$persistImpl = (config, baseOptions)=>{
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
        if (($db1029f36b931e86$import_meta.env ? $db1029f36b931e86$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
        return $db1029f36b931e86$var$oldImpl(config, baseOptions);
    }
    return $db1029f36b931e86$var$newImpl(config, baseOptions);
};
const $db1029f36b931e86$export$9a6132153fba2e0 = $db1029f36b931e86$var$persistImpl;


function $e444d6404c095fa5$var$e(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        t && (i = i.filter(function(t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, i);
    }
    return n;
}
function $e444d6404c095fa5$var$t(t) {
    for(var n = 1; n < arguments.length; n++){
        var i = null != arguments[n] ? arguments[n] : {};
        n % 2 ? $e444d6404c095fa5$var$e(Object(i), !0).forEach(function(e) {
            $e444d6404c095fa5$var$o(t, e, i[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : $e444d6404c095fa5$var$e(Object(i)).forEach(function(e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(i, e));
        });
    }
    return t;
}
function $e444d6404c095fa5$var$n(e) {
    return $e444d6404c095fa5$var$n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e;
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, $e444d6404c095fa5$var$n(e);
}
function $e444d6404c095fa5$var$i(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function $e444d6404c095fa5$var$r(e, t) {
    for(var n = 0; n < t.length; n++){
        var i = t[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
}
function $e444d6404c095fa5$var$s(e, t, n) {
    return t && $e444d6404c095fa5$var$r(e.prototype, t), n && $e444d6404c095fa5$var$r(e, n), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $e444d6404c095fa5$var$o(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = n, e;
}
function $e444d6404c095fa5$var$a(e, t) {
    if (null == e) return {};
    var n, i, r = function(e, t) {
        if (null == e) return {};
        var n, i, r = {}, s = Object.keys(e);
        for(i = 0; i < s.length; i++)n = s[i], t.indexOf(n) >= 0 || (r[n] = e[n]);
        return r;
    }(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(i = 0; i < s.length; i++)n = s[i], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
}
function $e444d6404c095fa5$var$u(e, t) {
    return function(e) {
        if (Array.isArray(e)) return e;
    }(e) || function(e, t) {
        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null == n) return;
        var i, r, s = [], o = !0, a = !1;
        try {
            for(n = n.call(e); !(o = (i = n.next()).done) && (s.push(i.value), !t || s.length !== t); o = !0);
        } catch (e) {
            a = !0, r = e;
        } finally{
            try {
                o || null == n.return || n.return();
            } finally{
                if (a) throw r;
            }
        }
        return s;
    }(e, t) || $e444d6404c095fa5$var$c(e, t) || function() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $e444d6404c095fa5$var$l(e) {
    return function(e) {
        if (Array.isArray(e)) return $e444d6404c095fa5$var$d(e);
    }(e) || function(e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }(e) || $e444d6404c095fa5$var$c(e) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $e444d6404c095fa5$var$c(e, t) {
    if (e) {
        if ("string" == typeof e) return $e444d6404c095fa5$var$d(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? $e444d6404c095fa5$var$d(e, t) : void 0;
    }
}
function $e444d6404c095fa5$var$d(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for(var n = 0, i = new Array(t); n < t; n++)i[n] = e[n];
    return i;
}
function $e444d6404c095fa5$var$h(e, t) {
    var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (!n) {
        if (Array.isArray(e) || (n = $e444d6404c095fa5$var$c(e)) || t && e && "number" == typeof e.length) {
            n && (e = n);
            var i = 0, r = function() {};
            return {
                s: r,
                n: function() {
                    return i >= e.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: e[i++]
                    };
                },
                e: function(e) {
                    throw e;
                },
                f: r
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var s, o = !0, a = !1;
    return {
        s: function() {
            n = n.call(e);
        },
        n: function() {
            var e = n.next();
            return o = e.done, e;
        },
        e: function(e) {
            a = !0, s = e;
        },
        f: function() {
            try {
                o || null == n.return || n.return();
            } finally{
                if (a) throw s;
            }
        }
    };
}
var $e444d6404c095fa5$var$f = {
    DEBUG: !1,
    LIB_VERSION: "1.146.3"
}, $e444d6404c095fa5$var$p = Array.isArray, $e444d6404c095fa5$var$v = Object.prototype, $e444d6404c095fa5$var$_ = $e444d6404c095fa5$var$v.hasOwnProperty, $e444d6404c095fa5$var$g = $e444d6404c095fa5$var$v.toString, $e444d6404c095fa5$var$m = $e444d6404c095fa5$var$p || function(e) {
    return "[object Array]" === $e444d6404c095fa5$var$g.call(e);
}, $e444d6404c095fa5$var$y = function(e) {
    return "function" == typeof e;
}, $e444d6404c095fa5$var$b = function(e) {
    return e === Object(e) && !$e444d6404c095fa5$var$m(e);
}, $e444d6404c095fa5$var$k = function(e) {
    if ($e444d6404c095fa5$var$b(e)) {
        for(var t in e)if ($e444d6404c095fa5$var$_.call(e, t)) return !1;
        return !0;
    }
    return !1;
}, $e444d6404c095fa5$var$w = function(e) {
    return void 0 === e;
}, $e444d6404c095fa5$var$S = function(e) {
    return "[object String]" == $e444d6404c095fa5$var$g.call(e);
}, $e444d6404c095fa5$var$E = function(e) {
    return $e444d6404c095fa5$var$S(e) && 0 === e.trim().length;
}, $e444d6404c095fa5$var$F = function(e) {
    return null === e;
}, $e444d6404c095fa5$var$I = function(e) {
    return $e444d6404c095fa5$var$w(e) || $e444d6404c095fa5$var$F(e);
}, $e444d6404c095fa5$var$R = function(e) {
    return "[object Number]" == $e444d6404c095fa5$var$g.call(e);
}, $e444d6404c095fa5$var$x = function(e) {
    return "[object Boolean]" === $e444d6404c095fa5$var$g.call(e);
}, $e444d6404c095fa5$var$P = function(e) {
    return e instanceof FormData;
}, $e444d6404c095fa5$var$T = "undefined" != typeof window ? window : void 0, $e444d6404c095fa5$var$C = "undefined" != typeof globalThis ? globalThis : $e444d6404c095fa5$var$T, $e444d6404c095fa5$var$$ = Array.prototype, $e444d6404c095fa5$var$O = $e444d6404c095fa5$var$$.forEach, $e444d6404c095fa5$var$M = $e444d6404c095fa5$var$$.indexOf, $e444d6404c095fa5$var$A = null == $e444d6404c095fa5$var$C ? void 0 : $e444d6404c095fa5$var$C.navigator, $e444d6404c095fa5$var$D = null == $e444d6404c095fa5$var$C ? void 0 : $e444d6404c095fa5$var$C.document, $e444d6404c095fa5$var$L = null == $e444d6404c095fa5$var$C ? void 0 : $e444d6404c095fa5$var$C.location, $e444d6404c095fa5$var$N = null == $e444d6404c095fa5$var$C ? void 0 : $e444d6404c095fa5$var$C.fetch, $e444d6404c095fa5$var$q = null != $e444d6404c095fa5$var$C && $e444d6404c095fa5$var$C.XMLHttpRequest && "withCredentials" in new $e444d6404c095fa5$var$C.XMLHttpRequest ? $e444d6404c095fa5$var$C.XMLHttpRequest : void 0, $e444d6404c095fa5$var$B = null == $e444d6404c095fa5$var$C ? void 0 : $e444d6404c095fa5$var$C.AbortController, $e444d6404c095fa5$var$H = null == $e444d6404c095fa5$var$A ? void 0 : $e444d6404c095fa5$var$A.userAgent, $e444d6404c095fa5$var$U = null != $e444d6404c095fa5$var$T ? $e444d6404c095fa5$var$T : {}, $e444d6404c095fa5$var$j = "[PostHog.js]", $e444d6404c095fa5$var$W = {
    _log: function(e) {
        if ($e444d6404c095fa5$var$T && ($e444d6404c095fa5$var$f.DEBUG || $e444d6404c095fa5$var$U.POSTHOG_DEBUG) && !$e444d6404c095fa5$var$w($e444d6404c095fa5$var$T.console) && $e444d6404c095fa5$var$T.console) {
            for(var t = ("__rrweb_original__" in $e444d6404c095fa5$var$T.console[e]) ? $e444d6404c095fa5$var$T.console[e].__rrweb_original__ : $e444d6404c095fa5$var$T.console[e], n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)i[r - 1] = arguments[r];
            t.apply(void 0, [
                $e444d6404c095fa5$var$j
            ].concat(i));
        }
    },
    info: function() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        $e444d6404c095fa5$var$W._log.apply($e444d6404c095fa5$var$W, [
            "log"
        ].concat(t));
    },
    warn: function() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        $e444d6404c095fa5$var$W._log.apply($e444d6404c095fa5$var$W, [
            "warn"
        ].concat(t));
    },
    error: function() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        $e444d6404c095fa5$var$W._log.apply($e444d6404c095fa5$var$W, [
            "error"
        ].concat(t));
    },
    critical: function() {
        for(var e, t = arguments.length, n = new Array(t), i = 0; i < t; i++)n[i] = arguments[i];
        (e = console).error.apply(e, [
            $e444d6404c095fa5$var$j
        ].concat(n));
    },
    uninitializedWarning: function(e) {
        $e444d6404c095fa5$var$W.error("You must initialize PostHog before calling ".concat(e));
    }
}, $e444d6404c095fa5$var$G = {}, $e444d6404c095fa5$var$z = function(e) {
    return e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
};
function $e444d6404c095fa5$var$V(e, t, n) {
    if ($e444d6404c095fa5$var$m(e)) {
        if ($e444d6404c095fa5$var$O && e.forEach === $e444d6404c095fa5$var$O) e.forEach(t, n);
        else if ("length" in e && e.length === +e.length) {
            for(var i = 0, r = e.length; i < r; i++)if (i in e && t.call(n, e[i], i) === $e444d6404c095fa5$var$G) return;
        }
    }
}
function $e444d6404c095fa5$var$Q(e, t, n) {
    if (!$e444d6404c095fa5$var$I(e)) {
        if ($e444d6404c095fa5$var$m(e)) return $e444d6404c095fa5$var$V(e, t, n);
        if ($e444d6404c095fa5$var$P(e)) {
            var i, r = $e444d6404c095fa5$var$h(e.entries());
            try {
                for(r.s(); !(i = r.n()).done;){
                    var s = i.value;
                    if (t.call(n, s[1], s[0]) === $e444d6404c095fa5$var$G) return;
                }
            } catch (e) {
                r.e(e);
            } finally{
                r.f();
            }
        } else for(var o in e)if ($e444d6404c095fa5$var$_.call(e, o) && t.call(n, e[o], o) === $e444d6404c095fa5$var$G) return;
    }
}
var $e444d6404c095fa5$var$J = function(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)n[i - 1] = arguments[i];
    return $e444d6404c095fa5$var$V(n, function(t) {
        for(var n in t)void 0 !== t[n] && (e[n] = t[n]);
    }), e;
};
function $e444d6404c095fa5$var$Y(e, t) {
    return -1 !== e.indexOf(t);
}
function $e444d6404c095fa5$var$X(e) {
    for(var t = Object.keys(e), n = t.length, i = new Array(n); n--;)i[n] = [
        t[n],
        e[t[n]]
    ];
    return i;
}
var $e444d6404c095fa5$var$K = function() {
    return Date.now = Date.now || function() {
        return +new Date;
    }, Date.now();
}, $e444d6404c095fa5$var$Z = function(e) {
    try {
        return e();
    } catch (e) {
        return;
    }
}, $e444d6404c095fa5$var$ee = function(e) {
    return function() {
        try {
            for(var t = arguments.length, n = new Array(t), i = 0; i < t; i++)n[i] = arguments[i];
            return e.apply(this, n);
        } catch (e) {
            $e444d6404c095fa5$var$W.critical("Implementation error. Please turn on debug mode and open a ticket on https://app.posthog.com/home#panel=support%3Asupport%3A."), $e444d6404c095fa5$var$W.critical(e);
        }
    };
}, $e444d6404c095fa5$var$te = function(e) {
    var t = {};
    return $e444d6404c095fa5$var$Q(e, function(e, n) {
        $e444d6404c095fa5$var$S(e) && e.length > 0 && (t[n] = e);
    }), t;
}, $e444d6404c095fa5$var$ne = function(e) {
    return e.replace(/^\$/, "");
};
function $e444d6404c095fa5$var$ie(e, t) {
    var n, i, r;
    return n = e, i = function(e) {
        return $e444d6404c095fa5$var$S(e) && !$e444d6404c095fa5$var$F(t) ? e.slice(0, t) : e;
    }, r = new Set, function e(t, n) {
        var s;
        return t !== Object(t) ? i ? i(t, n) : t : r.has(t) ? void 0 : (r.add(t), $e444d6404c095fa5$var$m(t) ? (s = [], $e444d6404c095fa5$var$V(t, function(t) {
            s.push(e(t));
        })) : (s = {}, $e444d6404c095fa5$var$Q(t, function(t, n) {
            r.has(t) || (s[n] = e(t, n));
        })), s);
    }(n);
}
var $e444d6404c095fa5$export$6a00d17b5aff0af, $e444d6404c095fa5$var$se = function(e) {
    var t, n, i, r, s = "";
    for(t = n = 0, i = (e = (e + "").replace(/\r\n/g, "\n").replace(/\r/g, "\n")).length, r = 0; r < i; r++){
        var o = e.charCodeAt(r), a = null;
        o < 128 ? n++ : a = o > 127 && o < 2048 ? String.fromCharCode(o >> 6 | 192, 63 & o | 128) : String.fromCharCode(o >> 12 | 224, o >> 6 & 63 | 128, 63 & o | 128), $e444d6404c095fa5$var$F(a) || (n > t && (s += e.substring(t, n)), s += a, t = n = r + 1);
    }
    return n > t && (s += e.substring(t, e.length)), s;
}, $e444d6404c095fa5$var$oe = function() {
    function e(t) {
        return t && (t.preventDefault = e.preventDefault, t.stopPropagation = e.stopPropagation), t;
    }
    return e.preventDefault = function() {
        this.returnValue = !1;
    }, e.stopPropagation = function() {
        this.cancelBubble = !0;
    }, function(t, n, i, r, s) {
        if (t) {
            if (t.addEventListener && !r) t.addEventListener(n, i, !!s);
            else {
                var o = "on" + n, a = t[o];
                t[o] = function(t, n, i) {
                    return function(r) {
                        if (r = r || e(null == $e444d6404c095fa5$var$T ? void 0 : $e444d6404c095fa5$var$T.event)) {
                            var s, o = !0;
                            $e444d6404c095fa5$var$y(i) && (s = i(r));
                            var a = n.call(t, r);
                            return !1 !== s && !1 !== a || (o = !1), o;
                        }
                    };
                }(t, i, a);
            }
        } else $e444d6404c095fa5$var$W.error("No valid element provided to register_event");
    };
}();
function $e444d6404c095fa5$var$ae(e, t) {
    for(var n = 0; n < e.length; n++)if (t(e[n])) return e[n];
}
!function(e) {
    e.GZipJS = "gzip-js", e.Base64 = "base64";
}($e444d6404c095fa5$export$6a00d17b5aff0af || ($e444d6404c095fa5$export$6a00d17b5aff0af = {}));
var $e444d6404c095fa5$export$9dd8f6ec3b5e6004 = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
], $e444d6404c095fa5$var$le = "$people_distinct_id", $e444d6404c095fa5$var$ce = "__alias", $e444d6404c095fa5$var$de = "__timers", $e444d6404c095fa5$var$he = "$autocapture_disabled_server_side", $e444d6404c095fa5$var$fe = "$heatmaps_enabled_server_side", $e444d6404c095fa5$var$pe = "$exception_capture_enabled_server_side", $e444d6404c095fa5$var$ve = "$exception_capture_endpoint", $e444d6404c095fa5$var$_e = "$web_vitals_enabled_server_side", $e444d6404c095fa5$var$ge = "$session_recording_enabled_server_side", $e444d6404c095fa5$var$me = "$console_log_recording_enabled_server_side", $e444d6404c095fa5$var$ye = "$session_recording_network_payload_capture", $e444d6404c095fa5$var$be = "$session_recording_canvas_recording", $e444d6404c095fa5$var$ke = "$replay_sample_rate", $e444d6404c095fa5$var$we = "$replay_minimum_duration", $e444d6404c095fa5$var$Se = "$sesid", $e444d6404c095fa5$var$Ee = "$session_is_sampled", $e444d6404c095fa5$var$Fe = "$enabled_feature_flags", $e444d6404c095fa5$var$Ie = "$early_access_features", $e444d6404c095fa5$var$Re = "$stored_person_properties", $e444d6404c095fa5$var$xe = "$stored_group_properties", $e444d6404c095fa5$var$Pe = "$surveys", $e444d6404c095fa5$var$Te = "$surveys_activated", $e444d6404c095fa5$var$Ce = "$flag_call_reported", $e444d6404c095fa5$var$$e = "$user_state", $e444d6404c095fa5$var$Oe = "$client_session_props", $e444d6404c095fa5$var$Me = "$capture_rate_limit", $e444d6404c095fa5$var$Ae = "$initial_campaign_params", $e444d6404c095fa5$var$De = "$initial_referrer_info", $e444d6404c095fa5$var$Le = "$initial_person_info", $e444d6404c095fa5$var$Ne = "$epp", $e444d6404c095fa5$var$qe = "__POSTHOG_TOOLBAR__", $e444d6404c095fa5$var$Be = [
    $e444d6404c095fa5$var$le,
    $e444d6404c095fa5$var$ce,
    "__cmpns",
    $e444d6404c095fa5$var$de,
    $e444d6404c095fa5$var$ge,
    $e444d6404c095fa5$var$fe,
    $e444d6404c095fa5$var$Se,
    $e444d6404c095fa5$var$Fe,
    $e444d6404c095fa5$var$$e,
    $e444d6404c095fa5$var$Ie,
    $e444d6404c095fa5$var$xe,
    $e444d6404c095fa5$var$Re,
    $e444d6404c095fa5$var$Pe,
    $e444d6404c095fa5$var$Ce,
    $e444d6404c095fa5$var$Oe,
    $e444d6404c095fa5$var$Me,
    $e444d6404c095fa5$var$Ae,
    $e444d6404c095fa5$var$De,
    $e444d6404c095fa5$var$Ne
], $e444d6404c095fa5$var$He = "$active_feature_flags", $e444d6404c095fa5$var$Ue = "$override_feature_flags", $e444d6404c095fa5$var$je = "$feature_flag_payloads", $e444d6404c095fa5$var$We = function(e) {
    var t, n = {}, i = $e444d6404c095fa5$var$h($e444d6404c095fa5$var$X(e || {}));
    try {
        for(i.s(); !(t = i.n()).done;){
            var r = $e444d6404c095fa5$var$u(t.value, 2), s = r[0], o = r[1];
            o && (n[s] = o);
        }
    } catch (e) {
        i.e(e);
    } finally{
        i.f();
    }
    return n;
}, $e444d6404c095fa5$var$Ge = function() {
    function e(t) {
        $e444d6404c095fa5$var$i(this, e), this.instance = t, this._override_warning = !1, this.featureFlagEventHandlers = [], this.reloadFeatureFlagsQueued = !1, this.reloadFeatureFlagsInAction = !1;
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "getFlags",
            value: function() {
                return Object.keys(this.getFlagVariants());
            }
        },
        {
            key: "getFlagVariants",
            value: function() {
                var e = this.instance.get_property($e444d6404c095fa5$var$Fe), t = this.instance.get_property($e444d6404c095fa5$var$Ue);
                if (!t) return e || {};
                for(var n = $e444d6404c095fa5$var$J({}, e), i = Object.keys(t), r = 0; r < i.length; r++)n[i[r]] = t[i[r]];
                return this._override_warning || ($e444d6404c095fa5$var$W.warn(" Overriding feature flags!", {
                    enabledFlags: e,
                    overriddenFlags: t,
                    finalFlags: n
                }), this._override_warning = !0), n;
            }
        },
        {
            key: "getFlagPayloads",
            value: function() {
                return this.instance.get_property($e444d6404c095fa5$var$je) || {};
            }
        },
        {
            key: "reloadFeatureFlags",
            value: function() {
                this.reloadFeatureFlagsQueued || (this.reloadFeatureFlagsQueued = !0, this._startReloadTimer());
            }
        },
        {
            key: "setAnonymousDistinctId",
            value: function(e) {
                this.$anon_distinct_id = e;
            }
        },
        {
            key: "setReloadingPaused",
            value: function(e) {
                this.reloadFeatureFlagsInAction = e;
            }
        },
        {
            key: "resetRequestQueue",
            value: function() {
                this.reloadFeatureFlagsQueued = !1;
            }
        },
        {
            key: "_startReloadTimer",
            value: function() {
                var e = this;
                this.reloadFeatureFlagsQueued && !this.reloadFeatureFlagsInAction && setTimeout(function() {
                    !e.reloadFeatureFlagsInAction && e.reloadFeatureFlagsQueued && (e.reloadFeatureFlagsQueued = !1, e._reloadFeatureFlagsRequest());
                }, 5);
            }
        },
        {
            key: "_reloadFeatureFlagsRequest",
            value: function() {
                var e = this;
                if (!this.instance.config.advanced_disable_feature_flags) {
                    this.setReloadingPaused(!0);
                    var t = this.instance.config.token, n = this.instance.get_property($e444d6404c095fa5$var$Re), i = this.instance.get_property($e444d6404c095fa5$var$xe), r = {
                        token: t,
                        distinct_id: this.instance.get_distinct_id(),
                        groups: this.instance.getGroups(),
                        $anon_distinct_id: this.$anon_distinct_id,
                        person_properties: n,
                        group_properties: i,
                        disable_flags: this.instance.config.advanced_disable_feature_flags || void 0
                    };
                    this.instance._send_request({
                        method: "POST",
                        url: this.instance.requestRouter.endpointFor("api", "/decide/?v=3"),
                        data: r,
                        compression: this.instance.config.disable_compression ? void 0 : $e444d6404c095fa5$export$6a00d17b5aff0af.Base64,
                        timeout: this.instance.config.feature_flag_request_timeout_ms,
                        callback: function(t) {
                            var n;
                            e.setReloadingPaused(!1);
                            var i = !0;
                            200 === t.statusCode && (e.$anon_distinct_id = void 0, i = !1), e.receivedFeatureFlags(null !== (n = t.json) && void 0 !== n ? n : {}, i), e._startReloadTimer();
                        }
                    });
                }
            }
        },
        {
            key: "getFeatureFlag",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                if (this.instance.decideEndpointWasHit || this.getFlags() && this.getFlags().length > 0) {
                    var n, i = this.getFlagVariants()[e], r = "".concat(i), s = this.instance.get_property($e444d6404c095fa5$var$Ce) || {};
                    if (t.send_event || !("send_event" in t)) {
                        if (!(e in s) || !s[e].includes(r)) $e444d6404c095fa5$var$m(s[e]) ? s[e].push(r) : s[e] = [
                            r
                        ], null === (n = this.instance.persistence) || void 0 === n || n.register($e444d6404c095fa5$var$o({}, $e444d6404c095fa5$var$Ce, s)), this.instance.capture("$feature_flag_called", {
                            $feature_flag: e,
                            $feature_flag_response: i
                        });
                    }
                    return i;
                }
                $e444d6404c095fa5$var$W.warn('getFeatureFlag for key "' + e + "\" failed. Feature flags didn't load in time.");
            }
        },
        {
            key: "getFeatureFlagPayload",
            value: function(e) {
                return this.getFlagPayloads()[e];
            }
        },
        {
            key: "isFeatureEnabled",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                if (this.instance.decideEndpointWasHit || this.getFlags() && this.getFlags().length > 0) return !!this.getFeatureFlag(e, t);
                $e444d6404c095fa5$var$W.warn('isFeatureEnabled for key "' + e + "\" failed. Feature flags didn't load in time.");
            }
        },
        {
            key: "addFeatureFlagsHandler",
            value: function(e) {
                this.featureFlagEventHandlers.push(e);
            }
        },
        {
            key: "removeFeatureFlagsHandler",
            value: function(e) {
                this.featureFlagEventHandlers = this.featureFlagEventHandlers.filter(function(t) {
                    return t !== e;
                });
            }
        },
        {
            key: "receivedFeatureFlags",
            value: function(e, n) {
                if (this.instance.persistence) {
                    this.instance.decideEndpointWasHit = !0;
                    var i = this.getFlagVariants(), r = this.getFlagPayloads();
                    !function(e, n) {
                        var i, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, s = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, a = e.featureFlags, u = e.featureFlagPayloads;
                        if (a) {
                            if ($e444d6404c095fa5$var$m(a)) {
                                var l, c = {};
                                if (a) for(var d = 0; d < a.length; d++)c[a[d]] = !0;
                                n && n.register(($e444d6404c095fa5$var$o(l = {}, $e444d6404c095fa5$var$He, a), $e444d6404c095fa5$var$o(l, $e444d6404c095fa5$var$Fe, c), l));
                            } else {
                                var h = a, f = u;
                                e.errorsWhileComputingFlags && (h = $e444d6404c095fa5$var$t($e444d6404c095fa5$var$t({}, r), h), f = $e444d6404c095fa5$var$t($e444d6404c095fa5$var$t({}, s), f)), n && n.register(($e444d6404c095fa5$var$o(i = {}, $e444d6404c095fa5$var$He, Object.keys($e444d6404c095fa5$var$We(h))), $e444d6404c095fa5$var$o(i, $e444d6404c095fa5$var$Fe, h || {}), $e444d6404c095fa5$var$o(i, $e444d6404c095fa5$var$je, f || {}), i));
                            }
                        }
                    }(e, this.instance.persistence, i, r), this._fireFeatureFlagsCallbacks(n);
                }
            }
        },
        {
            key: "override",
            value: function(e) {
                if (!this.instance.__loaded || !this.instance.persistence) return $e444d6404c095fa5$var$W.uninitializedWarning("posthog.feature_flags.override");
                if (this._override_warning = !1, !1 === e) this.instance.persistence.unregister($e444d6404c095fa5$var$Ue);
                else if ($e444d6404c095fa5$var$m(e)) {
                    for(var t = {}, n = 0; n < e.length; n++)t[e[n]] = !0;
                    this.instance.persistence.register($e444d6404c095fa5$var$o({}, $e444d6404c095fa5$var$Ue, t));
                } else this.instance.persistence.register($e444d6404c095fa5$var$o({}, $e444d6404c095fa5$var$Ue, e));
            }
        },
        {
            key: "onFeatureFlags",
            value: function(e) {
                var t = this;
                if (this.addFeatureFlagsHandler(e), this.instance.decideEndpointWasHit) {
                    var n = this._prepareFeatureFlagsForCallbacks(), i = n.flags, r = n.flagVariants;
                    e(i, r);
                }
                return function() {
                    return t.removeFeatureFlagsHandler(e);
                };
            }
        },
        {
            key: "updateEarlyAccessFeatureEnrollment",
            value: function(e, n) {
                var i, r, s = $e444d6404c095fa5$var$o({}, "$feature_enrollment/".concat(e), n);
                this.instance.capture("$feature_enrollment_update", {
                    $feature_flag: e,
                    $feature_enrollment: n,
                    $set: s
                }), this.setPersonPropertiesForFlags(s, !1);
                var a = $e444d6404c095fa5$var$t($e444d6404c095fa5$var$t({}, this.getFlagVariants()), {}, $e444d6404c095fa5$var$o({}, e, n));
                null === (i = this.instance.persistence) || void 0 === i || i.register(($e444d6404c095fa5$var$o(r = {}, $e444d6404c095fa5$var$He, Object.keys($e444d6404c095fa5$var$We(a))), $e444d6404c095fa5$var$o(r, $e444d6404c095fa5$var$Fe, a), r)), this._fireFeatureFlagsCallbacks();
            }
        },
        {
            key: "getEarlyAccessFeatures",
            value: function(e) {
                var t = this, n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], i = this.instance.get_property($e444d6404c095fa5$var$Ie);
                if (i && !n) return e(i);
                this.instance._send_request({
                    transport: "XHR",
                    url: this.instance.requestRouter.endpointFor("api", "/api/early_access_features/?token=".concat(this.instance.config.token)),
                    method: "GET",
                    callback: function(n) {
                        var i;
                        if (n.json) {
                            var r = n.json.earlyAccessFeatures;
                            return null === (i = t.instance.persistence) || void 0 === i || i.register($e444d6404c095fa5$var$o({}, $e444d6404c095fa5$var$Ie, r)), e(r);
                        }
                    }
                });
            }
        },
        {
            key: "_prepareFeatureFlagsForCallbacks",
            value: function() {
                var e = this.getFlags(), t = this.getFlagVariants();
                return {
                    flags: e.filter(function(e) {
                        return t[e];
                    }),
                    flagVariants: Object.keys(t).filter(function(e) {
                        return t[e];
                    }).reduce(function(e, n) {
                        return e[n] = t[n], e;
                    }, {})
                };
            }
        },
        {
            key: "_fireFeatureFlagsCallbacks",
            value: function(e) {
                var t = this._prepareFeatureFlagsForCallbacks(), n = t.flags, i = t.flagVariants;
                this.featureFlagEventHandlers.forEach(function(t) {
                    return t(n, i, {
                        errorsLoading: e
                    });
                });
            }
        },
        {
            key: "setPersonPropertiesForFlags",
            value: function(e) {
                var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = this.instance.get_property($e444d6404c095fa5$var$Re) || {};
                this.instance.register($e444d6404c095fa5$var$o({}, $e444d6404c095fa5$var$Re, $e444d6404c095fa5$var$t($e444d6404c095fa5$var$t({}, i), e))), n && this.instance.reloadFeatureFlags();
            }
        },
        {
            key: "resetPersonPropertiesForFlags",
            value: function() {
                this.instance.unregister($e444d6404c095fa5$var$Re);
            }
        },
        {
            key: "setGroupPropertiesForFlags",
            value: function(e) {
                var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = this.instance.get_property($e444d6404c095fa5$var$xe) || {};
                0 !== Object.keys(i).length && Object.keys(i).forEach(function(n) {
                    i[n] = $e444d6404c095fa5$var$t($e444d6404c095fa5$var$t({}, i[n]), e[n]), delete e[n];
                }), this.instance.register($e444d6404c095fa5$var$o({}, $e444d6404c095fa5$var$xe, $e444d6404c095fa5$var$t($e444d6404c095fa5$var$t({}, i), e))), n && this.instance.reloadFeatureFlags();
            }
        },
        {
            key: "resetGroupPropertiesForFlags",
            value: function(e) {
                if (e) {
                    var n = this.instance.get_property($e444d6404c095fa5$var$xe) || {};
                    this.instance.register($e444d6404c095fa5$var$o({}, $e444d6404c095fa5$var$xe, $e444d6404c095fa5$var$t($e444d6404c095fa5$var$t({}, n), {}, $e444d6404c095fa5$var$o({}, e, {}))));
                } else this.instance.unregister($e444d6404c095fa5$var$xe);
            }
        }
    ]), e;
}();
Math.trunc || (Math.trunc = function(e) {
    return e < 0 ? Math.ceil(e) : Math.floor(e);
}), Number.isInteger || (Number.isInteger = function(e) {
    return $e444d6404c095fa5$var$R(e) && isFinite(e) && Math.floor(e) === e;
});
var $e444d6404c095fa5$var$ze = "0123456789abcdef", $e444d6404c095fa5$var$Ve = function() {
    function e(t) {
        if ($e444d6404c095fa5$var$i(this, e), this.bytes = t, 16 !== t.length) throw new TypeError("not 128-bit length");
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "toString",
            value: function() {
                for(var e = "", t = 0; t < this.bytes.length; t++)e = e + $e444d6404c095fa5$var$ze.charAt(this.bytes[t] >>> 4) + $e444d6404c095fa5$var$ze.charAt(15 & this.bytes[t]), 3 !== t && 5 !== t && 7 !== t && 9 !== t || (e += "-");
                if (36 !== e.length) throw new Error("Invalid UUIDv7 was generated");
                return e;
            }
        },
        {
            key: "clone",
            value: function() {
                return new e(this.bytes.slice(0));
            }
        },
        {
            key: "equals",
            value: function(e) {
                return 0 === this.compareTo(e);
            }
        },
        {
            key: "compareTo",
            value: function(e) {
                for(var t = 0; t < 16; t++){
                    var n = this.bytes[t] - e.bytes[t];
                    if (0 !== n) return Math.sign(n);
                }
                return 0;
            }
        }
    ], [
        {
            key: "fromFieldsV7",
            value: function(t, n, i, r) {
                if (!Number.isInteger(t) || !Number.isInteger(n) || !Number.isInteger(i) || !Number.isInteger(r) || t < 0 || n < 0 || i < 0 || r < 0 || t > 0xffffffffffff || n > 4095 || i > 1073741823 || r > 4294967295) throw new RangeError("invalid field value");
                var s = new Uint8Array(16);
                return s[0] = t / Math.pow(2, 40), s[1] = t / Math.pow(2, 32), s[2] = t / Math.pow(2, 24), s[3] = t / Math.pow(2, 16), s[4] = t / Math.pow(2, 8), s[5] = t, s[6] = 112 | n >>> 8, s[7] = n, s[8] = 128 | i >>> 24, s[9] = i >>> 16, s[10] = i >>> 8, s[11] = i, s[12] = r >>> 24, s[13] = r >>> 16, s[14] = r >>> 8, s[15] = r, new e(s);
            }
        }
    ]), e;
}(), $e444d6404c095fa5$var$Qe = function() {
    function e() {
        $e444d6404c095fa5$var$i(this, e), $e444d6404c095fa5$var$o(this, "timestamp", 0), $e444d6404c095fa5$var$o(this, "counter", 0), $e444d6404c095fa5$var$o(this, "random", new $e444d6404c095fa5$var$Xe);
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "generate",
            value: function() {
                var e = this.generateOrAbort();
                if ($e444d6404c095fa5$var$w(e)) {
                    this.timestamp = 0;
                    var t = this.generateOrAbort();
                    if ($e444d6404c095fa5$var$w(t)) throw new Error("Could not generate UUID after timestamp reset");
                    return t;
                }
                return e;
            }
        },
        {
            key: "generateOrAbort",
            value: function() {
                var e = Date.now();
                if (e > this.timestamp) this.timestamp = e, this.resetCounter();
                else {
                    if (!(e + 1e4 > this.timestamp)) return;
                    this.counter++, this.counter > 4398046511103 && (this.timestamp++, this.resetCounter());
                }
                return $e444d6404c095fa5$var$Ve.fromFieldsV7(this.timestamp, Math.trunc(this.counter / Math.pow(2, 30)), this.counter & Math.pow(2, 30) - 1, this.random.nextUint32());
            }
        },
        {
            key: "resetCounter",
            value: function() {
                this.counter = 1024 * this.random.nextUint32() + (1023 & this.random.nextUint32());
            }
        }
    ]), e;
}(), $e444d6404c095fa5$var$Je = function(e) {
    if ("undefined" != typeof UUIDV7_DENY_WEAK_RNG && UUIDV7_DENY_WEAK_RNG) throw new Error("no cryptographically strong RNG available");
    for(var t = 0; t < e.length; t++)e[t] = 65536 * Math.trunc(65536 * Math.random()) + Math.trunc(65536 * Math.random());
    return e;
};
$e444d6404c095fa5$var$T && !$e444d6404c095fa5$var$w($e444d6404c095fa5$var$T.crypto) && crypto.getRandomValues && ($e444d6404c095fa5$var$Je = function(e) {
    return crypto.getRandomValues(e);
});
var $e444d6404c095fa5$var$Ye, $e444d6404c095fa5$var$Xe = function() {
    function e() {
        $e444d6404c095fa5$var$i(this, e), $e444d6404c095fa5$var$o(this, "buffer", new Uint32Array(8)), $e444d6404c095fa5$var$o(this, "cursor", 1 / 0);
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "nextUint32",
            value: function() {
                return this.cursor >= this.buffer.length && ($e444d6404c095fa5$var$Je(this.buffer), this.cursor = 0), this.buffer[this.cursor++];
            }
        }
    ]), e;
}(), $e444d6404c095fa5$var$Ke = function() {
    return $e444d6404c095fa5$var$Ze().toString();
}, $e444d6404c095fa5$var$Ze = function() {
    return ($e444d6404c095fa5$var$Ye || ($e444d6404c095fa5$var$Ye = new $e444d6404c095fa5$var$Qe)).generate();
}, $e444d6404c095fa5$var$et = "Thu, 01 Jan 1970 00:00:00 GMT", $e444d6404c095fa5$var$tt = "";
var $e444d6404c095fa5$var$nt = /[a-z0-9][a-z0-9-]+\.[a-z]{2,}$/i;
function $e444d6404c095fa5$var$it(e, t) {
    if (t) {
        var n = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : $e444d6404c095fa5$var$D;
            if ($e444d6404c095fa5$var$tt) return $e444d6404c095fa5$var$tt;
            if (!t) return "";
            if ([
                "localhost",
                "127.0.0.1"
            ].includes(e)) return "";
            for(var n = e.split("."), i = Math.min(n.length, 8), r = "dmn_chk_" + $e444d6404c095fa5$var$Ke(), s = new RegExp("(^|;)\\s*" + r + "=1"); !$e444d6404c095fa5$var$tt && i--;){
                var o = n.slice(i).join("."), a = r + "=1;domain=." + o;
                t.cookie = a, s.test(t.cookie) && (t.cookie = a + ";expires=" + $e444d6404c095fa5$var$et, $e444d6404c095fa5$var$tt = o);
            }
            return $e444d6404c095fa5$var$tt;
        }(e);
        if (!n) {
            var i = function(e) {
                var t = e.match($e444d6404c095fa5$var$nt);
                return t ? t[0] : "";
            }(e);
            i !== n && $e444d6404c095fa5$var$W.info("Warning: cookie subdomain discovery mismatch", i, n), n = i;
        }
        return n ? "; domain=." + n : "";
    }
    return "";
}
var $e444d6404c095fa5$var$rt, $e444d6404c095fa5$var$st = {
    is_supported: function() {
        return !!$e444d6404c095fa5$var$D;
    },
    error: function(e) {
        $e444d6404c095fa5$var$W.error("cookieStore error: " + e);
    },
    get: function(e) {
        if ($e444d6404c095fa5$var$D) {
            try {
                for(var t = e + "=", n = $e444d6404c095fa5$var$D.cookie.split(";").filter(function(e) {
                    return e.length;
                }), i = 0; i < n.length; i++){
                    for(var r = n[i]; " " == r.charAt(0);)r = r.substring(1, r.length);
                    if (0 === r.indexOf(t)) return decodeURIComponent(r.substring(t.length, r.length));
                }
            } catch (e) {}
            return null;
        }
    },
    parse: function(e) {
        var t;
        try {
            t = JSON.parse($e444d6404c095fa5$var$st.get(e)) || {};
        } catch (e) {}
        return t;
    },
    set: function(e, t, n, i, r) {
        if ($e444d6404c095fa5$var$D) try {
            var s = "", o = "", a = $e444d6404c095fa5$var$it($e444d6404c095fa5$var$D.location.hostname, i);
            if (n) {
                var u = new Date;
                u.setTime(u.getTime() + 24 * n * 3600000), s = "; expires=" + u.toUTCString();
            }
            r && (o = "; secure");
            var l = e + "=" + encodeURIComponent(JSON.stringify(t)) + s + "; SameSite=Lax; path=/" + a + o;
            return l.length > 3686.4 && $e444d6404c095fa5$var$W.warn("cookieStore warning: large cookie, len=" + l.length), $e444d6404c095fa5$var$D.cookie = l, l;
        } catch (e) {
            return;
        }
    },
    remove: function(e, t) {
        try {
            $e444d6404c095fa5$var$st.set(e, "", -1, t);
        } catch (e) {
            return;
        }
    }
}, $e444d6404c095fa5$var$ot = null, $e444d6404c095fa5$var$at = {
    is_supported: function() {
        if (!$e444d6404c095fa5$var$F($e444d6404c095fa5$var$ot)) return $e444d6404c095fa5$var$ot;
        var e = !0;
        if ($e444d6404c095fa5$var$w($e444d6404c095fa5$var$T)) e = !1;
        else try {
            var t = "__mplssupport__";
            $e444d6404c095fa5$var$at.set(t, "xyz"), '"xyz"' !== $e444d6404c095fa5$var$at.get(t) && (e = !1), $e444d6404c095fa5$var$at.remove(t);
        } catch (t) {
            e = !1;
        }
        return e || $e444d6404c095fa5$var$W.error("localStorage unsupported; falling back to cookie store"), $e444d6404c095fa5$var$ot = e, e;
    },
    error: function(e) {
        $e444d6404c095fa5$var$W.error("localStorage error: " + e);
    },
    get: function(e) {
        try {
            return null == $e444d6404c095fa5$var$T ? void 0 : $e444d6404c095fa5$var$T.localStorage.getItem(e);
        } catch (e) {
            $e444d6404c095fa5$var$at.error(e);
        }
        return null;
    },
    parse: function(e) {
        try {
            return JSON.parse($e444d6404c095fa5$var$at.get(e)) || {};
        } catch (e) {}
        return null;
    },
    set: function(e, t) {
        try {
            null == $e444d6404c095fa5$var$T || $e444d6404c095fa5$var$T.localStorage.setItem(e, JSON.stringify(t));
        } catch (e) {
            $e444d6404c095fa5$var$at.error(e);
        }
    },
    remove: function(e) {
        try {
            null == $e444d6404c095fa5$var$T || $e444d6404c095fa5$var$T.localStorage.removeItem(e);
        } catch (e) {
            $e444d6404c095fa5$var$at.error(e);
        }
    }
}, $e444d6404c095fa5$var$ut = [
    "distinct_id",
    $e444d6404c095fa5$var$Se,
    $e444d6404c095fa5$var$Ee,
    $e444d6404c095fa5$var$Ne
], $e444d6404c095fa5$var$lt = $e444d6404c095fa5$var$t($e444d6404c095fa5$var$t({}, $e444d6404c095fa5$var$at), {}, {
    parse: function(e) {
        try {
            var t = {};
            try {
                t = $e444d6404c095fa5$var$st.parse(e) || {};
            } catch (e) {}
            var n = $e444d6404c095fa5$var$J(t, JSON.parse($e444d6404c095fa5$var$at.get(e) || "{}"));
            return $e444d6404c095fa5$var$at.set(e, n), n;
        } catch (e) {}
        return null;
    },
    set: function(e, t, n, i, r) {
        try {
            $e444d6404c095fa5$var$at.set(e, t);
            var s = {};
            $e444d6404c095fa5$var$ut.forEach(function(e) {
                t[e] && (s[e] = t[e]);
            }), Object.keys(s).length && $e444d6404c095fa5$var$st.set(e, s, n, i, r);
        } catch (e) {
            $e444d6404c095fa5$var$at.error(e);
        }
    },
    remove: function(e, t) {
        try {
            null == $e444d6404c095fa5$var$T || $e444d6404c095fa5$var$T.localStorage.removeItem(e), $e444d6404c095fa5$var$st.remove(e, t);
        } catch (e) {
            $e444d6404c095fa5$var$at.error(e);
        }
    }
}), $e444d6404c095fa5$var$ct = {}, $e444d6404c095fa5$var$dt = {
    is_supported: function() {
        return !0;
    },
    error: function(e) {
        $e444d6404c095fa5$var$W.error("memoryStorage error: " + e);
    },
    get: function(e) {
        return $e444d6404c095fa5$var$ct[e] || null;
    },
    parse: function(e) {
        return $e444d6404c095fa5$var$ct[e] || null;
    },
    set: function(e, t) {
        $e444d6404c095fa5$var$ct[e] = t;
    },
    remove: function(e) {
        delete $e444d6404c095fa5$var$ct[e];
    }
}, $e444d6404c095fa5$var$ht = null, $e444d6404c095fa5$var$ft = {
    is_supported: function() {
        if (!$e444d6404c095fa5$var$F($e444d6404c095fa5$var$ht)) return $e444d6404c095fa5$var$ht;
        if ($e444d6404c095fa5$var$ht = !0, $e444d6404c095fa5$var$w($e444d6404c095fa5$var$T)) $e444d6404c095fa5$var$ht = !1;
        else try {
            var e = "__support__";
            $e444d6404c095fa5$var$ft.set(e, "xyz"), '"xyz"' !== $e444d6404c095fa5$var$ft.get(e) && ($e444d6404c095fa5$var$ht = !1), $e444d6404c095fa5$var$ft.remove(e);
        } catch (e) {
            $e444d6404c095fa5$var$ht = !1;
        }
        return $e444d6404c095fa5$var$ht;
    },
    error: function(e) {
        $e444d6404c095fa5$var$W.error("sessionStorage error: ", e);
    },
    get: function(e) {
        try {
            return null == $e444d6404c095fa5$var$T ? void 0 : $e444d6404c095fa5$var$T.sessionStorage.getItem(e);
        } catch (e) {
            $e444d6404c095fa5$var$ft.error(e);
        }
        return null;
    },
    parse: function(e) {
        try {
            return JSON.parse($e444d6404c095fa5$var$ft.get(e)) || null;
        } catch (e) {}
        return null;
    },
    set: function(e, t) {
        try {
            null == $e444d6404c095fa5$var$T || $e444d6404c095fa5$var$T.sessionStorage.setItem(e, JSON.stringify(t));
        } catch (e) {
            $e444d6404c095fa5$var$ft.error(e);
        }
    },
    remove: function(e) {
        try {
            null == $e444d6404c095fa5$var$T || $e444d6404c095fa5$var$T.sessionStorage.removeItem(e);
        } catch (e) {
            $e444d6404c095fa5$var$ft.error(e);
        }
    }
}, $e444d6404c095fa5$var$pt = [
    "localhost",
    "127.0.0.1"
], $e444d6404c095fa5$var$vt = function(e) {
    var t = null == $e444d6404c095fa5$var$D ? void 0 : $e444d6404c095fa5$var$D.createElement("a");
    return $e444d6404c095fa5$var$w(t) ? null : (t.href = e, t);
}, $e444d6404c095fa5$var$_t = function(e, t) {
    return !!function(e) {
        try {
            new RegExp(e);
        } catch (e) {
            return !1;
        }
        return !0;
    }(t) && new RegExp(t).test(e);
}, $e444d6404c095fa5$var$gt = function(e) {
    var t, n, i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "&", r = [];
    return $e444d6404c095fa5$var$Q(e, function(e, i) {
        $e444d6404c095fa5$var$w(e) || $e444d6404c095fa5$var$w(i) || "undefined" === i || (t = encodeURIComponent(function(e) {
            return e instanceof File;
        }(e) ? e.name : e.toString()), n = encodeURIComponent(i), r[r.length] = n + "=" + t);
    }), r.join(i);
}, $e444d6404c095fa5$var$mt = function(e, t) {
    for(var n, i = ((e.split("#")[0] || "").split("?")[1] || "").split("&"), r = 0; r < i.length; r++){
        var s = i[r].split("=");
        if (s[0] === t) {
            n = s;
            break;
        }
    }
    if (!$e444d6404c095fa5$var$m(n) || n.length < 2) return "";
    var o = n[1];
    try {
        o = decodeURIComponent(o);
    } catch (e) {
        $e444d6404c095fa5$var$W.error("Skipping decoding for malformed query param: " + o);
    }
    return o.replace(/\+/g, " ");
}, $e444d6404c095fa5$var$yt = function(e, t) {
    var n = e.match(new RegExp(t + "=([^&]*)"));
    return n ? n[1] : null;
}, $e444d6404c095fa5$var$bt = "Mobile", $e444d6404c095fa5$var$kt = "iOS", $e444d6404c095fa5$var$wt = "Android", $e444d6404c095fa5$var$St = "Tablet", $e444d6404c095fa5$var$Et = $e444d6404c095fa5$var$wt + " " + $e444d6404c095fa5$var$St, $e444d6404c095fa5$var$Ft = "iPad", $e444d6404c095fa5$var$It = "Apple", $e444d6404c095fa5$var$Rt = $e444d6404c095fa5$var$It + " Watch", $e444d6404c095fa5$var$xt = "Safari", $e444d6404c095fa5$var$Pt = "BlackBerry", $e444d6404c095fa5$var$Tt = "Samsung", $e444d6404c095fa5$var$Ct = $e444d6404c095fa5$var$Tt + "Browser", $e444d6404c095fa5$var$$t = $e444d6404c095fa5$var$Tt + " Internet", $e444d6404c095fa5$var$Ot = "Chrome", $e444d6404c095fa5$var$Mt = $e444d6404c095fa5$var$Ot + " OS", $e444d6404c095fa5$var$At = $e444d6404c095fa5$var$Ot + " " + $e444d6404c095fa5$var$kt, $e444d6404c095fa5$var$Dt = "Internet Explorer", $e444d6404c095fa5$var$Lt = $e444d6404c095fa5$var$Dt + " " + $e444d6404c095fa5$var$bt, $e444d6404c095fa5$var$Nt = "Opera", $e444d6404c095fa5$var$qt = $e444d6404c095fa5$var$Nt + " Mini", $e444d6404c095fa5$var$Bt = "Edge", $e444d6404c095fa5$var$Ht = "Microsoft " + $e444d6404c095fa5$var$Bt, $e444d6404c095fa5$var$Ut = "Firefox", $e444d6404c095fa5$var$jt = $e444d6404c095fa5$var$Ut + " " + $e444d6404c095fa5$var$kt, $e444d6404c095fa5$var$Wt = "Nintendo", $e444d6404c095fa5$var$Gt = "PlayStation", $e444d6404c095fa5$var$zt = "Xbox", $e444d6404c095fa5$var$Vt = $e444d6404c095fa5$var$wt + " " + $e444d6404c095fa5$var$bt, $e444d6404c095fa5$var$Qt = $e444d6404c095fa5$var$bt + " " + $e444d6404c095fa5$var$xt, $e444d6404c095fa5$var$Jt = "Windows", $e444d6404c095fa5$var$Yt = $e444d6404c095fa5$var$Jt + " Phone", $e444d6404c095fa5$var$Xt = "Nokia", $e444d6404c095fa5$var$Kt = "Ouya", $e444d6404c095fa5$var$Zt = "Generic", $e444d6404c095fa5$var$en = $e444d6404c095fa5$var$Zt + " " + $e444d6404c095fa5$var$bt.toLowerCase(), $e444d6404c095fa5$var$tn = $e444d6404c095fa5$var$Zt + " " + $e444d6404c095fa5$var$St.toLowerCase(), $e444d6404c095fa5$var$nn = "Konqueror", $e444d6404c095fa5$var$rn = "(\\d+(\\.\\d+)?)", $e444d6404c095fa5$var$sn = new RegExp("Version/" + $e444d6404c095fa5$var$rn), $e444d6404c095fa5$var$on = new RegExp($e444d6404c095fa5$var$zt, "i"), $e444d6404c095fa5$var$an = new RegExp($e444d6404c095fa5$var$Gt + " \\w+", "i"), $e444d6404c095fa5$var$un = new RegExp($e444d6404c095fa5$var$Wt + " \\w+", "i"), $e444d6404c095fa5$var$ln = new RegExp($e444d6404c095fa5$var$Pt + "|PlayBook|BB10", "i"), $e444d6404c095fa5$var$cn = {
    "NT3.51": "NT 3.11",
    "NT4.0": "NT 4.0",
    "5.0": "2000",
    5.1: "XP",
    5.2: "XP",
    "6.0": "Vista",
    6.1: "7",
    6.2: "8",
    6.3: "8.1",
    6.4: "10",
    "10.0": "10"
};
var $e444d6404c095fa5$var$dn = function(e, t) {
    return t && $e444d6404c095fa5$var$Y(t, $e444d6404c095fa5$var$It) || function(e) {
        return $e444d6404c095fa5$var$Y(e, $e444d6404c095fa5$var$xt) && !$e444d6404c095fa5$var$Y(e, $e444d6404c095fa5$var$Ot) && !$e444d6404c095fa5$var$Y(e, $e444d6404c095fa5$var$wt);
    }(e);
}, $e444d6404c095fa5$var$hn = function(e, t) {
    return t = t || "", $e444d6404c095fa5$var$Y(e, " OPR/") && $e444d6404c095fa5$var$Y(e, "Mini") ? $e444d6404c095fa5$var$qt : $e444d6404c095fa5$var$Y(e, " OPR/") ? $e444d6404c095fa5$var$Nt : $e444d6404c095fa5$var$ln.test(e) ? $e444d6404c095fa5$var$Pt : $e444d6404c095fa5$var$Y(e, "IE" + $e444d6404c095fa5$var$bt) || $e444d6404c095fa5$var$Y(e, "WPDesktop") ? $e444d6404c095fa5$var$Lt : $e444d6404c095fa5$var$Y(e, $e444d6404c095fa5$var$Ct) ? $e444d6404c095fa5$var$$t : $e444d6404c095fa5$var$Y(e, $e444d6404c095fa5$var$Bt) || $e444d6404c095fa5$var$Y(e, "Edg/") ? $e444d6404c095fa5$var$Ht : $e444d6404c095fa5$var$Y(e, "FBIOS") ? "Facebook " + $e444d6404c095fa5$var$bt : $e444d6404c095fa5$var$Y(e, "UCWEB") || $e444d6404c095fa5$var$Y(e, "UCBrowser") ? "UC Browser" : $e444d6404c095fa5$var$Y(e, "CriOS") ? $e444d6404c095fa5$var$At : $e444d6404c095fa5$var$Y(e, "CrMo") ? $e444d6404c095fa5$var$Ot : $e444d6404c095fa5$var$Y(e, $e444d6404c095fa5$var$wt) && $e444d6404c095fa5$var$Y(e, $e444d6404c095fa5$var$xt) ? $e444d6404c095fa5$var$Vt : $e444d6404c095fa5$var$Y(e, $e444d6404c095fa5$var$Ot) ? $e444d6404c095fa5$var$Ot : $e444d6404c095fa5$var$Y(e, "FxiOS") ? $e444d6404c095fa5$var$jt : $e444d6404c095fa5$var$Y(e.toLowerCase(), $e444d6404c095fa5$var$nn.toLowerCase()) ? $e444d6404c095fa5$var$nn : $e444d6404c095fa5$var$dn(e, t) ? $e444d6404c095fa5$var$Y(e, $e444d6404c095fa5$var$bt) ? $e444d6404c095fa5$var$Qt : $e444d6404c095fa5$var$xt : $e444d6404c095fa5$var$Y(e, $e444d6404c095fa5$var$Ut) ? $e444d6404c095fa5$var$Ut : $e444d6404c095fa5$var$Y(e, "MSIE") || $e444d6404c095fa5$var$Y(e, "Trident/") ? $e444d6404c095fa5$var$Dt : $e444d6404c095fa5$var$Y(e, "Gecko") ? $e444d6404c095fa5$var$Ut : "";
}, $e444d6404c095fa5$var$fn = ($e444d6404c095fa5$var$o($e444d6404c095fa5$var$rt = {}, $e444d6404c095fa5$var$Lt, [
    new RegExp("rv:" + $e444d6404c095fa5$var$rn)
]), $e444d6404c095fa5$var$o($e444d6404c095fa5$var$rt, $e444d6404c095fa5$var$Ht, [
    new RegExp($e444d6404c095fa5$var$Bt + "?\\/" + $e444d6404c095fa5$var$rn)
]), $e444d6404c095fa5$var$o($e444d6404c095fa5$var$rt, $e444d6404c095fa5$var$Ot, [
    new RegExp("(" + $e444d6404c095fa5$var$Ot + "|CrMo)\\/" + $e444d6404c095fa5$var$rn)
]), $e444d6404c095fa5$var$o($e444d6404c095fa5$var$rt, $e444d6404c095fa5$var$At, [
    new RegExp("CriOS\\/" + $e444d6404c095fa5$var$rn)
]), $e444d6404c095fa5$var$o($e444d6404c095fa5$var$rt, "UC Browser", [
    new RegExp("(UCBrowser|UCWEB)\\/" + $e444d6404c095fa5$var$rn)
]), $e444d6404c095fa5$var$o($e444d6404c095fa5$var$rt, $e444d6404c095fa5$var$xt, [
    $e444d6404c095fa5$var$sn
]), $e444d6404c095fa5$var$o($e444d6404c095fa5$var$rt, $e444d6404c095fa5$var$Qt, [
    $e444d6404c095fa5$var$sn
]), $e444d6404c095fa5$var$o($e444d6404c095fa5$var$rt, $e444d6404c095fa5$var$Nt, [
    new RegExp("(Opera|OPR)\\/" + $e444d6404c095fa5$var$rn)
]), $e444d6404c095fa5$var$o($e444d6404c095fa5$var$rt, $e444d6404c095fa5$var$Ut, [
    new RegExp($e444d6404c095fa5$var$Ut + "\\/" + $e444d6404c095fa5$var$rn)
]), $e444d6404c095fa5$var$o($e444d6404c095fa5$var$rt, $e444d6404c095fa5$var$jt, [
    new RegExp("FxiOS\\/" + $e444d6404c095fa5$var$rn)
]), $e444d6404c095fa5$var$o($e444d6404c095fa5$var$rt, $e444d6404c095fa5$var$nn, [
    new RegExp("Konqueror[:/]?" + $e444d6404c095fa5$var$rn, "i")
]), $e444d6404c095fa5$var$o($e444d6404c095fa5$var$rt, $e444d6404c095fa5$var$Pt, [
    new RegExp($e444d6404c095fa5$var$Pt + " " + $e444d6404c095fa5$var$rn),
    $e444d6404c095fa5$var$sn
]), $e444d6404c095fa5$var$o($e444d6404c095fa5$var$rt, $e444d6404c095fa5$var$Vt, [
    new RegExp("android\\s" + $e444d6404c095fa5$var$rn, "i")
]), $e444d6404c095fa5$var$o($e444d6404c095fa5$var$rt, $e444d6404c095fa5$var$$t, [
    new RegExp($e444d6404c095fa5$var$Ct + "\\/" + $e444d6404c095fa5$var$rn)
]), $e444d6404c095fa5$var$o($e444d6404c095fa5$var$rt, $e444d6404c095fa5$var$Dt, [
    new RegExp("(rv:|MSIE )" + $e444d6404c095fa5$var$rn)
]), $e444d6404c095fa5$var$o($e444d6404c095fa5$var$rt, "Mozilla", [
    new RegExp("rv:" + $e444d6404c095fa5$var$rn)
]), $e444d6404c095fa5$var$rt), $e444d6404c095fa5$var$pn = [
    [
        new RegExp($e444d6404c095fa5$var$zt + "; " + $e444d6404c095fa5$var$zt + " (.*?)[);]", "i"),
        function(e) {
            return [
                $e444d6404c095fa5$var$zt,
                e && e[1] || ""
            ];
        }
    ],
    [
        new RegExp($e444d6404c095fa5$var$Wt, "i"),
        [
            $e444d6404c095fa5$var$Wt,
            ""
        ]
    ],
    [
        new RegExp($e444d6404c095fa5$var$Gt, "i"),
        [
            $e444d6404c095fa5$var$Gt,
            ""
        ]
    ],
    [
        $e444d6404c095fa5$var$ln,
        [
            $e444d6404c095fa5$var$Pt,
            ""
        ]
    ],
    [
        new RegExp($e444d6404c095fa5$var$Jt, "i"),
        function(e, t) {
            if (/Phone/.test(t) || /WPDesktop/.test(t)) return [
                $e444d6404c095fa5$var$Yt,
                ""
            ];
            if (new RegExp($e444d6404c095fa5$var$bt).test(t) && !/IEMobile\b/.test(t)) return [
                $e444d6404c095fa5$var$Jt + " " + $e444d6404c095fa5$var$bt,
                ""
            ];
            var n = /Windows NT ([0-9.]+)/i.exec(t);
            if (n && n[1]) {
                var i = n[1], r = $e444d6404c095fa5$var$cn[i] || "";
                return /arm/i.test(t) && (r = "RT"), [
                    $e444d6404c095fa5$var$Jt,
                    r
                ];
            }
            return [
                $e444d6404c095fa5$var$Jt,
                ""
            ];
        }
    ],
    [
        /((iPhone|iPad|iPod).*?OS (\d+)_(\d+)_?(\d+)?|iPhone)/,
        function(e) {
            if (e && e[3]) {
                var t = [
                    e[3],
                    e[4],
                    e[5] || "0"
                ];
                return [
                    $e444d6404c095fa5$var$kt,
                    t.join(".")
                ];
            }
            return [
                $e444d6404c095fa5$var$kt,
                ""
            ];
        }
    ],
    [
        /(watch.*\/(\d+\.\d+\.\d+)|watch os,(\d+\.\d+),)/i,
        function(e) {
            var t = "";
            return e && e.length >= 3 && (t = $e444d6404c095fa5$var$w(e[2]) ? e[3] : e[2]), [
                "watchOS",
                t
            ];
        }
    ],
    [
        new RegExp("(" + $e444d6404c095fa5$var$wt + " (\\d+)\\.(\\d+)\\.?(\\d+)?|" + $e444d6404c095fa5$var$wt + ")", "i"),
        function(e) {
            if (e && e[2]) {
                var t = [
                    e[2],
                    e[3],
                    e[4] || "0"
                ];
                return [
                    $e444d6404c095fa5$var$wt,
                    t.join(".")
                ];
            }
            return [
                $e444d6404c095fa5$var$wt,
                ""
            ];
        }
    ],
    [
        /Mac OS X (\d+)[_.](\d+)[_.]?(\d+)?/i,
        function(e) {
            var t = [
                "Mac OS X",
                ""
            ];
            if (e && e[1]) {
                var n = [
                    e[1],
                    e[2],
                    e[3] || "0"
                ];
                t[1] = n.join(".");
            }
            return t;
        }
    ],
    [
        /Mac/i,
        [
            "Mac OS X",
            ""
        ]
    ],
    [
        /CrOS/,
        [
            $e444d6404c095fa5$var$Mt,
            ""
        ]
    ],
    [
        /Linux|debian/i,
        [
            "Linux",
            ""
        ]
    ]
], $e444d6404c095fa5$var$vn = function(e) {
    return $e444d6404c095fa5$var$un.test(e) ? $e444d6404c095fa5$var$Wt : $e444d6404c095fa5$var$an.test(e) ? $e444d6404c095fa5$var$Gt : $e444d6404c095fa5$var$on.test(e) ? $e444d6404c095fa5$var$zt : new RegExp($e444d6404c095fa5$var$Kt, "i").test(e) ? $e444d6404c095fa5$var$Kt : new RegExp("(" + $e444d6404c095fa5$var$Yt + "|WPDesktop)", "i").test(e) ? $e444d6404c095fa5$var$Yt : /iPad/.test(e) ? $e444d6404c095fa5$var$Ft : /iPod/.test(e) ? "iPod Touch" : /iPhone/.test(e) ? "iPhone" : /(watch)(?: ?os[,/]|\d,\d\/)[\d.]+/i.test(e) ? $e444d6404c095fa5$var$Rt : $e444d6404c095fa5$var$ln.test(e) ? $e444d6404c095fa5$var$Pt : /(kobo)\s(ereader|touch)/i.test(e) ? "Kobo" : new RegExp($e444d6404c095fa5$var$Xt, "i").test(e) ? $e444d6404c095fa5$var$Xt : /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i.test(e) || /(kf[a-z]+)( bui|\)).+silk\//i.test(e) ? "Kindle Fire" : /(Android|ZTE)/i.test(e) ? !new RegExp($e444d6404c095fa5$var$bt).test(e) || /(9138B|TB782B|Nexus [97]|pixel c|HUAWEISHT|BTV|noble nook|smart ultra 6)/i.test(e) ? /pixel[\daxl ]{1,6}/i.test(e) && !/pixel c/i.test(e) || /(huaweimed-al00|tah-|APA|SM-G92|i980|zte|U304AA)/i.test(e) || /lmy47v/i.test(e) && !/QTAQZ3/i.test(e) ? $e444d6404c095fa5$var$wt : $e444d6404c095fa5$var$Et : $e444d6404c095fa5$var$wt : new RegExp("(pda|" + $e444d6404c095fa5$var$bt + ")", "i").test(e) ? $e444d6404c095fa5$var$en : new RegExp($e444d6404c095fa5$var$St, "i").test(e) && !new RegExp($e444d6404c095fa5$var$St + " pc", "i").test(e) ? $e444d6404c095fa5$var$tn : "";
}, $e444d6404c095fa5$var$_n = "https?://(.*)", $e444d6404c095fa5$var$gn = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gclid",
    "gad_source",
    "gclsrc",
    "dclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "msclkid",
    "twclid",
    "li_fat_id",
    "mc_cid",
    "igshid",
    "ttclid",
    "rdt_cid"
], $e444d6404c095fa5$var$mn = {
    campaignParams: function(e) {
        return $e444d6404c095fa5$var$D ? this._campaignParamsFromUrl($e444d6404c095fa5$var$D.URL, e) : {};
    },
    _campaignParamsFromUrl: function(e, t) {
        var n = $e444d6404c095fa5$var$gn.concat(t || []), i = {};
        return $e444d6404c095fa5$var$Q(n, function(t) {
            var n = $e444d6404c095fa5$var$mt(e, t);
            n && (i[t] = n);
        }), i;
    },
    _searchEngine: function(e) {
        return e ? 0 === e.search($e444d6404c095fa5$var$_n + "google.([^/?]*)") ? "google" : 0 === e.search($e444d6404c095fa5$var$_n + "bing.com") ? "bing" : 0 === e.search($e444d6404c095fa5$var$_n + "yahoo.com") ? "yahoo" : 0 === e.search($e444d6404c095fa5$var$_n + "duckduckgo.com") ? "duckduckgo" : null : null;
    },
    _searchInfoFromReferrer: function(e) {
        var t = $e444d6404c095fa5$var$mn._searchEngine(e), n = "yahoo" != t ? "q" : "p", i = {};
        if (!$e444d6404c095fa5$var$F(t)) {
            i.$search_engine = t;
            var r = $e444d6404c095fa5$var$D ? $e444d6404c095fa5$var$mt($e444d6404c095fa5$var$D.referrer, n) : "";
            r.length && (i.ph_keyword = r);
        }
        return i;
    },
    searchInfo: function() {
        var e = null == $e444d6404c095fa5$var$D ? void 0 : $e444d6404c095fa5$var$D.referrer;
        return e ? this._searchInfoFromReferrer(e) : {};
    },
    browser: $e444d6404c095fa5$var$hn,
    browserVersion: function(e, t) {
        var n = $e444d6404c095fa5$var$hn(e, t), i = $e444d6404c095fa5$var$fn[n];
        if ($e444d6404c095fa5$var$w(i)) return null;
        for(var r = 0; r < i.length; r++){
            var s = i[r], o = e.match(s);
            if (o) return parseFloat(o[o.length - 2]);
        }
        return null;
    },
    browserLanguage: function() {
        return navigator.language || navigator.userLanguage;
    },
    os: function(e) {
        for(var t = 0; t < $e444d6404c095fa5$var$pn.length; t++){
            var n = $e444d6404c095fa5$var$u($e444d6404c095fa5$var$pn[t], 2), i = n[0], r = n[1], s = i.exec(e), o = s && ($e444d6404c095fa5$var$y(r) ? r(s, e) : r);
            if (o) return o;
        }
        return [
            "",
            ""
        ];
    },
    device: $e444d6404c095fa5$var$vn,
    deviceType: function(e) {
        var t = $e444d6404c095fa5$var$vn(e);
        return t === $e444d6404c095fa5$var$Ft || t === $e444d6404c095fa5$var$Et || "Kobo" === t || "Kindle Fire" === t || t === $e444d6404c095fa5$var$tn ? $e444d6404c095fa5$var$St : t === $e444d6404c095fa5$var$Wt || t === $e444d6404c095fa5$var$zt || t === $e444d6404c095fa5$var$Gt || t === $e444d6404c095fa5$var$Kt ? "Console" : t === $e444d6404c095fa5$var$Rt ? "Wearable" : t ? $e444d6404c095fa5$var$bt : "Desktop";
    },
    referrer: function() {
        return (null == $e444d6404c095fa5$var$D ? void 0 : $e444d6404c095fa5$var$D.referrer) || "$direct";
    },
    referringDomain: function() {
        var e;
        return null != $e444d6404c095fa5$var$D && $e444d6404c095fa5$var$D.referrer && (null === (e = $e444d6404c095fa5$var$vt($e444d6404c095fa5$var$D.referrer)) || void 0 === e ? void 0 : e.host) || "$direct";
    },
    referrerInfo: function() {
        return {
            $referrer: this.referrer(),
            $referring_domain: this.referringDomain()
        };
    },
    initialPersonInfo: function() {
        return {
            r: this.referrer(),
            u: null == $e444d6404c095fa5$var$L ? void 0 : $e444d6404c095fa5$var$L.href
        };
    },
    initialPersonPropsFromInfo: function(e) {
        var t, n = e.r, i = e.u, r = {
            $initial_referrer: n,
            $initial_referring_domain: null == n ? void 0 : "$direct" == n ? "$direct" : null === (t = $e444d6404c095fa5$var$vt(n)) || void 0 === t ? void 0 : t.host
        };
        if (i) {
            r.$initial_current_url = i;
            var s = $e444d6404c095fa5$var$vt(i);
            r.$initial_host = null == s ? void 0 : s.host, r.$initial_pathname = null == s ? void 0 : s.pathname, $e444d6404c095fa5$var$Q(this._campaignParamsFromUrl(i), function(e, t) {
                r["$initial_" + $e444d6404c095fa5$var$ne(t)] = e;
            });
        }
        n && $e444d6404c095fa5$var$Q(this._searchInfoFromReferrer(n), function(e, t) {
            r["$initial_" + $e444d6404c095fa5$var$ne(t)] = e;
        });
        return r;
    },
    properties: function() {
        if (!$e444d6404c095fa5$var$H) return {};
        var e = $e444d6404c095fa5$var$u($e444d6404c095fa5$var$mn.os($e444d6404c095fa5$var$H), 2), t = e[0], n = e[1];
        return $e444d6404c095fa5$var$J($e444d6404c095fa5$var$te({
            $os: t,
            $os_version: n,
            $browser: $e444d6404c095fa5$var$mn.browser($e444d6404c095fa5$var$H, navigator.vendor),
            $device: $e444d6404c095fa5$var$mn.device($e444d6404c095fa5$var$H),
            $device_type: $e444d6404c095fa5$var$mn.deviceType($e444d6404c095fa5$var$H)
        }), {
            $current_url: null == $e444d6404c095fa5$var$L ? void 0 : $e444d6404c095fa5$var$L.href,
            $host: null == $e444d6404c095fa5$var$L ? void 0 : $e444d6404c095fa5$var$L.host,
            $pathname: null == $e444d6404c095fa5$var$L ? void 0 : $e444d6404c095fa5$var$L.pathname,
            $raw_user_agent: $e444d6404c095fa5$var$H.length > 1e3 ? $e444d6404c095fa5$var$H.substring(0, 997) + "..." : $e444d6404c095fa5$var$H,
            $browser_version: $e444d6404c095fa5$var$mn.browserVersion($e444d6404c095fa5$var$H, navigator.vendor),
            $browser_language: $e444d6404c095fa5$var$mn.browserLanguage(),
            $screen_height: null == $e444d6404c095fa5$var$T ? void 0 : $e444d6404c095fa5$var$T.screen.height,
            $screen_width: null == $e444d6404c095fa5$var$T ? void 0 : $e444d6404c095fa5$var$T.screen.width,
            $viewport_height: null == $e444d6404c095fa5$var$T ? void 0 : $e444d6404c095fa5$var$T.innerHeight,
            $viewport_width: null == $e444d6404c095fa5$var$T ? void 0 : $e444d6404c095fa5$var$T.innerWidth,
            $lib: "web",
            $lib_version: $e444d6404c095fa5$var$f.LIB_VERSION,
            $insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10),
            $time: $e444d6404c095fa5$var$K() / 1e3
        });
    },
    people_properties: function() {
        if (!$e444d6404c095fa5$var$H) return {};
        var e = $e444d6404c095fa5$var$u($e444d6404c095fa5$var$mn.os($e444d6404c095fa5$var$H), 2), t = e[0], n = e[1];
        return $e444d6404c095fa5$var$J($e444d6404c095fa5$var$te({
            $os: t,
            $os_version: n,
            $browser: $e444d6404c095fa5$var$mn.browser($e444d6404c095fa5$var$H, navigator.vendor)
        }), {
            $browser_version: $e444d6404c095fa5$var$mn.browserVersion($e444d6404c095fa5$var$H, navigator.vendor)
        });
    }
}, $e444d6404c095fa5$var$yn = [
    "cookie",
    "localstorage",
    "localstorage+cookie",
    "sessionstorage",
    "memory"
], $e444d6404c095fa5$var$bn = function() {
    function e(t) {
        $e444d6404c095fa5$var$i(this, e), this.config = t, this.props = {}, this.campaign_params_saved = !1, this.name = function(e) {
            var t = "";
            return e.token && (t = e.token.replace(/\+/g, "PL").replace(/\//g, "SL").replace(/=/g, "EQ")), e.persistence_name ? "ph_" + e.persistence_name : "ph_" + t + "_posthog";
        }(t), this.storage = this.buildStorage(t), this.load(), this.update_config(t, t), this.save();
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "buildStorage",
            value: function(e) {
                -1 === $e444d6404c095fa5$var$yn.indexOf(e.persistence.toLowerCase()) && ($e444d6404c095fa5$var$W.critical("Unknown persistence type " + e.persistence + "; falling back to localStorage+cookie"), e.persistence = "localStorage+cookie");
                var t = e.persistence.toLowerCase();
                return "localstorage" === t && $e444d6404c095fa5$var$at.is_supported() ? $e444d6404c095fa5$var$at : "localstorage+cookie" === t && $e444d6404c095fa5$var$lt.is_supported() ? $e444d6404c095fa5$var$lt : "sessionstorage" === t && $e444d6404c095fa5$var$ft.is_supported() ? $e444d6404c095fa5$var$ft : "memory" === t ? $e444d6404c095fa5$var$dt : "cookie" === t ? $e444d6404c095fa5$var$st : $e444d6404c095fa5$var$lt.is_supported() ? $e444d6404c095fa5$var$lt : $e444d6404c095fa5$var$st;
            }
        },
        {
            key: "properties",
            value: function() {
                var e = {};
                return $e444d6404c095fa5$var$Q(this.props, function(t, n) {
                    if (n === $e444d6404c095fa5$var$Fe && $e444d6404c095fa5$var$b(t)) for(var i = Object.keys(t), r = 0; r < i.length; r++)e["$feature/".concat(i[r])] = t[i[r]];
                    else o = n, a = !1, ($e444d6404c095fa5$var$F(s = $e444d6404c095fa5$var$Be) ? a : $e444d6404c095fa5$var$M && s.indexOf === $e444d6404c095fa5$var$M ? -1 != s.indexOf(o) : ($e444d6404c095fa5$var$Q(s, function(e) {
                        if (a || (a = e === o)) return $e444d6404c095fa5$var$G;
                    }), a)) || (e[n] = t);
                    var s, o, a;
                }), e;
            }
        },
        {
            key: "load",
            value: function() {
                if (!this.disabled) {
                    var e = this.storage.parse(this.name);
                    e && (this.props = $e444d6404c095fa5$var$J({}, e));
                }
            }
        },
        {
            key: "save",
            value: function() {
                this.disabled || this.storage.set(this.name, this.props, this.expire_days, this.cross_subdomain, this.secure);
            }
        },
        {
            key: "remove",
            value: function() {
                this.storage.remove(this.name, !1), this.storage.remove(this.name, !0);
            }
        },
        {
            key: "clear",
            value: function() {
                this.remove(), this.props = {};
            }
        },
        {
            key: "register_once",
            value: function(e, t, n) {
                var i = this;
                if ($e444d6404c095fa5$var$b(e)) {
                    $e444d6404c095fa5$var$w(t) && (t = "None"), this.expire_days = $e444d6404c095fa5$var$w(n) ? this.default_expiry : n;
                    var r = !1;
                    if ($e444d6404c095fa5$var$Q(e, function(e, n) {
                        i.props.hasOwnProperty(n) && i.props[n] !== t || (i.props[n] = e, r = !0);
                    }), r) return this.save(), !0;
                }
                return !1;
            }
        },
        {
            key: "register",
            value: function(e, t) {
                var n = this;
                if ($e444d6404c095fa5$var$b(e)) {
                    this.expire_days = $e444d6404c095fa5$var$w(t) ? this.default_expiry : t;
                    var i = !1;
                    if ($e444d6404c095fa5$var$Q(e, function(t, r) {
                        e.hasOwnProperty(r) && n.props[r] !== t && (n.props[r] = t, i = !0);
                    }), i) return this.save(), !0;
                }
                return !1;
            }
        },
        {
            key: "unregister",
            value: function(e) {
                e in this.props && (delete this.props[e], this.save());
            }
        },
        {
            key: "update_campaign_params",
            value: function() {
                this.campaign_params_saved || (this.register($e444d6404c095fa5$var$mn.campaignParams(this.config.custom_campaign_params)), this.campaign_params_saved = !0);
            }
        },
        {
            key: "update_search_keyword",
            value: function() {
                this.register($e444d6404c095fa5$var$mn.searchInfo());
            }
        },
        {
            key: "update_referrer_info",
            value: function() {
                this.register($e444d6404c095fa5$var$mn.referrerInfo());
            }
        },
        {
            key: "set_initial_person_info",
            value: function() {
                this.props[$e444d6404c095fa5$var$Ae] || this.props[$e444d6404c095fa5$var$De] || this.register_once($e444d6404c095fa5$var$o({}, $e444d6404c095fa5$var$Le, $e444d6404c095fa5$var$mn.initialPersonInfo()), void 0);
            }
        },
        {
            key: "get_referrer_info",
            value: function() {
                return $e444d6404c095fa5$var$te({
                    $referrer: this.props.$referrer,
                    $referring_domain: this.props.$referring_domain
                });
            }
        },
        {
            key: "get_initial_props",
            value: function() {
                var e = this, t = {};
                $e444d6404c095fa5$var$Q([
                    $e444d6404c095fa5$var$De,
                    $e444d6404c095fa5$var$Ae
                ], function(n) {
                    var i = e.props[n];
                    i && $e444d6404c095fa5$var$Q(i, function(e, n) {
                        t["$initial_" + $e444d6404c095fa5$var$ne(n)] = e;
                    });
                });
                var n = this.props[$e444d6404c095fa5$var$Le];
                if (n) {
                    var i = $e444d6404c095fa5$var$mn.initialPersonPropsFromInfo(n);
                    $e444d6404c095fa5$var$J(t, i);
                }
                return t;
            }
        },
        {
            key: "safe_merge",
            value: function(e) {
                return $e444d6404c095fa5$var$Q(this.props, function(t, n) {
                    n in e || (e[n] = t);
                }), e;
            }
        },
        {
            key: "update_config",
            value: function(e, t) {
                if (this.default_expiry = this.expire_days = e.cookie_expiration, this.set_disabled(e.disable_persistence), this.set_cross_subdomain(e.cross_subdomain_cookie), this.set_secure(e.secure_cookie), e.persistence !== t.persistence) {
                    var n = this.buildStorage(e), i = this.props;
                    this.clear(), this.storage = n, this.props = i, this.save();
                }
            }
        },
        {
            key: "set_disabled",
            value: function(e) {
                this.disabled = e, this.disabled ? this.remove() : this.save();
            }
        },
        {
            key: "set_cross_subdomain",
            value: function(e) {
                e !== this.cross_subdomain && (this.cross_subdomain = e, this.remove(), this.save());
            }
        },
        {
            key: "get_cross_subdomain",
            value: function() {
                return !!this.cross_subdomain;
            }
        },
        {
            key: "set_secure",
            value: function(e) {
                e !== this.secure && (this.secure = e, this.remove(), this.save());
            }
        },
        {
            key: "set_event_timer",
            value: function(e, t) {
                var n = this.props[$e444d6404c095fa5$var$de] || {};
                n[e] = t, this.props[$e444d6404c095fa5$var$de] = n, this.save();
            }
        },
        {
            key: "remove_event_timer",
            value: function(e) {
                var t = (this.props[$e444d6404c095fa5$var$de] || {})[e];
                return $e444d6404c095fa5$var$w(t) || (delete this.props[$e444d6404c095fa5$var$de][e], this.save()), t;
            }
        },
        {
            key: "get_property",
            value: function(e) {
                return this.props[e];
            }
        },
        {
            key: "set_property",
            value: function(e, t) {
                this.props[e] = t, this.save();
            }
        }
    ]), e;
}(), $e444d6404c095fa5$var$kn = 2, $e444d6404c095fa5$var$wn = 4;
var $e444d6404c095fa5$var$Sn = function(e) {
    return e[e.DomContentLoaded = 0] = "DomContentLoaded", e[e.Load = 1] = "Load", e[e.FullSnapshot = 2] = "FullSnapshot", e[e.IncrementalSnapshot = 3] = "IncrementalSnapshot", e[e.Meta = 4] = "Meta", e[e.Custom = 5] = "Custom", e[e.Plugin = 6] = "Plugin", e;
}($e444d6404c095fa5$var$Sn || {}), $e444d6404c095fa5$var$En = function(e) {
    return e[e.Mutation = 0] = "Mutation", e[e.MouseMove = 1] = "MouseMove", e[e.MouseInteraction = 2] = "MouseInteraction", e[e.Scroll = 3] = "Scroll", e[e.ViewportResize = 4] = "ViewportResize", e[e.Input = 5] = "Input", e[e.TouchMove = 6] = "TouchMove", e[e.MediaInteraction = 7] = "MediaInteraction", e[e.StyleSheetRule = 8] = "StyleSheetRule", e[e.CanvasMutation = 9] = "CanvasMutation", e[e.Font = 10] = "Font", e[e.Log = 11] = "Log", e[e.Drag = 12] = "Drag", e[e.StyleDeclaration = 13] = "StyleDeclaration", e[e.Selection = 14] = "Selection", e[e.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", e[e.CustomElement = 16] = "CustomElement", e;
}($e444d6404c095fa5$var$En || {});
function $e444d6404c095fa5$var$Fn(e) {
    return e ? $e444d6404c095fa5$var$z(e).split(/\s+/) : [];
}
function $e444d6404c095fa5$var$In(e) {
    var t = "";
    switch($e444d6404c095fa5$var$n(e.className)){
        case "string":
            t = e.className;
            break;
        case "object":
            t = ("baseVal" in e.className ? e.className.baseVal : null) || e.getAttribute("class") || "";
            break;
        default:
            t = "";
    }
    return $e444d6404c095fa5$var$Fn(t);
}
function $e444d6404c095fa5$var$Rn(e) {
    return $e444d6404c095fa5$var$I(e) ? null : $e444d6404c095fa5$var$z(e).split(/(\s+)/).filter(function(e) {
        return $e444d6404c095fa5$var$Wn(e);
    }).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
}
function $e444d6404c095fa5$var$xn(e) {
    var t = "";
    return $e444d6404c095fa5$var$Dn(e) && !$e444d6404c095fa5$var$Ln(e) && e.childNodes && e.childNodes.length && $e444d6404c095fa5$var$Q(e.childNodes, function(e) {
        var n;
        $e444d6404c095fa5$var$Cn(e) && e.textContent && (t += null !== (n = $e444d6404c095fa5$var$Rn(e.textContent)) && void 0 !== n ? n : "");
    }), $e444d6404c095fa5$var$z(t);
}
function $e444d6404c095fa5$var$Pn(e) {
    return !!e && 1 === e.nodeType;
}
function $e444d6404c095fa5$var$Tn(e, t) {
    return !!e && !!e.tagName && e.tagName.toLowerCase() === t.toLowerCase();
}
function $e444d6404c095fa5$var$Cn(e) {
    return !!e && 3 === e.nodeType;
}
function $e444d6404c095fa5$var$$n(e) {
    return !!e && 11 === e.nodeType;
}
var $e444d6404c095fa5$var$On = [
    "a",
    "button",
    "form",
    "input",
    "select",
    "textarea",
    "label"
];
function $e444d6404c095fa5$var$Mn(e) {
    var t = e.parentNode;
    return !(!t || !$e444d6404c095fa5$var$Pn(t)) && t;
}
function $e444d6404c095fa5$var$An(e, t) {
    var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0, r = arguments.length > 3 ? arguments[3] : void 0, s = arguments.length > 4 ? arguments[4] : void 0;
    if (!$e444d6404c095fa5$var$T || !e || $e444d6404c095fa5$var$Tn(e, "html") || !$e444d6404c095fa5$var$Pn(e)) return !1;
    if (null != i && i.url_allowlist) {
        var o = $e444d6404c095fa5$var$T.location.href, a = i.url_allowlist;
        if (a && !a.some(function(e) {
            return o.match(e);
        })) return !1;
    }
    if (null != i && i.dom_event_allowlist) {
        var u = i.dom_event_allowlist;
        if (u && !u.some(function(e) {
            return t.type === e;
        })) return !1;
    }
    for(var l = !1, c = [
        e
    ], d = !0, f = e; f.parentNode && !$e444d6404c095fa5$var$Tn(f, "body");)if ($e444d6404c095fa5$var$$n(f.parentNode)) c.push(f.parentNode.host), f = f.parentNode.host;
    else {
        if (!(d = $e444d6404c095fa5$var$Mn(f))) break;
        if (r || $e444d6404c095fa5$var$On.indexOf(d.tagName.toLowerCase()) > -1) l = !0;
        else {
            var p = $e444d6404c095fa5$var$T.getComputedStyle(d);
            p && "pointer" === p.getPropertyValue("cursor") && (l = !0);
        }
        c.push(d), f = d;
    }
    if (!function(e, t) {
        var i = null == t ? void 0 : t.element_allowlist;
        if ($e444d6404c095fa5$var$w(i)) return !0;
        var r, s = $e444d6404c095fa5$var$h(e);
        try {
            var o = function() {
                var e = r.value;
                if (i.some(function(t) {
                    return e.tagName.toLowerCase() === t;
                })) return {
                    v: !0
                };
            };
            for(s.s(); !(r = s.n()).done;){
                var a = o();
                if ("object" === $e444d6404c095fa5$var$n(a)) return a.v;
            }
        } catch (e) {
            s.e(e);
        } finally{
            s.f();
        }
        return !1;
    }(c, i)) return !1;
    if (!function(e, t) {
        var i = null == t ? void 0 : t.css_selector_allowlist;
        if ($e444d6404c095fa5$var$w(i)) return !0;
        var r, s = $e444d6404c095fa5$var$h(e);
        try {
            var o = function() {
                var e = r.value;
                if (i.some(function(t) {
                    return e.matches(t);
                })) return {
                    v: !0
                };
            };
            for(s.s(); !(r = s.n()).done;){
                var a = o();
                if ("object" === $e444d6404c095fa5$var$n(a)) return a.v;
            }
        } catch (e) {
            s.e(e);
        } finally{
            s.f();
        }
        return !1;
    }(c, i)) return !1;
    var v = $e444d6404c095fa5$var$T.getComputedStyle(e);
    if (v && "pointer" === v.getPropertyValue("cursor") && "click" === t.type) return !0;
    var _ = e.tagName.toLowerCase();
    switch(_){
        case "html":
            return !1;
        case "form":
            return (s || [
                "submit"
            ]).indexOf(t.type) >= 0;
        case "input":
        case "select":
        case "textarea":
            return (s || [
                "change",
                "click"
            ]).indexOf(t.type) >= 0;
        default:
            return l ? (s || [
                "click"
            ]).indexOf(t.type) >= 0 : (s || [
                "click"
            ]).indexOf(t.type) >= 0 && ($e444d6404c095fa5$var$On.indexOf(_) > -1 || "true" === e.getAttribute("contenteditable"));
    }
}
function $e444d6404c095fa5$var$Dn(e) {
    for(var t = e; t.parentNode && !$e444d6404c095fa5$var$Tn(t, "body"); t = t.parentNode){
        var n = $e444d6404c095fa5$var$In(t);
        if ($e444d6404c095fa5$var$Y(n, "ph-sensitive") || $e444d6404c095fa5$var$Y(n, "ph-no-capture")) return !1;
    }
    if ($e444d6404c095fa5$var$Y($e444d6404c095fa5$var$In(e), "ph-include")) return !0;
    var i = e.type || "";
    if ($e444d6404c095fa5$var$S(i)) switch(i.toLowerCase()){
        case "hidden":
        case "password":
            return !1;
    }
    var r = e.name || e.id || "";
    if ($e444d6404c095fa5$var$S(r)) {
        if (/^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(r.replace(/[^a-zA-Z0-9]/g, ""))) return !1;
    }
    return !0;
}
function $e444d6404c095fa5$var$Ln(e) {
    return !!($e444d6404c095fa5$var$Tn(e, "input") && ![
        "button",
        "checkbox",
        "submit",
        "reset"
    ].includes(e.type) || $e444d6404c095fa5$var$Tn(e, "select") || $e444d6404c095fa5$var$Tn(e, "textarea") || "true" === e.getAttribute("contenteditable"));
}
var $e444d6404c095fa5$var$Nn = "(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11})", $e444d6404c095fa5$var$qn = new RegExp("^(?:".concat($e444d6404c095fa5$var$Nn, ")$")), $e444d6404c095fa5$var$Bn = new RegExp($e444d6404c095fa5$var$Nn), $e444d6404c095fa5$var$Hn = "\\d{3}-?\\d{2}-?\\d{4}", $e444d6404c095fa5$var$Un = new RegExp("^(".concat($e444d6404c095fa5$var$Hn, ")$")), $e444d6404c095fa5$var$jn = new RegExp("(".concat($e444d6404c095fa5$var$Hn, ")"));
function $e444d6404c095fa5$var$Wn(e) {
    var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
    if ($e444d6404c095fa5$var$I(e)) return !1;
    if ($e444d6404c095fa5$var$S(e)) {
        if (e = $e444d6404c095fa5$var$z(e), (t ? $e444d6404c095fa5$var$qn : $e444d6404c095fa5$var$Bn).test((e || "").replace(/[- ]/g, ""))) return !1;
        if ((t ? $e444d6404c095fa5$var$Un : $e444d6404c095fa5$var$jn).test(e)) return !1;
    }
    return !0;
}
function $e444d6404c095fa5$var$Gn(e) {
    var t = $e444d6404c095fa5$var$xn(e);
    return $e444d6404c095fa5$var$Wn(t = "".concat(t, " ").concat($e444d6404c095fa5$var$zn(e)).trim()) ? t : "";
}
function $e444d6404c095fa5$var$zn(e) {
    var t = "";
    return e && e.childNodes && e.childNodes.length && $e444d6404c095fa5$var$Q(e.childNodes, function(e) {
        var n;
        if (e && "span" === (null === (n = e.tagName) || void 0 === n ? void 0 : n.toLowerCase())) try {
            var i = $e444d6404c095fa5$var$xn(e);
            t = "".concat(t, " ").concat(i).trim(), e.childNodes && e.childNodes.length && (t = "".concat(t, " ").concat($e444d6404c095fa5$var$zn(e)).trim());
        } catch (e) {
            $e444d6404c095fa5$var$W.error(e);
        }
    }), t;
}
function $e444d6404c095fa5$var$Vn(e) {
    return function(e) {
        var n = e.map(function(e) {
            var n, i, r = "";
            if (e.tag_name && (r += e.tag_name), e.attr_class) {
                e.attr_class.sort();
                var s, o = $e444d6404c095fa5$var$h(e.attr_class);
                try {
                    for(o.s(); !(s = o.n()).done;){
                        var a = s.value;
                        r += ".".concat(a.replace(/"/g, ""));
                    }
                } catch (e) {
                    o.e(e);
                } finally{
                    o.f();
                }
            }
            var l = $e444d6404c095fa5$var$t($e444d6404c095fa5$var$t($e444d6404c095fa5$var$t($e444d6404c095fa5$var$t({}, e.text ? {
                text: e.text
            } : {}), {}, {
                "nth-child": null !== (n = e.nth_child) && void 0 !== n ? n : 0,
                "nth-of-type": null !== (i = e.nth_of_type) && void 0 !== i ? i : 0
            }, e.href ? {
                href: e.href
            } : {}), e.attr_id ? {
                attr_id: e.attr_id
            } : {}), e.attributes), c = {};
            return $e444d6404c095fa5$var$X(l).sort(function(e, t) {
                var n = $e444d6404c095fa5$var$u(e, 1)[0], i = $e444d6404c095fa5$var$u(t, 1)[0];
                return n.localeCompare(i);
            }).forEach(function(e) {
                var t = $e444d6404c095fa5$var$u(e, 2), n = t[0], i = t[1];
                return c[$e444d6404c095fa5$var$Qn(n.toString())] = $e444d6404c095fa5$var$Qn(i.toString());
            }), r += ":", r += $e444d6404c095fa5$var$X(l).map(function(e) {
                var t = $e444d6404c095fa5$var$u(e, 2), n = t[0], i = t[1];
                return "".concat(n, '="').concat(i, '"');
            }).join("");
        });
        return n.join(";");
    }(function(e) {
        return e.map(function(e) {
            var t, n, i = {
                text: null === (t = e.$el_text) || void 0 === t ? void 0 : t.slice(0, 400),
                tag_name: e.tag_name,
                href: null === (n = e.attr__href) || void 0 === n ? void 0 : n.slice(0, 2048),
                attr_class: $e444d6404c095fa5$var$Jn(e),
                attr_id: e.attr__id,
                nth_child: e.nth_child,
                nth_of_type: e.nth_of_type,
                attributes: {}
            };
            return $e444d6404c095fa5$var$X(e).filter(function(e) {
                return 0 === $e444d6404c095fa5$var$u(e, 1)[0].indexOf("attr__");
            }).forEach(function(e) {
                var t = $e444d6404c095fa5$var$u(e, 2), n = t[0], r = t[1];
                return i.attributes[n] = r;
            }), i;
        });
    }(e));
}
function $e444d6404c095fa5$var$Qn(e) {
    return e.replace(/"|\\"/g, '\\"');
}
function $e444d6404c095fa5$var$Jn(e) {
    var t = e.attr__class;
    return t ? $e444d6404c095fa5$var$m(t) ? t : $e444d6404c095fa5$var$Fn(t) : void 0;
}
var $e444d6404c095fa5$var$Yn = "[SessionRecording]", $e444d6404c095fa5$var$Xn = "redacted", $e444d6404c095fa5$var$Kn = {
    initiatorTypes: [
        "audio",
        "beacon",
        "body",
        "css",
        "early-hint",
        "embed",
        "fetch",
        "frame",
        "iframe",
        "icon",
        "image",
        "img",
        "input",
        "link",
        "navigation",
        "object",
        "ping",
        "script",
        "track",
        "video",
        "xmlhttprequest"
    ],
    maskRequestFn: function(e) {
        return e;
    },
    recordHeaders: !1,
    recordBody: !1,
    recordInitialRequests: !1,
    recordPerformance: !1,
    performanceEntryTypeToObserve: [
        "first-input",
        "navigation",
        "paint",
        "resource"
    ],
    payloadSizeLimitBytes: 1e6,
    payloadHostDenyList: [
        ".lr-ingest.io",
        ".ingest.sentry.io"
    ]
}, $e444d6404c095fa5$var$Zn = [
    "authorization",
    "x-forwarded-for",
    "authorization",
    "cookie",
    "set-cookie",
    "x-api-key",
    "x-real-ip",
    "remote-addr",
    "forwarded",
    "proxy-authorization",
    "x-csrf-token",
    "x-csrftoken",
    "x-xsrf-token"
], $e444d6404c095fa5$var$ei = [
    "password",
    "secret",
    "passwd",
    "api_key",
    "apikey",
    "auth",
    "credentials",
    "mysql_pwd",
    "privatekey",
    "private_key",
    "token"
], $e444d6404c095fa5$var$ti = [
    "/s/",
    "/e/",
    "/i/"
];
function $e444d6404c095fa5$var$ni(e, t, n, i) {
    if ($e444d6404c095fa5$var$I(e)) return e;
    var r = (null == t ? void 0 : t["content-length"]) || function(e) {
        return new Blob([
            e
        ]).size;
    }(e);
    return $e444d6404c095fa5$var$S(r) && (r = parseInt(r)), r > n ? $e444d6404c095fa5$var$Yn + " ".concat(i, " body too large to record (").concat(r, " bytes)") : e;
}
function $e444d6404c095fa5$var$ii(e, t) {
    if ($e444d6404c095fa5$var$I(e)) return e;
    var n = e;
    return $e444d6404c095fa5$var$Wn(n, !1) || (n = $e444d6404c095fa5$var$Yn + " " + t + " body " + $e444d6404c095fa5$var$Xn), $e444d6404c095fa5$var$Q($e444d6404c095fa5$var$ei, function(e) {
        var i, r;
        null !== (i = n) && void 0 !== i && i.length && -1 !== (null === (r = n) || void 0 === r ? void 0 : r.indexOf(e)) && (n = $e444d6404c095fa5$var$Yn + " " + t + " body " + $e444d6404c095fa5$var$Xn + " as might contain: " + e);
    }), n;
}
var $e444d6404c095fa5$var$ri = function(e, n) {
    var i, r, s, o = {
        payloadSizeLimitBytes: $e444d6404c095fa5$var$Kn.payloadSizeLimitBytes,
        performanceEntryTypeToObserve: $e444d6404c095fa5$var$l($e444d6404c095fa5$var$Kn.performanceEntryTypeToObserve),
        payloadHostDenyList: [].concat($e444d6404c095fa5$var$l(n.payloadHostDenyList || []), $e444d6404c095fa5$var$l($e444d6404c095fa5$var$Kn.payloadHostDenyList))
    }, a = !1 !== e.session_recording.recordHeaders && n.recordHeaders, u = !1 !== e.session_recording.recordBody && n.recordBody, c = !1 !== e.capture_performance && n.recordPerformance, d = (i = o, s = Math.min(1e6, null !== (r = i.payloadSizeLimitBytes) && void 0 !== r ? r : 1e6), function(e) {
        return null != e && e.requestBody && (e.requestBody = $e444d6404c095fa5$var$ni(e.requestBody, e.requestHeaders, s, "Request")), null != e && e.responseBody && (e.responseBody = $e444d6404c095fa5$var$ni(e.responseBody, e.responseHeaders, s, "Response")), e;
    }), h = function(e) {
        var t, n;
        return d(function(e) {
            var t = $e444d6404c095fa5$var$vt(e.name);
            if (!(t && t.pathname && $e444d6404c095fa5$var$ti.some(function(e) {
                return 0 === t.pathname.indexOf(e);
            }))) return e;
        }((n = (t = e).requestHeaders, $e444d6404c095fa5$var$I(n) || $e444d6404c095fa5$var$Q(Object.keys(null != n ? n : {}), function(e) {
            $e444d6404c095fa5$var$Zn.includes(e.toLowerCase()) && (n[e] = $e444d6404c095fa5$var$Xn);
        }), t)));
    }, f = $e444d6404c095fa5$var$y(e.session_recording.maskNetworkRequestFn);
    return f && $e444d6404c095fa5$var$y(e.session_recording.maskCapturedNetworkRequestFn) && $e444d6404c095fa5$var$W.warn("Both `maskNetworkRequestFn` and `maskCapturedNetworkRequestFn` are defined. `maskNetworkRequestFn` will be ignored."), f && (e.session_recording.maskCapturedNetworkRequestFn = function(n) {
        var i = e.session_recording.maskNetworkRequestFn({
            url: n.name
        });
        return $e444d6404c095fa5$var$t($e444d6404c095fa5$var$t({}, n), {}, {
            name: null == i ? void 0 : i.url
        });
    }), o.maskRequestFn = $e444d6404c095fa5$var$y(e.session_recording.maskCapturedNetworkRequestFn) ? function(t) {
        var n, i, r, s = h(t);
        return s && null !== (n = null === (i = (r = e.session_recording).maskCapturedNetworkRequestFn) || void 0 === i ? void 0 : i.call(r, s)) && void 0 !== n ? n : void 0;
    } : function(e) {
        return function(e) {
            if (!$e444d6404c095fa5$var$w(e)) return e.requestBody = $e444d6404c095fa5$var$ii(e.requestBody, "Request"), e.responseBody = $e444d6404c095fa5$var$ii(e.responseBody, "Response"), e;
        }(h(e));
    }, $e444d6404c095fa5$var$t($e444d6404c095fa5$var$t($e444d6404c095fa5$var$t({}, $e444d6404c095fa5$var$Kn), o), {}, {
        recordHeaders: a,
        recordBody: u,
        recordPerformance: c,
        recordInitialRequests: c
    });
}, $e444d6404c095fa5$var$si = $e444d6404c095fa5$var$s(function e(t) {
    var n, r, s = this, a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    $e444d6404c095fa5$var$i(this, e), $e444d6404c095fa5$var$o(this, "bucketSize", 100), $e444d6404c095fa5$var$o(this, "refillRate", 10), $e444d6404c095fa5$var$o(this, "mutationBuckets", {}), $e444d6404c095fa5$var$o(this, "loggedTracker", {}), $e444d6404c095fa5$var$o(this, "refillBuckets", function() {
        Object.keys(s.mutationBuckets).forEach(function(e) {
            s.mutationBuckets[e] = s.mutationBuckets[e] + s.refillRate, s.mutationBuckets[e] >= s.bucketSize && delete s.mutationBuckets[e];
        });
    }), $e444d6404c095fa5$var$o(this, "getNodeOrRelevantParent", function(e) {
        var t = s.rrweb.mirror.getNode(e);
        if ("svg" !== (null == t ? void 0 : t.nodeName) && t instanceof Element) {
            var n = t.closest("svg");
            if (n) return [
                s.rrweb.mirror.getId(n),
                n
            ];
        }
        return [
            e,
            t
        ];
    }), $e444d6404c095fa5$var$o(this, "numberOfChanges", function(e) {
        var t, n, i, r, s, o, a, u;
        return (null !== (t = null === (n = e.removes) || void 0 === n ? void 0 : n.length) && void 0 !== t ? t : 0) + (null !== (i = null === (r = e.attributes) || void 0 === r ? void 0 : r.length) && void 0 !== i ? i : 0) + (null !== (s = null === (o = e.texts) || void 0 === o ? void 0 : o.length) && void 0 !== s ? s : 0) + (null !== (a = null === (u = e.adds) || void 0 === u ? void 0 : u.length) && void 0 !== a ? a : 0);
    }), $e444d6404c095fa5$var$o(this, "throttleMutations", function(e) {
        if (3 !== e.type || 0 !== e.data.source) return e;
        var t = e.data, n = s.numberOfChanges(t);
        t.attributes && (t.attributes = t.attributes.filter(function(e) {
            var t, n, i, r = $e444d6404c095fa5$var$u(s.getNodeOrRelevantParent(e.id), 2), o = r[0], a = r[1];
            if (0 === s.mutationBuckets[o]) return !1;
            (s.mutationBuckets[o] = null !== (t = s.mutationBuckets[o]) && void 0 !== t ? t : s.bucketSize, s.mutationBuckets[o] = Math.max(s.mutationBuckets[o] - 1, 0), 0 === s.mutationBuckets[o]) && (s.loggedTracker[o] || (s.loggedTracker[o] = !0, null === (n = (i = s.options).onBlockedNode) || void 0 === n || n.call(i, o, a)));
            return e;
        }));
        var i = s.numberOfChanges(t);
        return 0 !== i || n === i ? e : void 0;
    }), this.rrweb = t, this.options = a, this.refillRate = null !== (n = this.options.refillRate) && void 0 !== n ? n : this.refillRate, this.bucketSize = null !== (r = this.options.bucketSize) && void 0 !== r ? r : this.bucketSize, setInterval(function() {
        s.refillBuckets();
    }, 1e3);
}), $e444d6404c095fa5$var$oi = 3e5, $e444d6404c095fa5$var$ai = [
    $e444d6404c095fa5$var$En.MouseMove,
    $e444d6404c095fa5$var$En.MouseInteraction,
    $e444d6404c095fa5$var$En.Scroll,
    $e444d6404c095fa5$var$En.ViewportResize,
    $e444d6404c095fa5$var$En.Input,
    $e444d6404c095fa5$var$En.TouchMove,
    $e444d6404c095fa5$var$En.MediaInteraction,
    $e444d6404c095fa5$var$En.Drag
], $e444d6404c095fa5$var$ui = function(e) {
    return {
        rrwebMethod: e,
        enqueuedAt: Date.now(),
        attempt: 1
    };
}, $e444d6404c095fa5$var$li = "[SessionRecording]";
function $e444d6404c095fa5$var$ci(e) {
    var t;
    return JSON.stringify(e, (t = [], function(e, n) {
        if ($e444d6404c095fa5$var$b(n)) {
            for(; t.length > 0 && t.at(-1) !== this;)t.pop();
            return t.includes(n) ? "[Circular]" : (t.push(n), n);
        }
        return n;
    })).length;
}
var $e444d6404c095fa5$var$di, $e444d6404c095fa5$var$hi = function() {
    function e(t) {
        var n = this;
        if ($e444d6404c095fa5$var$i(this, e), $e444d6404c095fa5$var$o(this, "queuedRRWebEvents", []), $e444d6404c095fa5$var$o(this, "isIdle", !1), $e444d6404c095fa5$var$o(this, "_linkedFlagSeen", !1), $e444d6404c095fa5$var$o(this, "_lastActivityTimestamp", Date.now()), $e444d6404c095fa5$var$o(this, "_linkedFlag", null), $e444d6404c095fa5$var$o(this, "_forceAllowLocalhostNetworkCapture", !1), $e444d6404c095fa5$var$o(this, "_samplingSessionListener", null), this.instance = t, this._captureStarted = !1, this._endpoint = "/s/", this.stopRrweb = void 0, this.receivedDecide = !1, null == $e444d6404c095fa5$var$T || $e444d6404c095fa5$var$T.addEventListener("beforeunload", function() {
            n._flushBuffer();
        }), null == $e444d6404c095fa5$var$T || $e444d6404c095fa5$var$T.addEventListener("offline", function() {
            n._tryAddCustomEvent("browser offline", {});
        }), null == $e444d6404c095fa5$var$T || $e444d6404c095fa5$var$T.addEventListener("online", function() {
            n._tryAddCustomEvent("browser online", {});
        }), null == $e444d6404c095fa5$var$T || $e444d6404c095fa5$var$T.addEventListener("visibilitychange", function() {
            if (null != $e444d6404c095fa5$var$D && $e444d6404c095fa5$var$D.visibilityState) {
                var e = "window " + $e444d6404c095fa5$var$D.visibilityState;
                n._tryAddCustomEvent(e, {});
            }
        }), !this.instance.sessionManager) throw $e444d6404c095fa5$var$W.error($e444d6404c095fa5$var$li + " started without valid sessionManager"), new Error($e444d6404c095fa5$var$li + " started without valid sessionManager. This is a bug.");
        var r = this.sessionManager.checkAndGetSessionAndWindowId(), s = r.sessionId, a = r.windowId;
        this.sessionId = s, this.windowId = a, this.buffer = this.clearBuffer(), this._setupSampling();
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "rrwebRecord",
            get: function() {
                var e;
                return null == $e444d6404c095fa5$var$U || null === (e = $e444d6404c095fa5$var$U.rrweb) || void 0 === e ? void 0 : e.record;
            }
        },
        {
            key: "started",
            get: function() {
                return this._captureStarted;
            }
        },
        {
            key: "sessionManager",
            get: function() {
                if (!this.instance.sessionManager) throw new Error($e444d6404c095fa5$var$li + " must be started with a valid sessionManager.");
                return this.instance.sessionManager;
            }
        },
        {
            key: "fullSnapshotIntervalMillis",
            get: function() {
                var e;
                return (null === (e = this.instance.config.session_recording) || void 0 === e ? void 0 : e.full_snapshot_interval_millis) || $e444d6404c095fa5$var$oi;
            }
        },
        {
            key: "isSampled",
            get: function() {
                var e = this.instance.get_property($e444d6404c095fa5$var$Ee);
                return $e444d6404c095fa5$var$x(e) ? e : null;
            }
        },
        {
            key: "sessionDuration",
            get: function() {
                var e, t, n = null === (e = this.buffer) || void 0 === e ? void 0 : e.data[(null === (t = this.buffer) || void 0 === t ? void 0 : t.data.length) - 1], i = this.sessionManager.checkAndGetSessionAndWindowId(!0).sessionStartTimestamp;
                return n ? n.timestamp - i : null;
            }
        },
        {
            key: "isRecordingEnabled",
            get: function() {
                var e = !!this.instance.get_property($e444d6404c095fa5$var$ge), t = !this.instance.config.disable_session_recording;
                return $e444d6404c095fa5$var$T && e && t;
            }
        },
        {
            key: "isConsoleLogCaptureEnabled",
            get: function() {
                var e = !!this.instance.get_property($e444d6404c095fa5$var$me), t = this.instance.config.enable_recording_console_log;
                return null != t ? t : e;
            }
        },
        {
            key: "canvasRecording",
            get: function() {
                var e = this.instance.get_property($e444d6404c095fa5$var$be);
                return e && e.fps && e.quality ? {
                    enabled: e.enabled,
                    fps: e.fps,
                    quality: e.quality
                } : void 0;
            }
        },
        {
            key: "networkPayloadCapture",
            get: function() {
                var e, t, n = this.instance.get_property($e444d6404c095fa5$var$ye), i = {
                    recordHeaders: null === (e = this.instance.config.session_recording) || void 0 === e ? void 0 : e.recordHeaders,
                    recordBody: null === (t = this.instance.config.session_recording) || void 0 === t ? void 0 : t.recordBody
                }, r = (null == i ? void 0 : i.recordHeaders) || (null == n ? void 0 : n.recordHeaders), s = (null == i ? void 0 : i.recordBody) || (null == n ? void 0 : n.recordBody), o = $e444d6404c095fa5$var$b(this.instance.config.capture_performance) ? this.instance.config.capture_performance.network_timing : this.instance.config.capture_performance, a = !!($e444d6404c095fa5$var$x(o) ? o : null == n ? void 0 : n.capturePerformance);
                return r || s || a ? {
                    recordHeaders: r,
                    recordBody: s,
                    recordPerformance: a
                } : void 0;
            }
        },
        {
            key: "sampleRate",
            get: function() {
                var e = this.instance.get_property($e444d6404c095fa5$var$ke);
                return $e444d6404c095fa5$var$R(e) ? e : null;
            }
        },
        {
            key: "minimumDuration",
            get: function() {
                var e = this.instance.get_property($e444d6404c095fa5$var$we);
                return $e444d6404c095fa5$var$R(e) ? e : null;
            }
        },
        {
            key: "status",
            get: function() {
                return this.receivedDecide ? this.isRecordingEnabled ? $e444d6404c095fa5$var$I(this._linkedFlag) || this._linkedFlagSeen ? $e444d6404c095fa5$var$x(this.isSampled) ? this.isSampled ? "sampled" : "disabled" : "active" : "buffering" : "disabled" : "buffering";
            }
        },
        {
            key: "startIfEnabledOrStop",
            value: function() {
                this.isRecordingEnabled ? (this._startCapture(), $e444d6404c095fa5$var$W.info($e444d6404c095fa5$var$li + " started")) : (this.stopRecording(), this.clearBuffer());
            }
        },
        {
            key: "stopRecording",
            value: function() {
                this._captureStarted && this.stopRrweb && (this.stopRrweb(), this.stopRrweb = void 0, this._captureStarted = !1, $e444d6404c095fa5$var$W.info($e444d6404c095fa5$var$li + " stopped"));
            }
        },
        {
            key: "makeSamplingDecision",
            value: function(e) {
                var t, n = this.sessionId !== e, i = this.sampleRate;
                if ($e444d6404c095fa5$var$R(i)) {
                    var r, s = this.isSampled, a = n || !$e444d6404c095fa5$var$x(s);
                    if (a) r = Math.random() < i;
                    else r = s;
                    !r && a && $e444d6404c095fa5$var$W.warn($e444d6404c095fa5$var$li + " Sample rate (".concat(i, ") has determined that this sessionId (").concat(e, ") will not be sent to the server.")), this._tryAddCustomEvent("samplingDecisionMade", {
                        sampleRate: i
                    }), null === (t = this.instance.persistence) || void 0 === t || t.register($e444d6404c095fa5$var$o({}, $e444d6404c095fa5$var$Ee, r));
                } else {
                    var u;
                    null === (u = this.instance.persistence) || void 0 === u || u.register($e444d6404c095fa5$var$o({}, $e444d6404c095fa5$var$Ee, null));
                }
            }
        },
        {
            key: "afterDecideResponse",
            value: function(e) {
                var t, n, i, r = this;
                (this._persistDecideResponse(e), this._linkedFlag = (null === (t = e.sessionRecording) || void 0 === t ? void 0 : t.linkedFlag) || null, null !== (n = e.sessionRecording) && void 0 !== n && n.endpoint) && (this._endpoint = null === (i = e.sessionRecording) || void 0 === i ? void 0 : i.endpoint);
                if (this._setupSampling(), !$e444d6404c095fa5$var$I(this._linkedFlag)) {
                    var s = $e444d6404c095fa5$var$S(this._linkedFlag) ? this._linkedFlag : this._linkedFlag.flag, o = $e444d6404c095fa5$var$S(this._linkedFlag) ? null : this._linkedFlag.variant;
                    this.instance.onFeatureFlags(function(e, t) {
                        var n = $e444d6404c095fa5$var$b(t) && s in t, i = o ? t[s] === o : n;
                        if (i) {
                            var a = {
                                linkedFlag: s,
                                linkedVariant: o
                            }, u = "linked flag matched";
                            $e444d6404c095fa5$var$W.info($e444d6404c095fa5$var$li + " " + u, a), r._tryAddCustomEvent(u, a);
                        }
                        r._linkedFlagSeen = i;
                    });
                }
                this.receivedDecide = !0, this.startIfEnabledOrStop();
            }
        },
        {
            key: "_setupSampling",
            value: function() {
                var e = this;
                $e444d6404c095fa5$var$R(this.sampleRate) && $e444d6404c095fa5$var$F(this._samplingSessionListener) && (this._samplingSessionListener = this.sessionManager.onSessionId(function(t) {
                    e.makeSamplingDecision(t);
                }));
            }
        },
        {
            key: "_persistDecideResponse",
            value: function(e) {
                if (this.instance.persistence) {
                    var n = this.instance.persistence, i = function() {
                        var i, r, s, a, u, l, c, d, h = null === (i = e.sessionRecording) || void 0 === i ? void 0 : i.sampleRate, f = $e444d6404c095fa5$var$I(h) ? null : parseFloat(h), p = null === (r = e.sessionRecording) || void 0 === r ? void 0 : r.minimumDurationMilliseconds;
                        n.register(($e444d6404c095fa5$var$o(d = {}, $e444d6404c095fa5$var$ge, !!e.sessionRecording), $e444d6404c095fa5$var$o(d, $e444d6404c095fa5$var$me, null === (s = e.sessionRecording) || void 0 === s ? void 0 : s.consoleLogRecordingEnabled), $e444d6404c095fa5$var$o(d, $e444d6404c095fa5$var$ye, $e444d6404c095fa5$var$t({
                            capturePerformance: e.capturePerformance
                        }, null === (a = e.sessionRecording) || void 0 === a ? void 0 : a.networkPayloadCapture)), $e444d6404c095fa5$var$o(d, $e444d6404c095fa5$var$be, {
                            enabled: null === (u = e.sessionRecording) || void 0 === u ? void 0 : u.recordCanvas,
                            fps: null === (l = e.sessionRecording) || void 0 === l ? void 0 : l.canvasFps,
                            quality: null === (c = e.sessionRecording) || void 0 === c ? void 0 : c.canvasQuality
                        }), $e444d6404c095fa5$var$o(d, $e444d6404c095fa5$var$ke, f), $e444d6404c095fa5$var$o(d, $e444d6404c095fa5$var$we, $e444d6404c095fa5$var$w(p) ? null : p), d));
                    };
                    i(), this.sessionManager.onSessionId(i);
                }
            }
        },
        {
            key: "log",
            value: function(e) {
                var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "log";
                null === (t = this.instance.sessionRecording) || void 0 === t || t.onRRwebEmit({
                    type: 6,
                    data: {
                        plugin: "rrweb/console@1",
                        payload: {
                            level: n,
                            trace: [],
                            payload: [
                                JSON.stringify(e)
                            ]
                        }
                    },
                    timestamp: $e444d6404c095fa5$var$K()
                });
            }
        },
        {
            key: "_startCapture",
            value: function() {
                var e = this;
                $e444d6404c095fa5$var$w(Object.assign) || this._captureStarted || this.instance.config.disable_session_recording || this.instance.consent.isOptedOut() || (this._captureStarted = !0, this.sessionManager.checkAndGetSessionAndWindowId(), this.rrwebRecord ? this._onScriptLoaded() : this.instance.requestRouter.loadScript("/static/recorder.js?v=".concat($e444d6404c095fa5$var$f.LIB_VERSION), function(t) {
                    if (t) return $e444d6404c095fa5$var$W.error($e444d6404c095fa5$var$li + " could not load recorder.js", t);
                    e._onScriptLoaded();
                }));
            }
        },
        {
            key: "isInteractiveEvent",
            value: function(e) {
                var t;
                return 3 === e.type && -1 !== $e444d6404c095fa5$var$ai.indexOf(null === (t = e.data) || void 0 === t ? void 0 : t.source);
            }
        },
        {
            key: "_updateWindowAndSessionIds",
            value: function(e) {
                var t = this.isInteractiveEvent(e);
                t || this.isIdle || e.timestamp - this._lastActivityTimestamp > 3e5 && (this.isIdle = !0, clearTimeout(this._fullSnapshotTimer), this._flushBuffer());
                var n = !1;
                if (t && (this._lastActivityTimestamp = e.timestamp, this.isIdle && (this.isIdle = !1, this._tryAddCustomEvent("sessionNoLongerIdle", {
                    reason: "user activity",
                    type: e.type
                }), n = !0)), !this.isIdle) {
                    var i = this.sessionManager.checkAndGetSessionAndWindowId(!t, e.timestamp), r = i.windowId, s = i.sessionId, o = this.sessionId !== s, a = this.windowId !== r;
                    this.windowId = r, this.sessionId = s, (n || -1 === [
                        $e444d6404c095fa5$var$kn,
                        $e444d6404c095fa5$var$wn
                    ].indexOf(e.type) && (a || o || $e444d6404c095fa5$var$w(this._fullSnapshotTimer))) && this._tryTakeFullSnapshot();
                }
            }
        },
        {
            key: "_tryRRWebMethod",
            value: function(e) {
                try {
                    return e.rrwebMethod(), !0;
                } catch (t) {
                    return this.queuedRRWebEvents.length < 10 ? this.queuedRRWebEvents.push({
                        enqueuedAt: e.enqueuedAt || Date.now(),
                        attempt: e.attempt++,
                        rrwebMethod: e.rrwebMethod
                    }) : $e444d6404c095fa5$var$W.warn($e444d6404c095fa5$var$li + " could not emit queued rrweb event.", t, e), !1;
                }
            }
        },
        {
            key: "_tryAddCustomEvent",
            value: function(e, t) {
                var n = this;
                return this._tryRRWebMethod($e444d6404c095fa5$var$ui(function() {
                    return n.rrwebRecord.addCustomEvent(e, t);
                }));
            }
        },
        {
            key: "_tryTakeFullSnapshot",
            value: function() {
                var e = this;
                return this._tryRRWebMethod($e444d6404c095fa5$var$ui(function() {
                    return e.rrwebRecord.takeFullSnapshot();
                }));
            }
        },
        {
            key: "_onScriptLoaded",
            value: function() {
                for(var e, n = this, i = {
                    blockClass: "ph-no-capture",
                    blockSelector: void 0,
                    ignoreClass: "ph-ignore-input",
                    maskTextClass: "ph-mask",
                    maskTextSelector: void 0,
                    maskTextFn: void 0,
                    maskAllInputs: !0,
                    maskInputOptions: {},
                    maskInputFn: void 0,
                    slimDOMOptions: {},
                    collectFonts: !1,
                    inlineStylesheet: !0,
                    recordCrossOriginIframes: !1
                }, r = this.instance.config.session_recording, s = 0, o = Object.entries(r || {}); s < o.length; s++){
                    var a = $e444d6404c095fa5$var$u(o[s], 2), l = a[0], c = a[1];
                    l in i && (i[l] = c);
                }
                if (this.canvasRecording && this.canvasRecording.enabled && (i.recordCanvas = !0, i.sampling = {
                    canvas: this.canvasRecording.fps
                }, i.dataURLOptions = {
                    type: "image/webp",
                    quality: this.canvasRecording.quality
                }), this.rrwebRecord) {
                    this.mutationRateLimiter = null !== (e = this.mutationRateLimiter) && void 0 !== e ? e : new $e444d6404c095fa5$var$si(this.rrwebRecord, {
                        onBlockedNode: function(e, t) {
                            var i = "Too many mutations on node '".concat(e, "'. Rate limiting. This could be due to SVG animations or something similar");
                            $e444d6404c095fa5$var$W.info(i, {
                                node: t
                            }), n.log($e444d6404c095fa5$var$li + " " + i, "warn");
                        }
                    });
                    var d = this._gatherRRWebPlugins();
                    this.stopRrweb = this.rrwebRecord($e444d6404c095fa5$var$t({
                        emit: function(e) {
                            n.onRRwebEmit(e);
                        },
                        plugins: d
                    }, i)), this.instance._addCaptureHook(function(e) {
                        try {
                            if ("$pageview" === e) {
                                var t = $e444d6404c095fa5$var$T ? n._maskUrl($e444d6404c095fa5$var$T.location.href) : "";
                                if (!t) return;
                                n._tryAddCustomEvent("$pageview", {
                                    href: t
                                });
                            }
                        } catch (e) {
                            $e444d6404c095fa5$var$W.error("Could not add $pageview to rrweb session", e);
                        }
                    }), this._lastActivityTimestamp = Date.now(), this.isIdle = !1, this._tryAddCustomEvent("$session_options", {
                        sessionRecordingOptions: i,
                        activePlugins: d.map(function(e) {
                            return null == e ? void 0 : e.name;
                        })
                    }), this._tryAddCustomEvent("$posthog_config", {
                        config: this.instance.config
                    });
                } else $e444d6404c095fa5$var$W.error($e444d6404c095fa5$var$li + "onScriptLoaded was called but rrwebRecord is not available. This indicates something has gone wrong.");
            }
        },
        {
            key: "_scheduleFullSnapshot",
            value: function() {
                var e = this;
                if (this._fullSnapshotTimer && clearInterval(this._fullSnapshotTimer), !this.isIdle) {
                    var t = this.fullSnapshotIntervalMillis;
                    t && (this._fullSnapshotTimer = setInterval(function() {
                        e._tryTakeFullSnapshot();
                    }, t));
                }
            }
        },
        {
            key: "_gatherRRWebPlugins",
            value: function() {
                var e = [];
                ($e444d6404c095fa5$var$U.rrwebConsoleRecord && this.isConsoleLogCaptureEnabled && e.push($e444d6404c095fa5$var$U.rrwebConsoleRecord.getRecordConsolePlugin()), this.networkPayloadCapture && $e444d6404c095fa5$var$y($e444d6404c095fa5$var$U.getRecordNetworkPlugin)) && (!$e444d6404c095fa5$var$pt.includes(location.hostname) || this._forceAllowLocalhostNetworkCapture ? e.push($e444d6404c095fa5$var$U.getRecordNetworkPlugin($e444d6404c095fa5$var$ri(this.instance.config, this.networkPayloadCapture))) : $e444d6404c095fa5$var$W.info($e444d6404c095fa5$var$li + " NetworkCapture not started because we are on localhost."));
                return e;
            }
        },
        {
            key: "onRRwebEmit",
            value: function(e) {
                if (this._processQueuedEvents(), e && $e444d6404c095fa5$var$b(e)) {
                    if (e.type === $e444d6404c095fa5$var$Sn.Meta) {
                        var t = this._maskUrl(e.data.href);
                        if (this._lastHref = t, !t) return;
                        e.data.href = t;
                    } else this._pageViewFallBack();
                    e.type === $e444d6404c095fa5$var$Sn.FullSnapshot && this._scheduleFullSnapshot();
                    var n = this.mutationRateLimiter ? this.mutationRateLimiter.throttleMutations(e) : e;
                    if (n) {
                        var i = function(e) {
                            var t = e;
                            if (t && $e444d6404c095fa5$var$b(t) && 6 === t.type && $e444d6404c095fa5$var$b(t.data) && "rrweb/console@1" === t.data.plugin) {
                                t.data.payload.payload.length > 10 && (t.data.payload.payload = t.data.payload.payload.slice(0, 10), t.data.payload.payload.push("...[truncated]"));
                                for(var n = [], i = 0; i < t.data.payload.payload.length; i++)t.data.payload.payload[i] && t.data.payload.payload[i].length > 2e3 ? n.push(t.data.payload.payload[i].slice(0, 2e3) + "...[truncated]") : n.push(t.data.payload.payload[i]);
                                return t.data.payload.payload = n, e;
                            }
                            return e;
                        }(n), r = $e444d6404c095fa5$var$ci(i);
                        if (this._updateWindowAndSessionIds(i), !this.isIdle || i.type === $e444d6404c095fa5$var$Sn.Custom) {
                            var s = {
                                $snapshot_bytes: r,
                                $snapshot_data: i,
                                $session_id: this.sessionId,
                                $window_id: this.windowId
                            };
                            "disabled" !== this.status ? this._captureSnapshotBuffered(s) : this.clearBuffer();
                        }
                    }
                }
            }
        },
        {
            key: "_pageViewFallBack",
            value: function() {
                if (!this.instance.config.capture_pageview && $e444d6404c095fa5$var$T) {
                    var e = this._maskUrl($e444d6404c095fa5$var$T.location.href);
                    this._lastHref !== e && (this._tryAddCustomEvent("$url_changed", {
                        href: e
                    }), this._lastHref = e);
                }
            }
        },
        {
            key: "_processQueuedEvents",
            value: function() {
                var e = this;
                if (this.queuedRRWebEvents.length) {
                    var t = $e444d6404c095fa5$var$l(this.queuedRRWebEvents);
                    this.queuedRRWebEvents = [], t.forEach(function(t) {
                        Date.now() - t.enqueuedAt <= 2e3 && e._tryRRWebMethod(t);
                    });
                }
            }
        },
        {
            key: "_maskUrl",
            value: function(e) {
                var t = this.instance.config.session_recording;
                if (t.maskNetworkRequestFn) {
                    var n, i = {
                        url: e
                    };
                    return null === (n = i = t.maskNetworkRequestFn(i)) || void 0 === n ? void 0 : n.url;
                }
                return e;
            }
        },
        {
            key: "clearBuffer",
            value: function() {
                return this.buffer = {
                    size: 0,
                    data: [],
                    sessionId: this.sessionId,
                    windowId: this.windowId
                }, this.buffer;
            }
        },
        {
            key: "_flushBuffer",
            value: function() {
                var e = this;
                this.flushBufferTimer && (clearTimeout(this.flushBufferTimer), this.flushBufferTimer = void 0);
                var t = this.minimumDuration, n = this.sessionDuration, i = $e444d6404c095fa5$var$R(n) && n >= 0, r = $e444d6404c095fa5$var$R(t) && i && n < t;
                return "buffering" === this.status || r ? (this.flushBufferTimer = setTimeout(function() {
                    e._flushBuffer();
                }, 2e3), this.buffer) : (this.buffer.data.length > 0 && this._captureSnapshot({
                    $snapshot_bytes: this.buffer.size,
                    $snapshot_data: this.buffer.data,
                    $session_id: this.buffer.sessionId,
                    $window_id: this.buffer.windowId
                }), this.clearBuffer());
            }
        },
        {
            key: "_captureSnapshotBuffered",
            value: function(e) {
                var t, n = this, i = 2 + ((null === (t = this.buffer) || void 0 === t ? void 0 : t.data.length) || 0);
                (this.buffer.size + e.$snapshot_bytes + i > 943718.4 || this.buffer.sessionId !== this.sessionId) && (this.buffer = this._flushBuffer()), this.buffer.size += e.$snapshot_bytes, this.buffer.data.push(e.$snapshot_data), this.flushBufferTimer || (this.flushBufferTimer = setTimeout(function() {
                    n._flushBuffer();
                }, 2e3));
            }
        },
        {
            key: "_captureSnapshot",
            value: function(e) {
                this.instance.capture("$snapshot", e, {
                    _url: this.instance.requestRouter.endpointFor("api", this._endpoint),
                    _noTruncate: !0,
                    _batchKey: "recordings"
                });
            }
        }
    ]), e;
}(), $e444d6404c095fa5$var$fi = function() {
    function e(t) {
        $e444d6404c095fa5$var$i(this, e), this.instance = t, this.instance.decideEndpointWasHit = this.instance._hasBootstrappedFeatureFlags();
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "call",
            value: function() {
                var e = this, t = {
                    token: this.instance.config.token,
                    distinct_id: this.instance.get_distinct_id(),
                    groups: this.instance.getGroups(),
                    person_properties: this.instance.get_property($e444d6404c095fa5$var$Re),
                    group_properties: this.instance.get_property($e444d6404c095fa5$var$xe),
                    disable_flags: this.instance.config.advanced_disable_feature_flags || this.instance.config.advanced_disable_feature_flags_on_first_load || void 0
                };
                this.instance._send_request({
                    method: "POST",
                    url: this.instance.requestRouter.endpointFor("api", "/decide/?v=3"),
                    data: t,
                    compression: this.instance.config.disable_compression ? void 0 : $e444d6404c095fa5$export$6a00d17b5aff0af.Base64,
                    timeout: this.instance.config.feature_flag_request_timeout_ms,
                    callback: function(t) {
                        return e.parseDecideResponse(t.json);
                    }
                });
            }
        },
        {
            key: "parseDecideResponse",
            value: function(e) {
                var t = this;
                this.instance.featureFlags.setReloadingPaused(!1), this.instance.featureFlags._startReloadTimer();
                var n = !e;
                if (this.instance.config.advanced_disable_feature_flags_on_first_load || this.instance.config.advanced_disable_feature_flags || this.instance.featureFlags.receivedFeatureFlags(null != e ? e : {}, n), n) $e444d6404c095fa5$var$W.error("Failed to fetch feature flags from PostHog.");
                else {
                    if (!$e444d6404c095fa5$var$D || !$e444d6404c095fa5$var$D.body) return $e444d6404c095fa5$var$W.info("document not ready yet, trying again in 500 milliseconds..."), void setTimeout(function() {
                        t.parseDecideResponse(e);
                    }, 500);
                    if (this.instance._afterDecideResponse(e), e.siteApps) {
                        if (this.instance.config.opt_in_site_apps) {
                            var i, r = $e444d6404c095fa5$var$h(e.siteApps);
                            try {
                                var s = function() {
                                    var e = i.value, n = e.id, r = e.url, s = t.instance.requestRouter.endpointFor("api", r);
                                    $e444d6404c095fa5$var$U["__$$ph_site_app_".concat(n)] = t.instance, t.instance.requestRouter.loadScript(s, function(e) {
                                        e && $e444d6404c095fa5$var$W.error("Error while initializing PostHog app with config id ".concat(n), e);
                                    });
                                };
                                for(r.s(); !(i = r.n()).done;)s();
                            } catch (e) {
                                r.e(e);
                            } finally{
                                r.f();
                            }
                        } else e.siteApps.length > 0 && $e444d6404c095fa5$var$W.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
                    }
                }
            }
        }
    ]), e;
}(), $e444d6404c095fa5$var$pi = null != $e444d6404c095fa5$var$T && $e444d6404c095fa5$var$T.location ? $e444d6404c095fa5$var$yt($e444d6404c095fa5$var$T.location.hash, "__posthog") || $e444d6404c095fa5$var$yt(location.hash, "state") : null, $e444d6404c095fa5$var$vi = "_postHogToolbarParams";
!function(e) {
    e[e.UNINITIALIZED = 0] = "UNINITIALIZED", e[e.LOADING = 1] = "LOADING", e[e.LOADED = 2] = "LOADED";
}($e444d6404c095fa5$var$di || ($e444d6404c095fa5$var$di = {}));
var $e444d6404c095fa5$var$_i = function() {
    function e(t) {
        $e444d6404c095fa5$var$i(this, e), this.instance = t;
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "setToolbarState",
            value: function(e) {
                $e444d6404c095fa5$var$U.ph_toolbar_state = e;
            }
        },
        {
            key: "getToolbarState",
            value: function() {
                var e;
                return null !== (e = $e444d6404c095fa5$var$U.ph_toolbar_state) && void 0 !== e ? e : $e444d6404c095fa5$var$di.UNINITIALIZED;
            }
        },
        {
            key: "maybeLoadToolbar",
            value: function() {
                var e, t, n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
                if (!$e444d6404c095fa5$var$T || !$e444d6404c095fa5$var$D) return !1;
                n = null !== (e = n) && void 0 !== e ? e : $e444d6404c095fa5$var$T.location, r = null !== (t = r) && void 0 !== t ? t : $e444d6404c095fa5$var$T.history;
                try {
                    if (!i) {
                        try {
                            $e444d6404c095fa5$var$T.localStorage.setItem("test", "test"), $e444d6404c095fa5$var$T.localStorage.removeItem("test");
                        } catch (e) {
                            return !1;
                        }
                        i = null == $e444d6404c095fa5$var$T ? void 0 : $e444d6404c095fa5$var$T.localStorage;
                    }
                    var s, o = $e444d6404c095fa5$var$pi || $e444d6404c095fa5$var$yt(n.hash, "__posthog") || $e444d6404c095fa5$var$yt(n.hash, "state"), a = o ? $e444d6404c095fa5$var$Z(function() {
                        return JSON.parse(atob(decodeURIComponent(o)));
                    }) || $e444d6404c095fa5$var$Z(function() {
                        return JSON.parse(decodeURIComponent(o));
                    }) : null;
                    return a && "ph_authorize" === a.action ? ((s = a).source = "url", s && Object.keys(s).length > 0 && (a.desiredHash ? n.hash = a.desiredHash : r ? r.replaceState(r.state, "", n.pathname + n.search) : n.hash = "")) : ((s = JSON.parse(i.getItem($e444d6404c095fa5$var$vi) || "{}")).source = "localstorage", delete s.userIntent), !(!s.token || this.instance.config.token !== s.token) && (this.loadToolbar(s), !0);
                } catch (e) {
                    return !1;
                }
            }
        },
        {
            key: "_callLoadToolbar",
            value: function(e) {
                ($e444d6404c095fa5$var$U.ph_load_toolbar || $e444d6404c095fa5$var$U.ph_load_editor)(e, this.instance);
            }
        },
        {
            key: "loadToolbar",
            value: function(e) {
                var n = this, i = !(null == $e444d6404c095fa5$var$D || !$e444d6404c095fa5$var$D.getElementById($e444d6404c095fa5$var$qe));
                if (!$e444d6404c095fa5$var$T || i) return !1;
                var r = "custom" === this.instance.requestRouter.region && this.instance.config.advanced_disable_toolbar_metrics, s = $e444d6404c095fa5$var$t($e444d6404c095fa5$var$t({
                    token: this.instance.config.token
                }, e), {}, {
                    apiURL: this.instance.requestRouter.endpointFor("ui")
                }, r ? {
                    instrument: !1
                } : {});
                if ($e444d6404c095fa5$var$T.localStorage.setItem($e444d6404c095fa5$var$vi, JSON.stringify($e444d6404c095fa5$var$t($e444d6404c095fa5$var$t({}, s), {}, {
                    source: void 0
                }))), this.getToolbarState() === $e444d6404c095fa5$var$di.LOADED) this._callLoadToolbar(s);
                else if (this.getToolbarState() === $e444d6404c095fa5$var$di.UNINITIALIZED) {
                    this.setToolbarState($e444d6404c095fa5$var$di.LOADING);
                    var o = 3e5, a = Math.floor(Date.now() / o) * o;
                    this.instance.requestRouter.loadScript("/static/toolbar.js?t=".concat(a), function(e) {
                        if (e) return $e444d6404c095fa5$var$W.error("Failed to load toolbar", e), void n.setToolbarState($e444d6404c095fa5$var$di.UNINITIALIZED);
                        n.setToolbarState($e444d6404c095fa5$var$di.LOADED), n._callLoadToolbar(s);
                    }), $e444d6404c095fa5$var$oe($e444d6404c095fa5$var$T, "turbolinks:load", function() {
                        n.setToolbarState($e444d6404c095fa5$var$di.UNINITIALIZED), n.loadToolbar(s);
                    });
                }
                return !0;
            }
        },
        {
            key: "_loadEditor",
            value: function(e) {
                return this.loadToolbar(e);
            }
        },
        {
            key: "maybeLoadEditor",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
                return this.maybeLoadToolbar(e, t, n);
            }
        }
    ]), e;
}(), $e444d6404c095fa5$var$gi = function() {
    function e(t) {
        $e444d6404c095fa5$var$i(this, e), $e444d6404c095fa5$var$o(this, "isPaused", !0), $e444d6404c095fa5$var$o(this, "queue", []), $e444d6404c095fa5$var$o(this, "flushTimeoutMs", 3e3), this.sendRequest = t;
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "enqueue",
            value: function(e) {
                this.queue.push(e), this.flushTimeout || this.setFlushTimeout();
            }
        },
        {
            key: "unload",
            value: function() {
                var e = this;
                this.clearFlushTimeout();
                var n = this.queue.length > 0 ? this.formatQueue() : {}, i = Object.values(n), r = [].concat($e444d6404c095fa5$var$l(i.filter(function(e) {
                    return 0 === e.url.indexOf("/e");
                })), $e444d6404c095fa5$var$l(i.filter(function(e) {
                    return 0 !== e.url.indexOf("/e");
                })));
                r.map(function(n) {
                    e.sendRequest($e444d6404c095fa5$var$t($e444d6404c095fa5$var$t({}, n), {}, {
                        transport: "sendBeacon"
                    }));
                });
            }
        },
        {
            key: "enable",
            value: function() {
                this.isPaused = !1, this.setFlushTimeout();
            }
        },
        {
            key: "setFlushTimeout",
            value: function() {
                var e = this;
                this.isPaused || (this.flushTimeout = setTimeout(function() {
                    if (e.clearFlushTimeout(), e.queue.length > 0) {
                        var t = e.formatQueue(), n = function(n) {
                            var i = t[n], r = (new Date).getTime();
                            i.data && $e444d6404c095fa5$var$m(i.data) && $e444d6404c095fa5$var$Q(i.data, function(e) {
                                e.offset = Math.abs(e.timestamp - r), delete e.timestamp;
                            }), e.sendRequest(i);
                        };
                        for(var i in t)n(i);
                    }
                }, this.flushTimeoutMs));
            }
        },
        {
            key: "clearFlushTimeout",
            value: function() {
                clearTimeout(this.flushTimeout), this.flushTimeout = void 0;
            }
        },
        {
            key: "formatQueue",
            value: function() {
                var e = {};
                return $e444d6404c095fa5$var$Q(this.queue, function(n) {
                    var i, r = n, s = (r ? r.batchKey : null) || r.url;
                    $e444d6404c095fa5$var$w(e[s]) && (e[s] = $e444d6404c095fa5$var$t($e444d6404c095fa5$var$t({}, r), {}, {
                        data: []
                    })), null === (i = e[s].data) || void 0 === i || i.push(r.data);
                }), this.queue = [], e;
            }
        }
    ]), e;
}(), $e444d6404c095fa5$var$mi = Uint8Array, $e444d6404c095fa5$var$yi = Uint16Array, $e444d6404c095fa5$var$bi = Uint32Array, $e444d6404c095fa5$var$ki = new $e444d6404c095fa5$var$mi([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    0,
    0,
    0
]), $e444d6404c095fa5$var$wi = new $e444d6404c095fa5$var$mi([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    0,
    0
]), $e444d6404c095fa5$var$Si = new $e444d6404c095fa5$var$mi([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]), $e444d6404c095fa5$var$Ei = function(e, t) {
    for(var n = new $e444d6404c095fa5$var$yi(31), i = 0; i < 31; ++i)n[i] = t += 1 << e[i - 1];
    var r = new $e444d6404c095fa5$var$bi(n[30]);
    for(i = 1; i < 30; ++i)for(var s = n[i]; s < n[i + 1]; ++s)r[s] = s - n[i] << 5 | i;
    return [
        n,
        r
    ];
}, $e444d6404c095fa5$var$Fi = $e444d6404c095fa5$var$Ei($e444d6404c095fa5$var$ki, 2), $e444d6404c095fa5$var$Ii = $e444d6404c095fa5$var$Fi[0], $e444d6404c095fa5$var$Ri = $e444d6404c095fa5$var$Fi[1];
$e444d6404c095fa5$var$Ii[28] = 258, $e444d6404c095fa5$var$Ri[258] = 28;
for(var $e444d6404c095fa5$var$xi = $e444d6404c095fa5$var$Ei($e444d6404c095fa5$var$wi, 0)[1], $e444d6404c095fa5$var$Pi = new $e444d6404c095fa5$var$yi(32768), $e444d6404c095fa5$var$Ti = 0; $e444d6404c095fa5$var$Ti < 32768; ++$e444d6404c095fa5$var$Ti){
    var $e444d6404c095fa5$var$Ci = (43690 & $e444d6404c095fa5$var$Ti) >>> 1 | (21845 & $e444d6404c095fa5$var$Ti) << 1;
    $e444d6404c095fa5$var$Ci = (61680 & ($e444d6404c095fa5$var$Ci = (52428 & $e444d6404c095fa5$var$Ci) >>> 2 | (13107 & $e444d6404c095fa5$var$Ci) << 2)) >>> 4 | (3855 & $e444d6404c095fa5$var$Ci) << 4, $e444d6404c095fa5$var$Pi[$e444d6404c095fa5$var$Ti] = ((65280 & $e444d6404c095fa5$var$Ci) >>> 8 | (255 & $e444d6404c095fa5$var$Ci) << 8) >>> 1;
}
var $e444d6404c095fa5$var$$i = function(e, t, n) {
    for(var i = e.length, r = 0, s = new $e444d6404c095fa5$var$yi(t); r < i; ++r)++s[e[r] - 1];
    var o, a = new $e444d6404c095fa5$var$yi(t);
    for(r = 0; r < t; ++r)a[r] = a[r - 1] + s[r - 1] << 1;
    if (n) {
        o = new $e444d6404c095fa5$var$yi(1 << t);
        var u = 15 - t;
        for(r = 0; r < i; ++r)if (e[r]) for(var l = r << 4 | e[r], c = t - e[r], d = a[e[r] - 1]++ << c, h = d | (1 << c) - 1; d <= h; ++d)o[$e444d6404c095fa5$var$Pi[d] >>> u] = l;
    } else for(o = new $e444d6404c095fa5$var$yi(i), r = 0; r < i; ++r)o[r] = $e444d6404c095fa5$var$Pi[a[e[r] - 1]++] >>> 15 - e[r];
    return o;
}, $e444d6404c095fa5$var$Oi = new $e444d6404c095fa5$var$mi(288);
for($e444d6404c095fa5$var$Ti = 0; $e444d6404c095fa5$var$Ti < 144; ++$e444d6404c095fa5$var$Ti)$e444d6404c095fa5$var$Oi[$e444d6404c095fa5$var$Ti] = 8;
for($e444d6404c095fa5$var$Ti = 144; $e444d6404c095fa5$var$Ti < 256; ++$e444d6404c095fa5$var$Ti)$e444d6404c095fa5$var$Oi[$e444d6404c095fa5$var$Ti] = 9;
for($e444d6404c095fa5$var$Ti = 256; $e444d6404c095fa5$var$Ti < 280; ++$e444d6404c095fa5$var$Ti)$e444d6404c095fa5$var$Oi[$e444d6404c095fa5$var$Ti] = 7;
for($e444d6404c095fa5$var$Ti = 280; $e444d6404c095fa5$var$Ti < 288; ++$e444d6404c095fa5$var$Ti)$e444d6404c095fa5$var$Oi[$e444d6404c095fa5$var$Ti] = 8;
var $e444d6404c095fa5$var$Mi = new $e444d6404c095fa5$var$mi(32);
for($e444d6404c095fa5$var$Ti = 0; $e444d6404c095fa5$var$Ti < 32; ++$e444d6404c095fa5$var$Ti)$e444d6404c095fa5$var$Mi[$e444d6404c095fa5$var$Ti] = 5;
var $e444d6404c095fa5$var$Ai = $e444d6404c095fa5$var$$i($e444d6404c095fa5$var$Oi, 9, 0), $e444d6404c095fa5$var$Di = $e444d6404c095fa5$var$$i($e444d6404c095fa5$var$Mi, 5, 0), $e444d6404c095fa5$var$Li = function(e) {
    return (e / 8 >> 0) + (7 & e && 1);
}, $e444d6404c095fa5$var$Ni = function(e, t, n) {
    (null == t || t < 0) && (t = 0), (null == n || n > e.length) && (n = e.length);
    var i = new (e instanceof $e444d6404c095fa5$var$yi ? $e444d6404c095fa5$var$yi : e instanceof $e444d6404c095fa5$var$bi ? $e444d6404c095fa5$var$bi : $e444d6404c095fa5$var$mi)(n - t);
    return i.set(e.subarray(t, n)), i;
}, $e444d6404c095fa5$var$qi = function(e, t, n) {
    n <<= 7 & t;
    var i = t / 8 >> 0;
    e[i] |= n, e[i + 1] |= n >>> 8;
}, $e444d6404c095fa5$var$Bi = function(e, t, n) {
    n <<= 7 & t;
    var i = t / 8 >> 0;
    e[i] |= n, e[i + 1] |= n >>> 8, e[i + 2] |= n >>> 16;
}, $e444d6404c095fa5$var$Hi = function(e, t) {
    for(var n = [], i = 0; i < e.length; ++i)e[i] && n.push({
        s: i,
        f: e[i]
    });
    var r = n.length, s = n.slice();
    if (!r) return [
        new $e444d6404c095fa5$var$mi(0),
        0
    ];
    if (1 == r) {
        var o = new $e444d6404c095fa5$var$mi(n[0].s + 1);
        return o[n[0].s] = 1, [
            o,
            1
        ];
    }
    n.sort(function(e, t) {
        return e.f - t.f;
    }), n.push({
        s: -1,
        f: 25001
    });
    var a = n[0], u = n[1], l = 0, c = 1, d = 2;
    for(n[0] = {
        s: -1,
        f: a.f + u.f,
        l: a,
        r: u
    }; c != r - 1;)a = n[n[l].f < n[d].f ? l++ : d++], u = n[l != c && n[l].f < n[d].f ? l++ : d++], n[c++] = {
        s: -1,
        f: a.f + u.f,
        l: a,
        r: u
    };
    var h = s[0].s;
    for(i = 1; i < r; ++i)s[i].s > h && (h = s[i].s);
    var f = new $e444d6404c095fa5$var$yi(h + 1), p = $e444d6404c095fa5$var$Ui(n[c - 1], f, 0);
    if (p > t) {
        i = 0;
        var v = 0, _ = p - t, g = 1 << _;
        for(s.sort(function(e, t) {
            return f[t.s] - f[e.s] || e.f - t.f;
        }); i < r; ++i){
            var m = s[i].s;
            if (!(f[m] > t)) break;
            v += g - (1 << p - f[m]), f[m] = t;
        }
        for(v >>>= _; v > 0;){
            var y = s[i].s;
            f[y] < t ? v -= 1 << t - f[y]++ - 1 : ++i;
        }
        for(; i >= 0 && v; --i){
            var b = s[i].s;
            f[b] == t && (--f[b], ++v);
        }
        p = t;
    }
    return [
        new $e444d6404c095fa5$var$mi(f),
        p
    ];
}, $e444d6404c095fa5$var$Ui = function e(t, n, i) {
    return -1 == t.s ? Math.max(e(t.l, n, i + 1), e(t.r, n, i + 1)) : n[t.s] = i;
}, $e444d6404c095fa5$var$ji = function(e) {
    for(var t = e.length; t && !e[--t];);
    for(var n = new $e444d6404c095fa5$var$yi(++t), i = 0, r = e[0], s = 1, o = function(e) {
        n[i++] = e;
    }, a = 1; a <= t; ++a)if (e[a] == r && a != t) ++s;
    else {
        if (!r && s > 2) {
            for(; s > 138; s -= 138)o(32754);
            s > 2 && (o(s > 10 ? s - 11 << 5 | 28690 : s - 3 << 5 | 12305), s = 0);
        } else if (s > 3) {
            for(o(r), --s; s > 6; s -= 6)o(8304);
            s > 2 && (o(s - 3 << 5 | 8208), s = 0);
        }
        for(; s--;)o(r);
        s = 1, r = e[a];
    }
    return [
        n.subarray(0, i),
        t
    ];
}, $e444d6404c095fa5$var$Wi = function(e, t) {
    for(var n = 0, i = 0; i < t.length; ++i)n += e[i] * t[i];
    return n;
}, $e444d6404c095fa5$var$Gi = function(e, t, n) {
    var i = n.length, r = $e444d6404c095fa5$var$Li(t + 2);
    e[r] = 255 & i, e[r + 1] = i >>> 8, e[r + 2] = 255 ^ e[r], e[r + 3] = 255 ^ e[r + 1];
    for(var s = 0; s < i; ++s)e[r + s + 4] = n[s];
    return 8 * (r + 4 + i);
}, $e444d6404c095fa5$var$zi = function(e, t, n, i, r, s, o, a, u, l, c) {
    $e444d6404c095fa5$var$qi(t, c++, n), ++r[256];
    for(var d = $e444d6404c095fa5$var$Hi(r, 15), h = d[0], f = d[1], p = $e444d6404c095fa5$var$Hi(s, 15), v = p[0], _ = p[1], g = $e444d6404c095fa5$var$ji(h), m = g[0], y = g[1], b = $e444d6404c095fa5$var$ji(v), k = b[0], w = b[1], S = new $e444d6404c095fa5$var$yi(19), E = 0; E < m.length; ++E)S[31 & m[E]]++;
    for(E = 0; E < k.length; ++E)S[31 & k[E]]++;
    for(var F = $e444d6404c095fa5$var$Hi(S, 7), I = F[0], R = F[1], x = 19; x > 4 && !I[$e444d6404c095fa5$var$Si[x - 1]]; --x);
    var P, T, C, $, O = l + 5 << 3, M = $e444d6404c095fa5$var$Wi(r, $e444d6404c095fa5$var$Oi) + $e444d6404c095fa5$var$Wi(s, $e444d6404c095fa5$var$Mi) + o, A = $e444d6404c095fa5$var$Wi(r, h) + $e444d6404c095fa5$var$Wi(s, v) + o + 14 + 3 * x + $e444d6404c095fa5$var$Wi(S, I) + (2 * S[16] + 3 * S[17] + 7 * S[18]);
    if (O <= M && O <= A) return $e444d6404c095fa5$var$Gi(t, c, e.subarray(u, u + l));
    if ($e444d6404c095fa5$var$qi(t, c, 1 + (A < M)), c += 2, A < M) {
        P = $e444d6404c095fa5$var$$i(h, f, 0), T = h, C = $e444d6404c095fa5$var$$i(v, _, 0), $ = v;
        var D = $e444d6404c095fa5$var$$i(I, R, 0);
        $e444d6404c095fa5$var$qi(t, c, y - 257), $e444d6404c095fa5$var$qi(t, c + 5, w - 1), $e444d6404c095fa5$var$qi(t, c + 10, x - 4), c += 14;
        for(E = 0; E < x; ++E)$e444d6404c095fa5$var$qi(t, c + 3 * E, I[$e444d6404c095fa5$var$Si[E]]);
        c += 3 * x;
        for(var L = [
            m,
            k
        ], N = 0; N < 2; ++N){
            var q = L[N];
            for(E = 0; E < q.length; ++E){
                var B = 31 & q[E];
                $e444d6404c095fa5$var$qi(t, c, D[B]), c += I[B], B > 15 && ($e444d6404c095fa5$var$qi(t, c, q[E] >>> 5 & 127), c += q[E] >>> 12);
            }
        }
    } else P = $e444d6404c095fa5$var$Ai, T = $e444d6404c095fa5$var$Oi, C = $e444d6404c095fa5$var$Di, $ = $e444d6404c095fa5$var$Mi;
    for(E = 0; E < a; ++E)if (i[E] > 255) {
        B = i[E] >>> 18 & 31;
        $e444d6404c095fa5$var$Bi(t, c, P[B + 257]), c += T[B + 257], B > 7 && ($e444d6404c095fa5$var$qi(t, c, i[E] >>> 23 & 31), c += $e444d6404c095fa5$var$ki[B]);
        var H = 31 & i[E];
        $e444d6404c095fa5$var$Bi(t, c, C[H]), c += $[H], H > 3 && ($e444d6404c095fa5$var$Bi(t, c, i[E] >>> 5 & 8191), c += $e444d6404c095fa5$var$wi[H]);
    } else $e444d6404c095fa5$var$Bi(t, c, P[i[E]]), c += T[i[E]];
    return $e444d6404c095fa5$var$Bi(t, c, P[256]), c + T[256];
}, $e444d6404c095fa5$var$Vi = new $e444d6404c095fa5$var$bi([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]), $e444d6404c095fa5$var$Qi = new $e444d6404c095fa5$var$mi(0), $e444d6404c095fa5$var$Ji = function() {
    for(var e = new $e444d6404c095fa5$var$bi(256), t = 0; t < 256; ++t){
        for(var n = t, i = 9; --i;)n = (1 & n && 3988292384) ^ n >>> 1;
        e[t] = n;
    }
    return e;
}(), $e444d6404c095fa5$var$Yi = function(e, t, n, i, r) {
    return function(e, t, n, i, r, s) {
        var o = e.length, a = new $e444d6404c095fa5$var$mi(i + o + 5 * (1 + Math.floor(o / 7e3)) + r), u = a.subarray(i, a.length - r), l = 0;
        if (!t || o < 8) for(var c = 0; c <= o; c += 65535){
            var d = c + 65535;
            d < o ? l = $e444d6404c095fa5$var$Gi(u, l, e.subarray(c, d)) : (u[c] = s, l = $e444d6404c095fa5$var$Gi(u, l, e.subarray(c, o)));
        }
        else {
            for(var h = $e444d6404c095fa5$var$Vi[t - 1], f = h >>> 13, p = 8191 & h, v = (1 << n) - 1, _ = new $e444d6404c095fa5$var$yi(32768), g = new $e444d6404c095fa5$var$yi(v + 1), m = Math.ceil(n / 3), y = 2 * m, b = function(t) {
                return (e[t] ^ e[t + 1] << m ^ e[t + 2] << y) & v;
            }, k = new $e444d6404c095fa5$var$bi(25e3), w = new $e444d6404c095fa5$var$yi(288), S = new $e444d6404c095fa5$var$yi(32), E = 0, F = 0, I = (c = 0, 0), R = 0, x = 0; c < o; ++c){
                var P = b(c), T = 32767 & c, C = g[P];
                if (_[T] = C, g[P] = T, R <= c) {
                    var $ = o - c;
                    if ((E > 7e3 || I > 24576) && $ > 423) {
                        l = $e444d6404c095fa5$var$zi(e, u, 0, k, w, S, F, I, x, c - x, l), I = E = F = 0, x = c;
                        for(var O = 0; O < 286; ++O)w[O] = 0;
                        for(O = 0; O < 30; ++O)S[O] = 0;
                    }
                    var M = 2, A = 0, D = p, L = T - C & 32767;
                    if ($ > 2 && P == b(c - L)) for(var N = Math.min(f, $) - 1, q = Math.min(32767, c), B = Math.min(258, $); L <= q && --D && T != C;){
                        if (e[c + M] == e[c + M - L]) {
                            for(var H = 0; H < B && e[c + H] == e[c + H - L]; ++H);
                            if (H > M) {
                                if (M = H, A = L, H > N) break;
                                var U = Math.min(L, H - 2), j = 0;
                                for(O = 0; O < U; ++O){
                                    var W = c - L + O + 32768 & 32767, G = W - _[W] + 32768 & 32767;
                                    G > j && (j = G, C = W);
                                }
                            }
                        }
                        L += (T = C) - (C = _[T]) + 32768 & 32767;
                    }
                    if (A) {
                        k[I++] = 268435456 | $e444d6404c095fa5$var$Ri[M] << 18 | $e444d6404c095fa5$var$xi[A];
                        var z = 31 & $e444d6404c095fa5$var$Ri[M], V = 31 & $e444d6404c095fa5$var$xi[A];
                        F += $e444d6404c095fa5$var$ki[z] + $e444d6404c095fa5$var$wi[V], ++w[257 + z], ++S[V], R = c + M, ++E;
                    } else k[I++] = e[c], ++w[e[c]];
                }
            }
            l = $e444d6404c095fa5$var$zi(e, u, s, k, w, S, F, I, x, c - x, l), s || (l = $e444d6404c095fa5$var$Gi(u, l, $e444d6404c095fa5$var$Qi));
        }
        return $e444d6404c095fa5$var$Ni(a, 0, i + $e444d6404c095fa5$var$Li(l) + r);
    }(e, null == t.level ? 6 : t.level, null == t.mem ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(e.length)))) : 12 + t.mem, n, i, !r);
}, $e444d6404c095fa5$var$Xi = function(e, t, n) {
    for(; n; ++t)e[t] = n, n >>>= 8;
};
function $e444d6404c095fa5$var$Ki(e, t) {
    void 0 === t && (t = {});
    var n = function() {
        var e = 4294967295;
        return {
            p: function(t) {
                for(var n = e, i = 0; i < t.length; ++i)n = $e444d6404c095fa5$var$Ji[255 & n ^ t[i]] ^ n >>> 8;
                e = n;
            },
            d: function() {
                return 4294967295 ^ e;
            }
        };
    }(), i = e.length;
    n.p(e);
    var r = $e444d6404c095fa5$var$Yi(e, t, function(e) {
        return 10 + (e.filename && e.filename.length + 1 || 0);
    }(t), 8), s = r.length;
    return function(e, t) {
        var n = t.filename;
        if (e[0] = 31, e[1] = 139, e[2] = 8, e[8] = t.level < 2 ? 4 : 9 == t.level ? 2 : 0, e[9] = 3, 0 != t.mtime && $e444d6404c095fa5$var$Xi(e, 4, Math.floor(new Date(t.mtime || Date.now()) / 1e3)), n) {
            e[3] = 8;
            for(var i = 0; i <= n.length; ++i)e[i + 10] = n.charCodeAt(i);
        }
    }(r, t), $e444d6404c095fa5$var$Xi(r, s - 8, n.d()), $e444d6404c095fa5$var$Xi(r, s - 4, i), r;
}
var $e444d6404c095fa5$var$Zi = !!$e444d6404c095fa5$var$q || !!$e444d6404c095fa5$var$N, $e444d6404c095fa5$var$er = "text/plain", $e444d6404c095fa5$var$tr = function(e, n) {
    var i = $e444d6404c095fa5$var$u(e.split("?"), 2), r = i[0], s = i[1], o = $e444d6404c095fa5$var$t({}, n);
    null == s || s.split("&").forEach(function(e) {
        var t = $e444d6404c095fa5$var$u(e.split("="), 1)[0];
        delete o[t];
    });
    var a = $e444d6404c095fa5$var$gt(o);
    return a = a ? (s ? s + "&" : "") + a : s, "".concat(r, "?").concat(a);
}, $e444d6404c095fa5$var$nr = function(e) {
    return "data=" + encodeURIComponent("string" == typeof e ? e : JSON.stringify(e));
}, $e444d6404c095fa5$var$ir = function(e) {
    var t = e.data, n = e.compression;
    if (t) {
        if (n === $e444d6404c095fa5$export$6a00d17b5aff0af.GZipJS) {
            var i = $e444d6404c095fa5$var$Ki(function(e, t) {
                var n = e.length;
                if (!t && "undefined" != typeof TextEncoder) return (new TextEncoder).encode(e);
                for(var i = new $e444d6404c095fa5$var$mi(e.length + (e.length >>> 1)), r = 0, s = function(e) {
                    i[r++] = e;
                }, o = 0; o < n; ++o){
                    if (r + 5 > i.length) {
                        var a = new $e444d6404c095fa5$var$mi(r + 8 + (n - o << 1));
                        a.set(i), i = a;
                    }
                    var u = e.charCodeAt(o);
                    u < 128 || t ? s(u) : u < 2048 ? (s(192 | u >>> 6), s(128 | 63 & u)) : u > 55295 && u < 57344 ? (s(240 | (u = 65536 + (1047552 & u) | 1023 & e.charCodeAt(++o)) >>> 18), s(128 | u >>> 12 & 63), s(128 | u >>> 6 & 63), s(128 | 63 & u)) : (s(224 | u >>> 12), s(128 | u >>> 6 & 63), s(128 | 63 & u));
                }
                return $e444d6404c095fa5$var$Ni(i, 0, r);
            }(JSON.stringify(t)), {
                mtime: 0
            });
            return {
                contentType: $e444d6404c095fa5$var$er,
                body: new Blob([
                    i
                ], {
                    type: $e444d6404c095fa5$var$er
                })
            };
        }
        if (n === $e444d6404c095fa5$export$6a00d17b5aff0af.Base64) {
            var r = function(e) {
                var t, n, i, r, s, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", a = 0, u = 0, l = "", c = [];
                if (!e) return e;
                e = $e444d6404c095fa5$var$se(e);
                do t = (s = e.charCodeAt(a++) << 16 | e.charCodeAt(a++) << 8 | e.charCodeAt(a++)) >> 18 & 63, n = s >> 12 & 63, i = s >> 6 & 63, r = 63 & s, c[u++] = o.charAt(t) + o.charAt(n) + o.charAt(i) + o.charAt(r);
                while (a < e.length);
                switch(l = c.join(""), e.length % 3){
                    case 1:
                        l = l.slice(0, -2) + "==";
                        break;
                    case 2:
                        l = l.slice(0, -1) + "=";
                }
                return l;
            }(JSON.stringify(t));
            return {
                contentType: "application/x-www-form-urlencoded",
                body: $e444d6404c095fa5$var$nr(r)
            };
        }
        return {
            contentType: "application/json",
            body: JSON.stringify(t)
        };
    }
}, $e444d6404c095fa5$var$rr = [];
$e444d6404c095fa5$var$q && $e444d6404c095fa5$var$rr.push({
    transport: "XHR",
    method: function(e) {
        var t, n = new $e444d6404c095fa5$var$q;
        n.open(e.method || "GET", e.url, !0);
        var i = null !== (t = $e444d6404c095fa5$var$ir(e)) && void 0 !== t ? t : {}, r = i.contentType, s = i.body;
        $e444d6404c095fa5$var$Q(e.headers, function(e, t) {
            n.setRequestHeader(t, e);
        }), r && n.setRequestHeader("Content-Type", r), e.timeout && (n.timeout = e.timeout), n.withCredentials = !0, n.onreadystatechange = function() {
            if (4 === n.readyState) {
                var t, i = {
                    statusCode: n.status,
                    text: n.responseText
                };
                if (200 === n.status) try {
                    i.json = JSON.parse(n.responseText);
                } catch (e) {}
                null === (t = e.callback) || void 0 === t || t.call(e, i);
            }
        }, n.send(s);
    }
}), $e444d6404c095fa5$var$N && $e444d6404c095fa5$var$rr.push({
    transport: "fetch",
    method: function(e) {
        var t, n, i = null !== (t = $e444d6404c095fa5$var$ir(e)) && void 0 !== t ? t : {}, r = i.contentType, s = i.body, o = new Headers;
        $e444d6404c095fa5$var$Q(o, function(e, t) {
            o.append(t, e);
        }), r && o.append("Content-Type", r);
        var a = e.url, u = null;
        if ($e444d6404c095fa5$var$B) {
            var l = new $e444d6404c095fa5$var$B;
            u = {
                signal: l.signal,
                timeout: setTimeout(function() {
                    return l.abort();
                }, e.timeout)
            };
        }
        $e444d6404c095fa5$var$N(a, {
            method: (null == e ? void 0 : e.method) || "GET",
            headers: o,
            keepalive: "POST" === e.method,
            body: s,
            signal: null === (n = u) || void 0 === n ? void 0 : n.signal
        }).then(function(t) {
            return t.text().then(function(n) {
                var i, r = {
                    statusCode: t.status,
                    text: n
                };
                if (200 === t.status) try {
                    r.json = JSON.parse(n);
                } catch (e) {
                    $e444d6404c095fa5$var$W.error(e);
                }
                null === (i = e.callback) || void 0 === i || i.call(e, r);
            });
        }).catch(function(t) {
            var n;
            $e444d6404c095fa5$var$W.error(t), null === (n = e.callback) || void 0 === n || n.call(e, {
                statusCode: 0,
                text: t
            });
        }).finally(function() {
            return u ? clearTimeout(u.timeout) : null;
        });
    }
}), null != $e444d6404c095fa5$var$A && $e444d6404c095fa5$var$A.sendBeacon && $e444d6404c095fa5$var$rr.push({
    transport: "sendBeacon",
    method: function(e) {
        var t = $e444d6404c095fa5$var$tr(e.url, {
            beacon: "1"
        });
        try {
            var n, i = null !== (n = $e444d6404c095fa5$var$ir(e)) && void 0 !== n ? n : {}, r = i.contentType, s = i.body, o = "string" == typeof s ? new Blob([
                s
            ], {
                type: r
            }) : s;
            $e444d6404c095fa5$var$A.sendBeacon(t, o);
        } catch (e) {}
    }
});
var $e444d6404c095fa5$var$sr = [
    "retriesPerformedSoFar"
];
var $e444d6404c095fa5$var$or, $e444d6404c095fa5$var$ar = function() {
    function e(t) {
        var n = this;
        $e444d6404c095fa5$var$i(this, e), $e444d6404c095fa5$var$o(this, "isPolling", !1), $e444d6404c095fa5$var$o(this, "pollIntervalMs", 3e3), $e444d6404c095fa5$var$o(this, "queue", []), this.instance = t, this.queue = [], this.areWeOnline = !0, !$e444d6404c095fa5$var$w($e444d6404c095fa5$var$T) && "onLine" in $e444d6404c095fa5$var$T.navigator && (this.areWeOnline = $e444d6404c095fa5$var$T.navigator.onLine, $e444d6404c095fa5$var$T.addEventListener("online", function() {
            n.areWeOnline = !0, n.flush();
        }), $e444d6404c095fa5$var$T.addEventListener("offline", function() {
            n.areWeOnline = !1;
        }));
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "retriableRequest",
            value: function(e) {
                var n = this, i = e.retriesPerformedSoFar, r = $e444d6404c095fa5$var$a(e, $e444d6404c095fa5$var$sr);
                $e444d6404c095fa5$var$R(i) && i > 0 && (r.url = $e444d6404c095fa5$var$tr(r.url, {
                    retry_count: i
                })), this.instance._send_request($e444d6404c095fa5$var$t($e444d6404c095fa5$var$t({}, r), {}, {
                    callback: function(e) {
                        var s;
                        200 !== e.statusCode && (e.statusCode < 400 || e.statusCode >= 500) && (null != i ? i : 0) < 10 ? n.enqueue($e444d6404c095fa5$var$t({
                            retriesPerformedSoFar: i
                        }, r)) : null === (s = r.callback) || void 0 === s || s.call(r, e);
                    }
                }));
            }
        },
        {
            key: "enqueue",
            value: function(e) {
                var t = e.retriesPerformedSoFar || 0;
                e.retriesPerformedSoFar = t + 1;
                var n = function(e) {
                    var t = 3e3 * Math.pow(2, e), n = t / 2, i = Math.min(18e5, t), r = (Math.random() - .5) * (i - n);
                    return Math.ceil(i + r);
                }(t), i = Date.now() + n;
                this.queue.push({
                    retryAt: i,
                    requestOptions: e
                });
                var r = "Enqueued failed request for retry in ".concat(n);
                navigator.onLine || (r += " (Browser is offline)"), $e444d6404c095fa5$var$W.warn(r), this.isPolling || (this.isPolling = !0, this.poll());
            }
        },
        {
            key: "poll",
            value: function() {
                var e = this;
                this.poller && clearTimeout(this.poller), this.poller = setTimeout(function() {
                    e.areWeOnline && e.queue.length > 0 && e.flush(), e.poll();
                }, this.pollIntervalMs);
            }
        },
        {
            key: "flush",
            value: function() {
                var e = Date.now(), t = [], n = this.queue.filter(function(n) {
                    return n.retryAt < e || (t.push(n), !1);
                });
                if (this.queue = t, n.length > 0) {
                    var i, r = $e444d6404c095fa5$var$h(n);
                    try {
                        for(r.s(); !(i = r.n()).done;){
                            var s = i.value.requestOptions;
                            this.retriableRequest(s);
                        }
                    } catch (e) {
                        r.e(e);
                    } finally{
                        r.f();
                    }
                }
            }
        },
        {
            key: "unload",
            value: function() {
                this.poller && (clearTimeout(this.poller), this.poller = void 0);
                var e, n = $e444d6404c095fa5$var$h(this.queue);
                try {
                    for(n.s(); !(e = n.n()).done;){
                        var i = e.value.requestOptions;
                        try {
                            this.instance._send_request($e444d6404c095fa5$var$t($e444d6404c095fa5$var$t({}, i), {}, {
                                transport: "sendBeacon"
                            }));
                        } catch (e) {
                            $e444d6404c095fa5$var$W.error(e);
                        }
                    }
                } catch (e) {
                    n.e(e);
                } finally{
                    n.f();
                }
                this.queue = [];
            }
        }
    ]), e;
}(), $e444d6404c095fa5$var$ur = 1800, $e444d6404c095fa5$var$lr = function() {
    function e(t, n, r, s) {
        var a;
        $e444d6404c095fa5$var$i(this, e), $e444d6404c095fa5$var$o(this, "_sessionIdChangedHandlers", []), this.config = t, this.persistence = n, this._windowId = void 0, this._sessionId = void 0, this._sessionStartTimestamp = null, this._sessionActivityTimestamp = null, this._sessionIdGenerator = r || $e444d6404c095fa5$var$Ke, this._windowIdGenerator = s || $e444d6404c095fa5$var$Ke;
        var u = t.persistence_name || t.token, l = t.session_idle_timeout_seconds || $e444d6404c095fa5$var$ur;
        if ($e444d6404c095fa5$var$R(l) ? l > $e444d6404c095fa5$var$ur ? $e444d6404c095fa5$var$W.warn("session_idle_timeout_seconds cannot be  greater than 30 minutes. Using 30 minutes instead.") : l < 60 && $e444d6404c095fa5$var$W.warn("session_idle_timeout_seconds cannot be less than 60 seconds. Using 60 seconds instead.") : ($e444d6404c095fa5$var$W.warn("session_idle_timeout_seconds must be a number. Defaulting to 30 minutes."), l = $e444d6404c095fa5$var$ur), this._sessionTimeoutMs = 1e3 * Math.min(Math.max(l, 60), $e444d6404c095fa5$var$ur), this._window_id_storage_key = "ph_" + u + "_window_id", this._primary_window_exists_storage_key = "ph_" + u + "_primary_window_exists", this._canUseSessionStorage()) {
            var c = $e444d6404c095fa5$var$ft.parse(this._window_id_storage_key), d = $e444d6404c095fa5$var$ft.parse(this._primary_window_exists_storage_key);
            c && !d ? this._windowId = c : $e444d6404c095fa5$var$ft.remove(this._window_id_storage_key), $e444d6404c095fa5$var$ft.set(this._primary_window_exists_storage_key, !0);
        }
        if (null !== (a = this.config.bootstrap) && void 0 !== a && a.sessionID) try {
            var h = function(e) {
                var t = e.replace(/-/g, "");
                if (32 !== t.length) throw new Error("Not a valid UUID");
                if ("7" !== t[12]) throw new Error("Not a UUIDv7");
                return parseInt(t.substring(0, 12), 16);
            }(this.config.bootstrap.sessionID);
            this._setSessionId(this.config.bootstrap.sessionID, (new Date).getTime(), h);
        } catch (e) {
            $e444d6404c095fa5$var$W.error("Invalid sessionID in bootstrap", e);
        }
        this._listenToReloadWindow();
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "onSessionId",
            value: function(e) {
                var t = this;
                return $e444d6404c095fa5$var$w(this._sessionIdChangedHandlers) && (this._sessionIdChangedHandlers = []), this._sessionIdChangedHandlers.push(e), this._sessionId && e(this._sessionId, this._windowId), function() {
                    t._sessionIdChangedHandlers = t._sessionIdChangedHandlers.filter(function(t) {
                        return t !== e;
                    });
                };
            }
        },
        {
            key: "_canUseSessionStorage",
            value: function() {
                return "memory" !== this.config.persistence && !this.persistence.disabled && $e444d6404c095fa5$var$ft.is_supported();
            }
        },
        {
            key: "_setWindowId",
            value: function(e) {
                e !== this._windowId && (this._windowId = e, this._canUseSessionStorage() && $e444d6404c095fa5$var$ft.set(this._window_id_storage_key, e));
            }
        },
        {
            key: "_getWindowId",
            value: function() {
                return this._windowId ? this._windowId : this._canUseSessionStorage() ? $e444d6404c095fa5$var$ft.parse(this._window_id_storage_key) : null;
            }
        },
        {
            key: "_setSessionId",
            value: function(e, t, n) {
                e === this._sessionId && t === this._sessionActivityTimestamp && n === this._sessionStartTimestamp || (this._sessionStartTimestamp = n, this._sessionActivityTimestamp = t, this._sessionId = e, this.persistence.register($e444d6404c095fa5$var$o({}, $e444d6404c095fa5$var$Se, [
                    t,
                    e,
                    n
                ])));
            }
        },
        {
            key: "_getSessionId",
            value: function() {
                if (this._sessionId && this._sessionActivityTimestamp && this._sessionStartTimestamp) return [
                    this._sessionActivityTimestamp,
                    this._sessionId,
                    this._sessionStartTimestamp
                ];
                var e = this.persistence.props[$e444d6404c095fa5$var$Se];
                return $e444d6404c095fa5$var$m(e) && 2 === e.length && e.push(e[0]), e || [
                    0,
                    null,
                    0
                ];
            }
        },
        {
            key: "resetSessionId",
            value: function() {
                this._setSessionId(null, null, null);
            }
        },
        {
            key: "_listenToReloadWindow",
            value: function() {
                var e = this;
                null == $e444d6404c095fa5$var$T || $e444d6404c095fa5$var$T.addEventListener("beforeunload", function() {
                    e._canUseSessionStorage() && $e444d6404c095fa5$var$ft.remove(e._primary_window_exists_storage_key);
                });
            }
        },
        {
            key: "checkAndGetSessionAndWindowId",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], t = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null) || (new Date).getTime(), n = $e444d6404c095fa5$var$u(this._getSessionId(), 3), i = n[0], r = n[1], s = n[2], o = this._getWindowId(), a = s && s > 0 && Math.abs(t - s) > 864e5, l = !1, c = !r, d = !e && Math.abs(t - i) > this._sessionTimeoutMs;
                c || d || a ? (r = this._sessionIdGenerator(), o = this._windowIdGenerator(), $e444d6404c095fa5$var$W.info("[SessionId] new session ID generated", {
                    sessionId: r,
                    windowId: o,
                    changeReason: {
                        noSessionId: c,
                        activityTimeout: d,
                        sessionPastMaximumLength: a
                    }
                }), s = t, l = !0) : o || (o = this._windowIdGenerator(), l = !0);
                var h = 0 === i || !e || a ? t : i, f = 0 === s ? (new Date).getTime() : s;
                return this._setWindowId(o), this._setSessionId(r, h, f), l && this._sessionIdChangedHandlers.forEach(function(e) {
                    return e(r, o);
                }), {
                    sessionId: r,
                    windowId: o,
                    sessionStartTimestamp: f
                };
            }
        }
    ]), e;
}();
!function(e) {
    e.US = "us", e.EU = "eu", e.CUSTOM = "custom";
}($e444d6404c095fa5$var$or || ($e444d6404c095fa5$var$or = {}));
var $e444d6404c095fa5$var$cr = "i.posthog.com", $e444d6404c095fa5$var$dr = function() {
    function e(t) {
        $e444d6404c095fa5$var$i(this, e), $e444d6404c095fa5$var$o(this, "_regionCache", {}), this.instance = t;
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "apiHost",
            get: function() {
                return this.instance.config.api_host.trim().replace(/\/$/, "");
            }
        },
        {
            key: "uiHost",
            get: function() {
                var e, t = null === (e = this.instance.config.ui_host) || void 0 === e ? void 0 : e.replace(/\/$/, "");
                return "https://app.posthog.com" === t ? "https://us.posthog.com" : t;
            }
        },
        {
            key: "region",
            get: function() {
                return this._regionCache[this.apiHost] || (/https:\/\/(app|us|us-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this._regionCache[this.apiHost] = $e444d6404c095fa5$var$or.US : /https:\/\/(eu|eu-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this._regionCache[this.apiHost] = $e444d6404c095fa5$var$or.EU : this._regionCache[this.apiHost] = $e444d6404c095fa5$var$or.CUSTOM), this._regionCache[this.apiHost];
            }
        },
        {
            key: "endpointFor",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
                if (t && (t = "/" === t[0] ? t : "/".concat(t)), "ui" === e) return (this.uiHost || this.apiHost.replace(".".concat($e444d6404c095fa5$var$cr), ".posthog.com")) + t;
                if (this.region === $e444d6404c095fa5$var$or.CUSTOM) return this.apiHost + t;
                var n = $e444d6404c095fa5$var$cr + t;
                switch(e){
                    case "assets":
                        return "https://".concat(this.region, "-assets.").concat(n);
                    case "api":
                        return "https://".concat(this.region, ".").concat(n);
                }
            }
        },
        {
            key: "loadScript",
            value: function(e, t) {
                if (this.instance.config.disable_external_dependency_loading) return $e444d6404c095fa5$var$W.warn("".concat(e, " was requested but loading of external scripts is disabled.")), t("Loading of external scripts is disabled");
                var n = "/" === e[0] ? this.endpointFor("assets", e) : e, i = function() {
                    if (!$e444d6404c095fa5$var$D) return t("document not found");
                    var e = $e444d6404c095fa5$var$D.createElement("script");
                    e.type = "text/javascript", e.src = n, e.onload = function(e) {
                        return t(void 0, e);
                    }, e.onerror = function(e) {
                        return t(e);
                    };
                    var i, r = $e444d6404c095fa5$var$D.querySelectorAll("body > script");
                    r.length > 0 ? null === (i = r[0].parentNode) || void 0 === i || i.insertBefore(e, r[0]) : $e444d6404c095fa5$var$D.body.appendChild(e);
                };
                null != $e444d6404c095fa5$var$D && $e444d6404c095fa5$var$D.body ? i() : null == $e444d6404c095fa5$var$D || $e444d6404c095fa5$var$D.addEventListener("DOMContentLoaded", i);
            }
        }
    ]), e;
}(), $e444d6404c095fa5$var$hr = "/e/", $e444d6404c095fa5$var$fr = "[Exception Capture]", $e444d6404c095fa5$var$pr = function() {
    function e(t) {
        var n, r, s = this;
        $e444d6404c095fa5$var$i(this, e), $e444d6404c095fa5$var$o(this, "originalOnUnhandledRejectionHandler", void 0), $e444d6404c095fa5$var$o(this, "startCapturing", function() {
            var e;
            if ($e444d6404c095fa5$var$T && s.isEnabled && !s.hasHandlers && (null === (e = $e444d6404c095fa5$var$T.onerror) || void 0 === e || !e.__POSTHOG_INSTRUMENTED__)) {
                var t = $e444d6404c095fa5$var$T.posthogErrorWrappingFunctions.wrapOnError, n = $e444d6404c095fa5$var$T.posthogErrorWrappingFunctions.wrapUnhandledRejection;
                if (t && n) try {
                    s.unwrapOnError = t(s.captureException.bind(s)), s.unwrapUnhandledRejection = n(s.captureException.bind(s));
                } catch (e) {
                    $e444d6404c095fa5$var$W.error($e444d6404c095fa5$var$fr + " failed to start", e), s.stopCapturing();
                }
                else $e444d6404c095fa5$var$W.error($e444d6404c095fa5$var$fr + " failed to load error wrapping functions - cannot start");
            }
        }), this.instance = t, this.remoteEnabled = !(null === (n = this.instance.persistence) || void 0 === n || !n.props[$e444d6404c095fa5$var$pe]), this._endpoint = (null === (r = this.instance.persistence) || void 0 === r ? void 0 : r.props[$e444d6404c095fa5$var$ve]) || $e444d6404c095fa5$var$hr, this.startIfEnabled();
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "endpoint",
            get: function() {
                return this._endpoint;
            }
        },
        {
            key: "isEnabled",
            get: function() {
                var e;
                return null !== (e = this.remoteEnabled) && void 0 !== e && e;
            }
        },
        {
            key: "isCapturing",
            get: function() {
                var e;
                return !(null == $e444d6404c095fa5$var$T || null === (e = $e444d6404c095fa5$var$T.onerror) || void 0 === e || !e.__POSTHOG_INSTRUMENTED__);
            }
        },
        {
            key: "hasHandlers",
            get: function() {
                return this.originalOnUnhandledRejectionHandler || this.unwrapOnError;
            }
        },
        {
            key: "startIfEnabled",
            value: function() {
                this.isEnabled && !this.isCapturing && ($e444d6404c095fa5$var$W.info($e444d6404c095fa5$var$fr + " enabled, starting..."), this.loadScript(this.startCapturing));
            }
        },
        {
            key: "loadScript",
            value: function(e) {
                this.hasHandlers && e(), this.instance.requestRouter.loadScript(this.instance.requestRouter.endpointFor("assets", "/static/exception-autocapture.js?v=".concat($e444d6404c095fa5$var$f.LIB_VERSION)), function(t) {
                    t && $e444d6404c095fa5$var$W.error($e444d6404c095fa5$var$fr + " failed to load script", t), e();
                });
            }
        },
        {
            key: "stopCapturing",
            value: function() {
                var e, t;
                null === (e = this.unwrapOnError) || void 0 === e || e.call(this), null === (t = this.unwrapUnhandledRejection) || void 0 === t || t.call(this);
            }
        },
        {
            key: "afterDecideResponse",
            value: function(e) {
                var t = e.autocaptureExceptions;
                this.remoteEnabled = !!t || !1, this._endpoint = $e444d6404c095fa5$var$b(t) && t.endpoint || $e444d6404c095fa5$var$hr, this.instance.persistence && (this.instance.persistence.register($e444d6404c095fa5$var$o({}, $e444d6404c095fa5$var$pe, this.remoteEnabled)), this.instance.persistence.register($e444d6404c095fa5$var$o({}, $e444d6404c095fa5$var$ve, this._endpoint))), this.startIfEnabled();
            }
        },
        {
            key: "captureException",
            value: function(e) {
                var t = this.instance.requestRouter.endpointFor("ui");
                e.$exception_personURL = "".concat(t, "/project/").concat(this.instance.config.token, "/person/").concat(this.instance.get_distinct_id()), this.sendExceptionEvent(e);
            }
        },
        {
            key: "sendExceptionEvent",
            value: function(e) {
                this.instance.capture("$exception", e, {
                    _noTruncate: !0,
                    _batchKey: "exceptionEvent",
                    _url: this.endpoint
                });
            }
        }
    ]), e;
}(), $e444d6404c095fa5$var$vr = "posthog-js";
function $e444d6404c095fa5$var$_r(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = t.organization, i = t.projectId, r = t.prefix, s = t.severityAllowList, o = void 0 === s ? [
        "error"
    ] : s;
    return function(t) {
        var s, a, u, l, c, d;
        if (!("*" === o || o.includes(t.level)) || !e.__loaded) return t;
        t.tags || (t.tags = {});
        var h = e.requestRouter.endpointFor("ui", "/project/".concat(e.config.token, "/person/").concat(e.get_distinct_id()));
        t.tags["PostHog Person URL"] = h, e.sessionRecordingStarted() && (t.tags["PostHog Recording URL"] = e.get_session_replay_url({
            withTimestamp: !0
        }));
        var f = (null === (s = t.exception) || void 0 === s ? void 0 : s.values) || [], p = {
            $exception_message: (null === (a = f[0]) || void 0 === a ? void 0 : a.value) || t.message,
            $exception_type: null === (u = f[0]) || void 0 === u ? void 0 : u.type,
            $exception_personURL: h,
            $exception_level: t.level,
            $sentry_event_id: t.event_id,
            $sentry_exception: t.exception,
            $sentry_exception_message: (null === (l = f[0]) || void 0 === l ? void 0 : l.value) || t.message,
            $sentry_exception_type: null === (c = f[0]) || void 0 === c ? void 0 : c.type,
            $sentry_tags: t.tags,
            $level: t.level
        };
        return n && i && (p.$sentry_url = (r || "https://sentry.io/organizations/") + n + "/issues/?project=" + i + "&query=" + t.event_id), e.capture("$exception", p, {
            _url: (null === (d = e.exceptionObserver) || void 0 === d ? void 0 : d.endpoint) || $e444d6404c095fa5$var$hr
        }), t;
    };
}
var $e444d6404c095fa5$var$gr = $e444d6404c095fa5$var$s(function e(t, n, r, s, o) {
    $e444d6404c095fa5$var$i(this, e), this.name = $e444d6404c095fa5$var$vr, this.setupOnce = function(e) {
        e($e444d6404c095fa5$var$_r(t, {
            organization: n,
            projectId: r,
            prefix: s,
            severityAllowList: o
        }));
    };
});
function $e444d6404c095fa5$var$mr(e, t) {
    var n = e.config.segment;
    if (!n) return t();
    !function(e, t) {
        var n = e.config.segment;
        if (!n) return t();
        var i = function(n) {
            var i = function() {
                return n.anonymousId() || $e444d6404c095fa5$var$Ke();
            };
            e.config.get_device_id = i, n.id() && (e.register({
                distinct_id: n.id(),
                $device_id: i()
            }), e.persistence.set_property($e444d6404c095fa5$var$$e, "identified")), t();
        }, r = n.user();
        "then" in r && $e444d6404c095fa5$var$y(r.then) ? r.then(function(e) {
            return i(e);
        }) : i(r);
    }(e, function() {
        n.register(function(e) {
            Promise && Promise.resolve || $e444d6404c095fa5$var$W.warn("This browser does not have Promise support, and can not use the segment integration");
            var t = function(t, n) {
                var i;
                if (!n) return t;
                t.event.userId || t.event.anonymousId === e.get_distinct_id() || e.reset(), t.event.userId && t.event.userId !== e.get_distinct_id() && (e.register({
                    distinct_id: t.event.userId
                }), e.reloadFeatureFlags());
                var r = e._calculate_event_properties(n, null !== (i = t.event.properties) && void 0 !== i ? i : {});
                return t.event.properties = Object.assign({}, r, t.event.properties), t;
            };
            return {
                name: "PostHog JS",
                type: "enrichment",
                version: "1.0.0",
                isLoaded: function() {
                    return !0;
                },
                load: function() {
                    return Promise.resolve();
                },
                track: function(e) {
                    return t(e, e.event.event);
                },
                page: function(e) {
                    return t(e, "$pageview");
                },
                identify: function(e) {
                    return t(e, "$identify");
                },
                screen: function(e) {
                    return t(e, "$screen");
                }
            };
        }(e)).then(function() {
            t();
        });
    });
}
var $e444d6404c095fa5$export$22779822dd24228f, $e444d6404c095fa5$export$9c2ac61661d417f8, $e444d6404c095fa5$export$bbed2da3bd3bb001, $e444d6404c095fa5$var$wr = function() {
    function e(t) {
        $e444d6404c095fa5$var$i(this, e), this._instance = t;
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "doPageView",
            value: function() {
                var e, t = this._previousScrollProperties();
                return this._currentPath = null !== (e = null == $e444d6404c095fa5$var$T ? void 0 : $e444d6404c095fa5$var$T.location.pathname) && void 0 !== e ? e : "", this._instance.scrollManager.resetContext(), t;
            }
        },
        {
            key: "doPageLeave",
            value: function() {
                return this._previousScrollProperties();
            }
        },
        {
            key: "_previousScrollProperties",
            value: function() {
                var e = this._currentPath, t = this._instance.scrollManager.getContext();
                if (!e || !t) return {};
                var n = t.maxScrollHeight, i = t.lastScrollY, r = t.maxScrollY, s = t.maxContentHeight, o = t.lastContentY, a = t.maxContentY;
                return $e444d6404c095fa5$var$w(n) || $e444d6404c095fa5$var$w(i) || $e444d6404c095fa5$var$w(r) || $e444d6404c095fa5$var$w(s) || $e444d6404c095fa5$var$w(o) || $e444d6404c095fa5$var$w(a) ? {} : (n = Math.ceil(n), i = Math.ceil(i), r = Math.ceil(r), s = Math.ceil(s), o = Math.ceil(o), a = Math.ceil(a), {
                    $prev_pageview_pathname: e,
                    $prev_pageview_last_scroll: i,
                    $prev_pageview_last_scroll_percentage: n <= 1 ? 1 : $e444d6404c095fa5$var$Sr(i / n, 0, 1),
                    $prev_pageview_max_scroll: r,
                    $prev_pageview_max_scroll_percentage: n <= 1 ? 1 : $e444d6404c095fa5$var$Sr(r / n, 0, 1),
                    $prev_pageview_last_content: o,
                    $prev_pageview_last_content_percentage: s <= 1 ? 1 : $e444d6404c095fa5$var$Sr(o / s, 0, 1),
                    $prev_pageview_max_content: a,
                    $prev_pageview_max_content_percentage: s <= 1 ? 1 : $e444d6404c095fa5$var$Sr(a / s, 0, 1)
                });
            }
        }
    ]), e;
}();
function $e444d6404c095fa5$var$Sr(e, t, n) {
    return Math.max(t, Math.min(e, n));
}
!function(e) {
    e.Popover = "popover", e.API = "api", e.Widget = "widget";
}($e444d6404c095fa5$export$22779822dd24228f || ($e444d6404c095fa5$export$22779822dd24228f = {})), function(e) {
    e.Open = "open", e.MultipleChoice = "multiple_choice", e.SingleChoice = "single_choice", e.Rating = "rating", e.Link = "link";
}($e444d6404c095fa5$export$9c2ac61661d417f8 || ($e444d6404c095fa5$export$9c2ac61661d417f8 = {})), function(e) {
    e.NextQuestion = "next_question", e.End = "end", e.ResponseBased = "response_based", e.SpecificQuestion = "specific_question";
}($e444d6404c095fa5$export$bbed2da3bd3bb001 || ($e444d6404c095fa5$export$bbed2da3bd3bb001 = {}));
var $e444d6404c095fa5$var$Er = function() {
    function e() {
        $e444d6404c095fa5$var$i(this, e), $e444d6404c095fa5$var$o(this, "events", {}), this.events = {};
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "on",
            value: function(e, t) {
                var n = this;
                return this.events[e] || (this.events[e] = []), this.events[e].push(t), function() {
                    n.events[e] = n.events[e].filter(function(e) {
                        return e !== t;
                    });
                };
            }
        },
        {
            key: "emit",
            value: function(e, t) {
                var n, i = $e444d6404c095fa5$var$h(this.events[e] || []);
                try {
                    for(i.s(); !(n = i.n()).done;)(0, n.value)(t);
                } catch (e) {
                    i.e(e);
                } finally{
                    i.f();
                }
                var r, s = $e444d6404c095fa5$var$h(this.events["*"] || []);
                try {
                    for(s.s(); !(r = s.n()).done;)(0, r.value)(e, t);
                } catch (e) {
                    s.e(e);
                } finally{
                    s.f();
                }
            }
        }
    ]), e;
}(), $e444d6404c095fa5$var$Fr = function() {
    function e(t) {
        var n = this;
        $e444d6404c095fa5$var$i(this, e), $e444d6404c095fa5$var$o(this, "_debugEventEmitter", new $e444d6404c095fa5$var$Er), $e444d6404c095fa5$var$o(this, "checkStep", function(e, t) {
            return n.checkStepEvent(e, t) && n.checkStepUrl(e, t) && n.checkStepElement(e, t);
        }), $e444d6404c095fa5$var$o(this, "checkStepEvent", function(e, t) {
            return null == t || !t.event || (null == e ? void 0 : e.event) === (null == t ? void 0 : t.event);
        }), this.instance = t, this.actionEvents = new Set, this.actionRegistry = new Set;
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "init",
            value: function() {
                var e, t = this;
                if (!$e444d6404c095fa5$var$w(null === (e = this.instance) || void 0 === e ? void 0 : e._addCaptureHook)) {
                    var n;
                    null === (n = this.instance) || void 0 === n || n._addCaptureHook(function(e, n) {
                        t.on(e, n);
                    });
                }
            }
        },
        {
            key: "register",
            value: function(e) {
                var t, n, i = this;
                if (!$e444d6404c095fa5$var$w(null === (t = this.instance) || void 0 === t ? void 0 : t._addCaptureHook) && (e.forEach(function(e) {
                    var t, n;
                    null === (t = i.actionRegistry) || void 0 === t || t.add(e), null === (n = e.steps) || void 0 === n || n.forEach(function(e) {
                        var t;
                        null === (t = i.actionEvents) || void 0 === t || t.add((null == e ? void 0 : e.event) || "");
                    });
                }), null !== (n = this.instance) && void 0 !== n && n.autocapture)) {
                    var r, s = new Set;
                    e.forEach(function(e) {
                        var t;
                        null === (t = e.steps) || void 0 === t || t.forEach(function(e) {
                            null != e && e.selector && s.add(null == e ? void 0 : e.selector);
                        });
                    }), null === (r = this.instance) || void 0 === r || r.autocapture.setElementSelectors(s);
                }
            }
        },
        {
            key: "on",
            value: function(e, t) {
                var n, i = this;
                null != t && 0 != e.length && (this.actionEvents.has(e) || this.actionEvents.has(null == t ? void 0 : t.event)) && this.actionRegistry && (null === (n = this.actionRegistry) || void 0 === n ? void 0 : n.size) > 0 && this.actionRegistry.forEach(function(e) {
                    i.checkAction(t, e) && i._debugEventEmitter.emit("actionCaptured", e.name);
                });
            }
        },
        {
            key: "_addActionHook",
            value: function(e) {
                this.onAction("actionCaptured", function(t) {
                    return e(t);
                });
            }
        },
        {
            key: "checkAction",
            value: function(e, t) {
                if (null == (null == t ? void 0 : t.steps)) return !1;
                var n, i = $e444d6404c095fa5$var$h(t.steps);
                try {
                    for(i.s(); !(n = i.n()).done;){
                        var r = n.value;
                        if (this.checkStep(e, r)) return !0;
                    }
                } catch (e) {
                    i.e(e);
                } finally{
                    i.f();
                }
                return !1;
            }
        },
        {
            key: "onAction",
            value: function(e, t) {
                return this._debugEventEmitter.on(e, t);
            }
        },
        {
            key: "checkStepUrl",
            value: function(t, n) {
                if (null != n && n.url) {
                    var i, r = null == t || null === (i = t.properties) || void 0 === i ? void 0 : i.$current_url;
                    if (!r || "string" != typeof r) return !1;
                    if (!e.matchString(r, null == n ? void 0 : n.url, (null == n ? void 0 : n.url_matching) || "contains")) return !1;
                }
                return !0;
            }
        },
        {
            key: "checkStepElement",
            value: function(t, n) {
                if ((null != n && n.href || null != n && n.tag_name || null != n && n.text) && !this.getElementsList(t).some(function(t) {
                    return !(null != n && n.href && !e.matchString(t.href || "", null == n ? void 0 : n.href, (null == n ? void 0 : n.href_matching) || "exact")) && (null == n || !n.tag_name || t.tag_name === (null == n ? void 0 : n.tag_name)) && !(null != n && n.text && !e.matchString(t.text || "", null == n ? void 0 : n.text, (null == n ? void 0 : n.text_matching) || "exact") && !e.matchString(t.$el_text || "", null == n ? void 0 : n.text, (null == n ? void 0 : n.text_matching) || "exact"));
                })) return !1;
                if (null != n && n.selector) {
                    var i, r = null == t || null === (i = t.properties) || void 0 === i ? void 0 : i.$element_selectors;
                    if (!r) return !1;
                    if (!r.includes(null == n ? void 0 : n.selector)) return !1;
                }
                return !0;
            }
        },
        {
            key: "getElementsList",
            value: function(e) {
                return null == (null == e ? void 0 : e.properties.$elements) ? [] : null == e ? void 0 : e.properties.$elements;
            }
        }
    ], [
        {
            key: "matchString",
            value: function(t, n, i) {
                switch(i){
                    case "regex":
                        return !!$e444d6404c095fa5$var$T && $e444d6404c095fa5$var$_t(t, n);
                    case "exact":
                        return n === t;
                    case "contains":
                        var r = e.escapeStringRegexp(n).replace(/_/g, ".").replace(/%/g, ".*");
                        return $e444d6404c095fa5$var$_t(t, r);
                    default:
                        return !1;
                }
            }
        },
        {
            key: "escapeStringRegexp",
            value: function(e) {
                return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
            }
        }
    ]), e;
}(), $e444d6404c095fa5$var$Ir = function() {
    function e(t) {
        $e444d6404c095fa5$var$i(this, e), this.instance = t, this.eventToSurveys = new Map, this.actionToSurveys = new Map;
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "register",
            value: function(e) {
                var t;
                $e444d6404c095fa5$var$w(null === (t = this.instance) || void 0 === t ? void 0 : t._addCaptureHook) || (this.setupEventBasedSurveys(e), this.setupActionBasedSurveys(e));
            }
        },
        {
            key: "setupActionBasedSurveys",
            value: function(e) {
                var t = this, n = e.filter(function(e) {
                    var t, n, i, r;
                    return (null === (t = e.conditions) || void 0 === t ? void 0 : t.actions) && (null === (n = e.conditions) || void 0 === n || null === (i = n.actions) || void 0 === i || null === (r = i.values) || void 0 === r ? void 0 : r.length) > 0;
                });
                if (0 !== n.length) {
                    if (null == this.actionMatcher) {
                        this.actionMatcher = new $e444d6404c095fa5$var$Fr(this.instance), this.actionMatcher.init();
                        this.actionMatcher._addActionHook(function(e) {
                            t.onAction(e);
                        });
                    }
                    n.forEach(function(e) {
                        var n, i, r, s, o, a, u, l, c, d;
                        e.conditions && null !== (n = e.conditions) && void 0 !== n && n.actions && null !== (i = e.conditions) && void 0 !== i && null !== (r = i.actions) && void 0 !== r && r.values && (null === (s = e.conditions) || void 0 === s || null === (o = s.actions) || void 0 === o || null === (a = o.values) || void 0 === a ? void 0 : a.length) > 0 && (null === (u = t.actionMatcher) || void 0 === u || u.register(e.conditions.actions.values), null === (l = e.conditions) || void 0 === l || null === (c = l.actions) || void 0 === c || null === (d = c.values) || void 0 === d || d.forEach(function(n) {
                            if (n && n.name) {
                                var i = t.actionToSurveys.get(n.name);
                                i && i.push(e.id), t.actionToSurveys.set(n.name, i || [
                                    e.id
                                ]);
                            }
                        }));
                    });
                }
            }
        },
        {
            key: "setupEventBasedSurveys",
            value: function(e) {
                var t, n = this;
                if (0 !== e.filter(function(e) {
                    var t, n, i, r;
                    return (null === (t = e.conditions) || void 0 === t ? void 0 : t.events) && (null === (n = e.conditions) || void 0 === n || null === (i = n.events) || void 0 === i || null === (r = i.values) || void 0 === r ? void 0 : r.length) > 0;
                }).length) null === (t = this.instance) || void 0 === t || t._addCaptureHook(function(e) {
                    n.onEvent(e);
                }), e.forEach(function(e) {
                    var t, i, r;
                    null === (t = e.conditions) || void 0 === t || null === (i = t.events) || void 0 === i || null === (r = i.values) || void 0 === r || r.forEach(function(t) {
                        if (t && t.name) {
                            var i = n.eventToSurveys.get(t.name);
                            i && i.push(e.id), n.eventToSurveys.set(t.name, i || [
                                e.id
                            ]);
                        }
                    });
                });
            }
        },
        {
            key: "onEvent",
            value: function(t, n) {
                var i, r, s = (null === (i = this.instance) || void 0 === i || null === (r = i.persistence) || void 0 === r ? void 0 : r.props[$e444d6404c095fa5$var$Te]) || [];
                if (e.SURVEY_SHOWN_EVENT_NAME == t && n && s.length > 0) {
                    var o, a = null == n || null === (o = n.properties) || void 0 === o ? void 0 : o.$survey_id;
                    if (a) {
                        var u = s.indexOf(a);
                        u >= 0 && (s.splice(u, 1), this._updateActivatedSurveys(s));
                    }
                } else this.eventToSurveys.has(t) && this._updateActivatedSurveys(s.concat(this.eventToSurveys.get(t) || []));
            }
        },
        {
            key: "onAction",
            value: function(e) {
                var t, n, i = (null === (t = this.instance) || void 0 === t || null === (n = t.persistence) || void 0 === n ? void 0 : n.props[$e444d6404c095fa5$var$Te]) || [];
                this.actionToSurveys.has(e) && this._updateActivatedSurveys(i.concat(this.actionToSurveys.get(e) || []));
            }
        },
        {
            key: "_updateActivatedSurveys",
            value: function(e) {
                var t, n;
                null === (t = this.instance) || void 0 === t || null === (n = t.persistence) || void 0 === n || n.register($e444d6404c095fa5$var$o({}, $e444d6404c095fa5$var$Te, $e444d6404c095fa5$var$l(new Set(e))));
            }
        },
        {
            key: "getSurveys",
            value: function() {
                var e, t, n = null === (e = this.instance) || void 0 === e || null === (t = e.persistence) || void 0 === t ? void 0 : t.props[$e444d6404c095fa5$var$Te];
                return n || [];
            }
        },
        {
            key: "getEventToSurveys",
            value: function() {
                return this.eventToSurveys;
            }
        },
        {
            key: "_getActionMatcher",
            value: function() {
                return this.actionMatcher;
            }
        }
    ]), e;
}();
$e444d6404c095fa5$var$o($e444d6404c095fa5$var$Ir, "SURVEY_SHOWN_EVENT_NAME", "survey shown");
var $e444d6404c095fa5$var$Rr, $e444d6404c095fa5$var$xr, $e444d6404c095fa5$var$Pr, $e444d6404c095fa5$var$Tr, $e444d6404c095fa5$var$Cr, $e444d6404c095fa5$var$$r, $e444d6404c095fa5$var$Or, $e444d6404c095fa5$var$Mr, $e444d6404c095fa5$var$Ar = {}, $e444d6404c095fa5$var$Dr = [], $e444d6404c095fa5$var$Lr = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $e444d6404c095fa5$var$Nr = Array.isArray;
function $e444d6404c095fa5$var$qr(e, t) {
    for(var n in t)e[n] = t[n];
    return e;
}
function $e444d6404c095fa5$var$Br(e) {
    var t = e.parentNode;
    t && t.removeChild(e);
}
function $e444d6404c095fa5$var$Hr(e, t, n, i, r) {
    var s = {
        type: e,
        props: t,
        key: n,
        ref: i,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++$e444d6404c095fa5$var$Pr : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != $e444d6404c095fa5$var$xr.vnode && $e444d6404c095fa5$var$xr.vnode(s), s;
}
function $e444d6404c095fa5$var$Ur(e) {
    return e.children;
}
function $e444d6404c095fa5$var$jr(e, t) {
    this.props = e, this.context = t;
}
function $e444d6404c095fa5$var$Wr(e, t) {
    if (null == t) return e.__ ? $e444d6404c095fa5$var$Wr(e.__, e.__i + 1) : null;
    for(var n; t < e.__k.length; t++)if (null != (n = e.__k[t]) && null != n.__e) return n.__e;
    return "function" == typeof e.type ? $e444d6404c095fa5$var$Wr(e) : null;
}
function $e444d6404c095fa5$var$Gr(e) {
    var t, n;
    if (null != (e = e.__) && null != e.__c) {
        for(e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++)if (null != (n = e.__k[t]) && null != n.__e) {
            e.__e = e.__c.base = n.__e;
            break;
        }
        return $e444d6404c095fa5$var$Gr(e);
    }
}
function $e444d6404c095fa5$var$zr(e) {
    (!e.__d && (e.__d = !0) && $e444d6404c095fa5$var$Tr.push(e) && !$e444d6404c095fa5$var$Vr.__r++ || $e444d6404c095fa5$var$Cr !== $e444d6404c095fa5$var$xr.debounceRendering) && (($e444d6404c095fa5$var$Cr = $e444d6404c095fa5$var$xr.debounceRendering) || $e444d6404c095fa5$var$$r)($e444d6404c095fa5$var$Vr);
}
function $e444d6404c095fa5$var$Vr() {
    var e, t, n, i, r, s, o, a, u;
    for($e444d6404c095fa5$var$Tr.sort($e444d6404c095fa5$var$Or); e = $e444d6404c095fa5$var$Tr.shift();)e.__d && (t = $e444d6404c095fa5$var$Tr.length, i = void 0, s = (r = (n = e).__v).__e, a = [], u = [], (o = n.__P) && ((i = $e444d6404c095fa5$var$qr({}, r)).__v = r.__v + 1, $e444d6404c095fa5$var$xr.vnode && $e444d6404c095fa5$var$xr.vnode(i), $e444d6404c095fa5$var$ns(o, i, r, n.__n, void 0 !== o.ownerSVGElement, 32 & r.__u ? [
        s
    ] : null, a, null == s ? $e444d6404c095fa5$var$Wr(r) : s, !!(32 & r.__u), u), i.__.__k[i.__i] = i, $e444d6404c095fa5$var$is(a, i, u), i.__e != s && $e444d6404c095fa5$var$Gr(i)), $e444d6404c095fa5$var$Tr.length > t && $e444d6404c095fa5$var$Tr.sort($e444d6404c095fa5$var$Or));
    $e444d6404c095fa5$var$Vr.__r = 0;
}
function $e444d6404c095fa5$var$Qr(e, t, n, i, r, s, o, a, u, l, c) {
    var d, h, f, p, v, _ = i && i.__k || $e444d6404c095fa5$var$Dr, g = t.length;
    for(n.__d = u, $e444d6404c095fa5$var$Jr(n, t, _), u = n.__d, d = 0; d < g; d++)null != (f = n.__k[d]) && "boolean" != typeof f && "function" != typeof f && (h = -1 === f.__i ? $e444d6404c095fa5$var$Ar : _[f.__i] || $e444d6404c095fa5$var$Ar, f.__i = d, $e444d6404c095fa5$var$ns(e, f, h, r, s, o, a, u, l, c), p = f.__e, f.ref && h.ref != f.ref && (h.ref && $e444d6404c095fa5$var$ss(h.ref, null, f), c.push(f.ref, f.__c || p, f)), null == v && null != p && (v = p), 65536 & f.__u || h.__k === f.__k ? u = $e444d6404c095fa5$var$Yr(f, u, e) : "function" == typeof f.type && void 0 !== f.__d ? u = f.__d : p && (u = p.nextSibling), f.__d = void 0, f.__u &= -196609);
    n.__d = u, n.__e = v;
}
function $e444d6404c095fa5$var$Jr(e, t, n) {
    var i, r, s, o, a, u = t.length, l = n.length, c = l, d = 0;
    for(e.__k = [], i = 0; i < u; i++)null != (r = e.__k[i] = null == (r = t[i]) || "boolean" == typeof r || "function" == typeof r ? null : "string" == typeof r || "number" == typeof r || "bigint" == typeof r || r.constructor == String ? $e444d6404c095fa5$var$Hr(null, r, null, null, r) : $e444d6404c095fa5$var$Nr(r) ? $e444d6404c095fa5$var$Hr($e444d6404c095fa5$var$Ur, {
        children: r
    }, null, null, null) : void 0 === r.constructor && r.__b > 0 ? $e444d6404c095fa5$var$Hr(r.type, r.props, r.key, r.ref ? r.ref : null, r.__v) : r) ? (r.__ = e, r.__b = e.__b + 1, a = $e444d6404c095fa5$var$Xr(r, n, o = i + d, c), r.__i = a, s = null, -1 !== a && (c--, (s = n[a]) && (s.__u |= 131072)), null == s || null === s.__v ? (-1 == a && d--, "function" != typeof r.type && (r.__u |= 65536)) : a !== o && (a === o + 1 ? d++ : a > o ? c > u - o ? d += a - o : d-- : d = a < o && a == o - 1 ? a - o : 0, a !== i + d && (r.__u |= 65536))) : (s = n[i]) && null == s.key && s.__e && (s.__e == e.__d && (e.__d = $e444d6404c095fa5$var$Wr(s)), $e444d6404c095fa5$var$os(s, s, !1), n[i] = null, c--);
    if (c) for(i = 0; i < l; i++)null != (s = n[i]) && 0 == (131072 & s.__u) && (s.__e == e.__d && (e.__d = $e444d6404c095fa5$var$Wr(s)), $e444d6404c095fa5$var$os(s, s));
}
function $e444d6404c095fa5$var$Yr(e, t, n) {
    var i, r;
    if ("function" == typeof e.type) {
        for(i = e.__k, r = 0; i && r < i.length; r++)i[r] && (i[r].__ = e, t = $e444d6404c095fa5$var$Yr(i[r], t, n));
        return t;
    }
    return e.__e != t && (n.insertBefore(e.__e, t || null), t = e.__e), t && t.nextSibling;
}
function $e444d6404c095fa5$var$Xr(e, t, n, i) {
    var r = e.key, s = e.type, o = n - 1, a = n + 1, u = t[n];
    if (null === u || u && r == u.key && s === u.type) return n;
    if (i > (null != u && 0 == (131072 & u.__u) ? 1 : 0)) for(; o >= 0 || a < t.length;){
        if (o >= 0) {
            if ((u = t[o]) && 0 == (131072 & u.__u) && r == u.key && s === u.type) return o;
            o--;
        }
        if (a < t.length) {
            if ((u = t[a]) && 0 == (131072 & u.__u) && r == u.key && s === u.type) return a;
            a++;
        }
    }
    return -1;
}
function $e444d6404c095fa5$var$Kr(e, t, n) {
    "-" === t[0] ? e.setProperty(t, null == n ? "" : n) : e[t] = null == n ? "" : "number" != typeof n || $e444d6404c095fa5$var$Lr.test(t) ? n : n + "px";
}
function $e444d6404c095fa5$var$Zr(e, t, n, i, r) {
    var s;
    e: if ("style" === t) {
        if ("string" == typeof n) e.style.cssText = n;
        else {
            if ("string" == typeof i && (e.style.cssText = i = ""), i) for(t in i)n && t in n || $e444d6404c095fa5$var$Kr(e.style, t, "");
            if (n) for(t in n)i && n[t] === i[t] || $e444d6404c095fa5$var$Kr(e.style, t, n[t]);
        }
    } else if ("o" === t[0] && "n" === t[1]) s = t !== (t = t.replace(/(PointerCapture)$|Capture$/, "$1")), t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + s] = n, n ? i ? n.u = i.u : (n.u = Date.now(), e.addEventListener(t, s ? $e444d6404c095fa5$var$ts : $e444d6404c095fa5$var$es, s)) : e.removeEventListener(t, s ? $e444d6404c095fa5$var$ts : $e444d6404c095fa5$var$es, s);
    else {
        if (r) t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== t && "height" !== t && "href" !== t && "list" !== t && "form" !== t && "tabIndex" !== t && "download" !== t && "rowSpan" !== t && "colSpan" !== t && "role" !== t && t in e) try {
            e[t] = null == n ? "" : n;
            break e;
        } catch (e) {}
        "function" == typeof n || (null == n || !1 === n && "-" !== t[4] ? e.removeAttribute(t) : e.setAttribute(t, n));
    }
}
function $e444d6404c095fa5$var$es(e) {
    var t = this.l[e.type + !1];
    if (e.t) {
        if (e.t <= t.u) return;
    } else e.t = Date.now();
    return t($e444d6404c095fa5$var$xr.event ? $e444d6404c095fa5$var$xr.event(e) : e);
}
function $e444d6404c095fa5$var$ts(e) {
    return this.l[e.type + !0]($e444d6404c095fa5$var$xr.event ? $e444d6404c095fa5$var$xr.event(e) : e);
}
function $e444d6404c095fa5$var$ns(e, t, n, i, r, s, o, a, u, l) {
    var c, d, h, f, p, v, _, g, m, y, b, k, w, S, E, F = t.type;
    if (void 0 !== t.constructor) return null;
    128 & n.__u && (u = !!(32 & n.__u), s = [
        a = t.__e = n.__e
    ]), (c = $e444d6404c095fa5$var$xr.__b) && c(t);
    e: if ("function" == typeof F) try {
        if (g = t.props, m = (c = F.contextType) && i[c.__c], y = c ? m ? m.props.value : c.__ : i, n.__c ? _ = (d = t.__c = n.__c).__ = d.__E : ("prototype" in F && F.prototype.render ? t.__c = d = new F(g, y) : (t.__c = d = new $e444d6404c095fa5$var$jr(g, y), d.constructor = F, d.render = $e444d6404c095fa5$var$as), m && m.sub(d), d.props = g, d.state || (d.state = {}), d.context = y, d.__n = i, h = d.__d = !0, d.__h = [], d._sb = []), null == d.__s && (d.__s = d.state), null != F.getDerivedStateFromProps && (d.__s == d.state && (d.__s = $e444d6404c095fa5$var$qr({}, d.__s)), $e444d6404c095fa5$var$qr(d.__s, F.getDerivedStateFromProps(g, d.__s))), f = d.props, p = d.state, d.__v = t, h) null == F.getDerivedStateFromProps && null != d.componentWillMount && d.componentWillMount(), null != d.componentDidMount && d.__h.push(d.componentDidMount);
        else {
            if (null == F.getDerivedStateFromProps && g !== f && null != d.componentWillReceiveProps && d.componentWillReceiveProps(g, y), !d.__e && (null != d.shouldComponentUpdate && !1 === d.shouldComponentUpdate(g, d.__s, y) || t.__v === n.__v)) {
                for(t.__v !== n.__v && (d.props = g, d.state = d.__s, d.__d = !1), t.__e = n.__e, t.__k = n.__k, t.__k.forEach(function(e) {
                    e && (e.__ = t);
                }), b = 0; b < d._sb.length; b++)d.__h.push(d._sb[b]);
                d._sb = [], d.__h.length && o.push(d);
                break e;
            }
            null != d.componentWillUpdate && d.componentWillUpdate(g, d.__s, y), null != d.componentDidUpdate && d.__h.push(function() {
                d.componentDidUpdate(f, p, v);
            });
        }
        if (d.context = y, d.props = g, d.__P = e, d.__e = !1, k = $e444d6404c095fa5$var$xr.__r, w = 0, "prototype" in F && F.prototype.render) {
            for(d.state = d.__s, d.__d = !1, k && k(t), c = d.render(d.props, d.state, d.context), S = 0; S < d._sb.length; S++)d.__h.push(d._sb[S]);
            d._sb = [];
        } else do d.__d = !1, k && k(t), c = d.render(d.props, d.state, d.context), d.state = d.__s;
        while (d.__d && ++w < 25);
        d.state = d.__s, null != d.getChildContext && (i = $e444d6404c095fa5$var$qr($e444d6404c095fa5$var$qr({}, i), d.getChildContext())), h || null == d.getSnapshotBeforeUpdate || (v = d.getSnapshotBeforeUpdate(f, p)), $e444d6404c095fa5$var$Qr(e, $e444d6404c095fa5$var$Nr(E = null != c && c.type === $e444d6404c095fa5$var$Ur && null == c.key ? c.props.children : c) ? E : [
            E
        ], t, n, i, r, s, o, a, u, l), d.base = t.__e, t.__u &= -161, d.__h.length && o.push(d), _ && (d.__E = d.__ = null);
    } catch (e) {
        t.__v = null, u || null != s ? (t.__e = a, t.__u |= u ? 160 : 32, s[s.indexOf(a)] = null) : (t.__e = n.__e, t.__k = n.__k), $e444d6404c095fa5$var$xr.__e(e, t, n);
    }
    else null == s && t.__v === n.__v ? (t.__k = n.__k, t.__e = n.__e) : t.__e = $e444d6404c095fa5$var$rs(n.__e, t, n, i, r, s, o, u, l);
    (c = $e444d6404c095fa5$var$xr.diffed) && c(t);
}
function $e444d6404c095fa5$var$is(e, t, n) {
    t.__d = void 0;
    for(var i = 0; i < n.length; i++)$e444d6404c095fa5$var$ss(n[i], n[++i], n[++i]);
    $e444d6404c095fa5$var$xr.__c && $e444d6404c095fa5$var$xr.__c(t, e), e.some(function(t) {
        try {
            e = t.__h, t.__h = [], e.some(function(e) {
                e.call(t);
            });
        } catch (e) {
            $e444d6404c095fa5$var$xr.__e(e, t.__v);
        }
    });
}
function $e444d6404c095fa5$var$rs(e, t, n, i, r, s, o, a, u) {
    var l, c, d, h, f, p, v, _ = n.props, g = t.props, m = t.type;
    if ("svg" === m && (r = !0), null != s) {
        for(l = 0; l < s.length; l++)if ((f = s[l]) && "setAttribute" in f == !!m && (m ? f.localName === m : 3 === f.nodeType)) {
            e = f, s[l] = null;
            break;
        }
    }
    if (null == e) {
        if (null === m) return document.createTextNode(g);
        e = r ? document.createElementNS("http://www.w3.org/2000/svg", m) : document.createElement(m, g.is && g), s = null, a = !1;
    }
    if (null === m) _ === g || a && e.data === g || (e.data = g);
    else {
        if (s = s && $e444d6404c095fa5$var$Rr.call(e.childNodes), _ = n.props || $e444d6404c095fa5$var$Ar, !a && null != s) for(_ = {}, l = 0; l < e.attributes.length; l++)_[(f = e.attributes[l]).name] = f.value;
        for(l in _)f = _[l], "children" == l || ("dangerouslySetInnerHTML" == l ? d = f : "key" === l || l in g || $e444d6404c095fa5$var$Zr(e, l, null, f, r));
        for(l in g)f = g[l], "children" == l ? h = f : "dangerouslySetInnerHTML" == l ? c = f : "value" == l ? p = f : "checked" == l ? v = f : "key" === l || a && "function" != typeof f || _[l] === f || $e444d6404c095fa5$var$Zr(e, l, f, _[l], r);
        if (c) a || d && (c.__html === d.__html || c.__html === e.innerHTML) || (e.innerHTML = c.__html), t.__k = [];
        else if (d && (e.innerHTML = ""), $e444d6404c095fa5$var$Qr(e, $e444d6404c095fa5$var$Nr(h) ? h : [
            h
        ], t, n, i, r && "foreignObject" !== m, s, o, s ? s[0] : n.__k && $e444d6404c095fa5$var$Wr(n, 0), a, u), null != s) for(l = s.length; l--;)null != s[l] && $e444d6404c095fa5$var$Br(s[l]);
        a || (l = "value", void 0 !== p && (p !== e[l] || "progress" === m && !p || "option" === m && p !== _[l]) && $e444d6404c095fa5$var$Zr(e, l, p, _[l], !1), l = "checked", void 0 !== v && v !== e[l] && $e444d6404c095fa5$var$Zr(e, l, v, _[l], !1));
    }
    return e;
}
function $e444d6404c095fa5$var$ss(e, t, n) {
    try {
        "function" == typeof e ? e(t) : e.current = t;
    } catch (e) {
        $e444d6404c095fa5$var$xr.__e(e, n);
    }
}
function $e444d6404c095fa5$var$os(e, t, n) {
    var i, r;
    if ($e444d6404c095fa5$var$xr.unmount && $e444d6404c095fa5$var$xr.unmount(e), (i = e.ref) && (i.current && i.current !== e.__e || $e444d6404c095fa5$var$ss(i, null, t)), null != (i = e.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (e) {
            $e444d6404c095fa5$var$xr.__e(e, t);
        }
        i.base = i.__P = null, e.__c = void 0;
    }
    if (i = e.__k) for(r = 0; r < i.length; r++)i[r] && $e444d6404c095fa5$var$os(i[r], t, n || "function" != typeof e.type);
    n || null == e.__e || $e444d6404c095fa5$var$Br(e.__e), e.__ = e.__e = e.__d = void 0;
}
function $e444d6404c095fa5$var$as(e, t, n) {
    return this.constructor(e, n);
}
$e444d6404c095fa5$var$Rr = $e444d6404c095fa5$var$Dr.slice, $e444d6404c095fa5$var$xr = {
    __e: function(e, t, n, i) {
        for(var r, s, o; t = t.__;)if ((r = t.__c) && !r.__) try {
            if ((s = r.constructor) && null != s.getDerivedStateFromError && (r.setState(s.getDerivedStateFromError(e)), o = r.__d), null != r.componentDidCatch && (r.componentDidCatch(e, i || {}), o = r.__d), o) return r.__E = r;
        } catch (t) {
            e = t;
        }
        throw e;
    }
}, $e444d6404c095fa5$var$Pr = 0, $e444d6404c095fa5$var$jr.prototype.setState = function(e, t) {
    var n;
    n = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $e444d6404c095fa5$var$qr({}, this.state), "function" == typeof e && (e = e($e444d6404c095fa5$var$qr({}, n), this.props)), e && $e444d6404c095fa5$var$qr(n, e), null != e && this.__v && (t && this._sb.push(t), $e444d6404c095fa5$var$zr(this));
}, $e444d6404c095fa5$var$jr.prototype.forceUpdate = function(e) {
    this.__v && (this.__e = !0, e && this.__h.push(e), $e444d6404c095fa5$var$zr(this));
}, $e444d6404c095fa5$var$jr.prototype.render = $e444d6404c095fa5$var$Ur, $e444d6404c095fa5$var$Tr = [], $e444d6404c095fa5$var$$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $e444d6404c095fa5$var$Or = function(e, t) {
    return e.__v.__b - t.__v.__b;
}, $e444d6404c095fa5$var$Vr.__r = 0, $e444d6404c095fa5$var$Mr = 0;
var $e444d6404c095fa5$var$us = function(e) {
    var t, n;
    return !(null === (t = e.conditions) || void 0 === t || null === (n = t.events) || void 0 === n || !n.repeatedActivation || !function(e) {
        var t, n, i, r, s, o;
        return null != (null === (t = e.conditions) || void 0 === t || null === (n = t.events) || void 0 === n || null === (i = n.values) || void 0 === i ? void 0 : i.length) && (null === (r = e.conditions) || void 0 === r || null === (s = r.events) || void 0 === s || null === (o = s.values) || void 0 === o ? void 0 : o.length) > 0;
    }(e));
};
!function(e, t) {
    var n = {
        __c: t = "__cC" + $e444d6404c095fa5$var$Mr++,
        __: e,
        Consumer: function(e, t) {
            return e.children(t);
        },
        Provider: function(e) {
            var n, i;
            return this.getChildContext || (n = [], (i = {})[t] = this, this.getChildContext = function() {
                return i;
            }, this.shouldComponentUpdate = function(e) {
                this.props.value !== e.value && n.some(function(e) {
                    e.__e = !0, $e444d6404c095fa5$var$zr(e);
                });
            }, this.sub = function(e) {
                n.push(e);
                var t = e.componentWillUnmount;
                e.componentWillUnmount = function() {
                    n.splice(n.indexOf(e), 1), t && t.call(e);
                };
            }), e.children;
        }
    };
    n.Provider.__ = n.Consumer.contextType = n;
}({
    isPreviewMode: !1,
    previewPageIndex: 0,
    handleCloseSurveyPopup: function() {}
});
var $e444d6404c095fa5$var$ls = {
    icontains: function(e) {
        return !!$e444d6404c095fa5$var$T && $e444d6404c095fa5$var$T.location.href.toLowerCase().indexOf(e.toLowerCase()) > -1;
    },
    not_icontains: function(e) {
        return !!$e444d6404c095fa5$var$T && -1 === $e444d6404c095fa5$var$T.location.href.toLowerCase().indexOf(e.toLowerCase());
    },
    regex: function(e) {
        return !!$e444d6404c095fa5$var$T && $e444d6404c095fa5$var$_t($e444d6404c095fa5$var$T.location.href, e);
    },
    not_regex: function(e) {
        return !!$e444d6404c095fa5$var$T && !$e444d6404c095fa5$var$_t($e444d6404c095fa5$var$T.location.href, e);
    },
    exact: function(e) {
        return (null == $e444d6404c095fa5$var$T ? void 0 : $e444d6404c095fa5$var$T.location.href) === e;
    },
    is_not: function(e) {
        return (null == $e444d6404c095fa5$var$T ? void 0 : $e444d6404c095fa5$var$T.location.href) !== e;
    }
};
var $e444d6404c095fa5$var$cs = function() {
    function e(t) {
        $e444d6404c095fa5$var$i(this, e), this.instance = t, this._surveyEventReceiver = null;
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "afterDecideResponse",
            value: function(e) {
                this._decideServerResponse = !!e.surveys, this.loadIfEnabled();
            }
        },
        {
            key: "loadIfEnabled",
            value: function() {
                var e = this, t = null == $e444d6404c095fa5$var$U ? void 0 : $e444d6404c095fa5$var$U.extendPostHogWithSurveys;
                this.instance.config.disable_surveys || !this._decideServerResponse || t || (null == this._surveyEventReceiver && (this._surveyEventReceiver = new $e444d6404c095fa5$var$Ir(this.instance)), this.instance.requestRouter.loadScript("/static/surveys.js", function(t) {
                    if (t) return $e444d6404c095fa5$var$W.error("Could not load surveys script", t);
                    $e444d6404c095fa5$var$U.extendPostHogWithSurveys(e.instance);
                }));
            }
        },
        {
            key: "getSurveys",
            value: function(e) {
                var t = this, n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                if (this.instance.config.disable_surveys) return e([]);
                null == this._surveyEventReceiver && (this._surveyEventReceiver = new $e444d6404c095fa5$var$Ir(this.instance));
                var i = this.instance.get_property($e444d6404c095fa5$var$Pe);
                if (i && !n) return e(i);
                this.instance._send_request({
                    url: this.instance.requestRouter.endpointFor("api", "/api/surveys/?token=".concat(this.instance.config.token)),
                    method: "GET",
                    transport: "XHR",
                    callback: function(n) {
                        var i;
                        if (200 !== n.statusCode || !n.json) return e([]);
                        var r, s = n.json.surveys || [], a = s.filter(function(e) {
                            var t, n, i, r, s, o, a, u, l, c, d, h;
                            return (null === (t = e.conditions) || void 0 === t ? void 0 : t.events) && (null === (n = e.conditions) || void 0 === n || null === (i = n.events) || void 0 === i ? void 0 : i.values) && (null === (r = e.conditions) || void 0 === r || null === (s = r.events) || void 0 === s || null === (o = s.values) || void 0 === o ? void 0 : o.length) > 0 || (null === (a = e.conditions) || void 0 === a ? void 0 : a.actions) && (null === (u = e.conditions) || void 0 === u || null === (l = u.actions) || void 0 === l ? void 0 : l.values) && (null === (c = e.conditions) || void 0 === c || null === (d = c.actions) || void 0 === d || null === (h = d.values) || void 0 === h ? void 0 : h.length) > 0;
                        });
                        a.length > 0 && (null === (r = t._surveyEventReceiver) || void 0 === r || r.register(a));
                        return null === (i = t.instance.persistence) || void 0 === i || i.register($e444d6404c095fa5$var$o({}, $e444d6404c095fa5$var$Pe, s)), e(s);
                    }
                });
            }
        },
        {
            key: "getActiveMatchingSurveys",
            value: function(e) {
                var t = this, n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                this.getSurveys(function(n) {
                    var i, r = n.filter(function(e) {
                        return !(!e.start_date || e.end_date);
                    }).filter(function(e) {
                        var t, n, i, r;
                        if (!e.conditions) return !0;
                        var s = null === (t = e.conditions) || void 0 === t || !t.url || $e444d6404c095fa5$var$ls[null !== (n = null === (i = e.conditions) || void 0 === i ? void 0 : i.urlMatchType) && void 0 !== n ? n : "icontains"](e.conditions.url), o = null === (r = e.conditions) || void 0 === r || !r.selector || (null == $e444d6404c095fa5$var$D ? void 0 : $e444d6404c095fa5$var$D.querySelector(e.conditions.selector));
                        return s && o;
                    }), s = null === (i = t._surveyEventReceiver) || void 0 === i ? void 0 : i.getSurveys(), o = r.filter(function(e) {
                        var n, i, r, o, a, u, l, c, d, h;
                        if (!e.linked_flag_key && !e.targeting_flag_key && !e.internal_targeting_flag_key) return !0;
                        var f = !e.linked_flag_key || t.instance.featureFlags.isFeatureEnabled(e.linked_flag_key), p = !e.targeting_flag_key || t.instance.featureFlags.isFeatureEnabled(e.targeting_flag_key), v = (null === (n = e.conditions) || void 0 === n ? void 0 : n.events) && (null === (i = e.conditions) || void 0 === i || null === (r = i.events) || void 0 === r ? void 0 : r.values) && (null === (o = e.conditions) || void 0 === o || null === (a = o.events) || void 0 === a ? void 0 : a.values.length) > 0, _ = (null === (u = e.conditions) || void 0 === u ? void 0 : u.actions) && (null === (l = e.conditions) || void 0 === l || null === (c = l.actions) || void 0 === c ? void 0 : c.values) && (null === (d = e.conditions) || void 0 === d || null === (h = d.actions) || void 0 === h ? void 0 : h.values.length) > 0, g = !v && !_ || (null == s ? void 0 : s.includes(e.id)), m = $e444d6404c095fa5$var$us(e), y = !(e.internal_targeting_flag_key && !m) || t.instance.featureFlags.isFeatureEnabled(e.internal_targeting_flag_key);
                        return f && p && y && g;
                    });
                    return e(o);
                }, n);
            }
        },
        {
            key: "getNextSurveyStep",
            value: function(e, t, n) {
                var i, r = e.questions[t], s = t + 1;
                if (null === (i = r.branching) || void 0 === i || !i.type) return t === e.questions.length - 1 ? $e444d6404c095fa5$export$bbed2da3bd3bb001.End : s;
                if (r.branching.type === $e444d6404c095fa5$export$bbed2da3bd3bb001.End) return $e444d6404c095fa5$export$bbed2da3bd3bb001.End;
                if (r.branching.type === $e444d6404c095fa5$export$bbed2da3bd3bb001.SpecificQuestion) {
                    if (Number.isInteger(r.branching.index)) return r.branching.index;
                } else if (r.branching.type === $e444d6404c095fa5$export$bbed2da3bd3bb001.ResponseBased) {
                    if (r.type === $e444d6404c095fa5$export$9c2ac61661d417f8.SingleChoice) {
                        var o, a, u = r.choices.indexOf("".concat(n));
                        if (null !== (o = r.branching) && void 0 !== o && null !== (a = o.responseValues) && void 0 !== a && a.hasOwnProperty(u)) {
                            var l = r.branching.responseValues[u];
                            return Number.isInteger(l) ? l : l === $e444d6404c095fa5$export$bbed2da3bd3bb001.End ? $e444d6404c095fa5$export$bbed2da3bd3bb001.End : s;
                        }
                    } else if (r.type === $e444d6404c095fa5$export$9c2ac61661d417f8.Rating) {
                        var c, d;
                        if ("number" != typeof n || !Number.isInteger(n)) throw new Error("The response type must be an integer");
                        var h = function(e, t) {
                            if (3 === t) {
                                if (e < 1 || e > 3) throw new Error("The response must be in range 1-3");
                                return 1 === e ? "negative" : 2 === e ? "neutral" : "positive";
                            }
                            if (5 === t) {
                                if (e < 1 || e > 5) throw new Error("The response must be in range 1-5");
                                return e <= 2 ? "negative" : 3 === e ? "neutral" : "positive";
                            }
                            if (10 === t) {
                                if (e < 0 || e > 10) throw new Error("The response must be in range 0-10");
                                return e <= 6 ? "detractors" : e <= 8 ? "passives" : "promoters";
                            }
                            throw new Error("The scale must be one of: 3, 5, 10");
                        }(n, r.scale);
                        if (null !== (c = r.branching) && void 0 !== c && null !== (d = c.responseValues) && void 0 !== d && d.hasOwnProperty(h)) {
                            var f = r.branching.responseValues[h];
                            return Number.isInteger(f) ? f : f === $e444d6404c095fa5$export$bbed2da3bd3bb001.End ? $e444d6404c095fa5$export$bbed2da3bd3bb001.End : s;
                        }
                    }
                    return s;
                }
                return console.warn("Falling back to next question index due to unexpected branching type"), s;
            }
        }
    ]), e;
}(), $e444d6404c095fa5$var$ds = function() {
    function e(t) {
        var n, r, s = this;
        $e444d6404c095fa5$var$i(this, e), $e444d6404c095fa5$var$o(this, "serverLimits", {}), $e444d6404c095fa5$var$o(this, "lastEventRateLimited", !1), $e444d6404c095fa5$var$o(this, "checkForLimiting", function(e) {
            var t = e.text;
            if (t && t.length) try {
                (JSON.parse(t).quota_limited || []).forEach(function(e) {
                    $e444d6404c095fa5$var$W.info("[RateLimiter] ".concat(e || "events", " is quota limited.")), s.serverLimits[e] = (new Date).getTime() + 6e4;
                });
            } catch (e) {
                return void $e444d6404c095fa5$var$W.warn('[RateLimiter] could not rate limit - continuing. Error: "'.concat(null == e ? void 0 : e.message, '"'), {
                    text: t
                });
            }
        }), this.instance = t, this.captureEventsPerSecond = (null === (n = t.config.rate_limiting) || void 0 === n ? void 0 : n.events_per_second) || 10, this.captureEventsBurstLimit = Math.max((null === (r = t.config.rate_limiting) || void 0 === r ? void 0 : r.events_burst_limit) || 10 * this.captureEventsPerSecond, this.captureEventsPerSecond), this.lastEventRateLimited = this.clientRateLimitContext(!0).isRateLimited;
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "clientRateLimitContext",
            value: function() {
                var e, t, n, i = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], r = (new Date).getTime(), s = null !== (e = null === (t = this.instance.persistence) || void 0 === t ? void 0 : t.get_property($e444d6404c095fa5$var$Me)) && void 0 !== e ? e : {
                    tokens: this.captureEventsBurstLimit,
                    last: r
                };
                s.tokens += (r - s.last) / 1e3 * this.captureEventsPerSecond, s.last = r, s.tokens > this.captureEventsBurstLimit && (s.tokens = this.captureEventsBurstLimit);
                var o = s.tokens < 1;
                return o || i || (s.tokens = Math.max(0, s.tokens - 1)), !o || this.lastEventRateLimited || i || this.instance.capture("$$client_ingestion_warning", {
                    $$client_ingestion_warning_message: "posthog-js client rate limited. Config is set to ".concat(this.captureEventsPerSecond, " events per second and ").concat(this.captureEventsBurstLimit, " events burst limit.")
                }, {
                    skip_client_rate_limiting: !0
                }), this.lastEventRateLimited = o, null === (n = this.instance.persistence) || void 0 === n || n.set_property($e444d6404c095fa5$var$Me, s), {
                    isRateLimited: o,
                    remainingTokens: s.tokens
                };
            }
        },
        {
            key: "isServerRateLimited",
            value: function(e) {
                var t = this.serverLimits[e || "events"] || !1;
                return !1 !== t && (new Date).getTime() < t;
            }
        }
    ]), e;
}(), $e444d6404c095fa5$var$hs = function() {
    return $e444d6404c095fa5$var$t({
        initialPathName: (null == $e444d6404c095fa5$var$L ? void 0 : $e444d6404c095fa5$var$L.pathname) || "",
        referringDomain: $e444d6404c095fa5$var$mn.referringDomain()
    }, $e444d6404c095fa5$var$mn.campaignParams());
}, $e444d6404c095fa5$var$fs = function() {
    function e(t, n, r) {
        var s = this;
        $e444d6404c095fa5$var$i(this, e), $e444d6404c095fa5$var$o(this, "_onSessionIdCallback", function(e) {
            var t = s._getStoredProps();
            if (!t || t.sessionId !== e) {
                var n = {
                    sessionId: e,
                    props: s._sessionSourceParamGenerator()
                };
                s._persistence.register($e444d6404c095fa5$var$o({}, $e444d6404c095fa5$var$Oe, n));
            }
        }), this._sessionIdManager = t, this._persistence = n, this._sessionSourceParamGenerator = r || $e444d6404c095fa5$var$hs, this._sessionIdManager.onSessionId(this._onSessionIdCallback);
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "_getStoredProps",
            value: function() {
                return this._persistence.props[$e444d6404c095fa5$var$Oe];
            }
        },
        {
            key: "getSessionProps",
            value: function() {
                var e, t = null === (e = this._getStoredProps()) || void 0 === e ? void 0 : e.props;
                return t ? {
                    $client_session_initial_referring_host: t.referringDomain,
                    $client_session_initial_pathname: t.initialPathName,
                    $client_session_initial_utm_source: t.utm_source,
                    $client_session_initial_utm_campaign: t.utm_campaign,
                    $client_session_initial_utm_medium: t.utm_medium,
                    $client_session_initial_utm_content: t.utm_content,
                    $client_session_initial_utm_term: t.utm_term
                } : {};
            }
        }
    ]), e;
}(), $e444d6404c095fa5$var$ps = [
    "ahrefsbot",
    "ahrefssiteaudit",
    "applebot",
    "baiduspider",
    "bingbot",
    "bingpreview",
    "bot.htm",
    "bot.php",
    "crawler",
    "deepscan",
    "duckduckbot",
    "facebookexternal",
    "facebookcatalog",
    "gptbot",
    "http://yandex.com/bots",
    "hubspot",
    "ia_archiver",
    "linkedinbot",
    "mj12bot",
    "msnbot",
    "nessus",
    "petalbot",
    "pinterest",
    "prerender",
    "rogerbot",
    "screaming frog",
    "semrushbot",
    "sitebulb",
    "slurp",
    "turnitin",
    "twitterbot",
    "vercelbot",
    "yahoo! slurp",
    "yandexbot",
    "Google-HotelAdsVerifier",
    "adsbot-google",
    "apis-google",
    "duplexweb-google",
    "feedfetcher-google",
    "google favicon",
    "google web preview",
    "google-read-aloud",
    "googlebot",
    "googleweblight",
    "mediapartners-google",
    "storebot-google",
    "Bytespider;"
], $e444d6404c095fa5$var$vs = function(e, t) {
    if (!e) return !1;
    var n = e.toLowerCase();
    return $e444d6404c095fa5$var$ps.concat(t || []).some(function(e) {
        var t = e.toLowerCase();
        return -1 !== n.indexOf(t);
    });
}, $e444d6404c095fa5$var$_s = function() {
    function e() {
        $e444d6404c095fa5$var$i(this, e), this.clicks = [];
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "isRageClick",
            value: function(e, t, n) {
                var i = this.clicks[this.clicks.length - 1];
                if (i && Math.abs(e - i.x) + Math.abs(t - i.y) < 30 && n - i.timestamp < 1e3) {
                    if (this.clicks.push({
                        x: e,
                        y: t,
                        timestamp: n
                    }), 3 === this.clicks.length) return !0;
                } else this.clicks = [
                    {
                        x: e,
                        y: t,
                        timestamp: n
                    }
                ];
                return !1;
            }
        }
    ]), e;
}();
function $e444d6404c095fa5$var$gs(e) {
    var t;
    return e.id === $e444d6404c095fa5$var$qe || !(null === (t = e.closest) || void 0 === t || !t.call(e, "#" + $e444d6404c095fa5$var$qe));
}
var $e444d6404c095fa5$var$ms = function() {
    function e(t) {
        var n, r = this;
        $e444d6404c095fa5$var$i(this, e), $e444d6404c095fa5$var$o(this, "rageclicks", new $e444d6404c095fa5$var$_s), $e444d6404c095fa5$var$o(this, "_enabledServerSide", !1), $e444d6404c095fa5$var$o(this, "_initialized", !1), $e444d6404c095fa5$var$o(this, "_flushInterval", null), this.instance = t, this._enabledServerSide = !(null === (n = this.instance.persistence) || void 0 === n || !n.props[$e444d6404c095fa5$var$fe]), null == $e444d6404c095fa5$var$T || $e444d6404c095fa5$var$T.addEventListener("beforeunload", function() {
            r.flush();
        });
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "flushIntervalMilliseconds",
            get: function() {
                var e = 5e3;
                return $e444d6404c095fa5$var$b(this.instance.config.capture_heatmaps) && this.instance.config.capture_heatmaps.flush_interval_milliseconds && (e = this.instance.config.capture_heatmaps.flush_interval_milliseconds), e;
            }
        },
        {
            key: "isEnabled",
            get: function() {
                return $e444d6404c095fa5$var$w(this.instance.config.capture_heatmaps) ? $e444d6404c095fa5$var$w(this.instance.config.enable_heatmaps) ? this._enabledServerSide : this.instance.config.enable_heatmaps : !1 !== this.instance.config.capture_heatmaps;
            }
        },
        {
            key: "startIfEnabled",
            value: function() {
                if (this.isEnabled) {
                    if (this._initialized) return;
                    $e444d6404c095fa5$var$W.info("[heatmaps] starting..."), this._setupListeners(), this._flushInterval = setInterval(this.flush.bind(this), this.flushIntervalMilliseconds);
                } else {
                    var e;
                    clearInterval(null !== (e = this._flushInterval) && void 0 !== e ? e : void 0), this.getAndClearBuffer();
                }
            }
        },
        {
            key: "afterDecideResponse",
            value: function(e) {
                var t = !!e.heatmaps;
                this.instance.persistence && this.instance.persistence.register($e444d6404c095fa5$var$o({}, $e444d6404c095fa5$var$fe, t)), this._enabledServerSide = t, this.startIfEnabled();
            }
        },
        {
            key: "getAndClearBuffer",
            value: function() {
                var e = this.buffer;
                return this.buffer = void 0, e;
            }
        },
        {
            key: "_setupListeners",
            value: function() {
                var e = this;
                $e444d6404c095fa5$var$T && $e444d6404c095fa5$var$D && ($e444d6404c095fa5$var$oe($e444d6404c095fa5$var$D, "click", function(t) {
                    return e._onClick(t || (null == $e444d6404c095fa5$var$T ? void 0 : $e444d6404c095fa5$var$T.event));
                }, !1, !0), $e444d6404c095fa5$var$oe($e444d6404c095fa5$var$D, "mousemove", function(t) {
                    return e._onMouseMove(t || (null == $e444d6404c095fa5$var$T ? void 0 : $e444d6404c095fa5$var$T.event));
                }, !1, !0), this._initialized = !0);
            }
        },
        {
            key: "_getProperties",
            value: function(e, t) {
                var n = this.instance.scrollManager.scrollY(), i = this.instance.scrollManager.scrollX(), r = this.instance.scrollManager.scrollElement(), s = function(e, t, n) {
                    for(var i = e; i && !$e444d6404c095fa5$var$Tn(i, "body");){
                        if (i === n) return !1;
                        if ($e444d6404c095fa5$var$Y(t, null == $e444d6404c095fa5$var$T ? void 0 : $e444d6404c095fa5$var$T.getComputedStyle(i).position)) return !0;
                        i = $e444d6404c095fa5$var$Mn(i);
                    }
                    return !1;
                }(e.target, [
                    "fixed",
                    "sticky"
                ], r);
                return {
                    x: e.clientX + (s ? 0 : i),
                    y: e.clientY + (s ? 0 : n),
                    target_fixed: s,
                    type: t
                };
            }
        },
        {
            key: "_onClick",
            value: function(e) {
                var n;
                if (!$e444d6404c095fa5$var$gs(e.target)) {
                    var i = this._getProperties(e, "click");
                    null !== (n = this.rageclicks) && void 0 !== n && n.isRageClick(e.clientX, e.clientY, (new Date).getTime()) && this._capture($e444d6404c095fa5$var$t($e444d6404c095fa5$var$t({}, i), {}, {
                        type: "rageclick"
                    })), this._capture(i);
                }
            }
        },
        {
            key: "_onMouseMove",
            value: function(e) {
                var t = this;
                $e444d6404c095fa5$var$gs(e.target) || (clearTimeout(this._mouseMoveTimeout), this._mouseMoveTimeout = setTimeout(function() {
                    t._capture(t._getProperties(e, "mousemove"));
                }, 500));
            }
        },
        {
            key: "_capture",
            value: function(e) {
                if ($e444d6404c095fa5$var$T) {
                    var t = $e444d6404c095fa5$var$T.location.href;
                    this.buffer = this.buffer || {}, this.buffer[t] || (this.buffer[t] = []), this.buffer[t].push(e);
                }
            }
        },
        {
            key: "flush",
            value: function() {
                this.buffer && !$e444d6404c095fa5$var$k(this.buffer) && this.instance.capture("$$heatmap", {
                    $heatmap_data: this.getAndClearBuffer()
                });
            }
        }
    ]), e;
}(), $e444d6404c095fa5$var$ys = function() {
    function e(t) {
        var n = this;
        $e444d6404c095fa5$var$i(this, e), $e444d6404c095fa5$var$o(this, "_updateScrollData", function() {
            var e, t, i, r;
            n.context || (n.context = {});
            var s = n.scrollElement(), o = n.scrollY(), a = s ? Math.max(0, s.scrollHeight - s.clientHeight) : 0, u = o + ((null == s ? void 0 : s.clientHeight) || 0), l = (null == s ? void 0 : s.scrollHeight) || 0;
            n.context.lastScrollY = Math.ceil(o), n.context.maxScrollY = Math.max(o, null !== (e = n.context.maxScrollY) && void 0 !== e ? e : 0), n.context.maxScrollHeight = Math.max(a, null !== (t = n.context.maxScrollHeight) && void 0 !== t ? t : 0), n.context.lastContentY = u, n.context.maxContentY = Math.max(u, null !== (i = n.context.maxContentY) && void 0 !== i ? i : 0), n.context.maxContentHeight = Math.max(l, null !== (r = n.context.maxContentHeight) && void 0 !== r ? r : 0);
        }), this.instance = t;
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "getContext",
            value: function() {
                return this.context;
            }
        },
        {
            key: "resetContext",
            value: function() {
                var e = this.context;
                return setTimeout(this._updateScrollData, 0), e;
            }
        },
        {
            key: "startMeasuringScrollPosition",
            value: function() {
                null == $e444d6404c095fa5$var$T || $e444d6404c095fa5$var$T.addEventListener("scroll", this._updateScrollData, !0), null == $e444d6404c095fa5$var$T || $e444d6404c095fa5$var$T.addEventListener("scrollend", this._updateScrollData, !0), null == $e444d6404c095fa5$var$T || $e444d6404c095fa5$var$T.addEventListener("resize", this._updateScrollData);
            }
        },
        {
            key: "scrollElement",
            value: function() {
                if (!this.instance.config.scroll_root_selector) return null == $e444d6404c095fa5$var$T ? void 0 : $e444d6404c095fa5$var$T.document.documentElement;
                var e, t = $e444d6404c095fa5$var$h($e444d6404c095fa5$var$m(this.instance.config.scroll_root_selector) ? this.instance.config.scroll_root_selector : [
                    this.instance.config.scroll_root_selector
                ]);
                try {
                    for(t.s(); !(e = t.n()).done;){
                        var n = e.value, i = null == $e444d6404c095fa5$var$T ? void 0 : $e444d6404c095fa5$var$T.document.querySelector(n);
                        if (i) return i;
                    }
                } catch (e) {
                    t.e(e);
                } finally{
                    t.f();
                }
            }
        },
        {
            key: "scrollY",
            value: function() {
                if (this.instance.config.scroll_root_selector) {
                    var e = this.scrollElement();
                    return e && e.scrollTop || 0;
                }
                return $e444d6404c095fa5$var$T && ($e444d6404c095fa5$var$T.scrollY || $e444d6404c095fa5$var$T.pageYOffset || $e444d6404c095fa5$var$T.document.documentElement.scrollTop) || 0;
            }
        },
        {
            key: "scrollX",
            value: function() {
                if (this.instance.config.scroll_root_selector) {
                    var e = this.scrollElement();
                    return e && e.scrollLeft || 0;
                }
                return $e444d6404c095fa5$var$T && ($e444d6404c095fa5$var$T.scrollX || $e444d6404c095fa5$var$T.pageXOffset || $e444d6404c095fa5$var$T.document.documentElement.scrollLeft) || 0;
            }
        }
    ]), e;
}(), $e444d6404c095fa5$var$bs = "$copy_autocapture";
function $e444d6404c095fa5$var$ks(e, t) {
    return t.length > e ? t.slice(0, e) + "..." : t;
}
var $e444d6404c095fa5$var$ws, $e444d6404c095fa5$var$Ss = function() {
    function e(t) {
        $e444d6404c095fa5$var$i(this, e), $e444d6404c095fa5$var$o(this, "_initialized", !1), $e444d6404c095fa5$var$o(this, "_isDisabledServerSide", null), $e444d6404c095fa5$var$o(this, "rageclicks", new $e444d6404c095fa5$var$_s), $e444d6404c095fa5$var$o(this, "_elementsChainAsString", !1), this.instance = t, this._elementSelectors = null;
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "config",
            get: function() {
                var e, t = $e444d6404c095fa5$var$b(this.instance.config.autocapture) ? this.instance.config.autocapture : {};
                return t.url_allowlist = null === (e = t.url_allowlist) || void 0 === e ? void 0 : e.map(function(e) {
                    return new RegExp(e);
                }), t;
            }
        },
        {
            key: "_addDomEventHandlers",
            value: function() {
                var e = this;
                if (this.isBrowserSupported()) {
                    if ($e444d6404c095fa5$var$T && $e444d6404c095fa5$var$D) {
                        var t = function(t) {
                            t = t || (null == $e444d6404c095fa5$var$T ? void 0 : $e444d6404c095fa5$var$T.event);
                            try {
                                e._captureEvent(t);
                            } catch (e) {
                                $e444d6404c095fa5$var$W.error("Failed to capture event", e);
                            }
                        }, n = function(t) {
                            t = t || (null == $e444d6404c095fa5$var$T ? void 0 : $e444d6404c095fa5$var$T.event), e._captureEvent(t, $e444d6404c095fa5$var$bs);
                        };
                        $e444d6404c095fa5$var$oe($e444d6404c095fa5$var$D, "submit", t, !1, !0), $e444d6404c095fa5$var$oe($e444d6404c095fa5$var$D, "change", t, !1, !0), $e444d6404c095fa5$var$oe($e444d6404c095fa5$var$D, "click", t, !1, !0), this.config.capture_copied_text && ($e444d6404c095fa5$var$oe($e444d6404c095fa5$var$D, "copy", n, !1, !0), $e444d6404c095fa5$var$oe($e444d6404c095fa5$var$D, "cut", n, !1, !0));
                    }
                } else $e444d6404c095fa5$var$W.info("Disabling Automatic Event Collection because this browser is not supported");
            }
        },
        {
            key: "startIfEnabled",
            value: function() {
                this.isEnabled && !this._initialized && (this._addDomEventHandlers(), this._initialized = !0);
            }
        },
        {
            key: "afterDecideResponse",
            value: function(e) {
                e.elementsChainAsString && (this._elementsChainAsString = e.elementsChainAsString), this.instance.persistence && this.instance.persistence.register($e444d6404c095fa5$var$o({}, $e444d6404c095fa5$var$he, !!e.autocapture_opt_out)), this._isDisabledServerSide = !!e.autocapture_opt_out, this.startIfEnabled();
            }
        },
        {
            key: "setElementSelectors",
            value: function(e) {
                this._elementSelectors = e;
            }
        },
        {
            key: "getElementSelectors",
            value: function(e) {
                var t, n = [];
                return null === (t = this._elementSelectors) || void 0 === t || t.forEach(function(t) {
                    var i = null == $e444d6404c095fa5$var$D ? void 0 : $e444d6404c095fa5$var$D.querySelectorAll(t);
                    null == i || i.forEach(function(i) {
                        e === i && n.push(t);
                    });
                }), n;
            }
        },
        {
            key: "isEnabled",
            get: function() {
                var e, t, n = null === (e = this.instance.persistence) || void 0 === e ? void 0 : e.props[$e444d6404c095fa5$var$he], i = this._isDisabledServerSide;
                if ($e444d6404c095fa5$var$F(i) && !$e444d6404c095fa5$var$x(n) && !this.instance.config.advanced_disable_decide) return !1;
                var r = null !== (t = this._isDisabledServerSide) && void 0 !== t ? t : !!n;
                return !!this.instance.config.autocapture && !r;
            }
        },
        {
            key: "_previousElementSibling",
            value: function(e) {
                if (e.previousElementSibling) return e.previousElementSibling;
                var t = e;
                do t = t.previousSibling;
                while (t && !$e444d6404c095fa5$var$Pn(t));
                return t;
            }
        },
        {
            key: "_getAugmentPropertiesFromElement",
            value: function(e) {
                if (!$e444d6404c095fa5$var$Dn(e)) return {};
                var t = {};
                return $e444d6404c095fa5$var$Q(e.attributes, function(e) {
                    if (e.name && 0 === e.name.indexOf("data-ph-capture-attribute")) {
                        var n = e.name.replace("data-ph-capture-attribute-", ""), i = e.value;
                        n && i && $e444d6404c095fa5$var$Wn(i) && (t[n] = i);
                    }
                }), t;
            }
        },
        {
            key: "_getPropertiesFromElement",
            value: function(e, t, n) {
                var i, r = e.tagName.toLowerCase(), s = {
                    tag_name: r
                };
                $e444d6404c095fa5$var$On.indexOf(r) > -1 && !n && ("a" === r.toLowerCase() || "button" === r.toLowerCase() ? s.$el_text = $e444d6404c095fa5$var$ks(1024, $e444d6404c095fa5$var$Gn(e)) : s.$el_text = $e444d6404c095fa5$var$ks(1024, $e444d6404c095fa5$var$xn(e)));
                var o = $e444d6404c095fa5$var$In(e);
                o.length > 0 && (s.classes = o.filter(function(e) {
                    return "" !== e;
                }));
                var a = null === (i = this.config) || void 0 === i ? void 0 : i.element_attribute_ignorelist;
                $e444d6404c095fa5$var$Q(e.attributes, function(n) {
                    var i;
                    if ((!$e444d6404c095fa5$var$Ln(e) || -1 !== [
                        "name",
                        "id",
                        "class",
                        "aria-label"
                    ].indexOf(n.name)) && (null == a || !a.includes(n.name)) && !t && $e444d6404c095fa5$var$Wn(n.value) && (i = n.name, !$e444d6404c095fa5$var$S(i) || "_ngcontent" !== i.substring(0, 10) && "_nghost" !== i.substring(0, 7))) {
                        var r = n.value;
                        "class" === n.name && (r = $e444d6404c095fa5$var$Fn(r).join(" ")), s["attr__" + n.name] = $e444d6404c095fa5$var$ks(1024, r);
                    }
                });
                for(var u = 1, l = 1, c = e; c = this._previousElementSibling(c);)u++, c.tagName === e.tagName && l++;
                return s.nth_child = u, s.nth_of_type = l, s;
            }
        },
        {
            key: "_getDefaultProperties",
            value: function(e) {
                return {
                    $event_type: e,
                    $ce_version: 1
                };
            }
        },
        {
            key: "_getEventTarget",
            value: function(e) {
                var t;
                return $e444d6404c095fa5$var$w(e.target) ? e.srcElement || null : null !== (t = e.target) && void 0 !== t && t.shadowRoot ? e.composedPath()[0] || null : e.target || null;
            }
        },
        {
            key: "_captureEvent",
            value: function(e) {
                var t = this, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "$autocapture";
                if (this.isEnabled) {
                    var i, r = this._getEventTarget(e);
                    if ($e444d6404c095fa5$var$Cn(r) && (r = r.parentNode || null), "$autocapture" === n && "click" === e.type && e instanceof MouseEvent) this.instance.config.rageclick && null !== (i = this.rageclicks) && void 0 !== i && i.isRageClick(e.clientX, e.clientY, (new Date).getTime()) && this._captureEvent(e, "$rageclick");
                    var s = n === $e444d6404c095fa5$var$bs;
                    if (r && $e444d6404c095fa5$var$An(r, e, this.config, s, s ? [
                        "copy",
                        "cut"
                    ] : void 0)) {
                        for(var o, a, u = [
                            r
                        ], l = r; l.parentNode && !$e444d6404c095fa5$var$Tn(l, "body");)$e444d6404c095fa5$var$$n(l.parentNode) ? (u.push(l.parentNode.host), l = l.parentNode.host) : (u.push(l.parentNode), l = l.parentNode);
                        var c, d, h = [], f = {}, p = !1;
                        if ($e444d6404c095fa5$var$Q(u, function(e) {
                            var n = $e444d6404c095fa5$var$Dn(e);
                            "a" === e.tagName.toLowerCase() && (c = e.getAttribute("href"), c = n && $e444d6404c095fa5$var$Wn(c) && c), $e444d6404c095fa5$var$Y($e444d6404c095fa5$var$In(e), "ph-no-capture") && (p = !0), h.push(t._getPropertiesFromElement(e, t.instance.config.mask_all_element_attributes, t.instance.config.mask_all_text));
                            var i = t._getAugmentPropertiesFromElement(e);
                            $e444d6404c095fa5$var$J(f, i);
                        }), this.instance.config.mask_all_text || ("a" === r.tagName.toLowerCase() || "button" === r.tagName.toLowerCase() ? h[0].$el_text = $e444d6404c095fa5$var$Gn(r) : h[0].$el_text = $e444d6404c095fa5$var$xn(r)), c) {
                            var v, _;
                            h[0].attr__href = c;
                            var g = null === (v = $e444d6404c095fa5$var$vt(c)) || void 0 === v ? void 0 : v.host, m = null == $e444d6404c095fa5$var$T || null === (_ = $e444d6404c095fa5$var$T.location) || void 0 === _ ? void 0 : _.host;
                            g && m && g !== m && (d = c);
                        }
                        if (p) return !1;
                        var y = $e444d6404c095fa5$var$J(this._getDefaultProperties(e.type), this._elementsChainAsString ? {
                            $elements_chain: $e444d6404c095fa5$var$Vn(h)
                        } : {
                            $elements: h
                        }, null !== (o = h[0]) && void 0 !== o && o.$el_text ? {
                            $el_text: null === (a = h[0]) || void 0 === a ? void 0 : a.$el_text
                        } : {}, d && "click" === e.type ? {
                            $external_click_url: d
                        } : {}, f), b = this.getElementSelectors(r);
                        if (b && b.length > 0 && (y.$element_selectors = b), n === $e444d6404c095fa5$var$bs) {
                            var k, w = $e444d6404c095fa5$var$Rn(null == $e444d6404c095fa5$var$T || null === (k = $e444d6404c095fa5$var$T.getSelection()) || void 0 === k ? void 0 : k.toString()), S = e.type || "clipboard";
                            if (!w) return !1;
                            y.$selected_content = w, y.$copy_type = S;
                        }
                        return this.instance.capture(n, y), !0;
                    }
                }
            }
        },
        {
            key: "isBrowserSupported",
            value: function() {
                return $e444d6404c095fa5$var$y(null == $e444d6404c095fa5$var$D ? void 0 : $e444d6404c095fa5$var$D.querySelectorAll);
            }
        }
    ]), e;
}(), $e444d6404c095fa5$var$Es = function() {
    function e(t) {
        var n = this;
        $e444d6404c095fa5$var$i(this, e), $e444d6404c095fa5$var$o(this, "_restoreXHRPatch", void 0), $e444d6404c095fa5$var$o(this, "_restoreFetchPatch", void 0), $e444d6404c095fa5$var$o(this, "_startCapturing", function() {
            $e444d6404c095fa5$var$w(n._restoreXHRPatch) && $e444d6404c095fa5$var$U.postHogTracingHeadersPatchFns._patchXHR(n.instance.sessionManager), $e444d6404c095fa5$var$w(n._restoreFetchPatch) && $e444d6404c095fa5$var$U.postHogTracingHeadersPatchFns._patchFetch(n.instance.sessionManager);
        }), this.instance = t;
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "_loadScript",
            value: function(e) {
                $e444d6404c095fa5$var$U.postHogTracingHeadersPatchFns && e(), this.instance.requestRouter.loadScript("/static/tracing-headers.js?v=".concat($e444d6404c095fa5$var$f.LIB_VERSION), function(t) {
                    t && $e444d6404c095fa5$var$W.error("[TRACING-HEADERS] failed to load script", t), e();
                });
            }
        },
        {
            key: "startIfEnabledOrStop",
            value: function() {
                var e, t;
                this.instance.config.__add_tracing_headers ? this._loadScript(this._startCapturing) : (null === (e = this._restoreXHRPatch) || void 0 === e || e.call(this), null === (t = this._restoreFetchPatch) || void 0 === t || t.call(this), this._restoreXHRPatch = void 0, this._restoreFetchPatch = void 0);
            }
        }
    ]), e;
}();
!function(e) {
    e[e.PENDING = -1] = "PENDING", e[e.DENIED = 0] = "DENIED", e[e.GRANTED = 1] = "GRANTED";
}($e444d6404c095fa5$var$ws || ($e444d6404c095fa5$var$ws = {}));
var $e444d6404c095fa5$var$Fs = function() {
    function e(t) {
        $e444d6404c095fa5$var$i(this, e), this.instance = t;
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "config",
            get: function() {
                return this.instance.config;
            }
        },
        {
            key: "consent",
            get: function() {
                return this.getDnt() ? $e444d6404c095fa5$var$ws.DENIED : this.storedConsent;
            }
        },
        {
            key: "isOptedOut",
            value: function() {
                return this.consent === $e444d6404c095fa5$var$ws.DENIED || this.consent === $e444d6404c095fa5$var$ws.PENDING && this.config.opt_out_capturing_by_default;
            }
        },
        {
            key: "isOptedIn",
            value: function() {
                return !this.isOptedOut();
            }
        },
        {
            key: "optInOut",
            value: function(e) {
                this.storage.set(this.storageKey, e ? 1 : 0, this.config.cookie_expiration, this.config.cross_subdomain_cookie, this.config.secure_cookie);
            }
        },
        {
            key: "reset",
            value: function() {
                this.storage.remove(this.storageKey, this.config.cross_subdomain_cookie);
            }
        },
        {
            key: "storageKey",
            get: function() {
                var e = this.instance.config, t = e.token;
                return (e.opt_out_capturing_cookie_prefix || "__ph_opt_in_out_") + t;
            }
        },
        {
            key: "storedConsent",
            get: function() {
                var e = this.storage.get(this.storageKey);
                return "1" === e ? $e444d6404c095fa5$var$ws.GRANTED : "0" === e ? $e444d6404c095fa5$var$ws.DENIED : $e444d6404c095fa5$var$ws.PENDING;
            }
        },
        {
            key: "storage",
            get: function() {
                if (!this._storage) {
                    var e = this.config.opt_out_capturing_persistence_type;
                    this._storage = "localStorage" === e ? $e444d6404c095fa5$var$at : $e444d6404c095fa5$var$st;
                    var t = "localStorage" === e ? $e444d6404c095fa5$var$st : $e444d6404c095fa5$var$at;
                    t.get(this.storageKey) && (this._storage.get(this.storageKey) || this.optInOut("1" === t.get(this.storageKey)), t.remove(this.storageKey, this.config.cross_subdomain_cookie));
                }
                return this._storage;
            }
        },
        {
            key: "getDnt",
            value: function() {
                return !!this.config.respect_dnt && !!$e444d6404c095fa5$var$ae([
                    null == $e444d6404c095fa5$var$A ? void 0 : $e444d6404c095fa5$var$A.doNotTrack,
                    null == $e444d6404c095fa5$var$A ? void 0 : $e444d6404c095fa5$var$A.msDoNotTrack,
                    $e444d6404c095fa5$var$U.doNotTrack
                ], function(e) {
                    return $e444d6404c095fa5$var$Y([
                        !0,
                        1,
                        "1",
                        "yes"
                    ], e);
                });
            }
        }
    ]), e;
}(), $e444d6404c095fa5$var$Is = "[Web Vitals]", $e444d6404c095fa5$var$Rs = function() {
    function e(n) {
        var r, s = this;
        $e444d6404c095fa5$var$i(this, e), $e444d6404c095fa5$var$o(this, "_enabledServerSide", !1), $e444d6404c095fa5$var$o(this, "_initialized", !1), $e444d6404c095fa5$var$o(this, "buffer", {
            url: void 0,
            metrics: [],
            firstMetricTimestamp: void 0
        }), $e444d6404c095fa5$var$o(this, "_flushToCapture", function() {
            clearTimeout(s._delayedFlushTimer), 0 !== s.buffer.metrics.length && (s.instance.capture("$web_vitals", s.buffer.metrics.reduce(function(e, n) {
                var i;
                return $e444d6404c095fa5$var$t($e444d6404c095fa5$var$t({}, e), {}, ($e444d6404c095fa5$var$o(i = {}, "$web_vitals_".concat(n.name, "_event"), $e444d6404c095fa5$var$t({}, n)), $e444d6404c095fa5$var$o(i, "$web_vitals_".concat(n.name, "_value"), n.value), i));
            }, {})), s.buffer = {
                url: void 0,
                metrics: [],
                firstMetricTimestamp: void 0
            });
        }), $e444d6404c095fa5$var$o(this, "_addToBuffer", function(e) {
            var n, i = null === (n = s.instance.sessionManager) || void 0 === n ? void 0 : n.checkAndGetSessionAndWindowId(!0);
            if ($e444d6404c095fa5$var$w(i)) $e444d6404c095fa5$var$W.error($e444d6404c095fa5$var$Is + "Could not read session ID. Dropping metrics!");
            else {
                s.buffer = s.buffer || {};
                var r = s._currentURL();
                if (!$e444d6404c095fa5$var$w(r)) {
                    if ($e444d6404c095fa5$var$I(null == e ? void 0 : e.name) || $e444d6404c095fa5$var$I(null == e ? void 0 : e.value)) $e444d6404c095fa5$var$W.error($e444d6404c095fa5$var$Is + "Invalid metric received", e);
                    else s.buffer.url !== r && (s._flushToCapture(), s._delayedFlushTimer = setTimeout(s._flushToCapture, 8e3)), $e444d6404c095fa5$var$w(s.buffer.url) && (s.buffer.url = r), s.buffer.firstMetricTimestamp = $e444d6404c095fa5$var$w(s.buffer.firstMetricTimestamp) ? Date.now() : s.buffer.firstMetricTimestamp, s.buffer.metrics.push($e444d6404c095fa5$var$t($e444d6404c095fa5$var$t({}, e), {}, {
                        $current_url: r,
                        $session_id: i.sessionId,
                        $window_id: i.windowId,
                        timestamp: Date.now()
                    })), 4 === s.buffer.metrics.length && s._flushToCapture();
                }
            }
        }), $e444d6404c095fa5$var$o(this, "_startCapturing", function() {
            var e = $e444d6404c095fa5$var$U.postHogWebVitalsCallbacks, t = e.onLCP, n = e.onCLS, i = e.onFCP, r = e.onINP;
            t(s._addToBuffer), n(s._addToBuffer), i(s._addToBuffer), r(s._addToBuffer), s._initialized = !0;
        }), this.instance = n, this._enabledServerSide = !(null === (r = this.instance.persistence) || void 0 === r || !r.props[$e444d6404c095fa5$var$_e]), this.startIfEnabled();
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "isEnabled",
            get: function() {
                var e = $e444d6404c095fa5$var$b(this.instance.config.capture_performance) ? this.instance.config.capture_performance.web_vitals : void 0;
                return $e444d6404c095fa5$var$x(e) ? e : this._enabledServerSide;
            }
        },
        {
            key: "startIfEnabled",
            value: function() {
                this.isEnabled && !this._initialized && ($e444d6404c095fa5$var$W.info($e444d6404c095fa5$var$Is + " enabled, starting..."), this.loadScript(this._startCapturing));
            }
        },
        {
            key: "afterDecideResponse",
            value: function(e) {
                var t = $e444d6404c095fa5$var$b(e.capturePerformance) && !!e.capturePerformance.web_vitals;
                this.instance.persistence && this.instance.persistence.register($e444d6404c095fa5$var$o({}, $e444d6404c095fa5$var$_e, t)), this._enabledServerSide = t, this.startIfEnabled();
            }
        },
        {
            key: "loadScript",
            value: function(e) {
                $e444d6404c095fa5$var$T.postHogWebVitalsCallbacks && e(), this.instance.requestRouter.loadScript(this.instance.requestRouter.endpointFor("assets", "/static/web-vitals.js?v=".concat($e444d6404c095fa5$var$f.LIB_VERSION)), function(t) {
                    t && $e444d6404c095fa5$var$W.error($e444d6404c095fa5$var$Is + " failed to load script", t), e();
                });
            }
        },
        {
            key: "_currentURL",
            value: function() {
                var e = $e444d6404c095fa5$var$T ? $e444d6404c095fa5$var$T.location.href : void 0;
                return e || $e444d6404c095fa5$var$W.error($e444d6404c095fa5$var$Is + "Could not determine current URL"), e;
            }
        }
    ]), e;
}(), $e444d6404c095fa5$var$xs = {}, $e444d6404c095fa5$var$Ps = function() {}, $e444d6404c095fa5$var$Ts = "posthog", $e444d6404c095fa5$var$Cs = !$e444d6404c095fa5$var$Zi && -1 === (null == $e444d6404c095fa5$var$H ? void 0 : $e444d6404c095fa5$var$H.indexOf("MSIE")) && -1 === (null == $e444d6404c095fa5$var$H ? void 0 : $e444d6404c095fa5$var$H.indexOf("Mozilla")), $e444d6404c095fa5$var$$s = function() {
    var e, t, n;
    return {
        api_host: "https://us.i.posthog.com",
        ui_host: null,
        token: "",
        autocapture: !0,
        rageclick: !0,
        cross_subdomain_cookie: (t = null == $e444d6404c095fa5$var$D ? void 0 : $e444d6404c095fa5$var$D.location, n = null == t ? void 0 : t.hostname, !!$e444d6404c095fa5$var$S(n) && "herokuapp.com" !== n.split(".").slice(-2).join(".")),
        persistence: "localStorage+cookie",
        persistence_name: "",
        loaded: $e444d6404c095fa5$var$Ps,
        store_google: !0,
        custom_campaign_params: [],
        custom_blocked_useragents: [],
        save_referrer: !0,
        capture_pageview: !0,
        capture_pageleave: "if_capture_pageview",
        debug: $e444d6404c095fa5$var$L && $e444d6404c095fa5$var$S(null == $e444d6404c095fa5$var$L ? void 0 : $e444d6404c095fa5$var$L.search) && -1 !== $e444d6404c095fa5$var$L.search.indexOf("__posthog_debug=true") || !1,
        verbose: !1,
        cookie_expiration: 365,
        upgrade: !1,
        disable_session_recording: !1,
        disable_persistence: !1,
        disable_surveys: !1,
        enable_recording_console_log: void 0,
        secure_cookie: "https:" === (null == $e444d6404c095fa5$var$T || null === (e = $e444d6404c095fa5$var$T.location) || void 0 === e ? void 0 : e.protocol),
        ip: !0,
        opt_out_capturing_by_default: !1,
        opt_out_persistence_by_default: !1,
        opt_out_useragent_filter: !1,
        opt_out_capturing_persistence_type: "localStorage",
        opt_out_capturing_cookie_prefix: null,
        opt_in_site_apps: !1,
        property_denylist: [],
        respect_dnt: !1,
        sanitize_properties: null,
        request_headers: {},
        inapp_protocol: "//",
        inapp_link_new_window: !1,
        request_batching: !0,
        properties_string_max_length: 65535,
        session_recording: {},
        mask_all_element_attributes: !1,
        mask_all_text: !1,
        advanced_disable_decide: !1,
        advanced_disable_feature_flags: !1,
        advanced_disable_feature_flags_on_first_load: !1,
        advanced_disable_toolbar_metrics: !1,
        feature_flag_request_timeout_ms: 3e3,
        on_request_error: function(e) {
            var t = "Bad HTTP status: " + e.statusCode + " " + e.text;
            $e444d6404c095fa5$var$W.error(t);
        },
        get_device_id: function(e) {
            return e;
        },
        _onCapture: $e444d6404c095fa5$var$Ps,
        capture_performance: void 0,
        name: "posthog",
        bootstrap: {},
        disable_compression: !1,
        session_idle_timeout_seconds: 1800,
        person_profiles: "always",
        __add_tracing_headers: !1
    };
}, $e444d6404c095fa5$var$Os = function(e) {
    var t = {};
    $e444d6404c095fa5$var$w(e.process_person) || (t.person_profiles = e.process_person), $e444d6404c095fa5$var$w(e.xhr_headers) || (t.request_headers = e.xhr_headers), $e444d6404c095fa5$var$w(e.cookie_name) || (t.persistence_name = e.cookie_name), $e444d6404c095fa5$var$w(e.disable_cookie) || (t.disable_persistence = e.disable_cookie);
    var n = $e444d6404c095fa5$var$J({}, t, e);
    return $e444d6404c095fa5$var$m(e.property_blacklist) && ($e444d6404c095fa5$var$w(e.property_denylist) ? n.property_denylist = e.property_blacklist : $e444d6404c095fa5$var$m(e.property_denylist) ? n.property_denylist = [].concat($e444d6404c095fa5$var$l(e.property_blacklist), $e444d6404c095fa5$var$l(e.property_denylist)) : $e444d6404c095fa5$var$W.error("Invalid value for property_denylist config: " + e.property_denylist)), n;
}, $e444d6404c095fa5$var$Ms = function() {
    function e() {
        $e444d6404c095fa5$var$i(this, e), $e444d6404c095fa5$var$o(this, "__forceAllowLocalhost", !1);
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "_forceAllowLocalhost",
            get: function() {
                return this.__forceAllowLocalhost;
            },
            set: function(e) {
                $e444d6404c095fa5$var$W.error("WebPerformanceObserver is deprecated and has no impact on network capture. Use `_forceAllowLocalhostNetworkCapture` on `posthog.sessionRecording`"), this.__forceAllowLocalhost = e;
            }
        }
    ]), e;
}(), $e444d6404c095fa5$export$a9d6b9cbf49b8241 = function() {
    function e() {
        var t = this;
        $e444d6404c095fa5$var$i(this, e), $e444d6404c095fa5$var$o(this, "webPerformance", new $e444d6404c095fa5$var$Ms), $e444d6404c095fa5$var$o(this, "_internalEventEmitter", new $e444d6404c095fa5$var$Er), this.config = $e444d6404c095fa5$var$$s(), this.decideEndpointWasHit = !1, this.SentryIntegration = $e444d6404c095fa5$var$gr, this.sentryIntegration = function(e) {
            return function(e, t) {
                var n = $e444d6404c095fa5$var$_r(e, t);
                return {
                    name: $e444d6404c095fa5$var$vr,
                    processEvent: function(e) {
                        return n(e);
                    }
                };
            }(t, e);
        }, this.__request_queue = [], this.__loaded = !1, this.analyticsDefaultEndpoint = "/e/", this.featureFlags = new $e444d6404c095fa5$var$Ge(this), this.toolbar = new $e444d6404c095fa5$var$_i(this), this.scrollManager = new $e444d6404c095fa5$var$ys(this), this.pageViewManager = new $e444d6404c095fa5$var$wr(this), this.surveys = new $e444d6404c095fa5$var$cs(this), this.rateLimiter = new $e444d6404c095fa5$var$ds(this), this.requestRouter = new $e444d6404c095fa5$var$dr(this), this.consent = new $e444d6404c095fa5$var$Fs(this), this.people = {
            set: function(e, n, i) {
                var r = $e444d6404c095fa5$var$S(e) ? $e444d6404c095fa5$var$o({}, e, n) : e;
                t.setPersonProperties(r), null == i || i({});
            },
            set_once: function(e, n, i) {
                var r = $e444d6404c095fa5$var$S(e) ? $e444d6404c095fa5$var$o({}, e, n) : e;
                t.setPersonProperties(void 0, r), null == i || i({});
            }
        }, this.on("eventCaptured", function(e) {
            return $e444d6404c095fa5$var$W.info("send", e);
        });
    }
    return $e444d6404c095fa5$var$s(e, [
        {
            key: "init",
            value: function(t, n, i) {
                if (i && i !== $e444d6404c095fa5$var$Ts) {
                    var r, s = null !== (r = $e444d6404c095fa5$var$xs[i]) && void 0 !== r ? r : new e;
                    return s._init(t, n, i), $e444d6404c095fa5$var$xs[i] = s, $e444d6404c095fa5$var$xs[$e444d6404c095fa5$var$Ts][i] = s, s;
                }
                return this._init(t, n, i);
            }
        },
        {
            key: "_init",
            value: function(e) {
                var n, i, r = this, s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, o = arguments.length > 2 ? arguments[2] : void 0;
                if ($e444d6404c095fa5$var$w(e) || $e444d6404c095fa5$var$E(e)) return $e444d6404c095fa5$var$W.critical("PostHog was initialized without a token. This likely indicates a misconfiguration. Please check the first argument passed to posthog.init()"), this;
                if (this.__loaded) return $e444d6404c095fa5$var$W.warn("You have already initialized PostHog! Re-initializing is a no-op"), this;
                if (this.__loaded = !0, this.config = {}, this._triggered_notifs = [], this.set_config($e444d6404c095fa5$var$J({}, $e444d6404c095fa5$var$$s(), $e444d6404c095fa5$var$Os(s), {
                    name: o,
                    token: e
                })), this.config.on_xhr_error && $e444d6404c095fa5$var$W.error("[posthog] on_xhr_error is deprecated. Use on_request_error instead"), this.compression = s.disable_compression ? void 0 : $e444d6404c095fa5$export$6a00d17b5aff0af.Base64, this.persistence = new $e444d6404c095fa5$var$bn(this.config), this.sessionPersistence = "sessionStorage" === this.config.persistence ? this.persistence : new $e444d6404c095fa5$var$bn($e444d6404c095fa5$var$t($e444d6404c095fa5$var$t({}, this.config), {}, {
                    persistence: "sessionStorage"
                })), this._requestQueue = new $e444d6404c095fa5$var$gi(function(e) {
                    return r._send_retriable_request(e);
                }), this._retryQueue = new $e444d6404c095fa5$var$ar(this), this.__request_queue = [], this.sessionManager = new $e444d6404c095fa5$var$lr(this.config, this.persistence), this.sessionPropsManager = new $e444d6404c095fa5$var$fs(this.sessionManager, this.persistence), new $e444d6404c095fa5$var$Es(this).startIfEnabledOrStop(), this.sessionRecording = new $e444d6404c095fa5$var$hi(this), this.sessionRecording.startIfEnabledOrStop(), this.config.disable_scroll_properties || this.scrollManager.startMeasuringScrollPosition(), this.autocapture = new $e444d6404c095fa5$var$Ss(this), this.autocapture.startIfEnabled(), this.surveys.loadIfEnabled(), this.heatmaps = new $e444d6404c095fa5$var$ms(this), this.heatmaps.startIfEnabled(), this.webVitalsAutocapture = new $e444d6404c095fa5$var$Rs(this), this.exceptionObserver = new $e444d6404c095fa5$var$pr(this), this.exceptionObserver.startIfEnabled(), $e444d6404c095fa5$var$f.DEBUG = $e444d6404c095fa5$var$f.DEBUG || this.config.debug, this._sync_opt_out_with_persistence(), void 0 !== (null === (n = s.bootstrap) || void 0 === n ? void 0 : n.distinctID)) {
                    var a, u, l = this.config.get_device_id($e444d6404c095fa5$var$Ke()), c = null !== (a = s.bootstrap) && void 0 !== a && a.isIdentifiedID ? l : s.bootstrap.distinctID;
                    this.persistence.set_property($e444d6404c095fa5$var$$e, null !== (u = s.bootstrap) && void 0 !== u && u.isIdentifiedID ? "identified" : "anonymous"), this.register({
                        distinct_id: s.bootstrap.distinctID,
                        $device_id: c
                    });
                }
                if (this._hasBootstrappedFeatureFlags()) {
                    var d, h, p = Object.keys((null === (d = s.bootstrap) || void 0 === d ? void 0 : d.featureFlags) || {}).filter(function(e) {
                        var t, n;
                        return !(null === (t = s.bootstrap) || void 0 === t || null === (n = t.featureFlags) || void 0 === n || !n[e]);
                    }).reduce(function(e, t) {
                        var n, i;
                        return e[t] = (null === (n = s.bootstrap) || void 0 === n || null === (i = n.featureFlags) || void 0 === i ? void 0 : i[t]) || !1, e;
                    }, {}), v = Object.keys((null === (h = s.bootstrap) || void 0 === h ? void 0 : h.featureFlagPayloads) || {}).filter(function(e) {
                        return p[e];
                    }).reduce(function(e, t) {
                        var n, i, r, o;
                        null !== (n = s.bootstrap) && void 0 !== n && null !== (i = n.featureFlagPayloads) && void 0 !== i && i[t] && (e[t] = null === (r = s.bootstrap) || void 0 === r || null === (o = r.featureFlagPayloads) || void 0 === o ? void 0 : o[t]);
                        return e;
                    }, {});
                    this.featureFlags.receivedFeatureFlags({
                        featureFlags: p,
                        featureFlagPayloads: v
                    });
                }
                if (!this.get_distinct_id()) {
                    var _ = this.config.get_device_id($e444d6404c095fa5$var$Ke());
                    this.register_once({
                        distinct_id: _,
                        $device_id: _
                    }, ""), this.persistence.set_property($e444d6404c095fa5$var$$e, "anonymous");
                }
                return null == $e444d6404c095fa5$var$T || null === (i = $e444d6404c095fa5$var$T.addEventListener) || void 0 === i || i.call($e444d6404c095fa5$var$T, "onpagehide" in self ? "pagehide" : "unload", this._handle_unload.bind(this)), this.toolbar.maybeLoadToolbar(), s.segment ? $e444d6404c095fa5$var$mr(this, function() {
                    return r._loaded();
                }) : this._loaded(), $e444d6404c095fa5$var$y(this.config._onCapture) && this.on("eventCaptured", function(e) {
                    return r.config._onCapture(e.event, e);
                }), this;
            }
        },
        {
            key: "_afterDecideResponse",
            value: function(e) {
                var t, n, i, r, s, o, a;
                this.compression = void 0, e.supportedCompression && !this.config.disable_compression && (this.compression = $e444d6404c095fa5$var$Y(e.supportedCompression, $e444d6404c095fa5$export$6a00d17b5aff0af.GZipJS) ? $e444d6404c095fa5$export$6a00d17b5aff0af.GZipJS : $e444d6404c095fa5$var$Y(e.supportedCompression, $e444d6404c095fa5$export$6a00d17b5aff0af.Base64) ? $e444d6404c095fa5$export$6a00d17b5aff0af.Base64 : void 0), null !== (t = e.analytics) && void 0 !== t && t.endpoint && (this.analyticsDefaultEndpoint = e.analytics.endpoint), null === (n = this.sessionRecording) || void 0 === n || n.afterDecideResponse(e), null === (i = this.autocapture) || void 0 === i || i.afterDecideResponse(e), null === (r = this.heatmaps) || void 0 === r || r.afterDecideResponse(e), null === (s = this.surveys) || void 0 === s || s.afterDecideResponse(e), null === (o = this.webVitalsAutocapture) || void 0 === o || o.afterDecideResponse(e), null === (a = this.exceptionObserver) || void 0 === a || a.afterDecideResponse(e);
            }
        },
        {
            key: "_loaded",
            value: function() {
                var e = this, t = this.config.advanced_disable_decide;
                t || this.featureFlags.setReloadingPaused(!0);
                try {
                    this.config.loaded(this);
                } catch (e) {
                    $e444d6404c095fa5$var$W.critical("`loaded` function failed", e);
                }
                this._start_queue_if_opted_in(), this.config.capture_pageview && setTimeout(function() {
                    $e444d6404c095fa5$var$D && e.capture("$pageview", {
                        title: $e444d6404c095fa5$var$D.title
                    }, {
                        send_instantly: !0
                    });
                }, 1), t || (new $e444d6404c095fa5$var$fi(this).call(), this.featureFlags.resetRequestQueue());
            }
        },
        {
            key: "_start_queue_if_opted_in",
            value: function() {
                var e;
                this.has_opted_out_capturing() || this.config.request_batching && (null === (e = this._requestQueue) || void 0 === e || e.enable());
            }
        },
        {
            key: "_dom_loaded",
            value: function() {
                var e = this;
                this.has_opted_out_capturing() || $e444d6404c095fa5$var$V(this.__request_queue, function(t) {
                    return e._send_retriable_request(t);
                }), this.__request_queue = [], this._start_queue_if_opted_in();
            }
        },
        {
            key: "_handle_unload",
            value: function() {
                var e, t;
                this.config.request_batching ? (this._shouldCapturePageleave() && this.capture("$pageleave"), null === (e = this._requestQueue) || void 0 === e || e.unload(), null === (t = this._retryQueue) || void 0 === t || t.unload()) : this._shouldCapturePageleave() && this.capture("$pageleave", null, {
                    transport: "sendBeacon"
                });
            }
        },
        {
            key: "_send_request",
            value: function(e) {
                var n = this;
                this.__loaded && ($e444d6404c095fa5$var$Cs ? this.__request_queue.push(e) : this.rateLimiter.isServerRateLimited(e.batchKey) || (e.transport = e.transport || this.config.api_transport, e.url = $e444d6404c095fa5$var$tr(e.url, {
                    ip: this.config.ip ? 1 : 0
                }), e.headers = this.config.request_headers, e.compression = "best-available" === e.compression ? this.compression : e.compression, function(e) {
                    var n, i, r, s = $e444d6404c095fa5$var$t({}, e);
                    s.timeout = s.timeout || 6e4, s.url = $e444d6404c095fa5$var$tr(s.url, {
                        _: (new Date).getTime().toString(),
                        ver: $e444d6404c095fa5$var$f.LIB_VERSION,
                        compression: s.compression
                    });
                    var o = null !== (n = s.transport) && void 0 !== n ? n : "XHR", a = null !== (i = null === (r = $e444d6404c095fa5$var$ae($e444d6404c095fa5$var$rr, function(e) {
                        return e.transport === o;
                    })) || void 0 === r ? void 0 : r.method) && void 0 !== i ? i : $e444d6404c095fa5$var$rr[0].method;
                    if (!a) throw new Error("No available transport method");
                    a(s);
                }($e444d6404c095fa5$var$t($e444d6404c095fa5$var$t({}, e), {}, {
                    callback: function(t) {
                        var i, r, s;
                        (n.rateLimiter.checkForLimiting(t), t.statusCode >= 400) && (null === (r = (s = n.config).on_request_error) || void 0 === r || r.call(s, t));
                        null === (i = e.callback) || void 0 === i || i.call(e, t);
                    }
                }))));
            }
        },
        {
            key: "_send_retriable_request",
            value: function(e) {
                this._retryQueue ? this._retryQueue.retriableRequest(e) : this._send_request(e);
            }
        },
        {
            key: "_execute_array",
            value: function(e) {
                var t, n = this, i = [], r = [], s = [];
                $e444d6404c095fa5$var$V(e, function(e) {
                    e && (t = e[0], $e444d6404c095fa5$var$m(t) ? s.push(e) : $e444d6404c095fa5$var$y(e) ? e.call(n) : $e444d6404c095fa5$var$m(e) && "alias" === t ? i.push(e) : $e444d6404c095fa5$var$m(e) && -1 !== t.indexOf("capture") && $e444d6404c095fa5$var$y(n[t]) ? s.push(e) : r.push(e));
                });
                var o = function(e, t) {
                    $e444d6404c095fa5$var$V(e, function(e) {
                        if ($e444d6404c095fa5$var$m(e[0])) {
                            var n = t;
                            $e444d6404c095fa5$var$Q(e, function(e) {
                                n = n[e[0]].apply(n, e.slice(1));
                            });
                        } else this[e[0]].apply(this, e.slice(1));
                    }, t);
                };
                o(i, this), o(r, this), o(s, this);
            }
        },
        {
            key: "_hasBootstrappedFeatureFlags",
            value: function() {
                var e, t;
                return (null === (e = this.config.bootstrap) || void 0 === e ? void 0 : e.featureFlags) && Object.keys(null === (t = this.config.bootstrap) || void 0 === t ? void 0 : t.featureFlags).length > 0 || !1;
            }
        },
        {
            key: "push",
            value: function(e) {
                this._execute_array([
                    e
                ]);
            }
        },
        {
            key: "capture",
            value: function(e, n, i) {
                var r;
                if (!(this.__loaded && this.persistence && this.sessionPersistence && this._requestQueue)) return $e444d6404c095fa5$var$W.uninitializedWarning("posthog.capture");
                if (!this.consent.isOptedOut()) {
                    if (!$e444d6404c095fa5$var$w(e) && $e444d6404c095fa5$var$S(e)) {
                        if (!$e444d6404c095fa5$var$H || this.config.opt_out_useragent_filter || !$e444d6404c095fa5$var$vs($e444d6404c095fa5$var$H, this.config.custom_blocked_useragents)) {
                            var s = null != i && i.skip_client_rate_limiting ? void 0 : this.rateLimiter.clientRateLimitContext();
                            if (null == s || !s.isRateLimited) {
                                this.sessionPersistence.update_search_keyword(), this.config.store_google && this.sessionPersistence.update_campaign_params(), this.config.save_referrer && this.sessionPersistence.update_referrer_info(), (this.config.store_google || this.config.save_referrer) && this.persistence.set_initial_person_info();
                                var o = {
                                    uuid: $e444d6404c095fa5$var$Ke(),
                                    event: e,
                                    properties: this._calculate_event_properties(e, n || {})
                                };
                                s && (o.properties.$lib_rate_limit_remaining_tokens = s.remainingTokens), (null == i ? void 0 : i.$set) && (o.$set = null == i ? void 0 : i.$set);
                                var a = this._calculate_set_once_properties(null == i ? void 0 : i.$set_once);
                                a && (o.$set_once = a), (o = $e444d6404c095fa5$var$ie(o, null != i && i._noTruncate ? null : this.config.properties_string_max_length)).timestamp = (null == i ? void 0 : i.timestamp) || new Date, $e444d6404c095fa5$var$w(null == i ? void 0 : i.timestamp) || (o.properties.$event_time_override_provided = !0, o.properties.$event_time_override_system_time = new Date);
                                var u = $e444d6404c095fa5$var$t($e444d6404c095fa5$var$t({}, o.properties.$set), o.$set);
                                $e444d6404c095fa5$var$k(u) || this.setPersonPropertiesForFlags(u), this._internalEventEmitter.emit("eventCaptured", o);
                                var l = {
                                    method: "POST",
                                    url: null !== (r = null == i ? void 0 : i._url) && void 0 !== r ? r : this.requestRouter.endpointFor("api", this.analyticsDefaultEndpoint),
                                    data: o,
                                    compression: "best-available",
                                    batchKey: null == i ? void 0 : i._batchKey
                                };
                                return !this.config.request_batching || i && (null == i || !i._batchKey) || null != i && i.send_instantly ? this._send_retriable_request(l) : this._requestQueue.enqueue(l), o;
                            }
                            $e444d6404c095fa5$var$W.critical("This capture call is ignored due to client rate limiting.");
                        }
                    } else $e444d6404c095fa5$var$W.error("No event name provided to posthog.capture");
                }
            }
        },
        {
            key: "_addCaptureHook",
            value: function(e) {
                this.on("eventCaptured", function(t) {
                    return e(t.event, t);
                });
            }
        },
        {
            key: "_calculate_event_properties",
            value: function(e, n) {
                if (!this.persistence || !this.sessionPersistence) return n;
                var i = this.persistence.remove_event_timer(e), r = $e444d6404c095fa5$var$t({}, n);
                if (r.token = this.config.token, "$snapshot" === e) {
                    var s = $e444d6404c095fa5$var$t($e444d6404c095fa5$var$t({}, this.persistence.properties()), this.sessionPersistence.properties());
                    return r.distinct_id = s.distinct_id, (!$e444d6404c095fa5$var$S(r.distinct_id) && !$e444d6404c095fa5$var$R(r.distinct_id) || $e444d6404c095fa5$var$E(r.distinct_id)) && $e444d6404c095fa5$var$W.error("Invalid distinct_id for replay event. This indicates a bug in your implementation"), r;
                }
                var o = $e444d6404c095fa5$var$mn.properties();
                if (this.sessionManager) {
                    var a = this.sessionManager.checkAndGetSessionAndWindowId(), u = a.sessionId, l = a.windowId;
                    r.$session_id = u, r.$window_id = l;
                }
                if (this.requestRouter.region === $e444d6404c095fa5$var$or.CUSTOM && (r.$lib_custom_api_host = this.config.api_host), this.sessionPropsManager && this.config.__preview_send_client_session_params && ("$pageview" === e || "$pageleave" === e || "$autocapture" === e)) {
                    var c = this.sessionPropsManager.getSessionProps();
                    r = $e444d6404c095fa5$var$J(r, c);
                }
                if (!this.config.disable_scroll_properties) {
                    var d = {};
                    "$pageview" === e ? d = this.pageViewManager.doPageView() : "$pageleave" === e && (d = this.pageViewManager.doPageLeave()), r = $e444d6404c095fa5$var$J(r, d);
                }
                if ("$pageview" === e && $e444d6404c095fa5$var$D && (r.title = $e444d6404c095fa5$var$D.title), !$e444d6404c095fa5$var$w(i)) {
                    var h = (new Date).getTime() - i;
                    r.$duration = parseFloat((h / 1e3).toFixed(3));
                }
                $e444d6404c095fa5$var$H && this.config.opt_out_useragent_filter && (r.$browser_type = $e444d6404c095fa5$var$vs($e444d6404c095fa5$var$H, this.config.custom_blocked_useragents) ? "bot" : "browser"), (r = $e444d6404c095fa5$var$J({}, o, this.persistence.properties(), this.sessionPersistence.properties(), r)).$is_identified = this._isIdentified(), $e444d6404c095fa5$var$m(this.config.property_denylist) ? $e444d6404c095fa5$var$Q(this.config.property_denylist, function(e) {
                    delete r[e];
                }) : $e444d6404c095fa5$var$W.error("Invalid value for property_denylist config: " + this.config.property_denylist + " or property_blacklist config: " + this.config.property_blacklist);
                var f = this.config.sanitize_properties;
                return f && (r = f(r, e)), r.$process_person_profile = this._hasPersonProcessing(), r;
            }
        },
        {
            key: "_calculate_set_once_properties",
            value: function(e) {
                if (!this.persistence || !this._hasPersonProcessing()) return e;
                var t = $e444d6404c095fa5$var$J({}, this.persistence.get_initial_props(), e || {});
                return $e444d6404c095fa5$var$k(t) ? void 0 : t;
            }
        },
        {
            key: "register",
            value: function(e, t) {
                var n;
                null === (n = this.persistence) || void 0 === n || n.register(e, t);
            }
        },
        {
            key: "register_once",
            value: function(e, t, n) {
                var i;
                null === (i = this.persistence) || void 0 === i || i.register_once(e, t, n);
            }
        },
        {
            key: "register_for_session",
            value: function(e) {
                var t;
                null === (t = this.sessionPersistence) || void 0 === t || t.register(e);
            }
        },
        {
            key: "unregister",
            value: function(e) {
                var t;
                null === (t = this.persistence) || void 0 === t || t.unregister(e);
            }
        },
        {
            key: "unregister_for_session",
            value: function(e) {
                var t;
                null === (t = this.sessionPersistence) || void 0 === t || t.unregister(e);
            }
        },
        {
            key: "_register_single",
            value: function(e, t) {
                this.register($e444d6404c095fa5$var$o({}, e, t));
            }
        },
        {
            key: "getFeatureFlag",
            value: function(e, t) {
                return this.featureFlags.getFeatureFlag(e, t);
            }
        },
        {
            key: "getFeatureFlagPayload",
            value: function(e) {
                var t = this.featureFlags.getFeatureFlagPayload(e);
                try {
                    return JSON.parse(t);
                } catch (e) {
                    return t;
                }
            }
        },
        {
            key: "isFeatureEnabled",
            value: function(e, t) {
                return this.featureFlags.isFeatureEnabled(e, t);
            }
        },
        {
            key: "reloadFeatureFlags",
            value: function() {
                this.featureFlags.reloadFeatureFlags();
            }
        },
        {
            key: "updateEarlyAccessFeatureEnrollment",
            value: function(e, t) {
                this.featureFlags.updateEarlyAccessFeatureEnrollment(e, t);
            }
        },
        {
            key: "getEarlyAccessFeatures",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                return this.featureFlags.getEarlyAccessFeatures(e, t);
            }
        },
        {
            key: "on",
            value: function(e, t) {
                return this._internalEventEmitter.on(e, t);
            }
        },
        {
            key: "onFeatureFlags",
            value: function(e) {
                return this.featureFlags.onFeatureFlags(e);
            }
        },
        {
            key: "onSessionId",
            value: function(e) {
                var t, n;
                return null !== (t = null === (n = this.sessionManager) || void 0 === n ? void 0 : n.onSessionId(e)) && void 0 !== t ? t : function() {};
            }
        },
        {
            key: "getSurveys",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                this.surveys.getSurveys(e, t);
            }
        },
        {
            key: "getActiveMatchingSurveys",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                this.surveys.getActiveMatchingSurveys(e, t);
            }
        },
        {
            key: "getNextSurveyStep",
            value: function(e, t, n) {
                return this.surveys.getNextSurveyStep(e, t, n);
            }
        },
        {
            key: "identify",
            value: function(e, t, n) {
                if (!this.__loaded || !this.persistence) return $e444d6404c095fa5$var$W.uninitializedWarning("posthog.identify");
                if ($e444d6404c095fa5$var$R(e) && (e = e.toString(), $e444d6404c095fa5$var$W.warn("The first argument to posthog.identify was a number, but it should be a string. It has been converted to a string.")), e) {
                    if ([
                        "distinct_id",
                        "distinctid"
                    ].includes(e.toLowerCase())) $e444d6404c095fa5$var$W.critical('The string "'.concat(e, '" was set in posthog.identify which indicates an error. This ID should be unique to the user and not a hardcoded string.'));
                    else if (this._requirePersonProcessing("posthog.identify")) {
                        var i = this.get_distinct_id();
                        if (this.register({
                            $user_id: e
                        }), !this.get_property("$device_id")) {
                            var r = i;
                            this.register_once({
                                $had_persisted_distinct_id: !0,
                                $device_id: r
                            }, "");
                        }
                        e !== i && e !== this.get_property($e444d6404c095fa5$var$ce) && (this.unregister($e444d6404c095fa5$var$ce), this.register({
                            distinct_id: e
                        }));
                        var s = "anonymous" === (this.persistence.get_property($e444d6404c095fa5$var$$e) || "anonymous");
                        e !== i && s ? (this.persistence.set_property($e444d6404c095fa5$var$$e, "identified"), this.setPersonPropertiesForFlags(t || {}, !1), this.capture("$identify", {
                            distinct_id: e,
                            $anon_distinct_id: i
                        }, {
                            $set: t || {},
                            $set_once: n || {}
                        }), this.featureFlags.setAnonymousDistinctId(i)) : (t || n) && this.setPersonProperties(t, n), e !== i && (this.reloadFeatureFlags(), this.unregister($e444d6404c095fa5$var$Ce));
                    }
                } else $e444d6404c095fa5$var$W.error("Unique user id has not been set in posthog.identify");
            }
        },
        {
            key: "setPersonProperties",
            value: function(e, t) {
                (e || t) && this._requirePersonProcessing("posthog.setPersonProperties") && (this.setPersonPropertiesForFlags(e || {}), this.capture("$set", {
                    $set: e || {},
                    $set_once: t || {}
                }));
            }
        },
        {
            key: "group",
            value: function(e, n, i) {
                if (e && n) {
                    if (this._requirePersonProcessing("posthog.group")) {
                        var r = this.getGroups();
                        r[e] !== n && this.resetGroupPropertiesForFlags(e), this.register({
                            $groups: $e444d6404c095fa5$var$t($e444d6404c095fa5$var$t({}, r), {}, $e444d6404c095fa5$var$o({}, e, n))
                        }), i && (this.capture("$groupidentify", {
                            $group_type: e,
                            $group_key: n,
                            $group_set: i
                        }), this.setGroupPropertiesForFlags($e444d6404c095fa5$var$o({}, e, i))), r[e] === n || i || this.reloadFeatureFlags();
                    }
                } else $e444d6404c095fa5$var$W.error("posthog.group requires a group type and group key");
            }
        },
        {
            key: "resetGroups",
            value: function() {
                this.register({
                    $groups: {}
                }), this.resetGroupPropertiesForFlags(), this.reloadFeatureFlags();
            }
        },
        {
            key: "setPersonPropertiesForFlags",
            value: function(e) {
                var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                this._requirePersonProcessing("posthog.setPersonPropertiesForFlags") && this.featureFlags.setPersonPropertiesForFlags(e, t);
            }
        },
        {
            key: "resetPersonPropertiesForFlags",
            value: function() {
                this.featureFlags.resetPersonPropertiesForFlags();
            }
        },
        {
            key: "setGroupPropertiesForFlags",
            value: function(e) {
                var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                this._requirePersonProcessing("posthog.setGroupPropertiesForFlags") && this.featureFlags.setGroupPropertiesForFlags(e, t);
            }
        },
        {
            key: "resetGroupPropertiesForFlags",
            value: function(e) {
                this.featureFlags.resetGroupPropertiesForFlags(e);
            }
        },
        {
            key: "reset",
            value: function(e) {
                var t, n, i, r;
                if (!this.__loaded) return $e444d6404c095fa5$var$W.uninitializedWarning("posthog.reset");
                var s = this.get_property("$device_id");
                this.consent.reset(), null === (t = this.persistence) || void 0 === t || t.clear(), null === (n = this.sessionPersistence) || void 0 === n || n.clear(), null === (i = this.persistence) || void 0 === i || i.set_property($e444d6404c095fa5$var$$e, "anonymous"), null === (r = this.sessionManager) || void 0 === r || r.resetSessionId();
                var o = this.config.get_device_id($e444d6404c095fa5$var$Ke());
                this.register_once({
                    distinct_id: o,
                    $device_id: e ? o : s
                }, "");
            }
        },
        {
            key: "get_distinct_id",
            value: function() {
                return this.get_property("distinct_id");
            }
        },
        {
            key: "getGroups",
            value: function() {
                return this.get_property("$groups") || {};
            }
        },
        {
            key: "get_session_id",
            value: function() {
                var e, t;
                return null !== (e = null === (t = this.sessionManager) || void 0 === t ? void 0 : t.checkAndGetSessionAndWindowId(!0).sessionId) && void 0 !== e ? e : "";
            }
        },
        {
            key: "get_session_replay_url",
            value: function(e) {
                if (!this.sessionManager) return "";
                var t = this.sessionManager.checkAndGetSessionAndWindowId(!0), n = t.sessionId, i = t.sessionStartTimestamp, r = this.requestRouter.endpointFor("ui", "/project/".concat(this.config.token, "/replay/").concat(n));
                if (null != e && e.withTimestamp && i) {
                    var s, o = null !== (s = e.timestampLookBack) && void 0 !== s ? s : 10;
                    if (!i) return r;
                    var a = Math.max(Math.floor(((new Date).getTime() - i) / 1e3) - o, 0);
                    r += "?t=".concat(a);
                }
                return r;
            }
        },
        {
            key: "alias",
            value: function(e, t) {
                return e === this.get_property($e444d6404c095fa5$var$le) ? ($e444d6404c095fa5$var$W.critical("Attempting to create alias for existing People user - aborting."), -2) : this._requirePersonProcessing("posthog.alias") ? ($e444d6404c095fa5$var$w(t) && (t = this.get_distinct_id()), e !== t ? (this._register_single($e444d6404c095fa5$var$ce, e), this.capture("$create_alias", {
                    alias: e,
                    distinct_id: t
                })) : ($e444d6404c095fa5$var$W.warn("alias matches current distinct_id - skipping api call."), this.identify(e), -1)) : void 0;
            }
        },
        {
            key: "set_config",
            value: function(e) {
                var n, i, r, s, o = $e444d6404c095fa5$var$t({}, this.config);
                $e444d6404c095fa5$var$b(e) && ($e444d6404c095fa5$var$J(this.config, $e444d6404c095fa5$var$Os(e)), null === (n = this.persistence) || void 0 === n || n.update_config(this.config, o), this.sessionPersistence = "sessionStorage" === this.config.persistence ? this.persistence : new $e444d6404c095fa5$var$bn($e444d6404c095fa5$var$t($e444d6404c095fa5$var$t({}, this.config), {}, {
                    persistence: "sessionStorage"
                })), $e444d6404c095fa5$var$at.is_supported() && "true" === $e444d6404c095fa5$var$at.get("ph_debug") && (this.config.debug = !0), this.config.debug && ($e444d6404c095fa5$var$f.DEBUG = !0), null === (i = this.sessionRecording) || void 0 === i || i.startIfEnabledOrStop(), null === (r = this.autocapture) || void 0 === r || r.startIfEnabled(), null === (s = this.heatmaps) || void 0 === s || s.startIfEnabled(), this.surveys.loadIfEnabled(), this._sync_opt_out_with_persistence());
            }
        },
        {
            key: "startSessionRecording",
            value: function(e) {
                if (null != e && e.sampling) {
                    var t, n, i = null === (t = this.sessionManager) || void 0 === t ? void 0 : t.checkAndGetSessionAndWindowId();
                    null === (n = this.persistence) || void 0 === n || n.register($e444d6404c095fa5$var$o({}, $e444d6404c095fa5$var$Ee, !0)), $e444d6404c095fa5$var$W.info("Session recording started with sampling override for session: ", null == i ? void 0 : i.sessionId);
                }
                this.set_config({
                    disable_session_recording: !1
                });
            }
        },
        {
            key: "stopSessionRecording",
            value: function() {
                this.set_config({
                    disable_session_recording: !0
                });
            }
        },
        {
            key: "sessionRecordingStarted",
            value: function() {
                var e;
                return !(null === (e = this.sessionRecording) || void 0 === e || !e.started);
            }
        },
        {
            key: "loadToolbar",
            value: function(e) {
                return this.toolbar.loadToolbar(e);
            }
        },
        {
            key: "get_property",
            value: function(e) {
                var t;
                return null === (t = this.persistence) || void 0 === t ? void 0 : t.props[e];
            }
        },
        {
            key: "getSessionProperty",
            value: function(e) {
                var t;
                return null === (t = this.sessionPersistence) || void 0 === t ? void 0 : t.props[e];
            }
        },
        {
            key: "toString",
            value: function() {
                var e, t = null !== (e = this.config.name) && void 0 !== e ? e : $e444d6404c095fa5$var$Ts;
                return t !== $e444d6404c095fa5$var$Ts && (t = $e444d6404c095fa5$var$Ts + "." + t), t;
            }
        },
        {
            key: "_isIdentified",
            value: function() {
                var e, t;
                return "identified" === (null === (e = this.persistence) || void 0 === e ? void 0 : e.get_property($e444d6404c095fa5$var$$e)) || "identified" === (null === (t = this.sessionPersistence) || void 0 === t ? void 0 : t.get_property($e444d6404c095fa5$var$$e));
            }
        },
        {
            key: "_hasPersonProcessing",
            value: function() {
                var e, t, n, i;
                return !("never" === this.config.person_profiles || "identified_only" === this.config.person_profiles && !this._isIdentified() && $e444d6404c095fa5$var$k(this.getGroups()) && (null === (e = this.persistence) || void 0 === e || null === (t = e.props) || void 0 === t || !t[$e444d6404c095fa5$var$ce]) && (null === (n = this.persistence) || void 0 === n || null === (i = n.props) || void 0 === i || !i[$e444d6404c095fa5$var$Ne]));
            }
        },
        {
            key: "_shouldCapturePageleave",
            value: function() {
                return !0 === this.config.capture_pageleave || "if_capture_pageview" === this.config.capture_pageleave && this.config.capture_pageview;
            }
        },
        {
            key: "createPersonProfile",
            value: function() {
                this._hasPersonProcessing() || this._requirePersonProcessing("posthog.createPersonProfile") && this.setPersonProperties({}, {});
            }
        },
        {
            key: "_requirePersonProcessing",
            value: function(e) {
                return "never" === this.config.person_profiles ? ($e444d6404c095fa5$var$W.error(e + ' was called, but process_person is set to "never". This call will be ignored.'), !1) : (this._register_single($e444d6404c095fa5$var$Ne, !0), !0);
            }
        },
        {
            key: "_sync_opt_out_with_persistence",
            value: function() {
                var e, t, n, i, r = this.consent.isOptedOut(), s = this.config.opt_out_persistence_by_default, o = this.config.disable_persistence || r && !!s;
                (null === (e = this.persistence) || void 0 === e ? void 0 : e.disabled) !== o && (null === (n = this.persistence) || void 0 === n || n.set_disabled(o));
                (null === (t = this.sessionPersistence) || void 0 === t ? void 0 : t.disabled) !== o && (null === (i = this.sessionPersistence) || void 0 === i || i.set_disabled(o));
            }
        },
        {
            key: "opt_in_capturing",
            value: function(e) {
                var t;
                this.consent.optInOut(!0), this._sync_opt_out_with_persistence(), ($e444d6404c095fa5$var$w(null == e ? void 0 : e.captureEventName) || null != e && e.captureEventName) && this.capture(null !== (t = null == e ? void 0 : e.captureEventName) && void 0 !== t ? t : "$opt_in", null == e ? void 0 : e.captureProperties, {
                    send_instantly: !0
                });
            }
        },
        {
            key: "opt_out_capturing",
            value: function() {
                this.consent.optInOut(!1), this._sync_opt_out_with_persistence();
            }
        },
        {
            key: "has_opted_in_capturing",
            value: function() {
                return this.consent.isOptedIn();
            }
        },
        {
            key: "has_opted_out_capturing",
            value: function() {
                return this.consent.isOptedOut();
            }
        },
        {
            key: "clear_opt_in_out_capturing",
            value: function() {
                this.consent.reset(), this._sync_opt_out_with_persistence();
            }
        },
        {
            key: "debug",
            value: function(e) {
                !1 === e ? (null == $e444d6404c095fa5$var$T || $e444d6404c095fa5$var$T.console.log("You've disabled debug mode."), localStorage && localStorage.removeItem("ph_debug"), this.set_config({
                    debug: !1
                })) : (null == $e444d6404c095fa5$var$T || $e444d6404c095fa5$var$T.console.log("You're now in debug mode. All calls to PostHog will be logged in your console.\nYou can disable this with `posthog.debug(false)`."), localStorage && localStorage.setItem("ph_debug", "true"), this.set_config({
                    debug: !0
                }));
            }
        }
    ]), e;
}();
!function(e, t) {
    for(var n = 0; n < t.length; n++)e.prototype[t[n]] = $e444d6404c095fa5$var$ee(e.prototype[t[n]]);
}($e444d6404c095fa5$export$a9d6b9cbf49b8241, [
    "identify"
]);
var $e444d6404c095fa5$var$Ds, $e444d6404c095fa5$export$2e2bcd8739ae039 = ($e444d6404c095fa5$var$Ds = $e444d6404c095fa5$var$xs[$e444d6404c095fa5$var$Ts] = new $e444d6404c095fa5$export$a9d6b9cbf49b8241, function() {
    function e() {
        e.done || (e.done = !0, $e444d6404c095fa5$var$Cs = !1, $e444d6404c095fa5$var$Q($e444d6404c095fa5$var$xs, function(e) {
            e._dom_loaded();
        }));
    }
    null != $e444d6404c095fa5$var$D && $e444d6404c095fa5$var$D.addEventListener && ("complete" === $e444d6404c095fa5$var$D.readyState ? e() : $e444d6404c095fa5$var$D.addEventListener("DOMContentLoaded", e, !1)), $e444d6404c095fa5$var$T && $e444d6404c095fa5$var$oe($e444d6404c095fa5$var$T, "load", e, !0);
}(), $e444d6404c095fa5$var$Ds);


const $b7120199cc96ae3e$var$POSTHOG_API_TOKEN = "phc_O1eWRFu5TV908GCX6DyW0vmjupXrkmn8tHLTaIMs0If";
const $b7120199cc96ae3e$var$POSTHOG_API_HOST_BASE = "https://lit-captions-staging.typito.com";
function $b7120199cc96ae3e$export$74b04d0e740afc5d() {
    // posthog
    if (!$b7120199cc96ae3e$var$POSTHOG_API_TOKEN) return;
    (0, $e444d6404c095fa5$export$2e2bcd8739ae039).init($b7120199cc96ae3e$var$POSTHOG_API_TOKEN, {
        ...$b7120199cc96ae3e$var$POSTHOG_API_HOST_BASE ? {
            api_host: `${$b7120199cc96ae3e$var$POSTHOG_API_HOST_BASE}/ingest`,
            ui_host: "https://us.i.posthog.com"
        } : {
            api_host: "https://us.i.posthog.com"
        },
        person_profiles: "always"
    });
}
function $b7120199cc96ae3e$export$1dc3d36b113964fb(userId, { email: email, name: name }) {
    if (!$b7120199cc96ae3e$var$POSTHOG_API_TOKEN) return;
    console.log("Identifying user in PostHog", {
        userId: userId,
        email: email,
        name: name
    });
    (0, $e444d6404c095fa5$export$2e2bcd8739ae039).identify(userId, {
        email: email,
        name: name
    });
}
function $b7120199cc96ae3e$export$817735e17a729e38(url) {
    if (!$b7120199cc96ae3e$var$POSTHOG_API_TOKEN) return;
    (0, $e444d6404c095fa5$export$2e2bcd8739ae039).capture("$pageview", {
        $current_url: url
    });
}
function $b7120199cc96ae3e$export$6dcfd4317fe45ce5(eventName, properties) {
    if (!$b7120199cc96ae3e$var$POSTHOG_API_TOKEN) return;
    (0, $e444d6404c095fa5$export$2e2bcd8739ae039).capture(eventName, properties);
}


var $54da56340462fe8a$exports = {};
"use strict";
// do not edit .js files directly - edit src/index.jst
$54da56340462fe8a$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};


function $527e5c120baf91d6$export$48b112d74ba9da53(userId, { email: email, name: name }) {
    console.log("Identifying user in GTM", {
        userId: userId,
        email: email,
        name: name
    });
    // @ts-ignore
    window.dataLayer = window.dataLayer || [];
    // @ts-ignore
    window.dataLayer.push({
        event: "identify",
        userId: userId,
        userEmail: email,
        userName: name
    });
}


function $6f510ee9957a1d4f$var$getInitialVariables() {
    return {};
}
function $6f510ee9957a1d4f$var$getActions(set, get) {
    return {
        fetchUser: async ()=>{
            try {
                const { user: user, credits: credits } = await (0, $21f88f1227598e15$export$7cbf767827cd68ba)();
                set({
                    user: user,
                    credits: credits
                });
            } catch (error) {
                console.error(error);
            }
        },
        resetStore: ()=>{
            set($6f510ee9957a1d4f$var$getInitialVariables());
        }
    };
}
const $6f510ee9957a1d4f$export$cc885caaa8b7ab4e = (0, $ab3cb874dadc0915$export$185802fd694ee1f5)()((0, $db1029f36b931e86$export$6922d3b3a607469e)((0, $db1029f36b931e86$export$5c593627aef9f076)((set, get)=>({
        ...$6f510ee9957a1d4f$var$getInitialVariables(),
        ...$6f510ee9957a1d4f$var$getActions(set, get)
    }))));
// track on posthog when user is authenticated
$6f510ee9957a1d4f$export$cc885caaa8b7ab4e.subscribe(({ user: user })=>{
    return user ? {
        id: user.id,
        email: user.email,
        name: user.name
    } : null;
}, (userInfo)=>{
    if (userInfo) {
        (0, $b7120199cc96ae3e$export$1dc3d36b113964fb)(userInfo.id, {
            email: userInfo.email,
            name: userInfo.name
        });
        (0, $527e5c120baf91d6$export$48b112d74ba9da53)(userInfo.id, {
            email: userInfo.email,
            name: userInfo.name
        });
    }
}, {
    equalityFn: (0, (/*@__PURE__*/$parcel$interopDefault($54da56340462fe8a$exports)))
});




// Inspired by react-hot-toast library

var $acw62 = parcelRequire("acw62");
const $9898a26843c73274$var$TOAST_LIMIT = 1;
const $9898a26843c73274$var$TOAST_REMOVE_DELAY = 1000000;
const $9898a26843c73274$var$actionTypes = {
    ADD_TOAST: "ADD_TOAST",
    UPDATE_TOAST: "UPDATE_TOAST",
    DISMISS_TOAST: "DISMISS_TOAST",
    REMOVE_TOAST: "REMOVE_TOAST"
};
let $9898a26843c73274$var$count = 0;
function $9898a26843c73274$var$genId() {
    $9898a26843c73274$var$count = ($9898a26843c73274$var$count + 1) % Number.MAX_SAFE_INTEGER;
    return $9898a26843c73274$var$count.toString();
}
const $9898a26843c73274$var$toastTimeouts = new Map();
const $9898a26843c73274$var$addToRemoveQueue = (toastId)=>{
    if ($9898a26843c73274$var$toastTimeouts.has(toastId)) return;
    const timeout = setTimeout(()=>{
        $9898a26843c73274$var$toastTimeouts.delete(toastId);
        $9898a26843c73274$var$dispatch({
            type: "REMOVE_TOAST",
            toastId: toastId
        });
    }, $9898a26843c73274$var$TOAST_REMOVE_DELAY);
    $9898a26843c73274$var$toastTimeouts.set(toastId, timeout);
};
const $9898a26843c73274$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case "ADD_TOAST":
            return {
                ...state,
                toasts: [
                    action.toast,
                    ...state.toasts
                ].slice(0, $9898a26843c73274$var$TOAST_LIMIT)
            };
        case "UPDATE_TOAST":
            return {
                ...state,
                toasts: state.toasts.map((t)=>t.id === action.toast.id ? {
                        ...t,
                        ...action.toast
                    } : t)
            };
        case "DISMISS_TOAST":
            {
                const { toastId: toastId } = action;
                // ! Side effects ! - This could be extracted into a dismissToast() action,
                // but I'll keep it here for simplicity
                if (toastId) $9898a26843c73274$var$addToRemoveQueue(toastId);
                else state.toasts.forEach((toast)=>{
                    $9898a26843c73274$var$addToRemoveQueue(toast.id);
                });
                return {
                    ...state,
                    toasts: state.toasts.map((t)=>t.id === toastId || toastId === undefined ? {
                            ...t,
                            open: false
                        } : t)
                };
            }
        case "REMOVE_TOAST":
            if (action.toastId === undefined) return {
                ...state,
                toasts: []
            };
            return {
                ...state,
                toasts: state.toasts.filter((t)=>t.id !== action.toastId)
            };
    }
};
const $9898a26843c73274$var$listeners = [];
let $9898a26843c73274$var$memoryState = {
    toasts: []
};
function $9898a26843c73274$var$dispatch(action) {
    $9898a26843c73274$var$memoryState = $9898a26843c73274$export$1650419e431d3ba3($9898a26843c73274$var$memoryState, action);
    $9898a26843c73274$var$listeners.forEach((listener)=>{
        listener($9898a26843c73274$var$memoryState);
    });
}
function $9898a26843c73274$export$b410431fab84fa58({ ...props }) {
    const id = $9898a26843c73274$var$genId();
    const update = (props)=>$9898a26843c73274$var$dispatch({
            type: "UPDATE_TOAST",
            toast: {
                ...props,
                id: id
            }
        });
    const dismiss = ()=>$9898a26843c73274$var$dispatch({
            type: "DISMISS_TOAST",
            toastId: id
        });
    $9898a26843c73274$var$dispatch({
        type: "ADD_TOAST",
        toast: {
            ...props,
            id: id,
            open: true,
            onOpenChange: (open)=>{
                if (!open) dismiss();
            }
        }
    });
    return {
        id: id,
        dismiss: dismiss,
        update: update
    };
}
function $9898a26843c73274$export$a407b657d3044108() {
    const [state, setState] = $acw62.useState($9898a26843c73274$var$memoryState);
    $acw62.useEffect(()=>{
        $9898a26843c73274$var$listeners.push(setState);
        return ()=>{
            const index = $9898a26843c73274$var$listeners.indexOf(setState);
            if (index > -1) $9898a26843c73274$var$listeners.splice(index, 1);
        };
    }, [
        state
    ]);
    return {
        ...state,
        toast: $9898a26843c73274$export$b410431fab84fa58,
        dismiss: (toastId)=>$9898a26843c73274$var$dispatch({
                type: "DISMISS_TOAST",
                toastId: toastId
            })
    };
}


const $850d0034a9416e03$var$GOOGLE_AUTH_BASE_URL = "";
const $850d0034a9416e03$var$GOOGLE_AUTH_URL = `${$850d0034a9416e03$var$GOOGLE_AUTH_BASE_URL}/auth/login/google`;
function $850d0034a9416e03$export$1d39dc5b47e56ff0() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { toast: toast } = (0, $9898a26843c73274$export$a407b657d3044108)();
    return {
        signupWithEmail: async (email, password)=>{
            try {
                await (0, $21f88f1227598e15$export$7200a869094fec36)(email, password);
                navigate("/");
            } catch (error) {
                console.error(error);
                toast({
                    variant: "destructive",
                    title: "Signup failed",
                    description: error.message
                });
            }
        },
        loginWithEmail: async (email, password)=>{
            try {
                await (0, $21f88f1227598e15$export$596d806903d1f59e)(email, password);
                navigate("/");
            } catch (error) {
                console.error(error);
                toast({
                    variant: "destructive",
                    title: "Login failed",
                    description: error.message
                });
            }
        },
        loginWithGoogle: async ()=>{
            window.location.assign($850d0034a9416e03$var$GOOGLE_AUTH_URL);
        // window.location.href = GOOGLE_AUTH_URL;
        },
        logout: async ()=>{
            await (0, $21f88f1227598e15$export$a0973bcfe11b05c9)();
            navigate("/");
        }
    };
}



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


function $fd27deb97aace157$var$getInitialVariables() {
    return {
        // Start with login until the first API fails
        loggedIn: true
    };
}
function $fd27deb97aace157$var$getActions(set, get) {
    return {
        setLoggedIn: (loggedIn)=>{
            set({
                loggedIn: loggedIn
            });
        },
        resetStore: ()=>{
            set($fd27deb97aace157$var$getInitialVariables());
        }
    };
}
const $fd27deb97aace157$export$650ce9f0b4df82fd = (0, $ab3cb874dadc0915$export$185802fd694ee1f5)()((0, $db1029f36b931e86$export$6922d3b3a607469e)((0, $db1029f36b931e86$export$5c593627aef9f076)((set, get)=>({
        ...$fd27deb97aace157$var$getInitialVariables(),
        ...$fd27deb97aace157$var$getActions(set, get)
    }))));


function $af10f25532815273$export$b8fc23a8b701aa67(apiCall) {
    const setLoggedIn = (0, $fd27deb97aace157$export$650ce9f0b4df82fd)((state)=>state.setLoggedIn);
    const apiCallRef = (0, $acw62.useRef)(apiCall);
    // This is fine
    if (apiCallRef.current !== apiCall) apiCallRef.current = apiCall;
    return (0, $acw62.useCallback)(async (...args)=>{
        try {
            return await apiCallRef.current(...args);
        } catch (error) {
            console.error(error);
            if (error instanceof (0, $21f88f1227598e15$export$8a9c04b0629a0419)) setLoggedIn(false);
            throw error;
        }
    }, [
        setLoggedIn
    ]);
}


function $4157376a2c009e9f$export$2e2bcd8739ae039({ activePage: activePage, children: children }) {
    const { logout: logout } = (0, $850d0034a9416e03$export$1d39dc5b47e56ff0)();
    const { user: user, credits: credits, fetchUser: fetchUser } = (0, $6f510ee9957a1d4f$export$cc885caaa8b7ab4e)();
    const fetchUserM = (0, $af10f25532815273$export$b8fc23a8b701aa67)(fetchUser);
    (0, $acw62.useEffect)(()=>{
        fetchUserM();
    }, []);
    const freeMinutesRemaining = credits ? Math.max(Math.round((credits.secondsAllocated - credits.secondsUsed) / 60), 0) : 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "grid min-h-svh w-full md:grid-cols-[280px_1fr]",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4157376a2c009e9f$var$DesktopSidebar, {
                activePage: activePage,
                credits: credits,
                freeMinutesRemaining: freeMinutesRemaining,
                user: user,
                logout: logout
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col min-w-0",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                        className: "fixed w-full flex h-14 items-center gap-4 bg-muted px-4 md:hidden z-50",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4157376a2c009e9f$var$MobileSidebar, {
                                activePage: activePage,
                                credits: credits,
                                freeMinutesRemaining: freeMinutesRemaining
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex h-14 items-center px-4 flex-1 justify-center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: "/",
                                    className: "flex items-center gap-2 font-semibold",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5519b20d0c9306a9$export$e6ff31bff12b7ff4), {
                                        withText: true
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4157376a2c009e9f$var$UserMenu, {
                                user: user,
                                logout: logout
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
                        className: "flex flex-1 pt-14 md:pt-0 overflow-auto",
                        children: children
                    })
                ]
            })
        ]
    });
}
const $4157376a2c009e9f$var$UserMenu = ({ user: user, logout: logout })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ef278092739ac562$export$e44a253a59704894), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef278092739ac562$export$d2469213b3befba9), {
                asChild: true,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b132ebe58e154a99$export$353f5b6fc5456de1), {
                    variant: "secondary",
                    size: "icon",
                    className: "rounded-full",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2851b04c8fda51c6$export$2e2bcd8739ae039), {
                            className: "h-5 w-5"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "sr-only",
                            children: "Toggle user menu"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ef278092739ac562$export$6e76d93a37c01248), {
                align: "end",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef278092739ac562$export$76e48c5b57f24495), {
                        children: !!user ? user.name || user.email : "Account"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef278092739ac562$export$da160178fd3bc7e9), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef278092739ac562$export$ed97964d1871885d), {
                        onClick: ()=>logout(),
                        children: "Logout"
                    })
                ]
            })
        ]
    });
};
const $4157376a2c009e9f$var$MobileSidebar = ({ activePage: activePage, credits: credits, freeMinutesRemaining: freeMinutesRemaining })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $891fc0b201b5d767$export$a9bf29f8d87ebbee), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $891fc0b201b5d767$export$de69b9b0343a1903), {
                asChild: true,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b132ebe58e154a99$export$353f5b6fc5456de1), {
                    variant: "outline",
                    size: "icon",
                    className: "shrink-0 md:hidden",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b66c39b6083b2b9$export$2e2bcd8739ae039), {
                            className: "h-5 w-5"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "sr-only",
                            children: "Toggle navigation menu"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $891fc0b201b5d767$export$fe5ec5b76996e2d3), {
                side: "left",
                className: "flex flex-col bg-muted",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex h-14 items-center px-4 lg:h-[60px] lg:px-6",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: "/",
                            className: "flex items-center gap-2 font-semibold",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5519b20d0c9306a9$export$e6ff31bff12b7ff4), {
                                withText: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("nav", {
                            className: "grid items-start px-2 text-sm font-medium lg:px-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: "/projects",
                                    className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("flex items-center gap-3 rounded-lg px-3 py-2 text-muted-foreground transition-all hover:text-primary", activePage === "projects" && "text-primary bg-slate-300/20"),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db352f301915b5ae$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4"
                                        }),
                                        "Projects"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: "/exports",
                                    className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("flex items-center gap-3 rounded-lg px-3 py-2 text-muted-foreground transition-all hover:text-primary", activePage === "exports" && "text-primary bg-slate-300/20"),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d8cd836460c6f743$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4"
                                        }),
                                        "Exports"
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-auto",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dec6137693824fa2$export$60332b2344f7fe41), {
                            children: [
                                credits && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dec6137693824fa2$export$5665775b26e26c5d), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dec6137693824fa2$export$16e0ed4cb97c00d4), {
                                        children: [
                                            credits.free ? "Free minutes" : "Minutes",
                                            " remaining:",
                                            " ",
                                            freeMinutesRemaining
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dec6137693824fa2$export$64ef9b8c11710c47), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
                                        action: (0, $c2a581aa5067f626$export$a2806f257ddae97a),
                                        method: "POST",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b132ebe58e154a99$export$353f5b6fc5456de1), {
                                            size: "sm",
                                            className: "w-full",
                                            children: "Buy minutes"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
const $4157376a2c009e9f$var$DesktopSidebar = ({ activePage: activePage, credits: credits, freeMinutesRemaining: freeMinutesRemaining, user: user, logout: logout })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "hidden bg-muted/40 md:block",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex h-full max-h-svh flex-col gap-2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex h-14 items-center px-4 lg:h-[60px] lg:px-6",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: "/",
                        className: "flex items-center gap-2 font-semibold",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5519b20d0c9306a9$export$e6ff31bff12b7ff4), {
                            withText: true
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex-1",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("nav", {
                        className: "grid items-start px-2 text-sm font-medium lg:px-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: "/projects",
                                className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("flex items-center gap-3 rounded-lg px-3 py-2 text-muted-foreground transition-all hover:text-primary", activePage === "projects" && "text-primary bg-muted"),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db352f301915b5ae$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    }),
                                    "Projects"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: "/exports",
                                className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("flex items-center gap-3 rounded-lg px-3 py-2 text-muted-foreground transition-all hover:text-primary", activePage === "exports" && "text-primary bg-muted"),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d8cd836460c6f743$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    }),
                                    "Exports"
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mt-auto px-4 py-2",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dec6137693824fa2$export$60332b2344f7fe41), {
                        "x-chunk": "dashboard-02-chunk-0",
                        children: [
                            credits && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dec6137693824fa2$export$5665775b26e26c5d), {
                                className: "p-2 pt-0 md:p-4",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dec6137693824fa2$export$16e0ed4cb97c00d4), {
                                    children: [
                                        credits.free ? "Free minutes" : "Minutes",
                                        " remaining:",
                                        " ",
                                        freeMinutesRemaining
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dec6137693824fa2$export$64ef9b8c11710c47), {
                                className: "p-2 pt-0 md:p-4 md:pt-0",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
                                    action: (0, $c2a581aa5067f626$export$a2806f257ddae97a),
                                    method: "POST",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b132ebe58e154a99$export$353f5b6fc5456de1), {
                                        size: "sm",
                                        className: "w-full",
                                        children: "Buy minutes"
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "border-t py-2",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
                        className: "flex flex-col px-2 text-sm font-medium",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ef278092739ac562$export$e44a253a59704894), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef278092739ac562$export$d2469213b3befba9), {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: "#",
                                        className: "flex items-center gap-3 rounded-lg px-3 py-2 text-muted-foreground transition-all hover:text-primary",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2851b04c8fda51c6$export$2e2bcd8739ae039), {
                                                className: "h-4 w-4"
                                            }),
                                            !!user ? user.name || user.email : "Account"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef278092739ac562$export$6e76d93a37c01248), {
                                    align: "end",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef278092739ac562$export$ed97964d1871885d), {
                                        onClick: ()=>logout(),
                                        children: "Logout"
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};


function $b8437b3fb5ace006$var$LayoutWithoutSidebar({ children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col w-full h-svh font-outfit",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "h-[60px] flex items-center justify-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: "/",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5519b20d0c9306a9$export$e6ff31bff12b7ff4), {
                        withText: true
                    })
                })
            }),
            children
        ]
    });
}
function $b8437b3fb5ace006$export$2e2bcd8739ae039({ activePage: activePage, children: children }) {
    const showSidebar = !!activePage;
    return showSidebar ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4157376a2c009e9f$export$2e2bcd8739ae039), {
        activePage: activePage,
        children: children
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b8437b3fb5ace006$var$LayoutWithoutSidebar, {
        children: children
    });
}





var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $dac22b55eb23ffcc$export$db0345794bfc14ed = new Map([
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
    [
        "aac",
        "audio/aac"
    ],
    [
        "abw",
        "application/x-abiword"
    ],
    [
        "arc",
        "application/x-freearc"
    ],
    [
        "avif",
        "image/avif"
    ],
    [
        "avi",
        "video/x-msvideo"
    ],
    [
        "azw",
        "application/vnd.amazon.ebook"
    ],
    [
        "bin",
        "application/octet-stream"
    ],
    [
        "bmp",
        "image/bmp"
    ],
    [
        "bz",
        "application/x-bzip"
    ],
    [
        "bz2",
        "application/x-bzip2"
    ],
    [
        "cda",
        "application/x-cdf"
    ],
    [
        "csh",
        "application/x-csh"
    ],
    [
        "css",
        "text/css"
    ],
    [
        "csv",
        "text/csv"
    ],
    [
        "doc",
        "application/msword"
    ],
    [
        "docx",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ],
    [
        "eot",
        "application/vnd.ms-fontobject"
    ],
    [
        "epub",
        "application/epub+zip"
    ],
    [
        "gz",
        "application/gzip"
    ],
    [
        "gif",
        "image/gif"
    ],
    [
        "heic",
        "image/heic"
    ],
    [
        "heif",
        "image/heif"
    ],
    [
        "htm",
        "text/html"
    ],
    [
        "html",
        "text/html"
    ],
    [
        "ico",
        "image/vnd.microsoft.icon"
    ],
    [
        "ics",
        "text/calendar"
    ],
    [
        "jar",
        "application/java-archive"
    ],
    [
        "jpeg",
        "image/jpeg"
    ],
    [
        "jpg",
        "image/jpeg"
    ],
    [
        "js",
        "text/javascript"
    ],
    [
        "json",
        "application/json"
    ],
    [
        "jsonld",
        "application/ld+json"
    ],
    [
        "mid",
        "audio/midi"
    ],
    [
        "midi",
        "audio/midi"
    ],
    [
        "mjs",
        "text/javascript"
    ],
    [
        "mp3",
        "audio/mpeg"
    ],
    [
        "mp4",
        "video/mp4"
    ],
    [
        "mpeg",
        "video/mpeg"
    ],
    [
        "mpkg",
        "application/vnd.apple.installer+xml"
    ],
    [
        "odp",
        "application/vnd.oasis.opendocument.presentation"
    ],
    [
        "ods",
        "application/vnd.oasis.opendocument.spreadsheet"
    ],
    [
        "odt",
        "application/vnd.oasis.opendocument.text"
    ],
    [
        "oga",
        "audio/ogg"
    ],
    [
        "ogv",
        "video/ogg"
    ],
    [
        "ogx",
        "application/ogg"
    ],
    [
        "opus",
        "audio/opus"
    ],
    [
        "otf",
        "font/otf"
    ],
    [
        "png",
        "image/png"
    ],
    [
        "pdf",
        "application/pdf"
    ],
    [
        "php",
        "application/x-httpd-php"
    ],
    [
        "ppt",
        "application/vnd.ms-powerpoint"
    ],
    [
        "pptx",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    ],
    [
        "rar",
        "application/vnd.rar"
    ],
    [
        "rtf",
        "application/rtf"
    ],
    [
        "sh",
        "application/x-sh"
    ],
    [
        "svg",
        "image/svg+xml"
    ],
    [
        "swf",
        "application/x-shockwave-flash"
    ],
    [
        "tar",
        "application/x-tar"
    ],
    [
        "tif",
        "image/tiff"
    ],
    [
        "tiff",
        "image/tiff"
    ],
    [
        "ts",
        "video/mp2t"
    ],
    [
        "ttf",
        "font/ttf"
    ],
    [
        "txt",
        "text/plain"
    ],
    [
        "vsd",
        "application/vnd.visio"
    ],
    [
        "wav",
        "audio/wav"
    ],
    [
        "weba",
        "audio/webm"
    ],
    [
        "webm",
        "video/webm"
    ],
    [
        "webp",
        "image/webp"
    ],
    [
        "woff",
        "font/woff"
    ],
    [
        "woff2",
        "font/woff2"
    ],
    [
        "xhtml",
        "application/xhtml+xml"
    ],
    [
        "xls",
        "application/vnd.ms-excel"
    ],
    [
        "xlsx",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ],
    [
        "xml",
        "application/xml"
    ],
    [
        "xul",
        "application/vnd.mozilla.xul+xml"
    ],
    [
        "zip",
        "application/zip"
    ],
    [
        "7z",
        "application/x-7z-compressed"
    ],
    // Others
    [
        "mkv",
        "video/x-matroska"
    ],
    [
        "mov",
        "video/quicktime"
    ],
    [
        "msg",
        "application/vnd.ms-outlook"
    ]
]);
function $dac22b55eb23ffcc$export$8cc09085015f0dc7(file, path) {
    var f = $dac22b55eb23ffcc$var$withMimeType(file);
    if (typeof f.path !== "string") {
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, "path", {
            value: typeof path === "string" ? path : typeof webkitRelativePath === "string" && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function $dac22b55eb23ffcc$var$withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf(".") !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split(".").pop().toLowerCase();
        var type = $dac22b55eb23ffcc$export$db0345794bfc14ed.get(ext);
        if (type) Object.defineProperty(file, "type", {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}


var $7ac450b547cb7da9$var$FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    ".DS_Store",
    "Thumbs.db" // Windows
];
function $7ac450b547cb7da9$export$a36e16046ae8f1bb(evt) {
    return (0, $a0acfd416da73b8a$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $a0acfd416da73b8a$export$67ebef60e6f28a6)(this, function(_a) {
            if ($7ac450b547cb7da9$var$isObject(evt) && $7ac450b547cb7da9$var$isDataTransfer(evt.dataTransfer)) return [
                2 /*return*/ ,
                $7ac450b547cb7da9$var$getDataTransferFiles(evt.dataTransfer, evt.type)
            ];
            else if ($7ac450b547cb7da9$var$isChangeEvt(evt)) return [
                2 /*return*/ ,
                $7ac450b547cb7da9$var$getInputFiles(evt)
            ];
            else if (Array.isArray(evt) && evt.every(function(item) {
                return "getFile" in item && typeof item.getFile === "function";
            })) return [
                2 /*return*/ ,
                $7ac450b547cb7da9$var$getFsHandleFiles(evt)
            ];
            return [
                2 /*return*/ ,
                []
            ];
        });
    });
}
function $7ac450b547cb7da9$var$isDataTransfer(value) {
    return $7ac450b547cb7da9$var$isObject(value);
}
function $7ac450b547cb7da9$var$isChangeEvt(value) {
    return $7ac450b547cb7da9$var$isObject(value) && $7ac450b547cb7da9$var$isObject(value.target);
}
function $7ac450b547cb7da9$var$isObject(v) {
    return typeof v === "object" && v !== null;
}
function $7ac450b547cb7da9$var$getInputFiles(evt) {
    return $7ac450b547cb7da9$var$fromList(evt.target.files).map(function(file) {
        return (0, $dac22b55eb23ffcc$export$8cc09085015f0dc7)(file);
    });
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function $7ac450b547cb7da9$var$getFsHandleFiles(handles) {
    return (0, $a0acfd416da73b8a$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var files;
        return (0, $a0acfd416da73b8a$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        Promise.all(handles.map(function(h) {
                            return h.getFile();
                        }))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        files.map(function(file) {
                            return (0, $dac22b55eb23ffcc$export$8cc09085015f0dc7)(file);
                        })
                    ];
            }
        });
    });
}
function $7ac450b547cb7da9$var$getDataTransferFiles(dt, type) {
    return (0, $a0acfd416da73b8a$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var items, files;
        return (0, $a0acfd416da73b8a$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!dt.items) return [
                        3 /*break*/ ,
                        2
                    ];
                    items = $7ac450b547cb7da9$var$fromList(dt.items).filter(function(item) {
                        return item.kind === "file";
                    });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== "drop") return [
                        2 /*return*/ ,
                        items
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.all(items.map($7ac450b547cb7da9$var$toFilePromises))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        $7ac450b547cb7da9$var$noIgnoredFiles($7ac450b547cb7da9$var$flatten(files))
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        $7ac450b547cb7da9$var$noIgnoredFiles($7ac450b547cb7da9$var$fromList(dt.files).map(function(file) {
                            return (0, $dac22b55eb23ffcc$export$8cc09085015f0dc7)(file);
                        }))
                    ];
            }
        });
    });
}
function $7ac450b547cb7da9$var$noIgnoredFiles(files) {
    return files.filter(function(file) {
        return $7ac450b547cb7da9$var$FILES_TO_IGNORE.indexOf(file.name) === -1;
    });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function $7ac450b547cb7da9$var$fromList(items) {
    if (items === null) return [];
    var files = [];
    // tslint:disable: prefer-for-of
    for(var i = 0; i < items.length; i++){
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function $7ac450b547cb7da9$var$toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== "function") return $7ac450b547cb7da9$var$fromDataTransferItem(item);
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) return $7ac450b547cb7da9$var$fromDirEntry(entry);
    return $7ac450b547cb7da9$var$fromDataTransferItem(item);
}
function $7ac450b547cb7da9$var$flatten(items) {
    return items.reduce(function(acc, files) {
        return (0, $a0acfd416da73b8a$export$1216008129fb82ed)((0, $a0acfd416da73b8a$export$1216008129fb82ed)([], (0, $a0acfd416da73b8a$export$8d051b38c9118094)(acc), false), (0, $a0acfd416da73b8a$export$8d051b38c9118094)(Array.isArray(files) ? $7ac450b547cb7da9$var$flatten(files) : [
            files
        ]), false);
    }, []);
}
function $7ac450b547cb7da9$var$fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) return Promise.reject("".concat(item, " is not a File"));
    var fwp = (0, $dac22b55eb23ffcc$export$8cc09085015f0dc7)(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function $7ac450b547cb7da9$var$fromEntry(entry) {
    return (0, $a0acfd416da73b8a$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $a0acfd416da73b8a$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                entry.isDirectory ? $7ac450b547cb7da9$var$fromDirEntry(entry) : $7ac450b547cb7da9$var$fromFileEntry(entry)
            ];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function $7ac450b547cb7da9$var$fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function(resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function(batch) {
                return (0, $a0acfd416da73b8a$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                    var files, err_1, items;
                    return (0, $a0acfd416da73b8a$export$67ebef60e6f28a6)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!!batch.length) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    Promise.all(entries)
                                ];
                            case 2:
                                files = _a.sent();
                                resolve(files);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                err_1 = _a.sent();
                                reject(err_1);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 4:
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 5:
                                items = Promise.all(batch.map($7ac450b547cb7da9$var$fromEntry));
                                entries.push(items);
                                // Continue reading
                                readEntries();
                                _a.label = 6;
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, function(err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function $7ac450b547cb7da9$var$fromFileEntry(entry) {
    return (0, $a0acfd416da73b8a$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $a0acfd416da73b8a$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    entry.file(function(file) {
                        var fwp = (0, $dac22b55eb23ffcc$export$8cc09085015f0dc7)(file, entry.fullPath);
                        resolve(fwp);
                    }, function(err) {
                        reject(err);
                    });
                })
            ];
        });
    });
}




var $000a86df99a95c54$export$1e511d4a378977f5;
var $000a86df99a95c54$export$2e2bcd8739ae039;
"use strict";
$000a86df99a95c54$export$1e511d4a378977f5 = true;
$000a86df99a95c54$export$2e2bcd8739ae039 = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(",");
        var fileName = file.name || "";
        var mimeType = (file.type || "").toLowerCase();
        var baseMimeType = mimeType.replace(/\/.*$/, "");
        return acceptedFilesArray.some(function(type) {
            var validType = type.trim().toLowerCase();
            if (validType.charAt(0) === ".") return fileName.toLowerCase().endsWith(validType);
            else if (validType.endsWith("/*")) // This is something like a image/* mime type
            return baseMimeType === validType.replace(/\/.*$/, "");
            return mimeType === validType;
        });
    }
    return true;
};


function $aaac53b849ab07d4$var$_toConsumableArray(arr) {
    return $aaac53b849ab07d4$var$_arrayWithoutHoles(arr) || $aaac53b849ab07d4$var$_iterableToArray(arr) || $aaac53b849ab07d4$var$_unsupportedIterableToArray(arr) || $aaac53b849ab07d4$var$_nonIterableSpread();
}
function $aaac53b849ab07d4$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aaac53b849ab07d4$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $aaac53b849ab07d4$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $aaac53b849ab07d4$var$_arrayLikeToArray(arr);
}
function $aaac53b849ab07d4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aaac53b849ab07d4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $aaac53b849ab07d4$var$ownKeys(Object(source), !0).forEach(function(key) {
            $aaac53b849ab07d4$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $aaac53b849ab07d4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $aaac53b849ab07d4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $aaac53b849ab07d4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $aaac53b849ab07d4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $aaac53b849ab07d4$var$_typeof(obj);
}
function $aaac53b849ab07d4$var$_slicedToArray(arr, i) {
    return $aaac53b849ab07d4$var$_arrayWithHoles(arr) || $aaac53b849ab07d4$var$_iterableToArrayLimit(arr, i) || $aaac53b849ab07d4$var$_unsupportedIterableToArray(arr, i) || $aaac53b849ab07d4$var$_nonIterableRest();
}
function $aaac53b849ab07d4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aaac53b849ab07d4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $aaac53b849ab07d4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $aaac53b849ab07d4$var$_arrayLikeToArray(o, minLen);
}
function $aaac53b849ab07d4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $aaac53b849ab07d4$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $aaac53b849ab07d4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $aaac53b849ab07d4$export$d2c35cc369247232 = "file-invalid-type";
var $aaac53b849ab07d4$export$d7bd1185abe1e87c = "file-too-large";
var $aaac53b849ab07d4$export$8bd5ec6ed990dc9 = "file-too-small";
var $aaac53b849ab07d4$export$3271ef1d2dd155f9 = "too-many-files";
var $aaac53b849ab07d4$export$d4e71bc0b80dc0fb = {
    FileInvalidType: $aaac53b849ab07d4$export$d2c35cc369247232,
    FileTooLarge: $aaac53b849ab07d4$export$d7bd1185abe1e87c,
    FileTooSmall: $aaac53b849ab07d4$export$8bd5ec6ed990dc9,
    TooManyFiles: $aaac53b849ab07d4$export$3271ef1d2dd155f9
}; // File Errors
var $aaac53b849ab07d4$export$bc0bbda045f09b5a = function getInvalidTypeRejectionErr(accept) {
    accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
    var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
    return {
        code: $aaac53b849ab07d4$export$d2c35cc369247232,
        message: "File type must be ".concat(messageSuffix)
    };
};
var $aaac53b849ab07d4$export$b70c322af07b9d49 = function getTooLargeRejectionErr(maxSize) {
    return {
        code: $aaac53b849ab07d4$export$d7bd1185abe1e87c,
        message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
    };
};
var $aaac53b849ab07d4$export$d61cfd6dff5a3e22 = function getTooSmallRejectionErr(minSize) {
    return {
        code: $aaac53b849ab07d4$export$8bd5ec6ed990dc9,
        message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
    };
};
var $aaac53b849ab07d4$export$1e1e1b6120329fe = {
    code: $aaac53b849ab07d4$export$3271ef1d2dd155f9,
    message: "Too many files"
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
function $aaac53b849ab07d4$export$b511db3632effe58(file, accept) {
    var isAcceptable = file.type === "application/x-moz-file" || (0, $000a86df99a95c54$export$2e2bcd8739ae039)(file, accept);
    return [
        isAcceptable,
        isAcceptable ? null : $aaac53b849ab07d4$export$bc0bbda045f09b5a(accept)
    ];
}
function $aaac53b849ab07d4$export$860631d45ba43fd9(file, minSize, maxSize) {
    if ($aaac53b849ab07d4$var$isDefined(file.size)) {
        if ($aaac53b849ab07d4$var$isDefined(minSize) && $aaac53b849ab07d4$var$isDefined(maxSize)) {
            if (file.size > maxSize) return [
                false,
                $aaac53b849ab07d4$export$b70c322af07b9d49(maxSize)
            ];
            if (file.size < minSize) return [
                false,
                $aaac53b849ab07d4$export$d61cfd6dff5a3e22(minSize)
            ];
        } else if ($aaac53b849ab07d4$var$isDefined(minSize) && file.size < minSize) return [
            false,
            $aaac53b849ab07d4$export$d61cfd6dff5a3e22(minSize)
        ];
        else if ($aaac53b849ab07d4$var$isDefined(maxSize) && file.size > maxSize) return [
            false,
            $aaac53b849ab07d4$export$b70c322af07b9d49(maxSize)
        ];
    }
    return [
        true,
        null
    ];
}
function $aaac53b849ab07d4$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $aaac53b849ab07d4$export$6a0bb4322c81a197(_ref) {
    var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple, maxFiles = _ref.maxFiles, validator = _ref.validator;
    if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) return false;
    return files.every(function(file) {
        var _fileAccepted = $aaac53b849ab07d4$export$b511db3632effe58(file, accept), _fileAccepted2 = $aaac53b849ab07d4$var$_slicedToArray(_fileAccepted, 1), accepted = _fileAccepted2[0];
        var _fileMatchSize = $aaac53b849ab07d4$export$860631d45ba43fd9(file, minSize, maxSize), _fileMatchSize2 = $aaac53b849ab07d4$var$_slicedToArray(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
        var customErrors = validator ? validator(file) : null;
        return accepted && sizeMatch && !customErrors;
    });
} // React's synthetic events has event.isPropagationStopped,
function $aaac53b849ab07d4$export$8d6d6472146de265(event) {
    if (typeof event.isPropagationStopped === "function") return event.isPropagationStopped();
    else if (typeof event.cancelBubble !== "undefined") return event.cancelBubble;
    return false;
}
function $aaac53b849ab07d4$export$52f1fc875a1e5986(event) {
    if (!event.dataTransfer) return !!event.target && !!event.target.files;
     // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
    return Array.prototype.some.call(event.dataTransfer.types, function(type) {
        return type === "Files" || type === "application/x-moz-file";
    });
}
function $aaac53b849ab07d4$export$f9006bf02b243736(item) {
    return $aaac53b849ab07d4$var$_typeof(item) === "object" && item !== null && item.kind === "file";
} // allow the entire document to be a drag target
function $aaac53b849ab07d4$export$2ead263d6635cecc(event) {
    event.preventDefault();
}
function $aaac53b849ab07d4$var$isIe(userAgent) {
    return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function $aaac53b849ab07d4$var$isEdge(userAgent) {
    return userAgent.indexOf("Edge/") !== -1;
}
function $aaac53b849ab07d4$export$d3498e653911f962() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return $aaac53b849ab07d4$var$isIe(userAgent) || $aaac53b849ab07d4$var$isEdge(userAgent);
}
function $aaac53b849ab07d4$export$b9ecd428b558ff10() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            if (!$aaac53b849ab07d4$export$8d6d6472146de265(event) && fn) fn.apply(void 0, [
                event
            ].concat(args));
            return $aaac53b849ab07d4$export$8d6d6472146de265(event);
        });
    };
}
function $aaac53b849ab07d4$export$858af2af50e1eaf8() {
    return "showOpenFilePicker" in window;
}
function $aaac53b849ab07d4$export$8ce4bd13c494743e(accept) {
    if ($aaac53b849ab07d4$var$isDefined(accept)) {
        var acceptForPicker = Object.entries(accept).filter(function(_ref2) {
            var _ref3 = $aaac53b849ab07d4$var$_slicedToArray(_ref2, 2), mimeType = _ref3[0], ext = _ref3[1];
            var ok = true;
            if (!$aaac53b849ab07d4$export$69c8ec3250e1cfbf(mimeType)) {
                console.warn('Skipped "'.concat(mimeType, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.'));
                ok = false;
            }
            if (!Array.isArray(ext) || !ext.every($aaac53b849ab07d4$export$42c2be5a6d408120)) {
                console.warn('Skipped "'.concat(mimeType, '" because an invalid file extension was provided.'));
                ok = false;
            }
            return ok;
        }).reduce(function(agg, _ref4) {
            var _ref5 = $aaac53b849ab07d4$var$_slicedToArray(_ref4, 2), mimeType = _ref5[0], ext = _ref5[1];
            return $aaac53b849ab07d4$var$_objectSpread($aaac53b849ab07d4$var$_objectSpread({}, agg), {}, $aaac53b849ab07d4$var$_defineProperty({}, mimeType, ext));
        }, {});
        return [
            {
                // description is required due to https://crbug.com/1264708
                description: "Files",
                accept: acceptForPicker
            }
        ];
    }
    return accept;
}
function $aaac53b849ab07d4$export$1278288bcefb97b9(accept) {
    if ($aaac53b849ab07d4$var$isDefined(accept)) return Object.entries(accept).reduce(function(a, _ref6) {
        var _ref7 = $aaac53b849ab07d4$var$_slicedToArray(_ref6, 2), mimeType = _ref7[0], ext = _ref7[1];
        return [].concat($aaac53b849ab07d4$var$_toConsumableArray(a), [
            mimeType
        ], $aaac53b849ab07d4$var$_toConsumableArray(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function(v) {
        return $aaac53b849ab07d4$export$69c8ec3250e1cfbf(v) || $aaac53b849ab07d4$export$42c2be5a6d408120(v);
    }).join(",");
    return undefined;
}
function $aaac53b849ab07d4$export$72580c77a176a18f(v) {
    return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
function $aaac53b849ab07d4$export$c4f82d4432e209a9(v) {
    return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
function $aaac53b849ab07d4$export$69c8ec3250e1cfbf(v) {
    return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || /\w+\/[-+.\w]+/g.test(v);
}
function $aaac53b849ab07d4$export$42c2be5a6d408120(v) {
    return /^.*\.[\w]+$/.test(v);
} /**
 * @typedef {Object.<string, string[]>} AcceptProp
 */  /**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */  /**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */ 



var $a24044586ed82795$var$_excluded = [
    "children"
], $a24044586ed82795$var$_excluded2 = [
    "open"
], $a24044586ed82795$var$_excluded3 = [
    "refKey",
    "role",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onClick",
    "onDragEnter",
    "onDragOver",
    "onDragLeave",
    "onDrop"
], $a24044586ed82795$var$_excluded4 = [
    "refKey",
    "onChange",
    "onClick"
];
function $a24044586ed82795$var$_toConsumableArray(arr) {
    return $a24044586ed82795$var$_arrayWithoutHoles(arr) || $a24044586ed82795$var$_iterableToArray(arr) || $a24044586ed82795$var$_unsupportedIterableToArray(arr) || $a24044586ed82795$var$_nonIterableSpread();
}
function $a24044586ed82795$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a24044586ed82795$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $a24044586ed82795$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $a24044586ed82795$var$_arrayLikeToArray(arr);
}
function $a24044586ed82795$var$_slicedToArray(arr, i) {
    return $a24044586ed82795$var$_arrayWithHoles(arr) || $a24044586ed82795$var$_iterableToArrayLimit(arr, i) || $a24044586ed82795$var$_unsupportedIterableToArray(arr, i) || $a24044586ed82795$var$_nonIterableRest();
}
function $a24044586ed82795$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a24044586ed82795$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a24044586ed82795$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a24044586ed82795$var$_arrayLikeToArray(o, minLen);
}
function $a24044586ed82795$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a24044586ed82795$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a24044586ed82795$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a24044586ed82795$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a24044586ed82795$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a24044586ed82795$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a24044586ed82795$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a24044586ed82795$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a24044586ed82795$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a24044586ed82795$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a24044586ed82795$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a24044586ed82795$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */ var $a24044586ed82795$var$Dropzone = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, params = $a24044586ed82795$var$_objectWithoutProperties(_ref, $a24044586ed82795$var$_excluded);
    var _useDropzone = $a24044586ed82795$export$cd49c0ecc5be9f36(params), open = _useDropzone.open, props = $a24044586ed82795$var$_objectWithoutProperties(_useDropzone, $a24044586ed82795$var$_excluded2);
    (0, $acw62.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    }, [
        open
    ]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, children($a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, props), {}, {
        open: open
    })));
});
$a24044586ed82795$var$Dropzone.displayName = "Dropzone"; // Add default props for react-docgen
var $a24044586ed82795$var$defaultProps = {
    disabled: false,
    getFilesFromEvent: (0, $7ac450b547cb7da9$export$a36e16046ae8f1bb),
    maxSize: Infinity,
    minSize: 0,
    multiple: true,
    maxFiles: 0,
    preventDropOnDocument: true,
    noClick: false,
    noKeyboard: false,
    noDrag: false,
    noDragEventsBubbling: false,
    validator: null,
    useFsAccessApi: true,
    autoFocus: false
};
$a24044586ed82795$var$Dropzone.defaultProps = $a24044586ed82795$var$defaultProps;
$a24044586ed82795$var$Dropzone.propTypes = {
    /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */ accept: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)),
    /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If false, allow dropped items to take over the current browser window
   */ preventDropOnDocument: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If true, disables click to open the native file selection dialog
   */ noClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */ noKeyboard: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If true, disables drag 'n' drop
   */ noDrag: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If true, stops drag event propagation to parents
   */ noDragEventsBubbling: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Minimum file size (in bytes)
   */ minSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Maximum file size (in bytes)
   */ maxSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */ maxFiles: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Enable/disable the dropzone
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ getFilesFromEvent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when closing the file dialog with no selection
   */ onFileDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when opening the file dialog
   */ onFileDialogOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */ useFsAccessApi: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Set to true to focus the root element on render
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */ onDragEnter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */ onDragOver: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */ onDropAccepted: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */ onDropRejected: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */ validator: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $a24044586ed82795$export$2e2bcd8739ae039 = $a24044586ed82795$var$Dropzone;
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */ /**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */ /**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */ var $a24044586ed82795$var$initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    acceptedFiles: [],
    fileRejections: []
};
function $a24044586ed82795$export$cd49c0ecc5be9f36() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _defaultProps$props = $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$defaultProps), props), accept = _defaultProps$props.accept, disabled = _defaultProps$props.disabled, getFilesFromEvent = _defaultProps$props.getFilesFromEvent, maxSize = _defaultProps$props.maxSize, minSize = _defaultProps$props.minSize, multiple = _defaultProps$props.multiple, maxFiles = _defaultProps$props.maxFiles, onDragEnter = _defaultProps$props.onDragEnter, onDragLeave = _defaultProps$props.onDragLeave, onDragOver = _defaultProps$props.onDragOver, onDrop = _defaultProps$props.onDrop, onDropAccepted = _defaultProps$props.onDropAccepted, onDropRejected = _defaultProps$props.onDropRejected, onFileDialogCancel = _defaultProps$props.onFileDialogCancel, onFileDialogOpen = _defaultProps$props.onFileDialogOpen, useFsAccessApi = _defaultProps$props.useFsAccessApi, autoFocus = _defaultProps$props.autoFocus, preventDropOnDocument = _defaultProps$props.preventDropOnDocument, noClick = _defaultProps$props.noClick, noKeyboard = _defaultProps$props.noKeyboard, noDrag = _defaultProps$props.noDrag, noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling, onError = _defaultProps$props.onError, validator = _defaultProps$props.validator;
    var acceptAttr = (0, $acw62.useMemo)(function() {
        return (0, $aaac53b849ab07d4$export$1278288bcefb97b9)(accept);
    }, [
        accept
    ]);
    var pickerTypes = (0, $acw62.useMemo)(function() {
        return (0, $aaac53b849ab07d4$export$8ce4bd13c494743e)(accept);
    }, [
        accept
    ]);
    var onFileDialogOpenCb = (0, $acw62.useMemo)(function() {
        return typeof onFileDialogOpen === "function" ? onFileDialogOpen : $a24044586ed82795$var$noop;
    }, [
        onFileDialogOpen
    ]);
    var onFileDialogCancelCb = (0, $acw62.useMemo)(function() {
        return typeof onFileDialogCancel === "function" ? onFileDialogCancel : $a24044586ed82795$var$noop;
    }, [
        onFileDialogCancel
    ]);
    /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */ var rootRef = (0, $acw62.useRef)(null);
    var inputRef = (0, $acw62.useRef)(null);
    var _useReducer = (0, $acw62.useReducer)($a24044586ed82795$var$reducer, $a24044586ed82795$var$initialState), _useReducer2 = $a24044586ed82795$var$_slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive;
    var fsAccessApiWorksRef = (0, $acw62.useRef)(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && (0, $aaac53b849ab07d4$export$858af2af50e1eaf8)()); // Update file dialog active state when the window is focused on
    var onWindowFocus = function onWindowFocus() {
        // Execute the timeout only if the file dialog is opened in the browser
        if (!fsAccessApiWorksRef.current && isFileDialogActive) setTimeout(function() {
            if (inputRef.current) {
                var files = inputRef.current.files;
                if (!files.length) {
                    dispatch({
                        type: "closeDialog"
                    });
                    onFileDialogCancelCb();
                }
            }
        }, 300);
    };
    (0, $acw62.useEffect)(function() {
        window.addEventListener("focus", onWindowFocus, false);
        return function() {
            window.removeEventListener("focus", onWindowFocus, false);
        };
    }, [
        inputRef,
        isFileDialogActive,
        onFileDialogCancelCb,
        fsAccessApiWorksRef
    ]);
    var dragTargetsRef = (0, $acw62.useRef)([]);
    var onDocumentDrop = function onDocumentDrop(event) {
        if (rootRef.current && rootRef.current.contains(event.target)) // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
        event.preventDefault();
        dragTargetsRef.current = [];
    };
    (0, $acw62.useEffect)(function() {
        if (preventDropOnDocument) {
            document.addEventListener("dragover", (0, $aaac53b849ab07d4$export$2ead263d6635cecc), false);
            document.addEventListener("drop", onDocumentDrop, false);
        }
        return function() {
            if (preventDropOnDocument) {
                document.removeEventListener("dragover", (0, $aaac53b849ab07d4$export$2ead263d6635cecc));
                document.removeEventListener("drop", onDocumentDrop);
            }
        };
    }, [
        rootRef,
        preventDropOnDocument
    ]); // Auto focus the root when autoFocus is true
    (0, $acw62.useEffect)(function() {
        if (!disabled && autoFocus && rootRef.current) rootRef.current.focus();
        return function() {};
    }, [
        rootRef,
        autoFocus,
        disabled
    ]);
    var onErrCb = (0, $acw62.useCallback)(function(e) {
        if (onError) onError(e);
        else // Let the user know something's gone wrong if they haven't provided the onError cb.
        console.error(e);
    }, [
        onError
    ]);
    var onDragEnterCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [].concat($a24044586ed82795$var$_toConsumableArray(dragTargetsRef.current), [
            event.target
        ]);
        if ((0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $aaac53b849ab07d4$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            var fileCount = files.length;
            var isDragAccept = fileCount > 0 && (0, $aaac53b849ab07d4$export$6a0bb4322c81a197)({
                files: files,
                accept: acceptAttr,
                minSize: minSize,
                maxSize: maxSize,
                multiple: multiple,
                maxFiles: maxFiles,
                validator: validator
            });
            var isDragReject = fileCount > 0 && !isDragAccept;
            dispatch({
                isDragAccept: isDragAccept,
                isDragReject: isDragReject,
                isDragActive: true,
                type: "setDraggedFiles"
            });
            if (onDragEnter) onDragEnter(event);
        }).catch(function(e) {
            return onErrCb(e);
        });
    }, [
        getFilesFromEvent,
        onDragEnter,
        onErrCb,
        noDragEventsBubbling,
        acceptAttr,
        minSize,
        maxSize,
        multiple,
        maxFiles,
        validator
    ]);
    var onDragOverCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        var hasFiles = (0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event);
        if (hasFiles && event.dataTransfer) try {
            event.dataTransfer.dropEffect = "copy";
        } catch (_unused) {}
        if (hasFiles && onDragOver) onDragOver(event);
        return false;
    }, [
        onDragOver,
        noDragEventsBubbling
    ]);
    var onDragLeaveCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event); // Only deactivate once the dropzone and all children have been left
        var targets = dragTargetsRef.current.filter(function(target) {
            return rootRef.current && rootRef.current.contains(target);
        }); // Make sure to remove a target present multiple times only once
        // (Firefox may fire dragenter/dragleave multiple times on the same element)
        var targetIdx = targets.indexOf(event.target);
        if (targetIdx !== -1) targets.splice(targetIdx, 1);
        dragTargetsRef.current = targets;
        if (targets.length > 0) return;
        dispatch({
            type: "setDraggedFiles",
            isDragActive: false,
            isDragAccept: false,
            isDragReject: false
        });
        if ((0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event) && onDragLeave) onDragLeave(event);
    }, [
        rootRef,
        onDragLeave,
        noDragEventsBubbling
    ]);
    var setFiles = (0, $acw62.useCallback)(function(files, event) {
        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function(file) {
            var _fileAccepted = (0, $aaac53b849ab07d4$export$b511db3632effe58)(file, acceptAttr), _fileAccepted2 = $a24044586ed82795$var$_slicedToArray(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
            var _fileMatchSize = (0, $aaac53b849ab07d4$export$860631d45ba43fd9)(file, minSize, maxSize), _fileMatchSize2 = $a24044586ed82795$var$_slicedToArray(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
            var customErrors = validator ? validator(file) : null;
            if (accepted && sizeMatch && !customErrors) acceptedFiles.push(file);
            else {
                var errors = [
                    acceptError,
                    sizeError
                ];
                if (customErrors) errors = errors.concat(customErrors);
                fileRejections.push({
                    file: file,
                    errors: errors.filter(function(e) {
                        return e;
                    })
                });
            }
        });
        if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
            // Reject everything and empty accepted files
            acceptedFiles.forEach(function(file) {
                fileRejections.push({
                    file: file,
                    errors: [
                        (0, $aaac53b849ab07d4$export$1e1e1b6120329fe)
                    ]
                });
            });
            acceptedFiles.splice(0);
        }
        dispatch({
            acceptedFiles: acceptedFiles,
            fileRejections: fileRejections,
            type: "setFiles"
        });
        if (onDrop) onDrop(acceptedFiles, fileRejections, event);
        if (fileRejections.length > 0 && onDropRejected) onDropRejected(fileRejections, event);
        if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
    }, [
        dispatch,
        multiple,
        acceptAttr,
        minSize,
        maxSize,
        maxFiles,
        onDrop,
        onDropAccepted,
        onDropRejected,
        validator
    ]);
    var onDropCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [];
        if ((0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $aaac53b849ab07d4$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            setFiles(files, event);
        }).catch(function(e) {
            return onErrCb(e);
        });
        dispatch({
            type: "reset"
        });
    }, [
        getFilesFromEvent,
        setFiles,
        onErrCb,
        noDragEventsBubbling
    ]); // Fn for opening the file dialog programmatically
    var openFileDialog = (0, $acw62.useCallback)(function() {
        // No point to use FS access APIs if context is not secure
        // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
        if (fsAccessApiWorksRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
            var opts = {
                multiple: multiple,
                types: pickerTypes
            };
            window.showOpenFilePicker(opts).then(function(handles) {
                return getFilesFromEvent(handles);
            }).then(function(files) {
                setFiles(files, null);
                dispatch({
                    type: "closeDialog"
                });
            }).catch(function(e) {
                // AbortError means the user canceled
                if ((0, $aaac53b849ab07d4$export$72580c77a176a18f)(e)) {
                    onFileDialogCancelCb(e);
                    dispatch({
                        type: "closeDialog"
                    });
                } else if ((0, $aaac53b849ab07d4$export$c4f82d4432e209a9)(e)) {
                    fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
                    // Try using the input
                    if (inputRef.current) {
                        inputRef.current.value = null;
                        inputRef.current.click();
                    } else onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
                } else onErrCb(e);
            });
            return;
        }
        if (inputRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb();
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, [
        dispatch,
        onFileDialogOpenCb,
        onFileDialogCancelCb,
        useFsAccessApi,
        setFiles,
        onErrCb,
        pickerTypes,
        multiple
    ]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone
    var onKeyDownCb = (0, $acw62.useCallback)(function(event) {
        // Ignore keyboard events bubbling up the DOM tree
        if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
        if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            openFileDialog();
        }
    }, [
        rootRef,
        openFileDialog
    ]); // Update focus state for the dropzone
    var onFocusCb = (0, $acw62.useCallback)(function() {
        dispatch({
            type: "focus"
        });
    }, []);
    var onBlurCb = (0, $acw62.useCallback)(function() {
        dispatch({
            type: "blur"
        });
    }, []); // Cb to open the file dialog when click occurs on the dropzone
    var onClickCb = (0, $acw62.useCallback)(function() {
        if (noClick) return;
         // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
        // to ensure React can handle state changes
        // See: https://github.com/react-dropzone/react-dropzone/issues/450
        if ((0, $aaac53b849ab07d4$export$d3498e653911f962)()) setTimeout(openFileDialog, 0);
        else openFileDialog();
    }, [
        noClick,
        openFileDialog
    ]);
    var composeHandler = function composeHandler(fn) {
        return disabled ? null : fn;
    };
    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
        return noKeyboard ? null : composeHandler(fn);
    };
    var composeDragHandler = function composeDragHandler(fn) {
        return noDrag ? null : composeHandler(fn);
    };
    var stopPropagation = function stopPropagation(event) {
        if (noDragEventsBubbling) event.stopPropagation();
    };
    var getRootProps = (0, $acw62.useMemo)(function() {
        return function() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$refKey = _ref2.refKey, refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey, role = _ref2.role, onKeyDown = _ref2.onKeyDown, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick, onDragEnter = _ref2.onDragEnter, onDragOver = _ref2.onDragOver, onDragLeave = _ref2.onDragLeave, onDrop = _ref2.onDrop, rest = $a24044586ed82795$var$_objectWithoutProperties(_ref2, $a24044586ed82795$var$_excluded3);
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_defineProperty({
                onKeyDown: composeKeyboardHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onBlur, onBlurCb)),
                onClick: composeHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onClick, onClickCb)),
                onDragEnter: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDrop, onDropCb)),
                role: typeof role === "string" && role !== "" ? role : "presentation"
            }, refKey, rootRef), !disabled && !noKeyboard ? {
                tabIndex: 0
            } : {}), rest);
        };
    }, [
        rootRef,
        onKeyDownCb,
        onFocusCb,
        onBlurCb,
        onClickCb,
        onDragEnterCb,
        onDragOverCb,
        onDragLeaveCb,
        onDropCb,
        noKeyboard,
        noDrag,
        disabled
    ]);
    var onInputElementClick = (0, $acw62.useCallback)(function(event) {
        event.stopPropagation();
    }, []);
    var getInputProps = (0, $acw62.useMemo)(function() {
        return function() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onChange = _ref3.onChange, onClick = _ref3.onClick, rest = $a24044586ed82795$var$_objectWithoutProperties(_ref3, $a24044586ed82795$var$_excluded4);
            var inputProps = $a24044586ed82795$var$_defineProperty({
                accept: acceptAttr,
                multiple: multiple,
                type: "file",
                style: {
                    display: "none"
                },
                onChange: composeHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onChange, onDropCb)),
                onClick: composeHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onClick, onInputElementClick)),
                tabIndex: -1
            }, refKey, inputRef);
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, inputProps), rest);
        };
    }, [
        inputRef,
        accept,
        multiple,
        onDropCb,
        disabled
    ]);
    return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
        isFocused: isFocused && !disabled,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        rootRef: rootRef,
        inputRef: inputRef,
        open: composeHandler(openFileDialog)
    });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */ function $a24044586ed82795$var$reducer(state, action) {
    /* istanbul ignore next */ switch(action.type){
        case "focus":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFocused: true
            });
        case "blur":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFocused: false
            });
        case "openDialog":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$initialState), {}, {
                isFileDialogActive: true
            });
        case "closeDialog":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFileDialogActive: false
            });
        case "setDraggedFiles":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isDragActive: action.isDragActive,
                isDragAccept: action.isDragAccept,
                isDragReject: action.isDragReject
            });
        case "setFiles":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                acceptedFiles: action.acceptedFiles,
                fileRejections: action.fileRejections
            });
        case "reset":
            return $a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$initialState);
        default:
            return state;
    }
}
function $a24044586ed82795$var$noop() {}


const $280c78e4324a6db1$var$BYTE_UNITS = [
    "B",
    "kB",
    "MB",
    "GB",
    "TB",
    "PB",
    "EB",
    "ZB",
    "YB"
];
const $280c78e4324a6db1$var$BIBYTE_UNITS = [
    "B",
    "KiB",
    "MiB",
    "GiB",
    "TiB",
    "PiB",
    "EiB",
    "ZiB",
    "YiB"
];
const $280c78e4324a6db1$var$BIT_UNITS = [
    "b",
    "kbit",
    "Mbit",
    "Gbit",
    "Tbit",
    "Pbit",
    "Ebit",
    "Zbit",
    "Ybit"
];
const $280c78e4324a6db1$var$BIBIT_UNITS = [
    "b",
    "kibit",
    "Mibit",
    "Gibit",
    "Tibit",
    "Pibit",
    "Eibit",
    "Zibit",
    "Yibit"
];
/*
Formats the given number using `Number#toLocaleString`.
- If locale is a string, the value is expected to be a locale-key (for example: `de`).
- If locale is true, the system default locale is used for translation.
- If no value for locale is specified, the number is returned unmodified.
*/ const $280c78e4324a6db1$var$toLocaleString = (number, locale, options)=>{
    let result = number;
    if (typeof locale === "string" || Array.isArray(locale)) result = number.toLocaleString(locale, options);
    else if (locale === true || options !== undefined) result = number.toLocaleString(undefined, options);
    return result;
};
function $280c78e4324a6db1$export$2e2bcd8739ae039(number, options) {
    if (!Number.isFinite(number)) throw new TypeError(`Expected a finite number, got ${typeof number}: ${number}`);
    options = {
        bits: false,
        binary: false,
        space: true,
        ...options
    };
    const UNITS = options.bits ? options.binary ? $280c78e4324a6db1$var$BIBIT_UNITS : $280c78e4324a6db1$var$BIT_UNITS : options.binary ? $280c78e4324a6db1$var$BIBYTE_UNITS : $280c78e4324a6db1$var$BYTE_UNITS;
    const separator = options.space ? " " : "";
    if (options.signed && number === 0) return ` 0${separator}${UNITS[0]}`;
    const isNegative = number < 0;
    const prefix = isNegative ? "-" : options.signed ? "+" : "";
    if (isNegative) number = -number;
    let localeOptions;
    if (options.minimumFractionDigits !== undefined) localeOptions = {
        minimumFractionDigits: options.minimumFractionDigits
    };
    if (options.maximumFractionDigits !== undefined) localeOptions = {
        maximumFractionDigits: options.maximumFractionDigits,
        ...localeOptions
    };
    if (number < 1) {
        const numberString = $280c78e4324a6db1$var$toLocaleString(number, options.locale, localeOptions);
        return prefix + numberString + separator + UNITS[0];
    }
    const exponent = Math.min(Math.floor(options.binary ? Math.log(number) / Math.log(1024) : Math.log10(number) / 3), UNITS.length - 1);
    number /= (options.binary ? 1024 : 1000) ** exponent;
    if (!localeOptions) number = number.toPrecision(3);
    const numberString = $280c78e4324a6db1$var$toLocaleString(Number(number), options.locale, localeOptions);
    const unit = UNITS[exponent];
    return prefix + numberString + separator + unit;
}


function $503b851f3b9eb17a$export$cbffdc74a4cfb5e7({ maxFileSize: maxFileSize, onFileSelected: onFileSelected }) {
    const { toast: toast } = (0, $9898a26843c73274$export$a407b657d3044108)();
    const onDrop = (acceptedFiles)=>{
        console.log(acceptedFiles);
        const file = acceptedFiles[0];
        onFileSelected(file);
    };
    const onDropRejected = (files)=>{
        const file = files[0];
        const error = file.errors[0];
        toast({
            variant: "destructive",
            title: error.code,
            description: error.message
        });
    };
    const { getRootProps: getRootProps, getInputProps: getInputProps } = (0, $a24044586ed82795$export$cd49c0ecc5be9f36)({
        onDrop: onDrop,
        onDropRejected: onDropRejected,
        accept: {
            "video/mp4": [
                ".mp4"
            ]
        },
        multiple: false,
        validator: (file)=>{
            if (file.size > maxFileSize) {
                const humanReadableFileSize = (0, $280c78e4324a6db1$export$2e2bcd8739ae039)(maxFileSize);
                return {
                    code: "File is too large",
                    message: `Your file was too large (${humanReadableFileSize}). We only support files up to ${(0, $280c78e4324a6db1$export$2e2bcd8739ae039)(maxFileSize)}.`
                };
            }
            if (file.type !== "video/mp4") return {
                code: "Invalid file type",
                message: "We only support .mp4 files right now."
            };
            return null;
        }
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-2 border-dashed border-primary bg-primary/10 hover:bg-primary/5 transition-colors rounded-lg p-8 cursor-pointer flex flex-col items-center justify-center min-h-40 gap-2",
        ...getRootProps(),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                ...getInputProps()
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-primary/70",
                children: "Drag 'n' drop your video here, or click to select a video file"
            })
        ]
    });
}





async function $c3d2a57415c7862d$export$acc5a9ee48c18b07(file) {
    return new Promise((resolve, reject)=>{
        const video = document.createElement("video");
        video.onloadedmetadata = ()=>{
            console.log("onloadedmetadata", video.duration, video.videoWidth, video.videoHeight);
            const duration = video.duration;
            const width = video.videoWidth;
            const height = video.videoHeight;
            video.remove();
            URL.revokeObjectURL(video.src);
            resolve({
                duration: duration,
                width: width,
                height: height
            });
        };
        video.onerror = reject;
        video.src = URL.createObjectURL(file);
    });
}



var $acw62 = parcelRequire("acw62");


function $28d61181697a5cec$export$c17561cb55d4db30({ type: type, value: value = 0 }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex flex-1 relative border border-lit-purple h-3 rounded-xl overflow-clip",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("absolute top-0 h-full rounded-xl left-0 bg-lit-purple", {
                "w-[25%] animate-progress-bar-slide": type === "indeterminate",
                "transition-[width]": type === "determinate"
            }),
            style: type === "determinate" ? {
                width: `${Math.min(100, Math.max(0, value))}%`
            } : {}
        })
    });
}


"use strict";
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if ($c319b2c832c2914a$var$kindOf(val) !== "object") return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $c319b2c832c2914a$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $c319b2c832c2914a$var$isFunction(thing.append) && ((kind = $c319b2c832c2914a$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest("URLSearchParams");
const [$c319b2c832c2914a$var$isReadableStream, $c319b2c832c2914a$var$isRequest, $c319b2c832c2914a$var$isResponse, $c319b2c832c2914a$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($c319b2c832c2914a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $c319b2c832c2914a$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    const { caseless: caseless } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $c319b2c832c2914a$var$findKey(result, key) || key;
        if ($c319b2c832c2914a$var$isPlainObject(result[targetKey]) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(result[targetKey], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) a[key] = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest("HTMLFormElement");
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest("RegExp");
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const $c319b2c832c2914a$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $c319b2c832c2914a$var$DIGIT = "0123456789";
const $c319b2c832c2914a$var$ALPHABET = {
    DIGIT: $c319b2c832c2914a$var$DIGIT,
    ALPHA: $c319b2c832c2914a$var$ALPHA,
    ALPHA_DIGIT: $c319b2c832c2914a$var$ALPHA + $c319b2c832c2914a$var$ALPHA.toUpperCase() + $c319b2c832c2914a$var$DIGIT
};
const $c319b2c832c2914a$var$generateString = (size = 16, alphabet = $c319b2c832c2914a$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest("AsyncFunction");
const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isReadableStream: $c319b2c832c2914a$var$isReadableStream,
    isRequest: $c319b2c832c2914a$var$isRequest,
    isResponse: $c319b2c832c2914a$var$isResponse,
    isHeaders: $c319b2c832c2914a$var$isHeaders,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    ALPHABET: $c319b2c832c2914a$var$ALPHABET,
    generateString: $c319b2c832c2914a$var$generateString,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $4e2395edb77acf3a$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($4e2395edb77acf3a$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $4e2395edb77acf3a$var$prototype = $4e2395edb77acf3a$var$AxiosError.prototype;
const $4e2395edb77acf3a$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $4e2395edb77acf3a$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($4e2395edb77acf3a$var$AxiosError, $4e2395edb77acf3a$var$descriptors);
Object.defineProperty($4e2395edb77acf3a$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$4e2395edb77acf3a$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($4e2395edb77acf3a$var$prototype);
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $4e2395edb77acf3a$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;


// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
var $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        var len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        var buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $51861dfc7ca9d588$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $e6cbd383b18c9625$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject((0, $c319b2c832c2914a$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4023ac50ad132196$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $f66f8c7b4f247caf$var$encode);
    } : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $8df8fedf1c1e4428$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;





"use strict";
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039);


"use strict";
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $6eeff4490c995137$export$2e2bcd8739ae039,
        FormData: $86d275a264afb13f$export$2e2bcd8739ae039,
        Blob: $59c79e94740631e4$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $565e85ead8bde60a$exports = {};

$parcel$export($565e85ead8bde60a$exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
$parcel$export($565e85ead8bde60a$exports, "origin", () => $565e85ead8bde60a$export$f710a83a91838a36);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = ((product)=>{
    return $565e85ead8bde60a$export$c4996c4b7b93b0bf && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $565e85ead8bde60a$export$f710a83a91838a36 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";


var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$565e85ead8bde60a$exports,
    ...(0, $2f71637df772b183$export$2e2bcd8739ae039)
};


"use strict";
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(data, new (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).isNode && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $51466d41a76e5b4b$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $5f8142930b3b943f$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFile(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $f6f250f62cadb740$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isResponse(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $866cce54f6bdfb0c$var$$internals = Symbol("internals");
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : String(value);
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $fc026bbf9ee156f1$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;


"use strict";
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $843bf0209bc94df8$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $9fd0919e266b4fda$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($9fd0919e266b4fda$var$CanceledError, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;







"use strict";
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





"use strict";
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;


"use strict";
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $9b3ced92bc7bdc99$var$throttle(fn, freq) {
    let timestamp = 0;
    const threshold = 1000 / freq;
    let timer = null;
    return function throttled() {
        const force = this === true;
        const now = Date.now();
        if (force || now - timestamp > threshold) {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            timestamp = now;
            return fn.apply(null, arguments);
        }
        if (!timer) timer = setTimeout(()=>{
            timer = null;
            timestamp = Date.now();
            return fn.apply(null, arguments);
        }, threshold - (now - timestamp));
    };
}
var $9b3ced92bc7bdc99$export$2e2bcd8739ae039 = $9b3ced92bc7bdc99$var$throttle;


var $1a6c80b567b74091$export$2e2bcd8739ae039 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $4a9d49cd0e6b8acc$export$2e2bcd8739ae039)(50, 250);
    return (0, $9b3ced92bc7bdc99$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    }, freq);
};






"use strict";
var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();




var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


"use strict";
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $8fa91c1a59edb5d9$export$2e2bcd8739ae039)(requestedURL)) return (0, $b63e12c1e0b9e0be$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), true)
    };
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $ab4625fac3104691$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)((0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    let contentType;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || "multipart/form-data",
                ...tokens
            ].join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $5eb63b558e1fb85a$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $65cc14c0704b5541$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType } = _config;
        let onCanceled;
        function done() {
            if (_config.cancelToken) _config.cancelToken.unsubscribe(onCanceled);
            if (_config.signal) _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Request aborted", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, _config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Network Error", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, _config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, _config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (typeof _config.onDownloadProgress === "function") request.addEventListener("progress", (0, $1a6c80b567b74091$export$2e2bcd8739ae039)(_config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof _config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", (0, $1a6c80b567b74091$export$2e2bcd8739ae039)(_config.onUploadProgress));
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $23607f53e4fda918$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $bb8180acb278e187$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};







const $a052b9a6636aacdc$var$composeSignals = (signals, timeout)=>{
    let controller = new AbortController();
    let aborted;
    const onabort = function(cancel) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = cancel instanceof Error ? cancel : this.reason;
            controller.abort(err instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) ? err : new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        onabort(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (signals) {
            timer && clearTimeout(timer);
            timer = null;
            signals.forEach((signal)=>{
                signal && (signal.removeEventListener ? signal.removeEventListener("abort", onabort) : signal.unsubscribe(onabort));
            });
            signals = null;
        }
    };
    signals.forEach((signal)=>signal && signal.addEventListener && signal.addEventListener("abort", onabort));
    const { signal: signal } = controller;
    signal.unsubscribe = unsubscribe;
    return [
        signal,
        ()=>{
            timer && clearTimeout(timer);
            timer = null;
        }
    ];
};
var $a052b9a6636aacdc$export$2e2bcd8739ae039 = $a052b9a6636aacdc$var$composeSignals;


const $c9465135abb26626$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c9465135abb26626$export$f9f241124ee3198e = async function*(iterable, chunkSize, encode) {
    for await (const chunk of iterable)yield* $c9465135abb26626$export$71b051935044bd5d(ArrayBuffer.isView(chunk) ? chunk : await encode(String(chunk)), chunkSize);
};
const $c9465135abb26626$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish, encode)=>{
    const iterator = $c9465135abb26626$export$f9f241124ee3198e(stream, chunkSize, encode);
    let bytes = 0;
    return new ReadableStream({
        type: "bytes",
        async pull (controller) {
            const { done: done, value: value } = await iterator.next();
            if (done) {
                controller.close();
                onFinish();
                return;
            }
            let len = value.byteLength;
            onProgress && onProgress(bytes += len);
            controller.enqueue(new Uint8Array(value));
        },
        cancel (reason) {
            onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $e52be20a9fc15e96$var$fetchProgressDecorator = (total, fn)=>{
    const lengthComputable = total != null;
    return (loaded)=>setTimeout(()=>fn({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }));
};
const $e52be20a9fc15e96$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const $e52be20a9fc15e96$var$isReadableStreamSupported = $e52be20a9fc15e96$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
const $e52be20a9fc15e96$var$encodeText = $e52be20a9fc15e96$var$isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $e52be20a9fc15e96$var$supportsRequestStream = $e52be20a9fc15e96$var$isReadableStreamSupported && (()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
})();
const $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE = 65536;
const $e52be20a9fc15e96$var$supportsResponseStream = $e52be20a9fc15e96$var$isReadableStreamSupported && !!(()=>{
    try {
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(new Response("").body);
    } catch (err) {
    // return undefined
    }
})();
const $e52be20a9fc15e96$var$resolvers = {
    stream: $e52be20a9fc15e96$var$supportsResponseStream && ((res)=>res.body)
};
$e52be20a9fc15e96$var$isFetchSupported && ((res)=>{
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach((type)=>{
        !$e52be20a9fc15e96$var$resolvers[type] && ($e52be20a9fc15e96$var$resolvers[type] = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $e52be20a9fc15e96$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(body)) return (await new Request(body).arrayBuffer()).byteLength;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(body)) return body.byteLength;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + "";
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(body)) return (await $e52be20a9fc15e96$var$encodeText(body)).byteLength;
};
const $e52be20a9fc15e96$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $e52be20a9fc15e96$var$getBodyLength(body) : length;
};
var $e52be20a9fc15e96$export$2e2bcd8739ae039 = $e52be20a9fc15e96$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions } = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + "").toLowerCase() : "text";
    let [composedSignal, stopTimeout] = signal || cancelToken || timeout ? (0, $a052b9a6636aacdc$export$2e2bcd8739ae039)([
        signal,
        cancelToken
    ], timeout) : [];
    let finished, request;
    const onFinish = ()=>{
        !finished && setTimeout(()=>{
            composedSignal && composedSignal.unsubscribe();
        });
        finished = true;
    };
    let requestContentLength;
    try {
        if (onUploadProgress && $e52be20a9fc15e96$var$supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await $e52be20a9fc15e96$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: "POST",
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
            if (_request.body) data = (0, $c9465135abb26626$export$b0119225647bd83)(_request.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, $e52be20a9fc15e96$var$fetchProgressDecorator(requestContentLength, (0, $1a6c80b567b74091$export$2e2bcd8739ae039)(onUploadProgress)), null, $e52be20a9fc15e96$var$encodeText);
        }
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? "cors" : "omit";
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            withCredentials: withCredentials
        });
        let response = await fetch(request);
        const isStreamResponse = $e52be20a9fc15e96$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
        if ($e52be20a9fc15e96$var$supportsResponseStream && (onDownloadProgress || isStreamResponse)) {
            const options = {};
            [
                "status",
                "statusText",
                "headers"
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get("content-length"));
            response = new Response((0, $c9465135abb26626$export$b0119225647bd83)(response.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onDownloadProgress && $e52be20a9fc15e96$var$fetchProgressDecorator(responseContentLength, (0, $1a6c80b567b74091$export$2e2bcd8739ae039)(onDownloadProgress, true)), isStreamResponse && onFinish, $e52be20a9fc15e96$var$encodeText), options);
        }
        responseType = responseType || "text";
        let responseData = await $e52be20a9fc15e96$var$resolvers[(0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey($e52be20a9fc15e96$var$resolvers, responseType) || "text"](response, config);
        !isStreamResponse && onFinish();
        stopTimeout && stopTimeout();
        return await new Promise((resolve, reject)=>{
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        onFinish();
        if (err && err.name === "TypeError" && /fetch/i.test(err.message)) throw Object.assign(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Network Error", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $4023ac50ad132196$export$2e2bcd8739ae039),
    xhr: (0, $79f0a48d5eb7919b$export$2e2bcd8739ae039),
    fetch: (0, $e52be20a9fc15e96$export$2e2bcd8739ae039)
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($e8c8c7960873e9ee$var$renderReason).join("\n") : " " + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $e8c8c7960873e9ee$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $843bf0209bc94df8$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5a60afef8b0dd173$export$2e2bcd8739ae039)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.7.2";



"use strict";
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("options must be an object", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};



"use strict";
const $a93486d2307f31c3$var$validators = (0, $85f59389941e7907$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)(),
            response: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    $a93486d2307f31c3$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;






"use strict";
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $a93486d2307f31c3$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)((0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, (0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $843bf0209bc94df8$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $a93486d2307f31c3$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $9fd0919e266b4fda$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $fb81495929d8a282$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.isCancel = (0, $5a60afef8b0dd173$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.VERSION = (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132);
$57966c7e0affc4cb$var$axios.toFormData = (0, $e6cbd383b18c9625$export$2e2bcd8739ae039);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $4e2395edb77acf3a$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $089369673aa7c1c3$export$2e2bcd8739ae039);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $9db8da59db12cd94$export$2e2bcd8739ae039);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $5f8142930b3b943f$export$2e2bcd8739ae039)((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $f919374d785e9fb8$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a } = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039);





const $0a7277092783dafa$var$MAX_FILE_SIZE = 524288000; // 500MB
const $0a7277092783dafa$var$MAX_VIDEO_DURATION = 300; // 5 minutes
const $0a7277092783dafa$var$UPLOAD_STAGES = {
    NONE: "NONE",
    UPLOADING: "UPLOADING",
    COMPLETED: "COMPLETED",
    ERROR: "ERROR"
};
function $0a7277092783dafa$export$2e2bcd8739ae039() {
    const { toast: toast } = (0, $9898a26843c73274$export$a407b657d3044108)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [uploadStage, setUploadStage] = (0, $acw62.useState)($0a7277092783dafa$var$UPLOAD_STAGES.NONE);
    const createVideoUploadUrlM = (0, $af10f25532815273$export$b8fc23a8b701aa67)((0, $21f88f1227598e15$export$bd33b5cca346a1c5));
    const initProjectWithVideoM = (0, $af10f25532815273$export$b8fc23a8b701aa67)((0, $21f88f1227598e15$export$cfdbd1456a933055));
    const [uploadProgress, setUploadProgress] = (0, $acw62.useState)(0);
    const onFileSelected = async (file)=>{
        (0, $b7120199cc96ae3e$export$6dcfd4317fe45ce5)("Video file selected", {
            fileSize: file.size,
            fileName: file.name,
            fileType: file.type
        });
        let videoMetadata;
        try {
            videoMetadata = await (0, $c3d2a57415c7862d$export$acc5a9ee48c18b07)(file);
            (0, $b7120199cc96ae3e$export$6dcfd4317fe45ce5)("Video get metadata success", {
                fileSize: file.size,
                fileName: file.name,
                fileType: file.type,
                duration: videoMetadata.duration,
                width: videoMetadata.width,
                height: videoMetadata.height
            });
        } catch (error) {
            console.warn(error);
            (0, $b7120199cc96ae3e$export$6dcfd4317fe45ce5)("Video get metadata error", {
                fileSize: file.size,
                fileName: file.name,
                fileType: file.type,
                error: error.message
            });
        }
        let uploadUrlParams;
        try {
            setUploadStage($0a7277092783dafa$var$UPLOAD_STAGES.UPLOADING);
            uploadUrlParams = await createVideoUploadUrlM();
            (0, $b7120199cc96ae3e$export$6dcfd4317fe45ce5)("Video get upload url success", {
                fileSize: file.size,
                fileName: file.name,
                fileType: file.type,
                uploadUrl: uploadUrlParams.uploadUrl,
                uploadPath: uploadUrlParams.uploadPath,
                identifier: uploadUrlParams.identifier
            });
        } catch (error) {
            (0, $b7120199cc96ae3e$export$6dcfd4317fe45ce5)("Video get upload url error", {
                fileSize: file.size,
                fileName: file.name,
                fileType: file.type,
                error: error.message
            });
            setUploadStage($0a7277092783dafa$var$UPLOAD_STAGES.ERROR);
            console.error(error);
            toast({
                variant: "destructive",
                title: "Failed to get upload URL",
                description: "Please try again."
            });
            return;
        }
        try {
            const response = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).put(uploadUrlParams.uploadUrl, file, {
                headers: {
                    "Content-Type": "application/octet-stream"
                },
                onUploadProgress: (progressEvent)=>{
                    const progress = (progressEvent.progress || 0) * 100;
                    setUploadProgress(progress);
                }
            });
            if (response.status < 200 || response.status >= 300) throw new Error("Failed to upload video");
            (0, $b7120199cc96ae3e$export$6dcfd4317fe45ce5)("Video upload success", {
                fileSize: file.size,
                fileName: file.name,
                fileType: file.type,
                uploadUrl: uploadUrlParams.uploadUrl,
                uploadPath: uploadUrlParams.uploadPath,
                identifier: uploadUrlParams.identifier
            });
        } catch (error) {
            (0, $b7120199cc96ae3e$export$6dcfd4317fe45ce5)("Video upload error", {
                fileSize: file.size,
                fileName: file.name,
                fileType: file.type,
                uploadUrl: uploadUrlParams.uploadUrl,
                uploadPath: uploadUrlParams.uploadPath,
                identifier: uploadUrlParams.identifier,
                error: error.message
            });
            setUploadStage($0a7277092783dafa$var$UPLOAD_STAGES.ERROR);
            console.error(error);
            toast({
                variant: "destructive",
                title: "Failed to upload video",
                description: "Please try again."
            });
            return;
        }
        try {
            const projectId = await initProjectWithVideoM({
                uploadPath: uploadUrlParams.uploadPath,
                identifier: uploadUrlParams.identifier
            });
            setUploadStage($0a7277092783dafa$var$UPLOAD_STAGES.COMPLETED);
            navigate(`/projects/${projectId}/status`);
        } catch (error) {
            setUploadStage($0a7277092783dafa$var$UPLOAD_STAGES.ERROR);
            console.error(error);
            toast({
                variant: "destructive",
                title: "Failed to create project",
                description: "Please try again."
            });
        }
    };
    const resetUploadStage = ()=>{
        setUploadStage($0a7277092783dafa$var$UPLOAD_STAGES.NONE);
        setUploadProgress(0);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8437b3fb5ace006$export$2e2bcd8739ae039), {
        activePage: "projects",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "flex justify-center flex-1",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex-1 max-w-4xl px-8 pt-8 pb-4 flex flex-col gap-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        children: "Create new project"
                    }),
                    uploadStage === $0a7277092783dafa$var$UPLOAD_STAGES.NONE ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-8 max-w-3xl",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        children: "Upload video"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "mt-2",
                                        children: [
                                            "Please upload a video file to get started.",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                            "Videos must be in ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: ".mp4 format"
                                            }),
                                            ", with a",
                                            " ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "9:16 (vertical) aspect ratio"
                                            }),
                                            " for best results.",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                            "We currently only support videos ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "up to 500MB"
                                            }),
                                            " ",
                                            "in size and ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "5 minutes"
                                            }),
                                            " in length."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $503b851f3b9eb17a$export$cbffdc74a4cfb5e7), {
                                maxFileSize: $0a7277092783dafa$var$MAX_FILE_SIZE,
                                onFileSelected: onFileSelected
                            })
                        ]
                    }) : uploadStage === $0a7277092783dafa$var$UPLOAD_STAGES.UPLOADING ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-col gap-8",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Uploading video"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mt-2",
                                    children: "Your video is being uploaded to our servers."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mt-4 w-2/3 flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $28d61181697a5cec$export$c17561cb55d4db30), {
                                            type: "determinate",
                                            value: uploadProgress
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                            className: "w-16 text-sm font-medium leading-none",
                                            children: [
                                                Math.floor(uploadProgress),
                                                "%"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }) : uploadStage === $0a7277092783dafa$var$UPLOAD_STAGES.COMPLETED ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-col gap-8",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "text-green-800",
                                children: "Video uploaded successfully"
                            })
                        })
                    }) : uploadStage === $0a7277092783dafa$var$UPLOAD_STAGES.ERROR ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-col gap-8",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    className: "text-red-800",
                                    children: "Something went wrong"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mt-2",
                                    children: "We couldn't create your project. Please try again."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "mt-4 w-2/3 flex items-center gap-2",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b132ebe58e154a99$export$353f5b6fc5456de1), {
                                        onClick: ()=>resetUploadStage(),
                                        children: "Try again"
                                    })
                                })
                            ]
                        })
                    }) : null
                ]
            })
        })
    });
}




var $acw62 = parcelRequire("acw62");



const $61f2e6d1e10dae2c$export$a6e25ba5f7be9e35 = ()=>{
    const { id: id } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const getProjectM = (0, $af10f25532815273$export$b8fc23a8b701aa67)((0, $21f88f1227598e15$export$637b60a42bb03f06));
    const [project, setProject] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        const fetchProject = async ()=>{
            try {
                if (!id) return;
                const projectId = parseInt(id);
                const project = await getProjectM(projectId);
                setProject(project);
            } catch (error) {
                console.error(error);
            }
        };
        fetchProject();
    }, []);
    if (!project) return null;
    const { videoAsset: { status: status, readyStatus: readyStatus } } = project;
    if (readyStatus !== null ? readyStatus === "READY" : status === "TRANSCRIPT_SAVED") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
        to: `/projects/${id}/edit`,
        replace: true
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
        to: `/projects/${id}/status`,
        replace: true
    });
};




/**
 * @license lucide-react v0.381.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $39f04136db3724b2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("LoaderCircle", [
    [
        "path",
        {
            d: "M21 12a9 9 0 1 1-6.219-8.56",
            key: "13zald"
        }
    ]
]);



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


var $1u0KT = parcelRequire("1u0KT");
var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


var $c78df6347432a4c1$var$__defProp = Object.defineProperty;
var $c78df6347432a4c1$var$__export = (target, all)=>{
    for(var name in all)$c78df6347432a4c1$var$__defProp(target, name, {
        get: all[name],
        enumerable: true,
        configurable: true,
        set: (newValue)=>all[name] = ()=>newValue
    });
};
if (typeof (0, $acw62.createContext) !== "function") {
    const err = [
        'Remotion requires React.createContext, but it is "undefined".',
        'If you are in a React Server Component, turn it into a client component by adding "use client" at the top of the file.',
        "",
        "Before:",
        '  import {useCurrentFrame} from "remotion";',
        "",
        "After:",
        '  "use client";',
        '  import {useCurrentFrame} from "remotion";'
    ];
    throw new Error(err.join("\n"));
}
var $c78df6347432a4c1$var$NativeLayersContext = (0, $acw62.createContext)({
    setClipRegion: ()=>{
        throw new Error("NativeLayers not set");
    },
    clipRegion: null
});
var $c78df6347432a4c1$var$NativeLayersProvider = ({ children: children })=>{
    const [clipRegion, setClipRegion] = (0, $acw62.useState)(null);
    const context = (0, $acw62.useMemo)(()=>{
        return {
            setClipRegion: setClipRegion,
            clipRegion: clipRegion
        };
    }, [
        clipRegion,
        setClipRegion
    ]);
    if (typeof window !== "undefined") (0, $acw62.useLayoutEffect)(()=>{
        window.remotion_getClipRegion = ()=>{
            return clipRegion;
        };
    }, [
        clipRegion,
        setClipRegion
    ]);
    return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$NativeLayersContext.Provider, {
        value: context,
        children: children
    });
};
// src/Clipper.tsx
var $c78df6347432a4c1$var$Clipper = ({ height: height, width: width, x: x, y: y })=>{
    const { setClipRegion: setClipRegion } = (0, $acw62.useContext)($c78df6347432a4c1$var$NativeLayersContext);
    (0, $acw62.useEffect)(()=>{
        setClipRegion((c)=>{
            if (c === "hide") throw new Error("Cannot render <Clipper>, because another <Null> is already rendered");
            if (c === null) return {
                height: height,
                width: width,
                x: x,
                y: y
            };
            throw new Error("Cannot render <Clipper>, because another component clipping the region was already rendered (most likely <Clipper>)");
        });
        return ()=>{
            setClipRegion(null);
        };
    }, [
        height,
        setClipRegion,
        width,
        x,
        y
    ]);
    return null;
};
// src/get-remotion-environment.ts
var $c78df6347432a4c1$var$getNodeEnvString = function() {
    return [
        "NOD",
        "E_EN",
        "V"
    ].join("");
};
var $c78df6347432a4c1$var$getEnvString = ()=>{
    return [
        "e",
        "nv"
    ].join("");
};
var $c78df6347432a4c1$export$2a36334a5203003d = ()=>{
    const isPlayer = typeof window !== "undefined" && window.remotion_isPlayer;
    const isRendering = typeof window !== "undefined" && typeof window.process !== "undefined" && typeof window.process.env !== "undefined" && (window.process[$c78df6347432a4c1$var$getEnvString()][$c78df6347432a4c1$var$getNodeEnvString()] === "test" || window.process[$c78df6347432a4c1$var$getEnvString()][$c78df6347432a4c1$var$getNodeEnvString()] === "production" && typeof window !== "undefined" && typeof window.remotion_puppeteerTimeout !== "undefined");
    const isStudio = typeof window !== "undefined" && window.remotion_isStudio;
    return {
        isStudio: isStudio,
        isRendering: isRendering,
        isPlayer: isPlayer
    };
};
// src/enable-sequence-stack-traces.ts
var $c78df6347432a4c1$var$originalCreateElement = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement;
var $c78df6347432a4c1$var$componentsToAddStacksTo = [];
var $c78df6347432a4c1$var$enableSequenceStackTraces = ()=>{
    if (!$c78df6347432a4c1$export$2a36334a5203003d().isStudio) return;
    const proxy = new Proxy($c78df6347432a4c1$var$originalCreateElement, {
        apply (target, thisArg, argArray) {
            if ($c78df6347432a4c1$var$componentsToAddStacksTo.includes(argArray[0])) {
                const [first, props, ...rest] = argArray;
                const newProps = {
                    ...props ?? {},
                    stack: new Error().stack
                };
                return Reflect.apply(target, thisArg, [
                    first,
                    newProps,
                    ...rest
                ]);
            }
            return Reflect.apply(target, thisArg, argArray);
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement = proxy;
};
var $c78df6347432a4c1$var$addSequenceStackTraces = (component)=>{
    $c78df6347432a4c1$var$componentsToAddStacksTo.push(component);
    $c78df6347432a4c1$var$enableSequenceStackTraces();
};
var $c78df6347432a4c1$var$IsPlayerContext = (0, $acw62.createContext)(false);
var $c78df6347432a4c1$var$IsPlayerContextProvider = ({ children: children })=>{
    return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$IsPlayerContext.Provider, {
        value: true,
        children: children
    });
};
var $c78df6347432a4c1$var$useIsPlayer = ()=>{
    return (0, $acw62.useContext)($c78df6347432a4c1$var$IsPlayerContext);
};
// src/truthy.ts
function $c78df6347432a4c1$var$truthy(value) {
    return Boolean(value);
}
// src/version.ts
var $c78df6347432a4c1$export$a4ad2735b021c132 = "4.0.200";
// src/multiple-versions-warning.ts
var $c78df6347432a4c1$var$checkMultipleRemotionVersions = ()=>{
    if (typeof globalThis === "undefined") return;
    const alreadyImported = globalThis.remotion_imported || typeof window !== "undefined" && window.remotion_imported;
    if (alreadyImported) {
        if (alreadyImported === $c78df6347432a4c1$export$a4ad2735b021c132) return;
        throw new TypeError(`\uD83D\uDEA8 Multiple versions of Remotion detected: ${[
            $c78df6347432a4c1$export$a4ad2735b021c132,
            typeof alreadyImported === "string" ? alreadyImported : "an older version"
        ].filter($c78df6347432a4c1$var$truthy).join(" and ")}. This will cause things to break in an unexpected way.\nCheck that all your Remotion packages are on the same version. If your dependencies depend on Remotion, make them peer dependencies. You can also run \`npx remotion versions\` from your terminal to see which versions are mismatching.`);
    }
    globalThis.remotion_imported = $c78df6347432a4c1$export$a4ad2735b021c132;
    if (typeof window !== "undefined") window.remotion_imported = $c78df6347432a4c1$export$a4ad2735b021c132;
};
var $c78df6347432a4c1$var$Null = ()=>{
    const { setClipRegion: setClipRegion } = (0, $acw62.useContext)($c78df6347432a4c1$var$NativeLayersContext);
    (0, $acw62.useEffect)(()=>{
        setClipRegion((c)=>{
            if (c === null) return "hide";
            if (c === "hide") return "hide";
            throw new Error("Cannot render <Null>, because another component clipping the region was already rendered (most likely <Clipper>)");
        });
        return ()=>{
            setClipRegion(null);
        };
    }, [
        setClipRegion
    ]);
    return null;
};
var $c78df6347432a4c1$var$AbsoluteFillRefForwarding = (props, ref)=>{
    const { style: style, ...other } = props;
    const actualStyle = (0, $acw62.useMemo)(()=>{
        return {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            ...style
        };
    }, [
        style
    ]);
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: ref,
        style: actualStyle,
        ...other
    });
};
var $c78df6347432a4c1$export$afbd5df19c967c53 = (0, $acw62.forwardRef)($c78df6347432a4c1$var$AbsoluteFillRefForwarding);
var $c78df6347432a4c1$var$SequenceContext = (0, $acw62.createContext)(null);
var $c78df6347432a4c1$var$SequenceManager = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    registerSequence: ()=>{
        throw new Error("SequenceManagerContext not initialized");
    },
    unregisterSequence: ()=>{
        throw new Error("SequenceManagerContext not initialized");
    },
    sequences: []
});
var $c78df6347432a4c1$var$SequenceVisibilityToggleContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    hidden: {},
    setHidden: ()=>{
        throw new Error("SequenceVisibilityToggle not initialized");
    }
});
var $c78df6347432a4c1$var$SequenceManagerProvider = ({ children: children })=>{
    const [sequences, setSequences] = (0, $acw62.useState)([]);
    const [hidden, setHidden] = (0, $acw62.useState)({});
    const registerSequence = (0, $acw62.useCallback)((seq)=>{
        setSequences((seqs)=>{
            return [
                ...seqs,
                seq
            ];
        });
    }, []);
    const unregisterSequence = (0, $acw62.useCallback)((seq)=>{
        setSequences((seqs)=>seqs.filter((s)=>s.id !== seq));
    }, []);
    const sequenceContext = (0, $acw62.useMemo)(()=>{
        return {
            registerSequence: registerSequence,
            sequences: sequences,
            unregisterSequence: unregisterSequence
        };
    }, [
        registerSequence,
        sequences,
        unregisterSequence
    ]);
    const hiddenContext = (0, $acw62.useMemo)(()=>{
        return {
            hidden: hidden,
            setHidden: setHidden
        };
    }, [
        hidden
    ]);
    return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$SequenceManager.Provider, {
        value: sequenceContext,
        children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$SequenceVisibilityToggleContext.Provider, {
            value: hiddenContext,
            children: children
        })
    });
};
var $c78df6347432a4c1$var$NonceContext = (0, $acw62.createContext)({
    getNonce: ()=>0,
    fastRefreshes: 0
});
var $c78df6347432a4c1$var$useNonce = ()=>{
    const context = (0, $acw62.useContext)($c78df6347432a4c1$var$NonceContext);
    const [nonce, setNonce] = (0, $acw62.useState)(()=>context.getNonce());
    const lastContext = (0, $acw62.useRef)(context);
    (0, $acw62.useEffect)(()=>{
        if (lastContext.current === context) return;
        lastContext.current = context;
        setNonce(context.getNonce);
    }, [
        context
    ]);
    return nonce;
};
// src/timeline-position-state.ts
var $c78df6347432a4c1$var$exports_timeline_position_state = {};
$c78df6347432a4c1$var$__export($c78df6347432a4c1$var$exports_timeline_position_state, {
    useTimelineSetFrame: ()=>$c78df6347432a4c1$var$useTimelineSetFrame,
    useTimelinePosition: ()=>$c78df6347432a4c1$var$useTimelinePosition,
    usePlayingState: ()=>$c78df6347432a4c1$var$usePlayingState,
    persistCurrentFrame: ()=>$c78df6347432a4c1$var$persistCurrentFrame,
    getInitialFrameState: ()=>$c78df6347432a4c1$var$getInitialFrameState,
    getFrameForComposition: ()=>$c78df6347432a4c1$var$getFrameForComposition,
    TimelineContext: ()=>$c78df6347432a4c1$var$TimelineContext,
    SetTimelineContext: ()=>$c78df6347432a4c1$var$SetTimelineContext
});
var $c78df6347432a4c1$var$CompositionManager = (0, $acw62.createContext)({
    compositions: [],
    registerComposition: ()=>{
        return;
    },
    unregisterComposition: ()=>{
        return;
    },
    registerFolder: ()=>{
        return;
    },
    unregisterFolder: ()=>{
        return;
    },
    setCurrentCompositionMetadata: ()=>{
        return;
    },
    updateCompositionDefaultProps: ()=>{
        return;
    },
    folders: [],
    currentCompositionMetadata: null,
    canvasContent: null,
    setCanvasContent: ()=>{
        return;
    }
});
var $c78df6347432a4c1$var$EditorPropsContext = (0, $acw62.createContext)({
    props: {},
    updateProps: ()=>{
        throw new Error("Not implemented");
    },
    resetUnsaved: ()=>{
        throw new Error("Not implemented");
    }
});
var $c78df6347432a4c1$var$editorPropsProviderRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef();
var $c78df6347432a4c1$var$EditorPropsProvider = ({ children: children })=>{
    const [props, setProps] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const updateProps = (0, $acw62.useCallback)(({ defaultProps: defaultProps, id: id, newProps: newProps })=>{
        setProps((prev)=>{
            return {
                ...prev,
                [id]: typeof newProps === "function" ? newProps(prev[id] ?? defaultProps) : newProps
            };
        });
    }, []);
    const resetUnsaved = (0, $acw62.useCallback)(()=>{
        setProps({});
    }, []);
    (0, $acw62.useImperativeHandle)($c78df6347432a4c1$var$editorPropsProviderRef, ()=>{
        return {
            getProps: ()=>props,
            setProps: setProps
        };
    }, [
        props
    ]);
    const ctx = (0, $acw62.useMemo)(()=>{
        return {
            props: props,
            updateProps: updateProps,
            resetUnsaved: resetUnsaved
        };
    }, [
        props,
        resetUnsaved,
        updateProps
    ]);
    return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$EditorPropsContext.Provider, {
        value: ctx,
        children: children
    });
};
// src/static-file.ts
var $c78df6347432a4c1$var$problematicCharacters = {
    "%3A": ":",
    "%2F": "/",
    "%3F": "?",
    "%23": "#",
    "%5B": "[",
    "%5D": "]",
    "%40": "@",
    "%21": "!",
    "%24": "$",
    "%26": "&",
    "%27": "'",
    "%28": "(",
    "%29": ")",
    "%2A": "*",
    "%2B": "+",
    "%2C": ",",
    "%3B": ";"
};
var $c78df6347432a4c1$var$didWarn = {};
var $c78df6347432a4c1$var$warnOnce = (message)=>{
    if ($c78df6347432a4c1$var$didWarn[message]) return;
    console.warn(message);
    $c78df6347432a4c1$var$didWarn[message] = true;
};
var $c78df6347432a4c1$var$includesHexOfUnsafeChar = (path)=>{
    for (const key of Object.keys($c78df6347432a4c1$var$problematicCharacters)){
        if (path.includes(key)) return {
            containsHex: true,
            hexCode: key
        };
    }
    return {
        containsHex: false
    };
};
var $c78df6347432a4c1$var$trimLeadingSlash = (path)=>{
    if (path.startsWith("/")) return $c78df6347432a4c1$var$trimLeadingSlash(path.substring(1));
    return path;
};
var $c78df6347432a4c1$var$inner = (path)=>{
    if (typeof window !== "undefined" && window.remotion_staticBase) {
        if (path.startsWith(window.remotion_staticBase)) throw new Error(`The value "${path}" is already prefixed with the static base ${window.remotion_staticBase}. You don't need to call staticFile() on it.`);
        return `${window.remotion_staticBase}/${$c78df6347432a4c1$var$trimLeadingSlash(path)}`;
    }
    return `/${$c78df6347432a4c1$var$trimLeadingSlash(path)}`;
};
var $c78df6347432a4c1$var$encodeBySplitting = (path)=>{
    const splitBySlash = path.split("/");
    const encodedArray = splitBySlash.map((element)=>{
        return encodeURIComponent(element);
    });
    const merged = encodedArray.join("/");
    return merged;
};
var $c78df6347432a4c1$export$6b34865dc09074f2 = (path)=>{
    if (path.startsWith("http://") || path.startsWith("https://")) throw new TypeError(`staticFile() does not support remote URLs - got "${path}". Instead, pass the URL without wrapping it in staticFile(). See: https://remotion.dev/docs/staticfile-remote-urls`);
    if (path.startsWith("..") || path.startsWith("./")) throw new TypeError(`staticFile() does not support relative paths - got "${path}". Instead, pass the name of a file that is inside the public/ folder. See: https://remotion.dev/docs/staticfile-relative-paths`);
    if (path.startsWith("/Users") || path.startsWith("/home") || path.startsWith("/tmp") || path.startsWith("/etc") || path.startsWith("/opt") || path.startsWith("/var") || path.startsWith("C:") || path.startsWith("D:") || path.startsWith("E:")) throw new TypeError(`staticFile() does not support absolute paths - got "${path}". Instead, pass the name of a file that is inside the public/ folder. See: https://remotion.dev/docs/staticfile-relative-paths`);
    if (path.startsWith("public/")) throw new TypeError(`Do not include the public/ prefix when using staticFile() - got "${path}". See: https://remotion.dev/docs/staticfile-relative-paths`);
    const includesHex = $c78df6347432a4c1$var$includesHexOfUnsafeChar(path);
    if (includesHex.containsHex) $c78df6347432a4c1$var$warnOnce(`WARNING: You seem to pass an already encoded path (path contains ${includesHex.hexCode}). Since Remotion 4.0, the encoding is done by staticFile() itself. You may want to remove a encodeURIComponent() wrapping.`);
    const preprocessed = $c78df6347432a4c1$var$encodeBySplitting(path);
    const preparsed = $c78df6347432a4c1$var$inner(preprocessed);
    if (!preparsed.startsWith("/")) return `/${preparsed}`;
    return preparsed;
};
// src/input-props-serialization.ts
var $c78df6347432a4c1$var$DATE_TOKEN = "remotion-date:";
var $c78df6347432a4c1$var$FILE_TOKEN = "remotion-file:";
var $c78df6347432a4c1$var$serializeJSONWithDate = ({ data: data, indent: indent, staticBase: staticBase })=>{
    let customDateUsed = false;
    let customFileUsed = false;
    let mapUsed = false;
    let setUsed = false;
    try {
        const serializedString = JSON.stringify(data, function(key, value) {
            const item = this[key];
            if (item instanceof Date) {
                customDateUsed = true;
                return `${$c78df6347432a4c1$var$DATE_TOKEN}${item.toISOString()}`;
            }
            if (item instanceof Map) {
                mapUsed = true;
                return value;
            }
            if (item instanceof Set) {
                setUsed = true;
                return value;
            }
            if (typeof item === "string" && staticBase !== null && item.startsWith(staticBase)) {
                customFileUsed = true;
                return `${$c78df6347432a4c1$var$FILE_TOKEN}${item.replace(staticBase + "/", "")}`;
            }
            return value;
        }, indent);
        return {
            serializedString: serializedString,
            customDateUsed: customDateUsed,
            customFileUsed: customFileUsed,
            mapUsed: mapUsed,
            setUsed: setUsed
        };
    } catch (err) {
        throw new Error("Could not serialize the passed input props to JSON: " + err.message);
    }
};
var $c78df6347432a4c1$var$deserializeJSONWithCustomFields = (data)=>{
    return JSON.parse(data, (_, value)=>{
        if (typeof value === "string" && value.startsWith($c78df6347432a4c1$var$DATE_TOKEN)) return new Date(value.replace($c78df6347432a4c1$var$DATE_TOKEN, ""));
        if (typeof value === "string" && value.startsWith($c78df6347432a4c1$var$FILE_TOKEN)) return $c78df6347432a4c1$export$6b34865dc09074f2(value.replace($c78df6347432a4c1$var$FILE_TOKEN, ""));
        return value;
    });
};
var $c78df6347432a4c1$var$serializeThenDeserializeInStudio = (props)=>{
    if ($c78df6347432a4c1$export$2a36334a5203003d().isStudio) return $c78df6347432a4c1$var$deserializeJSONWithCustomFields($c78df6347432a4c1$var$serializeJSONWithDate({
        data: props,
        indent: 2,
        staticBase: window.remotion_staticBase
    }).serializedString);
    return props;
};
// src/config/input-props.ts
var $c78df6347432a4c1$var$didWarnSSRImport = false;
var $c78df6347432a4c1$var$warnOnceSSRImport = ()=>{
    if ($c78df6347432a4c1$var$didWarnSSRImport) return;
    $c78df6347432a4c1$var$didWarnSSRImport = true;
    console.warn("Called `getInputProps()` on the server. This function is not available server-side and has returned an empty object.");
    console.warn("To hide this warning, don't call this function on the server:");
    console.warn("  typeof window === 'undefined' ? {} : getInputProps()");
};
var $c78df6347432a4c1$export$b0ce38999cfb8c02 = ()=>{
    if (typeof window === "undefined") {
        $c78df6347432a4c1$var$warnOnceSSRImport();
        return {};
    }
    if ($c78df6347432a4c1$export$2a36334a5203003d().isPlayer) throw new Error("You cannot call `getInputProps()` from a <Player>. Instead, the props are available as React props from component that you passed as `component` prop.");
    const param = window.remotion_inputProps;
    if (!param) return {};
    const parsed = $c78df6347432a4c1$var$deserializeJSONWithCustomFields(param);
    return parsed;
};
// src/codec.ts
var $c78df6347432a4c1$var$validCodecs = [
    "h264",
    "h265",
    "vp8",
    "vp9",
    "mp3",
    "aac",
    "wav",
    "prores",
    "h264-mkv",
    "h264-ts",
    "gif"
];
// src/validation/validate-default-codec.ts
function $c78df6347432a4c1$var$validateDefaultCodec(defaultCodec, location) {
    if (typeof defaultCodec === "undefined") return;
    if (typeof defaultCodec !== "string") throw new TypeError(`The "defaultCodec" prop ${location} must be a string, but you passed a value of type ${typeof defaultCodec}.`);
    if (!$c78df6347432a4c1$var$validCodecs.includes(defaultCodec)) throw new Error(`The "defaultCodec" prop ${location} must be one of ${$c78df6347432a4c1$var$validCodecs.join(", ")}, but you passed ${defaultCodec}.`);
}
// src/validation/validate-dimensions.ts
function $c78df6347432a4c1$var$validateDimension(amount, nameOfProp, location) {
    if (typeof amount !== "number") throw new Error(`The "${nameOfProp}" prop ${location} must be a number, but you passed a value of type ${typeof amount}`);
    if (isNaN(amount)) throw new TypeError(`The "${nameOfProp}" prop ${location} must not be NaN, but is NaN.`);
    if (!Number.isFinite(amount)) throw new TypeError(`The "${nameOfProp}" prop ${location} must be finite, but is ${amount}.`);
    if (amount % 1 !== 0) throw new TypeError(`The "${nameOfProp}" prop ${location} must be an integer, but is ${amount}.`);
    if (amount <= 0) throw new TypeError(`The "${nameOfProp}" prop ${location} must be positive, but got ${amount}.`);
}
// src/validation/validate-duration-in-frames.ts
function $c78df6347432a4c1$var$validateDurationInFrames(durationInFrames, options) {
    const { allowFloats: allowFloats, component: component } = options;
    if (typeof durationInFrames === "undefined") throw new Error(`The "durationInFrames" prop ${component} is missing.`);
    if (typeof durationInFrames !== "number") throw new Error(`The "durationInFrames" prop ${component} must be a number, but you passed a value of type ${typeof durationInFrames}`);
    if (durationInFrames <= 0) throw new TypeError(`The "durationInFrames" prop ${component} must be positive, but got ${durationInFrames}.`);
    if (!allowFloats && durationInFrames % 1 !== 0) throw new TypeError(`The "durationInFrames" prop ${component} must be an integer, but got ${durationInFrames}.`);
    if (!Number.isFinite(durationInFrames)) throw new TypeError(`The "durationInFrames" prop ${component} must be finite, but got ${durationInFrames}.`);
}
// src/validation/validate-fps.ts
function $c78df6347432a4c1$var$validateFps(fps, location, isGif) {
    if (typeof fps !== "number") throw new Error(`"fps" must be a number, but you passed a value of type ${typeof fps} ${location}`);
    if (!Number.isFinite(fps)) throw new Error(`"fps" must be a finite, but you passed ${fps} ${location}`);
    if (isNaN(fps)) throw new Error(`"fps" must not be NaN, but got ${fps} ${location}`);
    if (fps <= 0) throw new TypeError(`"fps" must be positive, but got ${fps} ${location}`);
    if (isGif && fps > 50) throw new TypeError(`The FPS for a GIF cannot be higher than 50. Use the --every-nth-frame option to lower the FPS: https://remotion.dev/docs/render-as-gif`);
}
// src/resolve-video-config.ts
var $c78df6347432a4c1$var$validateCalculated = ({ calculated: calculated, compositionId: compositionId, compositionFps: compositionFps, compositionHeight: compositionHeight, compositionWidth: compositionWidth, compositionDurationInFrames: compositionDurationInFrames })=>{
    const calculateMetadataErrorLocation = `calculated by calculateMetadata() for the composition "${compositionId}"`;
    const defaultErrorLocation = `of the "<Composition />" component with the id "${compositionId}"`;
    const width = calculated?.width ?? compositionWidth ?? undefined;
    $c78df6347432a4c1$var$validateDimension(width, "width", calculated?.width ? calculateMetadataErrorLocation : defaultErrorLocation);
    const height = calculated?.height ?? compositionHeight ?? undefined;
    $c78df6347432a4c1$var$validateDimension(height, "height", calculated?.height ? calculateMetadataErrorLocation : defaultErrorLocation);
    const fps = calculated?.fps ?? compositionFps ?? null;
    $c78df6347432a4c1$var$validateFps(fps, calculated?.fps ? calculateMetadataErrorLocation : defaultErrorLocation, false);
    const durationInFrames = calculated?.durationInFrames ?? compositionDurationInFrames ?? null;
    $c78df6347432a4c1$var$validateDurationInFrames(durationInFrames, {
        allowFloats: false,
        component: `of the "<Composition />" component with the id "${compositionId}"`
    });
    const defaultCodec = calculated?.defaultCodec;
    $c78df6347432a4c1$var$validateDefaultCodec(defaultCodec, calculateMetadataErrorLocation);
    return {
        width: width,
        height: height,
        fps: fps,
        durationInFrames: durationInFrames,
        defaultCodec: defaultCodec
    };
};
var $c78df6347432a4c1$var$resolveVideoConfig = ({ calculateMetadata: calculateMetadata, signal: signal, defaultProps: defaultProps, originalProps: originalProps, compositionId: compositionId, compositionDurationInFrames: compositionDurationInFrames, compositionFps: compositionFps, compositionHeight: compositionHeight, compositionWidth: compositionWidth })=>{
    const calculatedProm = calculateMetadata ? calculateMetadata({
        defaultProps: defaultProps,
        props: originalProps,
        abortSignal: signal,
        compositionId: compositionId
    }) : null;
    if (calculatedProm !== null && typeof calculatedProm === "object" && "then" in calculatedProm) return calculatedProm.then((c)=>{
        const { height: height, width: width, durationInFrames: durationInFrames, fps: fps, defaultCodec: defaultCodec } = $c78df6347432a4c1$var$validateCalculated({
            calculated: c,
            compositionDurationInFrames: compositionDurationInFrames,
            compositionFps: compositionFps,
            compositionHeight: compositionHeight,
            compositionWidth: compositionWidth,
            compositionId: compositionId
        });
        return {
            width: width,
            height: height,
            fps: fps,
            durationInFrames: durationInFrames,
            id: compositionId,
            defaultProps: $c78df6347432a4c1$var$serializeThenDeserializeInStudio(defaultProps),
            props: $c78df6347432a4c1$var$serializeThenDeserializeInStudio(c.props ?? originalProps),
            defaultCodec: defaultCodec ?? null
        };
    });
    const data = $c78df6347432a4c1$var$validateCalculated({
        calculated: calculatedProm,
        compositionDurationInFrames: compositionDurationInFrames,
        compositionFps: compositionFps,
        compositionHeight: compositionHeight,
        compositionWidth: compositionWidth,
        compositionId: compositionId
    });
    if (calculatedProm === null) return {
        ...data,
        id: compositionId,
        defaultProps: $c78df6347432a4c1$var$serializeThenDeserializeInStudio(defaultProps ?? {}),
        props: $c78df6347432a4c1$var$serializeThenDeserializeInStudio(originalProps),
        defaultCodec: null
    };
    return {
        ...data,
        id: compositionId,
        defaultProps: $c78df6347432a4c1$var$serializeThenDeserializeInStudio(defaultProps ?? {}),
        props: $c78df6347432a4c1$var$serializeThenDeserializeInStudio(calculatedProm.props ?? originalProps),
        defaultCodec: calculatedProm.defaultCodec ?? null
    };
};
var $c78df6347432a4c1$var$resolveVideoConfigOrCatch = (params)=>{
    try {
        const promiseOrReturnValue = $c78df6347432a4c1$var$resolveVideoConfig(params);
        return {
            type: "success",
            result: promiseOrReturnValue
        };
    } catch (err) {
        return {
            type: "error",
            error: err
        };
    }
};
var $c78df6347432a4c1$var$ResolveCompositionContext = (0, $acw62.createContext)(null);
var $c78df6347432a4c1$var$resolveCompositionsRef = (0, $acw62.createRef)();
var $c78df6347432a4c1$var$needsResolution = (composition)=>{
    return Boolean(composition.calculateMetadata);
};
var $c78df6347432a4c1$var$PROPS_UPDATED_EXTERNALLY = "remotion.propsUpdatedExternally";
var $c78df6347432a4c1$var$ResolveCompositionConfig = ({ children: children })=>{
    const [currentRenderModalComposition, setCurrentRenderModalComposition] = (0, $acw62.useState)(null);
    const { compositions: compositions, canvasContent: canvasContent, currentCompositionMetadata: currentCompositionMetadata } = (0, $acw62.useContext)($c78df6347432a4c1$var$CompositionManager);
    const { fastRefreshes: fastRefreshes } = (0, $acw62.useContext)($c78df6347432a4c1$var$NonceContext);
    const selectedComposition = (0, $acw62.useMemo)(()=>{
        return compositions.find((c)=>canvasContent && canvasContent.type === "composition" && canvasContent.compositionId === c.id);
    }, [
        canvasContent,
        compositions
    ]);
    const renderModalComposition = compositions.find((c)=>c.id === currentRenderModalComposition);
    const { props: allEditorProps } = (0, $acw62.useContext)($c78df6347432a4c1$var$EditorPropsContext);
    const inputProps = (0, $acw62.useMemo)(()=>{
        return typeof window === "undefined" || $c78df6347432a4c1$export$2a36334a5203003d().isPlayer ? {} : $c78df6347432a4c1$export$b0ce38999cfb8c02() ?? {};
    }, []);
    const [resolvedConfigs, setResolvedConfigs] = (0, $acw62.useState)({});
    const selectedEditorProps = (0, $acw62.useMemo)(()=>{
        return selectedComposition ? allEditorProps[selectedComposition.id] ?? {} : {};
    }, [
        allEditorProps,
        selectedComposition
    ]);
    const renderModalProps = (0, $acw62.useMemo)(()=>{
        return renderModalComposition ? allEditorProps[renderModalComposition.id] ?? {} : {};
    }, [
        allEditorProps,
        renderModalComposition
    ]);
    const hasResolution = Boolean(currentCompositionMetadata);
    const doResolution = (0, $acw62.useCallback)(({ calculateMetadata: calculateMetadata, combinedProps: combinedProps, compositionDurationInFrames: compositionDurationInFrames, compositionFps: compositionFps, compositionHeight: compositionHeight, compositionId: compositionId, compositionWidth: compositionWidth, defaultProps: defaultProps })=>{
        const controller = new AbortController;
        if (hasResolution) return controller;
        const { signal: signal } = controller;
        const result = $c78df6347432a4c1$var$resolveVideoConfigOrCatch({
            compositionId: compositionId,
            calculateMetadata: calculateMetadata,
            originalProps: combinedProps,
            signal: signal,
            defaultProps: defaultProps,
            compositionDurationInFrames: compositionDurationInFrames,
            compositionFps: compositionFps,
            compositionHeight: compositionHeight,
            compositionWidth: compositionWidth
        });
        if (result.type === "error") {
            setResolvedConfigs((r)=>({
                    ...r,
                    [compositionId]: {
                        type: "error",
                        error: result.error
                    }
                }));
            return controller;
        }
        const promOrNot = result.result;
        if (typeof promOrNot === "object" && "then" in promOrNot) {
            setResolvedConfigs((r)=>{
                const prev = r[compositionId];
                if (prev?.type === "success" || prev?.type === "success-and-refreshing") return {
                    ...r,
                    [compositionId]: {
                        type: "success-and-refreshing",
                        result: prev.result
                    }
                };
                return {
                    ...r,
                    [compositionId]: {
                        type: "loading"
                    }
                };
            });
            promOrNot.then((c)=>{
                if (controller.signal.aborted) return;
                setResolvedConfigs((r)=>({
                        ...r,
                        [compositionId]: {
                            type: "success",
                            result: c
                        }
                    }));
            }).catch((err)=>{
                if (controller.signal.aborted) return;
                setResolvedConfigs((r)=>({
                        ...r,
                        [compositionId]: {
                            type: "error",
                            error: err
                        }
                    }));
            });
        } else setResolvedConfigs((r)=>({
                ...r,
                [compositionId]: {
                    type: "success",
                    result: promOrNot
                }
            }));
        return controller;
    }, [
        hasResolution
    ]);
    const currentComposition = canvasContent?.type === "composition" ? canvasContent.compositionId : null;
    (0, $acw62.useImperativeHandle)($c78df6347432a4c1$var$resolveCompositionsRef, ()=>{
        return {
            setCurrentRenderModalComposition: (id)=>{
                setCurrentRenderModalComposition(id);
            },
            reloadCurrentlySelectedComposition: ()=>{
                if (!currentComposition) return;
                const composition = compositions.find((c)=>c.id === currentComposition);
                if (!composition) throw new Error(`Could not find composition with id ${currentComposition}`);
                const editorProps = allEditorProps[currentComposition] ?? {};
                const defaultProps = {
                    ...composition.defaultProps ?? {},
                    ...editorProps ?? {}
                };
                const props = {
                    ...defaultProps,
                    ...inputProps ?? {}
                };
                doResolution({
                    defaultProps: defaultProps,
                    calculateMetadata: composition.calculateMetadata,
                    combinedProps: props,
                    compositionDurationInFrames: composition.durationInFrames ?? null,
                    compositionFps: composition.fps ?? null,
                    compositionHeight: composition.height ?? null,
                    compositionWidth: composition.width ?? null,
                    compositionId: composition.id
                });
            }
        };
    }, [
        allEditorProps,
        compositions,
        currentComposition,
        doResolution,
        inputProps
    ]);
    const isTheSame = selectedComposition?.id === renderModalComposition?.id;
    const currentDefaultProps = (0, $acw62.useMemo)(()=>{
        return {
            ...selectedComposition?.defaultProps ?? {},
            ...selectedEditorProps ?? {}
        };
    }, [
        selectedComposition?.defaultProps,
        selectedEditorProps
    ]);
    const originalProps = (0, $acw62.useMemo)(()=>{
        return {
            ...currentDefaultProps,
            ...inputProps ?? {}
        };
    }, [
        currentDefaultProps,
        inputProps
    ]);
    const canResolve = selectedComposition && $c78df6347432a4c1$var$needsResolution(selectedComposition);
    const shouldIgnoreUpdate = typeof window !== "undefined" && window.remotion_ignoreFastRefreshUpdate && fastRefreshes <= window.remotion_ignoreFastRefreshUpdate;
    (0, $acw62.useEffect)(()=>{
        if (shouldIgnoreUpdate) return;
        if (canResolve) {
            const controller = doResolution({
                calculateMetadata: selectedComposition.calculateMetadata,
                combinedProps: originalProps,
                compositionDurationInFrames: selectedComposition.durationInFrames ?? null,
                compositionFps: selectedComposition.fps ?? null,
                compositionHeight: selectedComposition.height ?? null,
                compositionWidth: selectedComposition.width ?? null,
                defaultProps: currentDefaultProps,
                compositionId: selectedComposition.id
            });
            return ()=>{
                controller.abort();
            };
        }
    }, [
        canResolve,
        currentDefaultProps,
        doResolution,
        originalProps,
        selectedComposition?.calculateMetadata,
        selectedComposition?.durationInFrames,
        selectedComposition?.fps,
        selectedComposition?.height,
        selectedComposition?.id,
        selectedComposition?.width,
        shouldIgnoreUpdate
    ]);
    (0, $acw62.useEffect)(()=>{
        if (shouldIgnoreUpdate) return;
        window.dispatchEvent(new CustomEvent("remotion.propsUpdatedExternally"));
    }, [
        fastRefreshes
    ]);
    (0, $acw62.useEffect)(()=>{
        if (renderModalComposition && !isTheSame) {
            const combinedProps = {
                ...renderModalComposition.defaultProps ?? {},
                ...renderModalProps ?? {},
                ...inputProps ?? {}
            };
            const controller = doResolution({
                calculateMetadata: renderModalComposition.calculateMetadata,
                compositionDurationInFrames: renderModalComposition.durationInFrames ?? null,
                compositionFps: renderModalComposition.fps ?? null,
                compositionHeight: renderModalComposition.height ?? null,
                compositionId: renderModalComposition.id,
                compositionWidth: renderModalComposition.width ?? null,
                defaultProps: currentDefaultProps,
                combinedProps: combinedProps
            });
            return ()=>{
                controller.abort();
            };
        }
    }, [
        currentDefaultProps,
        doResolution,
        inputProps,
        isTheSame,
        renderModalComposition,
        renderModalProps
    ]);
    const resolvedConfigsIncludingStaticOnes = (0, $acw62.useMemo)(()=>{
        const staticComps = compositions.filter((c)=>{
            return c.calculateMetadata === null;
        });
        return {
            ...resolvedConfigs,
            ...staticComps.reduce((acc, curr)=>{
                return {
                    ...acc,
                    [curr.id]: {
                        type: "success",
                        result: {
                            ...curr,
                            defaultProps: curr.defaultProps ?? {}
                        }
                    }
                };
            }, {})
        };
    }, [
        compositions,
        resolvedConfigs
    ]);
    return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$ResolveCompositionContext.Provider, {
        value: resolvedConfigsIncludingStaticOnes,
        children: children
    });
};
var $c78df6347432a4c1$var$useResolvedVideoConfig = (preferredCompositionId)=>{
    const context = (0, $acw62.useContext)($c78df6347432a4c1$var$ResolveCompositionContext);
    const { props: allEditorProps } = (0, $acw62.useContext)($c78df6347432a4c1$var$EditorPropsContext);
    const { compositions: compositions, canvasContent: canvasContent, currentCompositionMetadata: currentCompositionMetadata } = (0, $acw62.useContext)($c78df6347432a4c1$var$CompositionManager);
    const currentComposition = canvasContent?.type === "composition" ? canvasContent.compositionId : null;
    const compositionId = preferredCompositionId ?? currentComposition;
    const composition = compositions.find((c)=>c.id === compositionId);
    const selectedEditorProps = (0, $acw62.useMemo)(()=>{
        return composition ? allEditorProps[composition.id] ?? {} : {};
    }, [
        allEditorProps,
        composition
    ]);
    return (0, $acw62.useMemo)(()=>{
        if (!composition) return null;
        if (currentCompositionMetadata) return {
            type: "success",
            result: {
                ...currentCompositionMetadata,
                id: composition.id,
                props: currentCompositionMetadata.props,
                defaultProps: composition.defaultProps ?? {},
                defaultCodec: currentCompositionMetadata.defaultCodec
            }
        };
        if (!$c78df6347432a4c1$var$needsResolution(composition)) {
            $c78df6347432a4c1$var$validateDurationInFrames(composition.durationInFrames, {
                allowFloats: false,
                component: `in <Composition id="${composition.id}">`
            });
            $c78df6347432a4c1$var$validateFps(composition.fps, `in <Composition id="${composition.id}">`, false);
            $c78df6347432a4c1$var$validateDimension(composition.width, "width", `in <Composition id="${composition.id}">`);
            $c78df6347432a4c1$var$validateDimension(composition.height, "height", `in <Composition id="${composition.id}">`);
            return {
                type: "success",
                result: {
                    width: composition.width,
                    height: composition.height,
                    fps: composition.fps,
                    id: composition.id,
                    durationInFrames: composition.durationInFrames,
                    defaultProps: composition.defaultProps ?? {},
                    props: {
                        ...composition.defaultProps ?? {},
                        ...selectedEditorProps ?? {},
                        ...typeof window === "undefined" || $c78df6347432a4c1$export$2a36334a5203003d().isPlayer ? {} : $c78df6347432a4c1$export$b0ce38999cfb8c02() ?? {}
                    },
                    defaultCodec: null
                }
            };
        }
        if (!context[composition.id]) return null;
        return context[composition.id];
    }, [
        composition,
        context,
        currentCompositionMetadata,
        selectedEditorProps
    ]);
};
// src/use-video.ts
var $c78df6347432a4c1$var$useVideo = ()=>{
    const { canvasContent: canvasContent, compositions: compositions, currentCompositionMetadata: currentCompositionMetadata } = (0, $acw62.useContext)($c78df6347432a4c1$var$CompositionManager);
    const selected = compositions.find((c)=>{
        return canvasContent?.type === "composition" && c.id === canvasContent.compositionId;
    });
    const resolved = $c78df6347432a4c1$var$useResolvedVideoConfig(selected?.id ?? null);
    return (0, $acw62.useMemo)(()=>{
        if (!resolved) return null;
        if (resolved.type === "error") return null;
        if (resolved.type === "loading") return null;
        if (!selected) return null;
        return {
            ...resolved.result,
            defaultProps: selected.defaultProps ?? {},
            id: selected.id,
            ...currentCompositionMetadata ?? {},
            component: selected.component
        };
    }, [
        currentCompositionMetadata,
        resolved,
        selected
    ]);
};
// src/timeline-position-state.ts
var $c78df6347432a4c1$var$TimelineContext = (0, $acw62.createContext)({
    frame: {},
    playing: false,
    playbackRate: 1,
    rootId: "",
    imperativePlaying: {
        current: false
    },
    setPlaybackRate: ()=>{
        throw new Error("default");
    },
    audioAndVideoTags: {
        current: []
    }
});
var $c78df6347432a4c1$var$SetTimelineContext = (0, $acw62.createContext)({
    setFrame: ()=>{
        throw new Error("default");
    },
    setPlaying: ()=>{
        throw new Error("default");
    }
});
var $c78df6347432a4c1$var$makeKey = ()=>{
    return `remotion.time-all`;
};
var $c78df6347432a4c1$var$persistCurrentFrame = (time)=>{
    localStorage.setItem($c78df6347432a4c1$var$makeKey(), JSON.stringify(time));
};
var $c78df6347432a4c1$var$getInitialFrameState = ()=>{
    const item = localStorage.getItem($c78df6347432a4c1$var$makeKey()) ?? "{}";
    const obj = JSON.parse(item);
    return obj;
};
var $c78df6347432a4c1$var$getFrameForComposition = (composition)=>{
    const item = localStorage.getItem($c78df6347432a4c1$var$makeKey()) ?? "{}";
    const obj = JSON.parse(item);
    if (obj[composition] !== undefined) return Number(obj[composition]);
    if (typeof window === "undefined") return 0;
    return window.remotion_initialFrame ?? 0;
};
var $c78df6347432a4c1$var$useTimelinePosition = ()=>{
    const videoConfig = $c78df6347432a4c1$var$useVideo();
    const state = (0, $acw62.useContext)($c78df6347432a4c1$var$TimelineContext);
    if (!videoConfig) return typeof window === "undefined" ? 0 : window.remotion_initialFrame ?? 0;
    const unclamped = state.frame[videoConfig.id] ?? ($c78df6347432a4c1$export$2a36334a5203003d().isPlayer ? 0 : $c78df6347432a4c1$var$getFrameForComposition(videoConfig.id));
    return Math.min(videoConfig.durationInFrames - 1, unclamped);
};
var $c78df6347432a4c1$var$useTimelineSetFrame = ()=>{
    const { setFrame: setFrame } = (0, $acw62.useContext)($c78df6347432a4c1$var$SetTimelineContext);
    return setFrame;
};
var $c78df6347432a4c1$var$usePlayingState = ()=>{
    const { playing: playing, imperativePlaying: imperativePlaying } = (0, $acw62.useContext)($c78df6347432a4c1$var$TimelineContext);
    const { setPlaying: setPlaying } = (0, $acw62.useContext)($c78df6347432a4c1$var$SetTimelineContext);
    return (0, $acw62.useMemo)(()=>[
            playing,
            setPlaying,
            imperativePlaying
        ], [
        imperativePlaying,
        playing,
        setPlaying
    ]);
};
var $c78df6347432a4c1$var$CanUseRemotionHooks = (0, $acw62.createContext)(false);
var $c78df6347432a4c1$var$CanUseRemotionHooksProvider = ({ children: children })=>{
    return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$CanUseRemotionHooks.Provider, {
        value: true,
        children: children
    });
};
var $c78df6347432a4c1$var$useUnsafeVideoConfig = ()=>{
    const context = (0, $acw62.useContext)($c78df6347432a4c1$var$SequenceContext);
    const ctxWidth = context?.width ?? null;
    const ctxHeight = context?.height ?? null;
    const ctxDuration = context?.durationInFrames ?? null;
    const video = $c78df6347432a4c1$var$useVideo();
    return (0, $acw62.useMemo)(()=>{
        if (!video) return null;
        const { id: id, durationInFrames: durationInFrames, fps: fps, height: height, width: width, defaultProps: defaultProps, props: props, defaultCodec: defaultCodec } = video;
        return {
            id: id,
            width: ctxWidth ?? width,
            height: ctxHeight ?? height,
            fps: fps,
            durationInFrames: ctxDuration ?? durationInFrames,
            defaultProps: defaultProps,
            props: props,
            defaultCodec: defaultCodec
        };
    }, [
        ctxDuration,
        ctxHeight,
        ctxWidth,
        video
    ]);
};
// src/use-video-config.ts
var $c78df6347432a4c1$export$da01606c8b81c2a0 = ()=>{
    const videoConfig = $c78df6347432a4c1$var$useUnsafeVideoConfig();
    const context = (0, $acw62.useContext)($c78df6347432a4c1$var$CanUseRemotionHooks);
    const isPlayer = $c78df6347432a4c1$var$useIsPlayer();
    if (!videoConfig) {
        if (typeof window !== "undefined" && window.remotion_isPlayer || isPlayer) throw new Error([
            "No video config found. Likely reasons:",
            "- You are probably calling useVideoConfig() from outside the component passed to <Player />. See https://www.remotion.dev/docs/player/examples for how to set up the Player correctly.",
            "- You have multiple versions of Remotion installed which causes the React context to get lost."
        ].join("-"));
        throw new Error("No video config found. You are probably calling useVideoConfig() from a component which has not been registered as a <Composition />. See https://www.remotion.dev/docs/the-fundamentals#defining-compositions for more information.");
    }
    if (!context) throw new Error("Called useVideoConfig() outside a Remotion composition.");
    return videoConfig;
};
var $c78df6347432a4c1$export$e82ee3202ebaa1e9 = ()=>{
    const canUseRemotionHooks = (0, $acw62.useContext)($c78df6347432a4c1$var$CanUseRemotionHooks);
    if (!canUseRemotionHooks) {
        if ($c78df6347432a4c1$export$2a36334a5203003d().isPlayer) throw new Error(`useCurrentFrame can only be called inside a component that was passed to <Player>. See: https://www.remotion.dev/docs/player/examples`);
        throw new Error(`useCurrentFrame() can only be called inside a component that was registered as a composition. See https://www.remotion.dev/docs/the-fundamentals#defining-compositions`);
    }
    const frame = $c78df6347432a4c1$var$useTimelinePosition();
    const context = (0, $acw62.useContext)($c78df6347432a4c1$var$SequenceContext);
    const contextOffset = context ? context.cumulatedFrom + context.relativeFrom : 0;
    return frame - contextOffset;
};
var $c78df6347432a4c1$export$f0826af67a39ec5d = ({ frame: frameToFreeze, children: children, active: active = true })=>{
    const frame = $c78df6347432a4c1$export$e82ee3202ebaa1e9();
    const videoConfig = $c78df6347432a4c1$export$da01606c8b81c2a0();
    if (typeof frameToFreeze === "undefined") throw new Error(`The <Freeze /> component requires a 'frame' prop, but none was passed.`);
    if (typeof frameToFreeze !== "number") throw new Error(`The 'frame' prop of <Freeze /> must be a number, but is of type ${typeof frameToFreeze}`);
    if (Number.isNaN(frameToFreeze)) throw new Error(`The 'frame' prop of <Freeze /> must be a real number, but it is NaN.`);
    if (!Number.isFinite(frameToFreeze)) throw new Error(`The 'frame' prop of <Freeze /> must be a finite number, but it is ${frameToFreeze}.`);
    const isActive = (0, $acw62.useMemo)(()=>{
        if (typeof active === "boolean") return active;
        if (typeof active === "function") return active(frame);
    }, [
        active,
        frame
    ]);
    const timelineContext = (0, $acw62.useContext)($c78df6347432a4c1$var$TimelineContext);
    const sequenceContext = (0, $acw62.useContext)($c78df6347432a4c1$var$SequenceContext);
    const relativeFrom = sequenceContext?.relativeFrom ?? 0;
    const timelineValue = (0, $acw62.useMemo)(()=>{
        if (!isActive) return timelineContext;
        return {
            ...timelineContext,
            playing: false,
            imperativePlaying: {
                current: false
            },
            frame: {
                [videoConfig.id]: frameToFreeze + relativeFrom
            }
        };
    }, [
        isActive,
        timelineContext,
        videoConfig.id,
        frameToFreeze,
        relativeFrom
    ]);
    return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$TimelineContext.Provider, {
        value: timelineValue,
        children: children
    });
};
var $c78df6347432a4c1$var$RegularSequenceRefForwardingFunction = ({ from: from = 0, durationInFrames: durationInFrames = Infinity, children: children, name: name, height: height, width: width, showInTimeline: showInTimeline = true, _remotionInternalLoopDisplay: loopDisplay, _remotionInternalStack: stack, _remotionInternalPremountDisplay: premountDisplay, ...other }, ref)=>{
    const { layout: layout = "absolute-fill" } = other;
    const [id] = (0, $acw62.useState)(()=>String(Math.random()));
    const parentSequence = (0, $acw62.useContext)($c78df6347432a4c1$var$SequenceContext);
    const { rootId: rootId } = (0, $acw62.useContext)($c78df6347432a4c1$var$TimelineContext);
    const cumulatedFrom = parentSequence ? parentSequence.cumulatedFrom + parentSequence.relativeFrom : 0;
    const nonce3 = $c78df6347432a4c1$var$useNonce();
    if (layout !== "absolute-fill" && layout !== "none") throw new TypeError(`The layout prop of <Sequence /> expects either "absolute-fill" or "none", but you passed: ${layout}`);
    if (layout === "none" && typeof other.style !== "undefined") throw new TypeError('If layout="none", you may not pass a style.');
    if (typeof durationInFrames !== "number") throw new TypeError(`You passed to durationInFrames an argument of type ${typeof durationInFrames}, but it must be a number.`);
    if (durationInFrames <= 0) throw new TypeError(`durationInFrames must be positive, but got ${durationInFrames}`);
    if (typeof from !== "number") throw new TypeError(`You passed to the "from" props of your <Sequence> an argument of type ${typeof from}, but it must be a number.`);
    if (!Number.isFinite(from)) throw new TypeError(`The "from" prop of a sequence must be finite, but got ${from}.`);
    const absoluteFrame = $c78df6347432a4c1$var$useTimelinePosition();
    const videoConfig = $c78df6347432a4c1$export$da01606c8b81c2a0();
    const parentSequenceDuration = parentSequence ? Math.min(parentSequence.durationInFrames - from, durationInFrames) : durationInFrames;
    const actualDurationInFrames = Math.max(0, Math.min(videoConfig.durationInFrames - from, parentSequenceDuration));
    const { registerSequence: registerSequence, unregisterSequence: unregisterSequence } = (0, $acw62.useContext)($c78df6347432a4c1$var$SequenceManager);
    const { hidden: hidden } = (0, $acw62.useContext)($c78df6347432a4c1$var$SequenceVisibilityToggleContext);
    const premounting = (0, $acw62.useMemo)(()=>{
        return parentSequence?.premounting ?? Boolean(other._remotionInternalIsPremounting);
    }, [
        other._remotionInternalIsPremounting,
        parentSequence?.premounting
    ]);
    const contextValue = (0, $acw62.useMemo)(()=>{
        return {
            cumulatedFrom: cumulatedFrom,
            relativeFrom: from,
            durationInFrames: actualDurationInFrames,
            parentFrom: parentSequence?.relativeFrom ?? 0,
            id: id,
            height: height ?? parentSequence?.height ?? null,
            width: width ?? parentSequence?.width ?? null,
            premounting: premounting
        };
    }, [
        cumulatedFrom,
        from,
        actualDurationInFrames,
        parentSequence,
        id,
        height,
        width,
        premounting
    ]);
    const timelineClipName = (0, $acw62.useMemo)(()=>{
        return name ?? "";
    }, [
        name
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!$c78df6347432a4c1$export$2a36334a5203003d().isStudio) return;
        registerSequence({
            from: from,
            duration: actualDurationInFrames,
            id: id,
            displayName: timelineClipName,
            parent: parentSequence?.id ?? null,
            type: "sequence",
            rootId: rootId,
            showInTimeline: showInTimeline,
            nonce: nonce3,
            loopDisplay: loopDisplay,
            stack: stack ?? null,
            premountDisplay: premountDisplay ?? null
        });
        return ()=>{
            unregisterSequence(id);
        };
    }, [
        durationInFrames,
        id,
        name,
        registerSequence,
        timelineClipName,
        unregisterSequence,
        parentSequence?.id,
        actualDurationInFrames,
        rootId,
        from,
        showInTimeline,
        nonce3,
        loopDisplay,
        stack,
        premountDisplay
    ]);
    const endThreshold = Math.ceil(cumulatedFrom + from + durationInFrames - 1);
    const content = absoluteFrame < cumulatedFrom + from ? null : absoluteFrame > endThreshold ? null : children;
    const styleIfThere = other.layout === "none" ? undefined : other.style;
    const defaultStyle = (0, $acw62.useMemo)(()=>{
        return {
            flexDirection: undefined,
            ...width ? {
                width: width
            } : {},
            ...height ? {
                height: height
            } : {},
            ...styleIfThere ?? {}
        };
    }, [
        height,
        styleIfThere,
        width
    ]);
    if (ref !== null && layout === "none") throw new TypeError('It is not supported to pass both a `ref` and `layout="none"` to <Sequence />.');
    const isSequenceHidden = hidden[id] ?? false;
    if (isSequenceHidden) return null;
    return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$SequenceContext.Provider, {
        value: contextValue,
        children: content === null ? null : other.layout === "none" ? content : (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$export$afbd5df19c967c53, {
            ref: ref,
            style: defaultStyle,
            className: other.className,
            children: content
        })
    });
};
var $c78df6347432a4c1$var$RegularSequence = (0, $acw62.forwardRef)($c78df6347432a4c1$var$RegularSequenceRefForwardingFunction);
var $c78df6347432a4c1$var$PremountedSequenceRefForwardingFunction = (props, ref)=>{
    const frame = $c78df6347432a4c1$export$e82ee3202ebaa1e9();
    if (props.layout === "none") throw new Error('`<Sequence>` with `premountFor` prop does not support layout="none"');
    const { style: passedStyle, from: from = 0, premountFor: premountFor = 0, ...otherProps } = props;
    const premountingActive = frame < from && frame >= from - premountFor;
    const style = (0, $acw62.useMemo)(()=>{
        return {
            ...passedStyle,
            opacity: premountingActive ? 0 : 1,
            pointerEvents: premountingActive ? "none" : passedStyle?.pointerEvents ?? undefined
        };
    }, [
        premountingActive,
        passedStyle
    ]);
    return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$export$f0826af67a39ec5d, {
        frame: from,
        active: premountingActive,
        children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$export$edde1bcb1b2b310e, {
            ref: ref,
            from: from,
            style: style,
            _remotionInternalPremountDisplay: premountFor,
            _remotionInternalIsPremounting: premountingActive,
            ...otherProps
        })
    });
};
var $c78df6347432a4c1$var$PremountedSequence = (0, $acw62.forwardRef)($c78df6347432a4c1$var$PremountedSequenceRefForwardingFunction);
var $c78df6347432a4c1$var$SequenceRefForwardingFunction = (props, ref)=>{
    if (props.layout !== "none" && props.premountFor && !$c78df6347432a4c1$export$2a36334a5203003d().isRendering) return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$PremountedSequence, {
        ...props,
        ref: ref
    });
    return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$RegularSequence, {
        ...props,
        ref: ref
    });
};
var $c78df6347432a4c1$export$edde1bcb1b2b310e = (0, $acw62.forwardRef)($c78df6347432a4c1$var$SequenceRefForwardingFunction);
// src/validation/validate-artifact.ts
var $c78df6347432a4c1$var$validateArtifactFilename = (filename)=>{
    if (typeof filename !== "string") throw new TypeError(`The "filename" must be a string, but you passed a value of type ${typeof filename}`);
    if (filename.trim() === "") throw new Error("The `filename` must not be empty");
    if (!filename.match(/^([0-9a-zA-Z-!_.*'()/:&$@=;+,?]+)/g)) throw new Error('The `filename` must match "/^([0-9a-zA-Z-!_.*\'()/:&$@=;+,?]+)/g". Use forward slashes only, even on Windows.');
};
var $c78df6347432a4c1$var$validateContent = (content)=>{
    if (typeof content !== "string" && !(content instanceof Uint8Array)) throw new TypeError(`The "content" must be a string or Uint8Array, but you passed a value of type ${typeof content}`);
    if (typeof content === "string" && content.trim() === "") throw new Error("The `content` must not be empty");
};
var $c78df6347432a4c1$var$validateRenderAsset = (artifact)=>{
    if (artifact.type !== "artifact") return;
    $c78df6347432a4c1$var$validateArtifactFilename(artifact.filename);
    $c78df6347432a4c1$var$validateContent(artifact.content);
};
var $c78df6347432a4c1$var$RenderAssetManager = (0, $acw62.createContext)({
    registerRenderAsset: ()=>{
        return;
    },
    unregisterRenderAsset: ()=>{
        return;
    },
    renderAssets: []
});
var $c78df6347432a4c1$var$RenderAssetManagerProvider = ({ children: children })=>{
    const [renderAssets, setRenderAssets] = (0, $acw62.useState)([]);
    const registerRenderAsset = (0, $acw62.useCallback)((renderAsset)=>{
        $c78df6347432a4c1$var$validateRenderAsset(renderAsset);
        setRenderAssets((assets)=>{
            return [
                ...assets,
                renderAsset
            ];
        });
    }, []);
    const unregisterRenderAsset = (0, $acw62.useCallback)((id)=>{
        setRenderAssets((assts)=>{
            return assts.filter((a)=>a.id !== id);
        });
    }, []);
    (0, $acw62.useLayoutEffect)(()=>{
        if (typeof window !== "undefined") window.remotion_collectAssets = ()=>{
            setRenderAssets([]);
            return renderAssets;
        };
    }, [
        renderAssets
    ]);
    const contextValue = (0, $acw62.useMemo)(()=>{
        return {
            registerRenderAsset: registerRenderAsset,
            unregisterRenderAsset: unregisterRenderAsset,
            renderAssets: renderAssets
        };
    }, [
        renderAssets,
        registerRenderAsset,
        unregisterRenderAsset
    ]);
    return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$RenderAssetManager.Provider, {
        value: contextValue,
        children: children
    });
};
// src/Artifact.tsx
var $c78df6347432a4c1$export$f509bf4c05b38d1a = ({ filename: filename, content: content })=>{
    const { registerRenderAsset: registerRenderAsset, unregisterRenderAsset: unregisterRenderAsset } = (0, $acw62.useContext)($c78df6347432a4c1$var$RenderAssetManager);
    const [env] = (0, $acw62.useState)(()=>$c78df6347432a4c1$export$2a36334a5203003d());
    const frame = $c78df6347432a4c1$export$e82ee3202ebaa1e9();
    const [id] = (0, $acw62.useState)(()=>{
        return String(Math.random());
    });
    (0, $acw62.useEffect)(()=>{
        if (!env.isRendering) return;
        if (content instanceof Uint8Array) registerRenderAsset({
            type: "artifact",
            id: id,
            content: btoa(new TextDecoder("utf8").decode(content)),
            filename: filename,
            frame: frame,
            binary: true
        });
        else registerRenderAsset({
            type: "artifact",
            id: id,
            content: content,
            filename: filename,
            frame: frame,
            binary: false
        });
        return ()=>{
            return unregisterRenderAsset(id);
        };
    }, [
        content,
        env.isRendering,
        filename,
        frame,
        id,
        registerRenderAsset,
        unregisterRenderAsset
    ]);
    return null;
};
// src/absolute-src.ts
var $c78df6347432a4c1$var$getAbsoluteSrc = (relativeSrc)=>{
    if (typeof window === "undefined") return relativeSrc;
    return new URL(relativeSrc, window.origin).href;
};
// src/calculate-loop.ts
var $c78df6347432a4c1$var$calculateLoopDuration = ({ endAt: endAt, mediaDuration: mediaDuration, playbackRate: playbackRate, startFrom: startFrom })=>{
    let duration = mediaDuration;
    if (typeof endAt !== "undefined") duration = endAt;
    if (typeof startFrom !== "undefined") duration -= startFrom;
    const actualDuration = duration / playbackRate;
    return Math.floor(actualDuration);
};
// src/cancel-render.ts
function $c78df6347432a4c1$export$c1ae5abd54a67e52(err) {
    let error;
    if ($c78df6347432a4c1$var$isErrorLike(err)) {
        error = err;
        if (!error.stack) error.stack = new Error(error.message).stack;
    } else if (typeof err === "string") error = Error(err);
    else error = Error("Rendering was cancelled");
    window.remotion_cancelledError = error.stack;
    throw error;
}
var $c78df6347432a4c1$var$isErrorLike = (err)=>{
    if (err instanceof Error) return true;
    if (err === null) return false;
    if (typeof err !== "object") return false;
    if (!("stack" in err)) return false;
    if (typeof err.stack !== "string") return false;
    if (!("message" in err)) return false;
    if (typeof err.message !== "string") return false;
    return true;
};
var $c78df6347432a4c1$var$LoopContext = (0, $acw62.createContext)(null);
var $c78df6347432a4c1$var$useLoop = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($c78df6347432a4c1$var$LoopContext);
};
var $c78df6347432a4c1$export$550acbd06a1f5a6a = ({ durationInFrames: durationInFrames, times: times = Infinity, children: children, name: name, ...props })=>{
    const currentFrame = $c78df6347432a4c1$export$e82ee3202ebaa1e9();
    const { durationInFrames: compDuration } = $c78df6347432a4c1$export$da01606c8b81c2a0();
    $c78df6347432a4c1$var$validateDurationInFrames(durationInFrames, {
        component: "of the <Loop /> component",
        allowFloats: true
    });
    if (typeof times !== "number") throw new TypeError(`You passed to "times" an argument of type ${typeof times}, but it must be a number.`);
    if (times !== Infinity && times % 1 !== 0) throw new TypeError(`The "times" prop of a loop must be an integer, but got ${times}.`);
    if (times < 0) throw new TypeError(`The "times" prop of a loop must be at least 0, but got ${times}`);
    const maxTimes = Math.ceil(compDuration / durationInFrames);
    const actualTimes = Math.min(maxTimes, times);
    const style = props.layout === "none" ? undefined : props.style;
    const maxFrame = durationInFrames * (actualTimes - 1);
    const iteration = Math.floor(currentFrame / durationInFrames);
    const start = iteration * durationInFrames;
    const from = Math.min(start, maxFrame);
    const loopDisplay = (0, $acw62.useMemo)(()=>{
        return {
            numberOfTimes: actualTimes,
            startOffset: -from,
            durationInFrames: durationInFrames
        };
    }, [
        actualTimes,
        durationInFrames,
        from
    ]);
    const loopContext = (0, $acw62.useMemo)(()=>{
        return {
            iteration: Math.floor(currentFrame / durationInFrames),
            durationInFrames: durationInFrames
        };
    }, [
        currentFrame,
        durationInFrames
    ]);
    return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$LoopContext.Provider, {
        value: loopContext,
        children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$export$edde1bcb1b2b310e, {
            durationInFrames: durationInFrames,
            from: from,
            name: name ?? "<Loop>",
            _remotionInternalLoopDisplay: loopDisplay,
            layout: props.layout,
            style: style,
            children: children
        })
    });
};
$c78df6347432a4c1$export$550acbd06a1f5a6a.useLoop = $c78df6347432a4c1$var$useLoop;
var $c78df6347432a4c1$var$PreloadContext = (0, $acw62.createContext)({});
var $c78df6347432a4c1$var$preloads = {};
var $c78df6347432a4c1$var$updaters = [];
var $c78df6347432a4c1$var$setPreloads = (updater)=>{
    $c78df6347432a4c1$var$preloads = updater($c78df6347432a4c1$var$preloads);
    $c78df6347432a4c1$var$updaters.forEach((u)=>u());
};
var $c78df6347432a4c1$var$PrefetchProvider = ({ children: children })=>{
    const [_preloads, _setPreloads] = (0, $acw62.useState)(()=>$c78df6347432a4c1$var$preloads);
    (0, $acw62.useEffect)(()=>{
        const updaterFunction = ()=>{
            _setPreloads($c78df6347432a4c1$var$preloads);
        };
        $c78df6347432a4c1$var$updaters.push(updaterFunction);
        return ()=>{
            $c78df6347432a4c1$var$updaters = $c78df6347432a4c1$var$updaters.filter((u)=>u !== updaterFunction);
        };
    }, []);
    return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$PreloadContext.Provider, {
        value: _preloads,
        children: children
    });
};
// src/prefetch.ts
var $c78df6347432a4c1$var$usePreload = (src)=>{
    const preloads2 = (0, $acw62.useContext)($c78df6347432a4c1$var$PreloadContext);
    return preloads2[src] ?? src;
};
var $c78df6347432a4c1$var$blobToBase64 = function(blob) {
    const reader = new FileReader;
    return new Promise((resolve, reject)=>{
        reader.onload = function() {
            const dataUrl = reader.result;
            resolve(dataUrl);
        };
        reader.onerror = (err)=>{
            return reject(err);
        };
        reader.readAsDataURL(blob);
    });
};
var $c78df6347432a4c1$var$getBlobFromReader = async ({ reader: reader, contentType: contentType, contentLength: contentLength, onProgress: onProgress })=>{
    let receivedLength = 0;
    const chunks = [];
    while(true){
        const { done: done, value: value } = await reader.read();
        if (done) break;
        chunks.push(value);
        receivedLength += value.length;
        if (onProgress) onProgress({
            loadedBytes: receivedLength,
            totalBytes: contentLength
        });
    }
    const chunksAll = new Uint8Array(receivedLength);
    let position = 0;
    for (const chunk of chunks){
        chunksAll.set(chunk, position);
        position += chunk.length;
    }
    return new Blob([
        chunksAll
    ], {
        type: contentType ?? undefined
    });
};
var $c78df6347432a4c1$export$f003ab04b0b3c00e = (src, options)=>{
    const method = options?.method ?? "blob-url";
    if ($c78df6347432a4c1$export$2a36334a5203003d().isRendering) return {
        free: ()=>{
            return;
        },
        waitUntilDone: ()=>Promise.resolve(src)
    };
    let canceled = false;
    let objectUrl = null;
    let resolve = ()=>{
        return;
    };
    let reject = ()=>{
        return;
    };
    const waitUntilDone = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    const controller = new AbortController;
    let canBeAborted = true;
    fetch(src, {
        signal: controller.signal
    }).then((res)=>{
        canBeAborted = false;
        if (canceled) return null;
        if (!res.ok) throw new Error(`HTTP error, status = ${res.status}`);
        const headerContentType = res.headers.get("Content-Type");
        const contentType = options?.contentType ?? headerContentType;
        const hasProperContentType = contentType && (contentType.startsWith("video/") || contentType.startsWith("audio/") || contentType.startsWith("image/"));
        if (!hasProperContentType) console.warn(`Called prefetch() on ${src} which returned a "Content-Type" of ${headerContentType}. Prefetched content should have a proper content type (video/... or audio/...) or a contentType passed the options of prefetch(). Otherwise, prefetching will not work properly in all browsers.`);
        if (!res.body) throw new Error(`HTTP response of ${src} has no body`);
        const reader = res.body.getReader();
        return $c78df6347432a4c1$var$getBlobFromReader({
            reader: reader,
            contentType: options?.contentType ?? headerContentType ?? null,
            contentLength: res.headers.get("Content-Length") ? parseInt(res.headers.get("Content-Length"), 10) : null,
            onProgress: options?.onProgress
        });
    }).then((buf)=>{
        if (!buf) return;
        const actualBlob = options?.contentType ? new Blob([
            buf
        ], {
            type: options.contentType
        }) : buf;
        if (method === "base64") return $c78df6347432a4c1$var$blobToBase64(actualBlob);
        return URL.createObjectURL(actualBlob);
    }).then((url)=>{
        if (canceled) return;
        objectUrl = url;
        $c78df6347432a4c1$var$setPreloads((p)=>({
                ...p,
                [src]: objectUrl
            }));
        resolve(objectUrl);
    }).catch((err)=>{
        reject(err);
    });
    return {
        free: ()=>{
            if (objectUrl) {
                if (method === "blob-url") URL.revokeObjectURL(objectUrl);
                $c78df6347432a4c1$var$setPreloads((p)=>{
                    const copy = {
                        ...p
                    };
                    delete copy[src];
                    return copy;
                });
            } else {
                canceled = true;
                if (canBeAborted) try {
                    controller.abort();
                } catch (e) {}
            }
        },
        waitUntilDone: ()=>{
            return waitUntilDone;
        }
    };
};
// src/validate-media-props.ts
var $c78df6347432a4c1$var$validateMediaProps = (props, component)=>{
    if (typeof props.volume !== "number" && typeof props.volume !== "function" && typeof props.volume !== "undefined") throw new TypeError(`You have passed a volume of type ${typeof props.volume} to your <${component} /> component. Volume must be a number or a function with the signature '(frame: number) => number' undefined.`);
    if (typeof props.volume === "number" && props.volume < 0) throw new TypeError(`You have passed a volume below 0 to your <${component} /> component. Volume must be between 0 and 1`);
    if (typeof props.playbackRate !== "number" && typeof props.playbackRate !== "undefined") throw new TypeError(`You have passed a playbackRate of type ${typeof props.playbackRate} to your <${component} /> component. Playback rate must a real number or undefined.`);
    if (typeof props.playbackRate === "number" && (isNaN(props.playbackRate) || !Number.isFinite(props.playbackRate) || props.playbackRate <= 0)) throw new TypeError(`You have passed a playbackRate of ${props.playbackRate} to your <${component} /> component. Playback rate must be a real number above 0.`);
};
// src/validate-start-from-props.ts
var $c78df6347432a4c1$var$validateStartFromProps = (startFrom, endAt)=>{
    if (typeof startFrom !== "undefined") {
        if (typeof startFrom !== "number") throw new TypeError(`type of startFrom prop must be a number, instead got type ${typeof startFrom}.`);
        if (isNaN(startFrom) || startFrom === Infinity) throw new TypeError("startFrom prop can not be NaN or Infinity.");
        if (startFrom < 0) throw new TypeError(`startFrom must be greater than equal to 0 instead got ${startFrom}.`);
    }
    if (typeof endAt !== "undefined") {
        if (typeof endAt !== "number") throw new TypeError(`type of endAt prop must be a number, instead got type ${typeof endAt}.`);
        if (isNaN(endAt)) throw new TypeError("endAt prop can not be NaN.");
        if (endAt <= 0) throw new TypeError(`endAt must be a positive number, instead got ${endAt}.`);
    }
    if (endAt < startFrom) throw new TypeError("endAt prop must be greater than startFrom prop.");
};
var $c78df6347432a4c1$var$durationReducer = (state, action)=>{
    switch(action.type){
        case "got-duration":
            {
                const absoluteSrc = $c78df6347432a4c1$var$getAbsoluteSrc(action.src);
                if (state[absoluteSrc] === action.durationInSeconds) return state;
                return {
                    ...state,
                    [absoluteSrc]: action.durationInSeconds
                };
            }
        default:
            return state;
    }
};
var $c78df6347432a4c1$var$DurationsContext = (0, $acw62.createContext)({
    durations: {},
    setDurations: ()=>{
        throw new Error("context missing");
    }
});
var $c78df6347432a4c1$var$DurationsContextProvider = ({ children: children })=>{
    const [durations, setDurations] = (0, $acw62.useReducer)($c78df6347432a4c1$var$durationReducer, {});
    const value = (0, $acw62.useMemo)(()=>{
        return {
            durations: durations,
            setDurations: setDurations
        };
    }, [
        durations
    ]);
    return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$DurationsContext.Provider, {
        value: value,
        children: children
    });
};
// src/random.ts
var $c78df6347432a4c1$var$mulberry32 = function(a) {
    let t = a + 1831565813;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
};
var $c78df6347432a4c1$var$hashCode = function(str) {
    let i = 0;
    let chr = 0;
    let hash = 0;
    for(i = 0; i < str.length; i++){
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0;
    }
    return hash;
};
var $c78df6347432a4c1$export$4385e60b38654f68 = (seed, dummy)=>{
    if (dummy !== undefined) throw new TypeError("random() takes only one argument");
    if (seed === null) return Math.random();
    if (typeof seed === "string") return $c78df6347432a4c1$var$mulberry32($c78df6347432a4c1$var$hashCode(seed));
    if (typeof seed === "number") return $c78df6347432a4c1$var$mulberry32(seed * 10000000000);
    throw new Error("random() argument must be a number or a string");
};
var $c78df6347432a4c1$var$useMediaStartsAt = ()=>{
    const parentSequence = (0, $acw62.useContext)($c78df6347432a4c1$var$SequenceContext);
    const startsAt = Math.min(0, parentSequence?.relativeFrom ?? 0);
    return startsAt;
};
var $c78df6347432a4c1$var$useFrameForVolumeProp = (behavior)=>{
    const loop2 = $c78df6347432a4c1$export$550acbd06a1f5a6a.useLoop();
    const frame = $c78df6347432a4c1$export$e82ee3202ebaa1e9();
    const startsAt = $c78df6347432a4c1$var$useMediaStartsAt();
    if (behavior === "repeat" || loop2 === null) return frame + startsAt;
    return frame + startsAt + loop2.durationInFrames * loop2.iteration;
};
// src/get-asset-file-name.ts
var $c78df6347432a4c1$var$getAssetDisplayName = (filename)=>{
    if (/data:|blob:/.test(filename.substring(0, 5))) return "Data URL";
    const splitted = filename.split("/").map((s)=>s.split("\\")).flat(1);
    return splitted[splitted.length - 1];
};
// src/play-and-handle-not-allowed-error.ts
var $c78df6347432a4c1$var$playAndHandleNotAllowedError = (mediaRef, mediaType, onAutoPlayError)=>{
    const { current: current } = mediaRef;
    if (!current) return;
    const prom = current.play();
    if (prom.catch) prom.catch((err)=>{
        if (!current) return;
        if (err.message.includes("request was interrupted by a call to pause")) return;
        if (err.message.includes("The operation was aborted.")) return;
        if (err.message.includes("The fetching process for the media resource was aborted by the user agent")) return;
        if (err.message.includes("request was interrupted by a new load request")) return;
        if (err.message.includes("because the media was removed from the document")) return;
        console.log(`Could not play ${mediaType} due to following error: `, err);
        if (!current.muted) {
            if (onAutoPlayError) {
                onAutoPlayError();
                return;
            }
            console.log(`The video will be muted and we'll retry playing it.`);
            if (mediaType === "video" && $c78df6347432a4c1$export$2a36334a5203003d().isPlayer) console.log("Use onAutoPlayError() to handle this error yourself.");
            current.muted = true;
            current.play();
        }
    });
};
// src/volume-prop.ts
var $c78df6347432a4c1$var$evaluateVolume = ({ frame: frame, volume: volume, mediaVolume: mediaVolume = 1, allowAmplificationDuringRender: allowAmplificationDuringRender })=>{
    const maxVolume = allowAmplificationDuringRender ? Infinity : 1;
    if (typeof volume === "number") return Math.min(maxVolume, volume * mediaVolume);
    if (typeof volume === "undefined") return Number(mediaVolume);
    const evaluated = volume(frame) * mediaVolume;
    if (typeof evaluated !== "number") throw new TypeError(`You passed in a a function to the volume prop but it did not return a number but a value of type ${typeof evaluated} for frame ${frame}`);
    if (Number.isNaN(evaluated)) throw new TypeError(`You passed in a function to the volume prop but it returned NaN for frame ${frame}.`);
    if (!Number.isFinite(evaluated)) throw new TypeError(`You passed in a function to the volume prop but it returned a non-finite number for frame ${frame}.`);
    return Math.max(0, Math.min(maxVolume, evaluated));
};
// src/use-media-in-timeline.ts
var $c78df6347432a4c1$var$didWarn2 = {};
var $c78df6347432a4c1$var$warnOnce2 = (message)=>{
    if ($c78df6347432a4c1$var$didWarn2[message]) return;
    console.warn(message);
    $c78df6347432a4c1$var$didWarn2[message] = true;
};
var $c78df6347432a4c1$var$useMediaInTimeline = ({ volume: volume, mediaVolume: mediaVolume, mediaRef: mediaRef, src: src, mediaType: mediaType, playbackRate: playbackRate, displayName: displayName, id: id, stack: stack, showInTimeline: showInTimeline, premountDisplay: premountDisplay, onAutoPlayError: onAutoPlayError })=>{
    const videoConfig = $c78df6347432a4c1$export$da01606c8b81c2a0();
    const { rootId: rootId, audioAndVideoTags: audioAndVideoTags } = (0, $acw62.useContext)($c78df6347432a4c1$var$TimelineContext);
    const parentSequence = (0, $acw62.useContext)($c78df6347432a4c1$var$SequenceContext);
    const actualFrom = parentSequence ? parentSequence.relativeFrom + parentSequence.cumulatedFrom : 0;
    const [playing] = $c78df6347432a4c1$var$usePlayingState();
    const startsAt = $c78df6347432a4c1$var$useMediaStartsAt();
    const { registerSequence: registerSequence, unregisterSequence: unregisterSequence } = (0, $acw62.useContext)($c78df6347432a4c1$var$SequenceManager);
    const [initialVolume] = (0, $acw62.useState)(()=>volume);
    const nonce4 = $c78df6347432a4c1$var$useNonce();
    const duration = parentSequence ? Math.min(parentSequence.durationInFrames, videoConfig.durationInFrames) : videoConfig.durationInFrames;
    const doesVolumeChange = typeof volume === "function";
    const volumes = (0, $acw62.useMemo)(()=>{
        if (typeof volume === "number") return volume;
        return new Array(Math.floor(Math.max(0, duration + startsAt))).fill(true).map((_, i)=>{
            return $c78df6347432a4c1$var$evaluateVolume({
                frame: i + startsAt,
                volume: volume,
                mediaVolume: mediaVolume,
                allowAmplificationDuringRender: false
            });
        }).join(",");
    }, [
        duration,
        startsAt,
        volume,
        mediaVolume
    ]);
    (0, $acw62.useEffect)(()=>{
        if (typeof volume === "number" && volume !== initialVolume) $c78df6347432a4c1$var$warnOnce2(`Remotion: The ${mediaType} with src ${src} has changed it's volume. Prefer the callback syntax for setting volume to get better timeline display: https://www.remotion.dev/docs/using-audio/#controlling-volume`);
    }, [
        initialVolume,
        mediaType,
        src,
        volume
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!mediaRef.current) return;
        if (!src) throw new Error("No src passed");
        if (!$c78df6347432a4c1$export$2a36334a5203003d().isStudio && window.process?.env?.NODE_ENV !== "test") return;
        if (!showInTimeline) return;
        registerSequence({
            type: mediaType,
            src: src,
            id: id,
            duration: duration,
            from: 0,
            parent: parentSequence?.id ?? null,
            displayName: displayName ?? $c78df6347432a4c1$var$getAssetDisplayName(src),
            rootId: rootId,
            volume: volumes,
            showInTimeline: true,
            nonce: nonce4,
            startMediaFrom: 0 - startsAt,
            doesVolumeChange: doesVolumeChange,
            loopDisplay: undefined,
            playbackRate: playbackRate,
            stack: stack,
            premountDisplay: premountDisplay
        });
        return ()=>{
            unregisterSequence(id);
        };
    }, [
        actualFrom,
        duration,
        id,
        parentSequence,
        src,
        registerSequence,
        rootId,
        unregisterSequence,
        videoConfig,
        volumes,
        doesVolumeChange,
        nonce4,
        mediaRef,
        mediaType,
        startsAt,
        playbackRate,
        displayName,
        stack,
        showInTimeline,
        premountDisplay
    ]);
    (0, $acw62.useEffect)(()=>{
        const tag = {
            id: id,
            play: ()=>{
                if (!playing) return;
                return $c78df6347432a4c1$var$playAndHandleNotAllowedError(mediaRef, mediaType, onAutoPlayError);
            }
        };
        audioAndVideoTags.current.push(tag);
        return ()=>{
            audioAndVideoTags.current = audioAndVideoTags.current.filter((a)=>a.id !== id);
        };
    }, [
        audioAndVideoTags,
        id,
        mediaRef,
        mediaType,
        onAutoPlayError,
        playing
    ]);
};
var $c78df6347432a4c1$var$useBufferManager = ()=>{
    const [blocks, setBlocks] = (0, $acw62.useState)([]);
    const [onBufferingCallbacks, setOnBufferingCallbacks] = (0, $acw62.useState)([]);
    const [onResumeCallbacks, setOnResumeCallbacks] = (0, $acw62.useState)([]);
    const buffering = (0, $acw62.useRef)(false);
    const addBlock = (0, $acw62.useCallback)((block)=>{
        setBlocks((b)=>[
                ...b,
                block
            ]);
        return {
            unblock: ()=>{
                setBlocks((b)=>{
                    const newArr = b.filter((bx)=>bx !== block);
                    if (newArr.length === b.length) return b;
                    return newArr;
                });
            }
        };
    }, []);
    const listenForBuffering = (0, $acw62.useCallback)((callback)=>{
        setOnBufferingCallbacks((c)=>[
                ...c,
                callback
            ]);
        return {
            remove: ()=>{
                setOnBufferingCallbacks((c)=>c.filter((cb)=>cb !== callback));
            }
        };
    }, []);
    const listenForResume = (0, $acw62.useCallback)((callback)=>{
        setOnResumeCallbacks((c)=>[
                ...c,
                callback
            ]);
        return {
            remove: ()=>{
                setOnResumeCallbacks((c)=>c.filter((cb)=>cb !== callback));
            }
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (blocks.length > 0) onBufferingCallbacks.forEach((c)=>c());
    }, [
        blocks
    ]);
    (0, $acw62.useEffect)(()=>{
        if (blocks.length === 0) onResumeCallbacks.forEach((c)=>c());
    }, [
        blocks
    ]);
    return (0, $acw62.useMemo)(()=>{
        return {
            addBlock: addBlock,
            listenForBuffering: listenForBuffering,
            listenForResume: listenForResume,
            buffering: buffering
        };
    }, [
        addBlock,
        buffering,
        listenForBuffering,
        listenForResume
    ]);
};
var $c78df6347432a4c1$var$BufferingContextReact = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
var $c78df6347432a4c1$var$BufferingProvider = ({ children: children })=>{
    const bufferManager = $c78df6347432a4c1$var$useBufferManager();
    return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$BufferingContextReact.Provider, {
        value: bufferManager,
        children: children
    });
};
// src/use-buffer-state.ts
var $c78df6347432a4c1$export$e20082a880d111ba = ()=>{
    const buffer = (0, $acw62.useContext)($c78df6347432a4c1$var$BufferingContextReact);
    const addBlock = buffer ? buffer.addBlock : null;
    return (0, $acw62.useMemo)(()=>({
            delayPlayback: ()=>{
                if (!addBlock) throw new Error("Tried to enable the buffering state, but a Remotion context was not found. This API can only be called in a component that was passed to the Remotion Player or a <Composition>. Or you might have experienced a version mismatch - run `npx remotion versions` and ensure all packages have the same version. This error is thrown by the buffer state https://remotion.dev/docs/player/buffer-state");
                const { unblock: unblock } = addBlock({
                    id: String(Math.random())
                });
                return {
                    unblock: unblock
                };
            }
        }), [
        addBlock
    ]);
};
// src/buffer-until-first-frame.ts
var $c78df6347432a4c1$var$useBufferUntilFirstFrame = ({ mediaRef: mediaRef, mediaType: mediaType, onVariableFpsVideoDetected: onVariableFpsVideoDetected, pauseWhenBuffering: pauseWhenBuffering })=>{
    const bufferingRef = (0, $acw62.useRef)(false);
    const { delayPlayback: delayPlayback } = $c78df6347432a4c1$export$e20082a880d111ba();
    const bufferUntilFirstFrame = (0, $acw62.useCallback)((requestedTime)=>{
        if (mediaType !== "video") return;
        if (!pauseWhenBuffering) return;
        const current = mediaRef.current;
        if (!current) return;
        if (!current.requestVideoFrameCallback) return;
        bufferingRef.current = true;
        const playback = delayPlayback();
        const unblock = ()=>{
            playback.unblock();
            current.removeEventListener("ended", unblock, {
                once: true
            });
            current.removeEventListener("pause", unblock, {
                once: true
            });
            bufferingRef.current = false;
        };
        const onEndedOrPause = ()=>{
            unblock();
        };
        current.requestVideoFrameCallback((_, info)=>{
            const differenceFromRequested = Math.abs(info.mediaTime - requestedTime);
            if (differenceFromRequested > 0.5) onVariableFpsVideoDetected();
            current.requestVideoFrameCallback(()=>{
                unblock();
            });
        });
        current.addEventListener("ended", onEndedOrPause, {
            once: true
        });
        current.addEventListener("pause", onEndedOrPause, {
            once: true
        });
    }, [
        delayPlayback,
        mediaRef,
        mediaType,
        onVariableFpsVideoDetected,
        pauseWhenBuffering
    ]);
    return (0, $acw62.useMemo)(()=>{
        return {
            isBuffering: ()=>bufferingRef.current,
            bufferUntilFirstFrame: bufferUntilFirstFrame
        };
    }, [
        bufferUntilFirstFrame
    ]);
};
var $c78df6347432a4c1$var$useMediaBuffering = ({ element: element, shouldBuffer: shouldBuffer, isPremounting: isPremounting })=>{
    const buffer = $c78df6347432a4c1$export$e20082a880d111ba();
    const [isBuffering, setIsBuffering] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        let cleanupFns = [];
        const { current: current } = element;
        if (!current) return;
        if (!shouldBuffer) return;
        if (isPremounting) return;
        const cleanup = ()=>{
            cleanupFns.forEach((fn)=>fn());
            cleanupFns = [];
            setIsBuffering(false);
        };
        const onWaiting = ()=>{
            setIsBuffering(true);
            const { unblock: unblock } = buffer.delayPlayback();
            const onCanPlay = ()=>{
                cleanup();
                init();
            };
            const onError = ()=>{
                cleanup();
                init();
            };
            current.addEventListener("canplay", onCanPlay, {
                once: true
            });
            cleanupFns.push(()=>{
                current.removeEventListener("canplay", onCanPlay);
            });
            current.addEventListener("error", onError, {
                once: true
            });
            cleanupFns.push(()=>{
                current.removeEventListener("error", onError);
            });
            cleanupFns.push(()=>{
                unblock();
            });
        };
        const init = ()=>{
            if (current.readyState < current.HAVE_FUTURE_DATA) {
                onWaiting();
                if (!navigator.userAgent.includes("Firefox/")) current.load();
            } else {
                current.addEventListener("waiting", onWaiting);
                cleanupFns.push(()=>{
                    current.removeEventListener("waiting", onWaiting);
                });
            }
        };
        init();
        return ()=>{
            cleanup();
        };
    }, [
        buffer,
        element,
        isPremounting,
        shouldBuffer
    ]);
    return isBuffering;
};
var $c78df6347432a4c1$var$useRequestVideoCallbackTime = ({ mediaRef: mediaRef, mediaType: mediaType, lastSeek: lastSeek, onVariableFpsVideoDetected: onVariableFpsVideoDetected })=>{
    const currentTime = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const { current: current } = mediaRef;
        if (current) currentTime.current = current.currentTime;
        else {
            currentTime.current = null;
            return;
        }
        if (mediaType !== "video") {
            currentTime.current = null;
            return;
        }
        const videoTag = current;
        if (!videoTag.requestVideoFrameCallback) return;
        let cancel = ()=>{
            return;
        };
        const request = ()=>{
            if (!videoTag) return;
            const cb = videoTag.requestVideoFrameCallback((_, info)=>{
                if (currentTime.current !== null) {
                    const difference = Math.abs(currentTime.current - info.mediaTime);
                    const differenceToLastSeek = Math.abs(lastSeek.current === null ? Infinity : info.mediaTime - lastSeek.current);
                    if (difference > 0.5 && differenceToLastSeek > 0.5 && info.mediaTime > currentTime.current) onVariableFpsVideoDetected();
                }
                currentTime.current = info.mediaTime;
                request();
            });
            cancel = ()=>{
                videoTag.cancelVideoFrameCallback(cb);
                cancel = ()=>{
                    return;
                };
            };
        };
        request();
        return ()=>{
            cancel();
        };
    }, [
        lastSeek,
        mediaRef,
        mediaType,
        onVariableFpsVideoDetected
    ]);
    return currentTime;
};
// src/interpolate.ts
var $c78df6347432a4c1$var$interpolateFunction = function(input, inputRange, outputRange, options) {
    const { extrapolateLeft: extrapolateLeft, extrapolateRight: extrapolateRight, easing: easing } = options;
    let result = input;
    const [inputMin, inputMax] = inputRange;
    const [outputMin, outputMax] = outputRange;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        if (extrapolateLeft === "clamp") result = inputMin;
        else if (extrapolateLeft === "wrap") {
            const range = inputMax - inputMin;
            result = ((result - inputMin) % range + range) % range + inputMin;
        } else extrapolateLeft;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        if (extrapolateRight === "clamp") result = inputMax;
        else if (extrapolateRight === "wrap") {
            const range = inputMax - inputMin;
            result = ((result - inputMin) % range + range) % range + inputMin;
        } else extrapolateRight;
    }
    if (outputMin === outputMax) return outputMin;
    result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    result = result * (outputMax - outputMin) + outputMin;
    return result;
};
var $c78df6347432a4c1$var$findRange = function(input, inputRange) {
    let i;
    for(i = 1; i < inputRange.length - 1; ++i){
        if (inputRange[i] >= input) break;
    }
    return i - 1;
};
var $c78df6347432a4c1$var$checkValidInputRange = function(arr) {
    for(let i = 1; i < arr.length; ++i){
        if (!(arr[i] > arr[i - 1])) throw new Error(`inputRange must be strictly monotonically increasing but got [${arr.join(",")}]`);
    }
};
var $c78df6347432a4c1$var$checkInfiniteRange = function(name, arr) {
    if (arr.length < 2) throw new Error(name + " must have at least 2 elements");
    for (const element of arr){
        if (typeof element !== "number") throw new Error(`${name} must contain only numbers`);
        if (!Number.isFinite(element)) throw new Error(`${name} must contain only finite numbers, but got [${arr.join(",")}]`);
    }
};
function $c78df6347432a4c1$export$89e29e4ab65e70a9(input, inputRange, outputRange, options) {
    if (typeof input === "undefined") throw new Error("input can not be undefined");
    if (typeof inputRange === "undefined") throw new Error("inputRange can not be undefined");
    if (typeof outputRange === "undefined") throw new Error("outputRange can not be undefined");
    if (inputRange.length !== outputRange.length) throw new Error("inputRange (" + inputRange.length + ") and outputRange (" + outputRange.length + ") must have the same length");
    $c78df6347432a4c1$var$checkInfiniteRange("inputRange", inputRange);
    $c78df6347432a4c1$var$checkInfiniteRange("outputRange", outputRange);
    $c78df6347432a4c1$var$checkValidInputRange(inputRange);
    const easing = options?.easing ?? ((num)=>num);
    let extrapolateLeft = "extend";
    if (options?.extrapolateLeft !== undefined) extrapolateLeft = options.extrapolateLeft;
    let extrapolateRight = "extend";
    if (options?.extrapolateRight !== undefined) extrapolateRight = options.extrapolateRight;
    if (typeof input !== "number") throw new TypeError("Cannot interpolate an input which is not a number");
    const range = $c78df6347432a4c1$var$findRange(input, inputRange);
    return $c78df6347432a4c1$var$interpolateFunction(input, [
        inputRange[range],
        inputRange[range + 1]
    ], [
        outputRange[range],
        outputRange[range + 1]
    ], {
        easing: easing,
        extrapolateLeft: extrapolateLeft,
        extrapolateRight: extrapolateRight
    });
}
// src/video/get-current-time.ts
var $c78df6347432a4c1$var$getExpectedMediaFrameUncorrected = ({ frame: frame, playbackRate: playbackRate, startFrom: startFrom })=>{
    return $c78df6347432a4c1$export$89e29e4ab65e70a9(frame, [
        -1,
        startFrom,
        startFrom + 1
    ], [
        -1,
        startFrom,
        startFrom + playbackRate
    ]);
};
var $c78df6347432a4c1$var$getMediaTime = ({ fps: fps, frame: frame, playbackRate: playbackRate, startFrom: startFrom })=>{
    const expectedFrame = $c78df6347432a4c1$var$getExpectedMediaFrameUncorrected({
        frame: frame,
        playbackRate: playbackRate,
        startFrom: startFrom
    });
    const msPerFrame = 1000 / fps;
    return expectedFrame * msPerFrame / 1000;
};
var $c78df6347432a4c1$var$toSeconds = (time, fps)=>{
    return Math.round(time / fps * 100) / 100;
};
var $c78df6347432a4c1$var$isIosSafari = ()=>{
    if (typeof window === "undefined") return false;
    const isIpadIPodIPhone = /iP(ad|od|hone)/i.test(window.navigator.userAgent);
    const isAppleWebKit = /AppleWebKit/.test(window.navigator.userAgent);
    return isIpadIPodIPhone && isAppleWebKit;
};
var $c78df6347432a4c1$var$isIOSSafariAndBlob = (actualSrc)=>{
    return $c78df6347432a4c1$var$isIosSafari() && actualSrc.startsWith("blob:");
};
var $c78df6347432a4c1$var$getVideoFragmentStart = ({ actualFrom: actualFrom, fps: fps })=>{
    return $c78df6347432a4c1$var$toSeconds(Math.max(0, -actualFrom), fps);
};
var $c78df6347432a4c1$var$getVideoFragmentEnd = ({ duration: duration, fps: fps })=>{
    return $c78df6347432a4c1$var$toSeconds(duration, fps);
};
var $c78df6347432a4c1$var$appendVideoFragment = ({ actualSrc: actualSrc, actualFrom: actualFrom, duration: duration, fps: fps })=>{
    if ($c78df6347432a4c1$var$isIOSSafariAndBlob(actualSrc)) return actualSrc;
    if (actualSrc.startsWith("data:")) return actualSrc;
    const existingHash = Boolean(new URL(actualSrc, (typeof window === "undefined" ? null : window.location.href) ?? "http://localhost:3000").hash);
    if (existingHash) return actualSrc;
    if (!Number.isFinite(actualFrom)) return actualSrc;
    const withStartHash = `${actualSrc}#t=${$c78df6347432a4c1$var$getVideoFragmentStart({
        actualFrom: actualFrom,
        fps: fps
    })}`;
    if (!Number.isFinite(duration)) return withStartHash;
    return `${withStartHash},${$c78df6347432a4c1$var$getVideoFragmentEnd({
        duration: duration,
        fps: fps
    })}`;
};
var $c78df6347432a4c1$var$isSubsetOfDuration = ({ prevStartFrom: prevStartFrom, newStartFrom: newStartFrom, prevDuration: prevDuration, newDuration: newDuration, fps: fps })=>{
    const previousFrom = $c78df6347432a4c1$var$getVideoFragmentStart({
        actualFrom: prevStartFrom,
        fps: fps
    });
    const newFrom = $c78df6347432a4c1$var$getVideoFragmentStart({
        actualFrom: newStartFrom,
        fps: fps
    });
    const previousEnd = $c78df6347432a4c1$var$getVideoFragmentEnd({
        duration: prevDuration,
        fps: fps
    });
    const newEnd = $c78df6347432a4c1$var$getVideoFragmentEnd({
        duration: newDuration,
        fps: fps
    });
    if (newFrom < previousFrom) return false;
    if (newEnd > previousEnd) return false;
    return true;
};
var $c78df6347432a4c1$var$useAppendVideoFragment = ({ actualSrc: initialActualSrc, actualFrom: initialActualFrom, duration: initialDuration, fps: fps })=>{
    const actualFromRef = (0, $acw62.useRef)(initialActualFrom);
    const actualDuration = (0, $acw62.useRef)(initialDuration);
    const actualSrc = (0, $acw62.useRef)(initialActualSrc);
    if (!$c78df6347432a4c1$var$isSubsetOfDuration({
        prevStartFrom: actualFromRef.current,
        newStartFrom: initialActualFrom,
        prevDuration: actualDuration.current,
        newDuration: initialDuration,
        fps: fps
    }) || initialActualSrc !== actualSrc.current) {
        actualFromRef.current = initialActualFrom;
        actualDuration.current = initialDuration;
        actualSrc.current = initialActualSrc;
    }
    const appended = $c78df6347432a4c1$var$appendVideoFragment({
        actualSrc: actualSrc.current,
        actualFrom: actualFromRef.current,
        duration: actualDuration.current,
        fps: fps
    });
    return appended;
};
// src/warn-about-non-seekable-media.ts
var $c78df6347432a4c1$var$alreadyWarned = {};
var $c78df6347432a4c1$var$warnAboutNonSeekableMedia = (ref, type)=>{
    if (ref === null) return;
    if (ref.seekable.length === 0) return;
    if (ref.seekable.length > 1) return;
    if ($c78df6347432a4c1$var$alreadyWarned[ref.src]) return;
    const range = {
        start: ref.seekable.start(0),
        end: ref.seekable.end(0)
    };
    if (range.start === 0 && range.end === 0) {
        const msg = [
            `The media ${ref.src} cannot be seeked. This could be one of few reasons:`,
            "1) The media resource was replaced while the video is playing but it was not loaded yet.",
            "2) The media does not support seeking.",
            "3) The media was loaded with security headers prventing it from being included.",
            "Please see https://remotion.dev/docs/non-seekable-media for assistance."
        ].join("\n");
        if (type === "console-error") console.error(msg);
        else if (type === "console-warning") console.warn(`The media ${ref.src} does not support seeking. The video will render fine, but may not play correctly in the Remotion Studio and in the <Player>. See https://remotion.dev/docs/non-seekable-media for an explanation.`);
        else throw new Error(msg);
        $c78df6347432a4c1$var$alreadyWarned[ref.src] = true;
    }
};
// src/use-media-playback.ts
var $c78df6347432a4c1$var$DEFAULT_ACCEPTABLE_TIMESHIFT = 0.45;
var $c78df6347432a4c1$var$seek = (mediaRef, time)=>{
    if (!mediaRef.current) return;
    const timeToSet = $c78df6347432a4c1$var$isIosSafari() ? Number(time.toFixed(1)) : time;
    mediaRef.current.currentTime = timeToSet;
};
var $c78df6347432a4c1$var$useMediaPlayback = ({ mediaRef: mediaRef, src: src, mediaType: mediaType, playbackRate: localPlaybackRate, onlyWarnForMediaSeekingError: onlyWarnForMediaSeekingError, acceptableTimeshift: acceptableTimeshift, pauseWhenBuffering: pauseWhenBuffering, isPremounting: isPremounting, debugSeeking: debugSeeking, onAutoPlayError: onAutoPlayError })=>{
    const { playbackRate: globalPlaybackRate } = (0, $acw62.useContext)($c78df6347432a4c1$var$TimelineContext);
    const frame = $c78df6347432a4c1$export$e82ee3202ebaa1e9();
    const absoluteFrame = $c78df6347432a4c1$var$useTimelinePosition();
    const [playing] = $c78df6347432a4c1$var$usePlayingState();
    const buffering3 = (0, $acw62.useContext)($c78df6347432a4c1$var$BufferingContextReact);
    const { fps: fps } = $c78df6347432a4c1$export$da01606c8b81c2a0();
    const mediaStartsAt = $c78df6347432a4c1$var$useMediaStartsAt();
    const lastSeekDueToShift = (0, $acw62.useRef)(null);
    const lastSeek = (0, $acw62.useRef)(null);
    if (!buffering3) throw new Error("useMediaPlayback must be used inside a <BufferingContext>");
    const isVariableFpsVideoMap = (0, $acw62.useRef)({});
    const onVariableFpsVideoDetected = (0, $acw62.useCallback)(()=>{
        if (!src) return;
        if (debugSeeking) console.log(`Detected ${src} as a variable FPS video. Disabling buffering while seeking.`);
        isVariableFpsVideoMap.current[src] = true;
    }, [
        debugSeeking,
        src
    ]);
    const currentTime = $c78df6347432a4c1$var$useRequestVideoCallbackTime({
        mediaRef: mediaRef,
        mediaType: mediaType,
        lastSeek: lastSeek,
        onVariableFpsVideoDetected: onVariableFpsVideoDetected
    });
    const desiredUnclampedTime = $c78df6347432a4c1$var$getMediaTime({
        frame: frame,
        playbackRate: localPlaybackRate,
        startFrom: -mediaStartsAt,
        fps: fps
    });
    const isMediaTagBuffering = $c78df6347432a4c1$var$useMediaBuffering({
        element: mediaRef,
        shouldBuffer: pauseWhenBuffering,
        isPremounting: isPremounting
    });
    const { bufferUntilFirstFrame: bufferUntilFirstFrame, isBuffering: isBuffering } = $c78df6347432a4c1$var$useBufferUntilFirstFrame({
        mediaRef: mediaRef,
        mediaType: mediaType,
        onVariableFpsVideoDetected: onVariableFpsVideoDetected,
        pauseWhenBuffering: pauseWhenBuffering
    });
    const playbackRate = localPlaybackRate * globalPlaybackRate;
    const acceptableTimeShiftButLessThanDuration = (()=>{
        if (mediaRef.current?.duration) return Math.min(mediaRef.current.duration, acceptableTimeshift ?? $c78df6347432a4c1$var$DEFAULT_ACCEPTABLE_TIMESHIFT);
        return acceptableTimeshift;
    })();
    (0, $acw62.useEffect)(()=>{
        if (!playing) {
            mediaRef.current?.pause();
            return;
        }
        const isPlayerBuffering = buffering3.buffering.current;
        const isMediaTagBufferingOrStalled = isMediaTagBuffering || isBuffering();
        if (isPlayerBuffering && !isMediaTagBufferingOrStalled) mediaRef.current?.pause();
    }, [
        buffering3.buffering,
        isBuffering,
        isMediaTagBuffering,
        mediaRef,
        playing
    ]);
    (0, $acw62.useEffect)(()=>{
        const tagName = mediaType === "audio" ? "<Audio>" : "<Video>";
        if (!mediaRef.current) throw new Error(`No ${mediaType} ref found`);
        if (!src) throw new Error(`No 'src' attribute was passed to the ${tagName} element.`);
        const playbackRateToSet = Math.max(0, playbackRate);
        if (mediaRef.current.playbackRate !== playbackRateToSet) mediaRef.current.playbackRate = playbackRateToSet;
        const { duration: duration } = mediaRef.current;
        const shouldBeTime = !Number.isNaN(duration) && Number.isFinite(duration) ? Math.min(duration, desiredUnclampedTime) : desiredUnclampedTime;
        const mediaTagTime = mediaRef.current.currentTime;
        const rvcTime = currentTime.current ?? null;
        const isVariableFpsVideo = isVariableFpsVideoMap.current[src];
        const timeShiftMediaTag = Math.abs(shouldBeTime - mediaTagTime);
        const timeShiftRvcTag = rvcTime ? Math.abs(shouldBeTime - rvcTime) : null;
        const timeShift = timeShiftRvcTag && !isVariableFpsVideo ? timeShiftRvcTag : timeShiftMediaTag;
        if (debugSeeking) console.log({
            mediaTagTime: mediaTagTime,
            rvcTime: rvcTime,
            shouldBeTime: shouldBeTime,
            state: mediaRef.current.readyState,
            playing: !mediaRef.current.paused,
            isVariableFpsVideo: isVariableFpsVideo
        });
        if (timeShift > acceptableTimeShiftButLessThanDuration && lastSeekDueToShift.current !== shouldBeTime) {
            if (debugSeeking) console.log("Seeking", {
                shouldBeTime: shouldBeTime,
                isTime: mediaTagTime,
                rvcTime: rvcTime,
                timeShift: timeShift,
                isVariableFpsVideo: isVariableFpsVideo
            });
            $c78df6347432a4c1$var$seek(mediaRef, shouldBeTime);
            lastSeek.current = shouldBeTime;
            lastSeekDueToShift.current = shouldBeTime;
            if (playing && !isVariableFpsVideo) {
                bufferUntilFirstFrame(shouldBeTime);
                if (mediaRef.current.paused) $c78df6347432a4c1$var$playAndHandleNotAllowedError(mediaRef, mediaType, onAutoPlayError);
            }
            if (!onlyWarnForMediaSeekingError) $c78df6347432a4c1$var$warnAboutNonSeekableMedia(mediaRef.current, onlyWarnForMediaSeekingError ? "console-warning" : "console-error");
            return;
        }
        const seekThreshold = playing ? 0.15 : 0.00001;
        const makesSenseToSeek = Math.abs(mediaRef.current.currentTime - shouldBeTime) > seekThreshold;
        const isMediaTagBufferingOrStalled = isMediaTagBuffering || isBuffering();
        const isSomethingElseBuffering = buffering3.buffering.current && !isMediaTagBufferingOrStalled;
        if (!playing || isSomethingElseBuffering) {
            if (makesSenseToSeek) {
                $c78df6347432a4c1$var$seek(mediaRef, shouldBeTime);
                lastSeek.current = shouldBeTime;
            }
            return;
        }
        if (mediaRef.current.paused && !mediaRef.current.ended || absoluteFrame === 0) {
            if (makesSenseToSeek) {
                $c78df6347432a4c1$var$seek(mediaRef, shouldBeTime);
                lastSeek.current = shouldBeTime;
            }
            $c78df6347432a4c1$var$playAndHandleNotAllowedError(mediaRef, mediaType, onAutoPlayError);
            if (!isVariableFpsVideo) bufferUntilFirstFrame(shouldBeTime);
        }
    }, [
        absoluteFrame,
        acceptableTimeShiftButLessThanDuration,
        bufferUntilFirstFrame,
        buffering3.buffering,
        currentTime,
        debugSeeking,
        desiredUnclampedTime,
        isBuffering,
        isMediaTagBuffering,
        mediaRef,
        mediaType,
        onlyWarnForMediaSeekingError,
        playbackRate,
        playing,
        src,
        onAutoPlayError
    ]);
};
var $c78df6347432a4c1$var$useMediaTagVolume = (mediaRef)=>{
    const [actualVolume, setActualVolume] = (0, $acw62.useState)(1);
    (0, $acw62.useEffect)(()=>{
        const ref = mediaRef.current;
        if (!ref) return;
        const onChange = ()=>{
            setActualVolume(ref.volume);
        };
        ref.addEventListener("volumechange", onChange);
        return ()=>ref.removeEventListener("volumechange", onChange);
    }, [
        mediaRef
    ]);
    (0, $acw62.useEffect)(()=>{
        const ref = mediaRef.current;
        if (!ref) return;
        if (ref.volume !== actualVolume) setActualVolume(ref.volume);
    }, [
        actualVolume,
        mediaRef
    ]);
    return actualVolume;
};
// src/is-approximately-the-same.ts
var $c78df6347432a4c1$var$FLOATING_POINT_ERROR_THRESHOLD = 0.00001;
var $c78df6347432a4c1$var$isApproximatelyTheSame = (num1, num2)=>{
    return Math.abs(num1 - num2) < $c78df6347432a4c1$var$FLOATING_POINT_ERROR_THRESHOLD;
};
// src/use-sync-volume-with-media-tag.ts
var $c78df6347432a4c1$var$useSyncVolumeWithMediaTag = ({ volumePropFrame: volumePropFrame, actualVolume: actualVolume, volume: volume, mediaVolume: mediaVolume, mediaRef: mediaRef })=>{
    (0, $acw62.useEffect)(()=>{
        const userPreferredVolume = $c78df6347432a4c1$var$evaluateVolume({
            frame: volumePropFrame,
            volume: volume,
            mediaVolume: mediaVolume,
            allowAmplificationDuringRender: false
        });
        if (!$c78df6347432a4c1$var$isApproximatelyTheSame(userPreferredVolume, actualVolume) && mediaRef.current) mediaRef.current.volume = userPreferredVolume;
    }, [
        actualVolume,
        volumePropFrame,
        mediaRef,
        volume,
        mediaVolume
    ]);
};
var $c78df6347432a4c1$var$MediaVolumeContext = (0, $acw62.createContext)({
    mediaMuted: false,
    mediaVolume: 1
});
var $c78df6347432a4c1$var$SetMediaVolumeContext = (0, $acw62.createContext)({
    setMediaMuted: ()=>{
        throw new Error("default");
    },
    setMediaVolume: ()=>{
        throw new Error("default");
    }
});
var $c78df6347432a4c1$var$useMediaVolumeState = ()=>{
    const { mediaVolume: mediaVolume } = (0, $acw62.useContext)($c78df6347432a4c1$var$MediaVolumeContext);
    const { setMediaVolume: setMediaVolume } = (0, $acw62.useContext)($c78df6347432a4c1$var$SetMediaVolumeContext);
    return (0, $acw62.useMemo)(()=>{
        return [
            mediaVolume,
            setMediaVolume
        ];
    }, [
        mediaVolume,
        setMediaVolume
    ]);
};
var $c78df6347432a4c1$var$useMediaMutedState = ()=>{
    const { mediaMuted: mediaMuted } = (0, $acw62.useContext)($c78df6347432a4c1$var$MediaVolumeContext);
    const { setMediaMuted: setMediaMuted } = (0, $acw62.useContext)($c78df6347432a4c1$var$SetMediaVolumeContext);
    return (0, $acw62.useMemo)(()=>{
        return [
            mediaMuted,
            setMediaMuted
        ];
    }, [
        mediaMuted,
        setMediaMuted
    ]);
};
var $c78df6347432a4c1$var$EMPTY_AUDIO = "data:audio/mp3;base64,/+MYxAAJcAV8AAgAABn//////+/gQ5BAMA+D4Pg+BAQBAEAwD4Pg+D4EBAEAQDAPg++hYBH///hUFQVBUFREDQNHmf///////+MYxBUGkAGIMAAAAP/29Xt6lUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV/+MYxDUAAANIAAAAAFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV";
var $c78df6347432a4c1$var$compareProps = (obj1, obj2)=>{
    const keysA = Object.keys(obj1).sort();
    const keysB = Object.keys(obj2).sort();
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (keysA[i] !== keysB[i]) return false;
        if (obj1[keysA[i]] !== obj2[keysB[i]]) return false;
    }
    return true;
};
var $c78df6347432a4c1$var$didPropChange = (key, newProp, prevProp)=>{
    if (key === "src" && !prevProp.startsWith("data:") && !newProp.startsWith("data:")) return new URL(prevProp, window.origin).toString() !== new URL(newProp, window.origin).toString();
    if (prevProp === newProp) return false;
    return true;
};
var $c78df6347432a4c1$var$SharedAudioContext = (0, $acw62.createContext)(null);
var $c78df6347432a4c1$var$SharedAudioContextProvider = ({ children: children, numberOfAudioTags: numberOfAudioTags, component: component })=>{
    const audios = (0, $acw62.useRef)([]);
    const [initialNumberOfAudioTags] = (0, $acw62.useState)(numberOfAudioTags);
    if (numberOfAudioTags !== initialNumberOfAudioTags) throw new Error("The number of shared audio tags has changed dynamically. Once you have set this property, you cannot change it afterwards.");
    const refs = (0, $acw62.useMemo)(()=>{
        return new Array(numberOfAudioTags).fill(true).map(()=>{
            return {
                id: Math.random(),
                ref: (0, $acw62.createRef)()
            };
        });
    }, [
        numberOfAudioTags
    ]);
    const takenAudios = (0, $acw62.useRef)(new Array(numberOfAudioTags).fill(false));
    const rerenderAudios = (0, $acw62.useCallback)(()=>{
        refs.forEach(({ ref: ref, id: id })=>{
            const data = audios.current?.find((a)=>a.id === id);
            const { current: current } = ref;
            if (!current) return;
            if (data === undefined) {
                current.src = $c78df6347432a4c1$var$EMPTY_AUDIO;
                return;
            }
            if (!data) throw new TypeError("Expected audio data to be there");
            Object.keys(data.props).forEach((key)=>{
                if ($c78df6347432a4c1$var$didPropChange(key, data.props[key], current[key])) current[key] = data.props[key];
            });
        });
    }, [
        refs
    ]);
    const registerAudio = (0, $acw62.useCallback)((aud, audioId)=>{
        const found = audios.current?.find((a)=>a.audioId === audioId);
        if (found) return found;
        const firstFreeAudio = takenAudios.current.findIndex((a)=>a === false);
        if (firstFreeAudio === -1) throw new Error(`Tried to simultaneously mount ${numberOfAudioTags + 1} <Audio /> tags at the same time. With the current settings, the maximum amount of <Audio /> tags is limited to ${numberOfAudioTags} at the same time. Remotion pre-mounts silent audio tags to help avoid browser autoplay restrictions. See https://remotion.dev/docs/player/autoplay#use-the-numberofsharedaudiotags-property for more information on how to increase this limit.`);
        const { id: id, ref: ref } = refs[firstFreeAudio];
        const cloned = [
            ...takenAudios.current
        ];
        cloned[firstFreeAudio] = id;
        takenAudios.current = cloned;
        const newElem = {
            props: aud,
            id: id,
            el: ref,
            audioId: audioId
        };
        audios.current?.push(newElem);
        rerenderAudios();
        return newElem;
    }, [
        numberOfAudioTags,
        refs,
        rerenderAudios
    ]);
    const unregisterAudio = (0, $acw62.useCallback)((id)=>{
        const cloned = [
            ...takenAudios.current
        ];
        const index = refs.findIndex((r)=>r.id === id);
        if (index === -1) throw new TypeError("Error occured in ");
        cloned[index] = false;
        takenAudios.current = cloned;
        audios.current = audios.current?.filter((a)=>a.id !== id);
        rerenderAudios();
    }, [
        refs,
        rerenderAudios
    ]);
    const updateAudio = (0, $acw62.useCallback)(({ aud: aud, audioId: audioId, id: id })=>{
        let changed = false;
        audios.current = audios.current?.map((prevA)=>{
            if (prevA.id === id) {
                const isTheSame = $c78df6347432a4c1$var$compareProps(aud, prevA.props);
                if (isTheSame) return prevA;
                changed = true;
                return {
                    ...prevA,
                    props: aud,
                    audioId: audioId
                };
            }
            return prevA;
        });
        if (changed) rerenderAudios();
    }, [
        rerenderAudios
    ]);
    const playAllAudios = (0, $acw62.useCallback)(()=>{
        refs.forEach((ref)=>{
            $c78df6347432a4c1$var$playAndHandleNotAllowedError(ref.ref, "audio", null);
        });
    }, [
        refs
    ]);
    const value = (0, $acw62.useMemo)(()=>{
        return {
            registerAudio: registerAudio,
            unregisterAudio: unregisterAudio,
            updateAudio: updateAudio,
            playAllAudios: playAllAudios,
            numberOfAudioTags: numberOfAudioTags
        };
    }, [
        numberOfAudioTags,
        playAllAudios,
        registerAudio,
        unregisterAudio,
        updateAudio
    ]);
    const resetAudio = (0, $acw62.useCallback)(()=>{
        takenAudios.current = new Array(numberOfAudioTags).fill(false);
        audios.current = [];
        rerenderAudios();
    }, [
        numberOfAudioTags,
        rerenderAudios
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            resetAudio();
        };
    }, [
        component,
        resetAudio
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)($c78df6347432a4c1$var$SharedAudioContext.Provider, {
        value: value,
        children: [
            refs.map(({ id: id, ref: ref })=>{
                return (0, $7b02d682eb115277$exports.jsx)("audio", {
                    ref: ref,
                    preload: "metadata",
                    src: $c78df6347432a4c1$var$EMPTY_AUDIO
                }, id);
            }),
            children
        ]
    });
};
var $c78df6347432a4c1$var$useSharedAudio = (aud, audioId)=>{
    const ctx = (0, $acw62.useContext)($c78df6347432a4c1$var$SharedAudioContext);
    const [elem] = (0, $acw62.useState)(()=>{
        if (ctx && ctx.numberOfAudioTags > 0) return ctx.registerAudio(aud, audioId);
        return {
            el: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef(),
            id: Math.random(),
            props: aud,
            audioId: audioId
        };
    });
    const effectToUse = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useInsertionEffect ?? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect;
    if (typeof document !== "undefined") {
        effectToUse(()=>{
            if (ctx && ctx.numberOfAudioTags > 0) ctx.updateAudio({
                id: elem.id,
                aud: aud,
                audioId: audioId
            });
        }, [
            aud,
            ctx,
            elem.id,
            audioId
        ]);
        effectToUse(()=>{
            return ()=>{
                if (ctx && ctx.numberOfAudioTags > 0) ctx.unregisterAudio(elem.id);
            };
        }, [
            ctx,
            elem.id
        ]);
    }
    return elem;
};
var $c78df6347432a4c1$var$AudioForDevelopmentForwardRefFunction = (props, ref)=>{
    const [initialShouldPreMountAudioElements] = (0, $acw62.useState)(props.shouldPreMountAudioTags);
    if (props.shouldPreMountAudioTags !== initialShouldPreMountAudioElements) throw new Error("Cannot change the behavior for pre-mounting audio tags dynamically.");
    const { volume: volume, muted: muted, playbackRate: playbackRate, shouldPreMountAudioTags: shouldPreMountAudioTags, src: src, onDuration: onDuration, acceptableTimeShiftInSeconds: acceptableTimeShiftInSeconds, _remotionInternalNeedsDurationCalculation: _remotionInternalNeedsDurationCalculation, _remotionInternalNativeLoopPassed: _remotionInternalNativeLoopPassed, _remotionInternalStack: _remotionInternalStack, _remotionDebugSeeking: _remotionDebugSeeking, allowAmplificationDuringRender: allowAmplificationDuringRender, name: name, pauseWhenBuffering: pauseWhenBuffering, showInTimeline: showInTimeline, loopVolumeCurveBehavior: loopVolumeCurveBehavior, stack: stack, ...nativeProps } = props;
    const [mediaVolume] = $c78df6347432a4c1$var$useMediaVolumeState();
    const [mediaMuted] = $c78df6347432a4c1$var$useMediaMutedState();
    const volumePropFrame = $c78df6347432a4c1$var$useFrameForVolumeProp(loopVolumeCurveBehavior ?? "repeat");
    const { hidden: hidden } = (0, $acw62.useContext)($c78df6347432a4c1$var$SequenceVisibilityToggleContext);
    if (!src) throw new TypeError("No 'src' was passed to <Audio>.");
    const preloadedSrc = $c78df6347432a4c1$var$usePreload(src);
    const sequenceContext = (0, $acw62.useContext)($c78df6347432a4c1$var$SequenceContext);
    const [timelineId] = (0, $acw62.useState)(()=>String(Math.random()));
    const isSequenceHidden = hidden[timelineId] ?? false;
    const userPreferredVolume = $c78df6347432a4c1$var$evaluateVolume({
        frame: volumePropFrame,
        volume: volume,
        mediaVolume: mediaVolume,
        allowAmplificationDuringRender: false
    });
    const propsToPass = (0, $acw62.useMemo)(()=>{
        return {
            muted: muted || mediaMuted || isSequenceHidden || userPreferredVolume <= 0,
            src: preloadedSrc,
            loop: _remotionInternalNativeLoopPassed,
            ...nativeProps
        };
    }, [
        _remotionInternalNativeLoopPassed,
        isSequenceHidden,
        mediaMuted,
        muted,
        nativeProps,
        preloadedSrc,
        userPreferredVolume
    ]);
    const id = (0, $acw62.useMemo)(()=>`audio-${$c78df6347432a4c1$export$4385e60b38654f68(src ?? "")}-${sequenceContext?.relativeFrom}-${sequenceContext?.cumulatedFrom}-${sequenceContext?.durationInFrames}-muted:${props.muted}-loop:${props.loop}`, [
        src,
        sequenceContext?.relativeFrom,
        sequenceContext?.cumulatedFrom,
        sequenceContext?.durationInFrames,
        props.muted,
        props.loop
    ]);
    const audioRef = $c78df6347432a4c1$var$useSharedAudio(propsToPass, id).el;
    const actualVolume = $c78df6347432a4c1$var$useMediaTagVolume(audioRef);
    $c78df6347432a4c1$var$useSyncVolumeWithMediaTag({
        volumePropFrame: volumePropFrame,
        actualVolume: actualVolume,
        volume: volume,
        mediaVolume: mediaVolume,
        mediaRef: audioRef
    });
    $c78df6347432a4c1$var$useMediaInTimeline({
        volume: volume,
        mediaVolume: mediaVolume,
        mediaRef: audioRef,
        src: src,
        mediaType: "audio",
        playbackRate: playbackRate ?? 1,
        displayName: name ?? null,
        id: timelineId,
        stack: _remotionInternalStack,
        showInTimeline: showInTimeline,
        premountDisplay: null,
        onAutoPlayError: null
    });
    $c78df6347432a4c1$var$useMediaPlayback({
        mediaRef: audioRef,
        src: src,
        mediaType: "audio",
        playbackRate: playbackRate ?? 1,
        onlyWarnForMediaSeekingError: false,
        acceptableTimeshift: acceptableTimeShiftInSeconds ?? $c78df6347432a4c1$var$DEFAULT_ACCEPTABLE_TIMESHIFT,
        isPremounting: Boolean(sequenceContext?.premounting),
        pauseWhenBuffering: pauseWhenBuffering,
        debugSeeking: _remotionDebugSeeking,
        onAutoPlayError: null
    });
    (0, $acw62.useImperativeHandle)(ref, ()=>{
        return audioRef.current;
    }, [
        audioRef
    ]);
    const currentOnDurationCallback = (0, $acw62.useRef)();
    currentOnDurationCallback.current = onDuration;
    (0, $acw62.useEffect)(()=>{
        const { current: current } = audioRef;
        if (!current) return;
        if (current.duration) {
            currentOnDurationCallback.current?.(current.src, current.duration);
            return;
        }
        const onLoadedMetadata = ()=>{
            currentOnDurationCallback.current?.(current.src, current.duration);
        };
        current.addEventListener("loadedmetadata", onLoadedMetadata);
        return ()=>{
            current.removeEventListener("loadedmetadata", onLoadedMetadata);
        };
    }, [
        audioRef,
        src
    ]);
    if (initialShouldPreMountAudioElements) return null;
    return (0, $7b02d682eb115277$exports.jsx)("audio", {
        ref: audioRef,
        preload: "metadata",
        ...propsToPass
    });
};
var $c78df6347432a4c1$var$AudioForPreview = (0, $acw62.forwardRef)($c78df6347432a4c1$var$AudioForDevelopmentForwardRefFunction);
// src/delay-render.ts
if (typeof window !== "undefined") window.remotion_renderReady = false;
var $c78df6347432a4c1$var$handles = [];
if (typeof window !== "undefined") window.remotion_delayRenderTimeouts = {};
var $c78df6347432a4c1$var$DELAY_RENDER_CALLSTACK_TOKEN = "The delayRender was called:";
var $c78df6347432a4c1$var$DELAY_RENDER_RETRIES_LEFT = "Retries left: ";
var $c78df6347432a4c1$var$DELAY_RENDER_RETRY_TOKEN = "- Rendering the frame will be retried.";
var $c78df6347432a4c1$var$defaultTimeout = 30000;
var $c78df6347432a4c1$export$c3ec5096f1c973ca = (label, options)=>{
    if (typeof label !== "string" && typeof label !== "undefined") throw new Error("The label parameter of delayRender() must be a string or undefined, got: " + JSON.stringify(label));
    const handle = Math.random();
    $c78df6347432a4c1$var$handles.push(handle);
    const called = Error().stack?.replace(/^Error/g, "") ?? "";
    if ($c78df6347432a4c1$export$2a36334a5203003d().isRendering) {
        const timeoutToUse = (options?.timeoutInMilliseconds ?? (typeof window === "undefined" ? $c78df6347432a4c1$var$defaultTimeout : window.remotion_puppeteerTimeout ?? $c78df6347432a4c1$var$defaultTimeout)) - 2000;
        if (typeof window !== "undefined") {
            const retriesLeft = (options?.retries ?? 0) - (window.remotion_attempt - 1);
            window.remotion_delayRenderTimeouts[handle] = {
                label: label ?? null,
                timeout: setTimeout(()=>{
                    const message = [
                        `A delayRender()`,
                        label ? `"${label}"` : null,
                        `was called but not cleared after ${timeoutToUse}ms. See https://remotion.dev/docs/timeout for help.`,
                        retriesLeft > 0 ? $c78df6347432a4c1$var$DELAY_RENDER_RETRIES_LEFT + retriesLeft : null,
                        retriesLeft > 0 ? $c78df6347432a4c1$var$DELAY_RENDER_RETRY_TOKEN : null,
                        $c78df6347432a4c1$var$DELAY_RENDER_CALLSTACK_TOKEN,
                        called
                    ].filter($c78df6347432a4c1$var$truthy).join(" ");
                    $c78df6347432a4c1$export$c1ae5abd54a67e52(Error(message));
                }, timeoutToUse)
            };
        }
    }
    if (typeof window !== "undefined") window.remotion_renderReady = false;
    return handle;
};
var $c78df6347432a4c1$export$616bfefa2b04605f = (handle)=>{
    if (typeof handle === "undefined") throw new TypeError("The continueRender() method must be called with a parameter that is the return value of delayRender(). No value was passed.");
    if (typeof handle !== "number") throw new TypeError("The parameter passed into continueRender() must be the return value of delayRender() which is a number. Got: " + JSON.stringify(handle));
    $c78df6347432a4c1$var$handles = $c78df6347432a4c1$var$handles.filter((h)=>{
        if (h === handle) {
            if ($c78df6347432a4c1$export$2a36334a5203003d().isRendering) {
                clearTimeout(window.remotion_delayRenderTimeouts[handle].timeout);
                delete window.remotion_delayRenderTimeouts[handle];
            }
            return false;
        }
        return true;
    });
    if ($c78df6347432a4c1$var$handles.length === 0 && typeof window !== "undefined") window.remotion_renderReady = true;
};
var $c78df6347432a4c1$var$AudioForRenderingRefForwardingFunction = (props, ref)=>{
    const audioRef = (0, $acw62.useRef)(null);
    const { volume: volumeProp, playbackRate: playbackRate, allowAmplificationDuringRender: allowAmplificationDuringRender, onDuration: onDuration, toneFrequency: toneFrequency, _remotionInternalNeedsDurationCalculation: _remotionInternalNeedsDurationCalculation, _remotionInternalNativeLoopPassed: _remotionInternalNativeLoopPassed, acceptableTimeShiftInSeconds: acceptableTimeShiftInSeconds, name: name, onError: onError, delayRenderRetries: delayRenderRetries, delayRenderTimeoutInMilliseconds: delayRenderTimeoutInMilliseconds, loopVolumeCurveBehavior: loopVolumeCurveBehavior, pauseWhenBuffering: pauseWhenBuffering, ...nativeProps } = props;
    const absoluteFrame = $c78df6347432a4c1$var$useTimelinePosition();
    const volumePropFrame = $c78df6347432a4c1$var$useFrameForVolumeProp(loopVolumeCurveBehavior ?? "repeat");
    const frame = $c78df6347432a4c1$export$e82ee3202ebaa1e9();
    const sequenceContext = (0, $acw62.useContext)($c78df6347432a4c1$var$SequenceContext);
    const { registerRenderAsset: registerRenderAsset, unregisterRenderAsset: unregisterRenderAsset } = (0, $acw62.useContext)($c78df6347432a4c1$var$RenderAssetManager);
    const id = (0, $acw62.useMemo)(()=>`audio-${$c78df6347432a4c1$export$4385e60b38654f68(props.src ?? "")}-${sequenceContext?.relativeFrom}-${sequenceContext?.cumulatedFrom}-${sequenceContext?.durationInFrames}`, [
        props.src,
        sequenceContext?.relativeFrom,
        sequenceContext?.cumulatedFrom,
        sequenceContext?.durationInFrames
    ]);
    const volume = $c78df6347432a4c1$var$evaluateVolume({
        volume: volumeProp,
        frame: volumePropFrame,
        mediaVolume: 1,
        allowAmplificationDuringRender: allowAmplificationDuringRender ?? false
    });
    (0, $acw62.useImperativeHandle)(ref, ()=>{
        return audioRef.current;
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!props.src) throw new Error("No src passed");
        if (!window.remotion_audioEnabled) return;
        if (props.muted) return;
        if (volume <= 0) return;
        registerRenderAsset({
            type: "audio",
            src: $c78df6347432a4c1$var$getAbsoluteSrc(props.src),
            id: id,
            frame: absoluteFrame,
            volume: volume,
            mediaFrame: frame,
            playbackRate: props.playbackRate ?? 1,
            allowAmplificationDuringRender: allowAmplificationDuringRender ?? false,
            toneFrequency: toneFrequency ?? null,
            audioStartFrame: Math.max(0, -(sequenceContext?.relativeFrom ?? 0))
        });
        return ()=>unregisterRenderAsset(id);
    }, [
        props.muted,
        props.src,
        registerRenderAsset,
        absoluteFrame,
        id,
        unregisterRenderAsset,
        volume,
        volumePropFrame,
        frame,
        playbackRate,
        props.playbackRate,
        allowAmplificationDuringRender,
        toneFrequency,
        sequenceContext?.relativeFrom
    ]);
    const { src: src } = props;
    const needsToRenderAudioTag = ref || _remotionInternalNeedsDurationCalculation;
    (0, $acw62.useLayoutEffect)(()=>{
        if (window.process?.env?.NODE_ENV === "test") return;
        if (!needsToRenderAudioTag) return;
        const newHandle = $c78df6347432a4c1$export$c3ec5096f1c973ca("Loading <Audio> duration with src=" + src, {
            retries: delayRenderRetries ?? undefined,
            timeoutInMilliseconds: delayRenderTimeoutInMilliseconds ?? undefined
        });
        const { current: current } = audioRef;
        const didLoad = ()=>{
            if (current?.duration) onDuration(current.src, current.duration);
            $c78df6347432a4c1$export$616bfefa2b04605f(newHandle);
        };
        if (current?.duration) {
            onDuration(current.src, current.duration);
            $c78df6347432a4c1$export$616bfefa2b04605f(newHandle);
        } else current?.addEventListener("loadedmetadata", didLoad, {
            once: true
        });
        return ()=>{
            current?.removeEventListener("loadedmetadata", didLoad);
            $c78df6347432a4c1$export$616bfefa2b04605f(newHandle);
        };
    }, [
        src,
        onDuration,
        needsToRenderAudioTag,
        delayRenderRetries,
        delayRenderTimeoutInMilliseconds
    ]);
    if (!needsToRenderAudioTag) return null;
    return (0, $7b02d682eb115277$exports.jsx)("audio", {
        ref: audioRef,
        ...nativeProps
    });
};
var $c78df6347432a4c1$var$AudioForRendering = (0, $acw62.forwardRef)($c78df6347432a4c1$var$AudioForRenderingRefForwardingFunction);
var $c78df6347432a4c1$var$AudioRefForwardingFunction = (props, ref)=>{
    const audioContext = (0, $acw62.useContext)($c78df6347432a4c1$var$SharedAudioContext);
    const { startFrom: startFrom, endAt: endAt, name: name, stack: stack, pauseWhenBuffering: pauseWhenBuffering, showInTimeline: showInTimeline, _remotionDebugSeeking: _remotionDebugSeeking, ...otherProps } = props;
    const { loop: loop3, ...propsOtherThanLoop } = props;
    const { fps: fps } = $c78df6347432a4c1$export$da01606c8b81c2a0();
    const environment = $c78df6347432a4c1$export$2a36334a5203003d();
    const { durations: durations, setDurations: setDurations } = (0, $acw62.useContext)($c78df6347432a4c1$var$DurationsContext);
    if (typeof props.src !== "string") throw new TypeError(`The \`<Audio>\` tag requires a string for \`src\`, but got ${JSON.stringify(props.src)} instead.`);
    const preloadedSrc = $c78df6347432a4c1$var$usePreload(props.src);
    const onError = (0, $acw62.useCallback)((e)=>{
        console.log(e.currentTarget.error);
        const errMessage = `Could not play audio with src ${preloadedSrc}: ${e.currentTarget.error}. See https://remotion.dev/docs/media-playback-error for help.`;
        if (loop3) $c78df6347432a4c1$export$c1ae5abd54a67e52(new Error(errMessage));
        else console.warn(errMessage);
    }, [
        loop3,
        preloadedSrc
    ]);
    const onDuration = (0, $acw62.useCallback)((src, durationInSeconds)=>{
        setDurations({
            type: "got-duration",
            durationInSeconds: durationInSeconds,
            src: src
        });
    }, [
        setDurations
    ]);
    const durationFetched = durations[$c78df6347432a4c1$var$getAbsoluteSrc(preloadedSrc)] ?? durations[$c78df6347432a4c1$var$getAbsoluteSrc(props.src)];
    if (loop3 && durationFetched !== undefined) {
        const duration = durationFetched * fps;
        return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$export$550acbd06a1f5a6a, {
            layout: "none",
            durationInFrames: $c78df6347432a4c1$var$calculateLoopDuration({
                endAt: endAt,
                mediaDuration: duration,
                playbackRate: props.playbackRate ?? 1,
                startFrom: startFrom
            }),
            children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$export$153755f98d9861de, {
                ...propsOtherThanLoop,
                ref: ref,
                _remotionInternalNativeLoopPassed: true
            })
        });
    }
    if (typeof startFrom !== "undefined" || typeof endAt !== "undefined") {
        $c78df6347432a4c1$var$validateStartFromProps(startFrom, endAt);
        const startFromFrameNo = startFrom ?? 0;
        const endAtFrameNo = endAt ?? Infinity;
        return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$export$edde1bcb1b2b310e, {
            layout: "none",
            from: 0 - startFromFrameNo,
            showInTimeline: false,
            durationInFrames: endAtFrameNo,
            name: name,
            children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$export$153755f98d9861de, {
                _remotionInternalNeedsDurationCalculation: Boolean(loop3),
                pauseWhenBuffering: pauseWhenBuffering ?? false,
                ...otherProps,
                ref: ref
            })
        });
    }
    $c78df6347432a4c1$var$validateMediaProps(props, "Audio");
    if (environment.isRendering) return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$AudioForRendering, {
        onDuration: onDuration,
        ...props,
        ref: ref,
        onError: onError,
        _remotionInternalNeedsDurationCalculation: Boolean(loop3)
    });
    return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$AudioForPreview, {
        _remotionInternalNativeLoopPassed: props._remotionInternalNativeLoopPassed ?? false,
        _remotionDebugSeeking: _remotionDebugSeeking ?? false,
        _remotionInternalStack: stack ?? null,
        shouldPreMountAudioTags: audioContext !== null && audioContext.numberOfAudioTags > 0,
        ...props,
        ref: ref,
        onError: onError,
        onDuration: onDuration,
        pauseWhenBuffering: pauseWhenBuffering ?? false,
        _remotionInternalNeedsDurationCalculation: Boolean(loop3),
        showInTimeline: showInTimeline ?? true
    });
};
var $c78df6347432a4c1$export$153755f98d9861de = (0, $acw62.forwardRef)($c78df6347432a4c1$var$AudioRefForwardingFunction);
$c78df6347432a4c1$var$addSequenceStackTraces($c78df6347432a4c1$export$153755f98d9861de);
// src/validation/validate-folder-name.ts
var $c78df6347432a4c1$var$getRegex = ()=>/^([a-zA-Z0-9-\u4E00-\u9FFF])+$/g;
var $c78df6347432a4c1$var$isFolderNameValid = (name)=>name.match($c78df6347432a4c1$var$getRegex());
var $c78df6347432a4c1$var$validateFolderName = (name)=>{
    if (name === undefined || name === null) throw new TypeError("You must pass a name to a <Folder />.");
    if (typeof name !== "string") throw new TypeError(`The "name" you pass into <Folder /> must be a string. Got: ${typeof name}`);
    if (!$c78df6347432a4c1$var$isFolderNameValid(name)) throw new Error(`Folder name can only contain a-z, A-Z, 0-9 and -. You passed ${name}`);
};
var $c78df6347432a4c1$var$invalidFolderNameErrorMessage = `Folder name must match ${String($c78df6347432a4c1$var$getRegex())}`;
var $c78df6347432a4c1$export$6f9af295b3574136 = (0, $acw62.createContext)({
    folderName: null,
    parentName: null
});
var $c78df6347432a4c1$export$80729fed35a16515 = ({ name: name, children: children })=>{
    const parent = (0, $acw62.useContext)($c78df6347432a4c1$export$6f9af295b3574136);
    const { registerFolder: registerFolder, unregisterFolder: unregisterFolder } = (0, $acw62.useContext)($c78df6347432a4c1$var$CompositionManager);
    $c78df6347432a4c1$var$validateFolderName(name);
    const parentNameArr = [
        parent.parentName,
        parent.folderName
    ].filter($c78df6347432a4c1$var$truthy);
    const parentName = parentNameArr.length === 0 ? null : parentNameArr.join("/");
    const value = (0, $acw62.useMemo)(()=>{
        return {
            folderName: name,
            parentName: parentName
        };
    }, [
        name,
        parentName
    ]);
    (0, $acw62.useEffect)(()=>{
        registerFolder(name, parentName);
        return ()=>{
            unregisterFolder(name, parentName);
        };
    }, [
        name,
        parent.folderName,
        parentName,
        registerFolder,
        unregisterFolder
    ]);
    return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$export$6f9af295b3574136.Provider, {
        value: value,
        children: children
    });
};
var $c78df6347432a4c1$var$rotate = {
    transform: `rotate(90deg)`
};
var $c78df6347432a4c1$var$ICON_SIZE = 40;
var $c78df6347432a4c1$var$label = {
    color: "white",
    fontSize: 14,
    fontFamily: "sans-serif"
};
var $c78df6347432a4c1$var$container = {
    justifyContent: "center",
    alignItems: "center"
};
var $c78df6347432a4c1$var$Loading = ()=>{
    return (0, $7b02d682eb115277$exports.jsxs)($c78df6347432a4c1$export$afbd5df19c967c53, {
        style: $c78df6347432a4c1$var$container,
        id: "remotion-comp-loading",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("style", {
                type: "text/css",
                children: `
				@keyframes anim {
					from {
						opacity: 0
					}
					to {
						opacity: 1
					}
				}
				#remotion-comp-loading {
					animation: anim 2s;
					animation-fill-mode: forwards;
				}
			`
            }),
            (0, $7b02d682eb115277$exports.jsx)("svg", {
                width: $c78df6347432a4c1$var$ICON_SIZE,
                height: $c78df6347432a4c1$var$ICON_SIZE,
                viewBox: "-100 -100 400 400",
                style: $c78df6347432a4c1$var$rotate,
                children: (0, $7b02d682eb115277$exports.jsx)("path", {
                    fill: "#555",
                    stroke: "#555",
                    strokeWidth: "100",
                    strokeLinejoin: "round",
                    d: "M 2 172 a 196 100 0 0 0 195 5 A 196 240 0 0 0 100 2.259 A 196 240 0 0 0 2 172 z"
                })
            }),
            (0, $7b02d682eb115277$exports.jsxs)("p", {
                style: $c78df6347432a4c1$var$label,
                children: [
                    "Resolving ",
                    "<Suspense>",
                    "..."
                ]
            })
        ]
    });
};
// src/portal-node.ts
var $c78df6347432a4c1$var$_portalNode = null;
var $c78df6347432a4c1$var$portalNode = ()=>{
    if (!$c78df6347432a4c1$var$_portalNode) {
        if (typeof document === "undefined") throw new Error("Tried to call an API that only works in the browser from outside the browser");
        $c78df6347432a4c1$var$_portalNode = document.createElement("div");
        $c78df6347432a4c1$var$_portalNode.style.position = "absolute";
        $c78df6347432a4c1$var$_portalNode.style.top = "0px";
        $c78df6347432a4c1$var$_portalNode.style.left = "0px";
        $c78df6347432a4c1$var$_portalNode.style.right = "0px";
        $c78df6347432a4c1$var$_portalNode.style.bottom = "0px";
        $c78df6347432a4c1$var$_portalNode.style.width = "100%";
        $c78df6347432a4c1$var$_portalNode.style.height = "100%";
        $c78df6347432a4c1$var$_portalNode.style.display = "flex";
        $c78df6347432a4c1$var$_portalNode.style.flexDirection = "column";
        const containerNode = document.createElement("div");
        containerNode.style.position = "fixed";
        containerNode.style.top = "-999999px";
        containerNode.appendChild($c78df6347432a4c1$var$_portalNode);
        document.body.appendChild(containerNode);
    }
    return $c78df6347432a4c1$var$_portalNode;
};
var $c78df6347432a4c1$var$useLazyComponent = (compProps)=>{
    const lazy = (0, $acw62.useMemo)(()=>{
        if ("lazyComponent" in compProps && typeof compProps.lazyComponent !== "undefined") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(compProps.lazyComponent);
        if ("component" in compProps) {
            if (typeof document === "undefined") return compProps.component;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(()=>Promise.resolve({
                    default: compProps.component
                }));
        }
        throw new Error("You must pass either 'component' or 'lazyComponent'");
    }, [
        compProps.component,
        compProps.lazyComponent
    ]);
    return lazy;
};
// src/validation/validate-composition-id.ts
var $c78df6347432a4c1$var$getRegex2 = ()=>/^([a-zA-Z0-9-\u4E00-\u9FFF])+$/g;
var $c78df6347432a4c1$var$isCompositionIdValid = (id)=>id.match($c78df6347432a4c1$var$getRegex2());
var $c78df6347432a4c1$var$validateCompositionId = (id)=>{
    if (!$c78df6347432a4c1$var$isCompositionIdValid(id)) throw new Error(`Composition id can only contain a-z, A-Z, 0-9, CJK characters and -. You passed ${id}`);
};
var $c78df6347432a4c1$var$invalidCompositionErrorMessage = `Composition ID must match ${String($c78df6347432a4c1$var$getRegex2())}`;
// src/validation/validate-default-props.ts
var $c78df6347432a4c1$var$validateDefaultAndInputProps = (defaultProps, name, compositionId)=>{
    if (!defaultProps) return;
    if (typeof defaultProps !== "object") throw new Error(`"${name}" must be an object, but you passed a value of type ${typeof defaultProps}`);
    if (Array.isArray(defaultProps)) throw new Error(`"${name}" must be an object, an array was passed ${compositionId ? `for composition "${compositionId}"` : ""}`);
};
var $c78df6347432a4c1$var$ClipComposition = ({ children: children })=>{
    const { clipRegion: clipRegion } = (0, $acw62.useContext)($c78df6347432a4c1$var$NativeLayersContext);
    const style = (0, $acw62.useMemo)(()=>{
        return {
            display: "flex",
            flexDirection: "row",
            opacity: clipRegion === "hide" ? 0 : 1,
            clipPath: clipRegion && clipRegion !== "hide" ? `polygon(${clipRegion.x}px ${clipRegion.y}px, ${clipRegion.x}px ${clipRegion.height + clipRegion.y}px, ${clipRegion.width + clipRegion.x}px ${clipRegion.height + clipRegion.y}px, ${clipRegion.width + clipRegion.x}px ${clipRegion.y}px)` : undefined
        };
    }, [
        clipRegion
    ]);
    return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$export$afbd5df19c967c53, {
        style: style,
        children: children
    });
};
var $c78df6347432a4c1$var$Fallback = ()=>{
    (0, $acw62.useEffect)(()=>{
        const fallback = $c78df6347432a4c1$export$c3ec5096f1c973ca("Waiting for Root component to unsuspend");
        return ()=>$c78df6347432a4c1$export$616bfefa2b04605f(fallback);
    }, []);
    return null;
};
var $c78df6347432a4c1$export$d955f48b7132ae28 = ({ width: width, height: height, fps: fps, durationInFrames: durationInFrames, id: id, defaultProps: defaultProps, schema: schema, ...compProps })=>{
    const { registerComposition: registerComposition, unregisterComposition: unregisterComposition } = (0, $acw62.useContext)($c78df6347432a4c1$var$CompositionManager);
    const video = $c78df6347432a4c1$var$useVideo();
    const lazy = $c78df6347432a4c1$var$useLazyComponent(compProps);
    const nonce5 = $c78df6347432a4c1$var$useNonce();
    const isPlayer = $c78df6347432a4c1$var$useIsPlayer();
    const environment = $c78df6347432a4c1$export$2a36334a5203003d();
    const canUseComposition = (0, $acw62.useContext)($c78df6347432a4c1$var$CanUseRemotionHooks);
    if (canUseComposition) {
        if (isPlayer) throw new Error("<Composition> was mounted inside the `component` that was passed to the <Player>. See https://remotion.dev/docs/wrong-composition-mount for help.");
        throw new Error("<Composition> mounted inside another composition. See https://remotion.dev/docs/wrong-composition-mount for help.");
    }
    const { folderName: folderName, parentName: parentName } = (0, $acw62.useContext)($c78df6347432a4c1$export$6f9af295b3574136);
    (0, $acw62.useEffect)(()=>{
        if (!id) throw new Error("No id for composition passed.");
        $c78df6347432a4c1$var$validateCompositionId(id);
        $c78df6347432a4c1$var$validateDefaultAndInputProps(defaultProps, "defaultProps", id);
        registerComposition({
            durationInFrames: durationInFrames ?? undefined,
            fps: fps ?? undefined,
            height: height ?? undefined,
            width: width ?? undefined,
            id: id,
            folderName: folderName,
            component: lazy,
            defaultProps: $c78df6347432a4c1$var$serializeThenDeserializeInStudio(defaultProps ?? {}),
            nonce: nonce5,
            parentFolderName: parentName,
            schema: schema ?? null,
            calculateMetadata: compProps.calculateMetadata ?? null
        });
        return ()=>{
            unregisterComposition(id);
        };
    }, [
        durationInFrames,
        fps,
        height,
        lazy,
        id,
        folderName,
        defaultProps,
        registerComposition,
        unregisterComposition,
        width,
        nonce5,
        parentName,
        schema,
        compProps.calculateMetadata
    ]);
    const resolved = $c78df6347432a4c1$var$useResolvedVideoConfig(id);
    if (environment.isStudio && video && video.component === lazy) {
        const Comp = lazy;
        if (resolved === null || resolved.type !== "success") return null;
        return (0, $1u0KT.createPortal)((0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$ClipComposition, {
            children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$CanUseRemotionHooksProvider, {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Suspense), {
                    fallback: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$Loading, {}),
                    children: (0, $7b02d682eb115277$exports.jsx)(Comp, {
                        ...resolved.result.props ?? {}
                    })
                })
            })
        }), $c78df6347432a4c1$var$portalNode());
    }
    if (environment.isRendering && video && video.component === lazy) {
        const Comp = lazy;
        if (resolved === null || resolved.type !== "success") return null;
        return (0, $1u0KT.createPortal)((0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$CanUseRemotionHooksProvider, {
            children: (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Suspense), {
                fallback: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$Fallback, {}),
                children: (0, $7b02d682eb115277$exports.jsx)(Comp, {
                    ...resolved.result.props ?? {}
                })
            })
        }), $c78df6347432a4c1$var$portalNode());
    }
    return null;
};
var $c78df6347432a4c1$var$compositionsRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef();
var $c78df6347432a4c1$var$CompositionManagerProvider = ({ children: children, numberOfAudioTags: numberOfAudioTags })=>{
    const [compositions, setCompositions] = (0, $acw62.useState)([]);
    const currentcompositionsRef = (0, $acw62.useRef)(compositions);
    const [folders, setFolders] = (0, $acw62.useState)([]);
    const [canvasContent, setCanvasContent] = (0, $acw62.useState)(null);
    const [currentCompositionMetadata, setCurrentCompositionMetadata] = (0, $acw62.useState)(null);
    const updateCompositions = (0, $acw62.useCallback)((updateComps)=>{
        setCompositions((comps)=>{
            const updated = updateComps(comps);
            currentcompositionsRef.current = updated;
            return updated;
        });
    }, []);
    const registerComposition = (0, $acw62.useCallback)((comp)=>{
        updateCompositions((comps)=>{
            if (comps.find((c)=>c.id === comp.id)) throw new Error(`Multiple composition with id ${comp.id} are registered.`);
            const value = [
                ...comps,
                comp
            ].slice().sort((a, b)=>a.nonce - b.nonce);
            return value;
        });
    }, [
        updateCompositions
    ]);
    const unregisterComposition = (0, $acw62.useCallback)((id)=>{
        setCompositions((comps)=>{
            return comps.filter((c)=>c.id !== id);
        });
    }, []);
    const registerFolder = (0, $acw62.useCallback)((name, parent)=>{
        setFolders((prevFolders)=>{
            return [
                ...prevFolders,
                {
                    name: name,
                    parent: parent
                }
            ];
        });
    }, []);
    const unregisterFolder = (0, $acw62.useCallback)((name, parent)=>{
        setFolders((prevFolders)=>{
            return prevFolders.filter((p)=>!(p.name === name && p.parent === parent));
        });
    }, []);
    (0, $acw62.useImperativeHandle)($c78df6347432a4c1$var$compositionsRef, ()=>{
        return {
            getCompositions: ()=>currentcompositionsRef.current
        };
    }, []);
    const composition = compositions.find((c)=>canvasContent?.type === "composition" ? c.id === canvasContent.compositionId : null);
    const updateCompositionDefaultProps = (0, $acw62.useCallback)((id, newDefaultProps)=>{
        setCompositions((comps)=>{
            const updated = comps.map((c)=>{
                if (c.id === id) return {
                    ...c,
                    defaultProps: newDefaultProps
                };
                return c;
            });
            return updated;
        });
    }, []);
    const contextValue = (0, $acw62.useMemo)(()=>{
        return {
            compositions: compositions,
            registerComposition: registerComposition,
            unregisterComposition: unregisterComposition,
            folders: folders,
            registerFolder: registerFolder,
            unregisterFolder: unregisterFolder,
            currentCompositionMetadata: currentCompositionMetadata,
            setCurrentCompositionMetadata: setCurrentCompositionMetadata,
            canvasContent: canvasContent,
            setCanvasContent: setCanvasContent,
            updateCompositionDefaultProps: updateCompositionDefaultProps
        };
    }, [
        compositions,
        registerComposition,
        unregisterComposition,
        folders,
        registerFolder,
        unregisterFolder,
        currentCompositionMetadata,
        canvasContent,
        updateCompositionDefaultProps
    ]);
    return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$CompositionManager.Provider, {
        value: contextValue,
        children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$SequenceManagerProvider, {
            children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$RenderAssetManagerProvider, {
                children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$ResolveCompositionConfig, {
                    children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$SharedAudioContextProvider, {
                        numberOfAudioTags: numberOfAudioTags,
                        component: composition?.component ?? null,
                        children: children
                    })
                })
            })
        })
    });
};
// src/bezier.ts
var $c78df6347432a4c1$var$a = function(aA1, aA2) {
    return 1 - 3 * aA2 + 3 * aA1;
};
var $c78df6347432a4c1$var$b = function(aA1, aA2) {
    return 3 * aA2 - 6 * aA1;
};
var $c78df6347432a4c1$var$c = function(aA1) {
    return 3 * aA1;
};
var $c78df6347432a4c1$var$calcBezier = function(aT, aA1, aA2) {
    return (($c78df6347432a4c1$var$a(aA1, aA2) * aT + $c78df6347432a4c1$var$b(aA1, aA2)) * aT + $c78df6347432a4c1$var$c(aA1)) * aT;
};
var $c78df6347432a4c1$var$getSlope = function(aT, aA1, aA2) {
    return 3 * $c78df6347432a4c1$var$a(aA1, aA2) * aT * aT + 2 * $c78df6347432a4c1$var$b(aA1, aA2) * aT + $c78df6347432a4c1$var$c(aA1);
};
var $c78df6347432a4c1$var$binarySubdivide = function({ aX: aX, _aA: _aA, _aB: _aB, mX1: mX1, mX2: mX2 }) {
    let currentX;
    let currentT;
    let i = 0;
    let aA = _aA;
    let aB = _aB;
    do {
        currentT = aA + (aB - aA) / 2;
        currentX = $c78df6347432a4c1$var$calcBezier(currentT, mX1, mX2) - aX;
        if (currentX > 0) aB = currentT;
        else aA = currentT;
    }while (Math.abs(currentX) > $c78df6347432a4c1$var$SUBDIVISION_PRECISION && ++i < $c78df6347432a4c1$var$SUBDIVISION_MAX_ITERATIONS);
    return currentT;
};
var $c78df6347432a4c1$var$newtonRaphsonIterate = function(aX, _aGuessT, mX1, mX2) {
    let aGuessT = _aGuessT;
    for(let i = 0; i < $c78df6347432a4c1$var$NEWTON_ITERATIONS; ++i){
        const currentSlope = $c78df6347432a4c1$var$getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0) return aGuessT;
        const currentX = $c78df6347432a4c1$var$calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
};
function $c78df6347432a4c1$var$bezier(mX1, mY1, mX2, mY2) {
    if (!(mX1 >= 0 && mX1 <= 1 && mX2 >= 0 && mX2 <= 1)) throw new Error("bezier x values must be in [0, 1] range");
    const sampleValues = $c78df6347432a4c1$var$float32ArraySupported ? new Float32Array($c78df6347432a4c1$var$kSplineTableSize) : new Array($c78df6347432a4c1$var$kSplineTableSize);
    if (mX1 !== mY1 || mX2 !== mY2) for(let i = 0; i < $c78df6347432a4c1$var$kSplineTableSize; ++i)sampleValues[i] = $c78df6347432a4c1$var$calcBezier(i * $c78df6347432a4c1$var$kSampleStepSize, mX1, mX2);
    function getTForX(aX) {
        let intervalStart = 0;
        let currentSample = 1;
        const lastSample = $c78df6347432a4c1$var$kSplineTableSize - 1;
        for(; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample)intervalStart += $c78df6347432a4c1$var$kSampleStepSize;
        --currentSample;
        const dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        const guessForT = intervalStart + dist * $c78df6347432a4c1$var$kSampleStepSize;
        const initialSlope = $c78df6347432a4c1$var$getSlope(guessForT, mX1, mX2);
        if (initialSlope >= $c78df6347432a4c1$var$NEWTON_MIN_SLOPE) return $c78df6347432a4c1$var$newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        if (initialSlope === 0) return guessForT;
        return $c78df6347432a4c1$var$binarySubdivide({
            aX: aX,
            _aA: intervalStart,
            _aB: intervalStart + $c78df6347432a4c1$var$kSampleStepSize,
            mX1: mX1,
            mX2: mX2
        });
    }
    return function(x) {
        if (mX1 === mY1 && mX2 === mY2) return x;
        if (x === 0) return 0;
        if (x === 1) return 1;
        return $c78df6347432a4c1$var$calcBezier(getTForX(x), mY1, mY2);
    };
}
var $c78df6347432a4c1$var$NEWTON_ITERATIONS = 4;
var $c78df6347432a4c1$var$NEWTON_MIN_SLOPE = 0.001;
var $c78df6347432a4c1$var$SUBDIVISION_PRECISION = 0.0000001;
var $c78df6347432a4c1$var$SUBDIVISION_MAX_ITERATIONS = 10;
var $c78df6347432a4c1$var$kSplineTableSize = 11;
var $c78df6347432a4c1$var$kSampleStepSize = 1 / ($c78df6347432a4c1$var$kSplineTableSize - 1);
var $c78df6347432a4c1$var$float32ArraySupported = typeof Float32Array === "function";
// src/easing.ts
class $c78df6347432a4c1$export$cea96571ebbff9dd {
    static step0(n) {
        return n > 0 ? 1 : 0;
    }
    static step1(n) {
        return n >= 1 ? 1 : 0;
    }
    static linear(t) {
        return t;
    }
    static ease(t) {
        return $c78df6347432a4c1$export$cea96571ebbff9dd.bezier(0.42, 0, 1, 1)(t);
    }
    static quad(t) {
        return t * t;
    }
    static cubic(t) {
        return t * t * t;
    }
    static poly(n) {
        return (t)=>t ** n;
    }
    static sin(t) {
        return 1 - Math.cos(t * Math.PI / 2);
    }
    static circle(t) {
        return 1 - Math.sqrt(1 - t * t);
    }
    static exp(t) {
        return 2 ** (10 * (t - 1));
    }
    static elastic(bounciness = 1) {
        const p = bounciness * Math.PI;
        return (t)=>1 - Math.cos(t * Math.PI / 2) ** 3 * Math.cos(t * p);
    }
    static back(s = 1.70158) {
        return (t)=>t * t * ((s + 1) * t - s);
    }
    static bounce(t) {
        if (t < 1 / 2.75) return 7.5625 * t * t;
        if (t < 2 / 2.75) {
            const t2_ = t - 1.5 / 2.75;
            return 7.5625 * t2_ * t2_ + 0.75;
        }
        if (t < 2.5 / 2.75) {
            const t2_ = t - 2.25 / 2.75;
            return 7.5625 * t2_ * t2_ + 0.9375;
        }
        const t2 = t - 2.625 / 2.75;
        return 7.5625 * t2 * t2 + 0.984375;
    }
    static bezier(x1, y1, x2, y2) {
        return $c78df6347432a4c1$var$bezier(x1, y1, x2, y2);
    }
    static in(easing) {
        return easing;
    }
    static out(easing) {
        return (t)=>1 - easing(1 - t);
    }
    static inOut(easing) {
        return (t)=>{
            if (t < 0.5) return easing(t * 2) / 2;
            return 1 - easing((1 - t) * 2) / 2;
        };
    }
}
// src/v5-flag.ts
var $c78df6347432a4c1$var$ENABLE_V5_BREAKING_CHANGES = false;
// src/get-static-files.ts
var $c78df6347432a4c1$var$warnedServer = false;
var $c78df6347432a4c1$var$warnedPlayer = false;
var $c78df6347432a4c1$var$warnServerOnce = ()=>{
    if ($c78df6347432a4c1$var$warnedServer) return;
    $c78df6347432a4c1$var$warnedServer = true;
    console.warn("Called getStaticFiles() on the server. The API is only available in the browser. An empty array was returned.");
};
var $c78df6347432a4c1$var$warnPlayerOnce = ()=>{
    if ($c78df6347432a4c1$var$warnedPlayer) return;
    $c78df6347432a4c1$var$warnedPlayer = true;
    console.warn("Called getStaticFiles() while using the Remotion Player. The API is only available while using the Remotion Studio. An empty array was returned.");
};
var $c78df6347432a4c1$export$a72d07badb469992 = ()=>{
    if ($c78df6347432a4c1$var$ENABLE_V5_BREAKING_CHANGES) throw new Error("getStaticFiles() has moved into the `@remotion/studio` package. Update your imports.");
    if (typeof document === "undefined") {
        $c78df6347432a4c1$var$warnServerOnce();
        return [];
    }
    if (window.remotion_isPlayer) {
        $c78df6347432a4c1$var$warnPlayerOnce();
        return [];
    }
    return window.remotion_staticFiles;
};
var $c78df6347432a4c1$var$IFrameRefForwarding = ({ onLoad: onLoad, onError: onError, delayRenderRetries: delayRenderRetries, delayRenderTimeoutInMilliseconds: delayRenderTimeoutInMilliseconds, ...props2 }, ref)=>{
    const [handle] = (0, $acw62.useState)(()=>$c78df6347432a4c1$export$c3ec5096f1c973ca(`Loading <IFrame> with source ${props2.src}`, {
            retries: delayRenderRetries ?? undefined,
            timeoutInMilliseconds: delayRenderTimeoutInMilliseconds ?? undefined
        }));
    const didLoad = (0, $acw62.useCallback)((e)=>{
        $c78df6347432a4c1$export$616bfefa2b04605f(handle);
        onLoad?.(e);
    }, [
        handle,
        onLoad
    ]);
    const didGetError = (0, $acw62.useCallback)((e)=>{
        $c78df6347432a4c1$export$616bfefa2b04605f(handle);
        if (onError) onError(e);
        else console.error("Error loading iframe:", e, "Handle the event using the onError() prop to make this message disappear.");
    }, [
        handle,
        onError
    ]);
    return (0, $7b02d682eb115277$exports.jsx)("iframe", {
        ...props2,
        ref: ref,
        onError: didGetError,
        onLoad: didLoad
    });
};
var $c78df6347432a4c1$export$b32b5f1ee4493319 = (0, $acw62.forwardRef)($c78df6347432a4c1$var$IFrameRefForwarding);
var $c78df6347432a4c1$var$exponentialBackoff = function(errorCount) {
    return 1000 * 2 ** (errorCount - 1);
};
var $c78df6347432a4c1$var$ImgRefForwarding = ({ onError: onError, maxRetries: maxRetries = 2, src: src, pauseWhenLoading: pauseWhenLoading, delayRenderRetries: delayRenderRetries, delayRenderTimeoutInMilliseconds: delayRenderTimeoutInMilliseconds, onImageFrame: onImageFrame, ...props2 }, ref)=>{
    const imageRef = (0, $acw62.useRef)(null);
    const errors = (0, $acw62.useRef)({});
    const { delayPlayback: delayPlayback } = $c78df6347432a4c1$export$e20082a880d111ba();
    const sequenceContext = (0, $acw62.useContext)($c78df6347432a4c1$var$SequenceContext);
    if (!src) throw new Error('No "src" prop was passed to <Img>.');
    (0, $acw62.useImperativeHandle)(ref, ()=>{
        return imageRef.current;
    }, []);
    const actualSrc = $c78df6347432a4c1$var$usePreload(src);
    const retryIn = (0, $acw62.useCallback)((timeout)=>{
        if (!imageRef.current) return;
        const currentSrc = imageRef.current.src;
        setTimeout(()=>{
            if (!imageRef.current) return;
            const newSrc = imageRef.current?.src;
            if (newSrc !== currentSrc) return;
            imageRef.current.removeAttribute("src");
            imageRef.current.setAttribute("src", newSrc);
        }, timeout);
    }, []);
    const didGetError = (0, $acw62.useCallback)((e)=>{
        if (!errors.current) return;
        errors.current[imageRef.current?.src] = (errors.current[imageRef.current?.src] ?? 0) + 1;
        if (onError && (errors.current[imageRef.current?.src] ?? 0) > maxRetries) {
            onError(e);
            return;
        }
        if ((errors.current[imageRef.current?.src] ?? 0) <= maxRetries) {
            const backoff = $c78df6347432a4c1$var$exponentialBackoff(errors.current[imageRef.current?.src] ?? 0);
            console.warn(`Could not load image with source ${imageRef.current?.src}, retrying again in ${backoff}ms`);
            retryIn(backoff);
            return;
        }
        $c78df6347432a4c1$export$c1ae5abd54a67e52("Error loading image with src: " + imageRef.current?.src);
    }, [
        maxRetries,
        onError,
        retryIn
    ]);
    if (typeof window !== "undefined") {
        const isPremounting = Boolean(sequenceContext?.premounting);
        (0, $acw62.useLayoutEffect)(()=>{
            if (window.process?.env?.NODE_ENV === "test") return;
            const newHandle = $c78df6347432a4c1$export$c3ec5096f1c973ca("Loading <Img> with src=" + actualSrc, {
                retries: delayRenderRetries ?? undefined,
                timeoutInMilliseconds: delayRenderTimeoutInMilliseconds ?? undefined
            });
            const unblock = pauseWhenLoading && !isPremounting ? delayPlayback().unblock : ()=>{
                return;
            };
            const { current: current } = imageRef;
            const onComplete = ()=>{
                if ((errors.current[imageRef.current?.src] ?? 0) > 0) {
                    delete errors.current[imageRef.current?.src];
                    console.info(`Retry successful - ${imageRef.current?.src} is now loaded`);
                }
                if (current) onImageFrame?.(current);
                unblock();
                $c78df6347432a4c1$export$616bfefa2b04605f(newHandle);
            };
            const didLoad = ()=>{
                onComplete();
            };
            if (current?.complete) onComplete();
            else current?.addEventListener("load", didLoad, {
                once: true
            });
            return ()=>{
                current?.removeEventListener("load", didLoad);
                unblock();
                $c78df6347432a4c1$export$616bfefa2b04605f(newHandle);
            };
        }, [
            actualSrc,
            delayPlayback,
            delayRenderRetries,
            delayRenderTimeoutInMilliseconds,
            pauseWhenLoading,
            isPremounting,
            onImageFrame
        ]);
    }
    return (0, $7b02d682eb115277$exports.jsx)("img", {
        ...props2,
        ref: imageRef,
        src: actualSrc,
        onError: didGetError
    });
};
var $c78df6347432a4c1$export$cc7b5f925acc71d3 = (0, $acw62.forwardRef)($c78df6347432a4c1$var$ImgRefForwarding);
// src/default-css.ts
var $c78df6347432a4c1$var$exports_default_css = {};
$c78df6347432a4c1$var$__export($c78df6347432a4c1$var$exports_default_css, {
    makeDefaultPreviewCSS: ()=>$c78df6347432a4c1$var$makeDefaultPreviewCSS,
    injectCSS: ()=>$c78df6347432a4c1$var$injectCSS,
    OFFTHREAD_VIDEO_CLASS_NAME: ()=>$c78df6347432a4c1$var$OFFTHREAD_VIDEO_CLASS_NAME
});
var $c78df6347432a4c1$var$injected = {};
var $c78df6347432a4c1$var$injectCSS = (css)=>{
    if (typeof document === "undefined") return;
    if ($c78df6347432a4c1$var$injected[css]) return;
    const head = document.head || document.getElementsByTagName("head")[0];
    const style = document.createElement("style");
    style.appendChild(document.createTextNode(css));
    head.prepend(style);
    $c78df6347432a4c1$var$injected[css] = true;
};
var $c78df6347432a4c1$var$OFFTHREAD_VIDEO_CLASS_NAME = "__remotion_offthreadvideo";
var $c78df6347432a4c1$var$makeDefaultPreviewCSS = (scope, backgroundColor)=>{
    if (!scope) return `
    * {
      box-sizing: border-box;
    }
    body {
      margin: 0;
	    background-color: ${backgroundColor};
    }
    .${$c78df6347432a4c1$var$OFFTHREAD_VIDEO_CLASS_NAME} {
      object-fit: contain;
    }
    `;
    return `
    ${scope} * {
      box-sizing: border-box;
    }
    ${scope} *:-webkit-full-screen {
      width: 100%;
      height: 100%;
    }
    ${scope} .${$c78df6347432a4c1$var$OFFTHREAD_VIDEO_CLASS_NAME} {
      object-fit: contain;
    }
  `;
};
// src/get-preview-dom-element.ts
var $c78df6347432a4c1$var$REMOTION_STUDIO_CONTAINER_ELEMENT = "__remotion-studio-container";
var $c78df6347432a4c1$var$getPreviewDomElement = ()=>{
    return document.getElementById($c78df6347432a4c1$var$REMOTION_STUDIO_CONTAINER_ELEMENT);
};
// src/register-root.ts
var $c78df6347432a4c1$var$Root = null;
var $c78df6347432a4c1$var$listeners = [];
var $c78df6347432a4c1$export$1799a3c442238c4 = (comp)=>{
    if (!comp) throw new Error(`You must pass a React component to registerRoot(), but ${JSON.stringify(comp)} was passed.`);
    if ($c78df6347432a4c1$var$Root) throw new Error("registerRoot() was called more than once.");
    $c78df6347432a4c1$var$Root = comp;
    $c78df6347432a4c1$var$listeners.forEach((l)=>{
        l(comp);
    });
};
var $c78df6347432a4c1$var$getRoot = ()=>{
    return $c78df6347432a4c1$var$Root;
};
var $c78df6347432a4c1$var$waitForRoot = (fn)=>{
    if ($c78df6347432a4c1$var$Root) {
        fn($c78df6347432a4c1$var$Root);
        return ()=>{
            return;
        };
    }
    $c78df6347432a4c1$var$listeners.push(fn);
    return ()=>{
        $c78df6347432a4c1$var$listeners = $c78df6347432a4c1$var$listeners.filter((l)=>l !== fn);
    };
};
var $c78df6347432a4c1$var$RemotionRoot = ({ children: children, numberOfAudioTags: numberOfAudioTags })=>{
    const [remotionRootId] = (0, $acw62.useState)(()=>String($c78df6347432a4c1$export$4385e60b38654f68(null)));
    const [frame, setFrame] = (0, $acw62.useState)(()=>$c78df6347432a4c1$var$getInitialFrameState());
    const [playing, setPlaying] = (0, $acw62.useState)(false);
    const imperativePlaying = (0, $acw62.useRef)(false);
    const [fastRefreshes, setFastRefreshes] = (0, $acw62.useState)(0);
    const [playbackRate, setPlaybackRate] = (0, $acw62.useState)(1);
    const audioAndVideoTags = (0, $acw62.useRef)([]);
    if (typeof window !== "undefined") (0, $acw62.useLayoutEffect)(()=>{
        window.remotion_setFrame = (f, composition, attempt)=>{
            window.remotion_attempt = attempt;
            const id = $c78df6347432a4c1$export$c3ec5096f1c973ca(`Setting the current frame to ${f}`);
            let asyncUpdate = true;
            setFrame((s)=>{
                const currentFrame = s[composition] ?? window.remotion_initialFrame;
                if (currentFrame === f) {
                    asyncUpdate = false;
                    return s;
                }
                return {
                    ...s,
                    [composition]: f
                };
            });
            if (asyncUpdate) requestAnimationFrame(()=>$c78df6347432a4c1$export$616bfefa2b04605f(id));
            else $c78df6347432a4c1$export$616bfefa2b04605f(id);
        };
        window.remotion_isPlayer = false;
    }, []);
    const timelineContextValue = (0, $acw62.useMemo)(()=>{
        return {
            frame: frame,
            playing: playing,
            imperativePlaying: imperativePlaying,
            rootId: remotionRootId,
            playbackRate: playbackRate,
            setPlaybackRate: setPlaybackRate,
            audioAndVideoTags: audioAndVideoTags
        };
    }, [
        frame,
        playbackRate,
        playing,
        remotionRootId
    ]);
    const setTimelineContextValue = (0, $acw62.useMemo)(()=>{
        return {
            setFrame: setFrame,
            setPlaying: setPlaying
        };
    }, []);
    const nonceContext = (0, $acw62.useMemo)(()=>{
        let counter = 0;
        return {
            getNonce: ()=>counter++,
            fastRefreshes: fastRefreshes
        };
    }, [
        fastRefreshes
    ]);
    (0, $acw62.useEffect)(()=>{
        if (typeof __webpack_module__ !== "undefined") {
            if (__webpack_module__.hot) __webpack_module__.hot.addStatusHandler((status)=>{
                if (status === "idle") setFastRefreshes((i)=>i + 1);
            });
        }
    }, []);
    return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$NonceContext.Provider, {
        value: nonceContext,
        children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$TimelineContext.Provider, {
            value: timelineContextValue,
            children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$SetTimelineContext.Provider, {
                value: setTimelineContextValue,
                children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$EditorPropsProvider, {
                    children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$PrefetchProvider, {
                        children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$NativeLayersProvider, {
                            children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$CompositionManagerProvider, {
                                numberOfAudioTags: numberOfAudioTags,
                                children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$DurationsContextProvider, {
                                    children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$BufferingProvider, {
                                        children: children
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
// src/setup-env-variables.ts
var $c78df6347432a4c1$var$getEnvVariables = ()=>{
    if ($c78df6347432a4c1$export$2a36334a5203003d().isRendering) {
        const param = window.remotion_envVariables;
        if (!param) return {};
        return {
            ...JSON.parse(param),
            NODE_ENV: "production"
        };
    }
    return {
        NODE_ENV: "production"
    };
};
var $c78df6347432a4c1$var$setupEnvVariables = ()=>{
    const env = $c78df6347432a4c1$var$getEnvVariables();
    if (!window.process) window.process = {};
    if (!window.process.env) window.process.env = {};
    Object.keys(env).forEach((key)=>{
        window.process.env[key] = env[key];
    });
};
var $c78df6347432a4c1$var$CurrentScaleContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
var $c78df6347432a4c1$var$PreviewSizeContext = (0, $acw62.createContext)({
    setSize: ()=>{
        return;
    },
    size: {
        size: "auto",
        translation: {
            x: 0,
            y: 0
        }
    }
});
var $c78df6347432a4c1$var$calculateScale = ({ canvasSize: canvasSize, compositionHeight: compositionHeight, compositionWidth: compositionWidth, previewSize: previewSize })=>{
    const heightRatio = canvasSize.height / compositionHeight;
    const widthRatio = canvasSize.width / compositionWidth;
    const ratio = Math.min(heightRatio, widthRatio);
    return previewSize === "auto" ? ratio : Number(previewSize);
};
var $c78df6347432a4c1$export$cee0d53d9893b3a0 = (options)=>{
    const hasContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($c78df6347432a4c1$var$CurrentScaleContext);
    const zoomContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($c78df6347432a4c1$var$PreviewSizeContext);
    const config = $c78df6347432a4c1$var$useUnsafeVideoConfig();
    if (hasContext === null || config === null || zoomContext === null) {
        if (options?.dontThrowIfOutsideOfRemotion) return 1;
        if ($c78df6347432a4c1$export$2a36334a5203003d().isRendering) return 1;
        throw new Error([
            "useCurrentScale() was called outside of a Remotion context.",
            "This hook can only be called in a component that is being rendered by Remotion.",
            "If you want to this hook to return 1 outside of Remotion, pass {dontThrowIfOutsideOfRemotion: true} as an option.",
            "If you think you called this hook in a Remotion component, make sure all versions of Remotion are aligned."
        ].join("\n"));
    }
    if (hasContext.type === "scale") return hasContext.scale;
    return $c78df6347432a4c1$var$calculateScale({
        canvasSize: hasContext.canvasSize,
        compositionHeight: config.height,
        compositionWidth: config.width,
        previewSize: zoomContext.size.size
    });
};
// src/watch-static-file.ts
var $c78df6347432a4c1$var$WATCH_REMOTION_STATIC_FILES = "remotion_staticFilesChanged";
var $c78df6347432a4c1$export$dcf8c346e84bf836 = (fileName, callback)=>{
    if ($c78df6347432a4c1$var$ENABLE_V5_BREAKING_CHANGES) throw new Error("watchStaticFile() has moved into the `@remotion/studio` package. Update your imports.");
    if (!$c78df6347432a4c1$export$2a36334a5203003d().isStudio) {
        console.warn("The API is only available while using the Remotion Studio.");
        return {
            cancel: ()=>{
                return;
            }
        };
    }
    const withoutStaticBase = fileName.startsWith(window.remotion_staticBase) ? fileName.replace(window.remotion_staticBase, "") : fileName;
    const withoutLeadingSlash = withoutStaticBase.startsWith("/") ? withoutStaticBase.slice(1) : withoutStaticBase;
    let prevFileData = window.remotion_staticFiles.find((file)=>file.name === withoutLeadingSlash);
    const checkFile = (event)=>{
        const staticFiles = event.detail.files;
        const newFileData = staticFiles.find((file)=>file.name === withoutLeadingSlash);
        if (!newFileData) {
            if (prevFileData !== undefined) callback(null);
            prevFileData = undefined;
            return;
        }
        if (prevFileData === undefined || prevFileData.lastModified !== newFileData.lastModified) {
            callback(newFileData);
            prevFileData = newFileData;
        }
    };
    window.addEventListener($c78df6347432a4c1$var$WATCH_REMOTION_STATIC_FILES, checkFile);
    const cancel = ()=>{
        return window.removeEventListener($c78df6347432a4c1$var$WATCH_REMOTION_STATIC_FILES, checkFile);
    };
    return {
        cancel: cancel
    };
};
function $c78df6347432a4c1$var$useRemotionContexts() {
    const compositionManagerCtx = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($c78df6347432a4c1$var$CompositionManager);
    const timelineContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($c78df6347432a4c1$var$TimelineContext);
    const setTimelineContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($c78df6347432a4c1$var$SetTimelineContext);
    const sequenceContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($c78df6347432a4c1$var$SequenceContext);
    const nonceContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($c78df6347432a4c1$var$NonceContext);
    const canUseRemotionHooksContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($c78df6347432a4c1$var$CanUseRemotionHooks);
    const nativeLayersContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($c78df6347432a4c1$var$NativeLayersContext);
    const preloadContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($c78df6347432a4c1$var$PreloadContext);
    const resolveCompositionContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($c78df6347432a4c1$var$ResolveCompositionContext);
    const renderAssetManagerContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($c78df6347432a4c1$var$RenderAssetManager);
    const sequenceManagerContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($c78df6347432a4c1$var$SequenceManager);
    const bufferManagerContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($c78df6347432a4c1$var$BufferingContextReact);
    return (0, $acw62.useMemo)(()=>({
            compositionManagerCtx: compositionManagerCtx,
            timelineContext: timelineContext,
            setTimelineContext: setTimelineContext,
            sequenceContext: sequenceContext,
            nonceContext: nonceContext,
            canUseRemotionHooksContext: canUseRemotionHooksContext,
            nativeLayersContext: nativeLayersContext,
            preloadContext: preloadContext,
            resolveCompositionContext: resolveCompositionContext,
            renderAssetManagerContext: renderAssetManagerContext,
            sequenceManagerContext: sequenceManagerContext,
            bufferManagerContext: bufferManagerContext
        }), [
        compositionManagerCtx,
        nonceContext,
        sequenceContext,
        setTimelineContext,
        timelineContext,
        canUseRemotionHooksContext,
        nativeLayersContext,
        preloadContext,
        resolveCompositionContext,
        renderAssetManagerContext,
        sequenceManagerContext,
        bufferManagerContext
    ]);
}
var $c78df6347432a4c1$var$RemotionContextProvider = (props2)=>{
    const { children: children, contexts: contexts } = props2;
    return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$CanUseRemotionHooks.Provider, {
        value: contexts.canUseRemotionHooksContext,
        children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$NonceContext.Provider, {
            value: contexts.nonceContext,
            children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$NativeLayersContext.Provider, {
                value: contexts.nativeLayersContext,
                children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$PreloadContext.Provider, {
                    value: contexts.preloadContext,
                    children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$CompositionManager.Provider, {
                        value: contexts.compositionManagerCtx,
                        children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$SequenceManager.Provider, {
                            value: contexts.sequenceManagerContext,
                            children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$RenderAssetManager.Provider, {
                                value: contexts.renderAssetManagerContext,
                                children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$ResolveCompositionContext.Provider, {
                                    value: contexts.resolveCompositionContext,
                                    children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$TimelineContext.Provider, {
                                        value: contexts.timelineContext,
                                        children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$SetTimelineContext.Provider, {
                                            value: contexts.setTimelineContext,
                                            children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$SequenceContext.Provider, {
                                                value: contexts.sequenceContext,
                                                children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$BufferingContextReact.Provider, {
                                                    value: contexts.bufferManagerContext,
                                                    children: children
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
// src/internals.ts
var $c78df6347432a4c1$export$c39fff9f74a28020 = {
    useUnsafeVideoConfig: $c78df6347432a4c1$var$useUnsafeVideoConfig,
    Timeline: $c78df6347432a4c1$var$exports_timeline_position_state,
    CompositionManager: $c78df6347432a4c1$var$CompositionManager,
    SequenceManager: $c78df6347432a4c1$var$SequenceManager,
    SequenceVisibilityToggleContext: $c78df6347432a4c1$var$SequenceVisibilityToggleContext,
    RemotionRoot: $c78df6347432a4c1$var$RemotionRoot,
    useVideo: $c78df6347432a4c1$var$useVideo,
    getRoot: $c78df6347432a4c1$var$getRoot,
    useMediaVolumeState: $c78df6347432a4c1$var$useMediaVolumeState,
    useMediaMutedState: $c78df6347432a4c1$var$useMediaMutedState,
    useLazyComponent: $c78df6347432a4c1$var$useLazyComponent,
    truthy: $c78df6347432a4c1$var$truthy,
    SequenceContext: $c78df6347432a4c1$var$SequenceContext,
    useRemotionContexts: $c78df6347432a4c1$var$useRemotionContexts,
    RemotionContextProvider: $c78df6347432a4c1$var$RemotionContextProvider,
    CSSUtils: $c78df6347432a4c1$var$exports_default_css,
    setupEnvVariables: $c78df6347432a4c1$var$setupEnvVariables,
    MediaVolumeContext: $c78df6347432a4c1$var$MediaVolumeContext,
    SetMediaVolumeContext: $c78df6347432a4c1$var$SetMediaVolumeContext,
    getRemotionEnvironment: $c78df6347432a4c1$export$2a36334a5203003d,
    SharedAudioContext: $c78df6347432a4c1$var$SharedAudioContext,
    SharedAudioContextProvider: $c78df6347432a4c1$var$SharedAudioContextProvider,
    invalidCompositionErrorMessage: $c78df6347432a4c1$var$invalidCompositionErrorMessage,
    isCompositionIdValid: $c78df6347432a4c1$var$isCompositionIdValid,
    getPreviewDomElement: $c78df6347432a4c1$var$getPreviewDomElement,
    compositionsRef: $c78df6347432a4c1$var$compositionsRef,
    portalNode: $c78df6347432a4c1$var$portalNode,
    waitForRoot: $c78df6347432a4c1$var$waitForRoot,
    CanUseRemotionHooksProvider: $c78df6347432a4c1$var$CanUseRemotionHooksProvider,
    CanUseRemotionHooks: $c78df6347432a4c1$var$CanUseRemotionHooks,
    PrefetchProvider: $c78df6347432a4c1$var$PrefetchProvider,
    DurationsContextProvider: $c78df6347432a4c1$var$DurationsContextProvider,
    IsPlayerContextProvider: $c78df6347432a4c1$var$IsPlayerContextProvider,
    useIsPlayer: $c78df6347432a4c1$var$useIsPlayer,
    EditorPropsProvider: $c78df6347432a4c1$var$EditorPropsProvider,
    EditorPropsContext: $c78df6347432a4c1$var$EditorPropsContext,
    usePreload: $c78df6347432a4c1$var$usePreload,
    NonceContext: $c78df6347432a4c1$var$NonceContext,
    resolveVideoConfig: $c78df6347432a4c1$var$resolveVideoConfig,
    useResolvedVideoConfig: $c78df6347432a4c1$var$useResolvedVideoConfig,
    resolveCompositionsRef: $c78df6347432a4c1$var$resolveCompositionsRef,
    ResolveCompositionConfig: $c78df6347432a4c1$var$ResolveCompositionConfig,
    REMOTION_STUDIO_CONTAINER_ELEMENT: $c78df6347432a4c1$var$REMOTION_STUDIO_CONTAINER_ELEMENT,
    RenderAssetManager: $c78df6347432a4c1$var$RenderAssetManager,
    persistCurrentFrame: $c78df6347432a4c1$var$persistCurrentFrame,
    useTimelineSetFrame: $c78df6347432a4c1$var$useTimelineSetFrame,
    NativeLayersProvider: $c78df6347432a4c1$var$NativeLayersProvider,
    ClipComposition: $c78df6347432a4c1$var$ClipComposition,
    isIosSafari: $c78df6347432a4c1$var$isIosSafari,
    WATCH_REMOTION_STATIC_FILES: $c78df6347432a4c1$var$WATCH_REMOTION_STATIC_FILES,
    addSequenceStackTraces: $c78df6347432a4c1$var$addSequenceStackTraces,
    useMediaStartsAt: $c78df6347432a4c1$var$useMediaStartsAt,
    BufferingProvider: $c78df6347432a4c1$var$BufferingProvider,
    BufferingContextReact: $c78df6347432a4c1$var$BufferingContextReact,
    enableSequenceStackTraces: $c78df6347432a4c1$var$enableSequenceStackTraces,
    CurrentScaleContext: $c78df6347432a4c1$var$CurrentScaleContext,
    PreviewSizeContext: $c78df6347432a4c1$var$PreviewSizeContext,
    calculateScale: $c78df6347432a4c1$var$calculateScale,
    editorPropsProviderRef: $c78df6347432a4c1$var$editorPropsProviderRef,
    PROPS_UPDATED_EXTERNALLY: $c78df6347432a4c1$var$PROPS_UPDATED_EXTERNALLY,
    validateRenderAsset: $c78df6347432a4c1$var$validateRenderAsset
};
// src/interpolate-colors.ts
var $c78df6347432a4c1$var$call = function(...args) {
    return "\\(\\s*(" + args.join(")\\s*,\\s*(") + ")\\s*\\)";
};
var $c78df6347432a4c1$var$getMatchers = function() {
    const cachedMatchers = {
        rgb: undefined,
        rgba: undefined,
        hsl: undefined,
        hsla: undefined,
        hex3: undefined,
        hex4: undefined,
        hex5: undefined,
        hex6: undefined,
        hex8: undefined
    };
    if (cachedMatchers.rgb === undefined) {
        cachedMatchers.rgb = new RegExp("rgb" + $c78df6347432a4c1$var$call($c78df6347432a4c1$var$NUMBER, $c78df6347432a4c1$var$NUMBER, $c78df6347432a4c1$var$NUMBER));
        cachedMatchers.rgba = new RegExp("rgba" + $c78df6347432a4c1$var$call($c78df6347432a4c1$var$NUMBER, $c78df6347432a4c1$var$NUMBER, $c78df6347432a4c1$var$NUMBER, $c78df6347432a4c1$var$NUMBER));
        cachedMatchers.hsl = new RegExp("hsl" + $c78df6347432a4c1$var$call($c78df6347432a4c1$var$NUMBER, $c78df6347432a4c1$var$PERCENTAGE, $c78df6347432a4c1$var$PERCENTAGE));
        cachedMatchers.hsla = new RegExp("hsla" + $c78df6347432a4c1$var$call($c78df6347432a4c1$var$NUMBER, $c78df6347432a4c1$var$PERCENTAGE, $c78df6347432a4c1$var$PERCENTAGE, $c78df6347432a4c1$var$NUMBER));
        cachedMatchers.hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
        cachedMatchers.hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
        cachedMatchers.hex6 = /^#([0-9a-fA-F]{6})$/;
        cachedMatchers.hex8 = /^#([0-9a-fA-F]{8})$/;
    }
    return cachedMatchers;
};
var $c78df6347432a4c1$var$hue2rgb = function(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
};
var $c78df6347432a4c1$var$hslToRgb = function(h, s, l) {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = $c78df6347432a4c1$var$hue2rgb(p, q, h + 1 / 3);
    const g = $c78df6347432a4c1$var$hue2rgb(p, q, h);
    const b2 = $c78df6347432a4c1$var$hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b2 * 255) << 8;
};
var $c78df6347432a4c1$var$parse255 = function(str) {
    const int = Number.parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
};
var $c78df6347432a4c1$var$parse360 = function(str) {
    const int = Number.parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
};
var $c78df6347432a4c1$var$parse1 = function(str) {
    const num = Number.parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
};
var $c78df6347432a4c1$var$parsePercentage = function(str) {
    const int = Number.parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
};
var $c78df6347432a4c1$var$normalizeColor = function(color) {
    const matchers = $c78df6347432a4c1$var$getMatchers();
    let match;
    if (matchers.hex6) {
        if (match = matchers.hex6.exec(color)) return Number.parseInt(match[1] + "ff", 16) >>> 0;
    }
    if ($c78df6347432a4c1$var$colorNames[color] !== undefined) return $c78df6347432a4c1$var$colorNames[color];
    if (matchers.rgb) {
        if (match = matchers.rgb.exec(color)) return ($c78df6347432a4c1$var$parse255(match[1]) << 24 | $c78df6347432a4c1$var$parse255(match[2]) << 16 | $c78df6347432a4c1$var$parse255(match[3]) << 8 | 255) >>> 0;
    }
    if (matchers.rgba) {
        if (match = matchers.rgba.exec(color)) return ($c78df6347432a4c1$var$parse255(match[1]) << 24 | $c78df6347432a4c1$var$parse255(match[2]) << 16 | $c78df6347432a4c1$var$parse255(match[3]) << 8 | $c78df6347432a4c1$var$parse1(match[4])) >>> 0;
    }
    if (matchers.hex3) {
        if (match = matchers.hex3.exec(color)) return Number.parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + "ff", 16) >>> 0;
    }
    if (matchers.hex8) {
        if (match = matchers.hex8.exec(color)) return Number.parseInt(match[1], 16) >>> 0;
    }
    if (matchers.hex4) {
        if (match = matchers.hex4.exec(color)) return Number.parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + match[4] + match[4], 16) >>> 0;
    }
    if (matchers.hsl) {
        if (match = matchers.hsl.exec(color)) return ($c78df6347432a4c1$var$hslToRgb($c78df6347432a4c1$var$parse360(match[1]), $c78df6347432a4c1$var$parsePercentage(match[2]), $c78df6347432a4c1$var$parsePercentage(match[3])) | 255) >>> 0;
    }
    if (matchers.hsla) {
        if (match = matchers.hsla.exec(color)) return ($c78df6347432a4c1$var$hslToRgb($c78df6347432a4c1$var$parse360(match[1]), $c78df6347432a4c1$var$parsePercentage(match[2]), $c78df6347432a4c1$var$parsePercentage(match[3])) | $c78df6347432a4c1$var$parse1(match[4])) >>> 0;
    }
    throw new Error(`invalid color string ${color} provided`);
};
function $c78df6347432a4c1$var$processColor(color) {
    const normalizedColor = $c78df6347432a4c1$var$normalizeColor(color);
    return (normalizedColor << 24 | normalizedColor >>> 8) >>> 0;
}
var $c78df6347432a4c1$var$NUMBER = "[-+]?\\d*\\.?\\d+";
var $c78df6347432a4c1$var$PERCENTAGE = $c78df6347432a4c1$var$NUMBER + "%";
var $c78df6347432a4c1$var$colorNames = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
};
var $c78df6347432a4c1$var$opacity = (c2)=>{
    return (c2 >> 24 & 255) / 255;
};
var $c78df6347432a4c1$var$red = (c2)=>{
    return c2 >> 16 & 255;
};
var $c78df6347432a4c1$var$green = (c2)=>{
    return c2 >> 8 & 255;
};
var $c78df6347432a4c1$var$blue = (c2)=>{
    return c2 & 255;
};
var $c78df6347432a4c1$var$rgbaColor = (r, g, b2, alpha)=>{
    return `rgba(${r}, ${g}, ${b2}, ${alpha})`;
};
var $c78df6347432a4c1$var$interpolateColorsRGB = (value, inputRange, colors)=>{
    const [r, g, b2, a2] = [
        $c78df6347432a4c1$var$red,
        $c78df6347432a4c1$var$green,
        $c78df6347432a4c1$var$blue,
        $c78df6347432a4c1$var$opacity
    ].map((f)=>{
        const unrounded = $c78df6347432a4c1$export$89e29e4ab65e70a9(value, inputRange, colors.map((c2)=>f(c2)), {
            extrapolateLeft: "clamp",
            extrapolateRight: "clamp"
        });
        if (f === $c78df6347432a4c1$var$opacity) return Number(unrounded.toFixed(3));
        return Math.round(unrounded);
    });
    return $c78df6347432a4c1$var$rgbaColor(r, g, b2, a2);
};
var $c78df6347432a4c1$export$ac51ceaa2f6fb770 = (input, inputRange, outputRange)=>{
    if (typeof input === "undefined") throw new TypeError("input can not be undefined");
    if (typeof inputRange === "undefined") throw new TypeError("inputRange can not be undefined");
    if (typeof outputRange === "undefined") throw new TypeError("outputRange can not be undefined");
    if (inputRange.length !== outputRange.length) throw new TypeError("inputRange (" + inputRange.length + " values provided) and outputRange (" + outputRange.length + " values provided) must have the same length");
    const processedOutputRange = outputRange.map((c2)=>$c78df6347432a4c1$var$processColor(c2));
    return $c78df6347432a4c1$var$interpolateColorsRGB(input, inputRange, processedOutputRange);
};
// src/validate-frame.ts
var $c78df6347432a4c1$var$validateFrame = ({ allowFloats: allowFloats, durationInFrames: durationInFrames, frame: frame })=>{
    if (typeof frame === "undefined") throw new TypeError(`Argument missing for parameter "frame"`);
    if (typeof frame !== "number") throw new TypeError(`Argument passed for "frame" is not a number: ${frame}`);
    if (!Number.isFinite(frame)) throw new RangeError(`Frame ${frame} is not finite`);
    if (frame % 1 !== 0 && !allowFloats) throw new RangeError(`Argument for frame must be an integer, but got ${frame}`);
    if (frame < 0 && frame < -durationInFrames) throw new RangeError(`Cannot use frame ${frame}: Duration of composition is ${durationInFrames}, therefore the lowest frame that can be rendered is ${-durationInFrames}`);
    if (frame > durationInFrames - 1) throw new RangeError(`Cannot use frame ${frame}: Duration of composition is ${durationInFrames}, therefore the highest frame that can be rendered is ${durationInFrames - 1}`);
};
// src/video/offthread-video-source.ts
var $c78df6347432a4c1$var$getOffthreadVideoSource = ({ src: src, transparent: transparent, currentTime: currentTime, toneMapped: toneMapped })=>{
    return `http://localhost:${window.remotion_proxyPort}/proxy?src=${encodeURIComponent($c78df6347432a4c1$var$getAbsoluteSrc(src))}&time=${encodeURIComponent(currentTime)}&transparent=${String(transparent)}&toneMapped=${String(toneMapped)}`;
};
var $c78df6347432a4c1$var$flattenChildren = (children)=>{
    const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(children);
    return childrenArray.reduce((flatChildren, child)=>{
        if (child.type === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment) return flatChildren.concat($c78df6347432a4c1$var$flattenChildren(child.props.children));
        flatChildren.push(child);
        return flatChildren;
    }, []);
};
var $c78df6347432a4c1$var$IsInsideSeriesContext = (0, $acw62.createContext)(false);
var $c78df6347432a4c1$var$IsInsideSeriesContainer = ({ children: children })=>{
    return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$IsInsideSeriesContext.Provider, {
        value: true,
        children: children
    });
};
var $c78df6347432a4c1$var$IsNotInsideSeriesProvider = ({ children: children })=>{
    return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$IsInsideSeriesContext.Provider, {
        value: false,
        children: children
    });
};
var $c78df6347432a4c1$var$useRequireToBeInsideSeries = ()=>{
    const isInsideSeries = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($c78df6347432a4c1$var$IsInsideSeriesContext);
    if (!isInsideSeries) throw new Error("This component must be inside a <Series /> component.");
};
var $c78df6347432a4c1$var$SeriesSequenceRefForwardingFunction = ({ children: children }, _ref)=>{
    $c78df6347432a4c1$var$useRequireToBeInsideSeries();
    return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$IsNotInsideSeriesProvider, {
        children: children
    });
};
var $c78df6347432a4c1$var$SeriesSequence = (0, $acw62.forwardRef)($c78df6347432a4c1$var$SeriesSequenceRefForwardingFunction);
var $c78df6347432a4c1$export$ed28a77b2a3badcf = (props2)=>{
    const childrenValue = (0, $acw62.useMemo)(()=>{
        let startFrame = 0;
        const flattenedChildren = $c78df6347432a4c1$var$flattenChildren(props2.children);
        return (0, $acw62.Children).map(flattenedChildren, (child, i)=>{
            const castedChild = child;
            if (typeof castedChild === "string") {
                if (castedChild.trim() === "") return null;
                throw new TypeError(`The <Series /> component only accepts a list of <Series.Sequence /> components as its children, but you passed a string "${castedChild}"`);
            }
            if (castedChild.type !== $c78df6347432a4c1$var$SeriesSequence) throw new TypeError(`The <Series /> component only accepts a list of <Series.Sequence /> components as its children, but got ${castedChild} instead`);
            const debugInfo = `index = ${i}, duration = ${castedChild.props.durationInFrames}`;
            if (!castedChild?.props.children) throw new TypeError(`A <Series.Sequence /> component (${debugInfo}) was detected to not have any children. Delete it to fix this error.`);
            const durationInFramesProp = castedChild.props.durationInFrames;
            const { durationInFrames: durationInFrames, children: _children, from: from, name: name, ...passedProps } = castedChild.props;
            if (i !== flattenedChildren.length - 1 || durationInFramesProp !== Infinity) $c78df6347432a4c1$var$validateDurationInFrames(durationInFramesProp, {
                component: `of a <Series.Sequence /> component`,
                allowFloats: true
            });
            const offset = castedChild.props.offset ?? 0;
            if (Number.isNaN(offset)) throw new TypeError(`The "offset" property of a <Series.Sequence /> must not be NaN, but got NaN (${debugInfo}).`);
            if (!Number.isFinite(offset)) throw new TypeError(`The "offset" property of a <Series.Sequence /> must be finite, but got ${offset} (${debugInfo}).`);
            if (offset % 1 !== 0) throw new TypeError(`The "offset" property of a <Series.Sequence /> must be finite, but got ${offset} (${debugInfo}).`);
            const currentStartFrame = startFrame + offset;
            startFrame += durationInFramesProp + offset;
            return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$export$edde1bcb1b2b310e, {
                name: name || "<Series.Sequence>",
                from: currentStartFrame,
                durationInFrames: durationInFramesProp,
                ...passedProps,
                ref: castedChild.ref,
                children: child
            });
        });
    }, [
        props2.children
    ]);
    if ($c78df6347432a4c1$var$ENABLE_V5_BREAKING_CHANGES) return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$IsInsideSeriesContainer, {
        children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$export$edde1bcb1b2b310e, {
            ...props2,
            children: childrenValue
        })
    });
    return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$IsInsideSeriesContainer, {
        children: childrenValue
    });
};
$c78df6347432a4c1$export$ed28a77b2a3badcf.Sequence = $c78df6347432a4c1$var$SeriesSequence;
$c78df6347432a4c1$var$addSequenceStackTraces($c78df6347432a4c1$var$SeriesSequence);
// src/validation/validation-spring-duration.ts
var $c78df6347432a4c1$var$validateSpringDuration = (dur)=>{
    if (typeof dur === "undefined") return;
    if (typeof dur !== "number") throw new TypeError(`A "duration" of a spring must be a "number" but is "${typeof dur}"`);
    if (Number.isNaN(dur)) throw new TypeError('A "duration" of a spring is NaN, which it must not be');
    if (!Number.isFinite(dur)) throw new TypeError('A "duration" of a spring must be finite, but is ' + dur);
    if (dur <= 0) throw new TypeError('A "duration" of a spring must be positive, but is ' + dur);
};
// src/spring/spring-utils.ts
var $c78df6347432a4c1$var$advance = function({ animation: animation, now: now, config: config }) {
    const { toValue: toValue, lastTimestamp: lastTimestamp, current: current, velocity: velocity } = animation;
    const deltaTime = Math.min(now - lastTimestamp, 64);
    if (config.damping <= 0) throw new Error("Spring damping must be greater than 0, otherwise the spring() animation will never end, causing an infinite loop.");
    const c2 = config.damping;
    const m = config.mass;
    const k = config.stiffness;
    const cacheKey = [
        toValue,
        lastTimestamp,
        current,
        velocity,
        c2,
        m,
        k,
        now
    ].join("-");
    if ($c78df6347432a4c1$var$advanceCache[cacheKey]) return $c78df6347432a4c1$var$advanceCache[cacheKey];
    const v0 = -velocity;
    const x0 = toValue - current;
    const zeta = c2 / (2 * Math.sqrt(k * m));
    const omega0 = Math.sqrt(k / m);
    const omega1 = omega0 * Math.sqrt(1 - zeta ** 2);
    const t = deltaTime / 1000;
    const sin1 = Math.sin(omega1 * t);
    const cos1 = Math.cos(omega1 * t);
    const underDampedEnvelope = Math.exp(-zeta * omega0 * t);
    const underDampedFrag1 = underDampedEnvelope * (sin1 * ((v0 + zeta * omega0 * x0) / omega1) + x0 * cos1);
    const underDampedPosition = toValue - underDampedFrag1;
    const underDampedVelocity = zeta * omega0 * underDampedFrag1 - underDampedEnvelope * (cos1 * (v0 + zeta * omega0 * x0) - omega1 * x0 * sin1);
    const criticallyDampedEnvelope = Math.exp(-omega0 * t);
    const criticallyDampedPosition = toValue - criticallyDampedEnvelope * (x0 + (v0 + omega0 * x0) * t);
    const criticallyDampedVelocity = criticallyDampedEnvelope * (v0 * (t * omega0 - 1) + t * x0 * omega0 * omega0);
    const animationNode = {
        toValue: toValue,
        prevPosition: current,
        lastTimestamp: now,
        current: zeta < 1 ? underDampedPosition : criticallyDampedPosition,
        velocity: zeta < 1 ? underDampedVelocity : criticallyDampedVelocity
    };
    $c78df6347432a4c1$var$advanceCache[cacheKey] = animationNode;
    return animationNode;
};
function $c78df6347432a4c1$var$springCalculation({ frame: frame, fps: fps, config: config = {} }) {
    const from = 0;
    const to = 1;
    const cacheKey = [
        frame,
        fps,
        config.damping,
        config.mass,
        config.overshootClamping,
        config.stiffness
    ].join("-");
    if ($c78df6347432a4c1$var$calculationCache[cacheKey]) return $c78df6347432a4c1$var$calculationCache[cacheKey];
    let animation = {
        lastTimestamp: 0,
        current: from,
        toValue: to,
        velocity: 0,
        prevPosition: 0
    };
    const frameClamped = Math.max(0, frame);
    const unevenRest = frameClamped % 1;
    for(let f = 0; f <= Math.floor(frameClamped); f++){
        if (f === Math.floor(frameClamped)) f += unevenRest;
        const time = f / fps * 1000;
        animation = $c78df6347432a4c1$var$advance({
            animation: animation,
            now: time,
            config: {
                ...$c78df6347432a4c1$var$defaultSpringConfig,
                ...config
            }
        });
    }
    $c78df6347432a4c1$var$calculationCache[cacheKey] = animation;
    return animation;
}
var $c78df6347432a4c1$var$defaultSpringConfig = {
    damping: 10,
    mass: 1,
    stiffness: 100,
    overshootClamping: false
};
var $c78df6347432a4c1$var$advanceCache = {};
var $c78df6347432a4c1$var$calculationCache = {};
// src/spring/measure-spring.ts
function $c78df6347432a4c1$export$e4ea2ea5843070ed({ fps: fps, config: config = {}, threshold: threshold = 0.005 }) {
    if (typeof threshold !== "number") throw new TypeError(`threshold must be a number, got ${threshold} of type ${typeof threshold}`);
    if (threshold === 0) return Infinity;
    if (threshold === 1) return 0;
    if (isNaN(threshold)) throw new TypeError("Threshold is NaN");
    if (!Number.isFinite(threshold)) throw new TypeError("Threshold is not finite");
    if (threshold < 0) throw new TypeError("Threshold is below 0");
    const cacheKey = [
        fps,
        config.damping,
        config.mass,
        config.overshootClamping,
        config.stiffness,
        threshold
    ].join("-");
    if ($c78df6347432a4c1$var$cache.has(cacheKey)) return $c78df6347432a4c1$var$cache.get(cacheKey);
    $c78df6347432a4c1$var$validateFps(fps, "to the measureSpring() function", false);
    let frame = 0;
    let finishedFrame = 0;
    const calc = ()=>{
        return $c78df6347432a4c1$var$springCalculation({
            fps: fps,
            frame: frame,
            config: config
        });
    };
    let animation = calc();
    const calcDifference = ()=>{
        return Math.abs(animation.current - animation.toValue);
    };
    let difference = calcDifference();
    while(difference >= threshold){
        frame++;
        animation = calc();
        difference = calcDifference();
    }
    finishedFrame = frame;
    for(let i = 0; i < 20; i++){
        frame++;
        animation = calc();
        difference = calcDifference();
        if (difference >= threshold) {
            i = 0;
            finishedFrame = frame + 1;
        }
    }
    $c78df6347432a4c1$var$cache.set(cacheKey, finishedFrame);
    return finishedFrame;
}
var $c78df6347432a4c1$var$cache = new Map;
// src/spring/index.ts
function $c78df6347432a4c1$export$b36281d89752ae66({ frame: passedFrame, fps: fps, config: config = {}, from: from = 0, to: to = 1, durationInFrames: passedDurationInFrames, durationRestThreshold: durationRestThreshold, delay: delay = 0, reverse: reverse = false }) {
    $c78df6347432a4c1$var$validateSpringDuration(passedDurationInFrames);
    $c78df6347432a4c1$var$validateFrame({
        frame: passedFrame,
        durationInFrames: Infinity,
        allowFloats: true
    });
    $c78df6347432a4c1$var$validateFps(fps, "to spring()", false);
    const needsToCalculateNaturalDuration = reverse || typeof passedDurationInFrames !== "undefined";
    const naturalDuration = needsToCalculateNaturalDuration ? $c78df6347432a4c1$export$e4ea2ea5843070ed({
        fps: fps,
        config: config,
        threshold: durationRestThreshold
    }) : undefined;
    const naturalDurationGetter = needsToCalculateNaturalDuration ? {
        get: ()=>naturalDuration
    } : {
        get: ()=>{
            throw new Error("did not calculate natural duration, this is an error with Remotion. Please report");
        }
    };
    const reverseProcessed = reverse ? (passedDurationInFrames ?? naturalDurationGetter.get()) - passedFrame : passedFrame;
    const delayProcessed = reverseProcessed + (reverse ? delay : -delay);
    const durationProcessed = passedDurationInFrames === undefined ? delayProcessed : delayProcessed / (passedDurationInFrames / naturalDurationGetter.get());
    if (passedDurationInFrames && delayProcessed > passedDurationInFrames) return to;
    const spr = $c78df6347432a4c1$var$springCalculation({
        fps: fps,
        frame: durationProcessed,
        config: config
    });
    const inner2 = config.overshootClamping ? to >= from ? Math.min(spr.current, to) : Math.max(spr.current, to) : spr.current;
    const interpolated = from === 0 && to === 1 ? inner2 : $c78df6347432a4c1$export$89e29e4ab65e70a9(inner2, [
        0,
        1
    ], [
        from,
        to
    ]);
    return interpolated;
}
var $c78df6347432a4c1$export$253b5a0c30fd643e = (props2)=>{
    const newProps = {
        ...props2,
        durationInFrames: 1,
        fps: 1
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c78df6347432a4c1$export$d955f48b7132ae28, newProps);
};
var $c78df6347432a4c1$var$OffthreadVideoForRendering = ({ onError: onError, volume: volumeProp, playbackRate: playbackRate, src: src, muted: muted, allowAmplificationDuringRender: allowAmplificationDuringRender, transparent: transparent = false, toneMapped: toneMapped = true, toneFrequency: toneFrequency, name: name, loopVolumeCurveBehavior: loopVolumeCurveBehavior, delayRenderRetries: delayRenderRetries, delayRenderTimeoutInMilliseconds: delayRenderTimeoutInMilliseconds, onVideoFrame: onVideoFrame, ...props2 })=>{
    const absoluteFrame = $c78df6347432a4c1$var$useTimelinePosition();
    const frame = $c78df6347432a4c1$export$e82ee3202ebaa1e9();
    const volumePropsFrame = $c78df6347432a4c1$var$useFrameForVolumeProp(loopVolumeCurveBehavior ?? "repeat");
    const videoConfig = $c78df6347432a4c1$var$useUnsafeVideoConfig();
    const sequenceContext = (0, $acw62.useContext)($c78df6347432a4c1$var$SequenceContext);
    const mediaStartsAt = $c78df6347432a4c1$var$useMediaStartsAt();
    const { registerRenderAsset: registerRenderAsset, unregisterRenderAsset: unregisterRenderAsset } = (0, $acw62.useContext)($c78df6347432a4c1$var$RenderAssetManager);
    if (!src) throw new TypeError("No `src` was passed to <OffthreadVideo>.");
    const id = (0, $acw62.useMemo)(()=>`offthreadvideo-${$c78df6347432a4c1$export$4385e60b38654f68(src ?? "")}-${sequenceContext?.cumulatedFrom}-${sequenceContext?.relativeFrom}-${sequenceContext?.durationInFrames}`, [
        src,
        sequenceContext?.cumulatedFrom,
        sequenceContext?.relativeFrom,
        sequenceContext?.durationInFrames
    ]);
    if (!videoConfig) throw new Error("No video config found");
    const volume = $c78df6347432a4c1$var$evaluateVolume({
        volume: volumeProp,
        frame: volumePropsFrame,
        mediaVolume: 1,
        allowAmplificationDuringRender: allowAmplificationDuringRender ?? false
    });
    (0, $acw62.useEffect)(()=>{
        if (!src) throw new Error("No src passed");
        if (!window.remotion_audioEnabled) return;
        if (muted) return;
        if (volume <= 0) return;
        registerRenderAsset({
            type: "video",
            src: $c78df6347432a4c1$var$getAbsoluteSrc(src),
            id: id,
            frame: absoluteFrame,
            volume: volume,
            mediaFrame: frame,
            playbackRate: playbackRate ?? 1,
            allowAmplificationDuringRender: allowAmplificationDuringRender ?? false,
            toneFrequency: toneFrequency ?? null,
            audioStartFrame: Math.max(0, -(sequenceContext?.relativeFrom ?? 0))
        });
        return ()=>unregisterRenderAsset(id);
    }, [
        muted,
        src,
        registerRenderAsset,
        id,
        unregisterRenderAsset,
        volume,
        frame,
        absoluteFrame,
        playbackRate,
        allowAmplificationDuringRender,
        toneFrequency,
        sequenceContext?.relativeFrom
    ]);
    const currentTime = (0, $acw62.useMemo)(()=>{
        return $c78df6347432a4c1$var$getExpectedMediaFrameUncorrected({
            frame: frame,
            playbackRate: playbackRate || 1,
            startFrom: -mediaStartsAt
        }) / videoConfig.fps;
    }, [
        frame,
        mediaStartsAt,
        playbackRate,
        videoConfig.fps
    ]);
    const actualSrc = (0, $acw62.useMemo)(()=>{
        return $c78df6347432a4c1$var$getOffthreadVideoSource({
            src: src,
            currentTime: currentTime,
            transparent: transparent,
            toneMapped: toneMapped
        });
    }, [
        toneMapped,
        currentTime,
        src,
        transparent
    ]);
    const [imageSrc, setImageSrc] = (0, $acw62.useState)(null);
    (0, $acw62.useLayoutEffect)(()=>{
        const cleanup = [];
        setImageSrc(null);
        const controller = new AbortController;
        const newHandle = $c78df6347432a4c1$export$c3ec5096f1c973ca("Fetching " + actualSrc + "from server", {
            retries: delayRenderRetries ?? undefined,
            timeoutInMilliseconds: delayRenderTimeoutInMilliseconds ?? undefined
        });
        const execute = async ()=>{
            try {
                const res = await fetch(actualSrc, {
                    signal: controller.signal
                });
                if (res.status !== 200) {
                    if (res.status === 500) {
                        const json = await res.json();
                        if (json.error) {
                            const cleanedUpErrorMessage = json.error.replace(/^Error: /, "");
                            throw new Error(cleanedUpErrorMessage);
                        }
                    }
                    throw new Error(`Server returned status ${res.status} while fetching ${actualSrc}`);
                }
                const blob = await res.blob();
                const url = URL.createObjectURL(blob);
                cleanup.push(()=>URL.revokeObjectURL(url));
                setImageSrc({
                    src: url,
                    handle: newHandle
                });
            } catch (err) {
                if (err.message.includes("aborted")) return;
                if (controller.signal.aborted) return;
                if (err.message.includes("Failed to fetch")) err = new Error(`Failed to fetch ${actualSrc}. This could be caused by Chrome rejecting the request because the disk space is low. Consider increasing the disk size of your environment.`, {
                    cause: err
                });
                if (onError) onError(err);
                else $c78df6347432a4c1$export$c1ae5abd54a67e52(err);
            }
        };
        execute();
        cleanup.push(()=>{
            if (controller.signal.aborted) return;
            controller.abort();
        });
        return ()=>{
            cleanup.forEach((c2)=>c2());
        };
    }, [
        actualSrc,
        delayRenderRetries,
        delayRenderTimeoutInMilliseconds,
        onError
    ]);
    const onErr = (0, $acw62.useCallback)(()=>{
        if (onError) onError?.(new Error("Failed to load image with src " + imageSrc));
        else $c78df6347432a4c1$export$c1ae5abd54a67e52("Failed to load image with src " + imageSrc);
    }, [
        imageSrc,
        onError
    ]);
    const className = (0, $acw62.useMemo)(()=>{
        return [
            $c78df6347432a4c1$var$OFFTHREAD_VIDEO_CLASS_NAME,
            props2.className
        ].filter($c78df6347432a4c1$var$truthy).join(" ");
    }, [
        props2.className
    ]);
    const onImageFrame = (0, $acw62.useCallback)((img)=>{
        if (onVideoFrame) onVideoFrame(img);
    }, [
        onVideoFrame
    ]);
    if (!imageSrc) return null;
    $c78df6347432a4c1$export$616bfefa2b04605f(imageSrc.handle);
    return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$export$cc7b5f925acc71d3, {
        src: imageSrc.src,
        className: className,
        delayRenderRetries: delayRenderRetries,
        delayRenderTimeoutInMilliseconds: delayRenderTimeoutInMilliseconds,
        onImageFrame: onImageFrame,
        ...props2,
        onError: onErr
    });
};
var $c78df6347432a4c1$var$useEmitVideoFrame = ({ ref: ref, onVideoFrame: onVideoFrame })=>{
    (0, $acw62.useEffect)(()=>{
        const { current: current } = ref;
        if (!current) return;
        if (!onVideoFrame) return;
        let handle = 0;
        const callback = ()=>{
            if (!ref.current) return;
            onVideoFrame(ref.current);
            handle = ref.current.requestVideoFrameCallback(callback);
        };
        callback();
        return ()=>{
            current.cancelVideoFrameCallback(handle);
        };
    }, [
        onVideoFrame,
        ref
    ]);
};
var $c78df6347432a4c1$var$VideoForDevelopmentRefForwardingFunction = (props2, ref)=>{
    const videoRef = (0, $acw62.useRef)(null);
    const { volume: volume, muted: muted, playbackRate: playbackRate, onlyWarnForMediaSeekingError: onlyWarnForMediaSeekingError, src: src, onDuration: onDuration, acceptableTimeShift: acceptableTimeShift, acceptableTimeShiftInSeconds: acceptableTimeShiftInSeconds, toneFrequency: toneFrequency, name: name, _remotionInternalNativeLoopPassed: _remotionInternalNativeLoopPassed, _remotionInternalStack: _remotionInternalStack, _remotionDebugSeeking: _remotionDebugSeeking, style: style, pauseWhenBuffering: pauseWhenBuffering, showInTimeline: showInTimeline, loopVolumeCurveBehavior: loopVolumeCurveBehavior, onError: onError, onAutoPlayError: onAutoPlayError, onVideoFrame: onVideoFrame, crossOrigin: crossOrigin, ...nativeProps } = props2;
    const volumePropFrame = $c78df6347432a4c1$var$useFrameForVolumeProp(loopVolumeCurveBehavior ?? "repeat");
    const { fps: fps, durationInFrames: durationInFrames } = $c78df6347432a4c1$export$da01606c8b81c2a0();
    const parentSequence = (0, $acw62.useContext)($c78df6347432a4c1$var$SequenceContext);
    const { hidden: hidden } = (0, $acw62.useContext)($c78df6347432a4c1$var$SequenceVisibilityToggleContext);
    const [timelineId] = (0, $acw62.useState)(()=>String(Math.random()));
    const isSequenceHidden = hidden[timelineId] ?? false;
    if (typeof acceptableTimeShift !== "undefined") throw new Error("acceptableTimeShift has been removed. Use acceptableTimeShiftInSeconds instead.");
    const actualVolume = $c78df6347432a4c1$var$useMediaTagVolume(videoRef);
    const [mediaVolume] = $c78df6347432a4c1$var$useMediaVolumeState();
    const [mediaMuted] = $c78df6347432a4c1$var$useMediaMutedState();
    $c78df6347432a4c1$var$useMediaInTimeline({
        mediaRef: videoRef,
        volume: volume,
        mediaVolume: mediaVolume,
        mediaType: "video",
        src: src,
        playbackRate: props2.playbackRate ?? 1,
        displayName: name ?? null,
        id: timelineId,
        stack: _remotionInternalStack,
        showInTimeline: showInTimeline,
        premountDisplay: null,
        onAutoPlayError: onAutoPlayError ?? null
    });
    $c78df6347432a4c1$var$useSyncVolumeWithMediaTag({
        volumePropFrame: volumePropFrame,
        actualVolume: actualVolume,
        volume: volume,
        mediaVolume: mediaVolume,
        mediaRef: videoRef
    });
    $c78df6347432a4c1$var$useMediaPlayback({
        mediaRef: videoRef,
        src: src,
        mediaType: "video",
        playbackRate: props2.playbackRate ?? 1,
        onlyWarnForMediaSeekingError: onlyWarnForMediaSeekingError,
        acceptableTimeshift: acceptableTimeShiftInSeconds ?? $c78df6347432a4c1$var$DEFAULT_ACCEPTABLE_TIMESHIFT,
        isPremounting: Boolean(parentSequence?.premounting),
        pauseWhenBuffering: pauseWhenBuffering,
        debugSeeking: _remotionDebugSeeking,
        onAutoPlayError: onAutoPlayError ?? null
    });
    const actualFrom = parentSequence ? parentSequence.relativeFrom : 0;
    const duration = parentSequence ? Math.min(parentSequence.durationInFrames, durationInFrames) : durationInFrames;
    const actualSrc = $c78df6347432a4c1$var$useAppendVideoFragment({
        actualSrc: $c78df6347432a4c1$var$usePreload(src),
        actualFrom: actualFrom,
        duration: duration,
        fps: fps
    });
    (0, $acw62.useImperativeHandle)(ref, ()=>{
        return videoRef.current;
    }, []);
    (0, $acw62.useEffect)(()=>{
        const { current: current } = videoRef;
        if (!current) return;
        const errorHandler = ()=>{
            if (current.error) {
                console.error("Error occurred in video", current?.error);
                if (onError) {
                    const err = new Error(`Code ${current.error.code}: ${current.error.message}`);
                    onError(err);
                    return;
                }
                throw new Error(`The browser threw an error while playing the video ${src}: Code ${current.error.code} - ${current?.error?.message}. See https://remotion.dev/docs/media-playback-error for help. Pass an onError() prop to handle the error.`);
            } else {
                if (onError) {
                    const err = new Error(`The browser threw an error while playing the video ${src}`);
                    onError(err);
                    return;
                }
                throw new Error("The browser threw an error while playing the video");
            }
        };
        current.addEventListener("error", errorHandler, {
            once: true
        });
        return ()=>{
            current.removeEventListener("error", errorHandler);
        };
    }, [
        onError,
        src
    ]);
    const currentOnDurationCallback = (0, $acw62.useRef)();
    currentOnDurationCallback.current = onDuration;
    $c78df6347432a4c1$var$useEmitVideoFrame({
        ref: videoRef,
        onVideoFrame: onVideoFrame
    });
    (0, $acw62.useEffect)(()=>{
        const { current: current } = videoRef;
        if (!current) return;
        if (current.duration) {
            currentOnDurationCallback.current?.(src, current.duration);
            return;
        }
        const onLoadedMetadata = ()=>{
            currentOnDurationCallback.current?.(src, current.duration);
        };
        current.addEventListener("loadedmetadata", onLoadedMetadata);
        return ()=>{
            current.removeEventListener("loadedmetadata", onLoadedMetadata);
        };
    }, [
        src
    ]);
    (0, $acw62.useEffect)(()=>{
        const { current: current } = videoRef;
        if (!current) return;
        if ($c78df6347432a4c1$var$isIosSafari()) current.preload = "metadata";
        else current.preload = "auto";
    }, []);
    const actualStyle = (0, $acw62.useMemo)(()=>{
        return {
            ...style,
            opacity: isSequenceHidden ? 0 : style?.opacity ?? 1
        };
    }, [
        isSequenceHidden,
        style
    ]);
    const crossOriginValue = crossOrigin ?? (onVideoFrame ? "anonymous" : "");
    return (0, $7b02d682eb115277$exports.jsx)("video", {
        ref: videoRef,
        muted: muted || mediaMuted,
        playsInline: true,
        src: actualSrc,
        loop: _remotionInternalNativeLoopPassed,
        style: actualStyle,
        disableRemotePlayback: true,
        crossOrigin: crossOriginValue,
        ...nativeProps
    });
};
var $c78df6347432a4c1$var$VideoForPreview = (0, $acw62.forwardRef)($c78df6347432a4c1$var$VideoForDevelopmentRefForwardingFunction);
var $c78df6347432a4c1$export$5d890d9b17ec59e5 = (props2)=>{
    const { startFrom: startFrom, endAt: endAt, name: name, pauseWhenBuffering: pauseWhenBuffering, stack: stack, showInTimeline: showInTimeline, ...otherProps } = props2;
    const environment = $c78df6347432a4c1$export$2a36334a5203003d();
    const onDuration = (0, $acw62.useCallback)(()=>{
        return;
    }, []);
    if (typeof props2.src !== "string") throw new TypeError(`The \`<OffthreadVideo>\` tag requires a string for \`src\`, but got ${JSON.stringify(props2.src)} instead.`);
    if (props2.imageFormat) throw new TypeError(`The \`<OffthreadVideo>\` tag does no longer accept \`imageFormat\`. Use the \`transparent\` prop if you want to render a transparent video.`);
    if (typeof startFrom !== "undefined" || typeof endAt !== "undefined") {
        $c78df6347432a4c1$var$validateStartFromProps(startFrom, endAt);
        const startFromFrameNo = startFrom ?? 0;
        const endAtFrameNo = endAt ?? Infinity;
        return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$export$edde1bcb1b2b310e, {
            layout: "none",
            from: 0 - startFromFrameNo,
            showInTimeline: false,
            durationInFrames: endAtFrameNo,
            name: name,
            children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$export$5d890d9b17ec59e5, {
                pauseWhenBuffering: pauseWhenBuffering ?? false,
                ...otherProps
            })
        });
    }
    $c78df6347432a4c1$var$validateMediaProps(props2, "Video");
    if (environment.isRendering) return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$OffthreadVideoForRendering, {
        ...otherProps
    });
    const { transparent: transparent, toneMapped: toneMapped, _remotionDebugSeeking: _remotionDebugSeeking, onAutoPlayError: onAutoPlayError, onVideoFrame: onVideoFrame, crossOrigin: crossOrigin, ...withoutTransparent } = otherProps;
    return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$VideoForPreview, {
        _remotionInternalStack: stack ?? null,
        _remotionInternalNativeLoopPassed: false,
        _remotionDebugSeeking: _remotionDebugSeeking ?? false,
        onDuration: onDuration,
        onlyWarnForMediaSeekingError: true,
        pauseWhenBuffering: pauseWhenBuffering ?? false,
        showInTimeline: showInTimeline ?? true,
        onAutoPlayError: onAutoPlayError ?? undefined,
        onVideoFrame: onVideoFrame ?? null,
        crossOrigin: crossOrigin,
        ...withoutTransparent
    });
};
// src/video/seek-until-right.ts
var $c78df6347432a4c1$var$roundTo6Commas = (num)=>{
    return Math.round(num * 1e5) / 1e5;
};
var $c78df6347432a4c1$var$seekToTime = (element, desiredTime)=>{
    element.currentTime = desiredTime;
    let cancel;
    let cancelSeeked = null;
    const prom = new Promise((resolve)=>{
        cancel = element.requestVideoFrameCallback((now, metadata)=>{
            const displayIn = metadata.expectedDisplayTime - now;
            if (displayIn <= 0) {
                resolve(metadata.mediaTime);
                return;
            }
            setTimeout(()=>{
                resolve(metadata.mediaTime);
            }, displayIn + 150);
        });
    });
    const waitForSeekedEvent = new Promise((resolve)=>{
        const onDone = ()=>{
            resolve();
        };
        element.addEventListener("seeked", onDone, {
            once: true
        });
        cancelSeeked = ()=>{
            element.removeEventListener("seeked", onDone);
        };
    });
    return {
        wait: Promise.all([
            prom,
            waitForSeekedEvent
        ]).then(([time])=>time),
        cancel: ()=>{
            cancelSeeked?.();
            element.cancelVideoFrameCallback(cancel);
        }
    };
};
var $c78df6347432a4c1$var$seekToTimeMultipleUntilRight = (element, desiredTime, fps)=>{
    const threshold = 1 / fps / 2;
    let currentCancel = ()=>{
        return;
    };
    if (Number.isFinite(element.duration) && element.currentTime >= element.duration && desiredTime >= element.duration) return {
        prom: Promise.resolve(),
        cancel: ()=>{}
    };
    const prom = new Promise((resolve, reject)=>{
        const firstSeek = $c78df6347432a4c1$var$seekToTime(element, desiredTime + threshold);
        firstSeek.wait.then((seekedTo)=>{
            const difference = Math.abs(desiredTime - seekedTo);
            if (difference <= threshold) return resolve();
            const sign = desiredTime > seekedTo ? 1 : -1;
            const newSeek = $c78df6347432a4c1$var$seekToTime(element, seekedTo + threshold * sign);
            currentCancel = newSeek.cancel;
            newSeek.wait.then((newTime)=>{
                const newDifference = Math.abs(desiredTime - newTime);
                if ($c78df6347432a4c1$var$roundTo6Commas(newDifference) <= $c78df6347432a4c1$var$roundTo6Commas(threshold)) return resolve();
                const thirdSeek = $c78df6347432a4c1$var$seekToTime(element, desiredTime + threshold);
                currentCancel = thirdSeek.cancel;
                return thirdSeek.wait.then(()=>{
                    resolve();
                }).catch((err)=>{
                    reject(err);
                });
            }).catch((err)=>{
                reject(err);
            });
        });
        currentCancel = firstSeek.cancel;
    });
    return {
        prom: prom,
        cancel: ()=>{
            currentCancel();
        }
    };
};
var $c78df6347432a4c1$var$VideoForRenderingForwardFunction = ({ onError: onError, volume: volumeProp, allowAmplificationDuringRender: allowAmplificationDuringRender, playbackRate: playbackRate, onDuration: onDuration, toneFrequency: toneFrequency, name: name, acceptableTimeShiftInSeconds: acceptableTimeShiftInSeconds, delayRenderRetries: delayRenderRetries, delayRenderTimeoutInMilliseconds: delayRenderTimeoutInMilliseconds, loopVolumeCurveBehavior: loopVolumeCurveBehavior, ...props2 }, ref)=>{
    const absoluteFrame = $c78df6347432a4c1$var$useTimelinePosition();
    const frame = $c78df6347432a4c1$export$e82ee3202ebaa1e9();
    const volumePropsFrame = $c78df6347432a4c1$var$useFrameForVolumeProp(loopVolumeCurveBehavior ?? "repeat");
    const videoConfig = $c78df6347432a4c1$var$useUnsafeVideoConfig();
    const videoRef = (0, $acw62.useRef)(null);
    const sequenceContext = (0, $acw62.useContext)($c78df6347432a4c1$var$SequenceContext);
    const mediaStartsAt = $c78df6347432a4c1$var$useMediaStartsAt();
    const environment = $c78df6347432a4c1$export$2a36334a5203003d();
    const { registerRenderAsset: registerRenderAsset, unregisterRenderAsset: unregisterRenderAsset } = (0, $acw62.useContext)($c78df6347432a4c1$var$RenderAssetManager);
    const id = (0, $acw62.useMemo)(()=>`video-${$c78df6347432a4c1$export$4385e60b38654f68(props2.src ?? "")}-${sequenceContext?.cumulatedFrom}-${sequenceContext?.relativeFrom}-${sequenceContext?.durationInFrames}`, [
        props2.src,
        sequenceContext?.cumulatedFrom,
        sequenceContext?.relativeFrom,
        sequenceContext?.durationInFrames
    ]);
    if (!videoConfig) throw new Error("No video config found");
    const volume = $c78df6347432a4c1$var$evaluateVolume({
        volume: volumeProp,
        frame: volumePropsFrame,
        mediaVolume: 1,
        allowAmplificationDuringRender: allowAmplificationDuringRender ?? false
    });
    (0, $acw62.useEffect)(()=>{
        if (!props2.src) throw new Error("No src passed");
        if (props2.muted) return;
        if (volume <= 0) return;
        if (!window.remotion_audioEnabled) return;
        registerRenderAsset({
            type: "video",
            src: $c78df6347432a4c1$var$getAbsoluteSrc(props2.src),
            id: id,
            frame: absoluteFrame,
            volume: volume,
            mediaFrame: frame,
            playbackRate: playbackRate ?? 1,
            allowAmplificationDuringRender: allowAmplificationDuringRender ?? false,
            toneFrequency: toneFrequency ?? null,
            audioStartFrame: Math.max(0, -(sequenceContext?.relativeFrom ?? 0))
        });
        return ()=>unregisterRenderAsset(id);
    }, [
        props2.muted,
        props2.src,
        registerRenderAsset,
        id,
        unregisterRenderAsset,
        volume,
        frame,
        absoluteFrame,
        playbackRate,
        allowAmplificationDuringRender,
        toneFrequency,
        sequenceContext?.relativeFrom
    ]);
    (0, $acw62.useImperativeHandle)(ref, ()=>{
        return videoRef.current;
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!window.remotion_videoEnabled) return;
        const { current: current } = videoRef;
        if (!current) return;
        const currentTime = $c78df6347432a4c1$var$getMediaTime({
            frame: frame,
            playbackRate: playbackRate || 1,
            startFrom: -mediaStartsAt,
            fps: videoConfig.fps
        });
        const handle = $c78df6347432a4c1$export$c3ec5096f1c973ca(`Rendering <Video /> with src="${props2.src}"`, {
            retries: delayRenderRetries ?? undefined,
            timeoutInMilliseconds: delayRenderTimeoutInMilliseconds ?? undefined
        });
        if (window.process?.env?.NODE_ENV === "test") {
            $c78df6347432a4c1$export$616bfefa2b04605f(handle);
            return;
        }
        if ($c78df6347432a4c1$var$isApproximatelyTheSame(current.currentTime, currentTime)) {
            if (current.readyState >= 2) {
                $c78df6347432a4c1$export$616bfefa2b04605f(handle);
                return;
            }
            const loadedDataHandler = ()=>{
                $c78df6347432a4c1$export$616bfefa2b04605f(handle);
            };
            current.addEventListener("loadeddata", loadedDataHandler, {
                once: true
            });
            return ()=>{
                current.removeEventListener("loadeddata", loadedDataHandler);
            };
        }
        const endedHandler = ()=>{
            $c78df6347432a4c1$export$616bfefa2b04605f(handle);
        };
        const seek2 = $c78df6347432a4c1$var$seekToTimeMultipleUntilRight(current, currentTime, videoConfig.fps);
        seek2.prom.then(()=>{
            $c78df6347432a4c1$export$616bfefa2b04605f(handle);
        });
        current.addEventListener("ended", endedHandler, {
            once: true
        });
        const errorHandler = ()=>{
            if (current?.error) {
                console.error("Error occurred in video", current?.error);
                if (onError) return;
                throw new Error(`The browser threw an error while playing the video ${props2.src}: Code ${current.error.code} - ${current?.error?.message}. See https://remotion.dev/docs/media-playback-error for help. Pass an onError() prop to handle the error.`);
            } else throw new Error("The browser threw an error");
        };
        current.addEventListener("error", errorHandler, {
            once: true
        });
        return ()=>{
            seek2.cancel();
            current.removeEventListener("ended", endedHandler);
            current.removeEventListener("error", errorHandler);
            $c78df6347432a4c1$export$616bfefa2b04605f(handle);
        };
    }, [
        volumePropsFrame,
        props2.src,
        playbackRate,
        videoConfig.fps,
        frame,
        mediaStartsAt,
        onError,
        delayRenderRetries,
        delayRenderTimeoutInMilliseconds
    ]);
    const { src: src } = props2;
    if (environment.isRendering) (0, $acw62.useLayoutEffect)(()=>{
        if (window.process?.env?.NODE_ENV === "test") return;
        const newHandle = $c78df6347432a4c1$export$c3ec5096f1c973ca("Loading <Video> duration with src=" + src, {
            retries: delayRenderRetries ?? undefined,
            timeoutInMilliseconds: delayRenderTimeoutInMilliseconds ?? undefined
        });
        const { current: current } = videoRef;
        const didLoad = ()=>{
            if (current?.duration) onDuration(src, current.duration);
            $c78df6347432a4c1$export$616bfefa2b04605f(newHandle);
        };
        if (current?.duration) {
            onDuration(src, current.duration);
            $c78df6347432a4c1$export$616bfefa2b04605f(newHandle);
        } else current?.addEventListener("loadedmetadata", didLoad, {
            once: true
        });
        return ()=>{
            current?.removeEventListener("loadedmetadata", didLoad);
            $c78df6347432a4c1$export$616bfefa2b04605f(newHandle);
        };
    }, [
        src,
        onDuration,
        delayRenderRetries,
        delayRenderTimeoutInMilliseconds
    ]);
    return (0, $7b02d682eb115277$exports.jsx)("video", {
        ref: videoRef,
        ...props2
    });
};
var $c78df6347432a4c1$var$VideoForRendering = (0, $acw62.forwardRef)($c78df6347432a4c1$var$VideoForRenderingForwardFunction);
var $c78df6347432a4c1$var$VideoForwardingFunction = (props2, ref)=>{
    const { startFrom: startFrom, endAt: endAt, name: name, pauseWhenBuffering: pauseWhenBuffering, stack: stack, _remotionInternalNativeLoopPassed: _remotionInternalNativeLoopPassed, showInTimeline: showInTimeline, onAutoPlayError: onAutoPlayError, onVideoFrame: onVideoFrame, crossOrigin: crossOrigin, ...otherProps } = props2;
    const { loop: loop4, _remotionDebugSeeking: _remotionDebugSeeking, ...propsOtherThanLoop } = props2;
    const { fps: fps } = $c78df6347432a4c1$export$da01606c8b81c2a0();
    const environment = $c78df6347432a4c1$export$2a36334a5203003d();
    const { durations: durations, setDurations: setDurations } = (0, $acw62.useContext)($c78df6347432a4c1$var$DurationsContext);
    if (typeof ref === "string") throw new Error("string refs are not supported");
    if (typeof props2.src !== "string") throw new TypeError(`The \`<Video>\` tag requires a string for \`src\`, but got ${JSON.stringify(props2.src)} instead.`);
    const preloadedSrc = $c78df6347432a4c1$var$usePreload(props2.src);
    const onDuration = (0, $acw62.useCallback)((src, durationInSeconds)=>{
        setDurations({
            type: "got-duration",
            durationInSeconds: durationInSeconds,
            src: src
        });
    }, [
        setDurations
    ]);
    const durationFetched = durations[$c78df6347432a4c1$var$getAbsoluteSrc(preloadedSrc)] ?? durations[$c78df6347432a4c1$var$getAbsoluteSrc(props2.src)];
    if (loop4 && durationFetched !== undefined) {
        const mediaDuration = durationFetched * fps;
        return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$export$550acbd06a1f5a6a, {
            durationInFrames: $c78df6347432a4c1$var$calculateLoopDuration({
                endAt: endAt,
                mediaDuration: mediaDuration,
                playbackRate: props2.playbackRate ?? 1,
                startFrom: startFrom
            }),
            layout: "none",
            name: name,
            children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$export$ae01dedf5c052bb, {
                ...propsOtherThanLoop,
                ref: ref,
                onVideoFrame: onVideoFrame,
                _remotionInternalNativeLoopPassed: true
            })
        });
    }
    if (typeof startFrom !== "undefined" || typeof endAt !== "undefined") {
        $c78df6347432a4c1$var$validateStartFromProps(startFrom, endAt);
        const startFromFrameNo = startFrom ?? 0;
        const endAtFrameNo = endAt ?? Infinity;
        return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$export$edde1bcb1b2b310e, {
            layout: "none",
            from: 0 - startFromFrameNo,
            showInTimeline: false,
            durationInFrames: endAtFrameNo,
            name: name,
            children: (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$export$ae01dedf5c052bb, {
                pauseWhenBuffering: pauseWhenBuffering ?? false,
                onVideoFrame: onVideoFrame,
                ...otherProps,
                ref: ref
            })
        });
    }
    $c78df6347432a4c1$var$validateMediaProps(props2, "Video");
    if (environment.isRendering) return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$VideoForRendering, {
        onDuration: onDuration,
        onVideoFrame: onVideoFrame ?? null,
        ...otherProps,
        ref: ref
    });
    return (0, $7b02d682eb115277$exports.jsx)($c78df6347432a4c1$var$VideoForPreview, {
        onlyWarnForMediaSeekingError: false,
        ...otherProps,
        ref: ref,
        onVideoFrame: onVideoFrame ?? null,
        pauseWhenBuffering: pauseWhenBuffering ?? false,
        onDuration: onDuration,
        _remotionInternalStack: stack ?? null,
        _remotionInternalNativeLoopPassed: _remotionInternalNativeLoopPassed ?? false,
        _remotionDebugSeeking: _remotionDebugSeeking ?? false,
        showInTimeline: showInTimeline ?? true,
        onAutoPlayError: onAutoPlayError ?? undefined,
        crossOrigin: crossOrigin
    });
};
var $c78df6347432a4c1$export$ae01dedf5c052bb = (0, $acw62.forwardRef)($c78df6347432a4c1$var$VideoForwardingFunction);
$c78df6347432a4c1$var$addSequenceStackTraces($c78df6347432a4c1$export$ae01dedf5c052bb);
// src/index.ts
$c78df6347432a4c1$var$checkMultipleRemotionVersions();
var $c78df6347432a4c1$export$b15996dc65b33ec3 = {
    Clipper: $c78df6347432a4c1$var$Clipper,
    Null: $c78df6347432a4c1$var$Null,
    useIsPlayer: $c78df6347432a4c1$var$useIsPlayer
};
var $c78df6347432a4c1$var$proxyObj = {};
var $c78df6347432a4c1$export$29cd7b75162a9425 = new Proxy($c78df6347432a4c1$var$proxyObj, {
    get (_, prop) {
        if (prop === "Bundling" || prop === "Rendering" || prop === "Log" || prop === "Puppeteer" || prop === "Output") return $c78df6347432a4c1$export$29cd7b75162a9425;
        return ()=>{
            console.warn("\u26A0\uFE0F  The CLI configuration has been extracted from Remotion Core.");
            console.warn("Update the import from the config file:");
            console.warn();
            console.warn("- Delete:");
            console.warn('import {Config} from "remotion";');
            console.warn("+ Replace:");
            console.warn('import {Config} from "@remotion/cli/config";');
            console.warn();
            console.warn("For more information, see https://www.remotion.dev/docs/4-0-migration.");
            $cfae44f0dfdf62c0$exports.exit(1);
        };
    }
});
$c78df6347432a4c1$var$addSequenceStackTraces($c78df6347432a4c1$export$edde1bcb1b2b310e);



var $acw62 = parcelRequire("acw62");
// src/interpolate.ts
var $9380aba48b3a6b29$var$interpolateFunction = function(input, inputRange, outputRange, options) {
    const { extrapolateLeft: extrapolateLeft, extrapolateRight: extrapolateRight, easing: easing } = options;
    let result = input;
    const [inputMin, inputMax] = inputRange;
    const [outputMin, outputMax] = outputRange;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        if (extrapolateLeft === "clamp") result = inputMin;
        else if (extrapolateLeft === "wrap") {
            const range = inputMax - inputMin;
            result = ((result - inputMin) % range + range) % range + inputMin;
        } else extrapolateLeft;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        if (extrapolateRight === "clamp") result = inputMax;
        else if (extrapolateRight === "wrap") {
            const range = inputMax - inputMin;
            result = ((result - inputMin) % range + range) % range + inputMin;
        } else extrapolateRight;
    }
    if (outputMin === outputMax) return outputMin;
    result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    result = result * (outputMax - outputMin) + outputMin;
    return result;
};
var $9380aba48b3a6b29$var$findRange = function(input, inputRange) {
    let i;
    for(i = 1; i < inputRange.length - 1; ++i){
        if (inputRange[i] >= input) break;
    }
    return i - 1;
};
var $9380aba48b3a6b29$var$checkValidInputRange = function(arr) {
    for(let i = 1; i < arr.length; ++i){
        if (!(arr[i] > arr[i - 1])) throw new Error(`inputRange must be strictly monotonically increasing but got [${arr.join(",")}]`);
    }
};
var $9380aba48b3a6b29$var$checkInfiniteRange = function(name, arr) {
    if (arr.length < 2) throw new Error(name + " must have at least 2 elements");
    for (const element of arr){
        if (typeof element !== "number") throw new Error(`${name} must contain only numbers`);
        if (!Number.isFinite(element)) throw new Error(`${name} must contain only finite numbers, but got [${arr.join(",")}]`);
    }
};
function $9380aba48b3a6b29$export$89e29e4ab65e70a9(input, inputRange, outputRange, options) {
    if (typeof input === "undefined") throw new Error("input can not be undefined");
    if (typeof inputRange === "undefined") throw new Error("inputRange can not be undefined");
    if (typeof outputRange === "undefined") throw new Error("outputRange can not be undefined");
    if (inputRange.length !== outputRange.length) throw new Error("inputRange (" + inputRange.length + ") and outputRange (" + outputRange.length + ") must have the same length");
    $9380aba48b3a6b29$var$checkInfiniteRange("inputRange", inputRange);
    $9380aba48b3a6b29$var$checkInfiniteRange("outputRange", outputRange);
    $9380aba48b3a6b29$var$checkValidInputRange(inputRange);
    const easing = options?.easing ?? ((num)=>num);
    let extrapolateLeft = "extend";
    if (options?.extrapolateLeft !== undefined) extrapolateLeft = options.extrapolateLeft;
    let extrapolateRight = "extend";
    if (options?.extrapolateRight !== undefined) extrapolateRight = options.extrapolateRight;
    if (typeof input !== "number") throw new TypeError("Cannot interpolate an input which is not a number");
    const range = $9380aba48b3a6b29$var$findRange(input, inputRange);
    return $9380aba48b3a6b29$var$interpolateFunction(input, [
        inputRange[range],
        inputRange[range + 1]
    ], [
        outputRange[range],
        outputRange[range + 1]
    ], {
        easing: easing,
        extrapolateLeft: extrapolateLeft,
        extrapolateRight: extrapolateRight
    });
}
// src/random.ts
var $9380aba48b3a6b29$var$mulberry32 = function(a) {
    let t = a + 1831565813;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
};
var $9380aba48b3a6b29$var$hashCode = function(str) {
    let i = 0;
    let chr = 0;
    let hash = 0;
    for(i = 0; i < str.length; i++){
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0;
    }
    return hash;
};
var $9380aba48b3a6b29$export$4385e60b38654f68 = (seed, dummy)=>{
    if (dummy !== undefined) throw new TypeError("random() takes only one argument");
    if (seed === null) return Math.random();
    if (typeof seed === "string") return $9380aba48b3a6b29$var$mulberry32($9380aba48b3a6b29$var$hashCode(seed));
    if (typeof seed === "number") return $9380aba48b3a6b29$var$mulberry32(seed * 10000000000);
    throw new Error("random() argument must be a number or a string");
};
// src/truthy.ts
function $9380aba48b3a6b29$var$truthy(value) {
    return Boolean(value);
}
// src/delay-render.ts
if (typeof window !== "undefined") window.remotion_renderReady = false;
if (typeof window !== "undefined") window.remotion_delayRenderTimeouts = {};
var $9380aba48b3a6b29$var$DELAY_RENDER_CALLSTACK_TOKEN = "The delayRender was called:";
var $9380aba48b3a6b29$var$DELAY_RENDER_RETRIES_LEFT = "Retries left: ";
var $9380aba48b3a6b29$var$DELAY_RENDER_RETRY_TOKEN = "- Rendering the frame will be retried.";
// src/static-file.ts
var $9380aba48b3a6b29$var$problematicCharacters = {
    "%3A": ":",
    "%2F": "/",
    "%3F": "?",
    "%23": "#",
    "%5B": "[",
    "%5D": "]",
    "%40": "@",
    "%21": "!",
    "%24": "$",
    "%26": "&",
    "%27": "'",
    "%28": "(",
    "%29": ")",
    "%2A": "*",
    "%2B": "+",
    "%2C": ",",
    "%3B": ";"
};
var $9380aba48b3a6b29$var$didWarn = {};
var $9380aba48b3a6b29$var$warnOnce = (message)=>{
    if ($9380aba48b3a6b29$var$didWarn[message]) return;
    console.warn(message);
    $9380aba48b3a6b29$var$didWarn[message] = true;
};
var $9380aba48b3a6b29$var$includesHexOfUnsafeChar = (path)=>{
    for (const key of Object.keys($9380aba48b3a6b29$var$problematicCharacters)){
        if (path.includes(key)) return {
            containsHex: true,
            hexCode: key
        };
    }
    return {
        containsHex: false
    };
};
var $9380aba48b3a6b29$var$trimLeadingSlash = (path)=>{
    if (path.startsWith("/")) return $9380aba48b3a6b29$var$trimLeadingSlash(path.substring(1));
    return path;
};
var $9380aba48b3a6b29$var$inner = (path)=>{
    if (typeof window !== "undefined" && window.remotion_staticBase) {
        if (path.startsWith(window.remotion_staticBase)) throw new Error(`The value "${path}" is already prefixed with the static base ${window.remotion_staticBase}. You don't need to call staticFile() on it.`);
        return `${window.remotion_staticBase}/${$9380aba48b3a6b29$var$trimLeadingSlash(path)}`;
    }
    return `/${$9380aba48b3a6b29$var$trimLeadingSlash(path)}`;
};
var $9380aba48b3a6b29$var$encodeBySplitting = (path)=>{
    const splitBySlash = path.split("/");
    const encodedArray = splitBySlash.map((element)=>{
        return encodeURIComponent(element);
    });
    const merged = encodedArray.join("/");
    return merged;
};
var $9380aba48b3a6b29$var$staticFile = (path)=>{
    if (path.startsWith("http://") || path.startsWith("https://")) throw new TypeError(`staticFile() does not support remote URLs - got "${path}". Instead, pass the URL without wrapping it in staticFile(). See: https://remotion.dev/docs/staticfile-remote-urls`);
    if (path.startsWith("..") || path.startsWith("./")) throw new TypeError(`staticFile() does not support relative paths - got "${path}". Instead, pass the name of a file that is inside the public/ folder. See: https://remotion.dev/docs/staticfile-relative-paths`);
    if (path.startsWith("/Users") || path.startsWith("/home") || path.startsWith("/tmp") || path.startsWith("/etc") || path.startsWith("/opt") || path.startsWith("/var") || path.startsWith("C:") || path.startsWith("D:") || path.startsWith("E:")) throw new TypeError(`staticFile() does not support absolute paths - got "${path}". Instead, pass the name of a file that is inside the public/ folder. See: https://remotion.dev/docs/staticfile-relative-paths`);
    if (path.startsWith("public/")) throw new TypeError(`Do not include the public/ prefix when using staticFile() - got "${path}". See: https://remotion.dev/docs/staticfile-relative-paths`);
    const includesHex = $9380aba48b3a6b29$var$includesHexOfUnsafeChar(path);
    if (includesHex.containsHex) $9380aba48b3a6b29$var$warnOnce(`WARNING: You seem to pass an already encoded path (path contains ${includesHex.hexCode}). Since Remotion 4.0, the encoding is done by staticFile() itself. You may want to remove a encodeURIComponent() wrapping.`);
    const preprocessed = $9380aba48b3a6b29$var$encodeBySplitting(path);
    const preparsed = $9380aba48b3a6b29$var$inner(preprocessed);
    if (!preparsed.startsWith("/")) return `/${preparsed}`;
    return preparsed;
};
// src/input-props-serialization.ts
var $9380aba48b3a6b29$var$DATE_TOKEN = "remotion-date:";
var $9380aba48b3a6b29$var$FILE_TOKEN = "remotion-file:";
var $9380aba48b3a6b29$var$serializeJSONWithDate = ({ data: data, indent: indent, staticBase: staticBase })=>{
    let customDateUsed = false;
    let customFileUsed = false;
    let mapUsed = false;
    let setUsed = false;
    try {
        const serializedString = JSON.stringify(data, function(key, value) {
            const item = this[key];
            if (item instanceof Date) {
                customDateUsed = true;
                return `${$9380aba48b3a6b29$var$DATE_TOKEN}${item.toISOString()}`;
            }
            if (item instanceof Map) {
                mapUsed = true;
                return value;
            }
            if (item instanceof Set) {
                setUsed = true;
                return value;
            }
            if (typeof item === "string" && staticBase !== null && item.startsWith(staticBase)) {
                customFileUsed = true;
                return `${$9380aba48b3a6b29$var$FILE_TOKEN}${item.replace(staticBase + "/", "")}`;
            }
            return value;
        }, indent);
        return {
            serializedString: serializedString,
            customDateUsed: customDateUsed,
            customFileUsed: customFileUsed,
            mapUsed: mapUsed,
            setUsed: setUsed
        };
    } catch (err) {
        throw new Error("Could not serialize the passed input props to JSON: " + err.message);
    }
};
var $9380aba48b3a6b29$var$deserializeJSONWithCustomFields = (data)=>{
    return JSON.parse(data, (_, value)=>{
        if (typeof value === "string" && value.startsWith($9380aba48b3a6b29$var$DATE_TOKEN)) return new Date(value.replace($9380aba48b3a6b29$var$DATE_TOKEN, ""));
        if (typeof value === "string" && value.startsWith($9380aba48b3a6b29$var$FILE_TOKEN)) return $9380aba48b3a6b29$var$staticFile(value.replace($9380aba48b3a6b29$var$FILE_TOKEN, ""));
        return value;
    });
};
// src/interpolate-colors.ts
var $9380aba48b3a6b29$var$call = function(...args) {
    return "\\(\\s*(" + args.join(")\\s*,\\s*(") + ")\\s*\\)";
};
var $9380aba48b3a6b29$var$getMatchers = function() {
    const cachedMatchers = {
        rgb: undefined,
        rgba: undefined,
        hsl: undefined,
        hsla: undefined,
        hex3: undefined,
        hex4: undefined,
        hex5: undefined,
        hex6: undefined,
        hex8: undefined
    };
    if (cachedMatchers.rgb === undefined) {
        cachedMatchers.rgb = new RegExp("rgb" + $9380aba48b3a6b29$var$call($9380aba48b3a6b29$var$NUMBER, $9380aba48b3a6b29$var$NUMBER, $9380aba48b3a6b29$var$NUMBER));
        cachedMatchers.rgba = new RegExp("rgba" + $9380aba48b3a6b29$var$call($9380aba48b3a6b29$var$NUMBER, $9380aba48b3a6b29$var$NUMBER, $9380aba48b3a6b29$var$NUMBER, $9380aba48b3a6b29$var$NUMBER));
        cachedMatchers.hsl = new RegExp("hsl" + $9380aba48b3a6b29$var$call($9380aba48b3a6b29$var$NUMBER, $9380aba48b3a6b29$var$PERCENTAGE, $9380aba48b3a6b29$var$PERCENTAGE));
        cachedMatchers.hsla = new RegExp("hsla" + $9380aba48b3a6b29$var$call($9380aba48b3a6b29$var$NUMBER, $9380aba48b3a6b29$var$PERCENTAGE, $9380aba48b3a6b29$var$PERCENTAGE, $9380aba48b3a6b29$var$NUMBER));
        cachedMatchers.hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
        cachedMatchers.hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
        cachedMatchers.hex6 = /^#([0-9a-fA-F]{6})$/;
        cachedMatchers.hex8 = /^#([0-9a-fA-F]{8})$/;
    }
    return cachedMatchers;
};
var $9380aba48b3a6b29$var$hue2rgb = function(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
};
var $9380aba48b3a6b29$var$hslToRgb = function(h, s, l) {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = $9380aba48b3a6b29$var$hue2rgb(p, q, h + 1 / 3);
    const g = $9380aba48b3a6b29$var$hue2rgb(p, q, h);
    const b = $9380aba48b3a6b29$var$hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
};
var $9380aba48b3a6b29$var$parse255 = function(str) {
    const int = Number.parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
};
var $9380aba48b3a6b29$var$parse360 = function(str) {
    const int = Number.parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
};
var $9380aba48b3a6b29$var$parse1 = function(str) {
    const num = Number.parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
};
var $9380aba48b3a6b29$var$parsePercentage = function(str) {
    const int = Number.parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
};
var $9380aba48b3a6b29$var$normalizeColor = function(color) {
    const matchers = $9380aba48b3a6b29$var$getMatchers();
    let match;
    if (matchers.hex6) {
        if (match = matchers.hex6.exec(color)) return Number.parseInt(match[1] + "ff", 16) >>> 0;
    }
    if ($9380aba48b3a6b29$var$colorNames[color] !== undefined) return $9380aba48b3a6b29$var$colorNames[color];
    if (matchers.rgb) {
        if (match = matchers.rgb.exec(color)) return ($9380aba48b3a6b29$var$parse255(match[1]) << 24 | $9380aba48b3a6b29$var$parse255(match[2]) << 16 | $9380aba48b3a6b29$var$parse255(match[3]) << 8 | 255) >>> 0;
    }
    if (matchers.rgba) {
        if (match = matchers.rgba.exec(color)) return ($9380aba48b3a6b29$var$parse255(match[1]) << 24 | $9380aba48b3a6b29$var$parse255(match[2]) << 16 | $9380aba48b3a6b29$var$parse255(match[3]) << 8 | $9380aba48b3a6b29$var$parse1(match[4])) >>> 0;
    }
    if (matchers.hex3) {
        if (match = matchers.hex3.exec(color)) return Number.parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + "ff", 16) >>> 0;
    }
    if (matchers.hex8) {
        if (match = matchers.hex8.exec(color)) return Number.parseInt(match[1], 16) >>> 0;
    }
    if (matchers.hex4) {
        if (match = matchers.hex4.exec(color)) return Number.parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + match[4] + match[4], 16) >>> 0;
    }
    if (matchers.hsl) {
        if (match = matchers.hsl.exec(color)) return ($9380aba48b3a6b29$var$hslToRgb($9380aba48b3a6b29$var$parse360(match[1]), $9380aba48b3a6b29$var$parsePercentage(match[2]), $9380aba48b3a6b29$var$parsePercentage(match[3])) | 255) >>> 0;
    }
    if (matchers.hsla) {
        if (match = matchers.hsla.exec(color)) return ($9380aba48b3a6b29$var$hslToRgb($9380aba48b3a6b29$var$parse360(match[1]), $9380aba48b3a6b29$var$parsePercentage(match[2]), $9380aba48b3a6b29$var$parsePercentage(match[3])) | $9380aba48b3a6b29$var$parse1(match[4])) >>> 0;
    }
    throw new Error(`invalid color string ${color} provided`);
};
function $9380aba48b3a6b29$var$processColor(color) {
    const normalizedColor = $9380aba48b3a6b29$var$normalizeColor(color);
    return (normalizedColor << 24 | normalizedColor >>> 8) >>> 0;
}
var $9380aba48b3a6b29$var$NUMBER = "[-+]?\\d*\\.?\\d+";
var $9380aba48b3a6b29$var$PERCENTAGE = $9380aba48b3a6b29$var$NUMBER + "%";
var $9380aba48b3a6b29$var$colorNames = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
};
// src/v5-flag.ts
var $9380aba48b3a6b29$var$ENABLE_V5_BREAKING_CHANGES = false;
// src/validate-frame.ts
var $9380aba48b3a6b29$var$validateFrame = ({ allowFloats: allowFloats, durationInFrames: durationInFrames, frame: frame })=>{
    if (typeof frame === "undefined") throw new TypeError(`Argument missing for parameter "frame"`);
    if (typeof frame !== "number") throw new TypeError(`Argument passed for "frame" is not a number: ${frame}`);
    if (!Number.isFinite(frame)) throw new RangeError(`Frame ${frame} is not finite`);
    if (frame % 1 !== 0 && !allowFloats) throw new RangeError(`Argument for frame must be an integer, but got ${frame}`);
    if (frame < 0 && frame < -durationInFrames) throw new RangeError(`Cannot use frame ${frame}: Duration of composition is ${durationInFrames}, therefore the lowest frame that can be rendered is ${-durationInFrames}`);
    if (frame > durationInFrames - 1) throw new RangeError(`Cannot use frame ${frame}: Duration of composition is ${durationInFrames}, therefore the highest frame that can be rendered is ${durationInFrames - 1}`);
};
// src/validation/validate-default-props.ts
var $9380aba48b3a6b29$var$validateDefaultAndInputProps = (defaultProps, name, compositionId)=>{
    if (!defaultProps) return;
    if (typeof defaultProps !== "object") throw new Error(`"${name}" must be an object, but you passed a value of type ${typeof defaultProps}`);
    if (Array.isArray(defaultProps)) throw new Error(`"${name}" must be an object, an array was passed ${compositionId ? `for composition "${compositionId}"` : ""}`);
};
// src/validation/validate-dimensions.ts
function $9380aba48b3a6b29$var$validateDimension(amount, nameOfProp, location) {
    if (typeof amount !== "number") throw new Error(`The "${nameOfProp}" prop ${location} must be a number, but you passed a value of type ${typeof amount}`);
    if (isNaN(amount)) throw new TypeError(`The "${nameOfProp}" prop ${location} must not be NaN, but is NaN.`);
    if (!Number.isFinite(amount)) throw new TypeError(`The "${nameOfProp}" prop ${location} must be finite, but is ${amount}.`);
    if (amount % 1 !== 0) throw new TypeError(`The "${nameOfProp}" prop ${location} must be an integer, but is ${amount}.`);
    if (amount <= 0) throw new TypeError(`The "${nameOfProp}" prop ${location} must be positive, but got ${amount}.`);
}
// src/validation/validate-duration-in-frames.ts
function $9380aba48b3a6b29$var$validateDurationInFrames(durationInFrames, options) {
    const { allowFloats: allowFloats, component: component } = options;
    if (typeof durationInFrames === "undefined") throw new Error(`The "durationInFrames" prop ${component} is missing.`);
    if (typeof durationInFrames !== "number") throw new Error(`The "durationInFrames" prop ${component} must be a number, but you passed a value of type ${typeof durationInFrames}`);
    if (durationInFrames <= 0) throw new TypeError(`The "durationInFrames" prop ${component} must be positive, but got ${durationInFrames}.`);
    if (!allowFloats && durationInFrames % 1 !== 0) throw new TypeError(`The "durationInFrames" prop ${component} must be an integer, but got ${durationInFrames}.`);
    if (!Number.isFinite(durationInFrames)) throw new TypeError(`The "durationInFrames" prop ${component} must be finite, but got ${durationInFrames}.`);
}
// src/validation/validate-fps.ts
function $9380aba48b3a6b29$var$validateFps(fps, location, isGif) {
    if (typeof fps !== "number") throw new Error(`"fps" must be a number, but you passed a value of type ${typeof fps} ${location}`);
    if (!Number.isFinite(fps)) throw new Error(`"fps" must be a finite, but you passed ${fps} ${location}`);
    if (isNaN(fps)) throw new Error(`"fps" must not be NaN, but got ${fps} ${location}`);
    if (fps <= 0) throw new TypeError(`"fps" must be positive, but got ${fps} ${location}`);
    if (isGif && fps > 50) throw new TypeError(`The FPS for a GIF cannot be higher than 50. Use the --every-nth-frame option to lower the FPS: https://remotion.dev/docs/render-as-gif`);
}
// src/video/get-current-time.ts
var $9380aba48b3a6b29$var$getExpectedMediaFrameUncorrected = ({ frame: frame, playbackRate: playbackRate, startFrom: startFrom })=>{
    return $9380aba48b3a6b29$export$89e29e4ab65e70a9(frame, [
        -1,
        startFrom,
        startFrom + 1
    ], [
        -1,
        startFrom,
        startFrom + playbackRate
    ]);
};
// src/absolute-src.ts
var $9380aba48b3a6b29$var$getAbsoluteSrc = (relativeSrc)=>{
    if (typeof window === "undefined") return relativeSrc;
    return new URL(relativeSrc, window.origin).href;
};
// src/video/offthread-video-source.ts
var $9380aba48b3a6b29$var$getOffthreadVideoSource = ({ src: src, transparent: transparent, currentTime: currentTime, toneMapped: toneMapped })=>{
    return `http://localhost:${window.remotion_proxyPort}/proxy?src=${encodeURIComponent($9380aba48b3a6b29$var$getAbsoluteSrc(src))}&time=${encodeURIComponent(currentTime)}&transparent=${String(transparent)}&toneMapped=${String(toneMapped)}`;
};
// src/no-react.ts
var $9380aba48b3a6b29$export$5ca440e467e58dfb = {
    processColor: $9380aba48b3a6b29$var$processColor,
    truthy: $9380aba48b3a6b29$var$truthy,
    validateFps: $9380aba48b3a6b29$var$validateFps,
    validateDimension: $9380aba48b3a6b29$var$validateDimension,
    validateDurationInFrames: $9380aba48b3a6b29$var$validateDurationInFrames,
    validateDefaultAndInputProps: $9380aba48b3a6b29$var$validateDefaultAndInputProps,
    validateFrame: $9380aba48b3a6b29$var$validateFrame,
    serializeJSONWithDate: $9380aba48b3a6b29$var$serializeJSONWithDate,
    bundleName: "bundle.js",
    bundleMapName: "bundle.js.map",
    deserializeJSONWithCustomFields: $9380aba48b3a6b29$var$deserializeJSONWithCustomFields,
    DELAY_RENDER_CALLSTACK_TOKEN: $9380aba48b3a6b29$var$DELAY_RENDER_CALLSTACK_TOKEN,
    DELAY_RENDER_RETRY_TOKEN: $9380aba48b3a6b29$var$DELAY_RENDER_RETRY_TOKEN,
    DELAY_RENDER_ATTEMPT_TOKEN: $9380aba48b3a6b29$var$DELAY_RENDER_RETRIES_LEFT,
    getOffthreadVideoSource: $9380aba48b3a6b29$var$getOffthreadVideoSource,
    getExpectedMediaFrameUncorrected: $9380aba48b3a6b29$var$getExpectedMediaFrameUncorrected,
    ENABLE_V5_BREAKING_CHANGES: $9380aba48b3a6b29$var$ENABLE_V5_BREAKING_CHANGES,
    MIN_NODE_VERSION: $9380aba48b3a6b29$var$ENABLE_V5_BREAKING_CHANGES ? 18 : 16,
    MIN_BUN_VERSION: $9380aba48b3a6b29$var$ENABLE_V5_BREAKING_CHANGES ? "1.1.3" : "1.0.3",
    colorNames: $9380aba48b3a6b29$var$colorNames,
    DATE_TOKEN: $9380aba48b3a6b29$var$DATE_TOKEN,
    FILE_TOKEN: $9380aba48b3a6b29$var$FILE_TOKEN
};


"use client";
var $f33cd4ca105fd87b$var$ICON_SIZE = 25;
var $f33cd4ca105fd87b$var$fullscreenIconSize = 16;
var $f33cd4ca105fd87b$var$PlayIcon = ()=>{
    return (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: $f33cd4ca105fd87b$var$ICON_SIZE,
        height: $f33cd4ca105fd87b$var$ICON_SIZE,
        viewBox: "0 0 25 25",
        fill: "none",
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8 6.375C7.40904 8.17576 7.06921 10.2486 7.01438 12.3871C6.95955 14.5255 7.19163 16.6547 7.6875 18.5625C9.95364 18.2995 12.116 17.6164 14.009 16.5655C15.902 15.5147 17.4755 14.124 18.6088 12.5C17.5158 10.8949 15.9949 9.51103 14.1585 8.45082C12.3222 7.3906 10.2174 6.68116 8 6.375Z",
            fill: "white",
            stroke: "white",
            strokeWidth: "6.25",
            strokeLinejoin: "round"
        })
    });
};
var $f33cd4ca105fd87b$var$PauseIcon = ()=>{
    return (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 100 100",
        width: $f33cd4ca105fd87b$var$ICON_SIZE,
        height: $f33cd4ca105fd87b$var$ICON_SIZE,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "25",
                y: "20",
                width: "20",
                height: "60",
                fill: "#fff",
                ry: "5",
                rx: "5"
            }),
            (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "55",
                y: "20",
                width: "20",
                height: "60",
                fill: "#fff",
                ry: "5",
                rx: "5"
            })
        ]
    });
};
var $f33cd4ca105fd87b$var$FullscreenIcon = ({ isFullscreen: isFullscreen })=>{
    const strokeWidth = 6;
    const viewSize = 32;
    const out = isFullscreen ? 0 : strokeWidth / 2;
    const middleInset = isFullscreen ? strokeWidth * 1.6 : strokeWidth / 2;
    const inset = isFullscreen ? strokeWidth * 1.6 : strokeWidth * 2;
    return (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: `0 0 ${viewSize} ${viewSize}`,
        height: $f33cd4ca105fd87b$var$fullscreenIconSize,
        width: $f33cd4ca105fd87b$var$fullscreenIconSize,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: `
				M ${out} ${inset}
				L ${middleInset} ${middleInset}
				L ${inset} ${out}
				`,
                stroke: "#fff",
                strokeWidth: strokeWidth,
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: `
				M ${viewSize - out} ${inset}
				L ${viewSize - middleInset} ${middleInset}
				L ${viewSize - inset} ${out}
				`,
                stroke: "#fff",
                strokeWidth: strokeWidth,
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: `
				M ${out} ${viewSize - inset}
				L ${middleInset} ${viewSize - middleInset}
				L ${inset} ${viewSize - out}
				`,
                stroke: "#fff",
                strokeWidth: strokeWidth,
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: `
				M ${viewSize - out} ${viewSize - inset}
				L ${viewSize - middleInset} ${viewSize - middleInset}
				L ${viewSize - inset} ${viewSize - out}
				`,
                stroke: "#fff",
                strokeWidth: strokeWidth,
                fill: "none"
            })
        ]
    });
};
var $f33cd4ca105fd87b$var$VolumeOffIcon = ()=>{
    return (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: $f33cd4ca105fd87b$var$ICON_SIZE,
        height: $f33cd4ca105fd87b$var$ICON_SIZE,
        viewBox: "0 0 24 24",
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3.63 3.63a.996.996 0 000 1.41L7.29 8.7 7 9H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71v-4.17l4.18 4.18c-.49.37-1.02.68-1.6.91-.36.15-.58.53-.58.92 0 .72.73 1.18 1.39.91.8-.33 1.55-.77 2.22-1.31l1.34 1.34a.996.996 0 101.41-1.41L5.05 3.63c-.39-.39-1.02-.39-1.42 0zM19 12c0 .82-.15 1.61-.41 2.34l1.53 1.53c.56-1.17.88-2.48.88-3.87 0-3.83-2.4-7.11-5.78-8.4-.59-.23-1.22.23-1.22.86v.19c0 .38.25.71.61.85C17.18 6.54 19 9.06 19 12zm-8.71-6.29l-.17.17L12 7.76V6.41c0-.89-1.08-1.33-1.71-.7zM16.5 12A4.5 4.5 0 0014 7.97v1.79l2.48 2.48c.01-.08.02-.16.02-.24z",
            fill: "#fff"
        })
    });
};
var $f33cd4ca105fd87b$var$VolumeOnIcon = ()=>{
    return (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: $f33cd4ca105fd87b$var$ICON_SIZE,
        height: $f33cd4ca105fd87b$var$ICON_SIZE,
        viewBox: "0 0 24 24",
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3 10v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71V6.41c0-.89-1.08-1.34-1.71-.71L7 9H4c-.55 0-1 .45-1 1zm13.5 2A4.5 4.5 0 0014 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 4.45v.2c0 .38.25.71.6.85C17.18 6.53 19 9.06 19 12s-1.82 5.47-4.4 6.5c-.36.14-.6.47-.6.85v.2c0 .63.63 1.07 1.21.85C18.6 19.11 21 15.84 21 12s-2.4-7.11-5.79-8.4c-.58-.23-1.21.22-1.21.85z",
            fill: "#fff"
        })
    });
};
var $f33cd4ca105fd87b$var$className = "__remotion_buffering_indicator";
var $f33cd4ca105fd87b$var$remotionBufferingAnimation = "__remotion_buffering_animation";
var $f33cd4ca105fd87b$var$playerStyle = {
    width: $f33cd4ca105fd87b$var$ICON_SIZE,
    height: $f33cd4ca105fd87b$var$ICON_SIZE,
    overflow: "hidden",
    lineHeight: "normal",
    fontSize: "inherit"
};
var $f33cd4ca105fd87b$var$studioStyle = {
    width: 14,
    height: 14,
    overflow: "hidden",
    lineHeight: "normal",
    fontSize: "inherit"
};
var $f33cd4ca105fd87b$var$BufferingIndicator = ({ type: type })=>{
    const style = type === "player" ? $f33cd4ca105fd87b$var$playerStyle : $f33cd4ca105fd87b$var$studioStyle;
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("style", {
                type: "text/css",
                children: `
				@keyframes ${$f33cd4ca105fd87b$var$remotionBufferingAnimation} {
          0% {
            rotate: 0deg;
          }
          100% {
            rotate: 360deg;
          }
        }
        
        .${$f33cd4ca105fd87b$var$className} {
            animation: ${$f33cd4ca105fd87b$var$remotionBufferingAnimation} 1s linear infinite;
        }        
			`
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                style: style,
                children: (0, $7b02d682eb115277$exports.jsx)("svg", {
                    viewBox: type === "player" ? "0 0 22 22" : "0 0 18 18",
                    style: style,
                    className: $f33cd4ca105fd87b$var$className,
                    children: (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: type === "player" ? "M 11 4 A 7 7 0 0 1 15.1145 16.66312" : "M 9 2 A 7 7 0 0 1 13.1145 14.66312",
                        stroke: "white",
                        strokeLinecap: "round",
                        fill: "none",
                        strokeWidth: 3
                    })
                })
            })
        ]
    });
};
// src/utils/calculate-player-size.ts
var $f33cd4ca105fd87b$var$calculatePlayerSize = ({ currentSize: currentSize, width: width, height: height, compositionWidth: compositionWidth, compositionHeight: compositionHeight })=>{
    if (width !== undefined && height === undefined) return {
        aspectRatio: [
            compositionWidth,
            compositionHeight
        ].join("/")
    };
    if (height !== undefined && width === undefined) return {
        aspectRatio: [
            compositionWidth,
            compositionHeight
        ].join("/")
    };
    if (!currentSize) return {
        width: compositionWidth,
        height: compositionHeight
    };
    return {
        width: compositionWidth,
        height: compositionHeight
    };
};
// src/calculate-scale.ts
var $f33cd4ca105fd87b$var$calculateCanvasTransformation = ({ previewSize: previewSize, compositionWidth: compositionWidth, compositionHeight: compositionHeight, canvasSize: canvasSize })=>{
    const scale = (0, $c78df6347432a4c1$export$c39fff9f74a28020).calculateScale({
        canvasSize: canvasSize,
        compositionHeight: compositionHeight,
        compositionWidth: compositionWidth,
        previewSize: previewSize
    });
    const correction = 0 - (1 - scale) / 2;
    const xCorrection = correction * compositionWidth;
    const yCorrection = correction * compositionHeight;
    const width = compositionWidth * scale;
    const height = compositionHeight * scale;
    const centerX = canvasSize.width / 2 - width / 2;
    const centerY = canvasSize.height / 2 - height / 2;
    return {
        centerX: centerX,
        centerY: centerY,
        xCorrection: xCorrection,
        yCorrection: yCorrection,
        scale: scale
    };
};
var $f33cd4ca105fd87b$var$calculateOuterStyle = ({ config: config, style: style, canvasSize: canvasSize, overflowVisible: overflowVisible })=>{
    if (!config) return {};
    return {
        position: "relative",
        overflow: overflowVisible ? "visible" : "hidden",
        ...$f33cd4ca105fd87b$var$calculatePlayerSize({
            compositionHeight: config.height,
            compositionWidth: config.width,
            currentSize: canvasSize,
            height: style?.height,
            width: style?.width
        }),
        ...style
    };
};
var $f33cd4ca105fd87b$var$calculateContainerStyle = ({ config: config, canvasSize: canvasSize, layout: layout, scale: scale, overflowVisible: overflowVisible })=>{
    if (!config || !canvasSize || !layout) return {};
    return {
        position: "absolute",
        width: config.width,
        height: config.height,
        display: "flex",
        transform: `scale(${scale})`,
        marginLeft: layout.xCorrection,
        marginTop: layout.yCorrection,
        overflow: overflowVisible ? "visible" : "hidden"
    };
};
var $f33cd4ca105fd87b$var$calculateOuter = ({ layout: layout, scale: scale, config: config, overflowVisible: overflowVisible })=>{
    if (!layout || !config) return {};
    const { centerX: centerX, centerY: centerY } = layout;
    return {
        width: config.width * scale,
        height: config.height * scale,
        display: "flex",
        flexDirection: "column",
        position: "absolute",
        left: centerX,
        top: centerY,
        overflow: overflowVisible ? "visible" : "hidden"
    };
};
var $f33cd4ca105fd87b$var$PlayerEventEmitterContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(undefined);
var $f33cd4ca105fd87b$var$ThumbnailEmitterContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(undefined);
// src/event-emitter.ts
class $f33cd4ca105fd87b$var$PlayerEmitter {
    listeners = {
        ended: [],
        error: [],
        pause: [],
        play: [],
        ratechange: [],
        scalechange: [],
        seeked: [],
        timeupdate: [],
        frameupdate: [],
        fullscreenchange: [],
        volumechange: [],
        mutechange: [],
        waiting: [],
        resume: []
    };
    addEventListener(name, callback) {
        this.listeners[name].push(callback);
    }
    removeEventListener(name, callback) {
        this.listeners[name] = this.listeners[name].filter((l)=>l !== callback);
    }
    dispatchEvent(dispatchName, context) {
        this.listeners[dispatchName].forEach((callback)=>{
            callback({
                detail: context
            });
        });
    }
    dispatchSeek(frame) {
        this.dispatchEvent("seeked", {
            frame: frame
        });
    }
    dispatchVolumeChange(volume) {
        this.dispatchEvent("volumechange", {
            volume: volume
        });
    }
    dispatchPause() {
        this.dispatchEvent("pause", undefined);
    }
    dispatchPlay() {
        this.dispatchEvent("play", undefined);
    }
    dispatchEnded() {
        this.dispatchEvent("ended", undefined);
    }
    dispatchRateChange(playbackRate) {
        this.dispatchEvent("ratechange", {
            playbackRate: playbackRate
        });
    }
    dispatchScaleChange(scale) {
        this.dispatchEvent("scalechange", {
            scale: scale
        });
    }
    dispatchError(error) {
        this.dispatchEvent("error", {
            error: error
        });
    }
    dispatchTimeUpdate(event) {
        this.dispatchEvent("timeupdate", event);
    }
    dispatchFrameUpdate(event) {
        this.dispatchEvent("frameupdate", event);
    }
    dispatchFullscreenChange(event) {
        this.dispatchEvent("fullscreenchange", event);
    }
    dispatchMuteChange(event) {
        this.dispatchEvent("mutechange", event);
    }
    dispatchWaiting(event) {
        this.dispatchEvent("waiting", event);
    }
    dispatchResume(event) {
        this.dispatchEvent("resume", event);
    }
}
class $f33cd4ca105fd87b$var$ThumbnailEmitter {
    listeners = {
        error: [],
        waiting: [],
        resume: []
    };
    addEventListener(name, callback) {
        this.listeners[name].push(callback);
    }
    removeEventListener(name, callback) {
        this.listeners[name] = this.listeners[name].filter((l)=>l !== callback);
    }
    dispatchEvent(dispatchName, context) {
        this.listeners[dispatchName].forEach((callback)=>{
            callback({
                detail: context
            });
        });
    }
    dispatchError(error) {
        this.dispatchEvent("error", {
            error: error
        });
    }
    dispatchWaiting(event) {
        this.dispatchEvent("waiting", event);
    }
    dispatchResume(event) {
        this.dispatchEvent("resume", event);
    }
}
var $f33cd4ca105fd87b$var$useBufferStateEmitter = (emitter)=>{
    const bufferManager = (0, $acw62.useContext)((0, $c78df6347432a4c1$export$c39fff9f74a28020).BufferingContextReact);
    if (!bufferManager) throw new Error("BufferingContextReact not found");
    (0, $acw62.useEffect)(()=>{
        const clear1 = bufferManager.listenForBuffering(()=>{
            bufferManager.buffering.current = true;
            emitter.dispatchWaiting({});
        });
        const clear2 = bufferManager.listenForResume(()=>{
            bufferManager.buffering.current = false;
            emitter.dispatchResume({});
        });
        return ()=>{
            clear1.remove();
            clear2.remove();
        };
    }, [
        bufferManager,
        emitter
    ]);
};
var $f33cd4ca105fd87b$var$PlayerEmitterProvider = ({ children: children, currentPlaybackRate: currentPlaybackRate })=>{
    const [emitter] = (0, $acw62.useState)(()=>new $f33cd4ca105fd87b$var$PlayerEmitter);
    const bufferManager = (0, $acw62.useContext)((0, $c78df6347432a4c1$export$c39fff9f74a28020).BufferingContextReact);
    if (!bufferManager) throw new Error("BufferingContextReact not found");
    (0, $acw62.useEffect)(()=>{
        if (currentPlaybackRate) emitter.dispatchRateChange(currentPlaybackRate);
    }, [
        emitter,
        currentPlaybackRate
    ]);
    $f33cd4ca105fd87b$var$useBufferStateEmitter(emitter);
    return (0, $7b02d682eb115277$exports.jsx)($f33cd4ca105fd87b$var$PlayerEventEmitterContext.Provider, {
        value: emitter,
        children: children
    });
};
var $f33cd4ca105fd87b$var$useHoverState = (ref, hideControlsWhenPointerDoesntMove)=>{
    const [hovered, setHovered] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const { current: current } = ref;
        if (!current) return;
        let hoverTimeout;
        const addHoverTimeout = ()=>{
            if (hideControlsWhenPointerDoesntMove) {
                clearTimeout(hoverTimeout);
                hoverTimeout = setTimeout(()=>{
                    setHovered(false);
                }, hideControlsWhenPointerDoesntMove === true ? 3000 : hideControlsWhenPointerDoesntMove);
            }
        };
        const onHover = ()=>{
            setHovered(true);
            addHoverTimeout();
        };
        const onLeave = ()=>{
            setHovered(false);
            clearTimeout(hoverTimeout);
        };
        const onMove = ()=>{
            setHovered(true);
            addHoverTimeout();
        };
        current.addEventListener("mouseenter", onHover);
        current.addEventListener("mouseleave", onLeave);
        current.addEventListener("mousemove", onMove);
        return ()=>{
            current.removeEventListener("mouseenter", onHover);
            current.removeEventListener("mouseleave", onLeave);
            current.removeEventListener("mousemove", onMove);
            clearTimeout(hoverTimeout);
        };
    }, [
        hideControlsWhenPointerDoesntMove,
        ref
    ]);
    return hovered;
};
// src/calculate-next-frame.ts
var $f33cd4ca105fd87b$var$calculateNextFrame = ({ time: time, currentFrame: startFrame, playbackSpeed: playbackSpeed, fps: fps, actualLastFrame: actualLastFrame, actualFirstFrame: actualFirstFrame, framesAdvanced: framesAdvanced, shouldLoop: shouldLoop })=>{
    const op = playbackSpeed < 0 ? Math.ceil : Math.floor;
    const framesToAdvance = op(time * playbackSpeed / (1000 / fps)) - framesAdvanced;
    const nextFrame = framesToAdvance + startFrame;
    const isCurrentFrameOutside = startFrame > actualLastFrame || startFrame < actualFirstFrame;
    const isNextFrameOutside = nextFrame > actualLastFrame || nextFrame < actualFirstFrame;
    const hasEnded = !shouldLoop && isNextFrameOutside && !isCurrentFrameOutside;
    if (playbackSpeed > 0) {
        if (isNextFrameOutside) return {
            nextFrame: actualFirstFrame,
            framesToAdvance: framesToAdvance,
            hasEnded: hasEnded
        };
        return {
            nextFrame: nextFrame,
            framesToAdvance: framesToAdvance,
            hasEnded: hasEnded
        };
    }
    if (isNextFrameOutside) return {
        nextFrame: actualLastFrame,
        framesToAdvance: framesToAdvance,
        hasEnded: hasEnded
    };
    return {
        nextFrame: nextFrame,
        framesToAdvance: framesToAdvance,
        hasEnded: hasEnded
    };
};
var $f33cd4ca105fd87b$var$getIsBackgrounded = ()=>{
    if (typeof document === "undefined") return false;
    return document.visibilityState === "hidden";
};
var $f33cd4ca105fd87b$var$useIsBackgrounded = ()=>{
    const isBackgrounded = (0, $acw62.useRef)($f33cd4ca105fd87b$var$getIsBackgrounded());
    (0, $acw62.useEffect)(()=>{
        const onVisibilityChange = ()=>{
            isBackgrounded.current = $f33cd4ca105fd87b$var$getIsBackgrounded();
        };
        document.addEventListener("visibilitychange", onVisibilityChange);
        return ()=>{
            document.removeEventListener("visibilitychange", onVisibilityChange);
        };
    }, []);
    return isBackgrounded;
};
var $f33cd4ca105fd87b$var$usePlayer = ()=>{
    const [playing, setPlaying, imperativePlaying] = (0, $c78df6347432a4c1$export$c39fff9f74a28020).Timeline.usePlayingState();
    const [hasPlayed, setHasPlayed] = (0, $acw62.useState)(false);
    const frame = (0, $c78df6347432a4c1$export$c39fff9f74a28020).Timeline.useTimelinePosition();
    const playStart = (0, $acw62.useRef)(frame);
    const setFrame = (0, $c78df6347432a4c1$export$c39fff9f74a28020).Timeline.useTimelineSetFrame();
    const setTimelinePosition = (0, $c78df6347432a4c1$export$c39fff9f74a28020).Timeline.useTimelineSetFrame();
    const audioContext = (0, $acw62.useContext)((0, $c78df6347432a4c1$export$c39fff9f74a28020).SharedAudioContext);
    const { audioAndVideoTags: audioAndVideoTags } = (0, $acw62.useContext)((0, $c78df6347432a4c1$export$c39fff9f74a28020).Timeline.TimelineContext);
    const frameRef = (0, $acw62.useRef)(frame);
    frameRef.current = frame;
    const video = (0, $c78df6347432a4c1$export$c39fff9f74a28020).useVideo();
    const config = (0, $c78df6347432a4c1$export$c39fff9f74a28020).useUnsafeVideoConfig();
    const emitter = (0, $acw62.useContext)($f33cd4ca105fd87b$var$PlayerEventEmitterContext);
    const lastFrame = (config?.durationInFrames ?? 1) - 1;
    const isLastFrame = frame === lastFrame;
    const isFirstFrame = frame === 0;
    if (!emitter) throw new TypeError("Expected Player event emitter context");
    const bufferingContext = (0, $acw62.useContext)((0, $c78df6347432a4c1$export$c39fff9f74a28020).BufferingContextReact);
    if (!bufferingContext) throw new Error("Missing the buffering context. Most likely you have a Remotion version mismatch.");
    const { buffering: buffering } = bufferingContext;
    const seek = (0, $acw62.useCallback)((newFrame)=>{
        if (video?.id) setTimelinePosition((c)=>({
                ...c,
                [video.id]: newFrame
            }));
        frameRef.current = newFrame;
        emitter.dispatchSeek(newFrame);
    }, [
        emitter,
        setTimelinePosition,
        video?.id
    ]);
    const play = (0, $acw62.useCallback)((e)=>{
        if (imperativePlaying.current) return;
        setHasPlayed(true);
        if (isLastFrame) seek(0);
        if (audioContext && audioContext.numberOfAudioTags > 0 && e) audioContext.playAllAudios();
        audioAndVideoTags.current.forEach((a)=>a.play());
        imperativePlaying.current = true;
        setPlaying(true);
        playStart.current = frameRef.current;
        emitter.dispatchPlay();
    }, [
        imperativePlaying,
        isLastFrame,
        audioContext,
        setPlaying,
        emitter,
        seek,
        audioAndVideoTags
    ]);
    const pause = (0, $acw62.useCallback)(()=>{
        if (imperativePlaying.current) {
            imperativePlaying.current = false;
            setPlaying(false);
            emitter.dispatchPause();
        }
    }, [
        emitter,
        imperativePlaying,
        setPlaying
    ]);
    const pauseAndReturnToPlayStart = (0, $acw62.useCallback)(()=>{
        if (imperativePlaying.current) {
            imperativePlaying.current = false;
            frameRef.current = playStart.current;
            if (config) {
                setTimelinePosition((c)=>({
                        ...c,
                        [config.id]: playStart.current
                    }));
                setPlaying(false);
                emitter.dispatchPause();
            }
        }
    }, [
        config,
        emitter,
        imperativePlaying,
        setPlaying,
        setTimelinePosition
    ]);
    const videoId = video?.id;
    const frameBack = (0, $acw62.useCallback)((frames)=>{
        if (!videoId) return null;
        if (imperativePlaying.current) return;
        setFrame((c)=>{
            const prev = c[videoId] ?? window.remotion_initialFrame ?? 0;
            return {
                ...c,
                [videoId]: Math.max(0, prev - frames)
            };
        });
    }, [
        imperativePlaying,
        setFrame,
        videoId
    ]);
    const frameForward = (0, $acw62.useCallback)((frames)=>{
        if (!videoId) return null;
        if (imperativePlaying.current) return;
        setFrame((c)=>{
            const prev = c[videoId] ?? window.remotion_initialFrame ?? 0;
            return {
                ...c,
                [videoId]: Math.min(lastFrame, prev + frames)
            };
        });
    }, [
        videoId,
        imperativePlaying,
        lastFrame,
        setFrame
    ]);
    const returnValue = (0, $acw62.useMemo)(()=>{
        return {
            frameBack: frameBack,
            frameForward: frameForward,
            isLastFrame: isLastFrame,
            emitter: emitter,
            playing: playing,
            play: play,
            pause: pause,
            seek: seek,
            isFirstFrame: isFirstFrame,
            getCurrentFrame: ()=>frameRef.current,
            isPlaying: ()=>imperativePlaying.current,
            isBuffering: ()=>buffering.current,
            pauseAndReturnToPlayStart: pauseAndReturnToPlayStart,
            hasPlayed: hasPlayed,
            remotionInternal_currentFrameRef: frameRef
        };
    }, [
        frameBack,
        frameForward,
        isLastFrame,
        emitter,
        playing,
        play,
        pause,
        seek,
        isFirstFrame,
        pauseAndReturnToPlayStart,
        hasPlayed,
        imperativePlaying,
        buffering
    ]);
    return returnValue;
};
// src/use-playback.ts
var $f33cd4ca105fd87b$var$usePlayback = ({ loop: loop, playbackRate: playbackRate, moveToBeginningWhenEnded: moveToBeginningWhenEnded, inFrame: inFrame, outFrame: outFrame, frameRef: frameRef })=>{
    const config = (0, $c78df6347432a4c1$export$c39fff9f74a28020).useUnsafeVideoConfig();
    const frame = (0, $c78df6347432a4c1$export$c39fff9f74a28020).Timeline.useTimelinePosition();
    const { playing: playing, pause: pause, emitter: emitter } = $f33cd4ca105fd87b$var$usePlayer();
    const setFrame = (0, $c78df6347432a4c1$export$c39fff9f74a28020).Timeline.useTimelineSetFrame();
    const buffering = (0, $acw62.useRef)(null);
    const isBackgroundedRef = $f33cd4ca105fd87b$var$useIsBackgrounded();
    const lastTimeUpdateEvent = (0, $acw62.useRef)(null);
    const context = (0, $acw62.useContext)((0, $c78df6347432a4c1$export$c39fff9f74a28020).BufferingContextReact);
    if (!context) throw new Error("Missing the buffering context. Most likely you have a Remotion version mismatch.");
    (0, $acw62.useEffect)(()=>{
        const onBufferClear = context.listenForBuffering(()=>{
            buffering.current = performance.now();
        });
        const onResumeClear = context.listenForResume(()=>{
            buffering.current = null;
        });
        return ()=>{
            onBufferClear.remove();
            onResumeClear.remove();
        };
    }, [
        context
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!config) return;
        if (!playing) return;
        let hasBeenStopped = false;
        let reqAnimFrameCall = null;
        let startedTime = performance.now();
        let framesAdvanced = 0;
        const cancelQueuedFrame = ()=>{
            if (reqAnimFrameCall !== null) {
                if (reqAnimFrameCall.type === "raf") cancelAnimationFrame(reqAnimFrameCall.id);
                else clearTimeout(reqAnimFrameCall.id);
            }
        };
        const stop = ()=>{
            hasBeenStopped = true;
            cancelQueuedFrame();
        };
        const callback = ()=>{
            const time = performance.now() - startedTime;
            const actualLastFrame = outFrame ?? config.durationInFrames - 1;
            const actualFirstFrame = inFrame ?? 0;
            const currentFrame = frameRef.current;
            const { nextFrame: nextFrame, framesToAdvance: framesToAdvance, hasEnded: hasEnded } = $f33cd4ca105fd87b$var$calculateNextFrame({
                time: time,
                currentFrame: currentFrame,
                playbackSpeed: playbackRate,
                fps: config.fps,
                actualFirstFrame: actualFirstFrame,
                actualLastFrame: actualLastFrame,
                framesAdvanced: framesAdvanced,
                shouldLoop: loop
            });
            framesAdvanced += framesToAdvance;
            if (nextFrame !== frameRef.current && (!hasEnded || moveToBeginningWhenEnded)) setFrame((c)=>({
                    ...c,
                    [config.id]: nextFrame
                }));
            if (hasEnded) {
                stop();
                pause();
                emitter.dispatchEnded();
                return;
            }
            if (!hasBeenStopped) queueNextFrame();
        };
        const queueNextFrame = ()=>{
            if (buffering.current) {
                const stopListening = context.listenForResume(()=>{
                    stopListening.remove();
                    if (hasBeenStopped) return;
                    startedTime = performance.now();
                    framesAdvanced = 0;
                    callback();
                });
                return;
            }
            if (isBackgroundedRef.current) reqAnimFrameCall = {
                type: "timeout",
                id: setTimeout(callback, 1000 / config.fps)
            };
            else reqAnimFrameCall = {
                type: "raf",
                id: requestAnimationFrame(callback)
            };
        };
        queueNextFrame();
        const onVisibilityChange = ()=>{
            if (document.visibilityState === "visible") return;
            cancelQueuedFrame();
            callback();
        };
        window.addEventListener("visibilitychange", onVisibilityChange);
        return ()=>{
            window.removeEventListener("visibilitychange", onVisibilityChange);
            stop();
        };
    }, [
        config,
        loop,
        pause,
        playing,
        setFrame,
        emitter,
        playbackRate,
        inFrame,
        outFrame,
        moveToBeginningWhenEnded,
        isBackgroundedRef,
        frameRef,
        buffering,
        context
    ]);
    (0, $acw62.useEffect)(()=>{
        const interval = setInterval(()=>{
            if (lastTimeUpdateEvent.current === frameRef.current) return;
            emitter.dispatchTimeUpdate({
                frame: frameRef.current
            });
            lastTimeUpdateEvent.current = frameRef.current;
        }, 250);
        return ()=>clearInterval(interval);
    }, [
        emitter,
        frameRef
    ]);
    (0, $acw62.useEffect)(()=>{
        emitter.dispatchFrameUpdate({
            frame: frame
        });
    }, [
        emitter,
        frame
    ]);
};
var $f33cd4ca105fd87b$var$elementSizeHooks = [];
var $f33cd4ca105fd87b$var$updateAllElementsSizes = ()=>{
    for (const listener of $f33cd4ca105fd87b$var$elementSizeHooks)listener();
};
var $f33cd4ca105fd87b$var$useElementSize = (ref, options)=>{
    const [size, setSize] = (0, $acw62.useState)(()=>{
        if (!ref.current) return null;
        const rect = ref.current.getClientRects();
        if (!rect[0]) return null;
        return {
            width: rect[0].width,
            height: rect[0].height,
            left: rect[0].x,
            top: rect[0].y,
            windowSize: {
                height: window.innerHeight,
                width: window.innerWidth
            }
        };
    });
    const observer = (0, $acw62.useMemo)(()=>{
        if (typeof ResizeObserver === "undefined") return null;
        return new ResizeObserver((entries)=>{
            const { contentRect: contentRect, target: target } = entries[0];
            const newSize = target.getClientRects();
            if (!newSize?.[0]) {
                setSize(null);
                return;
            }
            const probableCssParentScale = contentRect.width === 0 ? 1 : newSize[0].width / contentRect.width;
            const width = options.shouldApplyCssTransforms ? newSize[0].width : newSize[0].width * (1 / probableCssParentScale);
            const height = options.shouldApplyCssTransforms ? newSize[0].height : newSize[0].height * (1 / probableCssParentScale);
            setSize({
                width: width,
                height: height,
                left: newSize[0].x,
                top: newSize[0].y,
                windowSize: {
                    height: window.innerHeight,
                    width: window.innerWidth
                }
            });
        });
    }, [
        options.shouldApplyCssTransforms
    ]);
    const updateSize = (0, $acw62.useCallback)(()=>{
        if (!ref.current) return;
        const rect = ref.current.getClientRects();
        if (!rect[0]) {
            setSize(null);
            return;
        }
        setSize((prevState)=>{
            const isSame = prevState && prevState.width === rect[0].width && prevState.height === rect[0].height && prevState.left === rect[0].x && prevState.top === rect[0].y && prevState.windowSize.height === window.innerHeight && prevState.windowSize.width === window.innerWidth;
            if (isSame) return prevState;
            return {
                width: rect[0].width,
                height: rect[0].height,
                left: rect[0].x,
                top: rect[0].y,
                windowSize: {
                    height: window.innerHeight,
                    width: window.innerWidth
                }
            };
        });
    }, [
        ref
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!observer) return;
        const { current: current } = ref;
        if (current) observer.observe(current);
        return ()=>{
            if (current) observer.unobserve(current);
        };
    }, [
        observer,
        ref,
        updateSize
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!options.triggerOnWindowResize) return;
        window.addEventListener("resize", updateSize);
        return ()=>{
            window.removeEventListener("resize", updateSize);
        };
    }, [
        options.triggerOnWindowResize,
        updateSize
    ]);
    (0, $acw62.useEffect)(()=>{
        $f33cd4ca105fd87b$var$elementSizeHooks.push(updateSize);
        return ()=>{
            $f33cd4ca105fd87b$var$elementSizeHooks = $f33cd4ca105fd87b$var$elementSizeHooks.filter((e)=>e !== updateSize);
        };
    }, [
        updateSize
    ]);
    return (0, $acw62.useMemo)(()=>{
        if (!size) return null;
        return {
            ...size,
            refresh: updateSize
        };
    }, [
        size,
        updateSize
    ]);
};
var $f33cd4ca105fd87b$var$DefaultPlayPauseButton = ({ playing: playing, buffering: buffering })=>{
    if (playing && buffering) return (0, $7b02d682eb115277$exports.jsx)($f33cd4ca105fd87b$var$BufferingIndicator, {
        type: "player"
    });
    if (playing) return (0, $7b02d682eb115277$exports.jsx)($f33cd4ca105fd87b$var$PauseIcon, {});
    return (0, $7b02d682eb115277$exports.jsx)($f33cd4ca105fd87b$var$PlayIcon, {});
};
var $f33cd4ca105fd87b$var$KNOB_SIZE = 12;
var $f33cd4ca105fd87b$var$BAR_HEIGHT = 5;
var $f33cd4ca105fd87b$var$DefaultVolumeSlider = ({ volume: volume, isVertical: isVertical, onBlur: onBlur, inputRef: inputRef, setVolume: setVolume })=>{
    const sliderContainer = (0, $acw62.useMemo)(()=>{
        const paddingLeft = 5;
        const common = {
            paddingLeft: paddingLeft,
            height: $f33cd4ca105fd87b$var$ICON_SIZE,
            width: $f33cd4ca105fd87b$var$VOLUME_SLIDER_WIDTH,
            display: "inline-flex",
            alignItems: "center"
        };
        if (isVertical) return {
            ...common,
            position: "absolute",
            transform: `rotate(-90deg) translateX(${$f33cd4ca105fd87b$var$VOLUME_SLIDER_WIDTH / 2 + $f33cd4ca105fd87b$var$ICON_SIZE / 2}px)`
        };
        return {
            ...common
        };
    }, [
        isVertical
    ]);
    const randomId = typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId === "undefined" ? "volume-slider" : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const [randomClass] = (0, $acw62.useState)(()=>`__remotion-volume-slider-${(0, $c78df6347432a4c1$export$4385e60b38654f68)(randomId)}`.replace(".", ""));
    const onVolumeChange = (0, $acw62.useCallback)((e)=>{
        setVolume(parseFloat(e.target.value));
    }, [
        setVolume
    ]);
    const inputStyle = (0, $acw62.useMemo)(()=>{
        const commonStyle = {
            WebkitAppearance: "none",
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            borderRadius: $f33cd4ca105fd87b$var$BAR_HEIGHT / 2,
            cursor: "pointer",
            height: $f33cd4ca105fd87b$var$BAR_HEIGHT,
            width: $f33cd4ca105fd87b$var$VOLUME_SLIDER_WIDTH,
            backgroundImage: `linear-gradient(
				to right,
				white ${volume * 100}%, rgba(255, 255, 255, 0) ${volume * 100}%
			)`
        };
        if (isVertical) return {
            ...commonStyle,
            bottom: $f33cd4ca105fd87b$var$ICON_SIZE + $f33cd4ca105fd87b$var$VOLUME_SLIDER_WIDTH / 2
        };
        return commonStyle;
    }, [
        isVertical,
        volume
    ]);
    const sliderStyle = `
	.${randomClass}::-webkit-slider-thumb {
		-webkit-appearance: none;
		background-color: white;
		border-radius: ${$f33cd4ca105fd87b$var$KNOB_SIZE / 2}px;
		box-shadow: 0 0 2px black;
		height: ${$f33cd4ca105fd87b$var$KNOB_SIZE}px;
		width: ${$f33cd4ca105fd87b$var$KNOB_SIZE}px;
	}

	.${randomClass}::-moz-range-thumb {
		-webkit-appearance: none;
		background-color: white;
		border-radius: ${$f33cd4ca105fd87b$var$KNOB_SIZE / 2}px;
		box-shadow: 0 0 2px black;
		height: ${$f33cd4ca105fd87b$var$KNOB_SIZE}px;
		width: ${$f33cd4ca105fd87b$var$KNOB_SIZE}px;
	}
`;
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: sliderContainer,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("style", {
                dangerouslySetInnerHTML: {
                    __html: sliderStyle
                }
            }),
            (0, $7b02d682eb115277$exports.jsx)("input", {
                ref: inputRef,
                "aria-label": "Change volume",
                className: randomClass,
                max: 1,
                min: 0,
                onBlur: onBlur,
                onChange: onVolumeChange,
                step: 0.01,
                type: "range",
                value: volume,
                style: inputStyle
            })
        ]
    });
};
var $f33cd4ca105fd87b$var$renderDefaultVolumeSlider = (props)=>{
    return (0, $7b02d682eb115277$exports.jsx)($f33cd4ca105fd87b$var$DefaultVolumeSlider, {
        ...props
    });
};
var $f33cd4ca105fd87b$var$VOLUME_SLIDER_WIDTH = 100;
var $f33cd4ca105fd87b$var$MediaVolumeSlider2 = ({ displayVerticalVolumeSlider: displayVerticalVolumeSlider, renderMuteButton: renderMuteButton, renderVolumeSlider: renderVolumeSlider })=>{
    const [mediaMuted, setMediaMuted] = (0, $c78df6347432a4c1$export$c39fff9f74a28020).useMediaMutedState();
    const [mediaVolume, setMediaVolume] = (0, $c78df6347432a4c1$export$c39fff9f74a28020).useMediaVolumeState();
    const [focused, setFocused] = (0, $acw62.useState)(false);
    const parentDivRef = (0, $acw62.useRef)(null);
    const inputRef = (0, $acw62.useRef)(null);
    const hover = $f33cd4ca105fd87b$var$useHoverState(parentDivRef, false);
    const onBlur = (0, $acw62.useCallback)(()=>{
        setTimeout(()=>{
            if (inputRef.current && document.activeElement !== inputRef.current) setFocused(false);
        }, 10);
    }, []);
    const isVolume0 = mediaVolume === 0;
    const onClick = (0, $acw62.useCallback)(()=>{
        if (isVolume0) {
            setMediaVolume(1);
            setMediaMuted(false);
            return;
        }
        setMediaMuted((mute)=>!mute);
    }, [
        isVolume0,
        setMediaMuted,
        setMediaVolume
    ]);
    const parentDivStyle = (0, $acw62.useMemo)(()=>{
        return {
            display: "inline-flex",
            background: "none",
            border: "none",
            justifyContent: "center",
            alignItems: "center",
            touchAction: "none",
            ...displayVerticalVolumeSlider && {
                position: "relative"
            }
        };
    }, [
        displayVerticalVolumeSlider
    ]);
    const volumeContainer = (0, $acw62.useMemo)(()=>{
        return {
            display: "inline",
            width: $f33cd4ca105fd87b$var$ICON_SIZE,
            height: $f33cd4ca105fd87b$var$ICON_SIZE,
            cursor: "pointer",
            appearance: "none",
            background: "none",
            border: "none",
            padding: 0
        };
    }, []);
    const renderDefaultMuteButton = (0, $acw62.useCallback)(({ muted: muted, volume: volume })=>{
        const isMutedOrZero = muted || volume === 0;
        return (0, $7b02d682eb115277$exports.jsx)("button", {
            "aria-label": isMutedOrZero ? "Unmute sound" : "Mute sound",
            title: isMutedOrZero ? "Unmute sound" : "Mute sound",
            onClick: onClick,
            onBlur: onBlur,
            onFocus: ()=>setFocused(true),
            style: volumeContainer,
            type: "button",
            children: isMutedOrZero ? (0, $7b02d682eb115277$exports.jsx)($f33cd4ca105fd87b$var$VolumeOffIcon, {}) : (0, $7b02d682eb115277$exports.jsx)($f33cd4ca105fd87b$var$VolumeOnIcon, {})
        });
    }, [
        onBlur,
        onClick,
        volumeContainer
    ]);
    const muteButton = (0, $acw62.useMemo)(()=>{
        return renderMuteButton ? renderMuteButton({
            muted: mediaMuted,
            volume: mediaVolume
        }) : renderDefaultMuteButton({
            muted: mediaMuted,
            volume: mediaVolume
        });
    }, [
        mediaMuted,
        mediaVolume,
        renderDefaultMuteButton,
        renderMuteButton
    ]);
    const volumeSlider = (0, $acw62.useMemo)(()=>{
        return (focused || hover) && !mediaMuted && !(0, $c78df6347432a4c1$export$c39fff9f74a28020).isIosSafari() ? (renderVolumeSlider ?? $f33cd4ca105fd87b$var$renderDefaultVolumeSlider)({
            isVertical: displayVerticalVolumeSlider,
            volume: mediaVolume,
            onBlur: ()=>setFocused(false),
            inputRef: inputRef,
            setVolume: setMediaVolume
        }) : null;
    }, [
        displayVerticalVolumeSlider,
        focused,
        hover,
        mediaMuted,
        mediaVolume,
        renderVolumeSlider,
        setMediaVolume
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: parentDivRef,
        style: parentDivStyle,
        children: [
            muteButton,
            volumeSlider
        ]
    });
};
function $f33cd4ca105fd87b$var$useComponentVisible(initialIsVisible) {
    const [isComponentVisible, setIsComponentVisible] = (0, $acw62.useState)(initialIsVisible);
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (ref.current && !ref.current.contains(event.target)) setIsComponentVisible(false);
        };
        document.addEventListener("pointerup", handleClickOutside, true);
        return ()=>{
            document.removeEventListener("pointerup", handleClickOutside, true);
        };
    }, []);
    return {
        ref: ref,
        isComponentVisible: isComponentVisible,
        setIsComponentVisible: setIsComponentVisible
    };
}
var $f33cd4ca105fd87b$var$BOTTOM = 35;
var $f33cd4ca105fd87b$var$THRESHOLD = 70;
var $f33cd4ca105fd87b$var$rateDiv = {
    height: 30,
    paddingRight: 15,
    paddingLeft: 12,
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
};
var $f33cd4ca105fd87b$var$checkmarkContainer = {
    width: 22,
    display: "flex",
    alignItems: "center"
};
var $f33cd4ca105fd87b$var$checkmarkStyle = {
    width: 14,
    height: 14,
    color: "black"
};
var $f33cd4ca105fd87b$var$Checkmark = ()=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 512 512",
        style: $f33cd4ca105fd87b$var$checkmarkStyle,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "currentColor",
            d: "M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z"
        })
    });
var $f33cd4ca105fd87b$var$PlaybackrateOption = ({ rate: rate, onSelect: onSelect, selectedRate: selectedRate, keyboardSelectedRate: keyboardSelectedRate })=>{
    const onClick = (0, $acw62.useCallback)((e)=>{
        e.stopPropagation();
        e.preventDefault();
        onSelect(rate);
    }, [
        onSelect,
        rate
    ]);
    const [hovered, setHovered] = (0, $acw62.useState)(false);
    const onMouseEnter = (0, $acw62.useCallback)(()=>{
        setHovered(true);
    }, []);
    const onMouseLeave = (0, $acw62.useCallback)(()=>{
        setHovered(false);
    }, []);
    const isFocused = keyboardSelectedRate === rate;
    const actualStyle = (0, $acw62.useMemo)(()=>{
        return {
            ...$f33cd4ca105fd87b$var$rateDiv,
            backgroundColor: hovered || isFocused ? "#eee" : "transparent"
        };
    }, [
        hovered,
        isFocused
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        tabIndex: 0,
        style: actualStyle,
        onClick: onClick,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                style: $f33cd4ca105fd87b$var$checkmarkContainer,
                children: rate === selectedRate ? (0, $7b02d682eb115277$exports.jsx)($f33cd4ca105fd87b$var$Checkmark, {}) : null
            }),
            rate.toFixed(1),
            "x"
        ]
    }, rate);
};
var $f33cd4ca105fd87b$var$PlaybackPopup = ({ setIsComponentVisible: setIsComponentVisible, playbackRates: playbackRates, canvasSize: canvasSize })=>{
    const { setPlaybackRate: setPlaybackRate, playbackRate: playbackRate } = (0, $acw62.useContext)((0, $c78df6347432a4c1$export$c39fff9f74a28020).Timeline.TimelineContext);
    const [keyboardSelectedRate, setKeyboardSelectedRate] = (0, $acw62.useState)(playbackRate);
    (0, $acw62.useEffect)(()=>{
        const listener = (e)=>{
            e.preventDefault();
            if (e.key === "ArrowUp") {
                const currentIndex = playbackRates.findIndex((rate)=>rate === keyboardSelectedRate);
                if (currentIndex === 0) return;
                if (currentIndex === -1) setKeyboardSelectedRate(playbackRates[0]);
                else setKeyboardSelectedRate(playbackRates[currentIndex - 1]);
            } else if (e.key === "ArrowDown") {
                const currentIndex = playbackRates.findIndex((rate)=>rate === keyboardSelectedRate);
                if (currentIndex === playbackRates.length - 1) return;
                if (currentIndex === -1) setKeyboardSelectedRate(playbackRates[playbackRates.length - 1]);
                else setKeyboardSelectedRate(playbackRates[currentIndex + 1]);
            } else if (e.key === "Enter") {
                setPlaybackRate(keyboardSelectedRate);
                setIsComponentVisible(false);
            }
        };
        window.addEventListener("keydown", listener);
        return ()=>{
            window.removeEventListener("keydown", listener);
        };
    }, [
        playbackRates,
        keyboardSelectedRate,
        setPlaybackRate,
        setIsComponentVisible
    ]);
    const onSelect = (0, $acw62.useCallback)((rate)=>{
        setPlaybackRate(rate);
        setIsComponentVisible(false);
    }, [
        setIsComponentVisible,
        setPlaybackRate
    ]);
    const playbackPopup = (0, $acw62.useMemo)(()=>{
        return {
            position: "absolute",
            right: 0,
            width: 125,
            maxHeight: canvasSize.height - $f33cd4ca105fd87b$var$THRESHOLD - $f33cd4ca105fd87b$var$BOTTOM,
            bottom: 35,
            background: "#fff",
            borderRadius: 4,
            overflow: "auto",
            color: "black",
            textAlign: "left"
        };
    }, [
        canvasSize.height
    ]);
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        style: playbackPopup,
        children: playbackRates.map((rate)=>{
            return (0, $7b02d682eb115277$exports.jsx)($f33cd4ca105fd87b$var$PlaybackrateOption, {
                selectedRate: playbackRate,
                onSelect: onSelect,
                rate: rate,
                keyboardSelectedRate: keyboardSelectedRate
            }, rate);
        })
    });
};
var $f33cd4ca105fd87b$var$label = {
    fontSize: 13,
    fontWeight: "bold",
    color: "white",
    border: "2px solid white",
    borderRadius: 20,
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 2,
    paddingBottom: 2
};
var $f33cd4ca105fd87b$var$playerButtonStyle = {
    appearance: "none",
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 6,
    paddingBottom: 6,
    height: 37,
    display: "inline-flex",
    marginBottom: 0,
    marginTop: 0,
    alignItems: "center"
};
var $f33cd4ca105fd87b$var$button = {
    ...$f33cd4ca105fd87b$var$playerButtonStyle,
    position: "relative"
};
var $f33cd4ca105fd87b$var$PlaybackrateControl = ({ playbackRates: playbackRates, canvasSize: canvasSize })=>{
    const { ref: ref, isComponentVisible: isComponentVisible, setIsComponentVisible: setIsComponentVisible } = $f33cd4ca105fd87b$var$useComponentVisible(false);
    const { playbackRate: playbackRate } = (0, $acw62.useContext)((0, $c78df6347432a4c1$export$c39fff9f74a28020).Timeline.TimelineContext);
    const onClick = (0, $acw62.useCallback)((e)=>{
        e.stopPropagation();
        e.preventDefault();
        setIsComponentVisible((prevIsComponentVisible)=>!prevIsComponentVisible);
    }, [
        setIsComponentVisible
    ]);
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: ref,
        children: (0, $7b02d682eb115277$exports.jsxs)("button", {
            type: "button",
            "aria-label": "Change playback rate",
            style: $f33cd4ca105fd87b$var$button,
            onClick: onClick,
            children: [
                (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: $f33cd4ca105fd87b$var$label,
                    children: [
                        playbackRate,
                        "x"
                    ]
                }),
                isComponentVisible && (0, $7b02d682eb115277$exports.jsx)($f33cd4ca105fd87b$var$PlaybackPopup, {
                    canvasSize: canvasSize,
                    playbackRates: playbackRates,
                    setIsComponentVisible: setIsComponentVisible
                })
            ]
        })
    });
};
var $f33cd4ca105fd87b$var$getFrameFromX = (clientX, durationInFrames, width)=>{
    const pos = clientX;
    const frame = Math.round((0, $c78df6347432a4c1$export$89e29e4ab65e70a9)(pos, [
        0,
        width
    ], [
        0,
        durationInFrames - 1
    ], {
        extrapolateLeft: "clamp",
        extrapolateRight: "clamp"
    }));
    return frame;
};
var $f33cd4ca105fd87b$var$BAR_HEIGHT2 = 5;
var $f33cd4ca105fd87b$var$KNOB_SIZE2 = 12;
var $f33cd4ca105fd87b$var$VERTICAL_PADDING = 4;
var $f33cd4ca105fd87b$var$containerStyle = {
    userSelect: "none",
    WebkitUserSelect: "none",
    paddingTop: $f33cd4ca105fd87b$var$VERTICAL_PADDING,
    paddingBottom: $f33cd4ca105fd87b$var$VERTICAL_PADDING,
    boxSizing: "border-box",
    cursor: "pointer",
    position: "relative",
    touchAction: "none"
};
var $f33cd4ca105fd87b$var$barBackground = {
    height: $f33cd4ca105fd87b$var$BAR_HEIGHT2,
    backgroundColor: "rgba(255, 255, 255, 0.25)",
    width: "100%",
    borderRadius: $f33cd4ca105fd87b$var$BAR_HEIGHT2 / 2
};
var $f33cd4ca105fd87b$var$findBodyInWhichDivIsLocated = (div)=>{
    let current = div;
    while(current.parentElement)current = current.parentElement;
    return current;
};
var $f33cd4ca105fd87b$var$PlayerSeekBar = ({ durationInFrames: durationInFrames, onSeekEnd: onSeekEnd, onSeekStart: onSeekStart, inFrame: inFrame, outFrame: outFrame })=>{
    const containerRef = (0, $acw62.useRef)(null);
    const barHovered = $f33cd4ca105fd87b$var$useHoverState(containerRef, false);
    const size = $f33cd4ca105fd87b$var$useElementSize(containerRef, {
        triggerOnWindowResize: true,
        shouldApplyCssTransforms: true
    });
    const { seek: seek, play: play, pause: pause, playing: playing } = $f33cd4ca105fd87b$var$usePlayer();
    const frame = (0, $c78df6347432a4c1$export$c39fff9f74a28020).Timeline.useTimelinePosition();
    const [dragging, setDragging] = (0, $acw62.useState)({
        dragging: false
    });
    const width = size?.width ?? 0;
    const onPointerDown = (0, $acw62.useCallback)((e)=>{
        if (e.button !== 0) return;
        const posLeft = containerRef.current?.getBoundingClientRect().left;
        const _frame = $f33cd4ca105fd87b$var$getFrameFromX(e.clientX - posLeft, durationInFrames, width);
        pause();
        seek(_frame);
        setDragging({
            dragging: true,
            wasPlaying: playing
        });
        onSeekStart();
    }, [
        durationInFrames,
        width,
        pause,
        seek,
        playing,
        onSeekStart
    ]);
    const onPointerMove = (0, $acw62.useCallback)((e)=>{
        if (!size) throw new Error("Player has no size");
        if (!dragging.dragging) return;
        const posLeft = containerRef.current?.getBoundingClientRect().left;
        const _frame = $f33cd4ca105fd87b$var$getFrameFromX(e.clientX - posLeft, durationInFrames, size.width);
        seek(_frame);
    }, [
        dragging.dragging,
        durationInFrames,
        seek,
        size
    ]);
    const onPointerUp = (0, $acw62.useCallback)(()=>{
        setDragging({
            dragging: false
        });
        if (!dragging.dragging) return;
        if (dragging.wasPlaying) play();
        else pause();
        onSeekEnd();
    }, [
        dragging,
        onSeekEnd,
        pause,
        play
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!dragging.dragging) return;
        const body = $f33cd4ca105fd87b$var$findBodyInWhichDivIsLocated(containerRef.current);
        body.addEventListener("pointermove", onPointerMove);
        body.addEventListener("pointerup", onPointerUp);
        return ()=>{
            body.removeEventListener("pointermove", onPointerMove);
            body.removeEventListener("pointerup", onPointerUp);
        };
    }, [
        dragging.dragging,
        onPointerMove,
        onPointerUp
    ]);
    const knobStyle = (0, $acw62.useMemo)(()=>{
        return {
            height: $f33cd4ca105fd87b$var$KNOB_SIZE2,
            width: $f33cd4ca105fd87b$var$KNOB_SIZE2,
            borderRadius: $f33cd4ca105fd87b$var$KNOB_SIZE2 / 2,
            position: "absolute",
            top: $f33cd4ca105fd87b$var$VERTICAL_PADDING - $f33cd4ca105fd87b$var$KNOB_SIZE2 / 2 + 2.5,
            backgroundColor: "white",
            left: Math.max(0, frame / Math.max(1, durationInFrames - 1) * width - $f33cd4ca105fd87b$var$KNOB_SIZE2 / 2),
            boxShadow: "0 0 2px black",
            opacity: Number(barHovered)
        };
    }, [
        barHovered,
        durationInFrames,
        frame,
        width
    ]);
    const fillStyle = (0, $acw62.useMemo)(()=>{
        return {
            height: $f33cd4ca105fd87b$var$BAR_HEIGHT2,
            backgroundColor: "rgba(255, 255, 255, 1)",
            width: (frame - (inFrame ?? 0)) / (durationInFrames - 1) * 100 + "%",
            marginLeft: (inFrame ?? 0) / (durationInFrames - 1) * 100 + "%",
            borderRadius: $f33cd4ca105fd87b$var$BAR_HEIGHT2 / 2
        };
    }, [
        durationInFrames,
        frame,
        inFrame
    ]);
    const active = (0, $acw62.useMemo)(()=>{
        return {
            height: $f33cd4ca105fd87b$var$BAR_HEIGHT2,
            backgroundColor: "rgba(255, 255, 255, 0.25)",
            width: ((outFrame ?? durationInFrames - 1) - (inFrame ?? 0)) / (durationInFrames - 1) * 100 + "%",
            marginLeft: (inFrame ?? 0) / (durationInFrames - 1) * 100 + "%",
            borderRadius: $f33cd4ca105fd87b$var$BAR_HEIGHT2 / 2,
            position: "absolute"
        };
    }, [
        durationInFrames,
        inFrame,
        outFrame
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: containerRef,
        onPointerDown: onPointerDown,
        style: $f33cd4ca105fd87b$var$containerStyle,
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: $f33cd4ca105fd87b$var$barBackground,
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: active
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: fillStyle
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                style: knobStyle
            })
        ]
    });
};
// src/format-time.ts
var $f33cd4ca105fd87b$var$formatTime = (timeInSeconds)=>{
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = Math.floor(timeInSeconds - minutes * 60);
    return `${String(minutes)}:${String(seconds).padStart(2, "0")}`;
};
var $f33cd4ca105fd87b$var$X_SPACER = 10;
var $f33cd4ca105fd87b$var$X_PADDING = 12;
var $f33cd4ca105fd87b$var$useVideoControlsResize = ({ allowFullscreen: allowFullScreen, playerWidth: playerWidth })=>{
    const resizeInfo = (0, $acw62.useMemo)(()=>{
        const playPauseIconSize = $f33cd4ca105fd87b$var$ICON_SIZE;
        const volumeIconSize = $f33cd4ca105fd87b$var$ICON_SIZE;
        const _fullscreenIconSize = allowFullScreen ? $f33cd4ca105fd87b$var$fullscreenIconSize : 0;
        const elementsSize = volumeIconSize + playPauseIconSize + _fullscreenIconSize + $f33cd4ca105fd87b$var$X_PADDING * 2 + $f33cd4ca105fd87b$var$X_SPACER * 2;
        const maxTimeLabelWidth = playerWidth - elementsSize;
        const maxTimeLabelWidthWithoutNegativeValue = Math.max(maxTimeLabelWidth, 0);
        const availableTimeLabelWidthIfVolumeOpen = maxTimeLabelWidthWithoutNegativeValue - $f33cd4ca105fd87b$var$VOLUME_SLIDER_WIDTH;
        const computedLabelWidth = availableTimeLabelWidthIfVolumeOpen < $f33cd4ca105fd87b$var$VOLUME_SLIDER_WIDTH ? maxTimeLabelWidthWithoutNegativeValue : availableTimeLabelWidthIfVolumeOpen;
        const minWidthForHorizontalDisplay = computedLabelWidth + elementsSize + $f33cd4ca105fd87b$var$VOLUME_SLIDER_WIDTH;
        const displayVerticalVolumeSlider = playerWidth < minWidthForHorizontalDisplay;
        return {
            maxTimeLabelWidth: maxTimeLabelWidthWithoutNegativeValue === 0 ? null : maxTimeLabelWidthWithoutNegativeValue,
            displayVerticalVolumeSlider: displayVerticalVolumeSlider
        };
    }, [
        allowFullScreen,
        playerWidth
    ]);
    return resizeInfo;
};
var $f33cd4ca105fd87b$var$gradientSteps = [
    0,
    0.013,
    0.049,
    0.104,
    0.175,
    0.259,
    0.352,
    0.45,
    0.55,
    0.648,
    0.741,
    0.825,
    0.896,
    0.951,
    0.987
];
var $f33cd4ca105fd87b$var$gradientOpacities = [
    0,
    8.1,
    15.5,
    22.5,
    29,
    35.3,
    41.2,
    47.1,
    52.9,
    58.8,
    64.7,
    71,
    77.5,
    84.5,
    91.9
];
var $f33cd4ca105fd87b$var$globalGradientOpacity = 1 / 0.7;
var $f33cd4ca105fd87b$var$containerStyle2 = {
    boxSizing: "border-box",
    position: "absolute",
    bottom: 0,
    width: "100%",
    paddingTop: 40,
    paddingBottom: 10,
    backgroundImage: `linear-gradient(to bottom,${$f33cd4ca105fd87b$var$gradientSteps.map((g, i)=>{
        return `hsla(0, 0%, 0%, ${g}) ${$f33cd4ca105fd87b$var$gradientOpacities[i] * $f33cd4ca105fd87b$var$globalGradientOpacity}%`;
    }).join(", ")}, hsl(0, 0%, 0%) 100%)`,
    backgroundSize: "auto 145px",
    display: "flex",
    paddingRight: $f33cd4ca105fd87b$var$X_PADDING,
    paddingLeft: $f33cd4ca105fd87b$var$X_PADDING,
    flexDirection: "column",
    transition: "opacity 0.3s"
};
var $f33cd4ca105fd87b$var$controlsRow = {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    userSelect: "none",
    WebkitUserSelect: "none"
};
var $f33cd4ca105fd87b$var$leftPartStyle = {
    display: "flex",
    flexDirection: "row",
    userSelect: "none",
    WebkitUserSelect: "none",
    alignItems: "center"
};
var $f33cd4ca105fd87b$var$xSpacer = {
    width: 12
};
var $f33cd4ca105fd87b$var$ySpacer = {
    height: 8
};
var $f33cd4ca105fd87b$var$flex1 = {
    flex: 1
};
var $f33cd4ca105fd87b$var$fullscreen = {};
var $f33cd4ca105fd87b$var$Controls = ({ durationInFrames: durationInFrames, isFullscreen: isFullscreen, fps: fps, player: player, showVolumeControls: showVolumeControls, onFullscreenButtonClick: onFullscreenButtonClick, allowFullscreen: allowFullscreen, onExitFullscreenButtonClick: onExitFullscreenButtonClick, spaceKeyToPlayOrPause: spaceKeyToPlayOrPause, onSeekEnd: onSeekEnd, onSeekStart: onSeekStart, inFrame: inFrame, outFrame: outFrame, initiallyShowControls: initiallyShowControls, canvasSize: canvasSize, renderPlayPauseButton: renderPlayPauseButton, renderFullscreenButton: renderFullscreenButton, alwaysShowControls: alwaysShowControls, showPlaybackRateControl: showPlaybackRateControl, containerRef: containerRef, buffering: buffering, hideControlsWhenPointerDoesntMove: hideControlsWhenPointerDoesntMove, onPointerDown: onPointerDown, onDoubleClick: onDoubleClick, renderMuteButton: renderMuteButton, renderVolumeSlider: renderVolumeSlider })=>{
    const playButtonRef = (0, $acw62.useRef)(null);
    const frame = (0, $c78df6347432a4c1$export$c39fff9f74a28020).Timeline.useTimelinePosition();
    const [supportsFullscreen, setSupportsFullscreen] = (0, $acw62.useState)(false);
    const hovered = $f33cd4ca105fd87b$var$useHoverState(containerRef, hideControlsWhenPointerDoesntMove);
    const { maxTimeLabelWidth: maxTimeLabelWidth, displayVerticalVolumeSlider: displayVerticalVolumeSlider } = $f33cd4ca105fd87b$var$useVideoControlsResize({
        allowFullscreen: allowFullscreen,
        playerWidth: canvasSize?.width ?? 0
    });
    const [shouldShowInitially, setInitiallyShowControls] = (0, $acw62.useState)(()=>{
        if (typeof initiallyShowControls === "boolean") return initiallyShowControls;
        if (typeof initiallyShowControls === "number") {
            if (initiallyShowControls % 1 !== 0) throw new Error("initiallyShowControls must be an integer or a boolean");
            if (Number.isNaN(initiallyShowControls)) throw new Error("initiallyShowControls must not be NaN");
            if (!Number.isFinite(initiallyShowControls)) throw new Error("initiallyShowControls must be finite");
            if (initiallyShowControls <= 0) throw new Error("initiallyShowControls must be a positive integer");
            return initiallyShowControls;
        }
        throw new TypeError("initiallyShowControls must be a number or a boolean");
    });
    const containerCss = (0, $acw62.useMemo)(()=>{
        const shouldShow = hovered || !player.playing || shouldShowInitially || alwaysShowControls;
        return {
            ...$f33cd4ca105fd87b$var$containerStyle2,
            opacity: Number(shouldShow)
        };
    }, [
        hovered,
        shouldShowInitially,
        player.playing,
        alwaysShowControls
    ]);
    (0, $acw62.useEffect)(()=>{
        if (playButtonRef.current && spaceKeyToPlayOrPause) playButtonRef.current.focus({
            preventScroll: true
        });
    }, [
        player.playing,
        spaceKeyToPlayOrPause
    ]);
    (0, $acw62.useEffect)(()=>{
        setSupportsFullscreen((typeof document !== "undefined" && (document.fullscreenEnabled || document.webkitFullscreenEnabled)) ?? false);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (shouldShowInitially === false) return;
        const time = shouldShowInitially === true ? 2000 : shouldShowInitially;
        const timeout = setTimeout(()=>{
            setInitiallyShowControls(false);
        }, time);
        return ()=>{
            clearInterval(timeout);
        };
    }, [
        shouldShowInitially
    ]);
    const timeLabel = (0, $acw62.useMemo)(()=>{
        return {
            color: "white",
            fontFamily: "sans-serif",
            fontSize: 14,
            maxWidth: maxTimeLabelWidth === null ? undefined : maxTimeLabelWidth,
            overflow: "hidden",
            textOverflow: "ellipsis"
        };
    }, [
        maxTimeLabelWidth
    ]);
    const playbackRates = (0, $acw62.useMemo)(()=>{
        if (showPlaybackRateControl === true) return [
            0.5,
            0.8,
            1,
            1.2,
            1.5,
            1.8,
            2,
            2.5,
            3
        ];
        if (Array.isArray(showPlaybackRateControl)) {
            for (const rate of showPlaybackRateControl){
                if (typeof rate !== "number") throw new Error("Every item in showPlaybackRateControl must be a number");
                if (rate <= 0) throw new Error("Every item in showPlaybackRateControl must be positive");
            }
            return showPlaybackRateControl;
        }
        return null;
    }, [
        showPlaybackRateControl
    ]);
    const ref = (0, $acw62.useRef)(null);
    const flexRef = (0, $acw62.useRef)(null);
    const onPointerDownIfContainer = (0, $acw62.useCallback)((e)=>{
        if (e.target === ref.current || e.target === flexRef.current) onPointerDown?.(e);
    }, [
        onPointerDown
    ]);
    const onDoubleClickIfContainer = (0, $acw62.useCallback)((e)=>{
        if (e.target === ref.current || e.target === flexRef.current) onDoubleClick?.(e);
    }, [
        onDoubleClick
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: ref,
        style: containerCss,
        onPointerDown: onPointerDownIfContainer,
        onDoubleClick: onDoubleClickIfContainer,
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                ref: flexRef,
                style: $f33cd4ca105fd87b$var$controlsRow,
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: $f33cd4ca105fd87b$var$leftPartStyle,
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("button", {
                                ref: playButtonRef,
                                type: "button",
                                style: $f33cd4ca105fd87b$var$playerButtonStyle,
                                onClick: player.playing ? player.pause : player.play,
                                "aria-label": player.playing ? "Pause video" : "Play video",
                                title: player.playing ? "Pause video" : "Play video",
                                children: renderPlayPauseButton === null ? (0, $7b02d682eb115277$exports.jsx)($f33cd4ca105fd87b$var$DefaultPlayPauseButton, {
                                    buffering: buffering,
                                    playing: player.playing
                                }) : renderPlayPauseButton({
                                    playing: player.playing,
                                    isBuffering: buffering
                                }) ?? (0, $7b02d682eb115277$exports.jsx)($f33cd4ca105fd87b$var$DefaultPlayPauseButton, {
                                    buffering: buffering,
                                    playing: player.playing
                                })
                            }),
                            showVolumeControls ? (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: $f33cd4ca105fd87b$var$xSpacer
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)($f33cd4ca105fd87b$var$MediaVolumeSlider2, {
                                        renderMuteButton: renderMuteButton,
                                        renderVolumeSlider: renderVolumeSlider,
                                        displayVerticalVolumeSlider: displayVerticalVolumeSlider
                                    })
                                ]
                            }) : null,
                            (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: $f33cd4ca105fd87b$var$xSpacer
                            }),
                            (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: timeLabel,
                                children: [
                                    $f33cd4ca105fd87b$var$formatTime(frame / fps),
                                    " / ",
                                    $f33cd4ca105fd87b$var$formatTime(durationInFrames / fps)
                                ]
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: $f33cd4ca105fd87b$var$xSpacer
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: $f33cd4ca105fd87b$var$flex1
                    }),
                    playbackRates && canvasSize && (0, $7b02d682eb115277$exports.jsx)($f33cd4ca105fd87b$var$PlaybackrateControl, {
                        canvasSize: canvasSize,
                        playbackRates: playbackRates
                    }),
                    playbackRates && supportsFullscreen && allowFullscreen ? (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: $f33cd4ca105fd87b$var$xSpacer
                    }) : null,
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: $f33cd4ca105fd87b$var$fullscreen,
                        children: supportsFullscreen && allowFullscreen ? (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            "aria-label": isFullscreen ? "Exit fullscreen" : "Enter Fullscreen",
                            title: isFullscreen ? "Exit fullscreen" : "Enter Fullscreen",
                            style: $f33cd4ca105fd87b$var$playerButtonStyle,
                            onClick: isFullscreen ? onExitFullscreenButtonClick : onFullscreenButtonClick,
                            children: renderFullscreenButton === null ? (0, $7b02d682eb115277$exports.jsx)($f33cd4ca105fd87b$var$FullscreenIcon, {
                                isFullscreen: isFullscreen
                            }) : renderFullscreenButton({
                                isFullscreen: isFullscreen
                            })
                        }) : null
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                style: $f33cd4ca105fd87b$var$ySpacer
            }),
            (0, $7b02d682eb115277$exports.jsx)($f33cd4ca105fd87b$var$PlayerSeekBar, {
                onSeekEnd: onSeekEnd,
                onSeekStart: onSeekStart,
                durationInFrames: durationInFrames,
                inFrame: inFrame,
                outFrame: outFrame
            })
        ]
    });
};
var $f33cd4ca105fd87b$var$errorStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    height: "100%",
    width: "100%"
};
class $f33cd4ca105fd87b$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    state = {
        hasError: null
    };
    static getDerivedStateFromError(error) {
        return {
            hasError: error
        };
    }
    componentDidCatch(error) {
        this.props.onError(error);
    }
    render() {
        if (this.state.hasError) return (0, $7b02d682eb115277$exports.jsx)("div", {
            style: $f33cd4ca105fd87b$var$errorStyle,
            children: this.props.errorFallback({
                error: this.state.hasError
            })
        });
        return this.props.children;
    }
}
// src/player-css-classname.ts
var $f33cd4ca105fd87b$var$PLAYER_CSS_CLASSNAME = "__remotion-player";
// src/utils/is-node.ts
var $f33cd4ca105fd87b$var$IS_NODE = typeof document === "undefined";
// src/utils/cancellable-promise.ts
var $f33cd4ca105fd87b$var$cancellablePromise = (promise)=>{
    let isCanceled = false;
    const wrappedPromise = new Promise((resolve, reject)=>{
        promise.then((value)=>{
            if (isCanceled) {
                reject({
                    isCanceled: isCanceled,
                    value: value
                });
                return;
            }
            resolve(value);
        }).catch((error)=>{
            reject({
                isCanceled: isCanceled,
                error: error
            });
        });
    });
    return {
        promise: wrappedPromise,
        cancel: ()=>{
            isCanceled = true;
        }
    };
};
// src/utils/delay.ts
var $f33cd4ca105fd87b$var$delay = (n)=>new Promise((resolve)=>setTimeout(resolve, n));
var $f33cd4ca105fd87b$var$useCancellablePromises = ()=>{
    const pendingPromises = (0, $acw62.useRef)([]);
    const appendPendingPromise = (0, $acw62.useCallback)((promise)=>{
        pendingPromises.current = [
            ...pendingPromises.current,
            promise
        ];
    }, []);
    const removePendingPromise = (0, $acw62.useCallback)((promise)=>{
        pendingPromises.current = pendingPromises.current.filter((p)=>p !== promise);
    }, []);
    const clearPendingPromises = (0, $acw62.useCallback)(()=>pendingPromises.current.map((p)=>p.cancel()), []);
    const api = (0, $acw62.useMemo)(()=>({
            appendPendingPromise: appendPendingPromise,
            removePendingPromise: removePendingPromise,
            clearPendingPromises: clearPendingPromises
        }), [
        appendPendingPromise,
        clearPendingPromises,
        removePendingPromise
    ]);
    return api;
};
// src/utils/use-click-prevention-on-double-click.ts
var $f33cd4ca105fd87b$var$useClickPreventionOnDoubleClick = (onClick, onDoubleClick, doubleClickToFullscreen)=>{
    const api = $f33cd4ca105fd87b$var$useCancellablePromises();
    const handleClick = (0, $acw62.useCallback)(async (e)=>{
        if (e instanceof PointerEvent ? e.pointerType === "touch" : e.nativeEvent.pointerType === "touch") {
            onClick(e);
            return;
        }
        api.clearPendingPromises();
        const waitForClick = $f33cd4ca105fd87b$var$cancellablePromise($f33cd4ca105fd87b$var$delay(200));
        api.appendPendingPromise(waitForClick);
        try {
            await waitForClick.promise;
            api.removePendingPromise(waitForClick);
            onClick(e);
        } catch (errorInfo) {
            const info = errorInfo;
            api.removePendingPromise(waitForClick);
            if (!info.isCanceled) throw info.error;
        }
    }, [
        api,
        onClick
    ]);
    const handlePointerDown = (0, $acw62.useCallback)(()=>{
        document.addEventListener("pointerup", (newEvt)=>{
            handleClick(newEvt);
        }, {
            once: true
        });
    }, [
        handleClick
    ]);
    const handleDoubleClick = (0, $acw62.useCallback)(()=>{
        api.clearPendingPromises();
        onDoubleClick();
    }, [
        api,
        onDoubleClick
    ]);
    const returnValue = (0, $acw62.useMemo)(()=>{
        if (!doubleClickToFullscreen) return {
            handlePointerDown: onClick,
            handleDoubleClick: ()=>{
                return;
            }
        };
        return {
            handlePointerDown: handlePointerDown,
            handleDoubleClick: handleDoubleClick
        };
    }, [
        doubleClickToFullscreen,
        handleDoubleClick,
        handlePointerDown,
        onClick
    ]);
    return returnValue;
};
var $f33cd4ca105fd87b$var$reactVersion = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).version.split(".")[0];
if ($f33cd4ca105fd87b$var$reactVersion === "0") throw new Error(`Version ${$f33cd4ca105fd87b$var$reactVersion} of "react" is not supported by Remotion`);
var $f33cd4ca105fd87b$var$doesReactVersionSupportSuspense = parseInt($f33cd4ca105fd87b$var$reactVersion, 10) >= 18;
var $f33cd4ca105fd87b$var$PlayerUI = ({ controls: controls, style: style, loop: loop, autoPlay: autoPlay, allowFullscreen: allowFullscreen, inputProps: inputProps, clickToPlay: clickToPlay, showVolumeControls: showVolumeControls, doubleClickToFullscreen: doubleClickToFullscreen, spaceKeyToPlayOrPause: spaceKeyToPlayOrPause, errorFallback: errorFallback, playbackRate: playbackRate, renderLoading: renderLoading, renderPoster: renderPoster, className: className2, moveToBeginningWhenEnded: moveToBeginningWhenEnded, showPosterWhenUnplayed: showPosterWhenUnplayed, showPosterWhenEnded: showPosterWhenEnded, showPosterWhenPaused: showPosterWhenPaused, showPosterWhenBuffering: showPosterWhenBuffering, inFrame: inFrame, outFrame: outFrame, initiallyShowControls: initiallyShowControls, renderFullscreen: renderFullscreenButton, renderPlayPauseButton: renderPlayPauseButton, renderMuteButton: renderMuteButton, renderVolumeSlider: renderVolumeSlider, alwaysShowControls: alwaysShowControls, showPlaybackRateControl: showPlaybackRateControl, posterFillMode: posterFillMode, bufferStateDelayInMilliseconds: bufferStateDelayInMilliseconds, hideControlsWhenPointerDoesntMove: hideControlsWhenPointerDoesntMove, overflowVisible: overflowVisible }, ref)=>{
    const config = (0, $c78df6347432a4c1$export$c39fff9f74a28020).useUnsafeVideoConfig();
    const video = (0, $c78df6347432a4c1$export$c39fff9f74a28020).useVideo();
    const container = (0, $acw62.useRef)(null);
    const canvasSize = $f33cd4ca105fd87b$var$useElementSize(container, {
        triggerOnWindowResize: false,
        shouldApplyCssTransforms: false
    });
    const [hasPausedToResume, setHasPausedToResume] = (0, $acw62.useState)(false);
    const [shouldAutoplay, setShouldAutoPlay] = (0, $acw62.useState)(autoPlay);
    const [isFullscreen, setIsFullscreen] = (0, $acw62.useState)(()=>false);
    const [seeking, setSeeking] = (0, $acw62.useState)(false);
    const supportsFullScreen = (0, $acw62.useMemo)(()=>{
        if (typeof document === "undefined") return false;
        return Boolean(document.fullscreenEnabled || document.webkitFullscreenEnabled);
    }, []);
    const player = $f33cd4ca105fd87b$var$usePlayer();
    $f33cd4ca105fd87b$var$usePlayback({
        loop: loop,
        playbackRate: playbackRate,
        moveToBeginningWhenEnded: moveToBeginningWhenEnded,
        inFrame: inFrame,
        outFrame: outFrame,
        frameRef: player.remotionInternal_currentFrameRef
    });
    (0, $acw62.useEffect)(()=>{
        if (hasPausedToResume && !player.playing) {
            setHasPausedToResume(false);
            player.play();
        }
    }, [
        hasPausedToResume,
        player
    ]);
    (0, $acw62.useEffect)(()=>{
        const { current: current } = container;
        if (!current) return;
        const onFullscreenChange = ()=>{
            const newValue = document.fullscreenElement === current || document.webkitFullscreenElement === current;
            setIsFullscreen(newValue);
        };
        document.addEventListener("fullscreenchange", onFullscreenChange);
        document.addEventListener("webkitfullscreenchange", onFullscreenChange);
        return ()=>{
            document.removeEventListener("fullscreenchange", onFullscreenChange);
            document.removeEventListener("webkitfullscreenchange", onFullscreenChange);
        };
    }, []);
    const toggle = (0, $acw62.useCallback)((e)=>{
        if (player.isPlaying()) player.pause();
        else player.play(e);
    }, [
        player
    ]);
    const requestFullscreen = (0, $acw62.useCallback)(()=>{
        if (!allowFullscreen) throw new Error("allowFullscreen is false");
        if (!supportsFullScreen) throw new Error("Browser doesnt support fullscreen");
        if (!container.current) throw new Error("No player ref found");
        if (container.current.webkitRequestFullScreen) container.current.webkitRequestFullScreen();
        else container.current.requestFullscreen();
    }, [
        allowFullscreen,
        supportsFullScreen
    ]);
    const exitFullscreen = (0, $acw62.useCallback)(()=>{
        if (document.webkitExitFullscreen) document.webkitExitFullscreen();
        else document.exitFullscreen();
    }, []);
    (0, $acw62.useEffect)(()=>{
        const { current: current } = container;
        if (!current) return;
        const fullscreenChange = ()=>{
            const element = document.webkitFullscreenElement ?? document.fullscreenElement;
            if (element && element === container.current) player.emitter.dispatchFullscreenChange({
                isFullscreen: true
            });
            else player.emitter.dispatchFullscreenChange({
                isFullscreen: false
            });
        };
        current.addEventListener("webkitfullscreenchange", fullscreenChange);
        current.addEventListener("fullscreenchange", fullscreenChange);
        return ()=>{
            current.removeEventListener("webkitfullscreenchange", fullscreenChange);
            current.removeEventListener("fullscreenchange", fullscreenChange);
        };
    }, [
        player.emitter
    ]);
    const durationInFrames = config?.durationInFrames ?? 1;
    const layout = (0, $acw62.useMemo)(()=>{
        if (!config || !canvasSize) return null;
        return $f33cd4ca105fd87b$var$calculateCanvasTransformation({
            canvasSize: canvasSize,
            compositionHeight: config.height,
            compositionWidth: config.width,
            previewSize: "auto"
        });
    }, [
        canvasSize,
        config
    ]);
    const scale = layout?.scale ?? 1;
    const initialScaleIgnored = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (!initialScaleIgnored.current) {
            initialScaleIgnored.current = true;
            return;
        }
        player.emitter.dispatchScaleChange(scale);
    }, [
        player.emitter,
        scale
    ]);
    const { setMediaVolume: setMediaVolume, setMediaMuted: setMediaMuted } = (0, $acw62.useContext)((0, $c78df6347432a4c1$export$c39fff9f74a28020).SetMediaVolumeContext);
    const { mediaMuted: mediaMuted, mediaVolume: mediaVolume } = (0, $acw62.useContext)((0, $c78df6347432a4c1$export$c39fff9f74a28020).MediaVolumeContext);
    (0, $acw62.useEffect)(()=>{
        player.emitter.dispatchVolumeChange(mediaVolume);
    }, [
        player.emitter,
        mediaVolume
    ]);
    const isMuted = mediaMuted || mediaVolume === 0;
    (0, $acw62.useEffect)(()=>{
        player.emitter.dispatchMuteChange({
            isMuted: isMuted
        });
    }, [
        player.emitter,
        isMuted
    ]);
    const [showBufferIndicator, setShowBufferState] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        let timeout = null;
        let stopped = false;
        const onBuffer = ()=>{
            stopped = false;
            requestAnimationFrame(()=>{
                if (bufferStateDelayInMilliseconds === 0) setShowBufferState(true);
                else timeout = setTimeout(()=>{
                    if (!stopped) setShowBufferState(true);
                }, bufferStateDelayInMilliseconds);
            });
        };
        const onResume = ()=>{
            requestAnimationFrame(()=>{
                stopped = true;
                setShowBufferState(false);
                if (timeout) clearTimeout(timeout);
            });
        };
        player.emitter.addEventListener("waiting", onBuffer);
        player.emitter.addEventListener("resume", onResume);
        return ()=>{
            player.emitter.removeEventListener("waiting", onBuffer);
            player.emitter.removeEventListener("resume", onResume);
            setShowBufferState(false);
            if (timeout) clearTimeout(timeout);
            stopped = true;
        };
    }, [
        bufferStateDelayInMilliseconds,
        player.emitter
    ]);
    (0, $acw62.useImperativeHandle)(ref, ()=>{
        const methods = {
            play: player.play,
            pause: ()=>{
                setHasPausedToResume(false);
                player.pause();
            },
            toggle: toggle,
            getContainerNode: ()=>container.current,
            getCurrentFrame: player.getCurrentFrame,
            isPlaying: player.isPlaying,
            seekTo: (f)=>{
                const lastFrame = durationInFrames - 1;
                const frameToSeekTo = Math.max(0, Math.min(lastFrame, f));
                if (player.isPlaying()) {
                    const pauseToResume = frameToSeekTo !== lastFrame || loop;
                    setHasPausedToResume(pauseToResume);
                    player.pause();
                }
                if (frameToSeekTo === lastFrame && !loop) player.emitter.dispatchEnded();
                player.seek(frameToSeekTo);
            },
            isFullscreen: ()=>{
                const { current: current } = container;
                if (!current) return false;
                return document.fullscreenElement === current || document.webkitFullscreenElement === current;
            },
            requestFullscreen: requestFullscreen,
            exitFullscreen: exitFullscreen,
            getVolume: ()=>{
                if (mediaMuted) return 0;
                return mediaVolume;
            },
            setVolume: (vol)=>{
                if (typeof vol !== "number") throw new TypeError(`setVolume() takes a number, got value of type ${typeof vol}`);
                if (isNaN(vol)) throw new TypeError(`setVolume() got a number that is NaN. Volume must be between 0 and 1.`);
                if (vol < 0 || vol > 1) throw new TypeError(`setVolume() got a number that is out of range. Must be between 0 and 1, got ${typeof vol}`);
                setMediaVolume(vol);
            },
            isMuted: ()=>isMuted,
            mute: ()=>{
                setMediaMuted(true);
            },
            unmute: ()=>{
                setMediaMuted(false);
            },
            getScale: ()=>scale,
            pauseAndReturnToPlayStart: ()=>{
                player.pauseAndReturnToPlayStart();
            }
        };
        return Object.assign(player.emitter, methods);
    }, [
        durationInFrames,
        exitFullscreen,
        loop,
        mediaMuted,
        isMuted,
        mediaVolume,
        player,
        requestFullscreen,
        setMediaMuted,
        setMediaVolume,
        toggle,
        scale
    ]);
    const VideoComponent = video ? video.component : null;
    const outerStyle = (0, $acw62.useMemo)(()=>{
        return $f33cd4ca105fd87b$var$calculateOuterStyle({
            canvasSize: canvasSize,
            config: config,
            style: style,
            overflowVisible: overflowVisible
        });
    }, [
        canvasSize,
        config,
        overflowVisible,
        style
    ]);
    const outer = (0, $acw62.useMemo)(()=>{
        return $f33cd4ca105fd87b$var$calculateOuter({
            config: config,
            layout: layout,
            scale: scale,
            overflowVisible: overflowVisible
        });
    }, [
        config,
        layout,
        overflowVisible,
        scale
    ]);
    const containerStyle3 = (0, $acw62.useMemo)(()=>{
        return $f33cd4ca105fd87b$var$calculateContainerStyle({
            canvasSize: canvasSize,
            config: config,
            layout: layout,
            scale: scale,
            overflowVisible: overflowVisible
        });
    }, [
        canvasSize,
        config,
        layout,
        overflowVisible,
        scale
    ]);
    const onError = (0, $acw62.useCallback)((error)=>{
        player.pause();
        player.emitter.dispatchError(error);
    }, [
        player
    ]);
    const onFullscreenButtonClick = (0, $acw62.useCallback)((e)=>{
        e.stopPropagation();
        requestFullscreen();
    }, [
        requestFullscreen
    ]);
    const onExitFullscreenButtonClick = (0, $acw62.useCallback)((e)=>{
        e.stopPropagation();
        exitFullscreen();
    }, [
        exitFullscreen
    ]);
    const onSingleClick = (0, $acw62.useCallback)((e)=>{
        const rightClick = e instanceof MouseEvent ? e.button === 2 : e.nativeEvent.button;
        if (rightClick) return;
        toggle(e);
    }, [
        toggle
    ]);
    const onSeekStart = (0, $acw62.useCallback)(()=>{
        setSeeking(true);
    }, []);
    const onSeekEnd = (0, $acw62.useCallback)(()=>{
        setSeeking(false);
    }, []);
    const onDoubleClick = (0, $acw62.useCallback)(()=>{
        if (isFullscreen) exitFullscreen();
        else requestFullscreen();
    }, [
        exitFullscreen,
        isFullscreen,
        requestFullscreen
    ]);
    const { handlePointerDown: handlePointerDown, handleDoubleClick: handleDoubleClick } = $f33cd4ca105fd87b$var$useClickPreventionOnDoubleClick(onSingleClick, onDoubleClick, doubleClickToFullscreen && allowFullscreen && supportsFullScreen);
    (0, $acw62.useEffect)(()=>{
        if (shouldAutoplay) {
            player.play();
            setShouldAutoPlay(false);
        }
    }, [
        shouldAutoplay,
        player
    ]);
    const loadingMarkup = (0, $acw62.useMemo)(()=>{
        return renderLoading ? renderLoading({
            height: outerStyle.height,
            width: outerStyle.width,
            isBuffering: showBufferIndicator
        }) : null;
    }, [
        outerStyle.height,
        outerStyle.width,
        renderLoading,
        showBufferIndicator
    ]);
    const currentScale = (0, $acw62.useMemo)(()=>{
        return {
            type: "scale",
            scale: scale
        };
    }, [
        scale
    ]);
    if (!config) return null;
    const poster = renderPoster ? renderPoster({
        height: posterFillMode === "player-size" ? outerStyle.height : config.height,
        width: posterFillMode === "player-size" ? outerStyle.width : config.width,
        isBuffering: showBufferIndicator
    }) : null;
    if (poster === undefined) throw new TypeError("renderPoster() must return a React element, but undefined was returned");
    const shouldShowPoster = poster && [
        showPosterWhenPaused && !player.isPlaying() && !seeking,
        showPosterWhenEnded && player.isLastFrame && !player.isPlaying(),
        showPosterWhenUnplayed && !player.hasPlayed && !player.isPlaying(),
        showPosterWhenBuffering && showBufferIndicator && player.isPlaying()
    ].some(Boolean);
    const { left: left, top: top, width: width, height: height, ...outerWithoutScale } = outer;
    const content = (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                style: outer,
                onPointerDown: clickToPlay ? handlePointerDown : undefined,
                onDoubleClick: doubleClickToFullscreen ? handleDoubleClick : undefined,
                children: (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: containerStyle3,
                    className: $f33cd4ca105fd87b$var$PLAYER_CSS_CLASSNAME,
                    children: [
                        VideoComponent ? (0, $7b02d682eb115277$exports.jsx)($f33cd4ca105fd87b$var$ErrorBoundary, {
                            onError: onError,
                            errorFallback: errorFallback,
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $c78df6347432a4c1$export$c39fff9f74a28020).ClipComposition, {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $c78df6347432a4c1$export$c39fff9f74a28020).CurrentScaleContext.Provider, {
                                    value: currentScale,
                                    children: (0, $7b02d682eb115277$exports.jsx)(VideoComponent, {
                                        ...video?.props ?? {},
                                        ...inputProps ?? {}
                                    })
                                })
                            })
                        }) : null,
                        shouldShowPoster && posterFillMode === "composition-size" ? (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                ...outerWithoutScale,
                                width: config.width,
                                height: config.height
                            },
                            onPointerDown: clickToPlay ? handlePointerDown : undefined,
                            onDoubleClick: doubleClickToFullscreen ? handleDoubleClick : undefined,
                            children: poster
                        }) : null
                    ]
                })
            }),
            shouldShowPoster && posterFillMode === "player-size" ? (0, $7b02d682eb115277$exports.jsx)("div", {
                style: outer,
                onPointerDown: clickToPlay ? handlePointerDown : undefined,
                onDoubleClick: doubleClickToFullscreen ? handleDoubleClick : undefined,
                children: poster
            }) : null,
            controls ? (0, $7b02d682eb115277$exports.jsx)($f33cd4ca105fd87b$var$Controls, {
                fps: config.fps,
                durationInFrames: config.durationInFrames,
                player: player,
                containerRef: container,
                onFullscreenButtonClick: onFullscreenButtonClick,
                isFullscreen: isFullscreen,
                allowFullscreen: allowFullscreen,
                showVolumeControls: showVolumeControls,
                onExitFullscreenButtonClick: onExitFullscreenButtonClick,
                spaceKeyToPlayOrPause: spaceKeyToPlayOrPause,
                onSeekEnd: onSeekEnd,
                onSeekStart: onSeekStart,
                inFrame: inFrame,
                outFrame: outFrame,
                initiallyShowControls: initiallyShowControls,
                canvasSize: canvasSize,
                renderFullscreenButton: renderFullscreenButton,
                renderPlayPauseButton: renderPlayPauseButton,
                alwaysShowControls: alwaysShowControls,
                showPlaybackRateControl: showPlaybackRateControl,
                buffering: showBufferIndicator,
                hideControlsWhenPointerDoesntMove: hideControlsWhenPointerDoesntMove,
                onDoubleClick: doubleClickToFullscreen ? handleDoubleClick : undefined,
                onPointerDown: clickToPlay ? handlePointerDown : undefined,
                renderMuteButton: renderMuteButton,
                renderVolumeSlider: renderVolumeSlider
            }) : null
        ]
    });
    if ($f33cd4ca105fd87b$var$IS_NODE && !$f33cd4ca105fd87b$var$doesReactVersionSupportSuspense) return (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: container,
        style: outerStyle,
        className: className2,
        children: content
    });
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: container,
        style: outerStyle,
        className: className2,
        children: (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Suspense), {
            fallback: loadingMarkup,
            children: content
        })
    });
};
var $f33cd4ca105fd87b$var$PlayerUI_default = (0, $acw62.forwardRef)($f33cd4ca105fd87b$var$PlayerUI);
// src/volume-persistance.ts
var $f33cd4ca105fd87b$var$VOLUME_PERSISTANCE_KEY = "remotion.volumePreference";
var $f33cd4ca105fd87b$var$persistVolume = (volume)=>{
    if (typeof window === "undefined") return;
    try {
        window.localStorage.setItem($f33cd4ca105fd87b$var$VOLUME_PERSISTANCE_KEY, String(volume));
    } catch (e) {
        console.log("Could not persist volume", e);
    }
};
var $f33cd4ca105fd87b$var$getPreferredVolume = ()=>{
    if (typeof window === "undefined") return 1;
    try {
        const val = window.localStorage.getItem($f33cd4ca105fd87b$var$VOLUME_PERSISTANCE_KEY);
        return val ? Number(val) : 1;
    } catch (e) {
        return 1;
    }
};
var $f33cd4ca105fd87b$var$PLAYER_COMP_ID = "player-comp";
var $f33cd4ca105fd87b$var$SharedPlayerContexts = ({ children: children, timelineContext: timelineContext, fps: fps, compositionHeight: compositionHeight, compositionWidth: compositionWidth, durationInFrames: durationInFrames, component: component, numberOfSharedAudioTags: numberOfSharedAudioTags, initiallyMuted: initiallyMuted })=>{
    const compositionManagerContext = (0, $acw62.useMemo)(()=>{
        const context = {
            compositions: [
                {
                    component: component,
                    durationInFrames: durationInFrames,
                    height: compositionHeight,
                    width: compositionWidth,
                    fps: fps,
                    id: $f33cd4ca105fd87b$var$PLAYER_COMP_ID,
                    nonce: 777,
                    folderName: null,
                    parentFolderName: null,
                    schema: null,
                    calculateMetadata: null
                }
            ],
            folders: [],
            registerFolder: ()=>{
                return;
            },
            unregisterFolder: ()=>{
                return;
            },
            registerComposition: ()=>{
                return;
            },
            unregisterComposition: ()=>{
                return;
            },
            currentCompositionMetadata: null,
            setCurrentCompositionMetadata: ()=>{
                return;
            },
            canvasContent: {
                type: "composition",
                compositionId: "player-comp"
            },
            setCanvasContent: ()=>{
                return;
            },
            updateCompositionDefaultProps: ()=>{
                return;
            }
        };
        return context;
    }, [
        component,
        durationInFrames,
        compositionHeight,
        compositionWidth,
        fps
    ]);
    const [mediaMuted, setMediaMuted] = (0, $acw62.useState)(()=>initiallyMuted);
    const [mediaVolume, setMediaVolume] = (0, $acw62.useState)(()=>$f33cd4ca105fd87b$var$getPreferredVolume());
    const mediaVolumeContextValue = (0, $acw62.useMemo)(()=>{
        return {
            mediaMuted: mediaMuted,
            mediaVolume: mediaVolume
        };
    }, [
        mediaMuted,
        mediaVolume
    ]);
    const setMediaVolumeAndPersist = (0, $acw62.useCallback)((vol)=>{
        setMediaVolume(vol);
        $f33cd4ca105fd87b$var$persistVolume(vol);
    }, []);
    const setMediaVolumeContextValue = (0, $acw62.useMemo)(()=>{
        return {
            setMediaMuted: setMediaMuted,
            setMediaVolume: setMediaVolumeAndPersist
        };
    }, [
        setMediaVolumeAndPersist
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $c78df6347432a4c1$export$c39fff9f74a28020).CanUseRemotionHooksProvider, {
        children: (0, $7b02d682eb115277$exports.jsx)((0, $c78df6347432a4c1$export$c39fff9f74a28020).Timeline.TimelineContext.Provider, {
            value: timelineContext,
            children: (0, $7b02d682eb115277$exports.jsx)((0, $c78df6347432a4c1$export$c39fff9f74a28020).CompositionManager.Provider, {
                value: compositionManagerContext,
                children: (0, $7b02d682eb115277$exports.jsx)((0, $c78df6347432a4c1$export$c39fff9f74a28020).ResolveCompositionConfig, {
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $c78df6347432a4c1$export$c39fff9f74a28020).PrefetchProvider, {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $c78df6347432a4c1$export$c39fff9f74a28020).DurationsContextProvider, {
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $c78df6347432a4c1$export$c39fff9f74a28020).MediaVolumeContext.Provider, {
                                value: mediaVolumeContextValue,
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $c78df6347432a4c1$export$c39fff9f74a28020).NativeLayersProvider, {
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $c78df6347432a4c1$export$c39fff9f74a28020).SetMediaVolumeContext.Provider, {
                                        value: setMediaVolumeContextValue,
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $c78df6347432a4c1$export$c39fff9f74a28020).SharedAudioContextProvider, {
                                            numberOfAudioTags: numberOfSharedAudioTags,
                                            component: component,
                                            children: (0, $7b02d682eb115277$exports.jsx)((0, $c78df6347432a4c1$export$c39fff9f74a28020).BufferingProvider, {
                                                children: children
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
// src/utils/validate-in-out-frame.ts
var $f33cd4ca105fd87b$var$validateSingleFrame = (frame, variableName)=>{
    if (typeof frame === "undefined" || frame === null) return frame ?? null;
    if (typeof frame !== "number") throw new TypeError(`"${variableName}" must be a number, but is ${JSON.stringify(frame)}`);
    if (Number.isNaN(frame)) throw new TypeError(`"${variableName}" must not be NaN, but is ${JSON.stringify(frame)}`);
    if (!Number.isFinite(frame)) throw new TypeError(`"${variableName}" must be finite, but is ${JSON.stringify(frame)}`);
    if (frame % 1 !== 0) throw new TypeError(`"${variableName}" must be an integer, but is ${JSON.stringify(frame)}`);
    return frame;
};
var $f33cd4ca105fd87b$var$validateInOutFrames = ({ inFrame: inFrame, durationInFrames: durationInFrames, outFrame: outFrame })=>{
    const validatedInFrame = $f33cd4ca105fd87b$var$validateSingleFrame(inFrame, "inFrame");
    const validatedOutFrame = $f33cd4ca105fd87b$var$validateSingleFrame(outFrame, "outFrame");
    if (validatedInFrame === null && validatedOutFrame === null) return;
    if (validatedInFrame !== null && validatedInFrame > durationInFrames - 1) throw new Error("inFrame must be less than (durationInFrames - 1), but is " + validatedInFrame);
    if (validatedOutFrame !== null && validatedOutFrame > durationInFrames - 1) throw new Error("outFrame must be less than (durationInFrames - 1), but is " + validatedOutFrame);
    if (validatedInFrame !== null && validatedInFrame < 0) throw new Error("inFrame must be greater than 0, but is " + validatedInFrame);
    if (validatedOutFrame !== null && validatedOutFrame <= 0) throw new Error(`outFrame must be greater than 0, but is ${validatedOutFrame}. If you want to render a single frame, use <Thumbnail /> instead.`);
    if (validatedOutFrame !== null && validatedInFrame !== null && validatedOutFrame <= validatedInFrame) throw new Error("outFrame must be greater than inFrame, but is " + validatedOutFrame + " <= " + validatedInFrame);
};
// src/utils/validate-initial-frame.ts
var $f33cd4ca105fd87b$var$validateInitialFrame = ({ initialFrame: initialFrame, durationInFrames: durationInFrames })=>{
    if (typeof durationInFrames !== "number") throw new Error(`\`durationInFrames\` must be a number, but is ${JSON.stringify(durationInFrames)}`);
    if (typeof initialFrame === "undefined") return;
    if (typeof initialFrame !== "number") throw new Error(`\`initialFrame\` must be a number, but is ${JSON.stringify(initialFrame)}`);
    if (Number.isNaN(initialFrame)) throw new Error(`\`initialFrame\` must be a number, but is NaN`);
    if (!Number.isFinite(initialFrame)) throw new Error(`\`initialFrame\` must be a number, but is Infinity`);
    if (initialFrame % 1 !== 0) throw new Error(`\`initialFrame\` must be an integer, but is ${JSON.stringify(initialFrame)}`);
    if (initialFrame > durationInFrames - 1) throw new Error(`\`initialFrame\` must be less or equal than \`durationInFrames - 1\`, but is ${JSON.stringify(initialFrame)}`);
};
// src/utils/validate-playbackrate.ts
var $f33cd4ca105fd87b$var$validatePlaybackRate = (playbackRate)=>{
    if (playbackRate === undefined) return;
    if (playbackRate > 4) throw new Error(`The highest possible playback rate is 4. You passed: ${playbackRate}`);
    if (playbackRate < -4) throw new Error(`The lowest possible playback rate is -4. You passed: ${playbackRate}`);
    if (playbackRate === 0) throw new Error(`A playback rate of 0 is not supported.`);
};
var $f33cd4ca105fd87b$var$validateFps = (0, $9380aba48b3a6b29$export$5ca440e467e58dfb).validateFps;
var $f33cd4ca105fd87b$var$validateDimension = (0, $9380aba48b3a6b29$export$5ca440e467e58dfb).validateDimension;
var $f33cd4ca105fd87b$var$validateDurationInFrames = (0, $9380aba48b3a6b29$export$5ca440e467e58dfb).validateDurationInFrames;
var $f33cd4ca105fd87b$var$validateDefaultAndInputProps = (0, $9380aba48b3a6b29$export$5ca440e467e58dfb).validateDefaultAndInputProps;
var $f33cd4ca105fd87b$var$componentOrNullIfLazy = (props)=>{
    if ("component" in props) return props.component;
    return null;
};
var $f33cd4ca105fd87b$var$PlayerFn = ({ durationInFrames: durationInFrames, compositionHeight: compositionHeight, compositionWidth: compositionWidth, fps: fps, inputProps: inputProps, style: style, controls: controls = false, loop: loop = false, autoPlay: autoPlay = false, showVolumeControls: showVolumeControls = true, allowFullscreen: allowFullscreen = true, clickToPlay: clickToPlay, doubleClickToFullscreen: doubleClickToFullscreen = false, spaceKeyToPlayOrPause: spaceKeyToPlayOrPause = true, moveToBeginningWhenEnded: moveToBeginningWhenEnded = true, numberOfSharedAudioTags: numberOfSharedAudioTags = 5, errorFallback: errorFallback = ()=>"\u26A0\uFE0F", playbackRate: playbackRate = 1, renderLoading: renderLoading, className: className2, showPosterWhenUnplayed: showPosterWhenUnplayed, showPosterWhenEnded: showPosterWhenEnded, showPosterWhenPaused: showPosterWhenPaused, showPosterWhenBuffering: showPosterWhenBuffering, initialFrame: initialFrame, renderPoster: renderPoster, inFrame: inFrame, outFrame: outFrame, initiallyShowControls: initiallyShowControls, renderFullscreenButton: renderFullscreenButton, renderPlayPauseButton: renderPlayPauseButton, renderVolumeSlider: renderVolumeSlider, alwaysShowControls: alwaysShowControls = false, initiallyMuted: initiallyMuted = false, showPlaybackRateControl: showPlaybackRateControl = false, posterFillMode: posterFillMode = "player-size", bufferStateDelayInMilliseconds: bufferStateDelayInMilliseconds, hideControlsWhenPointerDoesntMove: hideControlsWhenPointerDoesntMove = true, overflowVisible: overflowVisible = false, renderMuteButton: renderMuteButton, ...componentProps }, ref)=>{
    if (typeof window !== "undefined") (0, $acw62.useLayoutEffect)(()=>{
        window.remotion_isPlayer = true;
    }, []);
    if (componentProps.defaultProps !== undefined) throw new Error("The <Player /> component does not accept `defaultProps`, but some were passed. Use `inputProps` instead.");
    const componentForValidation = $f33cd4ca105fd87b$var$componentOrNullIfLazy(componentProps);
    if (componentForValidation?.type === (0, $c78df6347432a4c1$export$d955f48b7132ae28)) throw new TypeError(`'component' should not be an instance of <Composition/>. Pass the React component directly, and set the duration, fps and dimensions as separate props. See https://www.remotion.dev/docs/player/examples for an example.`);
    if (componentForValidation === (0, $c78df6347432a4c1$export$d955f48b7132ae28)) throw new TypeError(`'component' must not be the 'Composition' component. Pass your own React component directly, and set the duration, fps and dimensions as separate props. See https://www.remotion.dev/docs/player/examples for an example.`);
    const component = (0, $c78df6347432a4c1$export$c39fff9f74a28020).useLazyComponent(componentProps);
    $f33cd4ca105fd87b$var$validateInitialFrame({
        initialFrame: initialFrame,
        durationInFrames: durationInFrames
    });
    const [frame, setFrame] = (0, $acw62.useState)(()=>({
            [$f33cd4ca105fd87b$var$PLAYER_COMP_ID]: initialFrame ?? 0
        }));
    const [playing, setPlaying] = (0, $acw62.useState)(false);
    const [rootId] = (0, $acw62.useState)("player-comp");
    const rootRef = (0, $acw62.useRef)(null);
    const audioAndVideoTags = (0, $acw62.useRef)([]);
    const imperativePlaying = (0, $acw62.useRef)(false);
    const [currentPlaybackRate, setCurrentPlaybackRate] = (0, $acw62.useState)(playbackRate);
    if (typeof compositionHeight !== "number") throw new TypeError(`'compositionHeight' must be a number but got '${typeof compositionHeight}' instead`);
    if (typeof compositionWidth !== "number") throw new TypeError(`'compositionWidth' must be a number but got '${typeof compositionWidth}' instead`);
    $f33cd4ca105fd87b$var$validateDimension(compositionHeight, "compositionHeight", "of the <Player /> component");
    $f33cd4ca105fd87b$var$validateDimension(compositionWidth, "compositionWidth", "of the <Player /> component");
    $f33cd4ca105fd87b$var$validateDurationInFrames(durationInFrames, {
        component: "of the <Player/> component",
        allowFloats: false
    });
    $f33cd4ca105fd87b$var$validateFps(fps, "as a prop of the <Player/> component", false);
    $f33cd4ca105fd87b$var$validateDefaultAndInputProps(inputProps, "inputProps", null);
    $f33cd4ca105fd87b$var$validateInOutFrames({
        durationInFrames: durationInFrames,
        inFrame: inFrame,
        outFrame: outFrame
    });
    if (typeof controls !== "boolean" && typeof controls !== "undefined") throw new TypeError(`'controls' must be a boolean or undefined but got '${typeof controls}' instead`);
    if (typeof autoPlay !== "boolean" && typeof autoPlay !== "undefined") throw new TypeError(`'autoPlay' must be a boolean or undefined but got '${typeof autoPlay}' instead`);
    if (typeof loop !== "boolean" && typeof loop !== "undefined") throw new TypeError(`'loop' must be a boolean or undefined but got '${typeof loop}' instead`);
    if (typeof doubleClickToFullscreen !== "boolean" && typeof doubleClickToFullscreen !== "undefined") throw new TypeError(`'doubleClickToFullscreen' must be a boolean or undefined but got '${typeof doubleClickToFullscreen}' instead`);
    if (typeof showVolumeControls !== "boolean" && typeof showVolumeControls !== "undefined") throw new TypeError(`'showVolumeControls' must be a boolean or undefined but got '${typeof showVolumeControls}' instead`);
    if (typeof allowFullscreen !== "boolean" && typeof allowFullscreen !== "undefined") throw new TypeError(`'allowFullscreen' must be a boolean or undefined but got '${typeof allowFullscreen}' instead`);
    if (typeof clickToPlay !== "boolean" && typeof clickToPlay !== "undefined") throw new TypeError(`'clickToPlay' must be a boolean or undefined but got '${typeof clickToPlay}' instead`);
    if (typeof spaceKeyToPlayOrPause !== "boolean" && typeof spaceKeyToPlayOrPause !== "undefined") throw new TypeError(`'spaceKeyToPlayOrPause' must be a boolean or undefined but got '${typeof spaceKeyToPlayOrPause}' instead`);
    if (typeof numberOfSharedAudioTags !== "number" || numberOfSharedAudioTags % 1 !== 0 || !Number.isFinite(numberOfSharedAudioTags) || Number.isNaN(numberOfSharedAudioTags) || numberOfSharedAudioTags < 0) throw new TypeError(`'numberOfSharedAudioTags' must be an integer but got '${numberOfSharedAudioTags}' instead`);
    $f33cd4ca105fd87b$var$validatePlaybackRate(currentPlaybackRate);
    (0, $acw62.useEffect)(()=>{
        setCurrentPlaybackRate(playbackRate);
    }, [
        playbackRate
    ]);
    (0, $acw62.useImperativeHandle)(ref, ()=>rootRef.current, []);
    const timelineContextValue = (0, $acw62.useMemo)(()=>{
        return {
            frame: frame,
            playing: playing,
            rootId: rootId,
            playbackRate: currentPlaybackRate,
            imperativePlaying: imperativePlaying,
            setPlaybackRate: (rate)=>{
                setCurrentPlaybackRate(rate);
            },
            audioAndVideoTags: audioAndVideoTags
        };
    }, [
        frame,
        currentPlaybackRate,
        playing,
        rootId
    ]);
    const setTimelineContextValue = (0, $acw62.useMemo)(()=>{
        return {
            setFrame: setFrame,
            setPlaying: setPlaying
        };
    }, [
        setFrame
    ]);
    if (typeof window !== "undefined") (0, $acw62.useLayoutEffect)(()=>{
        (0, $c78df6347432a4c1$export$c39fff9f74a28020).CSSUtils.injectCSS((0, $c78df6347432a4c1$export$c39fff9f74a28020).CSSUtils.makeDefaultPreviewCSS(`.${$f33cd4ca105fd87b$var$PLAYER_CSS_CLASSNAME}`, "#fff"));
    }, []);
    const actualInputProps = (0, $acw62.useMemo)(()=>inputProps ?? {}, [
        inputProps
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $c78df6347432a4c1$export$c39fff9f74a28020).IsPlayerContextProvider, {
        children: (0, $7b02d682eb115277$exports.jsx)($f33cd4ca105fd87b$var$SharedPlayerContexts, {
            timelineContext: timelineContextValue,
            component: component,
            compositionHeight: compositionHeight,
            compositionWidth: compositionWidth,
            durationInFrames: durationInFrames,
            fps: fps,
            numberOfSharedAudioTags: numberOfSharedAudioTags,
            initiallyMuted: initiallyMuted,
            children: (0, $7b02d682eb115277$exports.jsx)((0, $c78df6347432a4c1$export$c39fff9f74a28020).Timeline.SetTimelineContext.Provider, {
                value: setTimelineContextValue,
                children: (0, $7b02d682eb115277$exports.jsx)($f33cd4ca105fd87b$var$PlayerEmitterProvider, {
                    currentPlaybackRate: currentPlaybackRate,
                    children: (0, $7b02d682eb115277$exports.jsx)($f33cd4ca105fd87b$var$PlayerUI_default, {
                        ref: rootRef,
                        posterFillMode: posterFillMode,
                        renderLoading: renderLoading,
                        autoPlay: Boolean(autoPlay),
                        loop: Boolean(loop),
                        controls: Boolean(controls),
                        errorFallback: errorFallback,
                        style: style,
                        inputProps: actualInputProps,
                        allowFullscreen: Boolean(allowFullscreen),
                        moveToBeginningWhenEnded: Boolean(moveToBeginningWhenEnded),
                        clickToPlay: typeof clickToPlay === "boolean" ? clickToPlay : Boolean(controls),
                        showVolumeControls: Boolean(showVolumeControls),
                        doubleClickToFullscreen: Boolean(doubleClickToFullscreen),
                        spaceKeyToPlayOrPause: Boolean(spaceKeyToPlayOrPause),
                        playbackRate: currentPlaybackRate,
                        className: className2 ?? undefined,
                        showPosterWhenUnplayed: Boolean(showPosterWhenUnplayed),
                        showPosterWhenEnded: Boolean(showPosterWhenEnded),
                        showPosterWhenPaused: Boolean(showPosterWhenPaused),
                        showPosterWhenBuffering: Boolean(showPosterWhenBuffering),
                        renderPoster: renderPoster,
                        inFrame: inFrame ?? null,
                        outFrame: outFrame ?? null,
                        initiallyShowControls: initiallyShowControls ?? true,
                        renderFullscreen: renderFullscreenButton ?? null,
                        renderPlayPauseButton: renderPlayPauseButton ?? null,
                        renderMuteButton: renderMuteButton ?? null,
                        renderVolumeSlider: renderVolumeSlider ?? null,
                        alwaysShowControls: alwaysShowControls,
                        showPlaybackRateControl: showPlaybackRateControl,
                        bufferStateDelayInMilliseconds: bufferStateDelayInMilliseconds ?? 300,
                        hideControlsWhenPointerDoesntMove: hideControlsWhenPointerDoesntMove,
                        overflowVisible: overflowVisible
                    })
                })
            })
        })
    });
};
var $f33cd4ca105fd87b$var$forward = (0, $acw62.forwardRef);
var $f33cd4ca105fd87b$export$2616165974278734 = $f33cd4ca105fd87b$var$forward($f33cd4ca105fd87b$var$PlayerFn);
var $f33cd4ca105fd87b$var$useThumbnail = ()=>{
    const emitter = (0, $acw62.useContext)($f33cd4ca105fd87b$var$ThumbnailEmitterContext);
    if (!emitter) throw new TypeError("Expected Player event emitter context");
    const returnValue = (0, $acw62.useMemo)(()=>{
        return {
            emitter: emitter
        };
    }, [
        emitter
    ]);
    return returnValue;
};
var $f33cd4ca105fd87b$var$reactVersion2 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).version.split(".")[0];
if ($f33cd4ca105fd87b$var$reactVersion2 === "0") throw new Error(`Version ${$f33cd4ca105fd87b$var$reactVersion2} of "react" is not supported by Remotion`);
var $f33cd4ca105fd87b$var$doesReactVersionSupportSuspense2 = parseInt($f33cd4ca105fd87b$var$reactVersion2, 10) >= 18;
var $f33cd4ca105fd87b$var$ThumbnailUI = ({ style: style, inputProps: inputProps, errorFallback: errorFallback, renderLoading: renderLoading, className: className2, overflowVisible: overflowVisible }, ref)=>{
    const config = (0, $c78df6347432a4c1$export$c39fff9f74a28020).useUnsafeVideoConfig();
    const video = (0, $c78df6347432a4c1$export$c39fff9f74a28020).useVideo();
    const container = (0, $acw62.useRef)(null);
    const canvasSize = $f33cd4ca105fd87b$var$useElementSize(container, {
        triggerOnWindowResize: false,
        shouldApplyCssTransforms: false
    });
    const layout = (0, $acw62.useMemo)(()=>{
        if (!config || !canvasSize) return null;
        return $f33cd4ca105fd87b$var$calculateCanvasTransformation({
            canvasSize: canvasSize,
            compositionHeight: config.height,
            compositionWidth: config.width,
            previewSize: "auto"
        });
    }, [
        canvasSize,
        config
    ]);
    const scale = layout?.scale ?? 1;
    const thumbnail = $f33cd4ca105fd87b$var$useThumbnail();
    $f33cd4ca105fd87b$var$useBufferStateEmitter(thumbnail.emitter);
    (0, $acw62.useImperativeHandle)(ref, ()=>{
        const methods = {
            getContainerNode: ()=>container.current,
            getScale: ()=>scale
        };
        return Object.assign(thumbnail.emitter, methods);
    }, [
        scale,
        thumbnail.emitter
    ]);
    const VideoComponent = video ? video.component : null;
    const outerStyle = (0, $acw62.useMemo)(()=>{
        return $f33cd4ca105fd87b$var$calculateOuterStyle({
            config: config,
            style: style,
            canvasSize: canvasSize,
            overflowVisible: overflowVisible
        });
    }, [
        canvasSize,
        config,
        overflowVisible,
        style
    ]);
    const outer = (0, $acw62.useMemo)(()=>{
        return $f33cd4ca105fd87b$var$calculateOuter({
            config: config,
            layout: layout,
            scale: scale,
            overflowVisible: overflowVisible
        });
    }, [
        config,
        layout,
        overflowVisible,
        scale
    ]);
    const containerStyle3 = (0, $acw62.useMemo)(()=>{
        return $f33cd4ca105fd87b$var$calculateContainerStyle({
            canvasSize: canvasSize,
            config: config,
            layout: layout,
            scale: scale,
            overflowVisible: overflowVisible
        });
    }, [
        canvasSize,
        config,
        layout,
        overflowVisible,
        scale
    ]);
    const onError = (0, $acw62.useCallback)((error)=>{
        thumbnail.emitter.dispatchError(error);
    }, [
        thumbnail.emitter
    ]);
    const loadingMarkup = (0, $acw62.useMemo)(()=>{
        return renderLoading ? renderLoading({
            height: outerStyle.height,
            width: outerStyle.width,
            isBuffering: false
        }) : null;
    }, [
        outerStyle.height,
        outerStyle.width,
        renderLoading
    ]);
    const currentScaleContext = (0, $acw62.useMemo)(()=>{
        return {
            type: "scale",
            scale: scale
        };
    }, [
        scale
    ]);
    if (!config) return null;
    const content = (0, $7b02d682eb115277$exports.jsx)("div", {
        style: outer,
        children: (0, $7b02d682eb115277$exports.jsx)("div", {
            style: containerStyle3,
            className: $f33cd4ca105fd87b$var$PLAYER_CSS_CLASSNAME,
            children: VideoComponent ? (0, $7b02d682eb115277$exports.jsx)($f33cd4ca105fd87b$var$ErrorBoundary, {
                onError: onError,
                errorFallback: errorFallback,
                children: (0, $7b02d682eb115277$exports.jsx)((0, $c78df6347432a4c1$export$c39fff9f74a28020).CurrentScaleContext.Provider, {
                    value: currentScaleContext,
                    children: (0, $7b02d682eb115277$exports.jsx)(VideoComponent, {
                        ...video?.props ?? {},
                        ...inputProps ?? {}
                    })
                })
            }) : null
        })
    });
    if ($f33cd4ca105fd87b$var$IS_NODE && !$f33cd4ca105fd87b$var$doesReactVersionSupportSuspense2) return (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: container,
        style: outerStyle,
        className: className2,
        children: content
    });
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: container,
        style: outerStyle,
        className: className2,
        children: (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Suspense), {
            fallback: loadingMarkup,
            children: content
        })
    });
};
var $f33cd4ca105fd87b$var$ThumbnailUI_default = (0, $acw62.forwardRef)($f33cd4ca105fd87b$var$ThumbnailUI);
var $f33cd4ca105fd87b$var$ThumbnailFn = ({ frameToDisplay: frameToDisplay, style: style, inputProps: inputProps, compositionHeight: compositionHeight, compositionWidth: compositionWidth, durationInFrames: durationInFrames, fps: fps, className: className2, errorFallback: errorFallback = ()=>"\u26A0\uFE0F", renderLoading: renderLoading, overflowVisible: overflowVisible = false, ...componentProps }, ref)=>{
    if (typeof window !== "undefined") (0, $acw62.useLayoutEffect)(()=>{
        window.remotion_isPlayer = true;
    }, []);
    const [thumbnailId] = (0, $acw62.useState)(()=>String((0, $c78df6347432a4c1$export$4385e60b38654f68)(null)));
    const rootRef = (0, $acw62.useRef)(null);
    const timelineState = (0, $acw62.useMemo)(()=>{
        const value = {
            playing: false,
            frame: {
                [$f33cd4ca105fd87b$var$PLAYER_COMP_ID]: frameToDisplay
            },
            rootId: thumbnailId,
            imperativePlaying: {
                current: false
            },
            playbackRate: 1,
            setPlaybackRate: ()=>{
                throw new Error("thumbnail");
            },
            audioAndVideoTags: {
                current: []
            }
        };
        return value;
    }, [
        frameToDisplay,
        thumbnailId
    ]);
    (0, $acw62.useImperativeHandle)(ref, ()=>rootRef.current, []);
    const Component = (0, $c78df6347432a4c1$export$c39fff9f74a28020).useLazyComponent(componentProps);
    const [emitter] = (0, $acw62.useState)(()=>new $f33cd4ca105fd87b$var$ThumbnailEmitter);
    const passedInputProps = (0, $acw62.useMemo)(()=>{
        return inputProps ?? {};
    }, [
        inputProps
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $c78df6347432a4c1$export$c39fff9f74a28020).IsPlayerContextProvider, {
        children: (0, $7b02d682eb115277$exports.jsx)($f33cd4ca105fd87b$var$SharedPlayerContexts, {
            timelineContext: timelineState,
            component: Component,
            compositionHeight: compositionHeight,
            compositionWidth: compositionWidth,
            durationInFrames: durationInFrames,
            fps: fps,
            numberOfSharedAudioTags: 0,
            initiallyMuted: true,
            children: (0, $7b02d682eb115277$exports.jsx)($f33cd4ca105fd87b$var$ThumbnailEmitterContext.Provider, {
                value: emitter,
                children: (0, $7b02d682eb115277$exports.jsx)($f33cd4ca105fd87b$var$ThumbnailUI_default, {
                    ref: rootRef,
                    className: className2,
                    errorFallback: errorFallback,
                    inputProps: passedInputProps,
                    renderLoading: renderLoading,
                    style: style,
                    overflowVisible: overflowVisible
                })
            })
        })
    });
};
var $f33cd4ca105fd87b$var$forward2 = (0, $acw62.forwardRef);
var $f33cd4ca105fd87b$export$1cd1efc78cb52ca5 = $f33cd4ca105fd87b$var$forward2($f33cd4ca105fd87b$var$ThumbnailFn);
// src/index.ts
var $f33cd4ca105fd87b$export$b017bb2377710b6a = {
    PlayerEventEmitterContext: $f33cd4ca105fd87b$var$PlayerEventEmitterContext,
    PlayerEmitter: $f33cd4ca105fd87b$var$PlayerEmitter,
    usePlayer: $f33cd4ca105fd87b$var$usePlayer,
    usePlayback: $f33cd4ca105fd87b$var$usePlayback,
    useElementSize: $f33cd4ca105fd87b$var$useElementSize,
    calculateCanvasTransformation: $f33cd4ca105fd87b$var$calculateCanvasTransformation,
    useHoverState: $f33cd4ca105fd87b$var$useHoverState,
    updateAllElementsSizes: $f33cd4ca105fd87b$var$updateAllElementsSizes,
    PlayerEmitterProvider: $f33cd4ca105fd87b$var$PlayerEmitterProvider,
    BufferingIndicator: $f33cd4ca105fd87b$var$BufferingIndicator
};





var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");

function $8e3e7cf4ccf81aa5$var$useDurationsWithGaps(timedTexts) {
    const gapsAfterTexts = (0, $acw62.useMemo)(()=>{
        return timedTexts.map((text, index)=>{
            if (index === timedTexts.length - 1) return 0;
            return timedTexts[index + 1].start - text.end;
        });
    }, [
        timedTexts
    ]);
    const durations = (0, $acw62.useMemo)(()=>{
        return timedTexts.map((text, index)=>{
            return text.end - text.start + gapsAfterTexts[index];
        });
    }, [
        timedTexts,
        gapsAfterTexts
    ]);
    return durations;
}
function $8e3e7cf4ccf81aa5$export$70c22249e674b2a0({ sequences: sequences, renderSequence: renderSequence }) {
    const { fps: fps } = (0, $c78df6347432a4c1$export$da01606c8b81c2a0)();
    const adjustedDurations = $8e3e7cf4ccf81aa5$var$useDurationsWithGaps(sequences);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: sequences.map((sequence, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c78df6347432a4c1$export$edde1bcb1b2b310e), {
                from: sequence.start / 1000 * fps,
                durationInFrames: Math.ceil(adjustedDurations[index] / 1000 * fps),
                children: renderSequence(sequence)
            }, index))
    });
}


function $41780d10c43e3168$export$94253674da513666({ sequences: sequences, rootClassName: rootClassName, sequenceTextClassName: sequenceTextClassName, wrapperClassName: wrapperClassName, wrapperStyles: wrapperStyles, sequenceTextStyles: sequenceTextStyles, wordTextStyles: wordTextStyles, hightlightedWordTextStyles: hightlightedWordTextStyles, renderWord: renderWord }) {
    const frame = (0, $c78df6347432a4c1$export$e82ee3202ebaa1e9)();
    const { fps: fps } = (0, $c78df6347432a4c1$export$da01606c8b81c2a0)();
    const renderSequence = (sequence)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("w-full flex flex-col items-center justify-end", rootClassName),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("w-full flex flex-col justify-end", wrapperClassName),
                style: wrapperStyles,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: sequenceTextClassName,
                    style: sequenceTextStyles,
                    children: sequence.words.map((word, index)=>{
                        const highlight = frame >= word.start / 1000 * fps && frame <= word.end / 1000 * fps;
                        const show = frame >= word.start / 1000 * fps;
                        if (renderWord) return renderWord(word, index, highlight, show);
                        else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            style: {
                                opacity: show ? 1 : 0,
                                ...wordTextStyles,
                                ...highlight ? hightlightedWordTextStyles : {}
                            },
                            children: [
                                word.text,
                                " "
                            ]
                        }, index);
                    })
                })
            })
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8e3e7cf4ccf81aa5$export$70c22249e674b2a0), {
        sequences: sequences,
        renderSequence: renderSequence
    });
}


const $eb028a7a6e843e1b$var$Properties = {
    textColor: {
        label: "Text",
        propertyType: "color"
    },
    highlightColor: {
        label: "Highlighted Text",
        propertyType: "color"
    },
    bgColor: {
        label: "Background",
        propertyType: "color"
    }
};
const $eb028a7a6e843e1b$export$fb8333fa36e109e4 = {
    properties: $eb028a7a6e843e1b$var$Properties
};
function $eb028a7a6e843e1b$export$7f2dde7b523257d1() {
    return {
        textColor: "#ffffff",
        highlightColor: "#ffff00",
        bgColor: "#042f2e"
    };
}
function $eb028a7a6e843e1b$export$7e433e842510d383({ values: values, phrases: phrases }) {
    const backgroundColor = values.bgColor;
    const textColor = values.textColor;
    const highlightColor = values.highlightColor;
    if (!backgroundColor || !textColor || !highlightColor) {
        console.error("Missing required options");
        return null;
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $41780d10c43e3168$export$94253674da513666), {
        sequences: phrases,
        rootClassName: "px-8 py-16 pb-[300px]",
        sequenceTextClassName: "text-center text-[72px] px-10 py-10 rounded-[32px] leading-[1.2]",
        sequenceTextStyles: {
            fontFamily: "Outfit",
            color: textColor,
            backgroundColor: backgroundColor
        },
        wordTextStyles: {
            color: textColor
        },
        hightlightedWordTextStyles: {
            color: highlightColor
        }
    });
}




const $416685c10d8c626b$var$Properties = {
    textColor: {
        label: "Text",
        propertyType: "color"
    },
    strokeColor: {
        label: "Outline",
        propertyType: "color"
    }
};
const $416685c10d8c626b$export$3271b405ff769db9 = {
    properties: $416685c10d8c626b$var$Properties
};
function $416685c10d8c626b$export$cfe86fe7e8620d40() {
    return {
        textColor: "#ffffff",
        strokeColor: "#111111"
    };
}
function $416685c10d8c626b$export$c776500face674d6({ values: values, phrases: phrases }) {
    const textColor = values.textColor;
    const strokeColor = values.strokeColor;
    if (!textColor || !strokeColor) {
        console.error("Missing required options");
        return null;
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $41780d10c43e3168$export$94253674da513666), {
        sequences: phrases,
        rootClassName: "px-8 py-16 pb-64",
        sequenceTextClassName: "text-center px-10 py-10 rounded-[32px] leading-[1.2]",
        renderWord: (word, index, highlighted, show)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "inline-block whitespace-pre-wrap relative z-0",
                style: {
                    fontFamily: `"Exo 2"`,
                    fontOpticalSizing: "auto",
                    fontSize: 120,
                    color: textColor,
                    letterSpacing: 2,
                    opacity: show ? 1 : 0
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "absolute top-0 left-0 w-full h-full z-[-1]",
                        style: {
                            fontFamily: `"Exo 2"`,
                            fontOpticalSizing: "auto",
                            whiteSpace: "pre",
                            fontSize: 120,
                            color: strokeColor,
                            letterSpacing: 2,
                            WebkitTextStrokeColor: strokeColor,
                            WebkitTextStrokeWidth: "20px"
                        },
                        children: [
                            word.text,
                            " "
                        ]
                    }),
                    word.text,
                    " "
                ]
            }, index)
    });
}





function $b0ce481cc2aa4560$export$2e2bcd8739ae039({ words: words, renderWord: renderWord }) {
    const { fps: fps } = (0, $c78df6347432a4c1$export$da01606c8b81c2a0)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: words.map((word, index)=>{
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c78df6347432a4c1$export$edde1bcb1b2b310e), {
                from: word.start / 1000 * fps,
                durationInFrames: word.end / 1000 * fps - word.start / 1000 * fps,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "w-full flex flex-col items-center justify-end px-8 py-16 pb-[300px]",
                    children: renderWord(word)
                })
            }, index);
        })
    });
}



const $4a971e4684c493ae$export$c47a6cc342009543 = {
    properties: {
        textColor: {
            label: "Text",
            propertyType: "color"
        },
        bgColor: {
            label: "Background",
            propertyType: "color"
        }
    }
};
function $4a971e4684c493ae$export$6f8da6070c48b4e9() {
    return {
        textColor: "#E6FF94",
        bgColor: "#355070"
    };
}
function $4a971e4684c493ae$var$SingleFadedWord({ word: word, textColor: textColor, bgColor: bgColor }) {
    const frame = (0, $c78df6347432a4c1$export$e82ee3202ebaa1e9)();
    const { fps: fps, durationInFrames: durationInFrames } = (0, $c78df6347432a4c1$export$da01606c8b81c2a0)();
    const animationDurationInFrames = Math.min(Math.floor(0.05 * fps), Math.floor(durationInFrames / 2) - 1);
    const opacity = animationDurationInFrames > 1 && durationInFrames > 5 ? (0, $c78df6347432a4c1$export$89e29e4ab65e70a9)(frame, [
        0,
        animationDurationInFrames,
        durationInFrames - animationDurationInFrames,
        durationInFrames
    ], [
        0,
        1,
        1,
        0
    ], {
        extrapolateLeft: "clamp",
        extrapolateRight: "clamp"
    }) : 1;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "w-full flex flex-col items-center justify-center",
        style: {
            opacity: opacity
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "text-8xl px-10 py-5 rounded-3xl",
            style: {
                backgroundColor: bgColor,
                color: textColor
            },
            children: word.text
        })
    });
}
function $4a971e4684c493ae$export$7480f237f2e384d0({ words: words, values: values }) {
    const backgroundColor = values.bgColor;
    const textColor = values.textColor;
    if (!backgroundColor || !textColor) {
        console.error("Missing required options");
        return null;
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0ce481cc2aa4560$export$2e2bcd8739ae039), {
        words: words,
        renderWord: (word)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4a971e4684c493ae$var$SingleFadedWord, {
                word: word,
                bgColor: backgroundColor,
                textColor: textColor
            })
    });
}





var $acw62 = parcelRequire("acw62");
var $08acccbbd431ef55$exports = {};
var $86e889c881e89501$exports = {};
/* MIT license */ var $e81b4034aa9db203$exports = {};
"use strict";
$e81b4034aa9db203$exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};


var $617e73434a6cfefb$exports = {};
"use strict";
var $1db015379498b09f$exports = {};
$1db015379498b09f$exports = function isArrayish(obj) {
    if (!obj || typeof obj === "string") return false;
    return obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== "String");
};


var $617e73434a6cfefb$var$concat = Array.prototype.concat;
var $617e73434a6cfefb$var$slice = Array.prototype.slice;
var $617e73434a6cfefb$var$swizzle = $617e73434a6cfefb$exports = function swizzle(args) {
    var results = [];
    for(var i = 0, len = args.length; i < len; i++){
        var arg = args[i];
        if ($1db015379498b09f$exports(arg)) // http://jsperf.com/javascript-array-concat-vs-push/98
        results = $617e73434a6cfefb$var$concat.call(results, $617e73434a6cfefb$var$slice.call(arg));
        else results.push(arg);
    }
    return results;
};
$617e73434a6cfefb$var$swizzle.wrap = function(fn) {
    return function() {
        return fn($617e73434a6cfefb$var$swizzle(arguments));
    };
};


var $86e889c881e89501$var$hasOwnProperty = Object.hasOwnProperty;
var $86e889c881e89501$var$reverseNames = Object.create(null);
// create a list of reverse color names
for(var $86e889c881e89501$var$name in $e81b4034aa9db203$exports)if ($86e889c881e89501$var$hasOwnProperty.call($e81b4034aa9db203$exports, $86e889c881e89501$var$name)) $86e889c881e89501$var$reverseNames[$e81b4034aa9db203$exports[$86e889c881e89501$var$name]] = $86e889c881e89501$var$name;
var $86e889c881e89501$var$cs = $86e889c881e89501$exports = {
    to: {},
    get: {}
};
$86e889c881e89501$var$cs.get = function(string) {
    var prefix = string.substring(0, 3).toLowerCase();
    var val;
    var model;
    switch(prefix){
        case "hsl":
            val = $86e889c881e89501$var$cs.get.hsl(string);
            model = "hsl";
            break;
        case "hwb":
            val = $86e889c881e89501$var$cs.get.hwb(string);
            model = "hwb";
            break;
        default:
            val = $86e889c881e89501$var$cs.get.rgb(string);
            model = "rgb";
            break;
    }
    if (!val) return null;
    return {
        model: model,
        value: val
    };
};
$86e889c881e89501$var$cs.get.rgb = function(string) {
    if (!string) return null;
    var abbr = /^#([a-f0-9]{3,4})$/i;
    var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
    var rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var keyword = /^(\w+)$/;
    var rgb = [
        0,
        0,
        0,
        1
    ];
    var match;
    var i;
    var hexAlpha;
    if (match = string.match(hex)) {
        hexAlpha = match[2];
        match = match[1];
        for(i = 0; i < 3; i++){
            // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
            var i2 = i * 2;
            rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
        }
        if (hexAlpha) rgb[3] = parseInt(hexAlpha, 16) / 255;
    } else if (match = string.match(abbr)) {
        match = match[1];
        hexAlpha = match[3];
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i] + match[i], 16);
        if (hexAlpha) rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
    } else if (match = string.match(rgba)) {
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i + 1], 0);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(per)) {
        for(i = 0; i < 3; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(keyword)) {
        if (match[1] === "transparent") return [
            0,
            0,
            0,
            0
        ];
        if (!$86e889c881e89501$var$hasOwnProperty.call($e81b4034aa9db203$exports, match[1])) return null;
        rgb = $e81b4034aa9db203$exports[match[1]];
        rgb[3] = 1;
        return rgb;
    } else return null;
    for(i = 0; i < 3; i++)rgb[i] = $86e889c881e89501$var$clamp(rgb[i], 0, 255);
    rgb[3] = $86e889c881e89501$var$clamp(rgb[3], 0, 1);
    return rgb;
};
$86e889c881e89501$var$cs.get.hsl = function(string) {
    if (!string) return null;
    var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hsl);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var s = $86e889c881e89501$var$clamp(parseFloat(match[2]), 0, 100);
        var l = $86e889c881e89501$var$clamp(parseFloat(match[3]), 0, 100);
        var a = $86e889c881e89501$var$clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            s,
            l,
            a
        ];
    }
    return null;
};
$86e889c881e89501$var$cs.get.hwb = function(string) {
    if (!string) return null;
    var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hwb);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var w = $86e889c881e89501$var$clamp(parseFloat(match[2]), 0, 100);
        var b = $86e889c881e89501$var$clamp(parseFloat(match[3]), 0, 100);
        var a = $86e889c881e89501$var$clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            w,
            b,
            a
        ];
    }
    return null;
};
$86e889c881e89501$var$cs.to.hex = function() {
    var rgba = $617e73434a6cfefb$exports(arguments);
    return "#" + $86e889c881e89501$var$hexDouble(rgba[0]) + $86e889c881e89501$var$hexDouble(rgba[1]) + $86e889c881e89501$var$hexDouble(rgba[2]) + (rgba[3] < 1 ? $86e889c881e89501$var$hexDouble(Math.round(rgba[3] * 255)) : "");
};
$86e889c881e89501$var$cs.to.rgb = function() {
    var rgba = $617e73434a6cfefb$exports(arguments);
    return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ")" : "rgba(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ", " + rgba[3] + ")";
};
$86e889c881e89501$var$cs.to.rgb.percent = function() {
    var rgba = $617e73434a6cfefb$exports(arguments);
    var r = Math.round(rgba[0] / 255 * 100);
    var g = Math.round(rgba[1] / 255 * 100);
    var b = Math.round(rgba[2] / 255 * 100);
    return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + r + "%, " + g + "%, " + b + "%)" : "rgba(" + r + "%, " + g + "%, " + b + "%, " + rgba[3] + ")";
};
$86e889c881e89501$var$cs.to.hsl = function() {
    var hsla = $617e73434a6cfefb$exports(arguments);
    return hsla.length < 4 || hsla[3] === 1 ? "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)" : "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + hsla[3] + ")";
};
// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
$86e889c881e89501$var$cs.to.hwb = function() {
    var hwba = $617e73434a6cfefb$exports(arguments);
    var a = "";
    if (hwba.length >= 4 && hwba[3] !== 1) a = ", " + hwba[3];
    return "hwb(" + hwba[0] + ", " + hwba[1] + "%, " + hwba[2] + "%" + a + ")";
};
$86e889c881e89501$var$cs.to.keyword = function(rgb) {
    return $86e889c881e89501$var$reverseNames[rgb.slice(0, 3)];
};
// helpers
function $86e889c881e89501$var$clamp(num, min, max) {
    return Math.min(Math.max(min, num), max);
}
function $86e889c881e89501$var$hexDouble(num) {
    var str = Math.round(num).toString(16).toUpperCase();
    return str.length < 2 ? "0" + str : str;
}


var $ce5238844c992f76$exports = {};
var $87010999ebf2f889$exports = {};
/* MIT license */ /* eslint-disable no-mixed-operators */ 
// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)
const $87010999ebf2f889$var$reverseKeywords = {};
for (const key of Object.keys($e81b4034aa9db203$exports))$87010999ebf2f889$var$reverseKeywords[$e81b4034aa9db203$exports[key]] = key;
const $87010999ebf2f889$var$convert = {
    rgb: {
        channels: 3,
        labels: "rgb"
    },
    hsl: {
        channels: 3,
        labels: "hsl"
    },
    hsv: {
        channels: 3,
        labels: "hsv"
    },
    hwb: {
        channels: 3,
        labels: "hwb"
    },
    cmyk: {
        channels: 4,
        labels: "cmyk"
    },
    xyz: {
        channels: 3,
        labels: "xyz"
    },
    lab: {
        channels: 3,
        labels: "lab"
    },
    lch: {
        channels: 3,
        labels: "lch"
    },
    hex: {
        channels: 1,
        labels: [
            "hex"
        ]
    },
    keyword: {
        channels: 1,
        labels: [
            "keyword"
        ]
    },
    ansi16: {
        channels: 1,
        labels: [
            "ansi16"
        ]
    },
    ansi256: {
        channels: 1,
        labels: [
            "ansi256"
        ]
    },
    hcg: {
        channels: 3,
        labels: [
            "h",
            "c",
            "g"
        ]
    },
    apple: {
        channels: 3,
        labels: [
            "r16",
            "g16",
            "b16"
        ]
    },
    gray: {
        channels: 1,
        labels: [
            "gray"
        ]
    }
};
$87010999ebf2f889$exports = $87010999ebf2f889$var$convert;
// Hide .channels and .labels properties
for (const model of Object.keys($87010999ebf2f889$var$convert)){
    if (!("channels" in $87010999ebf2f889$var$convert[model])) throw new Error("missing channels property: " + model);
    if (!("labels" in $87010999ebf2f889$var$convert[model])) throw new Error("missing channel labels property: " + model);
    if ($87010999ebf2f889$var$convert[model].labels.length !== $87010999ebf2f889$var$convert[model].channels) throw new Error("channel and label counts mismatch: " + model);
    const { channels: channels, labels: labels } = $87010999ebf2f889$var$convert[model];
    delete $87010999ebf2f889$var$convert[model].channels;
    delete $87010999ebf2f889$var$convert[model].labels;
    Object.defineProperty($87010999ebf2f889$var$convert[model], "channels", {
        value: channels
    });
    Object.defineProperty($87010999ebf2f889$var$convert[model], "labels", {
        value: labels
    });
}
$87010999ebf2f889$var$convert.rgb.hsl = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const min = Math.min(r, g, b);
    const max = Math.max(r, g, b);
    const delta = max - min;
    let h;
    let s;
    if (max === min) h = 0;
    else if (r === max) h = (g - b) / delta;
    else if (g === max) h = 2 + (b - r) / delta;
    else if (b === max) h = 4 + (r - g) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    const l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
};
$87010999ebf2f889$var$convert.rgb.hsv = function(rgb) {
    let rdif;
    let gdif;
    let bdif;
    let h;
    let s;
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const v = Math.max(r, g, b);
    const diff = v - Math.min(r, g, b);
    const diffc = function(c) {
        return (v - c) / 6 / diff + 0.5;
    };
    if (diff === 0) {
        h = 0;
        s = 0;
    } else {
        s = diff / v;
        rdif = diffc(r);
        gdif = diffc(g);
        bdif = diffc(b);
        if (r === v) h = bdif - gdif;
        else if (g === v) h = 1 / 3 + rdif - bdif;
        else if (b === v) h = 2 / 3 + gdif - rdif;
        if (h < 0) h += 1;
        else if (h > 1) h -= 1;
    }
    return [
        h * 360,
        s * 100,
        v * 100
    ];
};
$87010999ebf2f889$var$convert.rgb.hwb = function(rgb) {
    const r = rgb[0];
    const g = rgb[1];
    let b = rgb[2];
    const h = $87010999ebf2f889$var$convert.rgb.hsl(rgb)[0];
    const w = 1 / 255 * Math.min(r, Math.min(g, b));
    b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
    return [
        h,
        w * 100,
        b * 100
    ];
};
$87010999ebf2f889$var$convert.rgb.cmyk = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const k = Math.min(1 - r, 1 - g, 1 - b);
    const c = (1 - r - k) / (1 - k) || 0;
    const m = (1 - g - k) / (1 - k) || 0;
    const y = (1 - b - k) / (1 - k) || 0;
    return [
        c * 100,
        m * 100,
        y * 100,
        k * 100
    ];
};
function $87010999ebf2f889$var$comparativeDistance(x, y) {
    /*
		See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	*/ return (x[0] - y[0]) ** 2 + (x[1] - y[1]) ** 2 + (x[2] - y[2]) ** 2;
}
$87010999ebf2f889$var$convert.rgb.keyword = function(rgb) {
    const reversed = $87010999ebf2f889$var$reverseKeywords[rgb];
    if (reversed) return reversed;
    let currentClosestDistance = Infinity;
    let currentClosestKeyword;
    for (const keyword of Object.keys($e81b4034aa9db203$exports)){
        const value = $e81b4034aa9db203$exports[keyword];
        // Compute comparative distance
        const distance = $87010999ebf2f889$var$comparativeDistance(rgb, value);
        // Check if its less, if so set as closest
        if (distance < currentClosestDistance) {
            currentClosestDistance = distance;
            currentClosestKeyword = keyword;
        }
    }
    return currentClosestKeyword;
};
$87010999ebf2f889$var$convert.keyword.rgb = function(keyword) {
    return $e81b4034aa9db203$exports[keyword];
};
$87010999ebf2f889$var$convert.rgb.xyz = function(rgb) {
    let r = rgb[0] / 255;
    let g = rgb[1] / 255;
    let b = rgb[2] / 255;
    // Assume sRGB
    r = r > 0.04045 ? ((r + 0.055) / 1.055) ** 2.4 : r / 12.92;
    g = g > 0.04045 ? ((g + 0.055) / 1.055) ** 2.4 : g / 12.92;
    b = b > 0.04045 ? ((b + 0.055) / 1.055) ** 2.4 : b / 12.92;
    const x = r * 0.4124 + g * 0.3576 + b * 0.1805;
    const y = r * 0.2126 + g * 0.7152 + b * 0.0722;
    const z = r * 0.0193 + g * 0.1192 + b * 0.9505;
    return [
        x * 100,
        y * 100,
        z * 100
    ];
};
$87010999ebf2f889$var$convert.rgb.lab = function(rgb) {
    const xyz = $87010999ebf2f889$var$convert.rgb.xyz(rgb);
    let x = xyz[0];
    let y = xyz[1];
    let z = xyz[2];
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? x ** (1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? z ** (1 / 3) : 7.787 * z + 16 / 116;
    const l = 116 * y - 16;
    const a = 500 * (x - y);
    const b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$87010999ebf2f889$var$convert.hsl.rgb = function(hsl) {
    const h = hsl[0] / 360;
    const s = hsl[1] / 100;
    const l = hsl[2] / 100;
    let t2;
    let t3;
    let val;
    if (s === 0) {
        val = l * 255;
        return [
            val,
            val,
            val
        ];
    }
    if (l < 0.5) t2 = l * (1 + s);
    else t2 = l + s - l * s;
    const t1 = 2 * l - t2;
    const rgb = [
        0,
        0,
        0
    ];
    for(let i = 0; i < 3; i++){
        t3 = h + 1 / 3 * -(i - 1);
        if (t3 < 0) t3++;
        if (t3 > 1) t3--;
        if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
        else if (2 * t3 < 1) val = t2;
        else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        else val = t1;
        rgb[i] = val * 255;
    }
    return rgb;
};
$87010999ebf2f889$var$convert.hsl.hsv = function(hsl) {
    const h = hsl[0];
    let s = hsl[1] / 100;
    let l = hsl[2] / 100;
    let smin = s;
    const lmin = Math.max(l, 0.01);
    l *= 2;
    s *= l <= 1 ? l : 2 - l;
    smin *= lmin <= 1 ? lmin : 2 - lmin;
    const v = (l + s) / 2;
    const sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
    return [
        h,
        sv * 100,
        v * 100
    ];
};
$87010999ebf2f889$var$convert.hsv.rgb = function(hsv) {
    const h = hsv[0] / 60;
    const s = hsv[1] / 100;
    let v = hsv[2] / 100;
    const hi = Math.floor(h) % 6;
    const f = h - Math.floor(h);
    const p = 255 * v * (1 - s);
    const q = 255 * v * (1 - s * f);
    const t = 255 * v * (1 - s * (1 - f));
    v *= 255;
    switch(hi){
        case 0:
            return [
                v,
                t,
                p
            ];
        case 1:
            return [
                q,
                v,
                p
            ];
        case 2:
            return [
                p,
                v,
                t
            ];
        case 3:
            return [
                p,
                q,
                v
            ];
        case 4:
            return [
                t,
                p,
                v
            ];
        case 5:
            return [
                v,
                p,
                q
            ];
    }
};
$87010999ebf2f889$var$convert.hsv.hsl = function(hsv) {
    const h = hsv[0];
    const s = hsv[1] / 100;
    const v = hsv[2] / 100;
    const vmin = Math.max(v, 0.01);
    let sl;
    let l;
    l = (2 - s) * v;
    const lmin = (2 - s) * vmin;
    sl = s * vmin;
    sl /= lmin <= 1 ? lmin : 2 - lmin;
    sl = sl || 0;
    l /= 2;
    return [
        h,
        sl * 100,
        l * 100
    ];
};
// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
$87010999ebf2f889$var$convert.hwb.rgb = function(hwb) {
    const h = hwb[0] / 360;
    let wh = hwb[1] / 100;
    let bl = hwb[2] / 100;
    const ratio = wh + bl;
    let f;
    // Wh + bl cant be > 1
    if (ratio > 1) {
        wh /= ratio;
        bl /= ratio;
    }
    const i = Math.floor(6 * h);
    const v = 1 - bl;
    f = 6 * h - i;
    if ((i & 0x01) !== 0) f = 1 - f;
    const n = wh + f * (v - wh); // Linear interpolation
    let r;
    let g;
    let b;
    /* eslint-disable max-statements-per-line,no-multi-spaces */ switch(i){
        default:
        case 6:
        case 0:
            r = v;
            g = n;
            b = wh;
            break;
        case 1:
            r = n;
            g = v;
            b = wh;
            break;
        case 2:
            r = wh;
            g = v;
            b = n;
            break;
        case 3:
            r = wh;
            g = n;
            b = v;
            break;
        case 4:
            r = n;
            g = wh;
            b = v;
            break;
        case 5:
            r = v;
            g = wh;
            b = n;
            break;
    }
    /* eslint-enable max-statements-per-line,no-multi-spaces */ return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$87010999ebf2f889$var$convert.cmyk.rgb = function(cmyk) {
    const c = cmyk[0] / 100;
    const m = cmyk[1] / 100;
    const y = cmyk[2] / 100;
    const k = cmyk[3] / 100;
    const r = 1 - Math.min(1, c * (1 - k) + k);
    const g = 1 - Math.min(1, m * (1 - k) + k);
    const b = 1 - Math.min(1, y * (1 - k) + k);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$87010999ebf2f889$var$convert.xyz.rgb = function(xyz) {
    const x = xyz[0] / 100;
    const y = xyz[1] / 100;
    const z = xyz[2] / 100;
    let r;
    let g;
    let b;
    r = x * 3.2406 + y * -1.5372 + z * -0.4986;
    g = x * -0.9689 + y * 1.8758 + z * 0.0415;
    b = x * 0.0557 + y * -0.204 + z * 1.0570;
    // Assume sRGB
    r = r > 0.0031308 ? 1.055 * r ** (1.0 / 2.4) - 0.055 : r * 12.92;
    g = g > 0.0031308 ? 1.055 * g ** (1.0 / 2.4) - 0.055 : g * 12.92;
    b = b > 0.0031308 ? 1.055 * b ** (1.0 / 2.4) - 0.055 : b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$87010999ebf2f889$var$convert.xyz.lab = function(xyz) {
    let x = xyz[0];
    let y = xyz[1];
    let z = xyz[2];
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? x ** (1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? z ** (1 / 3) : 7.787 * z + 16 / 116;
    const l = 116 * y - 16;
    const a = 500 * (x - y);
    const b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$87010999ebf2f889$var$convert.lab.xyz = function(lab) {
    const l = lab[0];
    const a = lab[1];
    const b = lab[2];
    let x;
    let y;
    let z;
    y = (l + 16) / 116;
    x = a / 500 + y;
    z = y - b / 200;
    const y2 = y ** 3;
    const x2 = x ** 3;
    const z2 = z ** 3;
    y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
    x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
    z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
    x *= 95.047;
    y *= 100;
    z *= 108.883;
    return [
        x,
        y,
        z
    ];
};
$87010999ebf2f889$var$convert.lab.lch = function(lab) {
    const l = lab[0];
    const a = lab[1];
    const b = lab[2];
    let h;
    const hr = Math.atan2(b, a);
    h = hr * 360 / 2 / Math.PI;
    if (h < 0) h += 360;
    const c = Math.sqrt(a * a + b * b);
    return [
        l,
        c,
        h
    ];
};
$87010999ebf2f889$var$convert.lch.lab = function(lch) {
    const l = lch[0];
    const c = lch[1];
    const h = lch[2];
    const hr = h / 360 * 2 * Math.PI;
    const a = c * Math.cos(hr);
    const b = c * Math.sin(hr);
    return [
        l,
        a,
        b
    ];
};
$87010999ebf2f889$var$convert.rgb.ansi16 = function(args, saturation = null) {
    const [r, g, b] = args;
    let value = saturation === null ? $87010999ebf2f889$var$convert.rgb.hsv(args)[2] : saturation; // Hsv -> ansi16 optimization
    value = Math.round(value / 50);
    if (value === 0) return 30;
    let ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
    if (value === 2) ansi += 60;
    return ansi;
};
$87010999ebf2f889$var$convert.hsv.ansi16 = function(args) {
    // Optimization here; we already know the value and don't need to get
    // it converted for us.
    return $87010999ebf2f889$var$convert.rgb.ansi16($87010999ebf2f889$var$convert.hsv.rgb(args), args[2]);
};
$87010999ebf2f889$var$convert.rgb.ansi256 = function(args) {
    const r = args[0];
    const g = args[1];
    const b = args[2];
    // We use the extended greyscale palette here, with the exception of
    // black and white. normal palette only has 4 greyscale shades.
    if (r === g && g === b) {
        if (r < 8) return 16;
        if (r > 248) return 231;
        return Math.round((r - 8) / 247 * 24) + 232;
    }
    const ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
    return ansi;
};
$87010999ebf2f889$var$convert.ansi16.rgb = function(args) {
    let color = args % 10;
    // Handle greyscale
    if (color === 0 || color === 7) {
        if (args > 50) color += 3.5;
        color = color / 10.5 * 255;
        return [
            color,
            color,
            color
        ];
    }
    const mult = (~~(args > 50) + 1) * 0.5;
    const r = (color & 1) * mult * 255;
    const g = (color >> 1 & 1) * mult * 255;
    const b = (color >> 2 & 1) * mult * 255;
    return [
        r,
        g,
        b
    ];
};
$87010999ebf2f889$var$convert.ansi256.rgb = function(args) {
    // Handle greyscale
    if (args >= 232) {
        const c = (args - 232) * 10 + 8;
        return [
            c,
            c,
            c
        ];
    }
    args -= 16;
    let rem;
    const r = Math.floor(args / 36) / 5 * 255;
    const g = Math.floor((rem = args % 36) / 6) / 5 * 255;
    const b = rem % 6 / 5 * 255;
    return [
        r,
        g,
        b
    ];
};
$87010999ebf2f889$var$convert.rgb.hex = function(args) {
    const integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
    const string = integer.toString(16).toUpperCase();
    return "000000".substring(string.length) + string;
};
$87010999ebf2f889$var$convert.hex.rgb = function(args) {
    const match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!match) return [
        0,
        0,
        0
    ];
    let colorString = match[0];
    if (match[0].length === 3) colorString = colorString.split("").map((char)=>{
        return char + char;
    }).join("");
    const integer = parseInt(colorString, 16);
    const r = integer >> 16 & 0xFF;
    const g = integer >> 8 & 0xFF;
    const b = integer & 0xFF;
    return [
        r,
        g,
        b
    ];
};
$87010999ebf2f889$var$convert.rgb.hcg = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const max = Math.max(Math.max(r, g), b);
    const min = Math.min(Math.min(r, g), b);
    const chroma = max - min;
    let grayscale;
    let hue;
    if (chroma < 1) grayscale = min / (1 - chroma);
    else grayscale = 0;
    if (chroma <= 0) hue = 0;
    else if (max === r) hue = (g - b) / chroma % 6;
    else if (max === g) hue = 2 + (b - r) / chroma;
    else hue = 4 + (r - g) / chroma;
    hue /= 6;
    hue %= 1;
    return [
        hue * 360,
        chroma * 100,
        grayscale * 100
    ];
};
$87010999ebf2f889$var$convert.hsl.hcg = function(hsl) {
    const s = hsl[1] / 100;
    const l = hsl[2] / 100;
    const c = l < 0.5 ? 2.0 * s * l : 2.0 * s * (1.0 - l);
    let f = 0;
    if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
    return [
        hsl[0],
        c * 100,
        f * 100
    ];
};
$87010999ebf2f889$var$convert.hsv.hcg = function(hsv) {
    const s = hsv[1] / 100;
    const v = hsv[2] / 100;
    const c = s * v;
    let f = 0;
    if (c < 1.0) f = (v - c) / (1 - c);
    return [
        hsv[0],
        c * 100,
        f * 100
    ];
};
$87010999ebf2f889$var$convert.hcg.rgb = function(hcg) {
    const h = hcg[0] / 360;
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    if (c === 0.0) return [
        g * 255,
        g * 255,
        g * 255
    ];
    const pure = [
        0,
        0,
        0
    ];
    const hi = h % 1 * 6;
    const v = hi % 1;
    const w = 1 - v;
    let mg = 0;
    /* eslint-disable max-statements-per-line */ switch(Math.floor(hi)){
        case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
        case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
        case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
        case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
        case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
        default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
    }
    /* eslint-enable max-statements-per-line */ mg = (1.0 - c) * g;
    return [
        (c * pure[0] + mg) * 255,
        (c * pure[1] + mg) * 255,
        (c * pure[2] + mg) * 255
    ];
};
$87010999ebf2f889$var$convert.hcg.hsv = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const v = c + g * (1.0 - c);
    let f = 0;
    if (v > 0.0) f = c / v;
    return [
        hcg[0],
        f * 100,
        v * 100
    ];
};
$87010999ebf2f889$var$convert.hcg.hsl = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const l = g * (1.0 - c) + 0.5 * c;
    let s = 0;
    if (l > 0.0 && l < 0.5) s = c / (2 * l);
    else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
    return [
        hcg[0],
        s * 100,
        l * 100
    ];
};
$87010999ebf2f889$var$convert.hcg.hwb = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const v = c + g * (1.0 - c);
    return [
        hcg[0],
        (v - c) * 100,
        (1 - v) * 100
    ];
};
$87010999ebf2f889$var$convert.hwb.hcg = function(hwb) {
    const w = hwb[1] / 100;
    const b = hwb[2] / 100;
    const v = 1 - b;
    const c = v - w;
    let g = 0;
    if (c < 1) g = (v - c) / (1 - c);
    return [
        hwb[0],
        c * 100,
        g * 100
    ];
};
$87010999ebf2f889$var$convert.apple.rgb = function(apple) {
    return [
        apple[0] / 65535 * 255,
        apple[1] / 65535 * 255,
        apple[2] / 65535 * 255
    ];
};
$87010999ebf2f889$var$convert.rgb.apple = function(rgb) {
    return [
        rgb[0] / 255 * 65535,
        rgb[1] / 255 * 65535,
        rgb[2] / 255 * 65535
    ];
};
$87010999ebf2f889$var$convert.gray.rgb = function(args) {
    return [
        args[0] / 100 * 255,
        args[0] / 100 * 255,
        args[0] / 100 * 255
    ];
};
$87010999ebf2f889$var$convert.gray.hsl = function(args) {
    return [
        0,
        0,
        args[0]
    ];
};
$87010999ebf2f889$var$convert.gray.hsv = $87010999ebf2f889$var$convert.gray.hsl;
$87010999ebf2f889$var$convert.gray.hwb = function(gray) {
    return [
        0,
        100,
        gray[0]
    ];
};
$87010999ebf2f889$var$convert.gray.cmyk = function(gray) {
    return [
        0,
        0,
        0,
        gray[0]
    ];
};
$87010999ebf2f889$var$convert.gray.lab = function(gray) {
    return [
        gray[0],
        0,
        0
    ];
};
$87010999ebf2f889$var$convert.gray.hex = function(gray) {
    const val = Math.round(gray[0] / 100 * 255) & 0xFF;
    const integer = (val << 16) + (val << 8) + val;
    const string = integer.toString(16).toUpperCase();
    return "000000".substring(string.length) + string;
};
$87010999ebf2f889$var$convert.rgb.gray = function(rgb) {
    const val = (rgb[0] + rgb[1] + rgb[2]) / 3;
    return [
        val / 255 * 100
    ];
};


var $303e9ffbb6f2ff34$exports = {};

/*
	This function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function $303e9ffbb6f2ff34$var$buildGraph() {
    const graph = {};
    // https://jsperf.com/object-keys-vs-for-in-with-closure/3
    const models = Object.keys($87010999ebf2f889$exports);
    for(let len = models.length, i = 0; i < len; i++)graph[models[i]] = {
        // http://jsperf.com/1-vs-infinity
        // micro-opt, but this is simple.
        distance: -1,
        parent: null
    };
    return graph;
}
// https://en.wikipedia.org/wiki/Breadth-first_search
function $303e9ffbb6f2ff34$var$deriveBFS(fromModel) {
    const graph = $303e9ffbb6f2ff34$var$buildGraph();
    const queue = [
        fromModel
    ]; // Unshift -> queue -> pop
    graph[fromModel].distance = 0;
    while(queue.length){
        const current = queue.pop();
        const adjacents = Object.keys($87010999ebf2f889$exports[current]);
        for(let len = adjacents.length, i = 0; i < len; i++){
            const adjacent = adjacents[i];
            const node = graph[adjacent];
            if (node.distance === -1) {
                node.distance = graph[current].distance + 1;
                node.parent = current;
                queue.unshift(adjacent);
            }
        }
    }
    return graph;
}
function $303e9ffbb6f2ff34$var$link(from, to) {
    return function(args) {
        return to(from(args));
    };
}
function $303e9ffbb6f2ff34$var$wrapConversion(toModel, graph) {
    const path = [
        graph[toModel].parent,
        toModel
    ];
    let fn = $87010999ebf2f889$exports[graph[toModel].parent][toModel];
    let cur = graph[toModel].parent;
    while(graph[cur].parent){
        path.unshift(graph[cur].parent);
        fn = $303e9ffbb6f2ff34$var$link($87010999ebf2f889$exports[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
    }
    fn.conversion = path;
    return fn;
}
$303e9ffbb6f2ff34$exports = function(fromModel) {
    const graph = $303e9ffbb6f2ff34$var$deriveBFS(fromModel);
    const conversion = {};
    const models = Object.keys(graph);
    for(let len = models.length, i = 0; i < len; i++){
        const toModel = models[i];
        const node = graph[toModel];
        if (node.parent === null) continue;
        conversion[toModel] = $303e9ffbb6f2ff34$var$wrapConversion(toModel, graph);
    }
    return conversion;
};


const $ce5238844c992f76$var$convert = {};
const $ce5238844c992f76$var$models = Object.keys($87010999ebf2f889$exports);
function $ce5238844c992f76$var$wrapRaw(fn) {
    const wrappedFn = function(...args) {
        const arg0 = args[0];
        if (arg0 === undefined || arg0 === null) return arg0;
        if (arg0.length > 1) args = arg0;
        return fn(args);
    };
    // Preserve .conversion property if there is one
    if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
function $ce5238844c992f76$var$wrapRounded(fn) {
    const wrappedFn = function(...args) {
        const arg0 = args[0];
        if (arg0 === undefined || arg0 === null) return arg0;
        if (arg0.length > 1) args = arg0;
        const result = fn(args);
        // We're assuming the result is an array here.
        // see notice in conversions.js; don't use box types
        // in conversion functions.
        if (typeof result === "object") for(let len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
        return result;
    };
    // Preserve .conversion property if there is one
    if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
$ce5238844c992f76$var$models.forEach((fromModel)=>{
    $ce5238844c992f76$var$convert[fromModel] = {};
    Object.defineProperty($ce5238844c992f76$var$convert[fromModel], "channels", {
        value: $87010999ebf2f889$exports[fromModel].channels
    });
    Object.defineProperty($ce5238844c992f76$var$convert[fromModel], "labels", {
        value: $87010999ebf2f889$exports[fromModel].labels
    });
    const routes = $303e9ffbb6f2ff34$exports(fromModel);
    const routeModels = Object.keys(routes);
    routeModels.forEach((toModel)=>{
        const fn = routes[toModel];
        $ce5238844c992f76$var$convert[fromModel][toModel] = $ce5238844c992f76$var$wrapRounded(fn);
        $ce5238844c992f76$var$convert[fromModel][toModel].raw = $ce5238844c992f76$var$wrapRaw(fn);
    });
});
$ce5238844c992f76$exports = $ce5238844c992f76$var$convert;


const $08acccbbd431ef55$var$skippedModels = [
    // To be honest, I don't really feel like keyword belongs in color convert, but eh.
    "keyword",
    // Gray conflicts with some method names, and has its own method defined.
    "gray",
    // Shouldn't really be in color-convert either...
    "hex"
];
const $08acccbbd431ef55$var$hashedModelKeys = {};
for (const model of Object.keys($ce5238844c992f76$exports))$08acccbbd431ef55$var$hashedModelKeys[[
    ...$ce5238844c992f76$exports[model].labels
].sort().join("")] = model;
const $08acccbbd431ef55$var$limiters = {};
function $08acccbbd431ef55$var$Color(object, model) {
    if (!(this instanceof $08acccbbd431ef55$var$Color)) return new $08acccbbd431ef55$var$Color(object, model);
    if (model && model in $08acccbbd431ef55$var$skippedModels) model = null;
    if (model && !(model in $ce5238844c992f76$exports)) throw new Error("Unknown model: " + model);
    let i;
    let channels;
    if (object == null) {
        this.model = "rgb";
        this.color = [
            0,
            0,
            0
        ];
        this.valpha = 1;
    } else if (object instanceof $08acccbbd431ef55$var$Color) {
        this.model = object.model;
        this.color = [
            ...object.color
        ];
        this.valpha = object.valpha;
    } else if (typeof object === "string") {
        const result = $86e889c881e89501$exports.get(object);
        if (result === null) throw new Error("Unable to parse color from string: " + object);
        this.model = result.model;
        channels = $ce5238844c992f76$exports[this.model].channels;
        this.color = result.value.slice(0, channels);
        this.valpha = typeof result.value[channels] === "number" ? result.value[channels] : 1;
    } else if (object.length > 0) {
        this.model = model || "rgb";
        channels = $ce5238844c992f76$exports[this.model].channels;
        const newArray = Array.prototype.slice.call(object, 0, channels);
        this.color = $08acccbbd431ef55$var$zeroArray(newArray, channels);
        this.valpha = typeof object[channels] === "number" ? object[channels] : 1;
    } else if (typeof object === "number") {
        // This is always RGB - can be converted later on.
        this.model = "rgb";
        this.color = [
            object >> 16 & 0xFF,
            object >> 8 & 0xFF,
            object & 0xFF
        ];
        this.valpha = 1;
    } else {
        this.valpha = 1;
        const keys = Object.keys(object);
        if ("alpha" in object) {
            keys.splice(keys.indexOf("alpha"), 1);
            this.valpha = typeof object.alpha === "number" ? object.alpha : 0;
        }
        const hashedKeys = keys.sort().join("");
        if (!(hashedKeys in $08acccbbd431ef55$var$hashedModelKeys)) throw new Error("Unable to parse color from object: " + JSON.stringify(object));
        this.model = $08acccbbd431ef55$var$hashedModelKeys[hashedKeys];
        const { labels: labels } = $ce5238844c992f76$exports[this.model];
        const color = [];
        for(i = 0; i < labels.length; i++)color.push(object[labels[i]]);
        this.color = $08acccbbd431ef55$var$zeroArray(color);
    }
    // Perform limitations (clamping, etc.)
    if ($08acccbbd431ef55$var$limiters[this.model]) {
        channels = $ce5238844c992f76$exports[this.model].channels;
        for(i = 0; i < channels; i++){
            const limit = $08acccbbd431ef55$var$limiters[this.model][i];
            if (limit) this.color[i] = limit(this.color[i]);
        }
    }
    this.valpha = Math.max(0, Math.min(1, this.valpha));
    if (Object.freeze) Object.freeze(this);
}
$08acccbbd431ef55$var$Color.prototype = {
    toString () {
        return this.string();
    },
    toJSON () {
        return this[this.model]();
    },
    string (places) {
        let self = this.model in $86e889c881e89501$exports.to ? this : this.rgb();
        self = self.round(typeof places === "number" ? places : 1);
        const args = self.valpha === 1 ? self.color : [
            ...self.color,
            this.valpha
        ];
        return $86e889c881e89501$exports.to[self.model](args);
    },
    percentString (places) {
        const self = this.rgb().round(typeof places === "number" ? places : 1);
        const args = self.valpha === 1 ? self.color : [
            ...self.color,
            this.valpha
        ];
        return $86e889c881e89501$exports.to.rgb.percent(args);
    },
    array () {
        return this.valpha === 1 ? [
            ...this.color
        ] : [
            ...this.color,
            this.valpha
        ];
    },
    object () {
        const result = {};
        const { channels: channels } = $ce5238844c992f76$exports[this.model];
        const { labels: labels } = $ce5238844c992f76$exports[this.model];
        for(let i = 0; i < channels; i++)result[labels[i]] = this.color[i];
        if (this.valpha !== 1) result.alpha = this.valpha;
        return result;
    },
    unitArray () {
        const rgb = this.rgb().color;
        rgb[0] /= 255;
        rgb[1] /= 255;
        rgb[2] /= 255;
        if (this.valpha !== 1) rgb.push(this.valpha);
        return rgb;
    },
    unitObject () {
        const rgb = this.rgb().object();
        rgb.r /= 255;
        rgb.g /= 255;
        rgb.b /= 255;
        if (this.valpha !== 1) rgb.alpha = this.valpha;
        return rgb;
    },
    round (places) {
        places = Math.max(places || 0, 0);
        return new $08acccbbd431ef55$var$Color([
            ...this.color.map($08acccbbd431ef55$var$roundToPlace(places)),
            this.valpha
        ], this.model);
    },
    alpha (value) {
        if (value !== undefined) return new $08acccbbd431ef55$var$Color([
            ...this.color,
            Math.max(0, Math.min(1, value))
        ], this.model);
        return this.valpha;
    },
    // Rgb
    red: $08acccbbd431ef55$var$getset("rgb", 0, $08acccbbd431ef55$var$maxfn(255)),
    green: $08acccbbd431ef55$var$getset("rgb", 1, $08acccbbd431ef55$var$maxfn(255)),
    blue: $08acccbbd431ef55$var$getset("rgb", 2, $08acccbbd431ef55$var$maxfn(255)),
    hue: $08acccbbd431ef55$var$getset([
        "hsl",
        "hsv",
        "hsl",
        "hwb",
        "hcg"
    ], 0, (value)=>(value % 360 + 360) % 360),
    saturationl: $08acccbbd431ef55$var$getset("hsl", 1, $08acccbbd431ef55$var$maxfn(100)),
    lightness: $08acccbbd431ef55$var$getset("hsl", 2, $08acccbbd431ef55$var$maxfn(100)),
    saturationv: $08acccbbd431ef55$var$getset("hsv", 1, $08acccbbd431ef55$var$maxfn(100)),
    value: $08acccbbd431ef55$var$getset("hsv", 2, $08acccbbd431ef55$var$maxfn(100)),
    chroma: $08acccbbd431ef55$var$getset("hcg", 1, $08acccbbd431ef55$var$maxfn(100)),
    gray: $08acccbbd431ef55$var$getset("hcg", 2, $08acccbbd431ef55$var$maxfn(100)),
    white: $08acccbbd431ef55$var$getset("hwb", 1, $08acccbbd431ef55$var$maxfn(100)),
    wblack: $08acccbbd431ef55$var$getset("hwb", 2, $08acccbbd431ef55$var$maxfn(100)),
    cyan: $08acccbbd431ef55$var$getset("cmyk", 0, $08acccbbd431ef55$var$maxfn(100)),
    magenta: $08acccbbd431ef55$var$getset("cmyk", 1, $08acccbbd431ef55$var$maxfn(100)),
    yellow: $08acccbbd431ef55$var$getset("cmyk", 2, $08acccbbd431ef55$var$maxfn(100)),
    black: $08acccbbd431ef55$var$getset("cmyk", 3, $08acccbbd431ef55$var$maxfn(100)),
    x: $08acccbbd431ef55$var$getset("xyz", 0, $08acccbbd431ef55$var$maxfn(95.047)),
    y: $08acccbbd431ef55$var$getset("xyz", 1, $08acccbbd431ef55$var$maxfn(100)),
    z: $08acccbbd431ef55$var$getset("xyz", 2, $08acccbbd431ef55$var$maxfn(108.833)),
    l: $08acccbbd431ef55$var$getset("lab", 0, $08acccbbd431ef55$var$maxfn(100)),
    a: $08acccbbd431ef55$var$getset("lab", 1),
    b: $08acccbbd431ef55$var$getset("lab", 2),
    keyword (value) {
        if (value !== undefined) return new $08acccbbd431ef55$var$Color(value);
        return $ce5238844c992f76$exports[this.model].keyword(this.color);
    },
    hex (value) {
        if (value !== undefined) return new $08acccbbd431ef55$var$Color(value);
        return $86e889c881e89501$exports.to.hex(this.rgb().round().color);
    },
    hexa (value) {
        if (value !== undefined) return new $08acccbbd431ef55$var$Color(value);
        const rgbArray = this.rgb().round().color;
        let alphaHex = Math.round(this.valpha * 255).toString(16).toUpperCase();
        if (alphaHex.length === 1) alphaHex = "0" + alphaHex;
        return $86e889c881e89501$exports.to.hex(rgbArray) + alphaHex;
    },
    rgbNumber () {
        const rgb = this.rgb().color;
        return (rgb[0] & 0xFF) << 16 | (rgb[1] & 0xFF) << 8 | rgb[2] & 0xFF;
    },
    luminosity () {
        // http://www.w3.org/TR/WCAG20/#relativeluminancedef
        const rgb = this.rgb().color;
        const lum = [];
        for (const [i, element] of rgb.entries()){
            const chan = element / 255;
            lum[i] = chan <= 0.04045 ? chan / 12.92 : ((chan + 0.055) / 1.055) ** 2.4;
        }
        return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
    },
    contrast (color2) {
        // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
        const lum1 = this.luminosity();
        const lum2 = color2.luminosity();
        if (lum1 > lum2) return (lum1 + 0.05) / (lum2 + 0.05);
        return (lum2 + 0.05) / (lum1 + 0.05);
    },
    level (color2) {
        // https://www.w3.org/TR/WCAG/#contrast-enhanced
        const contrastRatio = this.contrast(color2);
        if (contrastRatio >= 7) return "AAA";
        return contrastRatio >= 4.5 ? "AA" : "";
    },
    isDark () {
        // YIQ equation from http://24ways.org/2010/calculating-color-contrast
        const rgb = this.rgb().color;
        const yiq = (rgb[0] * 2126 + rgb[1] * 7152 + rgb[2] * 722) / 10000;
        return yiq < 128;
    },
    isLight () {
        return !this.isDark();
    },
    negate () {
        const rgb = this.rgb();
        for(let i = 0; i < 3; i++)rgb.color[i] = 255 - rgb.color[i];
        return rgb;
    },
    lighten (ratio) {
        const hsl = this.hsl();
        hsl.color[2] += hsl.color[2] * ratio;
        return hsl;
    },
    darken (ratio) {
        const hsl = this.hsl();
        hsl.color[2] -= hsl.color[2] * ratio;
        return hsl;
    },
    saturate (ratio) {
        const hsl = this.hsl();
        hsl.color[1] += hsl.color[1] * ratio;
        return hsl;
    },
    desaturate (ratio) {
        const hsl = this.hsl();
        hsl.color[1] -= hsl.color[1] * ratio;
        return hsl;
    },
    whiten (ratio) {
        const hwb = this.hwb();
        hwb.color[1] += hwb.color[1] * ratio;
        return hwb;
    },
    blacken (ratio) {
        const hwb = this.hwb();
        hwb.color[2] += hwb.color[2] * ratio;
        return hwb;
    },
    grayscale () {
        // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
        const rgb = this.rgb().color;
        const value = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
        return $08acccbbd431ef55$var$Color.rgb(value, value, value);
    },
    fade (ratio) {
        return this.alpha(this.valpha - this.valpha * ratio);
    },
    opaquer (ratio) {
        return this.alpha(this.valpha + this.valpha * ratio);
    },
    rotate (degrees) {
        const hsl = this.hsl();
        let hue = hsl.color[0];
        hue = (hue + degrees) % 360;
        hue = hue < 0 ? 360 + hue : hue;
        hsl.color[0] = hue;
        return hsl;
    },
    mix (mixinColor, weight) {
        // Ported from sass implementation in C
        // https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
        if (!mixinColor || !mixinColor.rgb) throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof mixinColor);
        const color1 = mixinColor.rgb();
        const color2 = this.rgb();
        const p = weight === undefined ? 0.5 : weight;
        const w = 2 * p - 1;
        const a = color1.alpha() - color2.alpha();
        const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2;
        const w2 = 1 - w1;
        return $08acccbbd431ef55$var$Color.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue(), color1.alpha() * p + color2.alpha() * (1 - p));
    }
};
// Model conversion methods and static constructors
for (const model of Object.keys($ce5238844c992f76$exports)){
    if ($08acccbbd431ef55$var$skippedModels.includes(model)) continue;
    const { channels: channels } = $ce5238844c992f76$exports[model];
    // Conversion methods
    $08acccbbd431ef55$var$Color.prototype[model] = function(...args) {
        if (this.model === model) return new $08acccbbd431ef55$var$Color(this);
        if (args.length > 0) return new $08acccbbd431ef55$var$Color(args, model);
        return new $08acccbbd431ef55$var$Color([
            ...$08acccbbd431ef55$var$assertArray($ce5238844c992f76$exports[this.model][model].raw(this.color)),
            this.valpha
        ], model);
    };
    // 'static' construction methods
    $08acccbbd431ef55$var$Color[model] = function(...args) {
        let color = args[0];
        if (typeof color === "number") color = $08acccbbd431ef55$var$zeroArray(args, channels);
        return new $08acccbbd431ef55$var$Color(color, model);
    };
}
function $08acccbbd431ef55$var$roundTo(number, places) {
    return Number(number.toFixed(places));
}
function $08acccbbd431ef55$var$roundToPlace(places) {
    return function(number) {
        return $08acccbbd431ef55$var$roundTo(number, places);
    };
}
function $08acccbbd431ef55$var$getset(model, channel, modifier) {
    model = Array.isArray(model) ? model : [
        model
    ];
    for (const m of model)($08acccbbd431ef55$var$limiters[m] || ($08acccbbd431ef55$var$limiters[m] = []))[channel] = modifier;
    model = model[0];
    return function(value) {
        let result;
        if (value !== undefined) {
            if (modifier) value = modifier(value);
            result = this[model]();
            result.color[channel] = value;
            return result;
        }
        result = this[model]().color[channel];
        if (modifier) result = modifier(result);
        return result;
    };
}
function $08acccbbd431ef55$var$maxfn(max) {
    return function(v) {
        return Math.max(0, Math.min(max, v));
    };
}
function $08acccbbd431ef55$var$assertArray(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function $08acccbbd431ef55$var$zeroArray(array, length) {
    for(let i = 0; i < length; i++)if (typeof array[i] !== "number") array[i] = 0;
    return array;
}
$08acccbbd431ef55$exports = $08acccbbd431ef55$var$Color;


const $8e558191fa5d9039$var$Properties = {
    textColor: {
        label: "Text Gradient",
        propertyType: "gradientColor"
    },
    bgColor: {
        label: "Backdrop",
        propertyType: "color"
    }
};
const $8e558191fa5d9039$export$ca7fd5b4e71f0314 = {
    properties: $8e558191fa5d9039$var$Properties
};
function $8e558191fa5d9039$export$9e55ed472774ecc() {
    return {
        textColor: [
            "#6366f1",
            "#ec4899"
        ],
        bgColor: "#000000"
    };
}
function $8e558191fa5d9039$export$a83b925d7ca6d647({ values: values, phrases: phrases }) {
    const textGradientColors = values.textColor;
    const bgColor = values.bgColor;
    if (!textGradientColors || !bgColor) {
        console.error("Missing required options");
        return null;
    }
    const bgRgb = (0, $acw62.useMemo)(()=>{
        const rgb = (0, (/*@__PURE__*/$parcel$interopDefault($08acccbbd431ef55$exports)))(bgColor).rgb().array();
        if (!rgb) {
            console.error("Invalid bg color");
            return null;
        }
        return rgb;
    }, [
        bgColor
    ]);
    const bgFromRgba = `rgba(${bgRgb?.join(", ")}, 1)`;
    const bgViaRgba = `rgba(${bgRgb?.join(", ")}, 0.75)`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $41780d10c43e3168$export$94253674da513666), {
        sequences: phrases,
        rootClassName: "",
        sequenceTextClassName: "text-center px-10 py-10 rounded-[32px] leading-[1.2] bg-gradient-to-r bg-clip-text text-transparent",
        sequenceTextStyles: {
            // @ts-ignore
            "--tw-gradient-from": textGradientColors[0],
            // @ts-ignore
            "--tw-gradient-to": textGradientColors[1],
            // @ts-ignore
            "--tw-gradient-stops": `var(--tw-gradient-from), var(--tw-gradient-to)`
        },
        wrapperClassName: "px-8 py-64 bg-gradient-to-t via-80% to-transparent",
        wrapperStyles: {
            // @ts-ignore
            "--tw-gradient-from": bgFromRgba,
            // @ts-ignore
            "--tw-gradient-stops": `var(--tw-gradient-from), ${bgViaRgba} var(--tw-gradient-via-position), var(--tw-gradient-to)`
        },
        renderWord: (word, index, highlighted, show)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "whitespace-pre-wrap",
                style: {
                    fontFamily: `"Barlow"`,
                    fontWeight: 800,
                    fontOpticalSizing: "auto",
                    fontSize: 120,
                    letterSpacing: 2,
                    opacity: show ? 1 : 0
                },
                children: [
                    word.text,
                    " "
                ]
            }, index)
    });
}





var $acw62 = parcelRequire("acw62");

const $c0c51aee348d40ff$var$Properties = {
    textColor: {
        label: "Text",
        propertyType: "color"
    },
    highlightColor: {
        label: "Highlighted Text",
        propertyType: "color"
    },
    shadowColor: {
        label: "Shadow",
        propertyType: "color"
    }
};
const $c0c51aee348d40ff$export$273d937c02a914bf = {
    properties: $c0c51aee348d40ff$var$Properties
};
function $c0c51aee348d40ff$export$a19c1678a6ae2700() {
    return {
        textColor: "#1D3557",
        highlightColor: "#E63946",
        shadowColor: "#FFC8DD"
    };
}
function $c0c51aee348d40ff$export$dfe310eb02c9d1db({ values: values, phrases: phrases }) {
    const textColor = values.textColor;
    const highlightColor = values.highlightColor;
    const shadowColor = values.shadowColor;
    if (!textColor || !highlightColor || !shadowColor) {
        console.error("Missing required options");
        return null;
    }
    const shadowRgb = (0, $acw62.useMemo)(()=>{
        const rgb = (0, (/*@__PURE__*/$parcel$interopDefault($08acccbbd431ef55$exports)))(shadowColor).rgb().array();
        if (!rgb) {
            console.error("Invalid shadow color");
            return null;
        }
        return rgb;
    }, [
        shadowColor
    ]);
    const textStrokeColor = `rgba(${shadowRgb?.join(", ")}, 1)`;
    const dropShadowColor = `rgba(${shadowRgb?.join(", ")}, 0.5)`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $41780d10c43e3168$export$94253674da513666), {
        sequences: phrases,
        rootClassName: "px-8 py-16 pb-64",
        sequenceTextClassName: "text-center text-[72px] px-10 py-10 rounded-[32px] leading-[1.2]",
        renderWord: (word, index, highlighted)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                style: {
                    fontFamily: "Archivo Black",
                    fontSize: 96,
                    color: highlighted ? highlightColor : textColor,
                    WebkitTextStroke: `1px ${textStrokeColor}`,
                    // drop shadow
                    filter: new Array(2).fill(`drop-shadow(0px 0px 4px ${dropShadowColor})`).join(" ")
                },
                children: [
                    word.text,
                    " "
                ]
            }, index)
    });
}




const $c823805a912be76d$var$Properties = {
    textColor: {
        label: "Text",
        propertyType: "color"
    },
    highlightColor: {
        label: "Highlighted Text",
        propertyType: "color"
    },
    bgColor: {
        label: "Background",
        propertyType: "color"
    }
};
const $c823805a912be76d$export$92ef7f1a942ff30f = {
    properties: $c823805a912be76d$var$Properties
};
function $c823805a912be76d$export$83a1e5375c3904e9() {
    return {
        textColor: "#FE259B",
        highlightColor: "#25fe59",
        bgColor: "#2E101C"
    };
}
function $c823805a912be76d$export$6700a7728d8ba2f8({ values: values, phrases: phrases }) {
    const textColor = values.textColor;
    const highlightColor = values.highlightColor;
    const bgColor = values.bgColor;
    if (!textColor || !highlightColor || !bgColor) {
        console.error("Missing required options");
        return null;
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $41780d10c43e3168$export$94253674da513666), {
        sequences: phrases,
        rootClassName: "px-8 py-16 pb-64",
        sequenceTextClassName: "text-center text-[72px] px-10 py-10 rounded-[32px] leading-[1.2]",
        sequenceTextStyles: {
            backgroundColor: bgColor
        },
        renderWord: (word, index, highlighted)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "uppercase",
                style: {
                    fontFamily: "Poiret One",
                    fontSize: 120,
                    color: "#ffffff",
                    letterSpacing: 2,
                    WebkitTextStrokeColor: highlighted ? highlightColor : textColor,
                    WebkitTextStrokeWidth: "2px",
                    // drop shadow
                    filter: new Array(3).fill(`drop-shadow(0px 0px 3px ${highlighted ? highlightColor : textColor})`).join(" ")
                },
                children: [
                    word.text,
                    " "
                ]
            }, index)
    });
}





var $acw62 = parcelRequire("acw62");

const $a6679621264dc72f$var$Properties = {
    textColor: {
        label: "Text",
        propertyType: "color"
    },
    shadowColor: {
        label: "Shadow",
        propertyType: "color"
    }
};
const $a6679621264dc72f$export$1c6c09e05a97bd35 = {
    properties: $a6679621264dc72f$var$Properties
};
function $a6679621264dc72f$export$14a81b6eef97366() {
    return {
        textColor: "#cde6ff",
        shadowColor: "#093f55"
    };
}
function $a6679621264dc72f$export$ad7e046ee9c9c385({ values: values, phrases: phrases }) {
    const textColor = values.textColor;
    const shadowColor = values.shadowColor;
    if (!textColor || !shadowColor) {
        console.error("Missing required options");
        return null;
    }
    const shadowRgb = (0, $acw62.useMemo)(()=>{
        const rgb = (0, (/*@__PURE__*/$parcel$interopDefault($08acccbbd431ef55$exports)))(shadowColor).rgb().array();
        if (!rgb) {
            console.error("Invalid shadow color");
            return null;
        }
        return rgb;
    }, [
        shadowColor
    ]);
    const textShadowRgba = `rgba(${shadowRgb?.join(", ")}, 1)`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $41780d10c43e3168$export$94253674da513666), {
        sequences: phrases,
        rootClassName: "px-8 py-16 pb-64",
        sequenceTextClassName: "text-center px-10 py-10 rounded-[32px] leading-[1.2]",
        renderWord: (word, index, highlighted, show)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "inline-block whitespace-pre-wrap relative z-0",
                style: {
                    fontFamily: "Barlow",
                    fontWeight: 800,
                    fontOpticalSizing: "auto",
                    fontSize: 120,
                    color: textColor,
                    letterSpacing: 2,
                    opacity: show ? 1 : 0,
                    textShadow: show ? `5px 3px 3px ${textShadowRgba}` : "none"
                },
                children: [
                    word.text,
                    " "
                ]
            }, index)
    });
}





var $acw62 = parcelRequire("acw62");

const $36ebe6f60f0a80fa$var$Properties = {
    textColor: {
        label: "Text",
        propertyType: "color"
    },
    shadowColor: {
        label: "Shadow",
        propertyType: "color"
    }
};
const $36ebe6f60f0a80fa$export$cefd04fdd68bcb58 = {
    properties: $36ebe6f60f0a80fa$var$Properties
};
function $36ebe6f60f0a80fa$export$33831ab8ade33f65() {
    return {
        textColor: "#FDE157",
        shadowColor: "#000000"
    };
}
function $36ebe6f60f0a80fa$export$a9172feb8f71836({ values: values, phrases: phrases }) {
    const textColor = values.textColor;
    const shadowColor = values.shadowColor;
    if (!textColor || !shadowColor) {
        console.error("Missing required options");
        return null;
    }
    const shadowRgb = (0, $acw62.useMemo)(()=>{
        const rgb = (0, (/*@__PURE__*/$parcel$interopDefault($08acccbbd431ef55$exports)))(shadowColor).rgb().array();
        if (!rgb) {
            console.error("Invalid shadow color");
            return null;
        }
        return rgb;
    }, [
        shadowColor
    ]);
    const dropShadowColor = `rgba(${shadowRgb?.join(", ")}, 1)`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $41780d10c43e3168$export$94253674da513666), {
        sequences: phrases,
        rootClassName: "px-8 py-16 pb-64",
        sequenceTextClassName: "text-center text-[72px] px-10 py-10 rounded-[32px] leading-[1.2]",
        renderWord: (word, index, highlighted)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                style: {
                    fontFamily: "Josefin Sans",
                    fontSize: 96,
                    fontStyle: "italic",
                    fontWeight: 600,
                    color: textColor,
                    // drop shadow
                    filter: `drop-shadow(-1px 1px 0px ${dropShadowColor}) drop-shadow(-1px 1px 0px ${dropShadowColor}) drop-shadow(1px 4px 0px ${dropShadowColor}) drop-shadow(1px 1px 0px ${dropShadowColor}) drop-shadow(1px 1px 0px ${dropShadowColor})`
                },
                children: [
                    word.text,
                    " "
                ]
            }, index)
    });
}


var $a2e1df1105a0eae1$exports = {};
$a2e1df1105a0eae1$exports = new URL("1.fdfb8df6.webp", import.meta.url).toString();


var $64d6b21765523981$exports = {};
$64d6b21765523981$exports = new URL("2.38762f37.webp", import.meta.url).toString();


var $574429454924827d$exports = {};
$574429454924827d$exports = new URL("3.cb3cc22f.webp", import.meta.url).toString();


var $771191b3c2e77bc3$exports = {};
$771191b3c2e77bc3$exports = new URL("4.b4d32ae3.webp", import.meta.url).toString();


var $c3d78430f4960cde$exports = {};
$c3d78430f4960cde$exports = new URL("5.e3197081.webp", import.meta.url).toString();


var $ee8592e8b133aae5$exports = {};
$ee8592e8b133aae5$exports = new URL("6.a6e9d6f3.webp", import.meta.url).toString();


const $495938ea8e19aef5$var$BG_IMAGES = [
    new URL($a2e1df1105a0eae1$exports).toString(),
    new URL($64d6b21765523981$exports).toString(),
    new URL($574429454924827d$exports).toString(),
    new URL($771191b3c2e77bc3$exports).toString(),
    new URL($c3d78430f4960cde$exports).toString(),
    new URL($ee8592e8b133aae5$exports).toString()
];
var $c7f6e8e11a186bdc$exports = {};
$c7f6e8e11a186bdc$exports = new URL("faded-words.84c5d2ae.mp4", import.meta.url).toString();


var $f2ffd24c2bebd2e1$exports = {};
$f2ffd24c2bebd2e1$exports = new URL("faded-words.4b5b2c98.jpg", import.meta.url).toString();


var $7f478871bd90ef35$exports = {};
$7f478871bd90ef35$exports = new URL("slant-phrases.bcd7c8b4.mp4", import.meta.url).toString();


var $d86f9f9c7d092c6d$exports = {};
$d86f9f9c7d092c6d$exports = new URL("slant-phrases.c4f7645e.jpg", import.meta.url).toString();


var $1aaa89bf10ff5deb$exports = {};
$1aaa89bf10ff5deb$exports = new URL("neon-phrases-2.2c61694b.mp4", import.meta.url).toString();


var $3ba5fa89e87f9cf0$exports = {};
$3ba5fa89e87f9cf0$exports = new URL("neon-phrases-2.488d26b9.jpg", import.meta.url).toString();


var $bb7960f60bd52fc3$exports = {};
$bb7960f60bd52fc3$exports = new URL("basic-phrases.66bd453a.mp4", import.meta.url).toString();


var $ca20334260becd22$exports = {};
$ca20334260becd22$exports = new URL("basic-phrases.52ff8703.jpg", import.meta.url).toString();


var $33d943c8aa8f3051$exports = {};
$33d943c8aa8f3051$exports = new URL("gradient-phrases-words.2e305684.mp4", import.meta.url).toString();


var $4e5070745ba364f2$exports = {};
$4e5070745ba364f2$exports = new URL("gradient-phrases-words.034c1fa3.jpg", import.meta.url).toString();


var $5f8bebf789cc206d$exports = {};
$5f8bebf789cc206d$exports = new URL("neon-phrases.a61e054d.mp4", import.meta.url).toString();


var $b8176a176c719bd3$exports = {};
$b8176a176c719bd3$exports = new URL("neon-phrases.f34a4785.jpg", import.meta.url).toString();


var $156eb1bafa88374c$exports = {};
$156eb1bafa88374c$exports = new URL("shadow-phrases-words.dce7d8ff.mp4", import.meta.url).toString();


var $3a14eaa81403313b$exports = {};
$3a14eaa81403313b$exports = new URL("shadow-phrases-words.a0c431e4.jpg", import.meta.url).toString();


var $80191a660009bb38$exports = {};
$80191a660009bb38$exports = new URL("basic-phrases-words.cdbb4581.mp4", import.meta.url).toString();


var $fc6b080b70d10e77$exports = {};
$fc6b080b70d10e77$exports = new URL("basic-phrases-words.43926625.jpg", import.meta.url).toString();


const $495938ea8e19aef5$export$603deb0bff13d3bd = [
    {
        key: "faded-words",
        name: "Faded Words",
        spec: (0, $4a971e4684c493ae$export$c47a6cc342009543),
        component: (0, $4a971e4684c493ae$export$7480f237f2e384d0),
        defaultValues: (0, $4a971e4684c493ae$export$6f8da6070c48b4e9)(),
        bgImg: $495938ea8e19aef5$var$BG_IMAGES[1],
        bgPreviewVideo: {
            video: new URL($c7f6e8e11a186bdc$exports).toString(),
            poster: new URL($f2ffd24c2bebd2e1$exports).toString()
        }
    },
    {
        key: "slant-phrases",
        name: "Slant Phrases",
        spec: (0, $36ebe6f60f0a80fa$export$cefd04fdd68bcb58),
        component: (0, $36ebe6f60f0a80fa$export$a9172feb8f71836),
        defaultValues: (0, $36ebe6f60f0a80fa$export$33831ab8ade33f65)(),
        bgImg: $495938ea8e19aef5$var$BG_IMAGES[1],
        bgPreviewVideo: {
            video: new URL($7f478871bd90ef35$exports).toString(),
            poster: new URL($d86f9f9c7d092c6d$exports).toString()
        }
    },
    {
        key: "neon-phrases-2",
        name: "Neon Phrases 2",
        spec: (0, $c823805a912be76d$export$92ef7f1a942ff30f),
        component: (0, $c823805a912be76d$export$6700a7728d8ba2f8),
        defaultValues: (0, $c823805a912be76d$export$83a1e5375c3904e9)(),
        bgImg: $495938ea8e19aef5$var$BG_IMAGES[5],
        bgPreviewVideo: {
            video: new URL($1aaa89bf10ff5deb$exports).toString(),
            poster: new URL($3ba5fa89e87f9cf0$exports).toString()
        }
    },
    {
        key: "basic-phrases",
        name: "Basic Phrases",
        spec: (0, $eb028a7a6e843e1b$export$fb8333fa36e109e4),
        component: (0, $eb028a7a6e843e1b$export$7e433e842510d383),
        defaultValues: (0, $eb028a7a6e843e1b$export$7f2dde7b523257d1)(),
        bgImg: $495938ea8e19aef5$var$BG_IMAGES[3],
        bgPreviewVideo: {
            video: new URL($bb7960f60bd52fc3$exports).toString(),
            poster: new URL($ca20334260becd22$exports).toString()
        }
    },
    {
        key: "gradient-phrases-words",
        name: "Gradient Phrases Words",
        spec: (0, $8e558191fa5d9039$export$ca7fd5b4e71f0314),
        component: (0, $8e558191fa5d9039$export$a83b925d7ca6d647),
        defaultValues: (0, $8e558191fa5d9039$export$9e55ed472774ecc)(),
        bgImg: $495938ea8e19aef5$var$BG_IMAGES[3],
        bgPreviewVideo: {
            video: new URL($33d943c8aa8f3051$exports).toString(),
            poster: new URL($4e5070745ba364f2$exports).toString()
        }
    },
    {
        key: "neon-phrases",
        name: "Neon Phrases",
        spec: (0, $c0c51aee348d40ff$export$273d937c02a914bf),
        component: (0, $c0c51aee348d40ff$export$dfe310eb02c9d1db),
        defaultValues: (0, $c0c51aee348d40ff$export$a19c1678a6ae2700)(),
        bgImg: $495938ea8e19aef5$var$BG_IMAGES[4],
        bgPreviewVideo: {
            video: new URL($5f8bebf789cc206d$exports).toString(),
            poster: new URL($b8176a176c719bd3$exports).toString()
        }
    },
    {
        key: "shadow-phrases-words",
        name: "Shadow Phrases Words",
        spec: (0, $a6679621264dc72f$export$1c6c09e05a97bd35),
        component: (0, $a6679621264dc72f$export$ad7e046ee9c9c385),
        defaultValues: (0, $a6679621264dc72f$export$14a81b6eef97366)(),
        bgImg: $495938ea8e19aef5$var$BG_IMAGES[2],
        bgPreviewVideo: {
            video: new URL($156eb1bafa88374c$exports).toString(),
            poster: new URL($3a14eaa81403313b$exports).toString()
        }
    },
    {
        key: "basic-phrases-words",
        name: "Basic Phrases Words",
        spec: (0, $416685c10d8c626b$export$3271b405ff769db9),
        component: (0, $416685c10d8c626b$export$c776500face674d6),
        defaultValues: (0, $416685c10d8c626b$export$cfe86fe7e8620d40)(),
        bgImg: $495938ea8e19aef5$var$BG_IMAGES[1],
        bgPreviewVideo: {
            video: new URL($80191a660009bb38$exports).toString(),
            poster: new URL($fc6b080b70d10e77$exports).toString()
        }
    }
];
const $495938ea8e19aef5$export$e66ca54426df938 = $495938ea8e19aef5$export$603deb0bff13d3bd[0];


const $6738915eea69e49b$var$PHRASE_DURATION = 2000;
function $6738915eea69e49b$var$splitSentencesIntoPhrases(sentences) {
    const phrases = [];
    sentences.forEach((sentence)=>{
        const words = sentence.words;
        let phrase = [];
        let firstWord = words[0];
        words.forEach((word)=>{
            if (phrase.length === 0) phrase.push(word);
            else if (word.end - firstWord.start <= $6738915eea69e49b$var$PHRASE_DURATION) phrase.push(word);
            else {
                phrases.push({
                    text: phrase.map((word)=>word.text).join(" "),
                    start: firstWord.start,
                    end: word.end,
                    words: phrase
                });
                phrase = [
                    word
                ];
                firstWord = word;
            }
        });
        if (phrase.length > 0) phrases.push({
            text: phrase.map((word)=>word.text).join(" "),
            start: firstWord.start,
            end: phrase[phrase.length - 1].end,
            words: phrase
        });
    });
    return phrases;
}
function $6738915eea69e49b$export$422d30b5fbcf61ed({ captionPlayerParams: captionPlayerParams, captionStyleConfig: captionStyleConfig, captionStylePropertyValues: captionStylePropertyValues, videoRenderMode: videoRenderMode }) {
    (0, $acw62.useEffect)(()=>{
        console.log("captionPlayerParams", captionPlayerParams);
    }, [
        captionPlayerParams
    ]);
    const words = captionPlayerParams.transcript.words;
    const sentences = captionPlayerParams.transcript.sentences.sentences;
    const phrases = $6738915eea69e49b$var$splitSentencesIntoPhrases(sentences);
    let StyleRenderComponent;
    let styleValues = {};
    if (typeof captionStyleConfig === "string") {
        const styleConfig = (0, $495938ea8e19aef5$export$603deb0bff13d3bd).find((style)=>style.key === captionStyleConfig);
        if (!styleConfig) {
            console.error(`Invalid style config: ${captionStyleConfig}`);
            return null;
        }
        StyleRenderComponent = styleConfig.component;
        styleValues = {
            ...styleConfig.defaultValues,
            ...captionStylePropertyValues
        };
    } else {
        StyleRenderComponent = captionStyleConfig.component;
        styleValues = {
            ...captionStyleConfig.defaultValues,
            ...captionStylePropertyValues
        };
    }
    const videoUrl = (0, $acw62.useMemo)(()=>{
        if (!captionPlayerParams.videoUrl) return;
        const url = new URL(captionPlayerParams.videoUrl);
        if (url.protocol === "file:") return (0, $c78df6347432a4c1$export$6b34865dc09074f2)(url.pathname);
        return captionPlayerParams.videoUrl;
    }, [
        captionPlayerParams.videoUrl
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c78df6347432a4c1$export$afbd5df19c967c53), {
        children: [
            videoUrl && videoRenderMode === "default" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c78df6347432a4c1$export$ae01dedf5c052bb), {
                src: videoUrl,
                pauseWhenBuffering: true
            }),
            videoUrl && videoRenderMode === "offthread" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c78df6347432a4c1$export$5d890d9b17ec59e5), {
                src: videoUrl,
                pauseWhenBuffering: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(StyleRenderComponent, {
                words: words,
                sentences: sentences,
                phrases: phrases,
                values: styleValues
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.381.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c291f6067f6efa93$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Fullscreen", [
    [
        "path",
        {
            d: "M3 7V5a2 2 0 0 1 2-2h2",
            key: "aa7l1z"
        }
    ],
    [
        "path",
        {
            d: "M17 3h2a2 2 0 0 1 2 2v2",
            key: "4qcy5o"
        }
    ],
    [
        "path",
        {
            d: "M21 17v2a2 2 0 0 1-2 2h-2",
            key: "6vwrx8"
        }
    ],
    [
        "path",
        {
            d: "M7 21H5a2 2 0 0 1-2-2v-2",
            key: "ioqczr"
        }
    ],
    [
        "rect",
        {
            width: "10",
            height: "8",
            x: "7",
            y: "8",
            rx: "1",
            key: "vys8me"
        }
    ]
]);

/**
 * @license lucide-react v0.381.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $bfbb65af5bdc7218$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Pause", [
    [
        "rect",
        {
            x: "14",
            y: "4",
            width: "4",
            height: "16",
            rx: "1",
            key: "zuxfzm"
        }
    ],
    [
        "rect",
        {
            x: "6",
            y: "4",
            width: "4",
            height: "16",
            rx: "1",
            key: "1okwgv"
        }
    ]
]);

/**
 * @license lucide-react v0.381.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9b547c0f28739ad4$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Play", [
    [
        "polygon",
        {
            points: "6 3 20 12 6 21 6 3",
            key: "1oa8hb"
        }
    ]
]);



var $acw62 = parcelRequire("acw62");
const $fabe7b3bc61ad211$var$LOG_PLAYER_EVENTS = false;
function $fabe7b3bc61ad211$export$9885d3dafad52b6b(playerRef, { durationInFrames: durationInFrames, fps: fps }, { listenForTimeUpdate: listenForTimeUpdate = false } = {}) {
    const [isPlaying, setIsPlaying] = (0, $acw62.useState)(false);
    const [isFullscreen, setIsFullscreen] = (0, $acw62.useState)(false);
    const [currentTime, setCurrentTime] = (0, $acw62.useState)(0);
    const [duration, setDuration] = (0, $acw62.useState)(0);
    const [isBuffering, setIsBuffering] = (0, $acw62.useState)(false);
    const togglePlay = (0, $acw62.useCallback)(()=>{
        if (playerRef.current) {
            if (playerRef.current.isPlaying()) playerRef.current.pause();
            else playerRef.current.play();
        }
    }, [
        playerRef
    ]);
    const seekTo = (0, $acw62.useCallback)((time)=>{
        if (playerRef.current) playerRef.current.seekTo(time * fps);
    }, [
        playerRef,
        fps
    ]);
    const requestFullscreen = (0, $acw62.useCallback)(()=>{
        if (playerRef.current) playerRef.current.requestFullscreen();
    }, [
        playerRef
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!playerRef.current) return;
        setDuration(durationInFrames / fps);
        const onPlay = ()=>{
            $fabe7b3bc61ad211$var$LOG_PLAYER_EVENTS && console.log("playing");
            setIsPlaying(true);
        };
        const onRateChange = (e)=>{
            $fabe7b3bc61ad211$var$LOG_PLAYER_EVENTS && console.log("ratechange", e.detail.playbackRate);
        };
        const onVolumeChange = (e)=>{
            $fabe7b3bc61ad211$var$LOG_PLAYER_EVENTS && console.log("new volume", e.detail.volume);
        };
        const onPause = ()=>{
            $fabe7b3bc61ad211$var$LOG_PLAYER_EVENTS && console.log("pausing");
            setIsPlaying(false);
        };
        const onSeeked = (e)=>{
            $fabe7b3bc61ad211$var$LOG_PLAYER_EVENTS && console.log("seeked to " + e.detail.frame);
        };
        const onTimeupdate = (e)=>{
            $fabe7b3bc61ad211$var$LOG_PLAYER_EVENTS && console.log("time has updated to " + e.detail.frame);
            setCurrentTime(e.detail.frame / fps);
        };
        const onEnded = ()=>{
            $fabe7b3bc61ad211$var$LOG_PLAYER_EVENTS && console.log("ended");
            setIsPlaying(false);
        };
        const onError = (e)=>{
            $fabe7b3bc61ad211$var$LOG_PLAYER_EVENTS && console.log("error", e.detail.error);
            setIsPlaying(false);
        };
        const onFullscreenChange = (e)=>{
            $fabe7b3bc61ad211$var$LOG_PLAYER_EVENTS && console.log("fullscreenchange", e.detail.isFullscreen);
            setIsFullscreen(e.detail.isFullscreen);
        };
        const onScaleChange = (e)=>{
            $fabe7b3bc61ad211$var$LOG_PLAYER_EVENTS && console.log("scalechange", e.detail.scale);
        };
        const onMuteChange = (e)=>{
            $fabe7b3bc61ad211$var$LOG_PLAYER_EVENTS && console.log("mutechange", e.detail.isMuted);
        };
        playerRef.current.addEventListener("play", onPlay);
        playerRef.current.addEventListener("ratechange", onRateChange);
        playerRef.current.addEventListener("volumechange", onVolumeChange);
        playerRef.current.addEventListener("pause", onPause);
        playerRef.current.addEventListener("ended", onEnded);
        playerRef.current.addEventListener("error", onError);
        playerRef.current.addEventListener("fullscreenchange", onFullscreenChange);
        playerRef.current.addEventListener("scalechange", onScaleChange);
        playerRef.current.addEventListener("mutechange", onMuteChange);
        // See below for difference between `seeked` and `timeupdate`
        playerRef.current.addEventListener("seeked", onSeeked);
        if (listenForTimeUpdate) playerRef.current.addEventListener("timeupdate", onTimeupdate);
        return ()=>{
            // Make sure to clean up event listeners
            if (playerRef.current) {
                playerRef.current.removeEventListener("play", onPlay);
                playerRef.current.removeEventListener("ratechange", onRateChange);
                playerRef.current.removeEventListener("volumechange", onVolumeChange);
                playerRef.current.removeEventListener("pause", onPause);
                playerRef.current.removeEventListener("ended", onEnded);
                playerRef.current.removeEventListener("error", onError);
                playerRef.current.removeEventListener("fullscreenchange", onFullscreenChange);
                playerRef.current.removeEventListener("scalechange", onScaleChange);
                playerRef.current.removeEventListener("mutechange", onMuteChange);
                playerRef.current.removeEventListener("seeked", onSeeked);
                if (listenForTimeUpdate) playerRef.current.removeEventListener("timeupdate", onTimeupdate);
            }
        };
    }, [
        listenForTimeUpdate,
        fps,
        durationInFrames,
        playerRef
    ]);
    return {
        isPlaying: isPlaying,
        isBuffering: isBuffering,
        isFullscreen: isFullscreen,
        currentTime: currentTime,
        duration: duration,
        seekTo: seekTo,
        togglePlay: togglePlay,
        requestFullscreen: requestFullscreen
    };
}






var $acw62 = parcelRequire("acw62");
var $f9b9596425583678$exports = {};
"use strict";
var $508f735703b01dcf$exports = {};
"use strict";
Object.defineProperty($508f735703b01dcf$exports, "__esModule", {
    value: true
});
Object.defineProperty($508f735703b01dcf$exports, "DraggableCore", {
    enumerable: true,
    get: function() {
        return $508f735703b01dcf$var$_DraggableCore.default;
    }
});
$508f735703b01dcf$exports.default = void 0;

var $508f735703b01dcf$var$React = $508f735703b01dcf$var$_interopRequireWildcard((parcelRequire("acw62")));

var $508f735703b01dcf$var$_propTypes = $508f735703b01dcf$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $508f735703b01dcf$var$_reactDom = $508f735703b01dcf$var$_interopRequireDefault((parcelRequire("1u0KT")));

var $508f735703b01dcf$var$_clsx = $508f735703b01dcf$var$_interopRequireDefault((parcelRequire("8zh6d")));

var $hVGkP = parcelRequire("hVGkP");

var $jc5pr = parcelRequire("jc5pr");

var $7jnr7 = parcelRequire("7jnr7");

var $508f735703b01dcf$var$_DraggableCore = $508f735703b01dcf$var$_interopRequireDefault((parcelRequire("7eM6q")));

var $508f735703b01dcf$var$_log = $508f735703b01dcf$var$_interopRequireDefault((parcelRequire("ldVpK")));
function $508f735703b01dcf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $508f735703b01dcf$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($508f735703b01dcf$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $508f735703b01dcf$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $508f735703b01dcf$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $508f735703b01dcf$var$_extends() {
    $508f735703b01dcf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $508f735703b01dcf$var$_extends.apply(this, arguments);
}
function $508f735703b01dcf$var$_defineProperty(obj, key, value) {
    key = $508f735703b01dcf$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $508f735703b01dcf$var$_toPropertyKey(arg) {
    var key = $508f735703b01dcf$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $508f735703b01dcf$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
} /*:: import type {ControlPosition, PositionOffsetControlPosition, DraggableCoreProps, DraggableCoreDefaultProps} from './DraggableCore';*/ 
/*:: import type {Bounds, DraggableEventHandler} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ /*:: type DraggableState = {
  dragging: boolean,
  dragged: boolean,
  x: number, y: number,
  slackX: number, slackY: number,
  isElementSVG: boolean,
  prevPropsPosition: ?ControlPosition,
};*/ /*:: export type DraggableDefaultProps = {
  ...DraggableCoreDefaultProps,
  axis: 'both' | 'x' | 'y' | 'none',
  bounds: Bounds | string | false,
  defaultClassName: string,
  defaultClassNameDragging: string,
  defaultClassNameDragged: string,
  defaultPosition: ControlPosition,
  scale: number,
};*/ /*:: export type DraggableProps = {
  ...DraggableCoreProps,
  ...DraggableDefaultProps,
  positionOffset: PositionOffsetControlPosition,
  position: ControlPosition,
};*/ //
// Define <Draggable>
//
class $508f735703b01dcf$var$Draggable extends $508f735703b01dcf$var$React.Component /*:: <DraggableProps, DraggableState>*/  {
    // React 16.3+
    // Arity (props, state)
    static getDerivedStateFromProps(_ref /*:: */ , _ref2 /*:: */ ) /*: ?Partial<DraggableState>*/ {
        let { position: position } /*: DraggableProps*/  = _ref /*: DraggableProps*/ ;
        let { prevPropsPosition: prevPropsPosition } /*: DraggableState*/  = _ref2 /*: DraggableState*/ ;
        // Set x/y if a new position is provided in props that is different than the previous.
        if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
            (0, $508f735703b01dcf$var$_log.default)("Draggable: getDerivedStateFromProps %j", {
                position: position,
                prevPropsPosition: prevPropsPosition
            });
            return {
                x: position.x,
                y: position.y,
                prevPropsPosition: {
                    ...position
                }
            };
        }
        return null;
    }
    constructor(props /*: DraggableProps*/ ){
        super(props);
        $508f735703b01dcf$var$_defineProperty(this, "onDragStart", (e, coreData)=>{
            (0, $508f735703b01dcf$var$_log.default)("Draggable: onDragStart: %j", coreData);
            // Short-circuit if user's callback killed it.
            const shouldStart = this.props.onStart(e, (0, $jc5pr.createDraggableData)(this, coreData));
            // Kills start event on core as well, so move handlers are never bound.
            if (shouldStart === false) return false;
            this.setState({
                dragging: true,
                dragged: true
            });
        });
        $508f735703b01dcf$var$_defineProperty(this, "onDrag", (e, coreData)=>{
            if (!this.state.dragging) return false;
            (0, $508f735703b01dcf$var$_log.default)("Draggable: onDrag: %j", coreData);
            const uiData = (0, $jc5pr.createDraggableData)(this, coreData);
            const newState = {
                x: uiData.x,
                y: uiData.y,
                slackX: 0,
                slackY: 0
            };
            // Keep within bounds.
            if (this.props.bounds) {
                // Save original x and y.
                const { x: x, y: y } = newState;
                // Add slack to the values used to calculate bound position. This will ensure that if
                // we start removing slack, the element won't react to it right away until it's been
                // completely removed.
                newState.x += this.state.slackX;
                newState.y += this.state.slackY;
                // Get bound position. This will ceil/floor the x and y within the boundaries.
                const [newStateX, newStateY] = (0, $jc5pr.getBoundPosition)(this, newState.x, newState.y);
                newState.x = newStateX;
                newState.y = newStateY;
                // Recalculate slack by noting how much was shaved by the boundPosition handler.
                newState.slackX = this.state.slackX + (x - newState.x);
                newState.slackY = this.state.slackY + (y - newState.y);
                // Update the event we fire to reflect what really happened after bounds took effect.
                uiData.x = newState.x;
                uiData.y = newState.y;
                uiData.deltaX = newState.x - this.state.x;
                uiData.deltaY = newState.y - this.state.y;
            }
            // Short-circuit if user's callback killed it.
            const shouldUpdate = this.props.onDrag(e, uiData);
            if (shouldUpdate === false) return false;
            this.setState(newState);
        });
        $508f735703b01dcf$var$_defineProperty(this, "onDragStop", (e, coreData)=>{
            if (!this.state.dragging) return false;
            // Short-circuit if user's callback killed it.
            const shouldContinue = this.props.onStop(e, (0, $jc5pr.createDraggableData)(this, coreData));
            if (shouldContinue === false) return false;
            (0, $508f735703b01dcf$var$_log.default)("Draggable: onDragStop: %j", coreData);
            const newState /*: Partial<DraggableState>*/  = {
                dragging: false,
                slackX: 0,
                slackY: 0
            };
            // If this is a controlled component, the result of this operation will be to
            // revert back to the old position. We expect a handler on `onDragStop`, at the least.
            const controlled = Boolean(this.props.position);
            if (controlled) {
                const { x: x, y: y } = this.props.position;
                newState.x = x;
                newState.y = y;
            }
            this.setState(newState);
        });
        this.state = {
            // Whether or not we are currently dragging.
            dragging: false,
            // Whether or not we have been dragged before.
            dragged: false,
            // Current transform x and y.
            x: props.position ? props.position.x : props.defaultPosition.x,
            y: props.position ? props.position.y : props.defaultPosition.y,
            prevPropsPosition: {
                ...props.position
            },
            // Used for compensating for out-of-bounds drags
            slackX: 0,
            slackY: 0,
            // Can only determine if SVG after mounting
            isElementSVG: false
        };
        if (props.position && !(props.onDrag || props.onStop)) // eslint-disable-next-line no-console
        console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
    }
    componentDidMount() {
        // Check to see if the element passed is an instanceof SVGElement
        if (typeof window.SVGElement !== "undefined" && this.findDOMNode() instanceof window.SVGElement) this.setState({
            isElementSVG: true
        });
    }
    componentWillUnmount() {
        this.setState({
            dragging: false
        }); // prevents invariant if unmounted while dragging
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() /*: ?HTMLElement*/ {
        var _this$props$nodeRef$c, _this$props;
        return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 || (_this$props = _this$props.nodeRef) === null || _this$props === void 0 ? void 0 : _this$props.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : $508f735703b01dcf$var$_reactDom.default.findDOMNode(this);
    }
    render() /*: ReactElement<any>*/ {
        const { axis: axis, bounds: bounds, children: children, defaultPosition: defaultPosition, defaultClassName: defaultClassName, defaultClassNameDragging: defaultClassNameDragging, defaultClassNameDragged: defaultClassNameDragged, position: position, positionOffset: positionOffset, scale: scale, ...draggableCoreProps } = this.props;
        let style = {};
        let svgTransform = null;
        // If this is controlled, we don't want to move it - unless it's dragging.
        const controlled = Boolean(position);
        const draggable = !controlled || this.state.dragging;
        const validPosition = position || defaultPosition;
        const transformOpts = {
            // Set left if horizontal drag is enabled
            x: (0, $jc5pr.canDragX)(this) && draggable ? this.state.x : validPosition.x,
            // Set top if vertical drag is enabled
            y: (0, $jc5pr.canDragY)(this) && draggable ? this.state.y : validPosition.y
        };
        // If this element was SVG, we use the `transform` attribute.
        if (this.state.isElementSVG) svgTransform = (0, $hVGkP.createSVGTransform)(transformOpts, positionOffset);
        else // Add a CSS transform to move the element around. This allows us to move the element around
        // without worrying about whether or not it is relatively or absolutely positioned.
        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
        // has a clean slate.
        style = (0, $hVGkP.createCSSTransform)(transformOpts, positionOffset);
        // Mark with class while dragging
        const className = (0, $508f735703b01dcf$var$_clsx.default)(children.props.className || "", defaultClassName, {
            [defaultClassNameDragging]: this.state.dragging,
            [defaultClassNameDragged]: this.state.dragged
        });
        // Reuse the child provided
        // This makes it flexible to use whatever element is wanted (div, ul, etc)
        return /*#__PURE__*/ $508f735703b01dcf$var$React.createElement($508f735703b01dcf$var$_DraggableCore.default, $508f735703b01dcf$var$_extends({}, draggableCoreProps, {
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop
        }), /*#__PURE__*/ $508f735703b01dcf$var$React.cloneElement($508f735703b01dcf$var$React.Children.only(children), {
            className: className,
            style: {
                ...children.props.style,
                ...style
            },
            transform: svgTransform
        }));
    }
}
$508f735703b01dcf$exports.default = $508f735703b01dcf$var$Draggable;
$508f735703b01dcf$var$_defineProperty($508f735703b01dcf$var$Draggable, "displayName", "Draggable");
$508f735703b01dcf$var$_defineProperty($508f735703b01dcf$var$Draggable, "propTypes", {
    // Accepts all props <DraggableCore> accepts.
    ...$508f735703b01dcf$var$_DraggableCore.default.propTypes,
    /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */ axis: $508f735703b01dcf$var$_propTypes.default.oneOf([
        "both",
        "x",
        "y",
        "none"
    ]),
    /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ bounds: $508f735703b01dcf$var$_propTypes.default.oneOfType([
        $508f735703b01dcf$var$_propTypes.default.shape({
            left: $508f735703b01dcf$var$_propTypes.default.number,
            right: $508f735703b01dcf$var$_propTypes.default.number,
            top: $508f735703b01dcf$var$_propTypes.default.number,
            bottom: $508f735703b01dcf$var$_propTypes.default.number
        }),
        $508f735703b01dcf$var$_propTypes.default.string,
        $508f735703b01dcf$var$_propTypes.default.oneOf([
            false
        ])
    ]),
    defaultClassName: $508f735703b01dcf$var$_propTypes.default.string,
    defaultClassNameDragging: $508f735703b01dcf$var$_propTypes.default.string,
    defaultClassNameDragged: $508f735703b01dcf$var$_propTypes.default.string,
    /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ defaultPosition: $508f735703b01dcf$var$_propTypes.default.shape({
        x: $508f735703b01dcf$var$_propTypes.default.number,
        y: $508f735703b01dcf$var$_propTypes.default.number
    }),
    positionOffset: $508f735703b01dcf$var$_propTypes.default.shape({
        x: $508f735703b01dcf$var$_propTypes.default.oneOfType([
            $508f735703b01dcf$var$_propTypes.default.number,
            $508f735703b01dcf$var$_propTypes.default.string
        ]),
        y: $508f735703b01dcf$var$_propTypes.default.oneOfType([
            $508f735703b01dcf$var$_propTypes.default.number,
            $508f735703b01dcf$var$_propTypes.default.string
        ])
    }),
    /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ position: $508f735703b01dcf$var$_propTypes.default.shape({
        x: $508f735703b01dcf$var$_propTypes.default.number,
        y: $508f735703b01dcf$var$_propTypes.default.number
    }),
    /**
   * These properties should be defined on the child, not here.
   */ className: $7jnr7.dontSetMe,
    style: $7jnr7.dontSetMe,
    transform: $7jnr7.dontSetMe
});
$508f735703b01dcf$var$_defineProperty($508f735703b01dcf$var$Draggable, "defaultProps", {
    ...$508f735703b01dcf$var$_DraggableCore.default.defaultProps,
    axis: "both",
    bounds: false,
    defaultClassName: "react-draggable",
    defaultClassNameDragging: "react-draggable-dragging",
    defaultClassNameDragged: "react-draggable-dragged",
    defaultPosition: {
        x: 0,
        y: 0
    },
    scale: 1
});


var $f9b9596425583678$require$Draggable = $508f735703b01dcf$exports.default;
var $f9b9596425583678$require$DraggableCore = $508f735703b01dcf$exports.DraggableCore;
// Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266
$f9b9596425583678$exports = $f9b9596425583678$require$Draggable;
$f9b9596425583678$exports.default = $f9b9596425583678$require$Draggable;
$f9b9596425583678$exports.DraggableCore = $f9b9596425583678$require$DraggableCore;


function $980a3fa09728acbc$export$d57df24278cf018d({ playerRef: playerRef, durationInFrames: durationInFrames, fps: fps }) {
    const { currentTime: currentTime, duration: duration, seekTo: seekTo } = (0, $fabe7b3bc61ad211$export$9885d3dafad52b6b)(playerRef, {
        durationInFrames: durationInFrames,
        fps: fps
    }, {
        listenForTimeUpdate: true
    });
    const [xPercent, setXPercent] = (0, $acw62.useState)(0);
    const trackRef = (0, $acw62.useRef)(null);
    const handleRef = (0, $acw62.useRef)(null);
    const [isDragging, setIsDragging] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        console.log("currentTime", currentTime, duration);
    }, [
        currentTime,
        duration
    ]);
    const handleStart = ()=>{
        setIsDragging(true);
    };
    const handleDrag = (e, { x: x })=>{
        if (isDragging) {
            console.log("x", x, "trackWidth", trackRef.current?.clientWidth);
            const trackWidth = trackRef.current?.clientWidth || 1;
            const handleWidth = handleRef.current?.clientWidth || 1;
            const frac = Math.max(0, Math.min(1, x / (trackWidth - handleWidth)));
            const newTime = frac * duration;
            console.log("newTime", newTime);
            seekTo(newTime);
            setXPercent(frac * 100);
        }
    };
    const handleStop = (e, { x: x })=>{
        setIsDragging(false);
        const trackWidth = trackRef.current?.clientWidth || 1;
        const handleWidth = handleRef.current?.clientWidth || 0;
        const frac = Math.max(0, Math.min(1, x / (trackWidth - handleWidth) * 1));
        const newTime = frac * duration;
        seekTo(newTime);
        setXPercent(frac * 100);
    };
    const handleTrackClick = (e)=>{
        const trackWidth = trackRef.current?.clientWidth || 1;
        const clickX = e.clientX - trackRef.current?.getBoundingClientRect().left;
        const frac = Math.max(0, Math.min(1, clickX / trackWidth));
        const newTime = frac * duration;
        seekTo(newTime);
        setXPercent(frac * 100);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-1 relative h-3 group mx-2 parent",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-1 relative border border-lit-purple h-full rounded-xl overflow-clip",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("absolute top-0 h-full rounded-xl left-0 bg-lit-purple transition-[width]"),
                    style: {
                        width: `${duration === 0 ? 0 : Math.min(100, currentTime / duration * 100)}%`
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                ref: trackRef,
                className: "absolute track w-full h-full flex items-center cursor-pointer",
                onClick: handleTrackClick,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9b9596425583678$exports.DraggableCore), {
                        handle: ".handle",
                        scale: 1,
                        onStart: handleStart,
                        onDrag: handleDrag,
                        onStop: handleStop,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("relative w-0 h-0", {
                                "transition-[left]": !isDragging
                            }),
                            style: {
                                left: `${isDragging ? xPercent : currentTime / duration * 100}%`
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                ref: handleRef,
                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("handle w-5 h-5 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white border-2 border-lit-purple")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "absolute left-0 top-4 text-xs font-medium",
                        children: $980a3fa09728acbc$var$getDisplayTime(currentTime)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "absolute right-0 top-4 text-xs font-medium",
                        children: $980a3fa09728acbc$var$getDisplayTime(duration)
                    })
                ]
            })
        ]
    });
}
function $980a3fa09728acbc$var$getDisplayTime(time) {
    const hours = Math.floor(time / 60 / 60);
    const minutes = Math.floor(time / 60) % 60;
    const seconds = Math.floor(time) % 60;
    if (hours > 0) return `${hours}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    return `${minutes}:${String(seconds).padStart(2, "0")}`;
}


function $5670cf9808de93e1$export$d6739bcd3094dae6({ playerRef: playerRef, durationInFrames: durationInFrames, fps: fps }) {
    const { isPlaying: isPlaying, togglePlay: togglePlay, requestFullscreen: requestFullscreen } = (0, $fabe7b3bc61ad211$export$9885d3dafad52b6b)(playerRef, {
        durationInFrames: durationInFrames,
        fps: fps
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex mt-2 gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "py-2 cursor-pointer text-lit-purple hover:opacity-70 transition-opacity",
                onClick: togglePlay,
                children: isPlaying ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bfbb65af5bdc7218$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9b547c0f28739ad4$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex-1 flex items-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $980a3fa09728acbc$export$d57df24278cf018d), {
                    playerRef: playerRef,
                    durationInFrames: durationInFrames,
                    fps: fps
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "py-2 cursor-pointer text-lit-purple hover:opacity-70 transition-opacity",
                onClick: requestFullscreen,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c291f6067f6efa93$export$2e2bcd8739ae039), {})
            })
        ]
    });
}





function $3b79cf1cc497a9ee$export$8f942cad805e8814({ playerRef: playerRef, durationInFrames: durationInFrames, fps: fps }) {
    const { togglePlay: togglePlay } = (0, $fabe7b3bc61ad211$export$9885d3dafad52b6b)(playerRef, {
        durationInFrames: durationInFrames,
        fps: fps
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "absolute inset-0 bg-transparent",
        onClick: ()=>togglePlay()
    });
}



var $acw62 = parcelRequire("acw62");
var $99e74afc5f3a2c27$exports = {};
"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ var $984633e770578898$export$4659b591c19bdf3d;
var $984633e770578898$export$98e6a39c04603d36;
"use strict";
$984633e770578898$export$4659b591c19bdf3d = $984633e770578898$var$matchQuery;
$984633e770578898$export$98e6a39c04603d36 = $984633e770578898$var$parseQuery;
// -----------------------------------------------------------------------------
var $984633e770578898$var$RE_MEDIA_QUERY = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, $984633e770578898$var$RE_MQ_EXPRESSION = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, $984633e770578898$var$RE_MQ_FEATURE = /^(?:(min|max)-)?(.+)/, $984633e770578898$var$RE_LENGTH_UNIT = /(em|rem|px|cm|mm|in|pt|pc)?$/, $984633e770578898$var$RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
function $984633e770578898$var$matchQuery(mediaQuery, values) {
    return $984633e770578898$var$parseQuery(mediaQuery).some(function(query) {
        var inverse = query.inverse;
        // Either the parsed or specified `type` is "all", or the types must be
        // equal for a match.
        var typeMatch = query.type === "all" || values.type === query.type;
        // Quit early when `type` doesn't match, but take "not" into account.
        if (typeMatch && inverse || !(typeMatch || inverse)) return false;
        var expressionsMatch = query.expressions.every(function(expression) {
            var feature = expression.feature, modifier = expression.modifier, expValue = expression.value, value = values[feature];
            // Missing or falsy values don't match.
            if (!value) return false;
            switch(feature){
                case "orientation":
                case "scan":
                    return value.toLowerCase() === expValue.toLowerCase();
                case "width":
                case "height":
                case "device-width":
                case "device-height":
                    expValue = $984633e770578898$var$toPx(expValue);
                    value = $984633e770578898$var$toPx(value);
                    break;
                case "resolution":
                    expValue = $984633e770578898$var$toDpi(expValue);
                    value = $984633e770578898$var$toDpi(value);
                    break;
                case "aspect-ratio":
                case "device-aspect-ratio":
                case /* Deprecated */ "device-pixel-ratio":
                    expValue = $984633e770578898$var$toDecimal(expValue);
                    value = $984633e770578898$var$toDecimal(value);
                    break;
                case "grid":
                case "color":
                case "color-index":
                case "monochrome":
                    expValue = parseInt(expValue, 10) || 1;
                    value = parseInt(value, 10) || 0;
                    break;
            }
            switch(modifier){
                case "min":
                    return value >= expValue;
                case "max":
                    return value <= expValue;
                default:
                    return value === expValue;
            }
        });
        return expressionsMatch && !inverse || !expressionsMatch && inverse;
    });
}
function $984633e770578898$var$parseQuery(mediaQuery) {
    return mediaQuery.split(",").map(function(query) {
        query = query.trim();
        var captures = query.match($984633e770578898$var$RE_MEDIA_QUERY), modifier = captures[1], type = captures[2], expressions = captures[3] || "", parsed = {};
        parsed.inverse = !!modifier && modifier.toLowerCase() === "not";
        parsed.type = type ? type.toLowerCase() : "all";
        // Split expressions into a list.
        expressions = expressions.match(/\([^\)]+\)/g) || [];
        parsed.expressions = expressions.map(function(expression) {
            var captures = expression.match($984633e770578898$var$RE_MQ_EXPRESSION), feature = captures[1].toLowerCase().match($984633e770578898$var$RE_MQ_FEATURE);
            return {
                modifier: feature[1],
                feature: feature[2],
                value: captures[2]
            };
        });
        return parsed;
    });
}
// -- Utilities ----------------------------------------------------------------
function $984633e770578898$var$toDecimal(ratio) {
    var decimal = Number(ratio), numbers;
    if (!decimal) {
        numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/);
        decimal = numbers[1] / numbers[2];
    }
    return decimal;
}
function $984633e770578898$var$toDpi(resolution) {
    var value = parseFloat(resolution), units = String(resolution).match($984633e770578898$var$RE_RESOLUTION_UNIT)[1];
    switch(units){
        case "dpcm":
            return value / 2.54;
        case "dppx":
            return value * 96;
        default:
            return value;
    }
}
function $984633e770578898$var$toPx(length) {
    var value = parseFloat(length), units = String(length).match($984633e770578898$var$RE_LENGTH_UNIT)[1];
    switch(units){
        case "em":
            return value * 16;
        case "rem":
            return value * 16;
        case "cm":
            return value * 96 / 2.54;
        case "mm":
            return value * 96 / 2.54 / 10;
        case "in":
            return value * 96;
        case "pt":
            return value * 72;
        case "pc":
            return value * 72 / 12;
        default:
            return value;
    }
}


var $99e74afc5f3a2c27$require$staticMatch = $984633e770578898$export$4659b591c19bdf3d;
var $99e74afc5f3a2c27$var$dynamicMatch = typeof window !== "undefined" ? window.matchMedia : null;
// our fake MediaQueryList
function $99e74afc5f3a2c27$var$Mql(query, values, forceStatic) {
    var self = this;
    var mql;
    // matchMedia will return null in FF when it's called in a hidden iframe
    // ref: https://stackoverflow.com/a/12330568
    if ($99e74afc5f3a2c27$var$dynamicMatch && !forceStatic) mql = $99e74afc5f3a2c27$var$dynamicMatch.call(window, query);
    if (mql) {
        this.matches = mql.matches;
        this.media = mql.media;
        // TODO: is there a time it makes sense to remove this listener?
        mql.addListener(update);
    } else {
        this.matches = $99e74afc5f3a2c27$require$staticMatch(query, values);
        this.media = query;
    }
    this.addListener = addListener;
    this.removeListener = removeListener;
    this.dispose = dispose;
    function addListener(listener) {
        if (mql) mql.addListener(listener);
    }
    function removeListener(listener) {
        if (mql) mql.removeListener(listener);
    }
    // update ourselves!
    function update(evt) {
        self.matches = evt.matches;
        self.media = evt.media;
    }
    function dispose() {
        if (mql) mql.removeListener(update);
    }
}
function $99e74afc5f3a2c27$var$matchMedia(query, values, forceStatic) {
    return new $99e74afc5f3a2c27$var$Mql(query, values, forceStatic);
}
$99e74afc5f3a2c27$exports = $99e74afc5f3a2c27$var$matchMedia;


/* eslint-disable no-var, prefer-template */ var $cb370b3f4a9491f5$var$uppercasePattern = /[A-Z]/g;
var $cb370b3f4a9491f5$var$msPattern = /^ms-/;
var $cb370b3f4a9491f5$var$cache = {};
function $cb370b3f4a9491f5$var$toHyphenLower(match) {
    return "-" + match.toLowerCase();
}
function $cb370b3f4a9491f5$var$hyphenateStyleName(name) {
    if ($cb370b3f4a9491f5$var$cache.hasOwnProperty(name)) return $cb370b3f4a9491f5$var$cache[name];
    var hName = name.replace($cb370b3f4a9491f5$var$uppercasePattern, $cb370b3f4a9491f5$var$toHyphenLower);
    return $cb370b3f4a9491f5$var$cache[name] = $cb370b3f4a9491f5$var$msPattern.test(hName) ? "-" + hName : hName;
}
var $cb370b3f4a9491f5$export$2e2bcd8739ae039 = $cb370b3f4a9491f5$var$hyphenateStyleName;


function $589e07e840bb809e$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $589e07e840bb809e$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $589e07e840bb809e$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $589e07e840bb809e$export$967a6b9924a689f7(a, b);
    return $589e07e840bb809e$export$3e67810a3f0e9f1c(a, b);
}



var $c9Z8w = parcelRequire("c9Z8w");
const $e1951a4eca20087f$var$stringOrNumber = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
]);
// media types
const $e1951a4eca20087f$var$types = {
    all: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    grid: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    aural: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    braille: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    handheld: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    print: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    projection: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    screen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    tty: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    tv: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    embossed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
// properties that match media queries
const $e1951a4eca20087f$var$matchers = {
    orientation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "portrait",
        "landscape"
    ]),
    scan: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "progressive",
        "interlace"
    ]),
    aspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    deviceAspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    height: $e1951a4eca20087f$var$stringOrNumber,
    deviceHeight: $e1951a4eca20087f$var$stringOrNumber,
    width: $e1951a4eca20087f$var$stringOrNumber,
    deviceWidth: $e1951a4eca20087f$var$stringOrNumber,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    colorIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    monochrome: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    resolution: $e1951a4eca20087f$var$stringOrNumber,
    type: Object.keys($e1951a4eca20087f$var$types)
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { type: $e1951a4eca20087f$var$type, ...$e1951a4eca20087f$var$featureMatchers } = $e1951a4eca20087f$var$matchers;
// media features
const $e1951a4eca20087f$var$features = {
    minAspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    maxAspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    minDeviceAspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    maxDeviceAspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    minHeight: $e1951a4eca20087f$var$stringOrNumber,
    maxHeight: $e1951a4eca20087f$var$stringOrNumber,
    minDeviceHeight: $e1951a4eca20087f$var$stringOrNumber,
    maxDeviceHeight: $e1951a4eca20087f$var$stringOrNumber,
    minWidth: $e1951a4eca20087f$var$stringOrNumber,
    maxWidth: $e1951a4eca20087f$var$stringOrNumber,
    minDeviceWidth: $e1951a4eca20087f$var$stringOrNumber,
    maxDeviceWidth: $e1951a4eca20087f$var$stringOrNumber,
    minColor: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    maxColor: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    minColorIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    maxColorIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    minMonochrome: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    maxMonochrome: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    minResolution: $e1951a4eca20087f$var$stringOrNumber,
    maxResolution: $e1951a4eca20087f$var$stringOrNumber,
    ...$e1951a4eca20087f$var$featureMatchers
};
const $e1951a4eca20087f$var$all = {
    ...$e1951a4eca20087f$var$types,
    ...$e1951a4eca20087f$var$features
};
var $e1951a4eca20087f$var$mq = {
    all: $e1951a4eca20087f$var$all,
    types: $e1951a4eca20087f$var$types,
    matchers: $e1951a4eca20087f$var$matchers,
    features: $e1951a4eca20087f$var$features
};
const $e1951a4eca20087f$var$negate = (cond)=>`not ${cond}`;
const $e1951a4eca20087f$var$keyVal = (k, v)=>{
    const realKey = (0, $cb370b3f4a9491f5$export$2e2bcd8739ae039)(k);
    // px shorthand
    if (typeof v === "number") v = `${v}px`;
    if (v === true) return realKey;
    if (v === false) return $e1951a4eca20087f$var$negate(realKey);
    return `(${realKey}: ${v})`;
};
const $e1951a4eca20087f$var$join = (conds)=>conds.join(" and ");
const $e1951a4eca20087f$export$da99e50c1f5e8cc8 = (obj)=>{
    const rules = [];
    Object.keys($e1951a4eca20087f$var$mq.all).forEach((k)=>{
        const v = obj[k];
        if (v != null) rules.push($e1951a4eca20087f$var$keyVal(k, v));
    });
    return $e1951a4eca20087f$var$join(rules);
};
const $e1951a4eca20087f$export$841858b892ce1f4c = (0, $acw62.createContext)(undefined);
const $e1951a4eca20087f$var$makeQuery = (settings)=>settings.query || $e1951a4eca20087f$export$da99e50c1f5e8cc8(settings);
const $e1951a4eca20087f$var$hyphenateKeys = (obj)=>{
    if (!obj) return undefined;
    const keys = Object.keys(obj);
    return keys.reduce((result, key)=>{
        result[(0, $cb370b3f4a9491f5$export$2e2bcd8739ae039)(key)] = obj[key];
        return result;
    }, {});
};
const $e1951a4eca20087f$var$useIsUpdate = ()=>{
    const ref = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        ref.current = true;
    }, []);
    return ref.current;
};
const $e1951a4eca20087f$var$useDevice = (deviceFromProps)=>{
    const deviceFromContext = (0, $acw62.useContext)($e1951a4eca20087f$export$841858b892ce1f4c);
    const getDevice = ()=>$e1951a4eca20087f$var$hyphenateKeys(deviceFromProps) || $e1951a4eca20087f$var$hyphenateKeys(deviceFromContext);
    const [device, setDevice] = (0, $acw62.useState)(getDevice);
    (0, $acw62.useEffect)(()=>{
        const newDevice = getDevice();
        if (!(0, $589e07e840bb809e$export$3e67810a3f0e9f1c)(device, newDevice)) setDevice(newDevice);
    }, [
        deviceFromProps,
        deviceFromContext
    ]);
    return device;
};
const $e1951a4eca20087f$var$useQuery = (settings)=>{
    const getQuery = ()=>$e1951a4eca20087f$var$makeQuery(settings);
    const [query, setQuery] = (0, $acw62.useState)(getQuery);
    (0, $acw62.useEffect)(()=>{
        const newQuery = getQuery();
        if (query !== newQuery) setQuery(newQuery);
    }, [
        settings
    ]);
    return query;
};
const $e1951a4eca20087f$var$useMatchMedia = (query, device)=>{
    const getMatchMedia = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($99e74afc5f3a2c27$exports)))(query, device || {}, !!device);
    const [mq, setMq] = (0, $acw62.useState)(getMatchMedia);
    const isUpdate = $e1951a4eca20087f$var$useIsUpdate();
    (0, $acw62.useEffect)(()=>{
        if (isUpdate) {
            // skip on mounting, it has already been set
            const newMq = getMatchMedia();
            setMq(newMq);
            return ()=>{
                if (newMq) newMq.dispose();
            };
        }
    }, [
        query,
        device
    ]);
    return mq;
};
const $e1951a4eca20087f$var$useMatches = (mediaQuery)=>{
    const [matches, setMatches] = (0, $acw62.useState)(mediaQuery.matches);
    (0, $acw62.useEffect)(()=>{
        const updateMatches = (ev)=>{
            setMatches(ev.matches);
        };
        mediaQuery.addListener(updateMatches);
        setMatches(mediaQuery.matches);
        return ()=>{
            mediaQuery.removeListener(updateMatches);
        };
    }, [
        mediaQuery
    ]);
    return matches;
};
const $e1951a4eca20087f$export$32d5543ab307c01 = (settings, device, onChange)=>{
    const deviceSettings = $e1951a4eca20087f$var$useDevice(device);
    const query = $e1951a4eca20087f$var$useQuery(settings);
    if (!query) throw new Error("Invalid or missing MediaQuery!");
    const mq = $e1951a4eca20087f$var$useMatchMedia(query, deviceSettings);
    const matches = $e1951a4eca20087f$var$useMatches(mq);
    const isUpdate = $e1951a4eca20087f$var$useIsUpdate();
    (0, $acw62.useEffect)(()=>{
        if (isUpdate && onChange) onChange(matches);
    }, [
        matches
    ]);
    (0, $acw62.useEffect)(()=>()=>{
            if (mq) mq.dispose();
        }, []);
    return matches;
};
// ReactNode and ReactElement typings are a little funky for functional components, so the ReactElement cast is needed on the return
const $e1951a4eca20087f$export$2e2bcd8739ae039 = ({ children: children, device: device, onChange: onChange, ...settings })=>{
    const matches = $e1951a4eca20087f$export$32d5543ab307c01(settings, device, onChange);
    if (typeof children === "function") return children(matches);
    return matches ? children : null;
};


const $500ad2a9f4a35004$var$FPS = 30;
function $500ad2a9f4a35004$export$195c2c5b751432f4({ captionPlayerParams: captionPlayerParams, captionStyleConfig: captionStyleConfig, captionStylePropertyValues: captionStylePropertyValues }) {
    const durationInFrames = Math.floor(captionPlayerParams.videoDuration / 1000 * $500ad2a9f4a35004$var$FPS);
    const playerRef = (0, $acw62.useRef)(null);
    const isMobile = (0, $e1951a4eca20087f$export$32d5543ab307c01)({
        query: "(max-width: 640px)"
    });
    const { isFullscreen: isFullscreen } = (0, $fabe7b3bc61ad211$export$9885d3dafad52b6b)(playerRef, {
        durationInFrames: durationInFrames,
        fps: $500ad2a9f4a35004$var$FPS
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col items-stretch",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "opacity-70 mb-2 text-center",
                children: "Preview"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "relative outline outline-black/20",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "absolute inset-0 flex items-center justify-center",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col justify-center items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                    className: "w-6 h-6 animate-spin"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: "Loading preview"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f33cd4ca105fd87b$export$2616165974278734), {
                        ref: playerRef,
                        component: (0, $6738915eea69e49b$export$422d30b5fbcf61ed),
                        inputProps: {
                            captionPlayerParams: captionPlayerParams,
                            captionStyleConfig: captionStyleConfig,
                            captionStylePropertyValues: captionStylePropertyValues,
                            videoRenderMode: "default"
                        },
                        durationInFrames: durationInFrames,
                        compositionWidth: 1080,
                        compositionHeight: 1920,
                        fps: $500ad2a9f4a35004$var$FPS,
                        className: "w-full md:min-w-[360px]",
                        style: {
                            width: `100%`
                        },
                        controls: isFullscreen || isMobile
                    }),
                    !isFullscreen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3b79cf1cc497a9ee$export$8f942cad805e8814), {
                        playerRef: playerRef,
                        durationInFrames: durationInFrames,
                        fps: $500ad2a9f4a35004$var$FPS
                    })
                ]
            }),
            !isFullscreen && !isMobile && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5670cf9808de93e1$export$d6739bcd3094dae6), {
                playerRef: playerRef,
                durationInFrames: durationInFrames,
                fps: $500ad2a9f4a35004$var$FPS
            })
        ]
    });
}








var $acw62 = parcelRequire("acw62");

function $08d62422c99e31ec$export$738f9397c06fbf48({ video: video, poster: poster }) {
    const videoRef = (0, $acw62.useRef)(null);
    const isMobile = (0, $e1951a4eca20087f$export$32d5543ab307c01)({
        query: "(max-width: 640px)"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "w-full h-full rounded-[2px] relative",
        onMouseOver: (e)=>{
            if (isMobile) return;
            if (!videoRef.current) return;
            videoRef.current.play();
        },
        onMouseOut: (e)=>{
            if (isMobile) return;
            if (!videoRef.current) return;
            videoRef.current.pause();
            videoRef.current.src = video;
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("video", {
                ref: videoRef,
                muted: true,
                loop: true,
                className: "w-full h-full object-cover object-center rounded-[2px]",
                poster: poster,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("source", {
                    src: video,
                    type: "video/mp4"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "absolute inset-0 bg-transparent"
            })
        ]
    });
}



var $acw62 = parcelRequire("acw62");
const $473ff3de9accb412$export$5a49df65a0acfc9d = /*#__PURE__*/ (0, $acw62.forwardRef)(({ selected: selected, styleConfig: styleConfig, onClick: onClick }, ref)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: ref,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("aspect-[9/16] w-[120px] flex flex-col items-center justify-center basis-auto", "p-2 rounded border-2 bg-white cursor-pointer transition-colors", {
            "border-lit-purple": selected,
            "border-transparent": !selected
        }),
        onClick: onClick,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "relative w-full h-full object-cover object-center rounded-[2px]",
            children: styleConfig.bgPreviewVideo ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $08d62422c99e31ec$export$738f9397c06fbf48), {
                video: styleConfig.bgPreviewVideo.video,
                poster: styleConfig.bgPreviewVideo.poster
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: styleConfig.bgImg.toString(),
                        alt: styleConfig.name,
                        className: "w-full h-full object-cover object-center rounded-[2px]"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "absolute inset-0 text-[12px] text-white  flex flex-col items-center justify-center text-center overflow-hidden break-words",
                        style: {
                            textShadow: "0 0 4px rgba(0,0,0,0.5)"
                        },
                        children: styleConfig.name
                    })
                ]
            })
        })
    });
});



var $acw62 = parcelRequire("acw62");

const $e17b6cd86e079c80$var$QUICK_SELECT_STYLES = 3;
function $e17b6cd86e079c80$var$getQuickSelectStyles(selectedStyle) {
    const selectedStyleIndex = (0, $495938ea8e19aef5$export$603deb0bff13d3bd).findIndex((style)=>style.key === selectedStyle);
    if (selectedStyleIndex < 0 || selectedStyleIndex < $e17b6cd86e079c80$var$QUICK_SELECT_STYLES) return (0, $495938ea8e19aef5$export$603deb0bff13d3bd).slice(0, $e17b6cd86e079c80$var$QUICK_SELECT_STYLES);
    return [
        (0, $495938ea8e19aef5$export$603deb0bff13d3bd)[selectedStyleIndex],
        ...(0, $495938ea8e19aef5$export$603deb0bff13d3bd).slice(0, $e17b6cd86e079c80$var$QUICK_SELECT_STYLES - 1)
    ];
}
function $e17b6cd86e079c80$export$843f385214f1c099({ captionStyle: captionStyle, setCaptionStyle: setCaptionStyle }) {
    const cardRefs = (0, $acw62.useRef)({});
    const isMobile = (0, $e1951a4eca20087f$export$32d5543ab307c01)({
        query: "(max-width: 640px)"
    });
    (0, $acw62.useEffect)(()=>{
        if (!isMobile) // This causes jump on mobile, so just doing this on desktop
        cardRefs.current[captionStyle]?.scrollIntoView({
            behavior: "instant"
        });
    }, [
        isMobile
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex items-stretch overflow-x-scroll horizontal-visible-scrollbar pb-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "flex-1 flex justify-between",
            children: (0, $495938ea8e19aef5$export$603deb0bff13d3bd).map((styleConfig)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $473ff3de9accb412$export$5a49df65a0acfc9d), {
                    ref: (el)=>{
                        cardRefs.current[styleConfig.key] = el;
                    },
                    styleConfig: styleConfig,
                    selected: captionStyle === styleConfig.key,
                    onClick: ()=>setCaptionStyle(styleConfig.key)
                }, styleConfig.key))
        })
    });
}





var $acw62 = parcelRequire("acw62");

const $4850102781696fba$export$ddaf290ab5e039b4 = "flex h-10 w-full rounded-md border border-slate-200 bg-white px-3 py-2 text-sm ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-slate-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-slate-800 dark:bg-slate-950 dark:ring-offset-slate-950 dark:placeholder:text-slate-400 dark:focus-visible:ring-slate-300";
const $4850102781696fba$export$f5b8910cec6cf069 = /*#__PURE__*/ $acw62.forwardRef(({ className: className, type: type, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
        type: type,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)($4850102781696fba$export$ddaf290ab5e039b4, className),
        ref: ref,
        ...props
    });
});
$4850102781696fba$export$f5b8910cec6cf069.displayName = "Input";




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

/* -------------------------------------------------------------------------------------------------
 * Label
 * -----------------------------------------------------------------------------------------------*/ const $40af16ac68355199$var$$b73a6c6685e72184$var$NAME = "Label";
const $40af16ac68355199$export$b04be29aa201d4f5 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).label, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        onMouseDown: (event)=>{
            var _props$onMouseDown;
            (_props$onMouseDown = props.onMouseDown) === null || _props$onMouseDown === void 0 || _props$onMouseDown.call(props, event); // prevent text selection when double clicking label
            if (!event.defaultPrevented && event.detail > 1) event.preventDefault();
        }
    }));
});
/*#__PURE__*/ Object.assign($40af16ac68355199$export$b04be29aa201d4f5, {
    displayName: $40af16ac68355199$var$$b73a6c6685e72184$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $40af16ac68355199$export$be92b6f5f03c0fe9 = $40af16ac68355199$export$b04be29aa201d4f5;




const $b4d43578a5daea27$var$labelVariants = (0, $7d867aa0bbfd521e$export$87dc52566e90b739)("text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70");
const $b4d43578a5daea27$export$b04be29aa201d4f5 = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($40af16ac68355199$export$be92b6f5f03c0fe9, {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)($b4d43578a5daea27$var$labelVariants(), className),
        ...props
    }));
$b4d43578a5daea27$export$b04be29aa201d4f5.displayName = $40af16ac68355199$export$be92b6f5f03c0fe9.displayName;




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");















/* -------------------------------------------------------------------------------------------------
 * Popover
 * -----------------------------------------------------------------------------------------------*/ const $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$POPOVER_NAME = "Popover";
const [$f083a75650e73e88$var$$cb5cc270b50c6fcd$var$createPopoverContext, $f083a75650e73e88$export$c8393c9e73286932] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($f083a75650e73e88$var$$cb5cc270b50c6fcd$var$POPOVER_NAME, [
    (0, $a0ac11a1da65e329$export$722aac194ae923)
]);
const $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$usePopperScope = (0, $a0ac11a1da65e329$export$722aac194ae923)();
const [$f083a75650e73e88$var$$cb5cc270b50c6fcd$var$PopoverProvider, $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$usePopoverContext] = $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$createPopoverContext($f083a75650e73e88$var$$cb5cc270b50c6fcd$var$POPOVER_NAME);
const $f083a75650e73e88$export$5b6b19405a83ff9d = (props)=>{
    const { __scopePopover: __scopePopover, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = false } = props;
    const popperScope = $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const triggerRef = (0, $acw62.useRef)(null);
    const [hasCustomAnchor, setHasCustomAnchor] = (0, $acw62.useState)(false);
    const [open = false, setOpen] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $a0ac11a1da65e329$export$be92b6f5f03c0fe9), popperScope, /*#__PURE__*/ (0, $acw62.createElement)($f083a75650e73e88$var$$cb5cc270b50c6fcd$var$PopoverProvider, {
        scope: __scopePopover,
        contentId: (0, $11885ec535b13ccc$export$f680877a34711e37)(),
        triggerRef: triggerRef,
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: (0, $acw62.useCallback)(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        hasCustomAnchor: hasCustomAnchor,
        onCustomAnchorAdd: (0, $acw62.useCallback)(()=>setHasCustomAnchor(true), []),
        onCustomAnchorRemove: (0, $acw62.useCallback)(()=>setHasCustomAnchor(false), []),
        modal: modal
    }, children));
};
/*#__PURE__*/ Object.assign($f083a75650e73e88$export$5b6b19405a83ff9d, {
    displayName: $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$POPOVER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverAnchor
 * -----------------------------------------------------------------------------------------------*/ const $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$ANCHOR_NAME = "PopoverAnchor";
const $f083a75650e73e88$export$96e5381f42521a79 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...anchorProps } = props;
    const context = $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$usePopoverContext($f083a75650e73e88$var$$cb5cc270b50c6fcd$var$ANCHOR_NAME, __scopePopover);
    const popperScope = $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const { onCustomAnchorAdd: onCustomAnchorAdd, onCustomAnchorRemove: onCustomAnchorRemove } = context;
    (0, $acw62.useEffect)(()=>{
        onCustomAnchorAdd();
        return ()=>onCustomAnchorRemove();
    }, [
        onCustomAnchorAdd,
        onCustomAnchorRemove
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $a0ac11a1da65e329$export$b688253958b8dfe7), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, popperScope, anchorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($f083a75650e73e88$export$96e5381f42521a79, {
    displayName: $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverTrigger
 * -----------------------------------------------------------------------------------------------*/ const $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$TRIGGER_NAME = "PopoverTrigger";
const $f083a75650e73e88$export$7dacb05d26466c3 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...triggerProps } = props;
    const context = $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$usePopoverContext($f083a75650e73e88$var$$cb5cc270b50c6fcd$var$TRIGGER_NAME, __scopePopover);
    const popperScope = $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const composedTriggerRef = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    const trigger = /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).button, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$getState(context.open)
    }, triggerProps, {
        ref: composedTriggerRef,
        onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    }));
    return context.hasCustomAnchor ? trigger : /*#__PURE__*/ (0, $acw62.createElement)((0, $a0ac11a1da65e329$export$b688253958b8dfe7), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        asChild: true
    }, popperScope), trigger);
});
/*#__PURE__*/ Object.assign($f083a75650e73e88$export$7dacb05d26466c3, {
    displayName: $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverPortal
 * -----------------------------------------------------------------------------------------------*/ const $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$PORTAL_NAME = "PopoverPortal";
const [$f083a75650e73e88$var$$cb5cc270b50c6fcd$var$PortalProvider, $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$usePortalContext] = $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$createPopoverContext($f083a75650e73e88$var$$cb5cc270b50c6fcd$var$PORTAL_NAME, {
    forceMount: undefined
});
const $f083a75650e73e88$export$dd679ffb4362d2d4 = (props)=>{
    const { __scopePopover: __scopePopover, forceMount: forceMount, children: children, container: container } = props;
    const context = $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$usePopoverContext($f083a75650e73e88$var$$cb5cc270b50c6fcd$var$PORTAL_NAME, __scopePopover);
    return /*#__PURE__*/ (0, $acw62.createElement)($f083a75650e73e88$var$$cb5cc270b50c6fcd$var$PortalProvider, {
        scope: __scopePopover,
        forceMount: forceMount
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $95d053caea9c023a$export$602eac185826482c), {
        asChild: true,
        container: container
    }, children)));
};
/*#__PURE__*/ Object.assign($f083a75650e73e88$export$dd679ffb4362d2d4, {
    displayName: $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverContent
 * -----------------------------------------------------------------------------------------------*/ const $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$CONTENT_NAME = "PopoverContent";
const $f083a75650e73e88$export$d7e1f420b25549ff = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const portalContext = $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$usePortalContext($f083a75650e73e88$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$usePopoverContext($f083a75650e73e88$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, context.modal ? /*#__PURE__*/ (0, $acw62.createElement)($f083a75650e73e88$var$$cb5cc270b50c6fcd$var$PopoverContentModal, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $acw62.createElement)($f083a75650e73e88$var$$cb5cc270b50c6fcd$var$PopoverContentNonModal, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($f083a75650e73e88$export$d7e1f420b25549ff, {
    displayName: $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$PopoverContentModal = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const context = $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$usePopoverContext($f083a75650e73e88$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const contentRef = (0, $acw62.useRef)(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    const isRightClickOutsideRef = (0, $acw62.useRef)(false); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0, $acw62.useEffect)(()=>{
        const content = contentRef.current;
        if (content) return (0, $4a7537e072260c10$export$6e33d16126ed003c)(content);
    }, []);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039), {
        as: (0, $cf381de56a25bc52$export$8c6ed5c666ac1360),
        allowPinchZoom: true
    }, /*#__PURE__*/ (0, $acw62.createElement)($f083a75650e73e88$var$$cb5cc270b50c6fcd$var$PopoverContentImpl, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs // we make sure we're not trapping once it's been closed
        ,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            event.preventDefault();
            if (!isRightClickOutsideRef.current) (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
        }),
        onPointerDownOutside: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            isRightClickOutsideRef.current = isRightClick;
        }, {
            checkForDefaultPrevented: false
        }) // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault(), {
            checkForDefaultPrevented: false
        })
    })));
});
const $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$PopoverContentNonModal = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const context = $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$usePopoverContext($f083a75650e73e88$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const hasInteractedOutsideRef = (0, $acw62.useRef)(false);
    const hasPointerDownOutsideRef = (0, $acw62.useRef)(false);
    return /*#__PURE__*/ (0, $acw62.createElement)($f083a75650e73e88$var$$cb5cc270b50c6fcd$var$PopoverContentImpl, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props$onCloseAutoFoc;
            (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
            if (!event.defaultPrevented) {
                var _context$triggerRef$c2;
                if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus(); // Always prevent auto focus because we either focus manually or want user agent focus
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props$onInteractOuts, _context$triggerRef$c3;
            (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            } // Prevent dismissing when clicking the trigger.
            // As the trigger is already setup to close, without doing so would
            // cause it to close and immediately open.
            const target = event.target;
            const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
            if (targetIsTrigger) event.preventDefault(); // On Safari if the trigger is inside a container with tabIndex={0}, when clicked
            // we will get the pointer down outside event on the trigger, but then a subsequent
            // focus outside event on the container, we ignore any focus outside event when we've
            // already had a pointer down outside event.
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$PopoverContentImpl = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, disableOutsidePointerEvents: disableOutsidePointerEvents, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, ...contentProps } = props;
    const context = $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$usePopoverContext($f083a75650e73e88$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, __scopePopover);
    const popperScope = $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover); // Make sure the whole tree has focus guards as our `Popover` may be
    // the last element in the DOM (beacuse of the `Portal`)
    (0, $264faec0fdf8876a$export$b7ece24a22aeda8c)();
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $03c48a27777929a8$export$20e40289641fbbb6), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $30a399657994b369$export$177fb62ff3ec1f22), {
        asChild: true,
        disableOutsidePointerEvents: disableOutsidePointerEvents,
        onInteractOutside: onInteractOutside,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: onFocusOutside,
        onDismiss: ()=>context.onOpenChange(false)
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $a0ac11a1da65e329$export$7c6e2c02157bb7d2), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        "data-state": $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$getState(context.open),
        role: "dialog",
        id: context.contentId
    }, popperScope, contentProps, {
        ref: forwardedRef,
        style: {
            ...contentProps.style,
            "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
            "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
            "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
        }
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * PopoverClose
 * -----------------------------------------------------------------------------------------------*/ const $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$CLOSE_NAME = "PopoverClose";
const $f083a75650e73e88$export$d6ac43ebaa40d53e = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...closeProps } = props;
    const context = $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$usePopoverContext($f083a75650e73e88$var$$cb5cc270b50c6fcd$var$CLOSE_NAME, __scopePopover);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).button, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    }));
});
/*#__PURE__*/ Object.assign($f083a75650e73e88$export$d6ac43ebaa40d53e, {
    displayName: $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$CLOSE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverArrow
 * -----------------------------------------------------------------------------------------------*/ const $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$ARROW_NAME = "PopoverArrow";
const $f083a75650e73e88$export$3152841115e061b2 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...arrowProps } = props;
    const popperScope = $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $a0ac11a1da65e329$export$21b07c8f274aebd5), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, popperScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($f083a75650e73e88$export$3152841115e061b2, {
    displayName: $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $f083a75650e73e88$var$$cb5cc270b50c6fcd$var$getState(open) {
    return open ? "open" : "closed";
}
const $f083a75650e73e88$export$be92b6f5f03c0fe9 = $f083a75650e73e88$export$5b6b19405a83ff9d;
const $f083a75650e73e88$export$b688253958b8dfe7 = $f083a75650e73e88$export$96e5381f42521a79;
const $f083a75650e73e88$export$41fb9f06171c75f4 = $f083a75650e73e88$export$7dacb05d26466c3;
const $f083a75650e73e88$export$602eac185826482c = $f083a75650e73e88$export$dd679ffb4362d2d4;
const $f083a75650e73e88$export$7c6e2c02157bb7d2 = $f083a75650e73e88$export$d7e1f420b25549ff;
const $f083a75650e73e88$export$f39c2d165cd861fe = $f083a75650e73e88$export$d6ac43ebaa40d53e;
const $f083a75650e73e88$export$21b07c8f274aebd5 = $f083a75650e73e88$export$3152841115e061b2;



const $57ccbe188f8269ab$export$5b6b19405a83ff9d = $f083a75650e73e88$export$be92b6f5f03c0fe9;
const $57ccbe188f8269ab$export$7dacb05d26466c3 = $f083a75650e73e88$export$41fb9f06171c75f4;
const $57ccbe188f8269ab$export$d7e1f420b25549ff = /*#__PURE__*/ $acw62.forwardRef(({ className: className, align: align = "center", sideOffset: sideOffset = 4, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f083a75650e73e88$export$602eac185826482c, {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f083a75650e73e88$export$7c6e2c02157bb7d2, {
            ref: ref,
            align: align,
            sideOffset: sideOffset,
            className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("z-50 w-72 rounded-md border border-slate-200 bg-white p-4 text-slate-950 shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 dark:border-slate-800 dark:bg-slate-950 dark:text-slate-50", className),
            ...props
        })
    }));
$57ccbe188f8269ab$export$d7e1f420b25549ff.displayName = $f083a75650e73e88$export$7c6e2c02157bb7d2.displayName;




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");








/* -------------------------------------------------------------------------------------------------
 * Tabs
 * -----------------------------------------------------------------------------------------------*/ const $4e41c22d92371ca5$var$$69cb30bb0017df05$var$TABS_NAME = "Tabs";
const [$4e41c22d92371ca5$var$$69cb30bb0017df05$var$createTabsContext, $4e41c22d92371ca5$export$355f5bd209d7b13a] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($4e41c22d92371ca5$var$$69cb30bb0017df05$var$TABS_NAME, [
    (0, $0483c88073bf4923$export$c7109489551a4f4)
]);
const $4e41c22d92371ca5$var$$69cb30bb0017df05$var$useRovingFocusGroupScope = (0, $0483c88073bf4923$export$c7109489551a4f4)();
const [$4e41c22d92371ca5$var$$69cb30bb0017df05$var$TabsProvider, $4e41c22d92371ca5$var$$69cb30bb0017df05$var$useTabsContext] = $4e41c22d92371ca5$var$$69cb30bb0017df05$var$createTabsContext($4e41c22d92371ca5$var$$69cb30bb0017df05$var$TABS_NAME);
const $4e41c22d92371ca5$export$b2539bed5023c21c = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, value: valueProp, onValueChange: onValueChange, defaultValue: defaultValue, orientation: orientation = "horizontal", dir: dir, activationMode: activationMode = "automatic", ...tabsProps } = props;
    const direction = (0, $f9ad7d2f57cc5bec$export$b39126d51d94e6f3)(dir);
    const [value, setValue] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: valueProp,
        onChange: onValueChange,
        defaultProp: defaultValue
    });
    return /*#__PURE__*/ (0, $acw62.createElement)($4e41c22d92371ca5$var$$69cb30bb0017df05$var$TabsProvider, {
        scope: __scopeTabs,
        baseId: (0, $11885ec535b13ccc$export$f680877a34711e37)(),
        value: value,
        onValueChange: setValue,
        orientation: orientation,
        dir: direction,
        activationMode: activationMode
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        dir: direction,
        "data-orientation": orientation
    }, tabsProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($4e41c22d92371ca5$export$b2539bed5023c21c, {
    displayName: $4e41c22d92371ca5$var$$69cb30bb0017df05$var$TABS_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsList
 * -----------------------------------------------------------------------------------------------*/ const $4e41c22d92371ca5$var$$69cb30bb0017df05$var$TAB_LIST_NAME = "TabsList";
const $4e41c22d92371ca5$export$9712d22edc0d78c1 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, loop: loop = true, ...listProps } = props;
    const context = $4e41c22d92371ca5$var$$69cb30bb0017df05$var$useTabsContext($4e41c22d92371ca5$var$$69cb30bb0017df05$var$TAB_LIST_NAME, __scopeTabs);
    const rovingFocusGroupScope = $4e41c22d92371ca5$var$$69cb30bb0017df05$var$useRovingFocusGroupScope(__scopeTabs);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $0483c88073bf4923$export$be92b6f5f03c0fe9), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        asChild: true
    }, rovingFocusGroupScope, {
        orientation: context.orientation,
        dir: context.dir,
        loop: loop
    }), /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        role: "tablist",
        "aria-orientation": context.orientation
    }, listProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($4e41c22d92371ca5$export$9712d22edc0d78c1, {
    displayName: $4e41c22d92371ca5$var$$69cb30bb0017df05$var$TAB_LIST_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsTrigger
 * -----------------------------------------------------------------------------------------------*/ const $4e41c22d92371ca5$var$$69cb30bb0017df05$var$TRIGGER_NAME = "TabsTrigger";
const $4e41c22d92371ca5$export$8114b9fdfdf9f3ba = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, value: value, disabled: disabled = false, ...triggerProps } = props;
    const context = $4e41c22d92371ca5$var$$69cb30bb0017df05$var$useTabsContext($4e41c22d92371ca5$var$$69cb30bb0017df05$var$TRIGGER_NAME, __scopeTabs);
    const rovingFocusGroupScope = $4e41c22d92371ca5$var$$69cb30bb0017df05$var$useRovingFocusGroupScope(__scopeTabs);
    const triggerId = $4e41c22d92371ca5$var$$69cb30bb0017df05$var$makeTriggerId(context.baseId, value);
    const contentId = $4e41c22d92371ca5$var$$69cb30bb0017df05$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $0483c88073bf4923$export$6d08773d2e66f8f2), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        asChild: true
    }, rovingFocusGroupScope, {
        focusable: !disabled,
        active: isSelected
    }), /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).button, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        type: "button",
        role: "tab",
        "aria-selected": isSelected,
        "aria-controls": contentId,
        "data-state": isSelected ? "active" : "inactive",
        "data-disabled": disabled ? "" : undefined,
        disabled: disabled,
        id: triggerId
    }, triggerProps, {
        ref: forwardedRef,
        onMouseDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
            // only call handler if it's the left button (mousedown gets triggered by all mouse buttons)
            // but not when the control key is pressed (avoiding MacOS right click)
            if (!disabled && event.button === 0 && event.ctrlKey === false) context.onValueChange(value);
            else event.preventDefault();
        }),
        onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            if ([
                " ",
                "Enter"
            ].includes(event.key)) context.onValueChange(value);
        }),
        onFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocus, ()=>{
            // handle "automatic" activation if necessary
            // ie. activate tab following focus
            const isAutomaticActivation = context.activationMode !== "manual";
            if (!isSelected && !disabled && isAutomaticActivation) context.onValueChange(value);
        })
    })));
});
/*#__PURE__*/ Object.assign($4e41c22d92371ca5$export$8114b9fdfdf9f3ba, {
    displayName: $4e41c22d92371ca5$var$$69cb30bb0017df05$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsContent
 * -----------------------------------------------------------------------------------------------*/ const $4e41c22d92371ca5$var$$69cb30bb0017df05$var$CONTENT_NAME = "TabsContent";
const $4e41c22d92371ca5$export$bd905d70e8fd2ebb = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, value: value, forceMount: forceMount, children: children, ...contentProps } = props;
    const context = $4e41c22d92371ca5$var$$69cb30bb0017df05$var$useTabsContext($4e41c22d92371ca5$var$$69cb30bb0017df05$var$CONTENT_NAME, __scopeTabs);
    const triggerId = $4e41c22d92371ca5$var$$69cb30bb0017df05$var$makeTriggerId(context.baseId, value);
    const contentId = $4e41c22d92371ca5$var$$69cb30bb0017df05$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    const isMountAnimationPreventedRef = (0, $acw62.useRef)(isSelected);
    (0, $acw62.useEffect)(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false);
        return ()=>cancelAnimationFrame(rAF);
    }, []);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
        present: forceMount || isSelected
    }, ({ present: present })=>/*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            "data-state": isSelected ? "active" : "inactive",
            "data-orientation": context.orientation,
            role: "tabpanel",
            "aria-labelledby": triggerId,
            hidden: !present,
            id: contentId,
            tabIndex: 0
        }, contentProps, {
            ref: forwardedRef,
            style: {
                ...props.style,
                animationDuration: isMountAnimationPreventedRef.current ? "0s" : undefined
            }
        }), present && children));
});
/*#__PURE__*/ Object.assign($4e41c22d92371ca5$export$bd905d70e8fd2ebb, {
    displayName: $4e41c22d92371ca5$var$$69cb30bb0017df05$var$CONTENT_NAME
});
/* ---------------------------------------------------------------------------------------------- */ function $4e41c22d92371ca5$var$$69cb30bb0017df05$var$makeTriggerId(baseId, value) {
    return `${baseId}-trigger-${value}`;
}
function $4e41c22d92371ca5$var$$69cb30bb0017df05$var$makeContentId(baseId, value) {
    return `${baseId}-content-${value}`;
}
const $4e41c22d92371ca5$export$be92b6f5f03c0fe9 = $4e41c22d92371ca5$export$b2539bed5023c21c;
const $4e41c22d92371ca5$export$54c2e3dc7acea9f5 = $4e41c22d92371ca5$export$9712d22edc0d78c1;
const $4e41c22d92371ca5$export$41fb9f06171c75f4 = $4e41c22d92371ca5$export$8114b9fdfdf9f3ba;
const $4e41c22d92371ca5$export$7c6e2c02157bb7d2 = $4e41c22d92371ca5$export$bd905d70e8fd2ebb;



const $85bb3ced2d7ad87c$export$b2539bed5023c21c = $4e41c22d92371ca5$export$be92b6f5f03c0fe9;
const $85bb3ced2d7ad87c$export$9712d22edc0d78c1 = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4e41c22d92371ca5$export$54c2e3dc7acea9f5, {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("inline-flex h-10 items-center justify-center rounded-md bg-slate-100 p-1 text-slate-500 dark:bg-slate-800 dark:text-slate-400", className),
        ...props
    }));
$85bb3ced2d7ad87c$export$9712d22edc0d78c1.displayName = $4e41c22d92371ca5$export$54c2e3dc7acea9f5.displayName;
const $85bb3ced2d7ad87c$export$8114b9fdfdf9f3ba = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4e41c22d92371ca5$export$41fb9f06171c75f4, {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-white transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-white data-[state=active]:text-slate-950 data-[state=active]:shadow-sm dark:ring-offset-slate-950 dark:focus-visible:ring-slate-300 dark:data-[state=active]:bg-slate-950 dark:data-[state=active]:text-slate-50", className),
        ...props
    }));
$85bb3ced2d7ad87c$export$8114b9fdfdf9f3ba.displayName = $4e41c22d92371ca5$export$41fb9f06171c75f4.displayName;
const $85bb3ced2d7ad87c$export$bd905d70e8fd2ebb = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4e41c22d92371ca5$export$7c6e2c02157bb7d2, {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("mt-2 ring-offset-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 dark:ring-offset-slate-950 dark:focus-visible:ring-slate-300", className),
        ...props
    }));
$85bb3ced2d7ad87c$export$bd905d70e8fd2ebb.displayName = $4e41c22d92371ca5$export$7c6e2c02157bb7d2.displayName;




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $60195c5a78c2580e$var$u() {
    return ($60195c5a78c2580e$var$u = Object.assign || function(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = arguments[r];
            for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
        return e;
    }).apply(this, arguments);
}
function $60195c5a78c2580e$var$c(e, r) {
    if (null == e) return {};
    var t, n, o = {}, a = Object.keys(e);
    for(n = 0; n < a.length; n++)r.indexOf(t = a[n]) >= 0 || (o[t] = e[t]);
    return o;
}
function $60195c5a78c2580e$var$i(e) {
    var t = (0, $acw62.useRef)(e), n = (0, $acw62.useRef)(function(e) {
        t.current && t.current(e);
    });
    return t.current = e, n.current;
}
var $60195c5a78c2580e$var$s = function(e, r, t) {
    return void 0 === r && (r = 0), void 0 === t && (t = 1), e > t ? t : e < r ? r : e;
}, $60195c5a78c2580e$var$f = function(e) {
    return "touches" in e;
}, $60195c5a78c2580e$var$v = function(e) {
    return e && e.ownerDocument.defaultView || self;
}, $60195c5a78c2580e$var$d = function(e, r, t) {
    var n = e.getBoundingClientRect(), o = $60195c5a78c2580e$var$f(r) ? function(e, r) {
        for(var t = 0; t < e.length; t++)if (e[t].identifier === r) return e[t];
        return e[0];
    }(r.touches, t) : r;
    return {
        left: $60195c5a78c2580e$var$s((o.pageX - (n.left + $60195c5a78c2580e$var$v(e).pageXOffset)) / n.width),
        top: $60195c5a78c2580e$var$s((o.pageY - (n.top + $60195c5a78c2580e$var$v(e).pageYOffset)) / n.height)
    };
}, $60195c5a78c2580e$var$h = function(e) {
    !$60195c5a78c2580e$var$f(e) && e.preventDefault();
}, $60195c5a78c2580e$var$m = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(o) {
    var a = o.onMove, l = o.onKey, s = $60195c5a78c2580e$var$c(o, [
        "onMove",
        "onKey"
    ]), m = (0, $acw62.useRef)(null), g = $60195c5a78c2580e$var$i(a), p = $60195c5a78c2580e$var$i(l), b = (0, $acw62.useRef)(null), _ = (0, $acw62.useRef)(!1), x = (0, $acw62.useMemo)(function() {
        var e = function(e) {
            $60195c5a78c2580e$var$h(e), ($60195c5a78c2580e$var$f(e) ? e.touches.length > 0 : e.buttons > 0) && m.current ? g($60195c5a78c2580e$var$d(m.current, e, b.current)) : t(!1);
        }, r = function() {
            return t(!1);
        };
        function t(t) {
            var n = _.current, o = $60195c5a78c2580e$var$v(m.current), a = t ? o.addEventListener : o.removeEventListener;
            a(n ? "touchmove" : "mousemove", e), a(n ? "touchend" : "mouseup", r);
        }
        return [
            function(e) {
                var r = e.nativeEvent, n = m.current;
                if (n && ($60195c5a78c2580e$var$h(r), !function(e, r) {
                    return r && !$60195c5a78c2580e$var$f(e);
                }(r, _.current) && n)) {
                    if ($60195c5a78c2580e$var$f(r)) {
                        _.current = !0;
                        var o = r.changedTouches || [];
                        o.length && (b.current = o[0].identifier);
                    }
                    n.focus(), g($60195c5a78c2580e$var$d(n, r, b.current)), t(!0);
                }
            },
            function(e) {
                var r = e.which || e.keyCode;
                r < 37 || r > 40 || (e.preventDefault(), p({
                    left: 39 === r ? .05 : 37 === r ? -0.05 : 0,
                    top: 40 === r ? .05 : 38 === r ? -0.05 : 0
                }));
            },
            t
        ];
    }, [
        p,
        g
    ]), C = x[0], E = x[1], H = x[2];
    return (0, $acw62.useEffect)(function() {
        return H;
    }, [
        H
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $60195c5a78c2580e$var$u({}, s, {
        onTouchStart: C,
        onMouseDown: C,
        className: "react-colorful__interactive",
        ref: m,
        onKeyDown: E,
        tabIndex: 0,
        role: "slider"
    }));
}), $60195c5a78c2580e$var$g = function(e) {
    return e.filter(Boolean).join(" ");
}, $60195c5a78c2580e$var$p = function(r) {
    var t = r.color, n = r.left, o = r.top, a = void 0 === o ? .5 : o, l = $60195c5a78c2580e$var$g([
        "react-colorful__pointer",
        r.className
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: l,
        style: {
            top: 100 * a + "%",
            left: 100 * n + "%"
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "react-colorful__pointer-fill",
        style: {
            backgroundColor: t
        }
    }));
}, $60195c5a78c2580e$var$b = function(e, r, t) {
    return void 0 === r && (r = 0), void 0 === t && (t = Math.pow(10, r)), Math.round(t * e) / t;
}, $60195c5a78c2580e$var$_ = {
    grad: .9,
    turn: 360,
    rad: 360 / (2 * Math.PI)
}, $60195c5a78c2580e$var$x = function(e) {
    return $60195c5a78c2580e$var$L($60195c5a78c2580e$var$C(e));
}, $60195c5a78c2580e$var$C = function(e) {
    return "#" === e[0] && (e = e.substring(1)), e.length < 6 ? {
        r: parseInt(e[0] + e[0], 16),
        g: parseInt(e[1] + e[1], 16),
        b: parseInt(e[2] + e[2], 16),
        a: 4 === e.length ? $60195c5a78c2580e$var$b(parseInt(e[3] + e[3], 16) / 255, 2) : 1
    } : {
        r: parseInt(e.substring(0, 2), 16),
        g: parseInt(e.substring(2, 4), 16),
        b: parseInt(e.substring(4, 6), 16),
        a: 8 === e.length ? $60195c5a78c2580e$var$b(parseInt(e.substring(6, 8), 16) / 255, 2) : 1
    };
}, $60195c5a78c2580e$var$E = function(e, r) {
    return void 0 === r && (r = "deg"), Number(e) * ($60195c5a78c2580e$var$_[r] || 1);
}, $60195c5a78c2580e$var$H = function(e) {
    var r = /hsla?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);
    return r ? $60195c5a78c2580e$var$N({
        h: $60195c5a78c2580e$var$E(r[1], r[2]),
        s: Number(r[3]),
        l: Number(r[4]),
        a: void 0 === r[5] ? 1 : Number(r[5]) / (r[6] ? 100 : 1)
    }) : {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
}, $60195c5a78c2580e$var$M = $60195c5a78c2580e$var$H, $60195c5a78c2580e$var$N = function(e) {
    var r = e.s, t = e.l;
    return {
        h: e.h,
        s: (r *= (t < 50 ? t : 100 - t) / 100) > 0 ? 2 * r / (t + r) * 100 : 0,
        v: t + r,
        a: e.a
    };
}, $60195c5a78c2580e$var$w = function(e) {
    return $60195c5a78c2580e$var$K($60195c5a78c2580e$var$I(e));
}, $60195c5a78c2580e$var$y = function(e) {
    var r = e.s, t = e.v, n = e.a, o = (200 - r) * t / 100;
    return {
        h: $60195c5a78c2580e$var$b(e.h),
        s: $60195c5a78c2580e$var$b(o > 0 && o < 200 ? r * t / 100 / (o <= 100 ? o : 200 - o) * 100 : 0),
        l: $60195c5a78c2580e$var$b(o / 2),
        a: $60195c5a78c2580e$var$b(n, 2)
    };
}, $60195c5a78c2580e$var$q = function(e) {
    var r = $60195c5a78c2580e$var$y(e);
    return "hsl(" + r.h + ", " + r.s + "%, " + r.l + "%)";
}, $60195c5a78c2580e$var$k = function(e) {
    var r = $60195c5a78c2580e$var$y(e);
    return "hsla(" + r.h + ", " + r.s + "%, " + r.l + "%, " + r.a + ")";
}, $60195c5a78c2580e$var$I = function(e) {
    var r = e.h, t = e.s, n = e.v, o = e.a;
    r = r / 360 * 6, t /= 100, n /= 100;
    var a = Math.floor(r), l = n * (1 - t), u = n * (1 - (r - a) * t), c = n * (1 - (1 - r + a) * t), i = a % 6;
    return {
        r: $60195c5a78c2580e$var$b(255 * [
            n,
            u,
            l,
            l,
            c,
            n
        ][i]),
        g: $60195c5a78c2580e$var$b(255 * [
            c,
            n,
            n,
            u,
            l,
            l
        ][i]),
        b: $60195c5a78c2580e$var$b(255 * [
            l,
            l,
            c,
            n,
            n,
            u
        ][i]),
        a: $60195c5a78c2580e$var$b(o, 2)
    };
}, $60195c5a78c2580e$var$O = function(e) {
    var r = /hsva?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);
    return r ? $60195c5a78c2580e$var$A({
        h: $60195c5a78c2580e$var$E(r[1], r[2]),
        s: Number(r[3]),
        v: Number(r[4]),
        a: void 0 === r[5] ? 1 : Number(r[5]) / (r[6] ? 100 : 1)
    }) : {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
}, $60195c5a78c2580e$var$j = $60195c5a78c2580e$var$O, $60195c5a78c2580e$var$z = function(e) {
    var r = /rgba?\(?\s*(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);
    return r ? $60195c5a78c2580e$var$L({
        r: Number(r[1]) / (r[2] ? 100 / 255 : 1),
        g: Number(r[3]) / (r[4] ? 100 / 255 : 1),
        b: Number(r[5]) / (r[6] ? 100 / 255 : 1),
        a: void 0 === r[7] ? 1 : Number(r[7]) / (r[8] ? 100 : 1)
    }) : {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
}, $60195c5a78c2580e$var$B = $60195c5a78c2580e$var$z, $60195c5a78c2580e$var$D = function(e) {
    var r = e.toString(16);
    return r.length < 2 ? "0" + r : r;
}, $60195c5a78c2580e$var$K = function(e) {
    var r = e.r, t = e.g, n = e.b, o = e.a, a = o < 1 ? $60195c5a78c2580e$var$D($60195c5a78c2580e$var$b(255 * o)) : "";
    return "#" + $60195c5a78c2580e$var$D(r) + $60195c5a78c2580e$var$D(t) + $60195c5a78c2580e$var$D(n) + a;
}, $60195c5a78c2580e$var$L = function(e) {
    var r = e.r, t = e.g, n = e.b, o = e.a, a = Math.max(r, t, n), l = a - Math.min(r, t, n), u = l ? a === r ? (t - n) / l : a === t ? 2 + (n - r) / l : 4 + (r - t) / l : 0;
    return {
        h: $60195c5a78c2580e$var$b(60 * (u < 0 ? u + 6 : u)),
        s: $60195c5a78c2580e$var$b(a ? l / a * 100 : 0),
        v: $60195c5a78c2580e$var$b(a / 255 * 100),
        a: o
    };
}, $60195c5a78c2580e$var$A = function(e) {
    return {
        h: $60195c5a78c2580e$var$b(e.h),
        s: $60195c5a78c2580e$var$b(e.s),
        v: $60195c5a78c2580e$var$b(e.v),
        a: $60195c5a78c2580e$var$b(e.a, 2)
    };
}, $60195c5a78c2580e$var$S = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(r) {
    var t = r.hue, n = r.onChange, o = $60195c5a78c2580e$var$g([
        "react-colorful__hue",
        r.className
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: o
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($60195c5a78c2580e$var$m, {
        onMove: function(e) {
            n({
                h: 360 * e.left
            });
        },
        onKey: function(e) {
            n({
                h: $60195c5a78c2580e$var$s(t + 360 * e.left, 0, 360)
            });
        },
        "aria-label": "Hue",
        "aria-valuenow": $60195c5a78c2580e$var$b(t),
        "aria-valuemax": "360",
        "aria-valuemin": "0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($60195c5a78c2580e$var$p, {
        className: "react-colorful__hue-pointer",
        left: t / 360,
        color: $60195c5a78c2580e$var$q({
            h: t,
            s: 100,
            v: 100,
            a: 1
        })
    })));
}), $60195c5a78c2580e$var$T = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(r) {
    var t = r.hsva, n = r.onChange, o = {
        backgroundColor: $60195c5a78c2580e$var$q({
            h: t.h,
            s: 100,
            v: 100,
            a: 1
        })
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "react-colorful__saturation",
        style: o
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($60195c5a78c2580e$var$m, {
        onMove: function(e) {
            n({
                s: 100 * e.left,
                v: 100 - 100 * e.top
            });
        },
        onKey: function(e) {
            n({
                s: $60195c5a78c2580e$var$s(t.s + 100 * e.left, 0, 100),
                v: $60195c5a78c2580e$var$s(t.v - 100 * e.top, 0, 100)
            });
        },
        "aria-label": "Color",
        "aria-valuetext": "Saturation " + $60195c5a78c2580e$var$b(t.s) + "%, Brightness " + $60195c5a78c2580e$var$b(t.v) + "%"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($60195c5a78c2580e$var$p, {
        className: "react-colorful__saturation-pointer",
        top: 1 - t.v / 100,
        left: t.s / 100,
        color: $60195c5a78c2580e$var$q(t)
    })));
}), $60195c5a78c2580e$var$F = function(e, r) {
    if (e === r) return !0;
    for(var t in e)if (e[t] !== r[t]) return !1;
    return !0;
}, $60195c5a78c2580e$var$P = function(e, r) {
    return e.replace(/\s/g, "") === r.replace(/\s/g, "");
}, $60195c5a78c2580e$var$X = function(e, r) {
    return e.toLowerCase() === r.toLowerCase() || $60195c5a78c2580e$var$F($60195c5a78c2580e$var$C(e), $60195c5a78c2580e$var$C(r));
};
function $60195c5a78c2580e$var$Y(e, t, l) {
    var u = $60195c5a78c2580e$var$i(l), c = (0, $acw62.useState)(function() {
        return e.toHsva(t);
    }), s = c[0], f = c[1], v = (0, $acw62.useRef)({
        color: t,
        hsva: s
    });
    (0, $acw62.useEffect)(function() {
        if (!e.equal(t, v.current.color)) {
            var r = e.toHsva(t);
            v.current = {
                hsva: r,
                color: t
            }, f(r);
        }
    }, [
        t,
        e
    ]), (0, $acw62.useEffect)(function() {
        var r;
        $60195c5a78c2580e$var$F(s, v.current.hsva) || e.equal(r = e.fromHsva(s), v.current.color) || (v.current = {
            hsva: s,
            color: r
        }, u(r));
    }, [
        s,
        e,
        u
    ]);
    var d = (0, $acw62.useCallback)(function(e) {
        f(function(r) {
            return Object.assign({}, r, e);
        });
    }, []);
    return [
        s,
        d
    ];
}
var $60195c5a78c2580e$var$R, $60195c5a78c2580e$var$V = "undefined" != typeof window ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect), $60195c5a78c2580e$var$$ = function() {
    return $60195c5a78c2580e$var$R || ("undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : void 0);
}, $60195c5a78c2580e$export$c5f670b24c0ae95a = function(e) {
    $60195c5a78c2580e$var$R = e;
}, $60195c5a78c2580e$var$J = new Map, $60195c5a78c2580e$var$Q = function(e) {
    $60195c5a78c2580e$var$V(function() {
        var r = e.current ? e.current.ownerDocument : document;
        if (void 0 !== r && !$60195c5a78c2580e$var$J.has(r)) {
            var t = r.createElement("style");
            t.innerHTML = '.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url(\'data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>\')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}', $60195c5a78c2580e$var$J.set(r, t);
            var n = $60195c5a78c2580e$var$$();
            n && t.setAttribute("nonce", n), r.head.appendChild(t);
        }
    }, []);
}, $60195c5a78c2580e$var$U = function(t) {
    var n = t.className, o = t.colorModel, a = t.color, l = void 0 === a ? o.defaultColor : a, i = t.onChange, s = $60195c5a78c2580e$var$c(t, [
        "className",
        "colorModel",
        "color",
        "onChange"
    ]), f = (0, $acw62.useRef)(null);
    $60195c5a78c2580e$var$Q(f);
    var v = $60195c5a78c2580e$var$Y(o, l, i), d = v[0], h = v[1], m = $60195c5a78c2580e$var$g([
        "react-colorful",
        n
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $60195c5a78c2580e$var$u({}, s, {
        ref: f,
        className: m
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($60195c5a78c2580e$var$T, {
        hsva: d,
        onChange: h
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($60195c5a78c2580e$var$S, {
        hue: d.h,
        onChange: h,
        className: "react-colorful__last-control"
    }));
}, $60195c5a78c2580e$var$W = {
    defaultColor: "000",
    toHsva: $60195c5a78c2580e$var$x,
    fromHsva: function(e) {
        return $60195c5a78c2580e$var$w({
            h: e.h,
            s: e.s,
            v: e.v,
            a: 1
        });
    },
    equal: $60195c5a78c2580e$var$X
}, $60195c5a78c2580e$export$a3bc3c32746e9f3a = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($60195c5a78c2580e$var$U, $60195c5a78c2580e$var$u({}, r, {
        colorModel: $60195c5a78c2580e$var$W
    }));
}, $60195c5a78c2580e$var$ee = function(r) {
    var t = r.className, n = r.hsva, o = r.onChange, a = {
        backgroundImage: "linear-gradient(90deg, " + $60195c5a78c2580e$var$k(Object.assign({}, n, {
            a: 0
        })) + ", " + $60195c5a78c2580e$var$k(Object.assign({}, n, {
            a: 1
        })) + ")"
    }, l = $60195c5a78c2580e$var$g([
        "react-colorful__alpha",
        t
    ]), u = $60195c5a78c2580e$var$b(100 * n.a);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "react-colorful__alpha-gradient",
        style: a
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($60195c5a78c2580e$var$m, {
        onMove: function(e) {
            o({
                a: e.left
            });
        },
        onKey: function(e) {
            o({
                a: $60195c5a78c2580e$var$s(n.a + e.left)
            });
        },
        "aria-label": "Alpha",
        "aria-valuetext": u + "%",
        "aria-valuenow": u,
        "aria-valuemin": "0",
        "aria-valuemax": "100"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($60195c5a78c2580e$var$p, {
        className: "react-colorful__alpha-pointer",
        left: n.a,
        color: $60195c5a78c2580e$var$k(n)
    })));
}, $60195c5a78c2580e$var$re = function(t) {
    var n = t.className, o = t.colorModel, a = t.color, l = void 0 === a ? o.defaultColor : a, i = t.onChange, s = $60195c5a78c2580e$var$c(t, [
        "className",
        "colorModel",
        "color",
        "onChange"
    ]), f = (0, $acw62.useRef)(null);
    $60195c5a78c2580e$var$Q(f);
    var v = $60195c5a78c2580e$var$Y(o, l, i), d = v[0], h = v[1], m = $60195c5a78c2580e$var$g([
        "react-colorful",
        n
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $60195c5a78c2580e$var$u({}, s, {
        ref: f,
        className: m
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($60195c5a78c2580e$var$T, {
        hsva: d,
        onChange: h
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($60195c5a78c2580e$var$S, {
        hue: d.h,
        onChange: h
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($60195c5a78c2580e$var$ee, {
        hsva: d,
        onChange: h,
        className: "react-colorful__last-control"
    }));
}, $60195c5a78c2580e$var$te = {
    defaultColor: "0001",
    toHsva: $60195c5a78c2580e$var$x,
    fromHsva: $60195c5a78c2580e$var$w,
    equal: $60195c5a78c2580e$var$X
}, $60195c5a78c2580e$export$ac2f77823341da45 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($60195c5a78c2580e$var$re, $60195c5a78c2580e$var$u({}, r, {
        colorModel: $60195c5a78c2580e$var$te
    }));
}, $60195c5a78c2580e$var$oe = {
    defaultColor: {
        h: 0,
        s: 0,
        l: 0,
        a: 1
    },
    toHsva: $60195c5a78c2580e$var$N,
    fromHsva: $60195c5a78c2580e$var$y,
    equal: $60195c5a78c2580e$var$F
}, $60195c5a78c2580e$export$ee0b0fc8d408da1d = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($60195c5a78c2580e$var$re, $60195c5a78c2580e$var$u({}, r, {
        colorModel: $60195c5a78c2580e$var$oe
    }));
}, $60195c5a78c2580e$var$le = {
    defaultColor: "hsla(0, 0%, 0%, 1)",
    toHsva: $60195c5a78c2580e$var$H,
    fromHsva: $60195c5a78c2580e$var$k,
    equal: $60195c5a78c2580e$var$P
}, $60195c5a78c2580e$export$989f0248ad966033 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($60195c5a78c2580e$var$re, $60195c5a78c2580e$var$u({}, r, {
        colorModel: $60195c5a78c2580e$var$le
    }));
}, $60195c5a78c2580e$var$ce = {
    defaultColor: {
        h: 0,
        s: 0,
        l: 0
    },
    toHsva: function(e) {
        return $60195c5a78c2580e$var$N({
            h: e.h,
            s: e.s,
            l: e.l,
            a: 1
        });
    },
    fromHsva: function(e) {
        var r;
        return {
            h: (r = $60195c5a78c2580e$var$y(e)).h,
            s: r.s,
            l: r.l
        };
    },
    equal: $60195c5a78c2580e$var$F
}, $60195c5a78c2580e$export$c737d6c85aab3af7 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($60195c5a78c2580e$var$U, $60195c5a78c2580e$var$u({}, r, {
        colorModel: $60195c5a78c2580e$var$ce
    }));
}, $60195c5a78c2580e$var$se = {
    defaultColor: "hsl(0, 0%, 0%)",
    toHsva: $60195c5a78c2580e$var$M,
    fromHsva: $60195c5a78c2580e$var$q,
    equal: $60195c5a78c2580e$var$P
}, $60195c5a78c2580e$export$f4f988c96ece960 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($60195c5a78c2580e$var$U, $60195c5a78c2580e$var$u({}, r, {
        colorModel: $60195c5a78c2580e$var$se
    }));
}, $60195c5a78c2580e$var$ve = {
    defaultColor: {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    },
    toHsva: function(e) {
        return e;
    },
    fromHsva: $60195c5a78c2580e$var$A,
    equal: $60195c5a78c2580e$var$F
}, $60195c5a78c2580e$export$a2298f22bee4c5fd = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($60195c5a78c2580e$var$re, $60195c5a78c2580e$var$u({}, r, {
        colorModel: $60195c5a78c2580e$var$ve
    }));
}, $60195c5a78c2580e$var$he = {
    defaultColor: "hsva(0, 0%, 0%, 1)",
    toHsva: $60195c5a78c2580e$var$O,
    fromHsva: function(e) {
        var r = $60195c5a78c2580e$var$A(e);
        return "hsva(" + r.h + ", " + r.s + "%, " + r.v + "%, " + r.a + ")";
    },
    equal: $60195c5a78c2580e$var$P
}, $60195c5a78c2580e$export$b2c7d62665b7ee26 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($60195c5a78c2580e$var$re, $60195c5a78c2580e$var$u({}, r, {
        colorModel: $60195c5a78c2580e$var$he
    }));
}, $60195c5a78c2580e$var$ge = {
    defaultColor: {
        h: 0,
        s: 0,
        v: 0
    },
    toHsva: function(e) {
        return {
            h: e.h,
            s: e.s,
            v: e.v,
            a: 1
        };
    },
    fromHsva: function(e) {
        var r = $60195c5a78c2580e$var$A(e);
        return {
            h: r.h,
            s: r.s,
            v: r.v
        };
    },
    equal: $60195c5a78c2580e$var$F
}, $60195c5a78c2580e$export$580e7249020ee39f = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($60195c5a78c2580e$var$U, $60195c5a78c2580e$var$u({}, r, {
        colorModel: $60195c5a78c2580e$var$ge
    }));
}, $60195c5a78c2580e$var$be = {
    defaultColor: "hsv(0, 0%, 0%)",
    toHsva: $60195c5a78c2580e$var$j,
    fromHsva: function(e) {
        var r = $60195c5a78c2580e$var$A(e);
        return "hsv(" + r.h + ", " + r.s + "%, " + r.v + "%)";
    },
    equal: $60195c5a78c2580e$var$P
}, $60195c5a78c2580e$export$ef09412d0ef04fda = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($60195c5a78c2580e$var$U, $60195c5a78c2580e$var$u({}, r, {
        colorModel: $60195c5a78c2580e$var$be
    }));
}, $60195c5a78c2580e$var$xe = {
    defaultColor: {
        r: 0,
        g: 0,
        b: 0,
        a: 1
    },
    toHsva: $60195c5a78c2580e$var$L,
    fromHsva: $60195c5a78c2580e$var$I,
    equal: $60195c5a78c2580e$var$F
}, $60195c5a78c2580e$export$e9c07ef2be187cb1 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($60195c5a78c2580e$var$re, $60195c5a78c2580e$var$u({}, r, {
        colorModel: $60195c5a78c2580e$var$xe
    }));
}, $60195c5a78c2580e$var$Ee = {
    defaultColor: "rgba(0, 0, 0, 1)",
    toHsva: $60195c5a78c2580e$var$z,
    fromHsva: function(e) {
        var r = $60195c5a78c2580e$var$I(e);
        return "rgba(" + r.r + ", " + r.g + ", " + r.b + ", " + r.a + ")";
    },
    equal: $60195c5a78c2580e$var$P
}, $60195c5a78c2580e$export$be07dcc7abc11a36 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($60195c5a78c2580e$var$re, $60195c5a78c2580e$var$u({}, r, {
        colorModel: $60195c5a78c2580e$var$Ee
    }));
}, $60195c5a78c2580e$var$Me = {
    defaultColor: {
        r: 0,
        g: 0,
        b: 0
    },
    toHsva: function(e) {
        return $60195c5a78c2580e$var$L({
            r: e.r,
            g: e.g,
            b: e.b,
            a: 1
        });
    },
    fromHsva: function(e) {
        var r;
        return {
            r: (r = $60195c5a78c2580e$var$I(e)).r,
            g: r.g,
            b: r.b
        };
    },
    equal: $60195c5a78c2580e$var$F
}, $60195c5a78c2580e$export$5ac2ba36722d4bd2 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($60195c5a78c2580e$var$U, $60195c5a78c2580e$var$u({}, r, {
        colorModel: $60195c5a78c2580e$var$Me
    }));
}, $60195c5a78c2580e$var$we = {
    defaultColor: "rgb(0, 0, 0)",
    toHsva: $60195c5a78c2580e$var$B,
    fromHsva: function(e) {
        var r = $60195c5a78c2580e$var$I(e);
        return "rgb(" + r.r + ", " + r.g + ", " + r.b + ")";
    },
    equal: $60195c5a78c2580e$var$P
}, $60195c5a78c2580e$export$9d70f030bf44a214 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($60195c5a78c2580e$var$U, $60195c5a78c2580e$var$u({}, r, {
        colorModel: $60195c5a78c2580e$var$we
    }));
}, $60195c5a78c2580e$var$qe = /^#?([0-9A-F]{3,8})$/i, $60195c5a78c2580e$var$ke = function(r) {
    var t = r.color, l = void 0 === t ? "" : t, s = r.onChange, f = r.onBlur, v = r.escape, d = r.validate, h = r.format, m = r.process, g = $60195c5a78c2580e$var$c(r, [
        "color",
        "onChange",
        "onBlur",
        "escape",
        "validate",
        "format",
        "process"
    ]), p = (0, $acw62.useState)(function() {
        return v(l);
    }), b = p[0], _ = p[1], x = $60195c5a78c2580e$var$i(s), C = $60195c5a78c2580e$var$i(f), E = (0, $acw62.useCallback)(function(e) {
        var r = v(e.target.value);
        _(r), d(r) && x(m ? m(r) : r);
    }, [
        v,
        m,
        d,
        x
    ]), H = (0, $acw62.useCallback)(function(e) {
        d(e.target.value) || _(v(l)), C(e);
    }, [
        l,
        v,
        d,
        C
    ]);
    return (0, $acw62.useEffect)(function() {
        _(v(l));
    }, [
        l,
        v
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", $60195c5a78c2580e$var$u({}, g, {
        value: h ? h(b) : b,
        spellCheck: "false",
        onChange: E,
        onBlur: H
    }));
}, $60195c5a78c2580e$var$Ie = function(e) {
    return "#" + e;
}, $60195c5a78c2580e$export$9219d762117624b6 = function(r) {
    var t = r.prefixed, n = r.alpha, o = $60195c5a78c2580e$var$c(r, [
        "prefixed",
        "alpha"
    ]), l = (0, $acw62.useCallback)(function(e) {
        return e.replace(/([^0-9A-F]+)/gi, "").substring(0, n ? 8 : 6);
    }, [
        n
    ]), i = (0, $acw62.useCallback)(function(e) {
        return function(e, r) {
            var t = $60195c5a78c2580e$var$qe.exec(e), n = t ? t[1].length : 0;
            return 3 === n || 6 === n || !!r && 4 === n || !!r && 8 === n;
        }(e, n);
    }, [
        n
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($60195c5a78c2580e$var$ke, $60195c5a78c2580e$var$u({}, o, {
        escape: l,
        format: t ? $60195c5a78c2580e$var$Ie : void 0,
        process: $60195c5a78c2580e$var$Ie,
        validate: i
    }));
};



const $d1ee733c72e2dfda$var$ColorCircle = ({ color: color, interactive: interactive = false })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("inline-block w-8 h-8 rounded-full ring-1 ring-black/50", {
            "hover:opacity-80 transition-opacity cursor-pointer": interactive
        }),
        style: {
            backgroundColor: color
        }
    });
const $d1ee733c72e2dfda$var$PRESET_COLOR_PALETTES = [
    [
        "#006769",
        "#40A578",
        "#9DDE8B",
        "#E6FF94"
    ],
    [
        "#6F4E37",
        "#A67B5B",
        "#ECB176",
        "#FED8B1"
    ],
    [
        "#164863",
        "#427D9D",
        "#9BBEC8",
        "#DDF2FD"
    ],
    [
        "#264653",
        "#2A9D8F",
        "#E9C46A",
        "#F4A261",
        "#E76F51"
    ],
    [
        "#E63946",
        "#F1FAEE",
        "#A8DADC",
        "#457B9D",
        "#1D3557"
    ],
    [
        "#CDB4DB",
        "#FFC8DD",
        "#FFAFCC",
        "#BDE0FE",
        "#A2D2FF"
    ],
    [
        "#355070",
        "#6D597A",
        "#B56576",
        "#E56B6F",
        "#EAAC8B"
    ]
];
function $d1ee733c72e2dfda$export$13cf15360203042f({ color: color, setColor: setColor }) {
    const hexCodeInputId = (0, $acw62.useId)();
    const isMobile = (0, $e1951a4eca20087f$export$32d5543ab307c01)({
        query: "(max-width: 640px)"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $57ccbe188f8269ab$export$5b6b19405a83ff9d), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57ccbe188f8269ab$export$7dacb05d26466c3), {
                className: "flex",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d1ee733c72e2dfda$var$ColorCircle, {
                    color: color,
                    interactive: true
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57ccbe188f8269ab$export$d7e1f420b25549ff), {
                className: "p-4 font-outfit",
                side: isMobile ? "top" : "right",
                sideOffset: 16,
                collisionPadding: 24,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                            className: "font-medium",
                            children: "Select color"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm text-gray-500",
                            children: "Enter a hex code or click on a preset color or choose a custom color."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $85bb3ced2d7ad87c$export$b2539bed5023c21c), {
                            defaultValue: "presets",
                            className: "w-full mt-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $85bb3ced2d7ad87c$export$9712d22edc0d78c1), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $85bb3ced2d7ad87c$export$8114b9fdfdf9f3ba), {
                                            value: "presets",
                                            children: "Presets"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $85bb3ced2d7ad87c$export$8114b9fdfdf9f3ba), {
                                            value: "hex",
                                            children: "Hex"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $85bb3ced2d7ad87c$export$8114b9fdfdf9f3ba), {
                                            value: "custom",
                                            children: "Custom"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $85bb3ced2d7ad87c$export$bd905d70e8fd2ebb), {
                                    value: "hex",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-4 flex items-center gap-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4d43578a5daea27$export$b04be29aa201d4f5), {
                                                className: "text-base font-medium text-primary",
                                                htmlFor: hexCodeInputId,
                                                children: "Hex code"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $60195c5a78c2580e$export$9219d762117624b6), {
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("flex-1 uppercase", (0, $4850102781696fba$export$ddaf290ab5e039b4)),
                                                id: hexCodeInputId,
                                                prefixed: true,
                                                color: color,
                                                onChange: setColor
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $85bb3ced2d7ad87c$export$bd905d70e8fd2ebb), {
                                    value: "presets",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mt-4 flex flex-col gap-2",
                                        children: $d1ee733c72e2dfda$var$PRESET_COLOR_PALETTES.map((palette, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "flex gap-2",
                                                children: palette.map((color)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        onClick: ()=>{
                                                            setColor(color);
                                                        },
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d1ee733c72e2dfda$var$ColorCircle, {
                                                            color: color,
                                                            interactive: true
                                                        })
                                                    }, color))
                                            }, index))
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $85bb3ced2d7ad87c$export$bd905d70e8fd2ebb), {
                                    value: "custom",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mt-4 lit-colorpicker",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $60195c5a78c2580e$export$a3bc3c32746e9f3a), {
                                            color: color,
                                            onChange: setColor
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}





function $4c4b37f7bea87ab7$export$e08e3b67e392101e(...funcs) {
    return (...args)=>{
        return funcs.slice(1).reduce((acc, fn)=>fn(acc), funcs[0](...args));
    };
}
function $4c4b37f7bea87ab7$export$f672e0b6f7222cd7(...funcs) {
    return funcs.reverse().reduce((acc, fn)=>fn(acc));
}
const $4c4b37f7bea87ab7$export$e45945969df8035a = (fn, ...args)=>{
    return (...rest)=>fn(...[
            ...args,
            ...rest
        ]);
};
const $4c4b37f7bea87ab7$export$550093b3a1e4e3ec = (fn, argobj)=>{
    return (restobj)=>fn({
            ...argobj,
            ...restobj
        });
};
const $4c4b37f7bea87ab7$export$1cd5593a781c094c = (handler)=>{
    return new Proxy({}, {
        get: (target, propertyName)=>handler(propertyName)
    });
};
const $4c4b37f7bea87ab7$var$memoize = (cache, func, keyFunc, ttl)=>{
    return function callWithMemo(...args) {
        const key = keyFunc ? keyFunc(...args) : JSON.stringify({
            args: args
        });
        const existing = cache[key];
        if (existing !== void 0) {
            if (!existing.exp) return existing.value;
            if (existing.exp > new Date().getTime()) return existing.value;
        }
        const result = func(...args);
        cache[key] = {
            exp: ttl ? new Date().getTime() + ttl : null,
            value: result
        };
        return result;
    };
};
const $4c4b37f7bea87ab7$export$7c73462e0d25e514 = (func, options = {})=>{
    return $4c4b37f7bea87ab7$var$memoize({}, func, options.key ?? null, options.ttl ?? null);
};
const $4c4b37f7bea87ab7$export$61fc7d43ac8f84b0 = ({ delay: delay }, func)=>{
    let timer = void 0;
    let active = true;
    const debounced = (...args)=>{
        if (active) {
            clearTimeout(timer);
            timer = setTimeout(()=>{
                active && func(...args);
                timer = void 0;
            }, delay);
        } else func(...args);
    };
    debounced.isPending = ()=>{
        return timer !== void 0;
    };
    debounced.cancel = ()=>{
        active = false;
    };
    debounced.flush = (...args)=>func(...args);
    return debounced;
};
const $4c4b37f7bea87ab7$export$de363e709c412c8a = ({ interval: interval }, func)=>{
    let ready = true;
    let timer = void 0;
    const throttled = (...args)=>{
        if (!ready) return;
        func(...args);
        ready = false;
        timer = setTimeout(()=>{
            ready = true;
            timer = void 0;
        }, interval);
    };
    throttled.isThrottled = ()=>{
        return timer !== void 0;
    };
    return throttled;
};
const $4c4b37f7bea87ab7$export$6008ed0913d59b7a = (obj, fn)=>{
    const FUNC = ()=>{};
    return new Proxy(Object.assign(FUNC, obj), {
        get: (target, key)=>target[key],
        set: (target, key, value)=>{
            target[key] = value;
            return true;
        },
        apply: (target, self, args)=>fn(Object.assign({}, target))(...args)
    });
};

const $8ec73ad99a2999b4$export$a244864fd9645c7f = (value)=>{
    return !!value && value.constructor === Symbol;
};
const $8ec73ad99a2999b4$export$43bee75e5e14138e = Array.isArray;
const $8ec73ad99a2999b4$export$a6cdc56e425d0d0a = (value)=>{
    return !!value && value.constructor === Object;
};
const $8ec73ad99a2999b4$export$c3825b437cbdea5c = (value)=>{
    return value === void 0 || value === null || typeof value !== "object" && typeof value !== "function";
};
const $8ec73ad99a2999b4$export$f6e2535fb5126e54 = (value)=>{
    return !!(value && value.constructor && value.call && value.apply);
};
const $8ec73ad99a2999b4$export$844ec244b1367d54 = (value)=>{
    return typeof value === "string" || value instanceof String;
};
const $8ec73ad99a2999b4$export$357fc28f6427af8b = (value)=>{
    return $8ec73ad99a2999b4$export$7e4aa119212bc614(value) && value % 1 === 0;
};
const $8ec73ad99a2999b4$export$4ba1d6600e2a2892 = (value)=>{
    return $8ec73ad99a2999b4$export$7e4aa119212bc614(value) && value % 1 !== 0;
};
const $8ec73ad99a2999b4$export$7e4aa119212bc614 = (value)=>{
    try {
        return Number(value) === value;
    } catch  {
        return false;
    }
};
const $8ec73ad99a2999b4$export$871608497c498473 = (value)=>{
    return Object.prototype.toString.call(value) === "[object Date]";
};
const $8ec73ad99a2999b4$export$4369c812aac99591 = (value)=>{
    if (!value) return false;
    if (!value.then) return false;
    if (!$8ec73ad99a2999b4$export$f6e2535fb5126e54(value.then)) return false;
    return true;
};
const $8ec73ad99a2999b4$export$dd1bc94b04021eeb = (value)=>{
    if (value === true || value === false) return true;
    if (value === null || value === void 0) return true;
    if ($8ec73ad99a2999b4$export$7e4aa119212bc614(value)) return value === 0;
    if ($8ec73ad99a2999b4$export$871608497c498473(value)) return isNaN(value.getTime());
    if ($8ec73ad99a2999b4$export$f6e2535fb5126e54(value)) return false;
    if ($8ec73ad99a2999b4$export$a244864fd9645c7f(value)) return false;
    const length = value.length;
    if ($8ec73ad99a2999b4$export$7e4aa119212bc614(length)) return length === 0;
    const size = value.size;
    if ($8ec73ad99a2999b4$export$7e4aa119212bc614(size)) return size === 0;
    const keys = Object.keys(value).length;
    return keys === 0;
};
const $8ec73ad99a2999b4$export$248d38f6296296c5 = (x, y)=>{
    if (Object.is(x, y)) return true;
    if (x instanceof Date && y instanceof Date) return x.getTime() === y.getTime();
    if (x instanceof RegExp && y instanceof RegExp) return x.toString() === y.toString();
    if (typeof x !== "object" || x === null || typeof y !== "object" || y === null) return false;
    const keysX = Reflect.ownKeys(x);
    const keysY = Reflect.ownKeys(y);
    if (keysX.length !== keysY.length) return false;
    for(let i = 0; i < keysX.length; i++){
        if (!Reflect.has(y, keysX[i])) return false;
        if (!$8ec73ad99a2999b4$export$248d38f6296296c5(x[keysX[i]], y[keysX[i]])) return false;
    }
    return true;
};




function $216512ca0afd5ff0$var$getInitialVariables() {
    return {
        id: undefined,
        playerParams: undefined,
        captionStyle: undefined,
        captionStylePropertyOverrides: {}
    };
}
function $216512ca0afd5ff0$var$getActions(set, get) {
    return {
        setPlayerParams: ({ id: id, playerParams: playerParams })=>{
            set({
                id: id,
                playerParams: playerParams
            });
        },
        changeCaptionStyle: (captionStyle)=>{
            const currentCaptionStyle = get().captionStyle;
            if (currentCaptionStyle === captionStyle) return;
            const currentCaptionStylePropertyOverrides = get().captionStylePropertyOverrides;
            // Need to update caption style property overrides
            //   const captionStylePropertyOverrides =
            //     migrateCaptionStylePropertyOverrides(
            //       currentCaptionStyle,
            //       captionStyle,
            //       currentCaptionStylePropertyOverrides
            //     );
            set({
                captionStyle: captionStyle,
                captionStylePropertyOverrides: {}
            });
        },
        resetStore: ()=>{
            // May have to deal with pending updates before this
            set($216512ca0afd5ff0$var$getInitialVariables());
        },
        setCaptionStylePropertyOverrides: (values)=>{
            set({
                captionStylePropertyOverrides: values
            });
        },
        flushChanges: async ()=>{
            $216512ca0afd5ff0$var$debouncedSaveChanges.cancel();
            await $216512ca0afd5ff0$var$saveChanges();
        }
    };
}
const $216512ca0afd5ff0$export$3771425708360732 = (0, $ab3cb874dadc0915$export$185802fd694ee1f5)()((0, $db1029f36b931e86$export$6922d3b3a607469e)((0, $db1029f36b931e86$export$5c593627aef9f076)((set, get)=>({
        ...$216512ca0afd5ff0$var$getInitialVariables(),
        ...$216512ca0afd5ff0$var$getActions(set, get)
    }))));
const $216512ca0afd5ff0$var$saveChanges = async ()=>{
    // save changes
    console.log("Saving changes");
    const { id: id, captionStyle: captionStyle, captionStylePropertyOverrides: captionStylePropertyOverrides } = $216512ca0afd5ff0$export$3771425708360732.getState();
    if (!id) {
        console.log("No project id actively editing");
        return;
    }
    if (!captionStyle) {
        console.error("No caption style");
        return;
    }
    let captionStyleSettings = null;
    if (!(0, $8ec73ad99a2999b4$export$dd1bc94b04021eeb)(captionStylePropertyOverrides)) captionStyleSettings = captionStylePropertyOverrides;
    try {
        await (0, $21f88f1227598e15$export$ae3b9d24cc82af70)({
            projectId: id,
            captionStyle: captionStyle,
            captionStyleSettings: captionStyleSettings
        });
    } catch (error) {
        console.error("Failed to save caption style settings", error);
        if (error instanceof (0, $21f88f1227598e15$export$8a9c04b0629a0419)) (0, $fd27deb97aace157$export$650ce9f0b4df82fd).setState({
            loggedIn: false
        });
        throw error;
    }
};
const $216512ca0afd5ff0$var$debouncedSaveChanges = (0, $4c4b37f7bea87ab7$export$61fc7d43ac8f84b0)({
    delay: 500
}, async ()=>{
    // save changes
    await $216512ca0afd5ff0$var$saveChanges();
});
$216512ca0afd5ff0$export$3771425708360732.subscribe((state)=>({
        captionStyle: state.captionStyle,
        captionStylePropertyOverrides: state.captionStylePropertyOverrides
    }), (state)=>{
    console.log("useEditorStore changed", state);
    $216512ca0afd5ff0$var$debouncedSaveChanges();
}, {
    equalityFn: (0, (/*@__PURE__*/$parcel$interopDefault($54da56340462fe8a$exports)))
}); // export function useSlideshowPreviewStoreHasChanges() {
 //   const slideshow = useEditorStore((state) => state.slideshow);
 //   const sizeFormat = useEditorStore((state) => state.sizeFormat);
 //   return sizeFormat !== slideshow?.settings.sizeFormat;
 // }







var $acw62 = parcelRequire("acw62");



const $cf0004c49f91f5bc$export$3ddf2d174ce01153 = $eeaeb48e23f662e7$export$be92b6f5f03c0fe9;
const $cf0004c49f91f5bc$export$2e1e1122cf0cba88 = $eeaeb48e23f662e7$export$41fb9f06171c75f4;
const $cf0004c49f91f5bc$export$dad7c95542bacce0 = $eeaeb48e23f662e7$export$602eac185826482c;
const $cf0004c49f91f5bc$export$fba2fb7cd781b7ac = $eeaeb48e23f662e7$export$f39c2d165cd861fe;
const $cf0004c49f91f5bc$export$bd1d06c79be19e17 = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$c6fdb837b070b4ff, {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", className),
        ...props
    }));
$cf0004c49f91f5bc$export$bd1d06c79be19e17.displayName = $eeaeb48e23f662e7$export$c6fdb837b070b4ff.displayName;
const $cf0004c49f91f5bc$export$b6d9565de1e068cf = /*#__PURE__*/ $acw62.forwardRef(({ className: className, children: children, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($cf0004c49f91f5bc$export$dad7c95542bacce0, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cf0004c49f91f5bc$export$bd1d06c79be19e17, {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($eeaeb48e23f662e7$export$7c6e2c02157bb7d2, {
                ref: ref,
                className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border border-slate-200 bg-white p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg dark:border-slate-800 dark:bg-slate-950", className),
                ...props,
                children: [
                    children,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($eeaeb48e23f662e7$export$f39c2d165cd861fe, {
                        className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-white transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-slate-950 focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-slate-100 data-[state=open]:text-slate-500 dark:ring-offset-slate-950 dark:focus:ring-slate-300 dark:data-[state=open]:bg-slate-800 dark:data-[state=open]:text-slate-400",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                className: "h-4 w-4"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "sr-only",
                                children: "Close"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
$cf0004c49f91f5bc$export$b6d9565de1e068cf.displayName = $eeaeb48e23f662e7$export$7c6e2c02157bb7d2.displayName;
const $cf0004c49f91f5bc$export$742513523b177e3b = ({ className: className, ...props })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("flex flex-col space-y-1.5 text-center sm:text-left", className),
        ...props
    });
$cf0004c49f91f5bc$export$742513523b177e3b.displayName = "DialogHeader";
const $cf0004c49f91f5bc$export$7bbfb2d443473050 = ({ className: className, ...props })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", className),
        ...props
    });
$cf0004c49f91f5bc$export$7bbfb2d443473050.displayName = "DialogFooter";
const $cf0004c49f91f5bc$export$16f7638e4a34b909 = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$f99233281efd08a0, {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("text-lg font-semibold leading-none tracking-tight", className),
        ...props
    }));
$cf0004c49f91f5bc$export$16f7638e4a34b909.displayName = $eeaeb48e23f662e7$export$f99233281efd08a0.displayName;
const $cf0004c49f91f5bc$export$94e94c2ec2c954d5 = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$393edc798c47379d, {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("text-sm text-slate-500 dark:text-slate-400", className),
        ...props
    }));
$cf0004c49f91f5bc$export$94e94c2ec2c954d5.displayName = $eeaeb48e23f662e7$export$393edc798c47379d.displayName;









var $acw62 = parcelRequire("acw62");

function $e0c5125ddfb6c833$var$toMinutesString(minutes) {
    return minutes === 1 ? "1 minute" : `${minutes} minutes`;
}
function $e0c5125ddfb6c833$export$bb62a0a317a10219({ trigger: trigger }) {
    const { toast: toast } = (0, $9898a26843c73274$export$a407b657d3044108)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const id = (0, $216512ca0afd5ff0$export$3771425708360732)((state)=>state.id);
    const flushChanges = (0, $216512ca0afd5ff0$export$3771425708360732)((state)=>state.flushChanges);
    const canExportProjectM = (0, $af10f25532815273$export$b8fc23a8b701aa67)((0, $21f88f1227598e15$export$f3ec3b23e901d6d0));
    const exportProjectM = (0, $af10f25532815273$export$b8fc23a8b701aa67)((0, $21f88f1227598e15$export$619681a4b6d28e2e));
    const [dialogOpen, setDialogOpen] = (0, $acw62.useState)(false);
    const [exportEligibilityState, setExportEligibilityState] = (0, $acw62.useState)(null);
    const handleExport = async ()=>{
        await flushChanges();
        const exportId = await exportProjectM(id);
        setDialogOpen(false);
        console.log("Exported video", exportId);
        navigate(`/exports/${exportId}`);
    };
    const dialogContent = (()=>{
        if (!exportEligibilityState) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
            className: "animate-spin h-8 w-8"
        });
        if (!exportEligibilityState.canExport) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
            className: "my-4",
            children: [
                "You do not have enough minutes to export this video.",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                "You have",
                " ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    children: $e0c5125ddfb6c833$var$toMinutesString(exportEligibilityState.minutesRemaining)
                }),
                " ",
                "remaining.",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                "You need",
                " ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    children: $e0c5125ddfb6c833$var$toMinutesString(exportEligibilityState.minutesToConsume)
                }),
                " ",
                "for this export."
            ]
        });
        if (exportEligibilityState.canExport) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
            className: "my-4",
            children: [
                "This export will consume",
                " ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    children: $e0c5125ddfb6c833$var$toMinutesString(exportEligibilityState.minutesToConsume)
                }),
                ".",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                "You have",
                " ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    children: $e0c5125ddfb6c833$var$toMinutesString(exportEligibilityState.minutesRemaining)
                }),
                " ",
                "remaining."
            ]
        });
    })();
    const dialogFooterContent = (()=>{
        if (!exportEligibilityState) return null;
        if (!exportEligibilityState.canExport) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b132ebe58e154a99$export$353f5b6fc5456de1), {
                    variant: "secondary",
                    onClick: ()=>setDialogOpen(false),
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
                    action: (0, $c2a581aa5067f626$export$a2806f257ddae97a),
                    method: "POST",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b132ebe58e154a99$export$353f5b6fc5456de1), {
                        variant: "default",
                        onClick: ()=>setDialogOpen(false),
                        children: "Buy minutes"
                    })
                })
            ]
        });
        if (exportEligibilityState.canExport) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b132ebe58e154a99$export$353f5b6fc5456de1), {
                    variant: "secondary",
                    onClick: ()=>setDialogOpen(false),
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b132ebe58e154a99$export$353f5b6fc5456de1), {
                    type: "button",
                    onClick: handleExport,
                    children: "Confirm Export"
                })
            ]
        });
    })();
    const onExportTriggerClick = async ()=>{
        await flushChanges();
        if (!id) throw new Error("Project ID is missing");
        try {
            setExportEligibilityState(await canExportProjectM(id));
        } catch (e) {
            console.error("Failed to check export eligibility", e);
            toast({
                variant: "destructive",
                title: "Failed to check export eligibility"
            });
            setDialogOpen(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cf0004c49f91f5bc$export$3ddf2d174ce01153), {
        open: dialogOpen,
        onOpenChange: (isOpen)=>setDialogOpen(isOpen),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf0004c49f91f5bc$export$2e1e1122cf0cba88), {
                onClick: onExportTriggerClick,
                asChild: true,
                children: trigger
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cf0004c49f91f5bc$export$b6d9565de1e068cf), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf0004c49f91f5bc$export$742513523b177e3b), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf0004c49f91f5bc$export$16f7638e4a34b909), {
                            children: "Export Video"
                        })
                    }),
                    dialogContent,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf0004c49f91f5bc$export$7bbfb2d443473050), {
                        className: "gap-2 sm:gap-0",
                        children: dialogFooterContent
                    })
                ]
            })
        ]
    });
}





function $962d3f1718761a26$export$2e2bcd8739ae039() {
    const { id: id } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const playerParams = (0, $216512ca0afd5ff0$export$3771425708360732)((state)=>state.playerParams);
    const captionStyle = (0, $216512ca0afd5ff0$export$3771425708360732)((state)=>state.captionStyle);
    const captionStylePropertyOverrides = (0, $216512ca0afd5ff0$export$3771425708360732)((state)=>state.captionStylePropertyOverrides);
    const resetStore = (0, $216512ca0afd5ff0$export$3771425708360732)((state)=>state.resetStore);
    const setPlayerParams = (0, $216512ca0afd5ff0$export$3771425708360732)((state)=>state.setPlayerParams);
    const setCaptionStylePropertyOverrides = (0, $216512ca0afd5ff0$export$3771425708360732)((state)=>state.setCaptionStylePropertyOverrides);
    const changeCaptionStyle = (0, $216512ca0afd5ff0$export$3771425708360732)((state)=>state.changeCaptionStyle);
    const getProjectM = (0, $af10f25532815273$export$b8fc23a8b701aa67)((0, $21f88f1227598e15$export$637b60a42bb03f06));
    const captionStyleConfig = (0, $acw62.useMemo)(()=>{
        if (!captionStyle) return null;
        return (0, $495938ea8e19aef5$export$603deb0bff13d3bd).find((style)=>style.key === captionStyle);
    }, [
        captionStyle
    ]);
    (0, $acw62.useEffect)(()=>{
        resetStore();
    }, [
        id
    ]);
    const captionStylePropertyOptions = (0, $acw62.useMemo)(()=>{
        if (!captionStyleConfig) return [];
        const { spec: spec, defaultValues: defaultValues } = captionStyleConfig;
        const { properties: properties } = spec;
        return Object.entries(properties).map(([key, { label: label, propertyType: propertyType }])=>{
            const value = captionStylePropertyOverrides[key] || defaultValues[key];
            return {
                key: key,
                label: label,
                value: value,
                propertyType: propertyType
            };
        });
    }, [
        captionStyleConfig,
        captionStylePropertyOverrides
    ]);
    (0, $acw62.useEffect)(()=>{
        console.log("captionStylePropertyOptions", captionStylePropertyOptions);
    }, [
        captionStylePropertyOptions
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!id) return;
        const fetchData = async ()=>{
            try {
                const { transcript: transcript, videoUrl: videoUrl, videoAsset: videoAsset, captionStyle: captionStyleFromApi, captionStyleSettings: captionStyleSettingsFromApi } = await getProjectM(parseInt(id));
                console.log("transcript", transcript);
                setPlayerParams({
                    id: parseInt(id),
                    playerParams: {
                        transcript: transcript,
                        videoUrl: videoUrl,
                        videoAsset: videoAsset
                    }
                });
                changeCaptionStyle(captionStyleFromApi || (0, $495938ea8e19aef5$export$e66ca54426df938).key);
                let propertyValues = {};
                if (captionStyleSettingsFromApi) {
                    propertyValues = captionStyleSettingsFromApi;
                    setCaptionStylePropertyOverrides(propertyValues);
                }
            } catch (error) {
                console.error(error);
            }
        };
        fetchData();
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8437b3fb5ace006$export$2e2bcd8739ae039), {
        activePage: "projects",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "flex justify-center flex-1 min-w-0",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex-1 max-w-4xl p-6 md:p-8 flex flex-col min-w-0",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex justify-between mb-8 md:mb-16",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                children: "Edit"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0c5125ddfb6c833$export$bb62a0a317a10219), {
                                trigger: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b132ebe58e154a99$export$353f5b6fc5456de1), {
                                    variant: "default",
                                    children: "Export Video"
                                })
                            })
                        ]
                    }),
                    playerParams && playerParams.transcript && playerParams.videoAsset && playerParams.videoAsset.duration && playerParams.videoUrl && captionStyle && captionStyleConfig ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex gap-20 flex-col md:flex-row",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $500ad2a9f4a35004$export$195c2c5b751432f4), {
                                    captionPlayerParams: {
                                        transcript: playerParams.transcript,
                                        videoUrl: playerParams.videoUrl,
                                        videoDuration: playerParams.videoAsset.duration
                                    },
                                    captionStyleConfig: captionStyleConfig,
                                    captionStylePropertyValues: captionStylePropertyOverrides
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex-1 flex flex-col min-w-0",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            className: "border-b border-lit-purple/50 pb-2",
                                            children: "Select style"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "mt-6",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e17b6cd86e079c80$export$843f385214f1c099), {
                                                captionStyle: captionStyle,
                                                setCaptionStyle: changeCaptionStyle
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "mt-8",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "inline border-b border-lit-purple/50 pb-1.5",
                                                children: "Customize style"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                            className: "mt-8",
                                            children: "Colors"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "ml-2 mt-4 grid grid-cols-[minmax(150px,1fr),2fr] gap-4 items-center",
                                            children: captionStylePropertyOptions.map(({ key: key, label: label, value: value, propertyType: propertyType })=>{
                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "text-lit-purple",
                                                            children: label
                                                        }, `${key}-label`),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "flex",
                                                            children: propertyType === "color" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d1ee733c72e2dfda$export$13cf15360203042f), {
                                                                color: value,
                                                                setColor: (color)=>{
                                                                    setCaptionStylePropertyOverrides({
                                                                        ...captionStylePropertyOverrides,
                                                                        [key]: color
                                                                    });
                                                                }
                                                            }) : propertyType === "gradientColor" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "flex gap-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d1ee733c72e2dfda$export$13cf15360203042f), {
                                                                        color: value[0],
                                                                        setColor: (color)=>{
                                                                            setCaptionStylePropertyOverrides({
                                                                                ...captionStylePropertyOverrides,
                                                                                [key]: [
                                                                                    color,
                                                                                    value[1]
                                                                                ]
                                                                            });
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d1ee733c72e2dfda$export$13cf15360203042f), {
                                                                        color: value[1],
                                                                        setColor: (color)=>{
                                                                            setCaptionStylePropertyOverrides({
                                                                                ...captionStylePropertyOverrides,
                                                                                [key]: [
                                                                                    value[0],
                                                                                    color
                                                                                ]
                                                                            });
                                                                        }
                                                                    })
                                                                ]
                                                            }) : null
                                                        }, key)
                                                    ]
                                                });
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                className: "w-6 h-6 animate-spin"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "Loading your project..."
                            })
                        ]
                    })
                ]
            })
        })
    });
}



function $04df427cd8a0d2b0$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex flex-col items-center justify-center h-full gap-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
            className: "text-2xl font-bold",
            children: "Fix Caption Text"
        })
    });
}






var $acw62 = parcelRequire("acw62");





function $ef03d490440118e7$export$2e2bcd8739ae039() {
    const { id: id } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const exportId = parseInt(id);
    const [shouldPoll, setShouldPoll] = (0, $acw62.useState)(true);
    const [exportInst, setExportInst] = (0, $acw62.useState)(null);
    const [previewUrl, setPreviewUrl] = (0, $acw62.useState)(null);
    const fetchUser = (0, $6f510ee9957a1d4f$export$cc885caaa8b7ab4e)((state)=>state.fetchUser);
    const fetchUserM = (0, $af10f25532815273$export$b8fc23a8b701aa67)(fetchUser);
    const getExportM = (0, $af10f25532815273$export$b8fc23a8b701aa67)((0, $21f88f1227598e15$export$d4c07b1daf44a7f));
    (0, $acw62.useEffect)(()=>{
        if (!exportId) return;
        const pollExportStatus = async ()=>{
            const { exportInst: exportInst, previewUrl: previewUrl } = await getExportM(exportId);
            setExportInst(exportInst);
            setPreviewUrl(previewUrl);
            if (exportInst.status === "COMPLETED") {
                setShouldPoll(false);
                // Fetch user to update credits
                fetchUserM();
            }
        };
        if (shouldPoll) {
            const interval = setInterval(pollExportStatus, 1000);
            return ()=>clearInterval(interval);
        }
    }, [
        exportId,
        shouldPoll
    ]);
    const heading = (()=>{
        if (!exportInst) return "";
        if (exportInst.status === "QUEUED" || exportInst.status === "PROCESSING") return "Exporting";
        if (exportInst.status === "COMPLETED" || exportInst.status === "FAILED") return "Export";
        return "";
    })();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8437b3fb5ace006$export$2e2bcd8739ae039), {
        activePage: "exports",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "flex justify-center flex-1",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex-1 max-w-4xl px-8 pt-8 pb-4 flex flex-col",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                children: heading
                            }),
                            exportInst && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                className: "mt-4 underline underline-offset-4",
                                to: `/projects/${exportInst.project.id}`,
                                children: "Back to project"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-8",
                        children: [
                            (exportInst?.status === "QUEUED" || exportInst?.status === "PROCESSING") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: "Your project is being exported"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: "This shouldn't take too long, but there's never a wrong time to grab some coffee."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-8 md:mt-4 w-full md:w-2/3 flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $28d61181697a5cec$export$c17561cb55d4db30), {
                                                type: exportInst?.status === "QUEUED" ? "indeterminate" : "determinate",
                                                value: exportInst?.progress || 1
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                className: "w-8 text-right md:text-left text-sm font-medium leading-none",
                                                children: [
                                                    Math.floor(exportInst?.progress || 0),
                                                    "%"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            exportInst?.status === "COMPLETED" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mt-2",
                                        children: "Your export is ready to download"
                                    }),
                                    previewUrl && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-8 md:mt-4 flex flex-col md:flex-row gap-8 mb-10 md:mb-0 md:gap-20",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("video", {
                                                controls: true,
                                                className: "w-full md:w-[405px]",
                                                src: previewUrl
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b132ebe58e154a99$export$353f5b6fc5456de1), {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                        href: previewUrl,
                                                        download: true,
                                                        children: "Download Video"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            exportInst?.status === "FAILED" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-red-800",
                                        children: "Export failed"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "mt-2",
                                        children: "Something went wrong while exporting your project."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mt-8 md:mt-4 flex gap-20",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b132ebe58e154a99$export$353f5b6fc5456de1), {
                                            children: "Contact support"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}







var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v0.381.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1d55a58c47e43a5b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Trash2", [
    [
        "path",
        {
            d: "M3 6h18",
            key: "d0wm0j"
        }
    ],
    [
        "path",
        {
            d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6",
            key: "4alrt4"
        }
    ],
    [
        "path",
        {
            d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2",
            key: "v07s0e"
        }
    ],
    [
        "line",
        {
            x1: "10",
            x2: "10",
            y1: "11",
            y2: "17",
            key: "1uufr5"
        }
    ],
    [
        "line",
        {
            x1: "14",
            x2: "14",
            y1: "11",
            y2: "17",
            key: "xtxkd"
        }
    ]
]);





const $750a745bb5cf4cb9$var$FPS = 30;
function $750a745bb5cf4cb9$export$917ea8cb5bd216db({ captionPlayerParams: captionPlayerParams, captionStyleConfig: captionStyleConfig, captionStylePropertyValues: captionStylePropertyValues }) {
    const durationInFrames = Math.floor(captionPlayerParams.videoDuration / 1000 * $750a745bb5cf4cb9$var$FPS);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex flex-col items-center relative",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f33cd4ca105fd87b$export$1cd1efc78cb52ca5), {
            component: (0, $6738915eea69e49b$export$422d30b5fbcf61ed),
            inputProps: {
                captionPlayerParams: captionPlayerParams,
                captionStyleConfig: captionStyleConfig,
                captionStylePropertyValues: captionStylePropertyValues,
                videoRenderMode: "skip"
            },
            durationInFrames: durationInFrames,
            frameToDisplay: Math.min(durationInFrames / 2, 5 * $750a745bb5cf4cb9$var$FPS),
            compositionWidth: 1080,
            compositionHeight: 1920,
            fps: $750a745bb5cf4cb9$var$FPS,
            style: {
                width: `${180}px`,
                height: `${320}px`
            }
        })
    });
}



function $3df2c602f87ba442$export$2e2bcd8739ae039() {
    const [projects, setProjects] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { toast: toast } = (0, $9898a26843c73274$export$a407b657d3044108)();
    const getProjectsM = (0, $af10f25532815273$export$b8fc23a8b701aa67)((0, $21f88f1227598e15$export$b00a271f69f3d728));
    const deleteProjectM = (0, $af10f25532815273$export$b8fc23a8b701aa67)((0, $21f88f1227598e15$export$d7ff2361273ba2c2));
    (0, $acw62.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                setLoading(true);
                const projects = await getProjectsM();
                setProjects(projects);
            } catch (error) {
                console.error(error);
            } finally{
                setLoading(false);
            }
        };
        fetchData();
    }, []);
    const handleDelete = async (id)=>{
        try {
            await deleteProjectM(id);
            const projects = await getProjectsM();
            setProjects(projects);
        } catch (error) {
            console.error(error);
            toast({
                variant: "destructive",
                title: "Error deleting project",
                description: error.message
            });
        }
    };
    const handleCreateProject = ()=>{
        navigate("/projects/new");
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8437b3fb5ace006$export$2e2bcd8739ae039), {
        activePage: "projects",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "flex justify-center flex-1",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex-1 max-w-4xl px-8 pt-8 pb-4 flex flex-col gap-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                children: "Projects"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: "/projects/new",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b132ebe58e154a99$export$353f5b6fc5456de1), {
                                    variant: "default",
                                    children: "Upload video"
                                })
                            })
                        ]
                    }),
                    loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                className: "w-6 h-6 animate-spin"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "Fetching your projects..."
                            })
                        ]
                    }) : projects.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex gap-10 flex-wrap overflow-auto max-h-[80svh] vertical-visible-scrollbar",
                        children: projects.map((project)=>{
                            const { snapshotUrl: snapshotUrl, transcript: transcript, name: name = "Untitled Project" } = project;
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "group flex flex-col gap-1 justify-start w-min items-center relative",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: `/projects/${project.id}`,
                                        className: "flex flex-col gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "h-[320px] w-[180px] bg-slate-100 rounded-md bg-cover",
                                                style: snapshotUrl ? {
                                                    // snapshot as background
                                                    backgroundImage: `url(${snapshotUrl})`
                                                } : undefined,
                                                children: project.captionStyle && transcript && project.videoAsset.duration && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $750a745bb5cf4cb9$export$917ea8cb5bd216db), {
                                                    captionStylePropertyValues: project.captionStyleSettings || {},
                                                    captionStyleConfig: project.captionStyle,
                                                    captionPlayerParams: {
                                                        transcript: project.transcript || [],
                                                        videoDuration: project.videoAsset.duration,
                                                        videoUrl: ""
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                className: "line-clamp-2 text-wrap truncate text-left",
                                                title: name || "",
                                                children: name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "absolute top-2 right-2 w-8 h-8 flex items-center justify-center cursor-pointer bg-slate-400/0 group-hover:bg-slate-400 transition-colors rounded-md",
                                        onClick: ()=>handleDelete(project.id),
                                        title: "Delete",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                            className: "w-4 h-4 text-white/0 group-hover:text-white hover:opacity-70 transition-all"
                                        })
                                    })
                                ]
                            }, project.id);
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-1 items-center justify-center rounded-lg border border-dashed shadow-sm",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col items-center gap-2 text-center flex-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: "Welcome to Lit Captions"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm text-muted-foreground",
                                    children: "Create your first project by uploading a video"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b132ebe58e154a99$export$353f5b6fc5456de1), {
                                    className: "mt-4",
                                    onClick: handleCreateProject,
                                    children: "Upload video"
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}





var $acw62 = parcelRequire("acw62");








function $bb41fad3f6ee74e0$export$8c8457ff1aa219a() {
    const { loginWithEmail: loginWithEmail } = (0, $850d0034a9416e03$export$1d39dc5b47e56ff0)();
    const handleSubmit = async (event)=>{
        event.preventDefault();
        const form = event.currentTarget;
        const email = form.email.value;
        const password = form.password.value;
        await loginWithEmail(email, password);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
        onSubmit: handleSubmit,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dec6137693824fa2$export$60332b2344f7fe41), {
            className: "w-full max-w-sm min-w-72",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dec6137693824fa2$export$5665775b26e26c5d), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dec6137693824fa2$export$474db65c3c394e1c), {
                            className: "text-2xl",
                            children: "Sign in with email"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dec6137693824fa2$export$16e0ed4cb97c00d4), {
                            children: "Enter your email and password"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dec6137693824fa2$export$64ef9b8c11710c47), {
                    className: "grid gap-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "grid gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4d43578a5daea27$export$b04be29aa201d4f5), {
                                    htmlFor: "email",
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4850102781696fba$export$f5b8910cec6cf069), {
                                    id: "email",
                                    type: "email",
                                    placeholder: "name@company.com",
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "grid gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4d43578a5daea27$export$b04be29aa201d4f5), {
                                    htmlFor: "password",
                                    children: "Password"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4850102781696fba$export$f5b8910cec6cf069), {
                                    id: "password",
                                    type: "password",
                                    placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
                                    required: true
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dec6137693824fa2$export$e9897d434e0741ee), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b132ebe58e154a99$export$353f5b6fc5456de1), {
                        className: "w-full",
                        variant: "default",
                        children: "Sign in"
                    })
                })
            ]
        })
    });
}







function $f36f0210a1019566$export$fb30daaacfdf6651({ selectEmailLogin: selectEmailLogin }) {
    const { loginWithGoogle: loginWithGoogle } = (0, $850d0034a9416e03$export$1d39dc5b47e56ff0)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dec6137693824fa2$export$60332b2344f7fe41), {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dec6137693824fa2$export$5665775b26e26c5d), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dec6137693824fa2$export$474db65c3c394e1c), {
                    className: "text-2xl text-center",
                    children: "Login"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dec6137693824fa2$export$64ef9b8c11710c47), {
                className: "mt-4 grid gap-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b132ebe58e154a99$export$353f5b6fc5456de1), {
                        className: "w-full",
                        variant: "default",
                        onClick: ()=>loginWithGoogle(),
                        children: "Login with Google"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b132ebe58e154a99$export$353f5b6fc5456de1), {
                        className: "w-full",
                        variant: "default",
                        onClick: ()=>selectEmailLogin(),
                        children: "Login with Email"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dec6137693824fa2$export$e9897d434e0741ee), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dec6137693824fa2$export$16e0ed4cb97c00d4), {
                        className: "text-sm",
                        children: "Don\u2019t have an account yet?"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b132ebe58e154a99$export$353f5b6fc5456de1), {
                        asChild: true,
                        variant: "link",
                        className: "px-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: "/signup",
                            children: "Sign up"
                        })
                    })
                ]
            })
        ]
    });
}


function $29d80896db55218c$export$21a94553ffa41578() {
    const [emailSignInSelected, setEmailSignInSelected] = (0, $acw62.useState)(false);
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    (0, $acw62.useEffect)(()=>{
        const checkAuth = async ()=>{
            try {
                const { authenticated: authenticated } = await (0, $21f88f1227598e15$export$c2b96737387ce662)();
                if (authenticated) navigate("/projects");
            } catch (e) {
                console.error(e);
            }
        };
        checkAuth();
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8437b3fb5ace006$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "mt-40 flex justify-center items-center ",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col w-96 mx-10",
                children: [
                    !emailSignInSelected ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36f0210a1019566$export$fb30daaacfdf6651), {
                        selectEmailLogin: ()=>setEmailSignInSelected(true)
                    }, "login-options-card") : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb41fad3f6ee74e0$export$8c8457ff1aa219a), {}, "email-login-card"),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm px-6 py-2 text-muted-foreground",
                        children: "Please note: Lit Captions requires a separate account from your Typito account"
                    })
                ]
            })
        })
    });
}





var $acw62 = parcelRequire("acw62");








function $d6dbad8c3ebe333a$export$2965ed02389cc397() {
    const { signupWithEmail: signupWithEmail } = (0, $850d0034a9416e03$export$1d39dc5b47e56ff0)();
    const handleSubmit = async (event)=>{
        event.preventDefault();
        const form = event.currentTarget;
        const email = form.email.value;
        const password = form.password.value;
        await signupWithEmail(email, password);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
        onSubmit: handleSubmit,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dec6137693824fa2$export$60332b2344f7fe41), {
            className: "w-full min-w-48",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dec6137693824fa2$export$5665775b26e26c5d), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dec6137693824fa2$export$474db65c3c394e1c), {
                            className: "text-2xl",
                            children: "Sign up with email"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dec6137693824fa2$export$16e0ed4cb97c00d4), {
                            children: "Enter your email and choose a password"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dec6137693824fa2$export$64ef9b8c11710c47), {
                    className: "grid gap-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "grid gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4d43578a5daea27$export$b04be29aa201d4f5), {
                                    htmlFor: "email",
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4850102781696fba$export$f5b8910cec6cf069), {
                                    id: "email",
                                    type: "email",
                                    placeholder: "name@company.com",
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "grid gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4d43578a5daea27$export$b04be29aa201d4f5), {
                                    htmlFor: "password",
                                    children: "Password"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4850102781696fba$export$f5b8910cec6cf069), {
                                    id: "password",
                                    type: "password",
                                    placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
                                    required: true
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dec6137693824fa2$export$e9897d434e0741ee), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b132ebe58e154a99$export$353f5b6fc5456de1), {
                        className: "w-full",
                        variant: "default",
                        type: "submit",
                        children: "Sign up"
                    })
                })
            ]
        })
    });
}







function $7d58ba420aba9aa0$export$62dd3b0e0fc17c0d({ selectEmailSignup: selectEmailSignup }) {
    const { loginWithGoogle: loginWithGoogle } = (0, $850d0034a9416e03$export$1d39dc5b47e56ff0)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dec6137693824fa2$export$60332b2344f7fe41), {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dec6137693824fa2$export$5665775b26e26c5d), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dec6137693824fa2$export$474db65c3c394e1c), {
                    className: "text-2xl text-center",
                    children: "Sign up"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dec6137693824fa2$export$64ef9b8c11710c47), {
                className: "mt-4 grid gap-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b132ebe58e154a99$export$353f5b6fc5456de1), {
                        className: "w-full",
                        variant: "default",
                        onClick: ()=>loginWithGoogle(),
                        children: "Sign up with Google"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b132ebe58e154a99$export$353f5b6fc5456de1), {
                        className: "w-full",
                        variant: "default",
                        onClick: ()=>selectEmailSignup(),
                        children: "Sign up with Email"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dec6137693824fa2$export$e9897d434e0741ee), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dec6137693824fa2$export$16e0ed4cb97c00d4), {
                        className: "text-sm",
                        children: "Already have an account?"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b132ebe58e154a99$export$353f5b6fc5456de1), {
                        asChild: true,
                        variant: "link",
                        className: "px-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: "/login",
                            children: "Login"
                        })
                    })
                ]
            })
        ]
    });
}


function $33bb04eade30bddb$export$89200835fb4edfb9() {
    const [emailSignUpSelected, setEmailSignUpSelected] = (0, $acw62.useState)(false);
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    (0, $acw62.useEffect)(()=>{
        const checkAuth = async ()=>{
            try {
                const { authenticated: authenticated } = await (0, $21f88f1227598e15$export$c2b96737387ce662)();
                if (authenticated) navigate("/projects");
            } catch (e) {
                console.error(e);
            }
        };
        checkAuth();
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8437b3fb5ace006$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "mt-40 flex justify-center items-center",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col w-96 mx-10",
                children: [
                    !emailSignUpSelected ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d58ba420aba9aa0$export$62dd3b0e0fc17c0d), {
                        selectEmailSignup: ()=>setEmailSignUpSelected(true)
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d6dbad8c3ebe333a$export$2965ed02389cc397), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm px-6 py-2 text-muted-foreground",
                        children: "Please note: Lit Captions requires a separate account from your Typito account"
                    })
                ]
            })
        })
    });
}






function $bc79313bef060bae$export$271f9f08425019c7() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8437b3fb5ace006$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "flex justify-center flex-1",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex-1 px-8 mt-40 pb-4 flex flex-col items-center gap-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex justify-between",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            children: "Page not found"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: "/",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b132ebe58e154a99$export$353f5b6fc5456de1), {
                            variant: "default",
                            children: "Back to Home"
                        })
                    })
                ]
            })
        })
    });
}






function $d53715d363031e19$export$6845bb566205c2a7() {
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const success = searchParams.get("success");
    const canceled = searchParams.get("canceled");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8437b3fb5ace006$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "flex justify-center flex-1",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex-1 px-8 pt-8 pb-4 flex flex-col gap-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                children: success ? "Payment successful" : canceled ? "Payment canceled" : "???"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    success && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-green-700",
                                        children: "Thank you for your purchase!"
                                    }),
                                    canceled && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-red-500",
                                        children: "Your payment was canceled."
                                    }),
                                    !success && !canceled && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-gray-800",
                                        children: "We don't know why you're here. You shouldn't be."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: "/",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b132ebe58e154a99$export$353f5b6fc5456de1), {
                            variant: "default",
                            children: "Go to Dashboard"
                        })
                    })
                ]
            })
        })
    });
}





var $acw62 = parcelRequire("acw62");




function $ce242aab7dbd4259$export$2e2bcd8739ae039() {
    const [exports, setExports] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const getExportsM = (0, $af10f25532815273$export$b8fc23a8b701aa67)((0, $21f88f1227598e15$export$266000d9dfaf5358));
    (0, $acw62.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                setLoading(true);
                const exports = await getExportsM();
                setExports(exports);
            } catch (error) {
                console.error(error);
            } finally{
                setLoading(false);
            }
        };
        fetchData();
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8437b3fb5ace006$export$2e2bcd8739ae039), {
        activePage: "exports",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "flex justify-center flex-1",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex-1 max-w-4xl px-8 pt-8 pb-4 flex flex-col gap-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex justify-between",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            children: "Exports"
                        })
                    }),
                    loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                className: "w-6 h-6 animate-spin"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "Fetching your exports..."
                            })
                        ]
                    }) : exports.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex gap-10 flex-wrap overflow-auto max-h-[80svh] vertical-visible-scrollbar",
                        children: exports.map((exportData)=>{
                            const { id: id, snapshotUrl: snapshotUrl, project: project } = exportData;
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "group flex flex-col gap-1 justify-start w-min items-center relative",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: `/exports/${id}`,
                                    className: "flex flex-col gap-1",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "h-[320px] w-[180px] bg-slate-100 rounded-md bg-cover",
                                            style: snapshotUrl && {
                                                // snapshot as background
                                                backgroundImage: `url(${snapshotUrl})`
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                            className: "line-clamp-2 text-wrap truncate text-left",
                                            title: project.name,
                                            children: project.name
                                        })
                                    ]
                                })
                            }, id);
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-1 items-center justify-center rounded-lg border border-dashed shadow-sm",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex flex-col items-center gap-2 text-center",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-muted-foreground",
                                children: "You haven't exported any of your projects yet."
                            })
                        })
                    })
                ]
            })
        })
    });
}



var $acw62 = parcelRequire("acw62");


function $f8d412e13c3a75e2$export$4fc34ad4f1501e38() {
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const url = (0, $acw62.useMemo)(()=>{
        let url = window.origin + location.pathname;
        if (searchParams.toString()) url = url + `?${searchParams.toString()}`;
        return url;
    }, [
        location.pathname,
        searchParams.toString()
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $b7120199cc96ae3e$export$817735e17a729e38)(url);
    }, [
        url
    ]);
    return null;
}




var $acw62 = parcelRequire("acw62");



const $a7c5d45b03097357$export$a09107836e73ed02 = ()=>{
    const [authCheckStatus, setAuthCheckStatus] = (0, $acw62.useState)("loading");
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    (0, $acw62.useEffect)(()=>{
        const checkAuth = async ()=>{
            setAuthCheckStatus("loading");
            try {
                const { authenticated: authenticated, hasLoggedInBefore: hasLoggedInBefore } = await (0, $21f88f1227598e15$export$c2b96737387ce662)();
                if (authenticated) {
                    setAuthCheckStatus("authenticated");
                    navigate("/projects");
                } else {
                    setAuthCheckStatus("not-authenticated");
                    if (!hasLoggedInBefore) navigate("/signup");
                    else navigate("/login");
                }
            } catch (e) {
                setAuthCheckStatus("failed");
                console.error(e);
            }
        };
        checkAuth();
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8437b3fb5ace006$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "flex-1 flex flex-col items-center justify-center pb-40",
            children: authCheckStatus === "loading" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "animate-pulse",
                children: "Loading..."
            }) : authCheckStatus === "not-authenticated" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Redirecting to login..."
            }) : authCheckStatus === "failed" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Failed to load. Try refreshing the page."
            }) : authCheckStatus === "authenticated" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "animate-pulse",
                children: "Redirecting to dashboard..."
            }) : null
        })
    });
};





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// packages/react/context/src/createContext.tsx

var $acw62 = parcelRequire("acw62");

function $3cbe2cfe3ea0c144$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $acw62.createContext(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props;
        const value = $acw62.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    }
    function useContext2(consumerName) {
        const context = $acw62.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext2
    ];
}
function $3cbe2cfe3ea0c144$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $acw62.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName][index] || BaseContext;
            const value = $acw62.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        }
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName][index] || BaseContext;
            const context = $acw62.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $acw62.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $acw62.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $3cbe2cfe3ea0c144$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $3cbe2cfe3ea0c144$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $acw62.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}


// packages/react/compose-refs/src/composeRefs.tsx

var $acw62 = parcelRequire("acw62");
function $ee7011789a607340$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $ee7011789a607340$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$ee7011789a607340$var$setRef(ref, node));
}
function $ee7011789a607340$export$c7b2cbe3552a0d05(...refs) {
    return $acw62.useCallback($ee7011789a607340$export$43e446d32b3d21af(...refs), refs);
}



// packages/core/primitive/src/primitive.tsx
function $b8e788ef2f11948a$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}


// packages/react/slot/src/Slot.tsx

var $acw62 = parcelRequire("acw62");


var $786ba4c59651a61e$export$8c6ed5c666ac1360 = $acw62.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = $acw62.Children.toArray(children);
    const slottable = childrenArray.find($786ba4c59651a61e$var$isSlottable);
    if (slottable) {
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                if ($acw62.Children.count(newElement) > 1) return $acw62.Children.only(null);
                return $acw62.isValidElement(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($786ba4c59651a61e$var$SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: $acw62.isValidElement(newElement) ? $acw62.cloneElement(newElement, void 0, newChildren) : null
        });
    }
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($786ba4c59651a61e$var$SlotClone, {
        ...slotProps,
        ref: forwardedRef,
        children: children
    });
});
$786ba4c59651a61e$export$8c6ed5c666ac1360.displayName = "Slot";
var $786ba4c59651a61e$var$SlotClone = $acw62.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if ($acw62.isValidElement(children)) {
        const childrenRef = $786ba4c59651a61e$var$getElementRef(children);
        return $acw62.cloneElement(children, {
            ...$786ba4c59651a61e$var$mergeProps(slotProps, children.props),
            // @ts-ignore
            ref: forwardedRef ? (0, $ee7011789a607340$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef
        });
    }
    return $acw62.Children.count(children) > 1 ? $acw62.Children.only(null) : null;
});
$786ba4c59651a61e$var$SlotClone.displayName = "SlotClone";
var $786ba4c59651a61e$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
};
function $786ba4c59651a61e$var$isSlottable(child) {
    return $acw62.isValidElement(child) && child.type === $786ba4c59651a61e$export$d9f1ccf0bdb05d45;
}
function $786ba4c59651a61e$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $786ba4c59651a61e$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $786ba4c59651a61e$export$be92b6f5f03c0fe9 = $786ba4c59651a61e$export$8c6ed5c666ac1360;



"use client";
var $d12af7b8e27a6641$var$ROOT_NAME = "AlertDialog";
var [$d12af7b8e27a6641$var$createAlertDialogContext, $d12af7b8e27a6641$export$b8891880751c2c5b] = (0, $3cbe2cfe3ea0c144$export$50c7b4e9d9f19c1)($d12af7b8e27a6641$var$ROOT_NAME, [
    (0, $eeaeb48e23f662e7$export$cc702773b8ea3e41)
]);
var $d12af7b8e27a6641$var$useDialogScope = (0, $eeaeb48e23f662e7$export$cc702773b8ea3e41)();
var $d12af7b8e27a6641$export$de466dd8317b0b75 = (props)=>{
    const { __scopeAlertDialog: __scopeAlertDialog, ...alertDialogProps } = props;
    const dialogScope = $d12af7b8e27a6641$var$useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$be92b6f5f03c0fe9, {
        ...dialogScope,
        ...alertDialogProps,
        modal: true
    });
};
$d12af7b8e27a6641$export$de466dd8317b0b75.displayName = $d12af7b8e27a6641$var$ROOT_NAME;
var $d12af7b8e27a6641$var$TRIGGER_NAME = "AlertDialogTrigger";
var $d12af7b8e27a6641$export$6edd7a623ef0f40b = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog, ...triggerProps } = props;
    const dialogScope = $d12af7b8e27a6641$var$useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$41fb9f06171c75f4, {
        ...dialogScope,
        ...triggerProps,
        ref: forwardedRef
    });
});
$d12af7b8e27a6641$export$6edd7a623ef0f40b.displayName = $d12af7b8e27a6641$var$TRIGGER_NAME;
var $d12af7b8e27a6641$var$PORTAL_NAME = "AlertDialogPortal";
var $d12af7b8e27a6641$export$660f2bfdb986706c = (props)=>{
    const { __scopeAlertDialog: __scopeAlertDialog, ...portalProps } = props;
    const dialogScope = $d12af7b8e27a6641$var$useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$602eac185826482c, {
        ...dialogScope,
        ...portalProps
    });
};
$d12af7b8e27a6641$export$660f2bfdb986706c.displayName = $d12af7b8e27a6641$var$PORTAL_NAME;
var $d12af7b8e27a6641$var$OVERLAY_NAME = "AlertDialogOverlay";
var $d12af7b8e27a6641$export$a707a4895ce23256 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog, ...overlayProps } = props;
    const dialogScope = $d12af7b8e27a6641$var$useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$c6fdb837b070b4ff, {
        ...dialogScope,
        ...overlayProps,
        ref: forwardedRef
    });
});
$d12af7b8e27a6641$export$a707a4895ce23256.displayName = $d12af7b8e27a6641$var$OVERLAY_NAME;
var $d12af7b8e27a6641$var$CONTENT_NAME = "AlertDialogContent";
var [$d12af7b8e27a6641$var$AlertDialogContentProvider, $d12af7b8e27a6641$var$useAlertDialogContentContext] = $d12af7b8e27a6641$var$createAlertDialogContext($d12af7b8e27a6641$var$CONTENT_NAME);
var $d12af7b8e27a6641$export$94e6af45f0af4efd = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog, children: children, ...contentProps } = props;
    const dialogScope = $d12af7b8e27a6641$var$useDialogScope(__scopeAlertDialog);
    const contentRef = $acw62.useRef(null);
    const composedRefs = (0, $ee7011789a607340$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    const cancelRef = $acw62.useRef(null);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$69b62a49393917d6, {
        contentName: $d12af7b8e27a6641$var$CONTENT_NAME,
        titleName: $d12af7b8e27a6641$var$TITLE_NAME,
        docsSlug: "alert-dialog",
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($d12af7b8e27a6641$var$AlertDialogContentProvider, {
            scope: __scopeAlertDialog,
            cancelRef: cancelRef,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)($eeaeb48e23f662e7$export$7c6e2c02157bb7d2, {
                role: "alertdialog",
                ...dialogScope,
                ...contentProps,
                ref: composedRefs,
                onOpenAutoFocus: (0, $b8e788ef2f11948a$export$b9ecd428b558ff10)(contentProps.onOpenAutoFocus, (event)=>{
                    event.preventDefault();
                    cancelRef.current?.focus({
                        preventScroll: true
                    });
                }),
                onPointerDownOutside: (event)=>event.preventDefault(),
                onInteractOutside: (event)=>event.preventDefault(),
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $786ba4c59651a61e$export$d9f1ccf0bdb05d45), {
                        children: children
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($d12af7b8e27a6641$var$DescriptionWarning, {
                        contentRef: contentRef
                    })
                ]
            })
        })
    });
});
$d12af7b8e27a6641$export$94e6af45f0af4efd.displayName = $d12af7b8e27a6641$var$CONTENT_NAME;
var $d12af7b8e27a6641$var$TITLE_NAME = "AlertDialogTitle";
var $d12af7b8e27a6641$export$225e0da62d314b7 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog, ...titleProps } = props;
    const dialogScope = $d12af7b8e27a6641$var$useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$f99233281efd08a0, {
        ...dialogScope,
        ...titleProps,
        ref: forwardedRef
    });
});
$d12af7b8e27a6641$export$225e0da62d314b7.displayName = $d12af7b8e27a6641$var$TITLE_NAME;
var $d12af7b8e27a6641$var$DESCRIPTION_NAME = "AlertDialogDescription";
var $d12af7b8e27a6641$export$a23b55cde55ad9a5 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog, ...descriptionProps } = props;
    const dialogScope = $d12af7b8e27a6641$var$useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$393edc798c47379d, {
        ...dialogScope,
        ...descriptionProps,
        ref: forwardedRef
    });
});
$d12af7b8e27a6641$export$a23b55cde55ad9a5.displayName = $d12af7b8e27a6641$var$DESCRIPTION_NAME;
var $d12af7b8e27a6641$var$ACTION_NAME = "AlertDialogAction";
var $d12af7b8e27a6641$export$b454f818c58ee85d = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog, ...actionProps } = props;
    const dialogScope = $d12af7b8e27a6641$var$useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$f39c2d165cd861fe, {
        ...dialogScope,
        ...actionProps,
        ref: forwardedRef
    });
});
$d12af7b8e27a6641$export$b454f818c58ee85d.displayName = $d12af7b8e27a6641$var$ACTION_NAME;
var $d12af7b8e27a6641$var$CANCEL_NAME = "AlertDialogCancel";
var $d12af7b8e27a6641$export$2f67a923571aaea0 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog, ...cancelProps } = props;
    const { cancelRef: cancelRef } = $d12af7b8e27a6641$var$useAlertDialogContentContext($d12af7b8e27a6641$var$CANCEL_NAME, __scopeAlertDialog);
    const dialogScope = $d12af7b8e27a6641$var$useDialogScope(__scopeAlertDialog);
    const ref = (0, $ee7011789a607340$export$c7b2cbe3552a0d05)(forwardedRef, cancelRef);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$f39c2d165cd861fe, {
        ...dialogScope,
        ...cancelProps,
        ref: ref
    });
});
$d12af7b8e27a6641$export$2f67a923571aaea0.displayName = $d12af7b8e27a6641$var$CANCEL_NAME;
var $d12af7b8e27a6641$var$DescriptionWarning = ({ contentRef: contentRef })=>{
    const MESSAGE = `\`${$d12af7b8e27a6641$var$CONTENT_NAME}\` requires a description for the component to be accessible for screen reader users.

You can add a description to the \`${$d12af7b8e27a6641$var$CONTENT_NAME}\` by passing a \`${$d12af7b8e27a6641$var$DESCRIPTION_NAME}\` component as a child, which also benefits sighted users by adding visible context to the dialog.

Alternatively, you can use your own component as a description by assigning it an \`id\` and passing the same value to the \`aria-describedby\` prop in \`${$d12af7b8e27a6641$var$CONTENT_NAME}\`. If the description is confusing or duplicative for sighted users, you can use the \`@radix-ui/react-visually-hidden\` primitive as a wrapper around your description component.

For more information, see https://radix-ui.com/primitives/docs/components/alert-dialog`;
    $acw62.useEffect(()=>{
        const hasDescription = document.getElementById(contentRef.current?.getAttribute("aria-describedby"));
        if (!hasDescription) console.warn(MESSAGE);
    }, [
        MESSAGE,
        contentRef
    ]);
    return null;
};
var $d12af7b8e27a6641$export$be92b6f5f03c0fe9 = $d12af7b8e27a6641$export$de466dd8317b0b75;
var $d12af7b8e27a6641$export$41fb9f06171c75f4 = $d12af7b8e27a6641$export$6edd7a623ef0f40b;
var $d12af7b8e27a6641$export$602eac185826482c = $d12af7b8e27a6641$export$660f2bfdb986706c;
var $d12af7b8e27a6641$export$c6fdb837b070b4ff = $d12af7b8e27a6641$export$a707a4895ce23256;
var $d12af7b8e27a6641$export$7c6e2c02157bb7d2 = $d12af7b8e27a6641$export$94e6af45f0af4efd;
var $d12af7b8e27a6641$export$e19cd5f9376f8cee = $d12af7b8e27a6641$export$b454f818c58ee85d;
var $d12af7b8e27a6641$export$848c9b7ead0df967 = $d12af7b8e27a6641$export$2f67a923571aaea0;
var $d12af7b8e27a6641$export$f99233281efd08a0 = $d12af7b8e27a6641$export$225e0da62d314b7;
var $d12af7b8e27a6641$export$393edc798c47379d = $d12af7b8e27a6641$export$a23b55cde55ad9a5;




const $5ad6607202a3aaa4$export$de466dd8317b0b75 = $d12af7b8e27a6641$export$be92b6f5f03c0fe9;
const $5ad6607202a3aaa4$export$6edd7a623ef0f40b = $d12af7b8e27a6641$export$41fb9f06171c75f4;
const $5ad6607202a3aaa4$export$660f2bfdb986706c = $d12af7b8e27a6641$export$602eac185826482c;
const $5ad6607202a3aaa4$export$a707a4895ce23256 = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d12af7b8e27a6641$export$c6fdb837b070b4ff, {
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", className),
        ...props,
        ref: ref
    }));
$5ad6607202a3aaa4$export$a707a4895ce23256.displayName = $d12af7b8e27a6641$export$c6fdb837b070b4ff.displayName;
const $5ad6607202a3aaa4$export$94e6af45f0af4efd = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($5ad6607202a3aaa4$export$660f2bfdb986706c, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5ad6607202a3aaa4$export$a707a4895ce23256, {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d12af7b8e27a6641$export$7c6e2c02157bb7d2, {
                ref: ref,
                className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border border-slate-200 bg-white p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg dark:border-slate-800 dark:bg-slate-950", className),
                ...props
            })
        ]
    }));
$5ad6607202a3aaa4$export$94e6af45f0af4efd.displayName = $d12af7b8e27a6641$export$7c6e2c02157bb7d2.displayName;
const $5ad6607202a3aaa4$export$c9359e10414c2de7 = ({ className: className, ...props })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("flex flex-col space-y-2 text-center sm:text-left", className),
        ...props
    });
$5ad6607202a3aaa4$export$c9359e10414c2de7.displayName = "AlertDialogHeader";
const $5ad6607202a3aaa4$export$691560c8793e1baf = ({ className: className, ...props })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", className),
        ...props
    });
$5ad6607202a3aaa4$export$691560c8793e1baf.displayName = "AlertDialogFooter";
const $5ad6607202a3aaa4$export$225e0da62d314b7 = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d12af7b8e27a6641$export$f99233281efd08a0, {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("text-lg font-semibold", className),
        ...props
    }));
$5ad6607202a3aaa4$export$225e0da62d314b7.displayName = $d12af7b8e27a6641$export$f99233281efd08a0.displayName;
const $5ad6607202a3aaa4$export$a23b55cde55ad9a5 = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d12af7b8e27a6641$export$393edc798c47379d, {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("text-sm text-slate-500 dark:text-slate-400", className),
        ...props
    }));
$5ad6607202a3aaa4$export$a23b55cde55ad9a5.displayName = $d12af7b8e27a6641$export$393edc798c47379d.displayName;
const $5ad6607202a3aaa4$export$b454f818c58ee85d = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d12af7b8e27a6641$export$e19cd5f9376f8cee, {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)((0, $b132ebe58e154a99$export$dca1ee5a936bb312)(), className),
        ...props
    }));
$5ad6607202a3aaa4$export$b454f818c58ee85d.displayName = $d12af7b8e27a6641$export$e19cd5f9376f8cee.displayName;
const $5ad6607202a3aaa4$export$2f67a923571aaea0 = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d12af7b8e27a6641$export$848c9b7ead0df967, {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)((0, $b132ebe58e154a99$export$dca1ee5a936bb312)({
            variant: "outline"
        }), "mt-2 sm:mt-0", className),
        ...props
    }));
$5ad6607202a3aaa4$export$2f67a923571aaea0.displayName = $d12af7b8e27a6641$export$848c9b7ead0df967.displayName;



var $acw62 = parcelRequire("acw62");


function $eace23f8ff20c382$export$dcff0904848134d9() {
    const loggedIn = (0, $fd27deb97aace157$export$650ce9f0b4df82fd)((state)=>state.loggedIn);
    const [open, setOpen] = (0, $acw62.useState)(false);
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    (0, $acw62.useEffect)(()=>{
        // On change
        if (!loggedIn) setOpen(true);
    }, [
        loggedIn
    ]);
    const handleLogin = ()=>{
        // Handle login
        setOpen(false);
        navigate("/");
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ad6607202a3aaa4$export$de466dd8317b0b75), {
        open: open,
        defaultOpen: false,
        onOpenChange: setOpen,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5ad6607202a3aaa4$export$94e6af45f0af4efd), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5ad6607202a3aaa4$export$c9359e10414c2de7), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ad6607202a3aaa4$export$225e0da62d314b7), {
                            children: "You're not logged in"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ad6607202a3aaa4$export$a23b55cde55ad9a5), {
                            children: "You need to be logged in to perform this action."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ad6607202a3aaa4$export$691560c8793e1baf), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ad6607202a3aaa4$export$b454f818c58ee85d), {
                        onClick: handleLogin,
                        children: "Log in"
                    })
                })
            ]
        })
    });
}







var $acw62 = parcelRequire("acw62");



function $de7c96648d55bf18$export$2e2bcd8739ae039() {
    const { id: id } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const getProjectM = (0, $af10f25532815273$export$b8fc23a8b701aa67)((0, $21f88f1227598e15$export$637b60a42bb03f06));
    const [project, setProject] = (0, $acw62.useState)();
    const fetchProject = (0, $acw62.useCallback)(async ()=>{
        try {
            if (!id) return;
            const projectId = parseInt(id);
            const project = await getProjectM(projectId);
            setProject(project);
        } catch (error) {
            console.error(error);
        }
    }, [
        id
    ]);
    (0, $acw62.useEffect)(()=>{
        fetchProject();
    }, [
        id
    ]);
    const intervalRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const interval = setInterval(()=>{
            fetchProject();
        }, 3000);
        intervalRef.current = interval;
        return ()=>{
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [
        id
    ]);
    const isProjectReady = project ? project.videoAsset.readyStatus !== null ? project.videoAsset.readyStatus === "READY" : project.videoAsset.status === "TRANSCRIPT_SAVED" : false;
    (0, $acw62.useEffect)(()=>{
        if (isProjectReady) {
            if (intervalRef.current) clearInterval(intervalRef.current);
            setTimeout(()=>{
                navigate(`/projects/${id}/edit`);
            }, 1000);
        }
    }, [
        isProjectReady,
        id
    ]);
    if (!project) return null;
    const isPreparing = project ? project.videoAsset.readyStatus !== null ? project.videoAsset.readyStatus === "PROCESSING" || project.videoAsset.readyStatus === "UPLOADED" : project.videoAsset.status !== "TRANSCRIPT_SAVED" : false;
    const isError = project ? project.videoAsset.readyStatus !== null ? project.videoAsset.readyStatus === "ERROR" : false : false;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8437b3fb5ace006$export$2e2bcd8739ae039), {
        activePage: "projects",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "flex justify-center flex-1",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex-1 max-w-4xl px-8 pt-8 pb-4 flex flex-col gap-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        children: "Create new project"
                    }),
                    isPreparing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-col gap-8",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Preparing your project"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "mt-2",
                                    children: [
                                        "Preparing your project for editing and captioning.",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                        "This should only take at most a minute or two."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "mt-4 w-2/3 flex items-center gap-2",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $28d61181697a5cec$export$c17561cb55d4db30), {
                                        type: "indeterminate"
                                    })
                                })
                            ]
                        })
                    }) : isError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-col gap-8",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    className: "text-red-800",
                                    children: "Something went wrong"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mt-2",
                                    children: "We couldn't create your project. Please try again later."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "mt-4 w-2/3 flex items-center gap-2",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b132ebe58e154a99$export$353f5b6fc5456de1), {
                                        onClick: ()=>navigate("/projects/new"),
                                        children: "Try again"
                                    })
                                })
                            ]
                        })
                    }) : isProjectReady ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-col gap-8",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    className: "text-green-800",
                                    children: "Project created successfully"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mt-2",
                                    children: "Redirecting you to your project page..."
                                })
                            ]
                        })
                    }) : null
                ]
            })
        })
    });
}


function $5ea76e268d887ac0$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/exports/:id",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef03d490440118e7$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/exports",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ce242aab7dbd4259$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/projects/:id/fix-caption-text",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04df427cd8a0d2b0$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/projects/:id/edit",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962d3f1718761a26$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/projects/:id/status",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de7c96648d55bf18$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/projects/:id",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61f2e6d1e10dae2c$export$a6e25ba5f7be9e35), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/projects/new",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0a7277092783dafa$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/projects",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3df2c602f87ba442$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/postcheckout",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d53715d363031e19$export$6845bb566205c2a7), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/login",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $29d80896db55218c$export$21a94553ffa41578), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/signup",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $33bb04eade30bddb$export$89200835fb4edfb9), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7c5d45b03097357$export$a09107836e73ed02), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "*",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc79313bef060bae$export$271f9f08425019c7), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8d412e13c3a75e2$export$4fc34ad4f1501e38), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eace23f8ff20c382$export$dcff0904848134d9), {})
        ]
    });
}





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");













var $acw62 = parcelRequire("acw62");

/* -------------------------------------------------------------------------------------------------
 * VisuallyHidden
 * -----------------------------------------------------------------------------------------------*/ const $8d51f093cc1b6735$var$$ea1ef594cf570d83$var$NAME = "VisuallyHidden";
const $8d51f093cc1b6735$export$439d29a4e110a164 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).span, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        style: {
            // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
            position: "absolute",
            border: 0,
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            wordWrap: "normal",
            ...props.style
        }
    }));
});
/*#__PURE__*/ Object.assign($8d51f093cc1b6735$export$439d29a4e110a164, {
    displayName: $8d51f093cc1b6735$var$$ea1ef594cf570d83$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $8d51f093cc1b6735$export$be92b6f5f03c0fe9 = $8d51f093cc1b6735$export$439d29a4e110a164;


/* -------------------------------------------------------------------------------------------------
 * ToastProvider
 * -----------------------------------------------------------------------------------------------*/ const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$PROVIDER_NAME = "ToastProvider";
const [$39e058e35b3b85b5$var$$054eb8030ebde76e$var$Collection, $39e058e35b3b85b5$var$$054eb8030ebde76e$var$useCollection, $39e058e35b3b85b5$var$$054eb8030ebde76e$var$createCollectionScope] = (0, $a9634733d4b9bce9$export$c74125a8e3af6bb2)("Toast");
const [$39e058e35b3b85b5$var$$054eb8030ebde76e$var$createToastContext, $39e058e35b3b85b5$export$8a359da18fbc9073] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)("Toast", [
    $39e058e35b3b85b5$var$$054eb8030ebde76e$var$createCollectionScope
]);
const [$39e058e35b3b85b5$var$$054eb8030ebde76e$var$ToastProviderProvider, $39e058e35b3b85b5$var$$054eb8030ebde76e$var$useToastProviderContext] = $39e058e35b3b85b5$var$$054eb8030ebde76e$var$createToastContext($39e058e35b3b85b5$var$$054eb8030ebde76e$var$PROVIDER_NAME);
const $39e058e35b3b85b5$export$f5d03d415824e0e = (props)=>{
    const { __scopeToast: __scopeToast, label: label = "Notification", duration: duration = 5000, swipeDirection: swipeDirection = "right", swipeThreshold: swipeThreshold = 50, children: children } = props;
    const [viewport, setViewport] = (0, $acw62.useState)(null);
    const [toastCount, setToastCount] = (0, $acw62.useState)(0);
    const isFocusedToastEscapeKeyDownRef = (0, $acw62.useRef)(false);
    const isClosePausedRef = (0, $acw62.useRef)(false);
    return /*#__PURE__*/ (0, $acw62.createElement)($39e058e35b3b85b5$var$$054eb8030ebde76e$var$Collection.Provider, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0, $acw62.createElement)($39e058e35b3b85b5$var$$054eb8030ebde76e$var$ToastProviderProvider, {
        scope: __scopeToast,
        label: label,
        duration: duration,
        swipeDirection: swipeDirection,
        swipeThreshold: swipeThreshold,
        toastCount: toastCount,
        viewport: viewport,
        onViewportChange: setViewport,
        onToastAdd: (0, $acw62.useCallback)(()=>setToastCount((prevCount)=>prevCount + 1), []),
        onToastRemove: (0, $acw62.useCallback)(()=>setToastCount((prevCount)=>prevCount - 1), []),
        isFocusedToastEscapeKeyDownRef: isFocusedToastEscapeKeyDownRef,
        isClosePausedRef: isClosePausedRef
    }, children));
};
$39e058e35b3b85b5$export$f5d03d415824e0e.propTypes = {
    label (props) {
        if (props.label && typeof props.label === "string" && !props.label.trim()) {
            const error = `Invalid prop \`label\` supplied to \`${$39e058e35b3b85b5$var$$054eb8030ebde76e$var$PROVIDER_NAME}\`. Expected non-empty \`string\`.`;
            return new Error(error);
        }
        return null;
    }
};
/*#__PURE__*/ Object.assign($39e058e35b3b85b5$export$f5d03d415824e0e, {
    displayName: $39e058e35b3b85b5$var$$054eb8030ebde76e$var$PROVIDER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastViewport
 * -----------------------------------------------------------------------------------------------*/ const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$VIEWPORT_NAME = "ToastViewport";
const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$VIEWPORT_DEFAULT_HOTKEY = [
    "F8"
];
const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE = "toast.viewportPause";
const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$VIEWPORT_RESUME = "toast.viewportResume";
const $39e058e35b3b85b5$export$6192c2425ecfd989 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast, hotkey: hotkey = $39e058e35b3b85b5$var$$054eb8030ebde76e$var$VIEWPORT_DEFAULT_HOTKEY, label: label = "Notifications ({hotkey})", ...viewportProps } = props;
    const context = $39e058e35b3b85b5$var$$054eb8030ebde76e$var$useToastProviderContext($39e058e35b3b85b5$var$$054eb8030ebde76e$var$VIEWPORT_NAME, __scopeToast);
    const getItems = $39e058e35b3b85b5$var$$054eb8030ebde76e$var$useCollection(__scopeToast);
    const wrapperRef = (0, $acw62.useRef)(null);
    const headFocusProxyRef = (0, $acw62.useRef)(null);
    const tailFocusProxyRef = (0, $acw62.useRef)(null);
    const ref = (0, $acw62.useRef)(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref, context.onViewportChange);
    const hotkeyLabel = hotkey.join("+").replace(/Key/g, "").replace(/Digit/g, "");
    const hasToasts = context.toastCount > 0;
    (0, $acw62.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            var _ref$current;
            // we use `event.code` as it is consistent regardless of meta keys that were pressed.
            // for example, `event.key` for `Control+Alt+t` is `†` and `t !== †`
            const isHotkeyPressed = hotkey.every((key)=>event[key] || event.code === key);
            if (isHotkeyPressed) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>document.removeEventListener("keydown", handleKeyDown);
    }, [
        hotkey
    ]);
    (0, $acw62.useEffect)(()=>{
        const wrapper = wrapperRef.current;
        const viewport = ref.current;
        if (hasToasts && wrapper && viewport) {
            const handlePause = ()=>{
                if (!context.isClosePausedRef.current) {
                    const pauseEvent = new CustomEvent($39e058e35b3b85b5$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE);
                    viewport.dispatchEvent(pauseEvent);
                    context.isClosePausedRef.current = true;
                }
            };
            const handleResume = ()=>{
                if (context.isClosePausedRef.current) {
                    const resumeEvent = new CustomEvent($39e058e35b3b85b5$var$$054eb8030ebde76e$var$VIEWPORT_RESUME);
                    viewport.dispatchEvent(resumeEvent);
                    context.isClosePausedRef.current = false;
                }
            };
            const handleFocusOutResume = (event)=>{
                const isFocusMovingOutside = !wrapper.contains(event.relatedTarget);
                if (isFocusMovingOutside) handleResume();
            };
            const handlePointerLeaveResume = ()=>{
                const isFocusInside = wrapper.contains(document.activeElement);
                if (!isFocusInside) handleResume();
            }; // Toasts are not in the viewport React tree so we need to bind DOM events
            wrapper.addEventListener("focusin", handlePause);
            wrapper.addEventListener("focusout", handleFocusOutResume);
            wrapper.addEventListener("pointermove", handlePause);
            wrapper.addEventListener("pointerleave", handlePointerLeaveResume);
            window.addEventListener("blur", handlePause);
            window.addEventListener("focus", handleResume);
            return ()=>{
                wrapper.removeEventListener("focusin", handlePause);
                wrapper.removeEventListener("focusout", handleFocusOutResume);
                wrapper.removeEventListener("pointermove", handlePause);
                wrapper.removeEventListener("pointerleave", handlePointerLeaveResume);
                window.removeEventListener("blur", handlePause);
                window.removeEventListener("focus", handleResume);
            };
        }
    }, [
        hasToasts,
        context.isClosePausedRef
    ]);
    const getSortedTabbableCandidates = (0, $acw62.useCallback)(({ tabbingDirection: tabbingDirection })=>{
        const toastItems = getItems();
        const tabbableCandidates = toastItems.map((toastItem)=>{
            const toastNode = toastItem.ref.current;
            const toastTabbableCandidates = [
                toastNode,
                ...$39e058e35b3b85b5$var$$054eb8030ebde76e$var$getTabbableCandidates(toastNode)
            ];
            return tabbingDirection === "forwards" ? toastTabbableCandidates : toastTabbableCandidates.reverse();
        });
        return (tabbingDirection === "forwards" ? tabbableCandidates.reverse() : tabbableCandidates).flat();
    }, [
        getItems
    ]);
    (0, $acw62.useEffect)(()=>{
        const viewport = ref.current; // We programmatically manage tabbing as we are unable to influence
        // the source order with portals, this allows us to reverse the
        // tab order so that it runs from most recent toast to least
        if (viewport) {
            const handleKeyDown = (event)=>{
                const isMetaKey = event.altKey || event.ctrlKey || event.metaKey;
                const isTabKey = event.key === "Tab" && !isMetaKey;
                if (isTabKey) {
                    const focusedElement = document.activeElement;
                    const isTabbingBackwards = event.shiftKey;
                    const targetIsViewport = event.target === viewport; // If we're back tabbing after jumping to the viewport then we simply
                    // proxy focus out to the preceding document
                    if (targetIsViewport && isTabbingBackwards) {
                        var _headFocusProxyRef$cu;
                        (_headFocusProxyRef$cu = headFocusProxyRef.current) === null || _headFocusProxyRef$cu === void 0 || _headFocusProxyRef$cu.focus();
                        return;
                    }
                    const tabbingDirection = isTabbingBackwards ? "backwards" : "forwards";
                    const sortedCandidates = getSortedTabbableCandidates({
                        tabbingDirection: tabbingDirection
                    });
                    const index = sortedCandidates.findIndex((candidate)=>candidate === focusedElement);
                    if ($39e058e35b3b85b5$var$$054eb8030ebde76e$var$focusFirst(sortedCandidates.slice(index + 1))) event.preventDefault();
                    else {
                        var _headFocusProxyRef$cu2, _tailFocusProxyRef$cu;
                        // If we can't focus that means we're at the edges so we
                        // proxy to the corresponding exit point and let the browser handle
                        // tab/shift+tab keypress and implicitly pass focus to the next valid element in the document
                        isTabbingBackwards ? (_headFocusProxyRef$cu2 = headFocusProxyRef.current) === null || _headFocusProxyRef$cu2 === void 0 || _headFocusProxyRef$cu2.focus() : (_tailFocusProxyRef$cu = tailFocusProxyRef.current) === null || _tailFocusProxyRef$cu === void 0 || _tailFocusProxyRef$cu.focus();
                    }
                }
            }; // Toasts are not in the viewport React tree so we need to bind DOM events
            viewport.addEventListener("keydown", handleKeyDown);
            return ()=>viewport.removeEventListener("keydown", handleKeyDown);
        }
    }, [
        getItems,
        getSortedTabbableCandidates
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $30a399657994b369$export$aecb2ddcb55c95be), {
        ref: wrapperRef,
        role: "region",
        "aria-label": label.replace("{hotkey}", hotkeyLabel) // Ensure virtual cursor from landmarks menus triggers focus/blur for pause/resume
        ,
        tabIndex: -1 // incase list has size when empty (e.g. padding), we remove pointer events so
        ,
        style: {
            pointerEvents: hasToasts ? undefined : "none"
        }
    }, hasToasts && /*#__PURE__*/ (0, $acw62.createElement)($39e058e35b3b85b5$var$$054eb8030ebde76e$var$FocusProxy, {
        ref: headFocusProxyRef,
        onFocusFromOutsideViewport: ()=>{
            const tabbableCandidates = getSortedTabbableCandidates({
                tabbingDirection: "forwards"
            });
            $39e058e35b3b85b5$var$$054eb8030ebde76e$var$focusFirst(tabbableCandidates);
        }
    }), /*#__PURE__*/ (0, $acw62.createElement)($39e058e35b3b85b5$var$$054eb8030ebde76e$var$Collection.Slot, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).ol, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        tabIndex: -1
    }, viewportProps, {
        ref: composedRefs
    }))), hasToasts && /*#__PURE__*/ (0, $acw62.createElement)($39e058e35b3b85b5$var$$054eb8030ebde76e$var$FocusProxy, {
        ref: tailFocusProxyRef,
        onFocusFromOutsideViewport: ()=>{
            const tabbableCandidates = getSortedTabbableCandidates({
                tabbingDirection: "backwards"
            });
            $39e058e35b3b85b5$var$$054eb8030ebde76e$var$focusFirst(tabbableCandidates);
        }
    }));
});
/*#__PURE__*/ Object.assign($39e058e35b3b85b5$export$6192c2425ecfd989, {
    displayName: $39e058e35b3b85b5$var$$054eb8030ebde76e$var$VIEWPORT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$FOCUS_PROXY_NAME = "ToastFocusProxy";
const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$FocusProxy = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast, onFocusFromOutsideViewport: onFocusFromOutsideViewport, ...proxyProps } = props;
    const context = $39e058e35b3b85b5$var$$054eb8030ebde76e$var$useToastProviderContext($39e058e35b3b85b5$var$$054eb8030ebde76e$var$FOCUS_PROXY_NAME, __scopeToast);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $8d51f093cc1b6735$export$439d29a4e110a164), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        "aria-hidden": true,
        tabIndex: 0
    }, proxyProps, {
        ref: forwardedRef // Avoid page scrolling when focus is on the focus proxy
        ,
        style: {
            position: "fixed"
        },
        onFocus: (event)=>{
            var _context$viewport;
            const prevFocusedElement = event.relatedTarget;
            const isFocusFromOutsideViewport = !((_context$viewport = context.viewport) !== null && _context$viewport !== void 0 && _context$viewport.contains(prevFocusedElement));
            if (isFocusFromOutsideViewport) onFocusFromOutsideViewport();
        }
    }));
});
/*#__PURE__*/ Object.assign($39e058e35b3b85b5$var$$054eb8030ebde76e$var$FocusProxy, {
    displayName: $39e058e35b3b85b5$var$$054eb8030ebde76e$var$FOCUS_PROXY_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Toast
 * -----------------------------------------------------------------------------------------------*/ const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$TOAST_NAME = "Toast";
const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$TOAST_SWIPE_START = "toast.swipeStart";
const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$TOAST_SWIPE_MOVE = "toast.swipeMove";
const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$TOAST_SWIPE_CANCEL = "toast.swipeCancel";
const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$TOAST_SWIPE_END = "toast.swipeEnd";
const $39e058e35b3b85b5$export$8d8dc7d5f743331b = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { forceMount: forceMount, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, ...toastProps } = props;
    const [open = true, setOpen] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
        present: forceMount || open
    }, /*#__PURE__*/ (0, $acw62.createElement)($39e058e35b3b85b5$var$$054eb8030ebde76e$var$ToastImpl, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        open: open
    }, toastProps, {
        ref: forwardedRef,
        onClose: ()=>setOpen(false),
        onPause: (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(props.onPause),
        onResume: (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(props.onResume),
        onSwipeStart: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onSwipeStart, (event)=>{
            event.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onSwipeMove, (event)=>{
            const { x: x, y: y } = event.detail.delta;
            event.currentTarget.setAttribute("data-swipe", "move");
            event.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${x}px`);
            event.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${y}px`);
        }),
        onSwipeCancel: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onSwipeCancel, (event)=>{
            event.currentTarget.setAttribute("data-swipe", "cancel");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-move-x");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-move-y");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-end-x");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onSwipeEnd, (event)=>{
            const { x: x, y: y } = event.detail.delta;
            event.currentTarget.setAttribute("data-swipe", "end");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-move-x");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-move-y");
            event.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${x}px`);
            event.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${y}px`);
            setOpen(false);
        })
    })));
});
/*#__PURE__*/ Object.assign($39e058e35b3b85b5$export$8d8dc7d5f743331b, {
    displayName: $39e058e35b3b85b5$var$$054eb8030ebde76e$var$TOAST_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const [$39e058e35b3b85b5$var$$054eb8030ebde76e$var$ToastInteractiveProvider, $39e058e35b3b85b5$var$$054eb8030ebde76e$var$useToastInteractiveContext] = $39e058e35b3b85b5$var$$054eb8030ebde76e$var$createToastContext($39e058e35b3b85b5$var$$054eb8030ebde76e$var$TOAST_NAME, {
    onClose () {}
});
const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$ToastImpl = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast, type: type = "foreground", duration: durationProp, open: open, onClose: onClose, onEscapeKeyDown: onEscapeKeyDown, onPause: onPause, onResume: onResume, onSwipeStart: onSwipeStart, onSwipeMove: onSwipeMove, onSwipeCancel: onSwipeCancel, onSwipeEnd: onSwipeEnd, ...toastProps } = props;
    const context = $39e058e35b3b85b5$var$$054eb8030ebde76e$var$useToastProviderContext($39e058e35b3b85b5$var$$054eb8030ebde76e$var$TOAST_NAME, __scopeToast);
    const [node1, setNode] = (0, $acw62.useState)(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setNode(node));
    const pointerStartRef = (0, $acw62.useRef)(null);
    const swipeDeltaRef = (0, $acw62.useRef)(null);
    const duration1 = durationProp || context.duration;
    const closeTimerStartTimeRef = (0, $acw62.useRef)(0);
    const closeTimerRemainingTimeRef = (0, $acw62.useRef)(duration1);
    const closeTimerRef = (0, $acw62.useRef)(0);
    const { onToastAdd: onToastAdd, onToastRemove: onToastRemove } = context;
    const handleClose = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(()=>{
        var _context$viewport2;
        // focus viewport if focus is within toast to read the remaining toast
        // count to SR users and ensure focus isn't lost
        const isFocusInToast = node1 === null || node1 === void 0 ? void 0 : node1.contains(document.activeElement);
        if (isFocusInToast) (_context$viewport2 = context.viewport) === null || _context$viewport2 === void 0 || _context$viewport2.focus();
        onClose();
    });
    const startTimer = (0, $acw62.useCallback)((duration)=>{
        if (!duration || duration === Infinity) return;
        window.clearTimeout(closeTimerRef.current);
        closeTimerStartTimeRef.current = new Date().getTime();
        closeTimerRef.current = window.setTimeout(handleClose, duration);
    }, [
        handleClose
    ]);
    (0, $acw62.useEffect)(()=>{
        const viewport = context.viewport;
        if (viewport) {
            const handleResume = ()=>{
                startTimer(closeTimerRemainingTimeRef.current);
                onResume === null || onResume === void 0 || onResume();
            };
            const handlePause = ()=>{
                const elapsedTime = new Date().getTime() - closeTimerStartTimeRef.current;
                closeTimerRemainingTimeRef.current = closeTimerRemainingTimeRef.current - elapsedTime;
                window.clearTimeout(closeTimerRef.current);
                onPause === null || onPause === void 0 || onPause();
            };
            viewport.addEventListener($39e058e35b3b85b5$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE, handlePause);
            viewport.addEventListener($39e058e35b3b85b5$var$$054eb8030ebde76e$var$VIEWPORT_RESUME, handleResume);
            return ()=>{
                viewport.removeEventListener($39e058e35b3b85b5$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE, handlePause);
                viewport.removeEventListener($39e058e35b3b85b5$var$$054eb8030ebde76e$var$VIEWPORT_RESUME, handleResume);
            };
        }
    }, [
        context.viewport,
        duration1,
        onPause,
        onResume,
        startTimer
    ]); // start timer when toast opens or duration changes.
    // we include `open` in deps because closed !== unmounted when animating
    // so it could reopen before being completely unmounted
    (0, $acw62.useEffect)(()=>{
        if (open && !context.isClosePausedRef.current) startTimer(duration1);
    }, [
        open,
        duration1,
        context.isClosePausedRef,
        startTimer
    ]);
    (0, $acw62.useEffect)(()=>{
        onToastAdd();
        return ()=>onToastRemove();
    }, [
        onToastAdd,
        onToastRemove
    ]);
    const announceTextContent = (0, $acw62.useMemo)(()=>{
        return node1 ? $39e058e35b3b85b5$var$$054eb8030ebde76e$var$getAnnounceTextContent(node1) : null;
    }, [
        node1
    ]);
    if (!context.viewport) return null;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, announceTextContent && /*#__PURE__*/ (0, $acw62.createElement)($39e058e35b3b85b5$var$$054eb8030ebde76e$var$ToastAnnounce, {
        __scopeToast: __scopeToast // Toasts are always role=status to avoid stuttering issues with role=alert in SRs.
        ,
        role: "status",
        "aria-live": type === "foreground" ? "assertive" : "polite",
        "aria-atomic": true
    }, announceTextContent), /*#__PURE__*/ (0, $acw62.createElement)($39e058e35b3b85b5$var$$054eb8030ebde76e$var$ToastInteractiveProvider, {
        scope: __scopeToast,
        onClose: handleClose
    }, /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, $acw62.createElement)($39e058e35b3b85b5$var$$054eb8030ebde76e$var$Collection.ItemSlot, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $30a399657994b369$export$be92b6f5f03c0fe9), {
        asChild: true,
        onEscapeKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(onEscapeKeyDown, ()=>{
            if (!context.isFocusedToastEscapeKeyDownRef.current) handleClose();
            context.isFocusedToastEscapeKeyDownRef.current = false;
        })
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).li, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        // Ensure toasts are announced as status list or status when focused
        role: "status",
        "aria-live": "off",
        "aria-atomic": true,
        tabIndex: 0,
        "data-state": open ? "open" : "closed",
        "data-swipe-direction": context.swipeDirection
    }, toastProps, {
        ref: composedRefs,
        style: {
            userSelect: "none",
            touchAction: "none",
            ...props.style
        },
        onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            if (event.key !== "Escape") return;
            onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event.nativeEvent);
            if (!event.nativeEvent.defaultPrevented) {
                context.isFocusedToastEscapeKeyDownRef.current = true;
                handleClose();
            }
        }),
        onPointerDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerDown, (event)=>{
            if (event.button !== 0) return;
            pointerStartRef.current = {
                x: event.clientX,
                y: event.clientY
            };
        }),
        onPointerMove: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerMove, (event)=>{
            if (!pointerStartRef.current) return;
            const x = event.clientX - pointerStartRef.current.x;
            const y = event.clientY - pointerStartRef.current.y;
            const hasSwipeMoveStarted = Boolean(swipeDeltaRef.current);
            const isHorizontalSwipe = [
                "left",
                "right"
            ].includes(context.swipeDirection);
            const clamp = [
                "left",
                "up"
            ].includes(context.swipeDirection) ? Math.min : Math.max;
            const clampedX = isHorizontalSwipe ? clamp(0, x) : 0;
            const clampedY = !isHorizontalSwipe ? clamp(0, y) : 0;
            const moveStartBuffer = event.pointerType === "touch" ? 10 : 2;
            const delta = {
                x: clampedX,
                y: clampedY
            };
            const eventDetail = {
                originalEvent: event,
                delta: delta
            };
            if (hasSwipeMoveStarted) {
                swipeDeltaRef.current = delta;
                $39e058e35b3b85b5$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($39e058e35b3b85b5$var$$054eb8030ebde76e$var$TOAST_SWIPE_MOVE, onSwipeMove, eventDetail, {
                    discrete: false
                });
            } else if ($39e058e35b3b85b5$var$$054eb8030ebde76e$var$isDeltaInDirection(delta, context.swipeDirection, moveStartBuffer)) {
                swipeDeltaRef.current = delta;
                $39e058e35b3b85b5$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($39e058e35b3b85b5$var$$054eb8030ebde76e$var$TOAST_SWIPE_START, onSwipeStart, eventDetail, {
                    discrete: false
                });
                event.target.setPointerCapture(event.pointerId);
            } else if (Math.abs(x) > moveStartBuffer || Math.abs(y) > moveStartBuffer) // for the current pointer down interaction
            pointerStartRef.current = null;
        }),
        onPointerUp: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerUp, (event1)=>{
            const delta = swipeDeltaRef.current;
            const target = event1.target;
            if (target.hasPointerCapture(event1.pointerId)) target.releasePointerCapture(event1.pointerId);
            swipeDeltaRef.current = null;
            pointerStartRef.current = null;
            if (delta) {
                const toast = event1.currentTarget;
                const eventDetail = {
                    originalEvent: event1,
                    delta: delta
                };
                if ($39e058e35b3b85b5$var$$054eb8030ebde76e$var$isDeltaInDirection(delta, context.swipeDirection, context.swipeThreshold)) $39e058e35b3b85b5$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($39e058e35b3b85b5$var$$054eb8030ebde76e$var$TOAST_SWIPE_END, onSwipeEnd, eventDetail, {
                    discrete: true
                });
                else $39e058e35b3b85b5$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($39e058e35b3b85b5$var$$054eb8030ebde76e$var$TOAST_SWIPE_CANCEL, onSwipeCancel, eventDetail, {
                    discrete: true
                });
                // Prevent click event from triggering on items within the toast when
                // pointer up is part of a swipe gesture
                toast.addEventListener("click", (event)=>event.preventDefault(), {
                    once: true
                });
            }
        })
    })))), context.viewport)));
});
$39e058e35b3b85b5$var$$054eb8030ebde76e$var$ToastImpl.propTypes = {
    type (props) {
        if (props.type && ![
            "foreground",
            "background"
        ].includes(props.type)) {
            const error = `Invalid prop \`type\` supplied to \`${$39e058e35b3b85b5$var$$054eb8030ebde76e$var$TOAST_NAME}\`. Expected \`foreground | background\`.`;
            return new Error(error);
        }
        return null;
    }
};
/* -----------------------------------------------------------------------------------------------*/ const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$ToastAnnounce = (props)=>{
    const { __scopeToast: __scopeToast, children: children, ...announceProps } = props;
    const context = $39e058e35b3b85b5$var$$054eb8030ebde76e$var$useToastProviderContext($39e058e35b3b85b5$var$$054eb8030ebde76e$var$TOAST_NAME, __scopeToast);
    const [renderAnnounceText, setRenderAnnounceText] = (0, $acw62.useState)(false);
    const [isAnnounced, setIsAnnounced] = (0, $acw62.useState)(false); // render text content in the next frame to ensure toast is announced in NVDA
    $39e058e35b3b85b5$var$$054eb8030ebde76e$var$useNextFrame(()=>setRenderAnnounceText(true)); // cleanup after announcing
    (0, $acw62.useEffect)(()=>{
        const timer = window.setTimeout(()=>setIsAnnounced(true), 1000);
        return ()=>window.clearTimeout(timer);
    }, []);
    return isAnnounced ? null : /*#__PURE__*/ (0, $acw62.createElement)((0, $95d053caea9c023a$export$602eac185826482c), {
        asChild: true
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $8d51f093cc1b6735$export$439d29a4e110a164), announceProps, renderAnnounceText && /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, context.label, " ", children)));
};
/* -------------------------------------------------------------------------------------------------
 * ToastTitle
 * -----------------------------------------------------------------------------------------------*/ const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$TITLE_NAME = "ToastTitle";
const $39e058e35b3b85b5$export$16d42d7c29b95a4 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast, ...titleProps } = props;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, titleProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($39e058e35b3b85b5$export$16d42d7c29b95a4, {
    displayName: $39e058e35b3b85b5$var$$054eb8030ebde76e$var$TITLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastDescription
 * -----------------------------------------------------------------------------------------------*/ const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$DESCRIPTION_NAME = "ToastDescription";
const $39e058e35b3b85b5$export$ecddd96c53621d9a = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast, ...descriptionProps } = props;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, descriptionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($39e058e35b3b85b5$export$ecddd96c53621d9a, {
    displayName: $39e058e35b3b85b5$var$$054eb8030ebde76e$var$DESCRIPTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastAction
 * -----------------------------------------------------------------------------------------------*/ const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$ACTION_NAME = "ToastAction";
const $39e058e35b3b85b5$export$3019feecfda683d2 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { altText: altText, ...actionProps } = props;
    if (!altText) return null;
    return /*#__PURE__*/ (0, $acw62.createElement)($39e058e35b3b85b5$var$$054eb8030ebde76e$var$ToastAnnounceExclude, {
        altText: altText,
        asChild: true
    }, /*#__PURE__*/ (0, $acw62.createElement)($39e058e35b3b85b5$export$811e70f61c205839, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, actionProps, {
        ref: forwardedRef
    })));
});
$39e058e35b3b85b5$export$3019feecfda683d2.propTypes = {
    altText (props) {
        if (!props.altText) return new Error(`Missing prop \`altText\` expected on \`${$39e058e35b3b85b5$var$$054eb8030ebde76e$var$ACTION_NAME}\``);
        return null;
    }
};
/*#__PURE__*/ Object.assign($39e058e35b3b85b5$export$3019feecfda683d2, {
    displayName: $39e058e35b3b85b5$var$$054eb8030ebde76e$var$ACTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastClose
 * -----------------------------------------------------------------------------------------------*/ const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$CLOSE_NAME = "ToastClose";
const $39e058e35b3b85b5$export$811e70f61c205839 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast, ...closeProps } = props;
    const interactiveContext = $39e058e35b3b85b5$var$$054eb8030ebde76e$var$useToastInteractiveContext($39e058e35b3b85b5$var$$054eb8030ebde76e$var$CLOSE_NAME, __scopeToast);
    return /*#__PURE__*/ (0, $acw62.createElement)($39e058e35b3b85b5$var$$054eb8030ebde76e$var$ToastAnnounceExclude, {
        asChild: true
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).button, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onClick, interactiveContext.onClose)
    })));
});
/*#__PURE__*/ Object.assign($39e058e35b3b85b5$export$811e70f61c205839, {
    displayName: $39e058e35b3b85b5$var$$054eb8030ebde76e$var$CLOSE_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$ToastAnnounceExclude = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast, altText: altText, ...announceExcludeProps } = props;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        "data-radix-toast-announce-exclude": "",
        "data-radix-toast-announce-alt": altText || undefined
    }, announceExcludeProps, {
        ref: forwardedRef
    }));
});
function $39e058e35b3b85b5$var$$054eb8030ebde76e$var$getAnnounceTextContent(container) {
    const textContent = [];
    const childNodes = Array.from(container.childNodes);
    childNodes.forEach((node)=>{
        if (node.nodeType === node.TEXT_NODE && node.textContent) textContent.push(node.textContent);
        if ($39e058e35b3b85b5$var$$054eb8030ebde76e$var$isHTMLElement(node)) {
            const isHidden = node.ariaHidden || node.hidden || node.style.display === "none";
            const isExcluded = node.dataset.radixToastAnnounceExclude === "";
            if (!isHidden) {
                if (isExcluded) {
                    const altText = node.dataset.radixToastAnnounceAlt;
                    if (altText) textContent.push(altText);
                } else textContent.push(...$39e058e35b3b85b5$var$$054eb8030ebde76e$var$getAnnounceTextContent(node));
            }
        }
    }); // We return a collection of text rather than a single concatenated string.
    // This allows SR VO to naturally pause break between nodes while announcing.
    return textContent;
}
/* ---------------------------------------------------------------------------------------------- */ function $39e058e35b3b85b5$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const currentTarget = detail.originalEvent.currentTarget;
    const event = new CustomEvent(name, {
        bubbles: true,
        cancelable: true,
        detail: detail
    });
    if (handler) currentTarget.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $dc7d5df3de21cdcb$export$6d1a0317bde7de7f)(currentTarget, event);
    else currentTarget.dispatchEvent(event);
}
const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$isDeltaInDirection = (delta, direction, threshold = 0)=>{
    const deltaX = Math.abs(delta.x);
    const deltaY = Math.abs(delta.y);
    const isDeltaX = deltaX > deltaY;
    if (direction === "left" || direction === "right") return isDeltaX && deltaX > threshold;
    else return !isDeltaX && deltaY > threshold;
};
function $39e058e35b3b85b5$var$$054eb8030ebde76e$var$useNextFrame(callback = ()=>{}) {
    const fn = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(callback);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        let raf1 = 0;
        let raf2 = 0;
        raf1 = window.requestAnimationFrame(()=>raf2 = window.requestAnimationFrame(fn));
        return ()=>{
            window.cancelAnimationFrame(raf1);
            window.cancelAnimationFrame(raf2);
        };
    }, [
        fn
    ]);
}
function $39e058e35b3b85b5$var$$054eb8030ebde76e$var$isHTMLElement(node) {
    return node.nodeType === node.ELEMENT_NODE;
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $39e058e35b3b85b5$var$$054eb8030ebde76e$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
function $39e058e35b3b85b5$var$$054eb8030ebde76e$var$focusFirst(candidates) {
    const previouslyFocusedElement = document.activeElement;
    return candidates.some((candidate)=>{
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === previouslyFocusedElement) return true;
        candidate.focus();
        return document.activeElement !== previouslyFocusedElement;
    });
}
const $39e058e35b3b85b5$export$2881499e37b75b9a = $39e058e35b3b85b5$export$f5d03d415824e0e;
const $39e058e35b3b85b5$export$d5c6c08dc2d3ca7 = $39e058e35b3b85b5$export$6192c2425ecfd989;
const $39e058e35b3b85b5$export$be92b6f5f03c0fe9 = $39e058e35b3b85b5$export$8d8dc7d5f743331b;
const $39e058e35b3b85b5$export$f99233281efd08a0 = $39e058e35b3b85b5$export$16d42d7c29b95a4;
const $39e058e35b3b85b5$export$393edc798c47379d = $39e058e35b3b85b5$export$ecddd96c53621d9a;
const $39e058e35b3b85b5$export$e19cd5f9376f8cee = $39e058e35b3b85b5$export$3019feecfda683d2;
const $39e058e35b3b85b5$export$f39c2d165cd861fe = $39e058e35b3b85b5$export$811e70f61c205839;





const $1a24bd4ed1610cff$export$f5d03d415824e0e = $39e058e35b3b85b5$export$2881499e37b75b9a;
const $1a24bd4ed1610cff$export$6192c2425ecfd989 = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($39e058e35b3b85b5$export$d5c6c08dc2d3ca7, {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]", className),
        ...props
    }));
$1a24bd4ed1610cff$export$6192c2425ecfd989.displayName = $39e058e35b3b85b5$export$d5c6c08dc2d3ca7.displayName;
const $1a24bd4ed1610cff$var$toastVariants = (0, $7d867aa0bbfd521e$export$87dc52566e90b739)("group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border border-slate-200 p-6 pr-8 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full dark:border-slate-800", {
    variants: {
        variant: {
            default: "border bg-white text-slate-950 dark:bg-slate-950 dark:text-slate-50",
            destructive: "destructive group border-red-500 bg-red-500 text-slate-50 dark:border-red-900 dark:bg-red-900 dark:text-slate-50"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
const $1a24bd4ed1610cff$export$8d8dc7d5f743331b = /*#__PURE__*/ $acw62.forwardRef(({ className: className, variant: variant, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($39e058e35b3b85b5$export$be92b6f5f03c0fe9, {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)($1a24bd4ed1610cff$var$toastVariants({
            variant: variant
        }), className),
        ...props
    });
});
$1a24bd4ed1610cff$export$8d8dc7d5f743331b.displayName = $39e058e35b3b85b5$export$be92b6f5f03c0fe9.displayName;
const $1a24bd4ed1610cff$export$3019feecfda683d2 = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($39e058e35b3b85b5$export$e19cd5f9376f8cee, {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("inline-flex h-8 shrink-0 items-center justify-center rounded-md border border-slate-200 bg-transparent px-3 text-sm font-medium ring-offset-white transition-colors hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-slate-950 focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 group-[.destructive]:border-slate-100/40 group-[.destructive]:hover:border-red-500/30 group-[.destructive]:hover:bg-red-500 group-[.destructive]:hover:text-slate-50 group-[.destructive]:focus:ring-red-500 dark:border-slate-800 dark:ring-offset-slate-950 dark:hover:bg-slate-800 dark:focus:ring-slate-300 dark:group-[.destructive]:border-slate-800/40 dark:group-[.destructive]:hover:border-red-900/30 dark:group-[.destructive]:hover:bg-red-900 dark:group-[.destructive]:hover:text-slate-50 dark:group-[.destructive]:focus:ring-red-900", className),
        ...props
    }));
$1a24bd4ed1610cff$export$3019feecfda683d2.displayName = $39e058e35b3b85b5$export$e19cd5f9376f8cee.displayName;
const $1a24bd4ed1610cff$export$811e70f61c205839 = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($39e058e35b3b85b5$export$f39c2d165cd861fe, {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("absolute right-2 top-2 rounded-md p-1 text-slate-950/50 opacity-0 transition-opacity hover:text-slate-950 focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600 dark:text-slate-50/50 dark:hover:text-slate-50", className),
        "toast-close": "",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
            className: "h-4 w-4"
        })
    }));
$1a24bd4ed1610cff$export$811e70f61c205839.displayName = $39e058e35b3b85b5$export$f39c2d165cd861fe.displayName;
const $1a24bd4ed1610cff$export$16d42d7c29b95a4 = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($39e058e35b3b85b5$export$f99233281efd08a0, {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("text-sm font-semibold", className),
        ...props
    }));
$1a24bd4ed1610cff$export$16d42d7c29b95a4.displayName = $39e058e35b3b85b5$export$f99233281efd08a0.displayName;
const $1a24bd4ed1610cff$export$ecddd96c53621d9a = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($39e058e35b3b85b5$export$393edc798c47379d, {
        ref: ref,
        className: (0, $c6a4e06ec85a7455$export$1343a74baacb0543)("text-sm opacity-90", className),
        ...props
    }));
$1a24bd4ed1610cff$export$ecddd96c53621d9a.displayName = $39e058e35b3b85b5$export$393edc798c47379d.displayName;



function $d8d8228771ce99de$export$fb98e3a2a4cd92d7() {
    const { toasts: toasts } = (0, $9898a26843c73274$export$a407b657d3044108)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1a24bd4ed1610cff$export$f5d03d415824e0e), {
        children: [
            toasts.map(function({ id: id, title: title, description: description, action: action, ...props }) {
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1a24bd4ed1610cff$export$8d8dc7d5f743331b), {
                    ...props,
                    className: "font-outfit",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "grid gap-1",
                            children: [
                                title && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a24bd4ed1610cff$export$16d42d7c29b95a4), {
                                    children: title
                                }),
                                description && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a24bd4ed1610cff$export$ecddd96c53621d9a), {
                                    children: description
                                })
                            ]
                        }),
                        action,
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a24bd4ed1610cff$export$811e70f61c205839), {})
                    ]
                }, id);
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a24bd4ed1610cff$export$6192c2425ecfd989), {})
        ]
    });
}



// Clear the existing HTML content
document.body.innerHTML = '<div id="app" class="h-full"></div>';
// Render your React component instead
const $70fc9a727fa662ae$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)(document.getElementById("app"));
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.StrictMode), {
    children: [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ea76e268d887ac0$export$2e2bcd8739ae039), {}),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d8d8228771ce99de$export$fb98e3a2a4cd92d7), {})
    ]
}));
(0, $b7120199cc96ae3e$export$74b04d0e740afc5d)();


//# sourceMappingURL=index.39290575.js.map
